/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const ApiUserProto = $root.ApiUserProto = (() => {

    /**
     * Properties of an ApiUserProto.
     * @exports IApiUserProto
     * @interface IApiUserProto
     * @property {string|null} [userId] ApiUserProto userId
     * @property {string|null} [familyName] ApiUserProto familyName
     * @property {string|null} [givenName] ApiUserProto givenName
     * @property {IWellnessSurveyProto|null} [wellnessSurveyAnswers] ApiUserProto wellnessSurveyAnswers
     * @property {string|null} [mobileNumber] ApiUserProto mobileNumber
     * @property {string|null} [contactEmail] ApiUserProto contactEmail
     * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [verifiedContactMethods] ApiUserProto verifiedContactMethods
     * @property {Array.<string>|null} [acceptedTermsVersions] ApiUserProto acceptedTermsVersions
     * @property {space.kenko.proto.ILocalDateProto|null} [birthDate] ApiUserProto birthDate
     */

    /**
     * Constructs a new ApiUserProto.
     * @exports ApiUserProto
     * @classdesc Represents an ApiUserProto.
     * @implements IApiUserProto
     * @constructor
     * @param {IApiUserProto=} [properties] Properties to set
     */
    function ApiUserProto(properties) {
        this.verifiedContactMethods = [];
        this.acceptedTermsVersions = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiUserProto userId.
     * @member {string} userId
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.userId = "";

    /**
     * ApiUserProto familyName.
     * @member {string} familyName
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.familyName = "";

    /**
     * ApiUserProto givenName.
     * @member {string} givenName
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.givenName = "";

    /**
     * ApiUserProto wellnessSurveyAnswers.
     * @member {IWellnessSurveyProto|null|undefined} wellnessSurveyAnswers
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.wellnessSurveyAnswers = null;

    /**
     * ApiUserProto mobileNumber.
     * @member {string} mobileNumber
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.mobileNumber = "";

    /**
     * ApiUserProto contactEmail.
     * @member {string} contactEmail
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.contactEmail = "";

    /**
     * ApiUserProto verifiedContactMethods.
     * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} verifiedContactMethods
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.verifiedContactMethods = $util.emptyArray;

    /**
     * ApiUserProto acceptedTermsVersions.
     * @member {Array.<string>} acceptedTermsVersions
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.acceptedTermsVersions = $util.emptyArray;

    /**
     * ApiUserProto birthDate.
     * @member {space.kenko.proto.ILocalDateProto|null|undefined} birthDate
     * @memberof ApiUserProto
     * @instance
     */
    ApiUserProto.prototype.birthDate = null;

    /**
     * Creates a new ApiUserProto instance using the specified properties.
     * @function create
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto=} [properties] Properties to set
     * @returns {ApiUserProto} ApiUserProto instance
     */
    ApiUserProto.create = function create(properties) {
        return new ApiUserProto(properties);
    };

    /**
     * Encodes the specified ApiUserProto message. Does not implicitly {@link ApiUserProto.verify|verify} messages.
     * @function encode
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto} message ApiUserProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiUserProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.familyName != null && Object.hasOwnProperty.call(message, "familyName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.familyName);
        if (message.givenName != null && Object.hasOwnProperty.call(message, "givenName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.givenName);
        if (message.wellnessSurveyAnswers != null && Object.hasOwnProperty.call(message, "wellnessSurveyAnswers"))
            $root.WellnessSurveyProto.encode(message.wellnessSurveyAnswers, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.mobileNumber != null && Object.hasOwnProperty.call(message, "mobileNumber"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.mobileNumber);
        if (message.contactEmail != null && Object.hasOwnProperty.call(message, "contactEmail"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.contactEmail);
        if (message.verifiedContactMethods != null && message.verifiedContactMethods.length)
            for (let i = 0; i < message.verifiedContactMethods.length; ++i)
                $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.verifiedContactMethods[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.acceptedTermsVersions != null && message.acceptedTermsVersions.length)
            for (let i = 0; i < message.acceptedTermsVersions.length; ++i)
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.acceptedTermsVersions[i]);
        if (message.birthDate != null && Object.hasOwnProperty.call(message, "birthDate"))
            $root.space.kenko.proto.LocalDateProto.encode(message.birthDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiUserProto message, length delimited. Does not implicitly {@link ApiUserProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiUserProto
     * @static
     * @param {IApiUserProto} message ApiUserProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiUserProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiUserProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiUserProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiUserProto} ApiUserProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiUserProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiUserProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.familyName = reader.string();
                    break;
                }
            case 3: {
                    message.givenName = reader.string();
                    break;
                }
            case 4: {
                    message.wellnessSurveyAnswers = $root.WellnessSurveyProto.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.mobileNumber = reader.string();
                    break;
                }
            case 6: {
                    message.contactEmail = reader.string();
                    break;
                }
            case 7: {
                    if (!(message.verifiedContactMethods && message.verifiedContactMethods.length))
                        message.verifiedContactMethods = [];
                    message.verifiedContactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                    break;
                }
            case 8: {
                    if (!(message.acceptedTermsVersions && message.acceptedTermsVersions.length))
                        message.acceptedTermsVersions = [];
                    message.acceptedTermsVersions.push(reader.string());
                    break;
                }
            case 9: {
                    message.birthDate = $root.space.kenko.proto.LocalDateProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiUserProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiUserProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiUserProto} ApiUserProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiUserProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiUserProto message.
     * @function verify
     * @memberof ApiUserProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiUserProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            if (!$util.isString(message.familyName))
                return "familyName: string expected";
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            if (!$util.isString(message.givenName))
                return "givenName: string expected";
        if (message.wellnessSurveyAnswers != null && message.hasOwnProperty("wellnessSurveyAnswers")) {
            let error = $root.WellnessSurveyProto.verify(message.wellnessSurveyAnswers);
            if (error)
                return "wellnessSurveyAnswers." + error;
        }
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            if (!$util.isString(message.mobileNumber))
                return "mobileNumber: string expected";
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            if (!$util.isString(message.contactEmail))
                return "contactEmail: string expected";
        if (message.verifiedContactMethods != null && message.hasOwnProperty("verifiedContactMethods")) {
            if (!Array.isArray(message.verifiedContactMethods))
                return "verifiedContactMethods: array expected";
            for (let i = 0; i < message.verifiedContactMethods.length; ++i) {
                let error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.verifiedContactMethods[i]);
                if (error)
                    return "verifiedContactMethods." + error;
            }
        }
        if (message.acceptedTermsVersions != null && message.hasOwnProperty("acceptedTermsVersions")) {
            if (!Array.isArray(message.acceptedTermsVersions))
                return "acceptedTermsVersions: array expected";
            for (let i = 0; i < message.acceptedTermsVersions.length; ++i)
                if (!$util.isString(message.acceptedTermsVersions[i]))
                    return "acceptedTermsVersions: string[] expected";
        }
        if (message.birthDate != null && message.hasOwnProperty("birthDate")) {
            let error = $root.space.kenko.proto.LocalDateProto.verify(message.birthDate);
            if (error)
                return "birthDate." + error;
        }
        return null;
    };

    /**
     * Creates an ApiUserProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiUserProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiUserProto} ApiUserProto
     */
    ApiUserProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiUserProto)
            return object;
        let message = new $root.ApiUserProto();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.familyName != null)
            message.familyName = String(object.familyName);
        if (object.givenName != null)
            message.givenName = String(object.givenName);
        if (object.wellnessSurveyAnswers != null) {
            if (typeof object.wellnessSurveyAnswers !== "object")
                throw TypeError(".ApiUserProto.wellnessSurveyAnswers: object expected");
            message.wellnessSurveyAnswers = $root.WellnessSurveyProto.fromObject(object.wellnessSurveyAnswers);
        }
        if (object.mobileNumber != null)
            message.mobileNumber = String(object.mobileNumber);
        if (object.contactEmail != null)
            message.contactEmail = String(object.contactEmail);
        if (object.verifiedContactMethods) {
            if (!Array.isArray(object.verifiedContactMethods))
                throw TypeError(".ApiUserProto.verifiedContactMethods: array expected");
            message.verifiedContactMethods = [];
            for (let i = 0; i < object.verifiedContactMethods.length; ++i) {
                if (typeof object.verifiedContactMethods[i] !== "object")
                    throw TypeError(".ApiUserProto.verifiedContactMethods: object expected");
                message.verifiedContactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.verifiedContactMethods[i]);
            }
        }
        if (object.acceptedTermsVersions) {
            if (!Array.isArray(object.acceptedTermsVersions))
                throw TypeError(".ApiUserProto.acceptedTermsVersions: array expected");
            message.acceptedTermsVersions = [];
            for (let i = 0; i < object.acceptedTermsVersions.length; ++i)
                message.acceptedTermsVersions[i] = String(object.acceptedTermsVersions[i]);
        }
        if (object.birthDate != null) {
            if (typeof object.birthDate !== "object")
                throw TypeError(".ApiUserProto.birthDate: object expected");
            message.birthDate = $root.space.kenko.proto.LocalDateProto.fromObject(object.birthDate);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiUserProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiUserProto
     * @static
     * @param {ApiUserProto} message ApiUserProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiUserProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.verifiedContactMethods = [];
            object.acceptedTermsVersions = [];
        }
        if (options.defaults) {
            object.userId = "";
            object.familyName = "";
            object.givenName = "";
            object.wellnessSurveyAnswers = null;
            object.mobileNumber = "";
            object.contactEmail = "";
            object.birthDate = null;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.familyName != null && message.hasOwnProperty("familyName"))
            object.familyName = message.familyName;
        if (message.givenName != null && message.hasOwnProperty("givenName"))
            object.givenName = message.givenName;
        if (message.wellnessSurveyAnswers != null && message.hasOwnProperty("wellnessSurveyAnswers"))
            object.wellnessSurveyAnswers = $root.WellnessSurveyProto.toObject(message.wellnessSurveyAnswers, options);
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            object.mobileNumber = message.mobileNumber;
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            object.contactEmail = message.contactEmail;
        if (message.verifiedContactMethods && message.verifiedContactMethods.length) {
            object.verifiedContactMethods = [];
            for (let j = 0; j < message.verifiedContactMethods.length; ++j)
                object.verifiedContactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.verifiedContactMethods[j], options);
        }
        if (message.acceptedTermsVersions && message.acceptedTermsVersions.length) {
            object.acceptedTermsVersions = [];
            for (let j = 0; j < message.acceptedTermsVersions.length; ++j)
                object.acceptedTermsVersions[j] = message.acceptedTermsVersions[j];
        }
        if (message.birthDate != null && message.hasOwnProperty("birthDate"))
            object.birthDate = $root.space.kenko.proto.LocalDateProto.toObject(message.birthDate, options);
        return object;
    };

    /**
     * Converts this ApiUserProto to JSON.
     * @function toJSON
     * @memberof ApiUserProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiUserProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiUserProto
     * @function getTypeUrl
     * @memberof ApiUserProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiUserProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiUserProto";
    };

    return ApiUserProto;
})();

export const WellnessSurveyProto = $root.WellnessSurveyProto = (() => {

    /**
     * Properties of a WellnessSurveyProto.
     * @exports IWellnessSurveyProto
     * @interface IWellnessSurveyProto
     * @property {Array.<string>|null} [wellnessGoals] WellnessSurveyProto wellnessGoals
     * @property {Array.<string>|null} [holisticHealthInterests] WellnessSurveyProto holisticHealthInterests
     * @property {string|null} [opennessToHolisticModalities] WellnessSurveyProto opennessToHolisticModalities
     * @property {string|null} [gender] WellnessSurveyProto gender
     */

    /**
     * Constructs a new WellnessSurveyProto.
     * @exports WellnessSurveyProto
     * @classdesc Represents a WellnessSurveyProto.
     * @implements IWellnessSurveyProto
     * @constructor
     * @param {IWellnessSurveyProto=} [properties] Properties to set
     */
    function WellnessSurveyProto(properties) {
        this.wellnessGoals = [];
        this.holisticHealthInterests = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WellnessSurveyProto wellnessGoals.
     * @member {Array.<string>} wellnessGoals
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.wellnessGoals = $util.emptyArray;

    /**
     * WellnessSurveyProto holisticHealthInterests.
     * @member {Array.<string>} holisticHealthInterests
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.holisticHealthInterests = $util.emptyArray;

    /**
     * WellnessSurveyProto opennessToHolisticModalities.
     * @member {string} opennessToHolisticModalities
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.opennessToHolisticModalities = "";

    /**
     * WellnessSurveyProto gender.
     * @member {string} gender
     * @memberof WellnessSurveyProto
     * @instance
     */
    WellnessSurveyProto.prototype.gender = "";

    /**
     * Creates a new WellnessSurveyProto instance using the specified properties.
     * @function create
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto=} [properties] Properties to set
     * @returns {WellnessSurveyProto} WellnessSurveyProto instance
     */
    WellnessSurveyProto.create = function create(properties) {
        return new WellnessSurveyProto(properties);
    };

    /**
     * Encodes the specified WellnessSurveyProto message. Does not implicitly {@link WellnessSurveyProto.verify|verify} messages.
     * @function encode
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto} message WellnessSurveyProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WellnessSurveyProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.wellnessGoals != null && message.wellnessGoals.length)
            for (let i = 0; i < message.wellnessGoals.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.wellnessGoals[i]);
        if (message.holisticHealthInterests != null && message.holisticHealthInterests.length)
            for (let i = 0; i < message.holisticHealthInterests.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.holisticHealthInterests[i]);
        if (message.opennessToHolisticModalities != null && Object.hasOwnProperty.call(message, "opennessToHolisticModalities"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.opennessToHolisticModalities);
        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.gender);
        return writer;
    };

    /**
     * Encodes the specified WellnessSurveyProto message, length delimited. Does not implicitly {@link WellnessSurveyProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WellnessSurveyProto
     * @static
     * @param {IWellnessSurveyProto} message WellnessSurveyProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WellnessSurveyProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WellnessSurveyProto message from the specified reader or buffer.
     * @function decode
     * @memberof WellnessSurveyProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WellnessSurveyProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.WellnessSurveyProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.wellnessGoals && message.wellnessGoals.length))
                        message.wellnessGoals = [];
                    message.wellnessGoals.push(reader.string());
                    break;
                }
            case 2: {
                    if (!(message.holisticHealthInterests && message.holisticHealthInterests.length))
                        message.holisticHealthInterests = [];
                    message.holisticHealthInterests.push(reader.string());
                    break;
                }
            case 3: {
                    message.opennessToHolisticModalities = reader.string();
                    break;
                }
            case 4: {
                    message.gender = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WellnessSurveyProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WellnessSurveyProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WellnessSurveyProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WellnessSurveyProto message.
     * @function verify
     * @memberof WellnessSurveyProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WellnessSurveyProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.wellnessGoals != null && message.hasOwnProperty("wellnessGoals")) {
            if (!Array.isArray(message.wellnessGoals))
                return "wellnessGoals: array expected";
            for (let i = 0; i < message.wellnessGoals.length; ++i)
                if (!$util.isString(message.wellnessGoals[i]))
                    return "wellnessGoals: string[] expected";
        }
        if (message.holisticHealthInterests != null && message.hasOwnProperty("holisticHealthInterests")) {
            if (!Array.isArray(message.holisticHealthInterests))
                return "holisticHealthInterests: array expected";
            for (let i = 0; i < message.holisticHealthInterests.length; ++i)
                if (!$util.isString(message.holisticHealthInterests[i]))
                    return "holisticHealthInterests: string[] expected";
        }
        if (message.opennessToHolisticModalities != null && message.hasOwnProperty("opennessToHolisticModalities"))
            if (!$util.isString(message.opennessToHolisticModalities))
                return "opennessToHolisticModalities: string expected";
        if (message.gender != null && message.hasOwnProperty("gender"))
            if (!$util.isString(message.gender))
                return "gender: string expected";
        return null;
    };

    /**
     * Creates a WellnessSurveyProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WellnessSurveyProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WellnessSurveyProto} WellnessSurveyProto
     */
    WellnessSurveyProto.fromObject = function fromObject(object) {
        if (object instanceof $root.WellnessSurveyProto)
            return object;
        let message = new $root.WellnessSurveyProto();
        if (object.wellnessGoals) {
            if (!Array.isArray(object.wellnessGoals))
                throw TypeError(".WellnessSurveyProto.wellnessGoals: array expected");
            message.wellnessGoals = [];
            for (let i = 0; i < object.wellnessGoals.length; ++i)
                message.wellnessGoals[i] = String(object.wellnessGoals[i]);
        }
        if (object.holisticHealthInterests) {
            if (!Array.isArray(object.holisticHealthInterests))
                throw TypeError(".WellnessSurveyProto.holisticHealthInterests: array expected");
            message.holisticHealthInterests = [];
            for (let i = 0; i < object.holisticHealthInterests.length; ++i)
                message.holisticHealthInterests[i] = String(object.holisticHealthInterests[i]);
        }
        if (object.opennessToHolisticModalities != null)
            message.opennessToHolisticModalities = String(object.opennessToHolisticModalities);
        if (object.gender != null)
            message.gender = String(object.gender);
        return message;
    };

    /**
     * Creates a plain object from a WellnessSurveyProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WellnessSurveyProto
     * @static
     * @param {WellnessSurveyProto} message WellnessSurveyProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WellnessSurveyProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.wellnessGoals = [];
            object.holisticHealthInterests = [];
        }
        if (options.defaults) {
            object.opennessToHolisticModalities = "";
            object.gender = "";
        }
        if (message.wellnessGoals && message.wellnessGoals.length) {
            object.wellnessGoals = [];
            for (let j = 0; j < message.wellnessGoals.length; ++j)
                object.wellnessGoals[j] = message.wellnessGoals[j];
        }
        if (message.holisticHealthInterests && message.holisticHealthInterests.length) {
            object.holisticHealthInterests = [];
            for (let j = 0; j < message.holisticHealthInterests.length; ++j)
                object.holisticHealthInterests[j] = message.holisticHealthInterests[j];
        }
        if (message.opennessToHolisticModalities != null && message.hasOwnProperty("opennessToHolisticModalities"))
            object.opennessToHolisticModalities = message.opennessToHolisticModalities;
        if (message.gender != null && message.hasOwnProperty("gender"))
            object.gender = message.gender;
        return object;
    };

    /**
     * Converts this WellnessSurveyProto to JSON.
     * @function toJSON
     * @memberof WellnessSurveyProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WellnessSurveyProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for WellnessSurveyProto
     * @function getTypeUrl
     * @memberof WellnessSurveyProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    WellnessSurveyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/WellnessSurveyProto";
    };

    return WellnessSurveyProto;
})();

export const ClientRelationshipProto = $root.ClientRelationshipProto = (() => {

    /**
     * Properties of a ClientRelationshipProto.
     * @exports IClientRelationshipProto
     * @interface IClientRelationshipProto
     * @property {string|null} [businessId] ClientRelationshipProto businessId
     * @property {IClientRelationshipDetailsProto|null} [details] ClientRelationshipProto details
     */

    /**
     * Constructs a new ClientRelationshipProto.
     * @exports ClientRelationshipProto
     * @classdesc Represents a ClientRelationshipProto.
     * @implements IClientRelationshipProto
     * @constructor
     * @param {IClientRelationshipProto=} [properties] Properties to set
     */
    function ClientRelationshipProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRelationshipProto businessId.
     * @member {string} businessId
     * @memberof ClientRelationshipProto
     * @instance
     */
    ClientRelationshipProto.prototype.businessId = "";

    /**
     * ClientRelationshipProto details.
     * @member {IClientRelationshipDetailsProto|null|undefined} details
     * @memberof ClientRelationshipProto
     * @instance
     */
    ClientRelationshipProto.prototype.details = null;

    /**
     * Creates a new ClientRelationshipProto instance using the specified properties.
     * @function create
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto=} [properties] Properties to set
     * @returns {ClientRelationshipProto} ClientRelationshipProto instance
     */
    ClientRelationshipProto.create = function create(properties) {
        return new ClientRelationshipProto(properties);
    };

    /**
     * Encodes the specified ClientRelationshipProto message. Does not implicitly {@link ClientRelationshipProto.verify|verify} messages.
     * @function encode
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto} message ClientRelationshipProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.ClientRelationshipDetailsProto.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientRelationshipProto message, length delimited. Does not implicitly {@link ClientRelationshipProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRelationshipProto
     * @static
     * @param {IClientRelationshipProto} message ClientRelationshipProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRelationshipProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRelationshipProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRelationshipProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.details = $root.ClientRelationshipDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRelationshipProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRelationshipProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRelationshipProto message.
     * @function verify
     * @memberof ClientRelationshipProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRelationshipProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            let error = $root.ClientRelationshipDetailsProto.verify(message.details);
            if (error)
                return "details." + error;
        }
        return null;
    };

    /**
     * Creates a ClientRelationshipProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRelationshipProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRelationshipProto} ClientRelationshipProto
     */
    ClientRelationshipProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRelationshipProto)
            return object;
        let message = new $root.ClientRelationshipProto();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".ClientRelationshipProto.details: object expected");
            message.details = $root.ClientRelationshipDetailsProto.fromObject(object.details);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientRelationshipProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRelationshipProto
     * @static
     * @param {ClientRelationshipProto} message ClientRelationshipProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRelationshipProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.businessId = "";
            object.details = null;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.ClientRelationshipDetailsProto.toObject(message.details, options);
        return object;
    };

    /**
     * Converts this ClientRelationshipProto to JSON.
     * @function toJSON
     * @memberof ClientRelationshipProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRelationshipProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRelationshipProto
     * @function getTypeUrl
     * @memberof ClientRelationshipProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRelationshipProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRelationshipProto";
    };

    return ClientRelationshipProto;
})();

export const ClientRelationshipDetailsProto = $root.ClientRelationshipDetailsProto = (() => {

    /**
     * Properties of a ClientRelationshipDetailsProto.
     * @exports IClientRelationshipDetailsProto
     * @interface IClientRelationshipDetailsProto
     * @property {number|Long|null} [createdTimestampMs] ClientRelationshipDetailsProto createdTimestampMs
     * @property {Array.<IPurchasedPackageProto>|null} [purchasedClassPacks] ClientRelationshipDetailsProto purchasedClassPacks
     * @property {Array.<IPurchasedSingleClassCreditProto>|null} [singleClassCredits] ClientRelationshipDetailsProto singleClassCredits
     */

    /**
     * Constructs a new ClientRelationshipDetailsProto.
     * @exports ClientRelationshipDetailsProto
     * @classdesc Represents a ClientRelationshipDetailsProto.
     * @implements IClientRelationshipDetailsProto
     * @constructor
     * @param {IClientRelationshipDetailsProto=} [properties] Properties to set
     */
    function ClientRelationshipDetailsProto(properties) {
        this.purchasedClassPacks = [];
        this.singleClassCredits = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientRelationshipDetailsProto createdTimestampMs.
     * @member {number|Long} createdTimestampMs
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.createdTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ClientRelationshipDetailsProto purchasedClassPacks.
     * @member {Array.<IPurchasedPackageProto>} purchasedClassPacks
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.purchasedClassPacks = $util.emptyArray;

    /**
     * ClientRelationshipDetailsProto singleClassCredits.
     * @member {Array.<IPurchasedSingleClassCreditProto>} singleClassCredits
     * @memberof ClientRelationshipDetailsProto
     * @instance
     */
    ClientRelationshipDetailsProto.prototype.singleClassCredits = $util.emptyArray;

    /**
     * Creates a new ClientRelationshipDetailsProto instance using the specified properties.
     * @function create
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto=} [properties] Properties to set
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto instance
     */
    ClientRelationshipDetailsProto.create = function create(properties) {
        return new ClientRelationshipDetailsProto(properties);
    };

    /**
     * Encodes the specified ClientRelationshipDetailsProto message. Does not implicitly {@link ClientRelationshipDetailsProto.verify|verify} messages.
     * @function encode
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto} message ClientRelationshipDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipDetailsProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.createdTimestampMs != null && Object.hasOwnProperty.call(message, "createdTimestampMs"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.createdTimestampMs);
        if (message.purchasedClassPacks != null && message.purchasedClassPacks.length)
            for (let i = 0; i < message.purchasedClassPacks.length; ++i)
                $root.PurchasedPackageProto.encode(message.purchasedClassPacks[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.singleClassCredits != null && message.singleClassCredits.length)
            for (let i = 0; i < message.singleClassCredits.length; ++i)
                $root.PurchasedSingleClassCreditProto.encode(message.singleClassCredits[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientRelationshipDetailsProto message, length delimited. Does not implicitly {@link ClientRelationshipDetailsProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {IClientRelationshipDetailsProto} message ClientRelationshipDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientRelationshipDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientRelationshipDetailsProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipDetailsProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientRelationshipDetailsProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.createdTimestampMs = reader.int64();
                    break;
                }
            case 10: {
                    if (!(message.purchasedClassPacks && message.purchasedClassPacks.length))
                        message.purchasedClassPacks = [];
                    message.purchasedClassPacks.push($root.PurchasedPackageProto.decode(reader, reader.uint32()));
                    break;
                }
            case 11: {
                    if (!(message.singleClassCredits && message.singleClassCredits.length))
                        message.singleClassCredits = [];
                    message.singleClassCredits.push($root.PurchasedSingleClassCreditProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientRelationshipDetailsProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientRelationshipDetailsProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientRelationshipDetailsProto message.
     * @function verify
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientRelationshipDetailsProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
            if (!$util.isInteger(message.createdTimestampMs) && !(message.createdTimestampMs && $util.isInteger(message.createdTimestampMs.low) && $util.isInteger(message.createdTimestampMs.high)))
                return "createdTimestampMs: integer|Long expected";
        if (message.purchasedClassPacks != null && message.hasOwnProperty("purchasedClassPacks")) {
            if (!Array.isArray(message.purchasedClassPacks))
                return "purchasedClassPacks: array expected";
            for (let i = 0; i < message.purchasedClassPacks.length; ++i) {
                let error = $root.PurchasedPackageProto.verify(message.purchasedClassPacks[i]);
                if (error)
                    return "purchasedClassPacks." + error;
            }
        }
        if (message.singleClassCredits != null && message.hasOwnProperty("singleClassCredits")) {
            if (!Array.isArray(message.singleClassCredits))
                return "singleClassCredits: array expected";
            for (let i = 0; i < message.singleClassCredits.length; ++i) {
                let error = $root.PurchasedSingleClassCreditProto.verify(message.singleClassCredits[i]);
                if (error)
                    return "singleClassCredits." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ClientRelationshipDetailsProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientRelationshipDetailsProto} ClientRelationshipDetailsProto
     */
    ClientRelationshipDetailsProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientRelationshipDetailsProto)
            return object;
        let message = new $root.ClientRelationshipDetailsProto();
        if (object.createdTimestampMs != null)
            if ($util.Long)
                (message.createdTimestampMs = $util.Long.fromValue(object.createdTimestampMs)).unsigned = false;
            else if (typeof object.createdTimestampMs === "string")
                message.createdTimestampMs = parseInt(object.createdTimestampMs, 10);
            else if (typeof object.createdTimestampMs === "number")
                message.createdTimestampMs = object.createdTimestampMs;
            else if (typeof object.createdTimestampMs === "object")
                message.createdTimestampMs = new $util.LongBits(object.createdTimestampMs.low >>> 0, object.createdTimestampMs.high >>> 0).toNumber();
        if (object.purchasedClassPacks) {
            if (!Array.isArray(object.purchasedClassPacks))
                throw TypeError(".ClientRelationshipDetailsProto.purchasedClassPacks: array expected");
            message.purchasedClassPacks = [];
            for (let i = 0; i < object.purchasedClassPacks.length; ++i) {
                if (typeof object.purchasedClassPacks[i] !== "object")
                    throw TypeError(".ClientRelationshipDetailsProto.purchasedClassPacks: object expected");
                message.purchasedClassPacks[i] = $root.PurchasedPackageProto.fromObject(object.purchasedClassPacks[i]);
            }
        }
        if (object.singleClassCredits) {
            if (!Array.isArray(object.singleClassCredits))
                throw TypeError(".ClientRelationshipDetailsProto.singleClassCredits: array expected");
            message.singleClassCredits = [];
            for (let i = 0; i < object.singleClassCredits.length; ++i) {
                if (typeof object.singleClassCredits[i] !== "object")
                    throw TypeError(".ClientRelationshipDetailsProto.singleClassCredits: object expected");
                message.singleClassCredits[i] = $root.PurchasedSingleClassCreditProto.fromObject(object.singleClassCredits[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientRelationshipDetailsProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {ClientRelationshipDetailsProto} message ClientRelationshipDetailsProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientRelationshipDetailsProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.purchasedClassPacks = [];
            object.singleClassCredits = [];
        }
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.createdTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.createdTimestampMs = options.longs === String ? "0" : 0;
        if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
            if (typeof message.createdTimestampMs === "number")
                object.createdTimestampMs = options.longs === String ? String(message.createdTimestampMs) : message.createdTimestampMs;
            else
                object.createdTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimestampMs) : options.longs === Number ? new $util.LongBits(message.createdTimestampMs.low >>> 0, message.createdTimestampMs.high >>> 0).toNumber() : message.createdTimestampMs;
        if (message.purchasedClassPacks && message.purchasedClassPacks.length) {
            object.purchasedClassPacks = [];
            for (let j = 0; j < message.purchasedClassPacks.length; ++j)
                object.purchasedClassPacks[j] = $root.PurchasedPackageProto.toObject(message.purchasedClassPacks[j], options);
        }
        if (message.singleClassCredits && message.singleClassCredits.length) {
            object.singleClassCredits = [];
            for (let j = 0; j < message.singleClassCredits.length; ++j)
                object.singleClassCredits[j] = $root.PurchasedSingleClassCreditProto.toObject(message.singleClassCredits[j], options);
        }
        return object;
    };

    /**
     * Converts this ClientRelationshipDetailsProto to JSON.
     * @function toJSON
     * @memberof ClientRelationshipDetailsProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientRelationshipDetailsProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientRelationshipDetailsProto
     * @function getTypeUrl
     * @memberof ClientRelationshipDetailsProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientRelationshipDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientRelationshipDetailsProto";
    };

    return ClientRelationshipDetailsProto;
})();

export const ApiClientInquiryProto = $root.ApiClientInquiryProto = (() => {

    /**
     * Properties of an ApiClientInquiryProto.
     * @exports IApiClientInquiryProto
     * @interface IApiClientInquiryProto
     * @property {string|null} [userId] ApiClientInquiryProto userId
     * @property {IClientInquiryDetailsProto|null} [details] ApiClientInquiryProto details
     */

    /**
     * Constructs a new ApiClientInquiryProto.
     * @exports ApiClientInquiryProto
     * @classdesc Represents an ApiClientInquiryProto.
     * @implements IApiClientInquiryProto
     * @constructor
     * @param {IApiClientInquiryProto=} [properties] Properties to set
     */
    function ApiClientInquiryProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiClientInquiryProto userId.
     * @member {string} userId
     * @memberof ApiClientInquiryProto
     * @instance
     */
    ApiClientInquiryProto.prototype.userId = "";

    /**
     * ApiClientInquiryProto details.
     * @member {IClientInquiryDetailsProto|null|undefined} details
     * @memberof ApiClientInquiryProto
     * @instance
     */
    ApiClientInquiryProto.prototype.details = null;

    /**
     * Creates a new ApiClientInquiryProto instance using the specified properties.
     * @function create
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto=} [properties] Properties to set
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto instance
     */
    ApiClientInquiryProto.create = function create(properties) {
        return new ApiClientInquiryProto(properties);
    };

    /**
     * Encodes the specified ApiClientInquiryProto message. Does not implicitly {@link ApiClientInquiryProto.verify|verify} messages.
     * @function encode
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto} message ApiClientInquiryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiClientInquiryProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.ClientInquiryDetailsProto.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiClientInquiryProto message, length delimited. Does not implicitly {@link ApiClientInquiryProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiClientInquiryProto
     * @static
     * @param {IApiClientInquiryProto} message ApiClientInquiryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiClientInquiryProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiClientInquiryProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiClientInquiryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiClientInquiryProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiClientInquiryProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.details = $root.ClientInquiryDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiClientInquiryProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiClientInquiryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiClientInquiryProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiClientInquiryProto message.
     * @function verify
     * @memberof ApiClientInquiryProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiClientInquiryProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            let error = $root.ClientInquiryDetailsProto.verify(message.details);
            if (error)
                return "details." + error;
        }
        return null;
    };

    /**
     * Creates an ApiClientInquiryProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiClientInquiryProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiClientInquiryProto} ApiClientInquiryProto
     */
    ApiClientInquiryProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiClientInquiryProto)
            return object;
        let message = new $root.ApiClientInquiryProto();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".ApiClientInquiryProto.details: object expected");
            message.details = $root.ClientInquiryDetailsProto.fromObject(object.details);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiClientInquiryProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiClientInquiryProto
     * @static
     * @param {ApiClientInquiryProto} message ApiClientInquiryProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiClientInquiryProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.userId = "";
            object.details = null;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.ClientInquiryDetailsProto.toObject(message.details, options);
        return object;
    };

    /**
     * Converts this ApiClientInquiryProto to JSON.
     * @function toJSON
     * @memberof ApiClientInquiryProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiClientInquiryProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiClientInquiryProto
     * @function getTypeUrl
     * @memberof ApiClientInquiryProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiClientInquiryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiClientInquiryProto";
    };

    return ApiClientInquiryProto;
})();

export const ClientInquiryDetailsProto = $root.ClientInquiryDetailsProto = (() => {

    /**
     * Properties of a ClientInquiryDetailsProto.
     * @exports IClientInquiryDetailsProto
     * @interface IClientInquiryDetailsProto
     * @property {number|Long|null} [createTimestampMs] ClientInquiryDetailsProto createTimestampMs
     * @property {string|null} [message] ClientInquiryDetailsProto message
     * @property {boolean|null} [rejectedByProvider] ClientInquiryDetailsProto rejectedByProvider
     * @property {string|null} [inquirerEmail] ClientInquiryDetailsProto inquirerEmail
     * @property {string|null} [inquirerName] ClientInquiryDetailsProto inquirerName
     */

    /**
     * Constructs a new ClientInquiryDetailsProto.
     * @exports ClientInquiryDetailsProto
     * @classdesc Represents a ClientInquiryDetailsProto.
     * @implements IClientInquiryDetailsProto
     * @constructor
     * @param {IClientInquiryDetailsProto=} [properties] Properties to set
     */
    function ClientInquiryDetailsProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientInquiryDetailsProto createTimestampMs.
     * @member {number|Long} createTimestampMs
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.createTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ClientInquiryDetailsProto message.
     * @member {string} message
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.message = "";

    /**
     * ClientInquiryDetailsProto rejectedByProvider.
     * @member {boolean} rejectedByProvider
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.rejectedByProvider = false;

    /**
     * ClientInquiryDetailsProto inquirerEmail.
     * @member {string} inquirerEmail
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.inquirerEmail = "";

    /**
     * ClientInquiryDetailsProto inquirerName.
     * @member {string} inquirerName
     * @memberof ClientInquiryDetailsProto
     * @instance
     */
    ClientInquiryDetailsProto.prototype.inquirerName = "";

    /**
     * Creates a new ClientInquiryDetailsProto instance using the specified properties.
     * @function create
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto=} [properties] Properties to set
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto instance
     */
    ClientInquiryDetailsProto.create = function create(properties) {
        return new ClientInquiryDetailsProto(properties);
    };

    /**
     * Encodes the specified ClientInquiryDetailsProto message. Does not implicitly {@link ClientInquiryDetailsProto.verify|verify} messages.
     * @function encode
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto} message ClientInquiryDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInquiryDetailsProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.createTimestampMs != null && Object.hasOwnProperty.call(message, "createTimestampMs"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.createTimestampMs);
        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
        if (message.rejectedByProvider != null && Object.hasOwnProperty.call(message, "rejectedByProvider"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.rejectedByProvider);
        if (message.inquirerEmail != null && Object.hasOwnProperty.call(message, "inquirerEmail"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.inquirerEmail);
        if (message.inquirerName != null && Object.hasOwnProperty.call(message, "inquirerName"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.inquirerName);
        return writer;
    };

    /**
     * Encodes the specified ClientInquiryDetailsProto message, length delimited. Does not implicitly {@link ClientInquiryDetailsProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {IClientInquiryDetailsProto} message ClientInquiryDetailsProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientInquiryDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientInquiryDetailsProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInquiryDetailsProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientInquiryDetailsProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.createTimestampMs = reader.int64();
                    break;
                }
            case 2: {
                    message.message = reader.string();
                    break;
                }
            case 3: {
                    message.rejectedByProvider = reader.bool();
                    break;
                }
            case 4: {
                    message.inquirerEmail = reader.string();
                    break;
                }
            case 5: {
                    message.inquirerName = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientInquiryDetailsProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientInquiryDetailsProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientInquiryDetailsProto message.
     * @function verify
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientInquiryDetailsProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.createTimestampMs != null && message.hasOwnProperty("createTimestampMs"))
            if (!$util.isInteger(message.createTimestampMs) && !(message.createTimestampMs && $util.isInteger(message.createTimestampMs.low) && $util.isInteger(message.createTimestampMs.high)))
                return "createTimestampMs: integer|Long expected";
        if (message.message != null && message.hasOwnProperty("message"))
            if (!$util.isString(message.message))
                return "message: string expected";
        if (message.rejectedByProvider != null && message.hasOwnProperty("rejectedByProvider"))
            if (typeof message.rejectedByProvider !== "boolean")
                return "rejectedByProvider: boolean expected";
        if (message.inquirerEmail != null && message.hasOwnProperty("inquirerEmail"))
            if (!$util.isString(message.inquirerEmail))
                return "inquirerEmail: string expected";
        if (message.inquirerName != null && message.hasOwnProperty("inquirerName"))
            if (!$util.isString(message.inquirerName))
                return "inquirerName: string expected";
        return null;
    };

    /**
     * Creates a ClientInquiryDetailsProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientInquiryDetailsProto} ClientInquiryDetailsProto
     */
    ClientInquiryDetailsProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientInquiryDetailsProto)
            return object;
        let message = new $root.ClientInquiryDetailsProto();
        if (object.createTimestampMs != null)
            if ($util.Long)
                (message.createTimestampMs = $util.Long.fromValue(object.createTimestampMs)).unsigned = false;
            else if (typeof object.createTimestampMs === "string")
                message.createTimestampMs = parseInt(object.createTimestampMs, 10);
            else if (typeof object.createTimestampMs === "number")
                message.createTimestampMs = object.createTimestampMs;
            else if (typeof object.createTimestampMs === "object")
                message.createTimestampMs = new $util.LongBits(object.createTimestampMs.low >>> 0, object.createTimestampMs.high >>> 0).toNumber();
        if (object.message != null)
            message.message = String(object.message);
        if (object.rejectedByProvider != null)
            message.rejectedByProvider = Boolean(object.rejectedByProvider);
        if (object.inquirerEmail != null)
            message.inquirerEmail = String(object.inquirerEmail);
        if (object.inquirerName != null)
            message.inquirerName = String(object.inquirerName);
        return message;
    };

    /**
     * Creates a plain object from a ClientInquiryDetailsProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {ClientInquiryDetailsProto} message ClientInquiryDetailsProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientInquiryDetailsProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.createTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.createTimestampMs = options.longs === String ? "0" : 0;
            object.message = "";
            object.rejectedByProvider = false;
            object.inquirerEmail = "";
            object.inquirerName = "";
        }
        if (message.createTimestampMs != null && message.hasOwnProperty("createTimestampMs"))
            if (typeof message.createTimestampMs === "number")
                object.createTimestampMs = options.longs === String ? String(message.createTimestampMs) : message.createTimestampMs;
            else
                object.createTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimestampMs) : options.longs === Number ? new $util.LongBits(message.createTimestampMs.low >>> 0, message.createTimestampMs.high >>> 0).toNumber() : message.createTimestampMs;
        if (message.message != null && message.hasOwnProperty("message"))
            object.message = message.message;
        if (message.rejectedByProvider != null && message.hasOwnProperty("rejectedByProvider"))
            object.rejectedByProvider = message.rejectedByProvider;
        if (message.inquirerEmail != null && message.hasOwnProperty("inquirerEmail"))
            object.inquirerEmail = message.inquirerEmail;
        if (message.inquirerName != null && message.hasOwnProperty("inquirerName"))
            object.inquirerName = message.inquirerName;
        return object;
    };

    /**
     * Converts this ClientInquiryDetailsProto to JSON.
     * @function toJSON
     * @memberof ClientInquiryDetailsProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientInquiryDetailsProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientInquiryDetailsProto
     * @function getTypeUrl
     * @memberof ClientInquiryDetailsProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientInquiryDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientInquiryDetailsProto";
    };

    return ClientInquiryDetailsProto;
})();

export const PurchasedPackageProto = $root.PurchasedPackageProto = (() => {

    /**
     * Properties of a PurchasedPackageProto.
     * @exports IPurchasedPackageProto
     * @interface IPurchasedPackageProto
     * @property {string|null} [purchasedClassPackId] PurchasedPackageProto purchasedClassPackId
     * @property {IPackageProto|null} [packageDetails] PurchasedPackageProto packageDetails
     * @property {number|Long|null} [purchaseTimestamp] PurchasedPackageProto purchaseTimestamp
     * @property {string|null} [stripeSessionId] PurchasedPackageProto stripeSessionId
     * @property {number|null} [classesRemaining] PurchasedPackageProto classesRemaining
     */

    /**
     * Constructs a new PurchasedPackageProto.
     * @exports PurchasedPackageProto
     * @classdesc Represents a PurchasedPackageProto.
     * @implements IPurchasedPackageProto
     * @constructor
     * @param {IPurchasedPackageProto=} [properties] Properties to set
     */
    function PurchasedPackageProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedPackageProto purchasedClassPackId.
     * @member {string} purchasedClassPackId
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.purchasedClassPackId = "";

    /**
     * PurchasedPackageProto packageDetails.
     * @member {IPackageProto|null|undefined} packageDetails
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.packageDetails = null;

    /**
     * PurchasedPackageProto purchaseTimestamp.
     * @member {number|Long} purchaseTimestamp
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PurchasedPackageProto stripeSessionId.
     * @member {string} stripeSessionId
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.stripeSessionId = "";

    /**
     * PurchasedPackageProto classesRemaining.
     * @member {number} classesRemaining
     * @memberof PurchasedPackageProto
     * @instance
     */
    PurchasedPackageProto.prototype.classesRemaining = 0;

    /**
     * Creates a new PurchasedPackageProto instance using the specified properties.
     * @function create
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto=} [properties] Properties to set
     * @returns {PurchasedPackageProto} PurchasedPackageProto instance
     */
    PurchasedPackageProto.create = function create(properties) {
        return new PurchasedPackageProto(properties);
    };

    /**
     * Encodes the specified PurchasedPackageProto message. Does not implicitly {@link PurchasedPackageProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto} message PurchasedPackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedPackageProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.purchasedClassPackId != null && Object.hasOwnProperty.call(message, "purchasedClassPackId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.purchasedClassPackId);
        if (message.packageDetails != null && Object.hasOwnProperty.call(message, "packageDetails"))
            $root.PackageProto.encode(message.packageDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
        if (message.stripeSessionId != null && Object.hasOwnProperty.call(message, "stripeSessionId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stripeSessionId);
        if (message.classesRemaining != null && Object.hasOwnProperty.call(message, "classesRemaining"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.classesRemaining);
        return writer;
    };

    /**
     * Encodes the specified PurchasedPackageProto message, length delimited. Does not implicitly {@link PurchasedPackageProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedPackageProto
     * @static
     * @param {IPurchasedPackageProto} message PurchasedPackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedPackageProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedPackageProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedPackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedPackageProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedPackageProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.purchasedClassPackId = reader.string();
                    break;
                }
            case 2: {
                    message.packageDetails = $root.PackageProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.purchaseTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.stripeSessionId = reader.string();
                    break;
                }
            case 5: {
                    message.classesRemaining = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedPackageProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedPackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedPackageProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedPackageProto message.
     * @function verify
     * @memberof PurchasedPackageProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedPackageProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.purchasedClassPackId != null && message.hasOwnProperty("purchasedClassPackId"))
            if (!$util.isString(message.purchasedClassPackId))
                return "purchasedClassPackId: string expected";
        if (message.packageDetails != null && message.hasOwnProperty("packageDetails")) {
            let error = $root.PackageProto.verify(message.packageDetails);
            if (error)
                return "packageDetails." + error;
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                return "purchaseTimestamp: integer|Long expected";
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            if (!$util.isString(message.stripeSessionId))
                return "stripeSessionId: string expected";
        if (message.classesRemaining != null && message.hasOwnProperty("classesRemaining"))
            if (!$util.isInteger(message.classesRemaining))
                return "classesRemaining: integer expected";
        return null;
    };

    /**
     * Creates a PurchasedPackageProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedPackageProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedPackageProto} PurchasedPackageProto
     */
    PurchasedPackageProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedPackageProto)
            return object;
        let message = new $root.PurchasedPackageProto();
        if (object.purchasedClassPackId != null)
            message.purchasedClassPackId = String(object.purchasedClassPackId);
        if (object.packageDetails != null) {
            if (typeof object.packageDetails !== "object")
                throw TypeError(".PurchasedPackageProto.packageDetails: object expected");
            message.packageDetails = $root.PackageProto.fromObject(object.packageDetails);
        }
        if (object.purchaseTimestamp != null)
            if ($util.Long)
                (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
            else if (typeof object.purchaseTimestamp === "string")
                message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
            else if (typeof object.purchaseTimestamp === "number")
                message.purchaseTimestamp = object.purchaseTimestamp;
            else if (typeof object.purchaseTimestamp === "object")
                message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
        if (object.stripeSessionId != null)
            message.stripeSessionId = String(object.stripeSessionId);
        if (object.classesRemaining != null)
            message.classesRemaining = object.classesRemaining | 0;
        return message;
    };

    /**
     * Creates a plain object from a PurchasedPackageProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedPackageProto
     * @static
     * @param {PurchasedPackageProto} message PurchasedPackageProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedPackageProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.purchasedClassPackId = "";
            object.packageDetails = null;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.purchaseTimestamp = options.longs === String ? "0" : 0;
            object.stripeSessionId = "";
            object.classesRemaining = 0;
        }
        if (message.purchasedClassPackId != null && message.hasOwnProperty("purchasedClassPackId"))
            object.purchasedClassPackId = message.purchasedClassPackId;
        if (message.packageDetails != null && message.hasOwnProperty("packageDetails"))
            object.packageDetails = $root.PackageProto.toObject(message.packageDetails, options);
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (typeof message.purchaseTimestamp === "number")
                object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
            else
                object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            object.stripeSessionId = message.stripeSessionId;
        if (message.classesRemaining != null && message.hasOwnProperty("classesRemaining"))
            object.classesRemaining = message.classesRemaining;
        return object;
    };

    /**
     * Converts this PurchasedPackageProto to JSON.
     * @function toJSON
     * @memberof PurchasedPackageProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedPackageProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedPackageProto
     * @function getTypeUrl
     * @memberof PurchasedPackageProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedPackageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedPackageProto";
    };

    return PurchasedPackageProto;
})();

export const PurchasedSingleClassCreditProto = $root.PurchasedSingleClassCreditProto = (() => {

    /**
     * Properties of a PurchasedSingleClassCreditProto.
     * @exports IPurchasedSingleClassCreditProto
     * @interface IPurchasedSingleClassCreditProto
     * @property {string|null} [classCreditId] PurchasedSingleClassCreditProto classCreditId
     * @property {IPriceCategoryProto|null} [priceCategoryDetails] PurchasedSingleClassCreditProto priceCategoryDetails
     * @property {IPurchasedClassCreditProto|null} [classDetails] PurchasedSingleClassCreditProto classDetails
     * @property {IPurchasedServiceCreditProto|null} [serviceDetails] PurchasedSingleClassCreditProto serviceDetails
     * @property {number|Long|null} [purchaseTimestamp] PurchasedSingleClassCreditProto purchaseTimestamp
     * @property {string|null} [stripeSessionId] PurchasedSingleClassCreditProto stripeSessionId
     * @property {boolean|null} [used] PurchasedSingleClassCreditProto used
     */

    /**
     * Constructs a new PurchasedSingleClassCreditProto.
     * @exports PurchasedSingleClassCreditProto
     * @classdesc Represents a PurchasedSingleClassCreditProto.
     * @implements IPurchasedSingleClassCreditProto
     * @constructor
     * @param {IPurchasedSingleClassCreditProto=} [properties] Properties to set
     */
    function PurchasedSingleClassCreditProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedSingleClassCreditProto classCreditId.
     * @member {string} classCreditId
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.classCreditId = "";

    /**
     * PurchasedSingleClassCreditProto priceCategoryDetails.
     * @member {IPriceCategoryProto|null|undefined} priceCategoryDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.priceCategoryDetails = null;

    /**
     * PurchasedSingleClassCreditProto classDetails.
     * @member {IPurchasedClassCreditProto|null|undefined} classDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.classDetails = null;

    /**
     * PurchasedSingleClassCreditProto serviceDetails.
     * @member {IPurchasedServiceCreditProto|null|undefined} serviceDetails
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.serviceDetails = null;

    /**
     * PurchasedSingleClassCreditProto purchaseTimestamp.
     * @member {number|Long} purchaseTimestamp
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PurchasedSingleClassCreditProto stripeSessionId.
     * @member {string} stripeSessionId
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.stripeSessionId = "";

    /**
     * PurchasedSingleClassCreditProto used.
     * @member {boolean} used
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    PurchasedSingleClassCreditProto.prototype.used = false;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * PurchasedSingleClassCreditProto CreditType.
     * @member {"priceCategoryDetails"|"classDetails"|"serviceDetails"|undefined} CreditType
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     */
    Object.defineProperty(PurchasedSingleClassCreditProto.prototype, "CreditType", {
        get: $util.oneOfGetter($oneOfFields = ["priceCategoryDetails", "classDetails", "serviceDetails"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new PurchasedSingleClassCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto=} [properties] Properties to set
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto instance
     */
    PurchasedSingleClassCreditProto.create = function create(properties) {
        return new PurchasedSingleClassCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedSingleClassCreditProto message. Does not implicitly {@link PurchasedSingleClassCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedSingleClassCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classCreditId != null && Object.hasOwnProperty.call(message, "classCreditId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.classCreditId);
        if (message.priceCategoryDetails != null && Object.hasOwnProperty.call(message, "priceCategoryDetails"))
            $root.PriceCategoryProto.encode(message.priceCategoryDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
        if (message.stripeSessionId != null && Object.hasOwnProperty.call(message, "stripeSessionId"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.stripeSessionId);
        if (message.used != null && Object.hasOwnProperty.call(message, "used"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.used);
        if (message.classDetails != null && Object.hasOwnProperty.call(message, "classDetails"))
            $root.PurchasedClassCreditProto.encode(message.classDetails, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.serviceDetails != null && Object.hasOwnProperty.call(message, "serviceDetails"))
            $root.PurchasedServiceCreditProto.encode(message.serviceDetails, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedSingleClassCreditProto message, length delimited. Does not implicitly {@link PurchasedSingleClassCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {IPurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedSingleClassCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedSingleClassCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedSingleClassCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedSingleClassCreditProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classCreditId = reader.string();
                    break;
                }
            case 2: {
                    message.priceCategoryDetails = $root.PriceCategoryProto.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.classDetails = $root.PurchasedClassCreditProto.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    message.serviceDetails = $root.PurchasedServiceCreditProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.purchaseTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.stripeSessionId = reader.string();
                    break;
                }
            case 5: {
                    message.used = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedSingleClassCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedSingleClassCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedSingleClassCreditProto message.
     * @function verify
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedSingleClassCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.classCreditId != null && message.hasOwnProperty("classCreditId"))
            if (!$util.isString(message.classCreditId))
                return "classCreditId: string expected";
        if (message.priceCategoryDetails != null && message.hasOwnProperty("priceCategoryDetails")) {
            properties.CreditType = 1;
            {
                let error = $root.PriceCategoryProto.verify(message.priceCategoryDetails);
                if (error)
                    return "priceCategoryDetails." + error;
            }
        }
        if (message.classDetails != null && message.hasOwnProperty("classDetails")) {
            if (properties.CreditType === 1)
                return "CreditType: multiple values";
            properties.CreditType = 1;
            {
                let error = $root.PurchasedClassCreditProto.verify(message.classDetails);
                if (error)
                    return "classDetails." + error;
            }
        }
        if (message.serviceDetails != null && message.hasOwnProperty("serviceDetails")) {
            if (properties.CreditType === 1)
                return "CreditType: multiple values";
            properties.CreditType = 1;
            {
                let error = $root.PurchasedServiceCreditProto.verify(message.serviceDetails);
                if (error)
                    return "serviceDetails." + error;
            }
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                return "purchaseTimestamp: integer|Long expected";
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            if (!$util.isString(message.stripeSessionId))
                return "stripeSessionId: string expected";
        if (message.used != null && message.hasOwnProperty("used"))
            if (typeof message.used !== "boolean")
                return "used: boolean expected";
        return null;
    };

    /**
     * Creates a PurchasedSingleClassCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedSingleClassCreditProto} PurchasedSingleClassCreditProto
     */
    PurchasedSingleClassCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedSingleClassCreditProto)
            return object;
        let message = new $root.PurchasedSingleClassCreditProto();
        if (object.classCreditId != null)
            message.classCreditId = String(object.classCreditId);
        if (object.priceCategoryDetails != null) {
            if (typeof object.priceCategoryDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.priceCategoryDetails: object expected");
            message.priceCategoryDetails = $root.PriceCategoryProto.fromObject(object.priceCategoryDetails);
        }
        if (object.classDetails != null) {
            if (typeof object.classDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.classDetails: object expected");
            message.classDetails = $root.PurchasedClassCreditProto.fromObject(object.classDetails);
        }
        if (object.serviceDetails != null) {
            if (typeof object.serviceDetails !== "object")
                throw TypeError(".PurchasedSingleClassCreditProto.serviceDetails: object expected");
            message.serviceDetails = $root.PurchasedServiceCreditProto.fromObject(object.serviceDetails);
        }
        if (object.purchaseTimestamp != null)
            if ($util.Long)
                (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
            else if (typeof object.purchaseTimestamp === "string")
                message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
            else if (typeof object.purchaseTimestamp === "number")
                message.purchaseTimestamp = object.purchaseTimestamp;
            else if (typeof object.purchaseTimestamp === "object")
                message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
        if (object.stripeSessionId != null)
            message.stripeSessionId = String(object.stripeSessionId);
        if (object.used != null)
            message.used = Boolean(object.used);
        return message;
    };

    /**
     * Creates a plain object from a PurchasedSingleClassCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {PurchasedSingleClassCreditProto} message PurchasedSingleClassCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedSingleClassCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.classCreditId = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.purchaseTimestamp = options.longs === String ? "0" : 0;
            object.stripeSessionId = "";
            object.used = false;
        }
        if (message.classCreditId != null && message.hasOwnProperty("classCreditId"))
            object.classCreditId = message.classCreditId;
        if (message.priceCategoryDetails != null && message.hasOwnProperty("priceCategoryDetails")) {
            object.priceCategoryDetails = $root.PriceCategoryProto.toObject(message.priceCategoryDetails, options);
            if (options.oneofs)
                object.CreditType = "priceCategoryDetails";
        }
        if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
            if (typeof message.purchaseTimestamp === "number")
                object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
            else
                object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
        if (message.stripeSessionId != null && message.hasOwnProperty("stripeSessionId"))
            object.stripeSessionId = message.stripeSessionId;
        if (message.used != null && message.hasOwnProperty("used"))
            object.used = message.used;
        if (message.classDetails != null && message.hasOwnProperty("classDetails")) {
            object.classDetails = $root.PurchasedClassCreditProto.toObject(message.classDetails, options);
            if (options.oneofs)
                object.CreditType = "classDetails";
        }
        if (message.serviceDetails != null && message.hasOwnProperty("serviceDetails")) {
            object.serviceDetails = $root.PurchasedServiceCreditProto.toObject(message.serviceDetails, options);
            if (options.oneofs)
                object.CreditType = "serviceDetails";
        }
        return object;
    };

    /**
     * Converts this PurchasedSingleClassCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedSingleClassCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedSingleClassCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedSingleClassCreditProto
     * @function getTypeUrl
     * @memberof PurchasedSingleClassCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedSingleClassCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedSingleClassCreditProto";
    };

    return PurchasedSingleClassCreditProto;
})();

export const PurchasedClassCreditProto = $root.PurchasedClassCreditProto = (() => {

    /**
     * Properties of a PurchasedClassCreditProto.
     * @exports IPurchasedClassCreditProto
     * @interface IPurchasedClassCreditProto
     * @property {string|null} [classTemplateId] PurchasedClassCreditProto classTemplateId
     * @property {string|null} [className] PurchasedClassCreditProto className
     * @property {space.kenko.proto.IPriceProto|null} [purchasePrice] PurchasedClassCreditProto purchasePrice
     */

    /**
     * Constructs a new PurchasedClassCreditProto.
     * @exports PurchasedClassCreditProto
     * @classdesc Represents a PurchasedClassCreditProto.
     * @implements IPurchasedClassCreditProto
     * @constructor
     * @param {IPurchasedClassCreditProto=} [properties] Properties to set
     */
    function PurchasedClassCreditProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedClassCreditProto classTemplateId.
     * @member {string} classTemplateId
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.classTemplateId = "";

    /**
     * PurchasedClassCreditProto className.
     * @member {string} className
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.className = "";

    /**
     * PurchasedClassCreditProto purchasePrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} purchasePrice
     * @memberof PurchasedClassCreditProto
     * @instance
     */
    PurchasedClassCreditProto.prototype.purchasePrice = null;

    /**
     * Creates a new PurchasedClassCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto=} [properties] Properties to set
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto instance
     */
    PurchasedClassCreditProto.create = function create(properties) {
        return new PurchasedClassCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedClassCreditProto message. Does not implicitly {@link PurchasedClassCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto} message PurchasedClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedClassCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.classTemplateId);
        if (message.className != null && Object.hasOwnProperty.call(message, "className"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.className);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            $root.space.kenko.proto.PriceProto.encode(message.purchasePrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedClassCreditProto message, length delimited. Does not implicitly {@link PurchasedClassCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {IPurchasedClassCreditProto} message PurchasedClassCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedClassCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedClassCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedClassCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedClassCreditProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classTemplateId = reader.string();
                    break;
                }
            case 2: {
                    message.className = reader.string();
                    break;
                }
            case 3: {
                    message.purchasePrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedClassCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedClassCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedClassCreditProto message.
     * @function verify
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedClassCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            if (!$util.isString(message.classTemplateId))
                return "classTemplateId: string expected";
        if (message.className != null && message.hasOwnProperty("className"))
            if (!$util.isString(message.className))
                return "className: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice")) {
            let error = $root.space.kenko.proto.PriceProto.verify(message.purchasePrice);
            if (error)
                return "purchasePrice." + error;
        }
        return null;
    };

    /**
     * Creates a PurchasedClassCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedClassCreditProto} PurchasedClassCreditProto
     */
    PurchasedClassCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedClassCreditProto)
            return object;
        let message = new $root.PurchasedClassCreditProto();
        if (object.classTemplateId != null)
            message.classTemplateId = String(object.classTemplateId);
        if (object.className != null)
            message.className = String(object.className);
        if (object.purchasePrice != null) {
            if (typeof object.purchasePrice !== "object")
                throw TypeError(".PurchasedClassCreditProto.purchasePrice: object expected");
            message.purchasePrice = $root.space.kenko.proto.PriceProto.fromObject(object.purchasePrice);
        }
        return message;
    };

    /**
     * Creates a plain object from a PurchasedClassCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {PurchasedClassCreditProto} message PurchasedClassCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedClassCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.classTemplateId = "";
            object.className = "";
            object.purchasePrice = null;
        }
        if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
            object.classTemplateId = message.classTemplateId;
        if (message.className != null && message.hasOwnProperty("className"))
            object.className = message.className;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = $root.space.kenko.proto.PriceProto.toObject(message.purchasePrice, options);
        return object;
    };

    /**
     * Converts this PurchasedClassCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedClassCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedClassCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedClassCreditProto
     * @function getTypeUrl
     * @memberof PurchasedClassCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedClassCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedClassCreditProto";
    };

    return PurchasedClassCreditProto;
})();

export const PurchasedServiceCreditProto = $root.PurchasedServiceCreditProto = (() => {

    /**
     * Properties of a PurchasedServiceCreditProto.
     * @exports IPurchasedServiceCreditProto
     * @interface IPurchasedServiceCreditProto
     * @property {string|null} [serviceSku] PurchasedServiceCreditProto serviceSku
     * @property {string|null} [serviceName] PurchasedServiceCreditProto serviceName
     * @property {space.kenko.proto.IPriceProto|null} [purchasePrice] PurchasedServiceCreditProto purchasePrice
     */

    /**
     * Constructs a new PurchasedServiceCreditProto.
     * @exports PurchasedServiceCreditProto
     * @classdesc Represents a PurchasedServiceCreditProto.
     * @implements IPurchasedServiceCreditProto
     * @constructor
     * @param {IPurchasedServiceCreditProto=} [properties] Properties to set
     */
    function PurchasedServiceCreditProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PurchasedServiceCreditProto serviceSku.
     * @member {string} serviceSku
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.serviceSku = "";

    /**
     * PurchasedServiceCreditProto serviceName.
     * @member {string} serviceName
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.serviceName = "";

    /**
     * PurchasedServiceCreditProto purchasePrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} purchasePrice
     * @memberof PurchasedServiceCreditProto
     * @instance
     */
    PurchasedServiceCreditProto.prototype.purchasePrice = null;

    /**
     * Creates a new PurchasedServiceCreditProto instance using the specified properties.
     * @function create
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto=} [properties] Properties to set
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto instance
     */
    PurchasedServiceCreditProto.create = function create(properties) {
        return new PurchasedServiceCreditProto(properties);
    };

    /**
     * Encodes the specified PurchasedServiceCreditProto message. Does not implicitly {@link PurchasedServiceCreditProto.verify|verify} messages.
     * @function encode
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto} message PurchasedServiceCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedServiceCreditProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serviceSku != null && Object.hasOwnProperty.call(message, "serviceSku"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.serviceSku);
        if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.serviceName);
        if (message.purchasePrice != null && Object.hasOwnProperty.call(message, "purchasePrice"))
            $root.space.kenko.proto.PriceProto.encode(message.purchasePrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PurchasedServiceCreditProto message, length delimited. Does not implicitly {@link PurchasedServiceCreditProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {IPurchasedServiceCreditProto} message PurchasedServiceCreditProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PurchasedServiceCreditProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PurchasedServiceCreditProto message from the specified reader or buffer.
     * @function decode
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedServiceCreditProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PurchasedServiceCreditProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.serviceSku = reader.string();
                    break;
                }
            case 2: {
                    message.serviceName = reader.string();
                    break;
                }
            case 3: {
                    message.purchasePrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PurchasedServiceCreditProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PurchasedServiceCreditProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PurchasedServiceCreditProto message.
     * @function verify
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PurchasedServiceCreditProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            if (!$util.isString(message.serviceSku))
                return "serviceSku: string expected";
        if (message.serviceName != null && message.hasOwnProperty("serviceName"))
            if (!$util.isString(message.serviceName))
                return "serviceName: string expected";
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice")) {
            let error = $root.space.kenko.proto.PriceProto.verify(message.purchasePrice);
            if (error)
                return "purchasePrice." + error;
        }
        return null;
    };

    /**
     * Creates a PurchasedServiceCreditProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PurchasedServiceCreditProto} PurchasedServiceCreditProto
     */
    PurchasedServiceCreditProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PurchasedServiceCreditProto)
            return object;
        let message = new $root.PurchasedServiceCreditProto();
        if (object.serviceSku != null)
            message.serviceSku = String(object.serviceSku);
        if (object.serviceName != null)
            message.serviceName = String(object.serviceName);
        if (object.purchasePrice != null) {
            if (typeof object.purchasePrice !== "object")
                throw TypeError(".PurchasedServiceCreditProto.purchasePrice: object expected");
            message.purchasePrice = $root.space.kenko.proto.PriceProto.fromObject(object.purchasePrice);
        }
        return message;
    };

    /**
     * Creates a plain object from a PurchasedServiceCreditProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {PurchasedServiceCreditProto} message PurchasedServiceCreditProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PurchasedServiceCreditProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.serviceSku = "";
            object.serviceName = "";
            object.purchasePrice = null;
        }
        if (message.serviceSku != null && message.hasOwnProperty("serviceSku"))
            object.serviceSku = message.serviceSku;
        if (message.serviceName != null && message.hasOwnProperty("serviceName"))
            object.serviceName = message.serviceName;
        if (message.purchasePrice != null && message.hasOwnProperty("purchasePrice"))
            object.purchasePrice = $root.space.kenko.proto.PriceProto.toObject(message.purchasePrice, options);
        return object;
    };

    /**
     * Converts this PurchasedServiceCreditProto to JSON.
     * @function toJSON
     * @memberof PurchasedServiceCreditProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PurchasedServiceCreditProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PurchasedServiceCreditProto
     * @function getTypeUrl
     * @memberof PurchasedServiceCreditProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PurchasedServiceCreditProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PurchasedServiceCreditProto";
    };

    return PurchasedServiceCreditProto;
})();

export const PriceCategoryProto = $root.PriceCategoryProto = (() => {

    /**
     * Properties of a PriceCategoryProto.
     * @exports IPriceCategoryProto
     * @interface IPriceCategoryProto
     * @property {string|null} [categoryId] PriceCategoryProto categoryId
     * @property {string|null} [displayName] PriceCategoryProto displayName
     * @property {space.kenko.proto.IPriceProto|null} [singleClassPrice] PriceCategoryProto singleClassPrice
     * @property {boolean|null} [archived] PriceCategoryProto archived
     */

    /**
     * Constructs a new PriceCategoryProto.
     * @exports PriceCategoryProto
     * @classdesc Represents a PriceCategoryProto.
     * @implements IPriceCategoryProto
     * @constructor
     * @param {IPriceCategoryProto=} [properties] Properties to set
     */
    function PriceCategoryProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PriceCategoryProto categoryId.
     * @member {string} categoryId
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.categoryId = "";

    /**
     * PriceCategoryProto displayName.
     * @member {string} displayName
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.displayName = "";

    /**
     * PriceCategoryProto singleClassPrice.
     * @member {space.kenko.proto.IPriceProto|null|undefined} singleClassPrice
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.singleClassPrice = null;

    /**
     * PriceCategoryProto archived.
     * @member {boolean} archived
     * @memberof PriceCategoryProto
     * @instance
     */
    PriceCategoryProto.prototype.archived = false;

    /**
     * Creates a new PriceCategoryProto instance using the specified properties.
     * @function create
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto=} [properties] Properties to set
     * @returns {PriceCategoryProto} PriceCategoryProto instance
     */
    PriceCategoryProto.create = function create(properties) {
        return new PriceCategoryProto(properties);
    };

    /**
     * Encodes the specified PriceCategoryProto message. Does not implicitly {@link PriceCategoryProto.verify|verify} messages.
     * @function encode
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto} message PriceCategoryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceCategoryProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.categoryId != null && Object.hasOwnProperty.call(message, "categoryId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.categoryId);
        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
        if (message.singleClassPrice != null && Object.hasOwnProperty.call(message, "singleClassPrice"))
            $root.space.kenko.proto.PriceProto.encode(message.singleClassPrice, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
        return writer;
    };

    /**
     * Encodes the specified PriceCategoryProto message, length delimited. Does not implicitly {@link PriceCategoryProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PriceCategoryProto
     * @static
     * @param {IPriceCategoryProto} message PriceCategoryProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PriceCategoryProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PriceCategoryProto message from the specified reader or buffer.
     * @function decode
     * @memberof PriceCategoryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PriceCategoryProto} PriceCategoryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceCategoryProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PriceCategoryProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.categoryId = reader.string();
                    break;
                }
            case 2: {
                    message.displayName = reader.string();
                    break;
                }
            case 3: {
                    message.singleClassPrice = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.archived = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PriceCategoryProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PriceCategoryProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PriceCategoryProto} PriceCategoryProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PriceCategoryProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PriceCategoryProto message.
     * @function verify
     * @memberof PriceCategoryProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PriceCategoryProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.categoryId != null && message.hasOwnProperty("categoryId"))
            if (!$util.isString(message.categoryId))
                return "categoryId: string expected";
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            if (!$util.isString(message.displayName))
                return "displayName: string expected";
        if (message.singleClassPrice != null && message.hasOwnProperty("singleClassPrice")) {
            let error = $root.space.kenko.proto.PriceProto.verify(message.singleClassPrice);
            if (error)
                return "singleClassPrice." + error;
        }
        if (message.archived != null && message.hasOwnProperty("archived"))
            if (typeof message.archived !== "boolean")
                return "archived: boolean expected";
        return null;
    };

    /**
     * Creates a PriceCategoryProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PriceCategoryProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PriceCategoryProto} PriceCategoryProto
     */
    PriceCategoryProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PriceCategoryProto)
            return object;
        let message = new $root.PriceCategoryProto();
        if (object.categoryId != null)
            message.categoryId = String(object.categoryId);
        if (object.displayName != null)
            message.displayName = String(object.displayName);
        if (object.singleClassPrice != null) {
            if (typeof object.singleClassPrice !== "object")
                throw TypeError(".PriceCategoryProto.singleClassPrice: object expected");
            message.singleClassPrice = $root.space.kenko.proto.PriceProto.fromObject(object.singleClassPrice);
        }
        if (object.archived != null)
            message.archived = Boolean(object.archived);
        return message;
    };

    /**
     * Creates a plain object from a PriceCategoryProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PriceCategoryProto
     * @static
     * @param {PriceCategoryProto} message PriceCategoryProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PriceCategoryProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.categoryId = "";
            object.displayName = "";
            object.singleClassPrice = null;
            object.archived = false;
        }
        if (message.categoryId != null && message.hasOwnProperty("categoryId"))
            object.categoryId = message.categoryId;
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            object.displayName = message.displayName;
        if (message.singleClassPrice != null && message.hasOwnProperty("singleClassPrice"))
            object.singleClassPrice = $root.space.kenko.proto.PriceProto.toObject(message.singleClassPrice, options);
        if (message.archived != null && message.hasOwnProperty("archived"))
            object.archived = message.archived;
        return object;
    };

    /**
     * Converts this PriceCategoryProto to JSON.
     * @function toJSON
     * @memberof PriceCategoryProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PriceCategoryProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PriceCategoryProto
     * @function getTypeUrl
     * @memberof PriceCategoryProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PriceCategoryProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PriceCategoryProto";
    };

    return PriceCategoryProto;
})();

export const PackageProto = $root.PackageProto = (() => {

    /**
     * Properties of a PackageProto.
     * @exports IPackageProto
     * @interface IPackageProto
     * @property {string|null} [id] PackageProto id
     * @property {string|null} [displayName] PackageProto displayName
     * @property {Array.<string>|null} [includedClassOrServiceIds] PackageProto includedClassOrServiceIds
     * @property {number|null} [classLimit] PackageProto classLimit
     * @property {number|null} [expirationDays] PackageProto expirationDays
     * @property {space.kenko.proto.IPriceProto|null} [price] PackageProto price
     * @property {boolean|null} [archived] PackageProto archived
     */

    /**
     * Constructs a new PackageProto.
     * @exports PackageProto
     * @classdesc Represents a PackageProto.
     * @implements IPackageProto
     * @constructor
     * @param {IPackageProto=} [properties] Properties to set
     */
    function PackageProto(properties) {
        this.includedClassOrServiceIds = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PackageProto id.
     * @member {string} id
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.id = "";

    /**
     * PackageProto displayName.
     * @member {string} displayName
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.displayName = "";

    /**
     * PackageProto includedClassOrServiceIds.
     * @member {Array.<string>} includedClassOrServiceIds
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.includedClassOrServiceIds = $util.emptyArray;

    /**
     * PackageProto classLimit.
     * @member {number} classLimit
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.classLimit = 0;

    /**
     * PackageProto expirationDays.
     * @member {number} expirationDays
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.expirationDays = 0;

    /**
     * PackageProto price.
     * @member {space.kenko.proto.IPriceProto|null|undefined} price
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.price = null;

    /**
     * PackageProto archived.
     * @member {boolean} archived
     * @memberof PackageProto
     * @instance
     */
    PackageProto.prototype.archived = false;

    /**
     * Creates a new PackageProto instance using the specified properties.
     * @function create
     * @memberof PackageProto
     * @static
     * @param {IPackageProto=} [properties] Properties to set
     * @returns {PackageProto} PackageProto instance
     */
    PackageProto.create = function create(properties) {
        return new PackageProto(properties);
    };

    /**
     * Encodes the specified PackageProto message. Does not implicitly {@link PackageProto.verify|verify} messages.
     * @function encode
     * @memberof PackageProto
     * @static
     * @param {IPackageProto} message PackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PackageProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
        if (message.includedClassOrServiceIds != null && message.includedClassOrServiceIds.length)
            for (let i = 0; i < message.includedClassOrServiceIds.length; ++i)
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.includedClassOrServiceIds[i]);
        if (message.classLimit != null && Object.hasOwnProperty.call(message, "classLimit"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.classLimit);
        if (message.expirationDays != null && Object.hasOwnProperty.call(message, "expirationDays"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.expirationDays);
        if (message.price != null && Object.hasOwnProperty.call(message, "price"))
            $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
        return writer;
    };

    /**
     * Encodes the specified PackageProto message, length delimited. Does not implicitly {@link PackageProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PackageProto
     * @static
     * @param {IPackageProto} message PackageProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PackageProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PackageProto message from the specified reader or buffer.
     * @function decode
     * @memberof PackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PackageProto} PackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PackageProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PackageProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.displayName = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.includedClassOrServiceIds && message.includedClassOrServiceIds.length))
                        message.includedClassOrServiceIds = [];
                    message.includedClassOrServiceIds.push(reader.string());
                    break;
                }
            case 4: {
                    message.classLimit = reader.int32();
                    break;
                }
            case 5: {
                    message.expirationDays = reader.int32();
                    break;
                }
            case 6: {
                    message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.archived = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PackageProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PackageProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PackageProto} PackageProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PackageProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PackageProto message.
     * @function verify
     * @memberof PackageProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PackageProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            if (!$util.isString(message.displayName))
                return "displayName: string expected";
        if (message.includedClassOrServiceIds != null && message.hasOwnProperty("includedClassOrServiceIds")) {
            if (!Array.isArray(message.includedClassOrServiceIds))
                return "includedClassOrServiceIds: array expected";
            for (let i = 0; i < message.includedClassOrServiceIds.length; ++i)
                if (!$util.isString(message.includedClassOrServiceIds[i]))
                    return "includedClassOrServiceIds: string[] expected";
        }
        if (message.classLimit != null && message.hasOwnProperty("classLimit"))
            if (!$util.isInteger(message.classLimit))
                return "classLimit: integer expected";
        if (message.expirationDays != null && message.hasOwnProperty("expirationDays"))
            if (!$util.isInteger(message.expirationDays))
                return "expirationDays: integer expected";
        if (message.price != null && message.hasOwnProperty("price")) {
            let error = $root.space.kenko.proto.PriceProto.verify(message.price);
            if (error)
                return "price." + error;
        }
        if (message.archived != null && message.hasOwnProperty("archived"))
            if (typeof message.archived !== "boolean")
                return "archived: boolean expected";
        return null;
    };

    /**
     * Creates a PackageProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PackageProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PackageProto} PackageProto
     */
    PackageProto.fromObject = function fromObject(object) {
        if (object instanceof $root.PackageProto)
            return object;
        let message = new $root.PackageProto();
        if (object.id != null)
            message.id = String(object.id);
        if (object.displayName != null)
            message.displayName = String(object.displayName);
        if (object.includedClassOrServiceIds) {
            if (!Array.isArray(object.includedClassOrServiceIds))
                throw TypeError(".PackageProto.includedClassOrServiceIds: array expected");
            message.includedClassOrServiceIds = [];
            for (let i = 0; i < object.includedClassOrServiceIds.length; ++i)
                message.includedClassOrServiceIds[i] = String(object.includedClassOrServiceIds[i]);
        }
        if (object.classLimit != null)
            message.classLimit = object.classLimit | 0;
        if (object.expirationDays != null)
            message.expirationDays = object.expirationDays | 0;
        if (object.price != null) {
            if (typeof object.price !== "object")
                throw TypeError(".PackageProto.price: object expected");
            message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
        }
        if (object.archived != null)
            message.archived = Boolean(object.archived);
        return message;
    };

    /**
     * Creates a plain object from a PackageProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PackageProto
     * @static
     * @param {PackageProto} message PackageProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PackageProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.includedClassOrServiceIds = [];
        if (options.defaults) {
            object.id = "";
            object.displayName = "";
            object.classLimit = 0;
            object.expirationDays = 0;
            object.price = null;
            object.archived = false;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.displayName != null && message.hasOwnProperty("displayName"))
            object.displayName = message.displayName;
        if (message.includedClassOrServiceIds && message.includedClassOrServiceIds.length) {
            object.includedClassOrServiceIds = [];
            for (let j = 0; j < message.includedClassOrServiceIds.length; ++j)
                object.includedClassOrServiceIds[j] = message.includedClassOrServiceIds[j];
        }
        if (message.classLimit != null && message.hasOwnProperty("classLimit"))
            object.classLimit = message.classLimit;
        if (message.expirationDays != null && message.hasOwnProperty("expirationDays"))
            object.expirationDays = message.expirationDays;
        if (message.price != null && message.hasOwnProperty("price"))
            object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
        if (message.archived != null && message.hasOwnProperty("archived"))
            object.archived = message.archived;
        return object;
    };

    /**
     * Converts this PackageProto to JSON.
     * @function toJSON
     * @memberof PackageProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PackageProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PackageProto
     * @function getTypeUrl
     * @memberof PackageProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PackageProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PackageProto";
    };

    return PackageProto;
})();

export const space = $root.space = (() => {

    /**
     * Namespace space.
     * @exports space
     * @namespace
     */
    const space = {};

    space.kenko = (function() {

        /**
         * Namespace kenko.
         * @memberof space
         * @namespace
         */
        const kenko = {};

        kenko.proto = (function() {

            /**
             * Namespace proto.
             * @memberof space.kenko
             * @namespace
             */
            const proto = {};

            proto.LocalTimeProto = (function() {

                /**
                 * Properties of a LocalTimeProto.
                 * @memberof space.kenko.proto
                 * @interface ILocalTimeProto
                 * @property {number|null} [hour] LocalTimeProto hour
                 * @property {number|null} [minute] LocalTimeProto minute
                 */

                /**
                 * Constructs a new LocalTimeProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LocalTimeProto.
                 * @implements ILocalTimeProto
                 * @constructor
                 * @param {space.kenko.proto.ILocalTimeProto=} [properties] Properties to set
                 */
                function LocalTimeProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalTimeProto hour.
                 * @member {number} hour
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 */
                LocalTimeProto.prototype.hour = 0;

                /**
                 * LocalTimeProto minute.
                 * @member {number} minute
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 */
                LocalTimeProto.prototype.minute = 0;

                /**
                 * Creates a new LocalTimeProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto instance
                 */
                LocalTimeProto.create = function create(properties) {
                    return new LocalTimeProto(properties);
                };

                /**
                 * Encodes the specified LocalTimeProto message. Does not implicitly {@link space.kenko.proto.LocalTimeProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto} message LocalTimeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalTimeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.hour);
                    if (message.minute != null && Object.hasOwnProperty.call(message, "minute"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minute);
                    return writer;
                };

                /**
                 * Encodes the specified LocalTimeProto message, length delimited. Does not implicitly {@link space.kenko.proto.LocalTimeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.ILocalTimeProto} message LocalTimeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalTimeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalTimeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalTimeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LocalTimeProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.hour = reader.int32();
                                break;
                            }
                        case 2: {
                                message.minute = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalTimeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalTimeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalTimeProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalTimeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.hour != null && message.hasOwnProperty("hour"))
                        if (!$util.isInteger(message.hour))
                            return "hour: integer expected";
                    if (message.minute != null && message.hasOwnProperty("minute"))
                        if (!$util.isInteger(message.minute))
                            return "minute: integer expected";
                    return null;
                };

                /**
                 * Creates a LocalTimeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LocalTimeProto} LocalTimeProto
                 */
                LocalTimeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LocalTimeProto)
                        return object;
                    let message = new $root.space.kenko.proto.LocalTimeProto();
                    if (object.hour != null)
                        message.hour = object.hour | 0;
                    if (object.minute != null)
                        message.minute = object.minute | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a LocalTimeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {space.kenko.proto.LocalTimeProto} message LocalTimeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalTimeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.hour = 0;
                        object.minute = 0;
                    }
                    if (message.hour != null && message.hasOwnProperty("hour"))
                        object.hour = message.hour;
                    if (message.minute != null && message.hasOwnProperty("minute"))
                        object.minute = message.minute;
                    return object;
                };

                /**
                 * Converts this LocalTimeProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalTimeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalTimeProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LocalTimeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalTimeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LocalTimeProto";
                };

                return LocalTimeProto;
            })();

            proto.LocalDateProto = (function() {

                /**
                 * Properties of a LocalDateProto.
                 * @memberof space.kenko.proto
                 * @interface ILocalDateProto
                 * @property {number|null} [year] LocalDateProto year
                 * @property {number|null} [month] LocalDateProto month
                 * @property {number|null} [date] LocalDateProto date
                 */

                /**
                 * Constructs a new LocalDateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LocalDateProto.
                 * @implements ILocalDateProto
                 * @constructor
                 * @param {space.kenko.proto.ILocalDateProto=} [properties] Properties to set
                 */
                function LocalDateProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LocalDateProto year.
                 * @member {number} year
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.year = 0;

                /**
                 * LocalDateProto month.
                 * @member {number} month
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.month = 0;

                /**
                 * LocalDateProto date.
                 * @member {number} date
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 */
                LocalDateProto.prototype.date = 0;

                /**
                 * Creates a new LocalDateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto instance
                 */
                LocalDateProto.create = function create(properties) {
                    return new LocalDateProto(properties);
                };

                /**
                 * Encodes the specified LocalDateProto message. Does not implicitly {@link space.kenko.proto.LocalDateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto} message LocalDateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalDateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
                    if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
                    if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.date);
                    return writer;
                };

                /**
                 * Encodes the specified LocalDateProto message, length delimited. Does not implicitly {@link space.kenko.proto.LocalDateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.ILocalDateProto} message LocalDateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LocalDateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LocalDateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalDateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LocalDateProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.year = reader.int32();
                                break;
                            }
                        case 2: {
                                message.month = reader.int32();
                                break;
                            }
                        case 3: {
                                message.date = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LocalDateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LocalDateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LocalDateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LocalDateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.year != null && message.hasOwnProperty("year"))
                        if (!$util.isInteger(message.year))
                            return "year: integer expected";
                    if (message.month != null && message.hasOwnProperty("month"))
                        if (!$util.isInteger(message.month))
                            return "month: integer expected";
                    if (message.date != null && message.hasOwnProperty("date"))
                        if (!$util.isInteger(message.date))
                            return "date: integer expected";
                    return null;
                };

                /**
                 * Creates a LocalDateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LocalDateProto} LocalDateProto
                 */
                LocalDateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LocalDateProto)
                        return object;
                    let message = new $root.space.kenko.proto.LocalDateProto();
                    if (object.year != null)
                        message.year = object.year | 0;
                    if (object.month != null)
                        message.month = object.month | 0;
                    if (object.date != null)
                        message.date = object.date | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a LocalDateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {space.kenko.proto.LocalDateProto} message LocalDateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LocalDateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.year = 0;
                        object.month = 0;
                        object.date = 0;
                    }
                    if (message.year != null && message.hasOwnProperty("year"))
                        object.year = message.year;
                    if (message.month != null && message.hasOwnProperty("month"))
                        object.month = message.month;
                    if (message.date != null && message.hasOwnProperty("date"))
                        object.date = message.date;
                    return object;
                };

                /**
                 * Converts this LocalDateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LocalDateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LocalDateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LocalDateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LocalDateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LocalDateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LocalDateProto";
                };

                return LocalDateProto;
            })();

            proto.PriceProto = (function() {

                /**
                 * Properties of a PriceProto.
                 * @memberof space.kenko.proto
                 * @interface IPriceProto
                 * @property {number|Long|null} [amount] PriceProto amount
                 * @property {string|null} [currencyCode] PriceProto currencyCode
                 */

                /**
                 * Constructs a new PriceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PriceProto.
                 * @implements IPriceProto
                 * @constructor
                 * @param {space.kenko.proto.IPriceProto=} [properties] Properties to set
                 */
                function PriceProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PriceProto amount.
                 * @member {number|Long} amount
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 */
                PriceProto.prototype.amount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PriceProto currencyCode.
                 * @member {string} currencyCode
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 */
                PriceProto.prototype.currencyCode = "";

                /**
                 * Creates a new PriceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PriceProto} PriceProto instance
                 */
                PriceProto.create = function create(properties) {
                    return new PriceProto(properties);
                };

                /**
                 * Encodes the specified PriceProto message. Does not implicitly {@link space.kenko.proto.PriceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto} message PriceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PriceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.amount);
                    if (message.currencyCode != null && Object.hasOwnProperty.call(message, "currencyCode"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.currencyCode);
                    return writer;
                };

                /**
                 * Encodes the specified PriceProto message, length delimited. Does not implicitly {@link space.kenko.proto.PriceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.IPriceProto} message PriceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PriceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PriceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PriceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PriceProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.amount = reader.int64();
                                break;
                            }
                        case 2: {
                                message.currencyCode = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PriceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PriceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PriceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PriceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount) && !(message.amount && $util.isInteger(message.amount.low) && $util.isInteger(message.amount.high)))
                            return "amount: integer|Long expected";
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        if (!$util.isString(message.currencyCode))
                            return "currencyCode: string expected";
                    return null;
                };

                /**
                 * Creates a PriceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PriceProto} PriceProto
                 */
                PriceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PriceProto)
                        return object;
                    let message = new $root.space.kenko.proto.PriceProto();
                    if (object.amount != null)
                        if ($util.Long)
                            (message.amount = $util.Long.fromValue(object.amount)).unsigned = false;
                        else if (typeof object.amount === "string")
                            message.amount = parseInt(object.amount, 10);
                        else if (typeof object.amount === "number")
                            message.amount = object.amount;
                        else if (typeof object.amount === "object")
                            message.amount = new $util.LongBits(object.amount.low >>> 0, object.amount.high >>> 0).toNumber();
                    if (object.currencyCode != null)
                        message.currencyCode = String(object.currencyCode);
                    return message;
                };

                /**
                 * Creates a plain object from a PriceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {space.kenko.proto.PriceProto} message PriceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PriceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.amount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.amount = options.longs === String ? "0" : 0;
                        object.currencyCode = "";
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (typeof message.amount === "number")
                            object.amount = options.longs === String ? String(message.amount) : message.amount;
                        else
                            object.amount = options.longs === String ? $util.Long.prototype.toString.call(message.amount) : options.longs === Number ? new $util.LongBits(message.amount.low >>> 0, message.amount.high >>> 0).toNumber() : message.amount;
                    if (message.currencyCode != null && message.hasOwnProperty("currencyCode"))
                        object.currencyCode = message.currencyCode;
                    return object;
                };

                /**
                 * Converts this PriceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PriceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PriceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PriceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PriceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PriceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PriceProto";
                };

                return PriceProto;
            })();

            proto.ErrorProto = (function() {

                /**
                 * Properties of an ErrorProto.
                 * @memberof space.kenko.proto
                 * @interface IErrorProto
                 * @property {string|null} [path] ErrorProto path
                 * @property {string|null} [error] ErrorProto error
                 */

                /**
                 * Constructs a new ErrorProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ErrorProto.
                 * @implements IErrorProto
                 * @constructor
                 * @param {space.kenko.proto.IErrorProto=} [properties] Properties to set
                 */
                function ErrorProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ErrorProto path.
                 * @member {string} path
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 */
                ErrorProto.prototype.path = "";

                /**
                 * ErrorProto error.
                 * @member {string} error
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 */
                ErrorProto.prototype.error = "";

                /**
                 * Creates a new ErrorProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto instance
                 */
                ErrorProto.create = function create(properties) {
                    return new ErrorProto(properties);
                };

                /**
                 * Encodes the specified ErrorProto message. Does not implicitly {@link space.kenko.proto.ErrorProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto} message ErrorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.path);
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
                    return writer;
                };

                /**
                 * Encodes the specified ErrorProto message, length delimited. Does not implicitly {@link space.kenko.proto.ErrorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.IErrorProto} message ErrorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ErrorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ErrorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ErrorProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.path = reader.string();
                                break;
                            }
                        case 2: {
                                message.error = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ErrorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ErrorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ErrorProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ErrorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path"))
                        if (!$util.isString(message.path))
                            return "path: string expected";
                    if (message.error != null && message.hasOwnProperty("error"))
                        if (!$util.isString(message.error))
                            return "error: string expected";
                    return null;
                };

                /**
                 * Creates an ErrorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ErrorProto} ErrorProto
                 */
                ErrorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ErrorProto)
                        return object;
                    let message = new $root.space.kenko.proto.ErrorProto();
                    if (object.path != null)
                        message.path = String(object.path);
                    if (object.error != null)
                        message.error = String(object.error);
                    return message;
                };

                /**
                 * Creates a plain object from an ErrorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {space.kenko.proto.ErrorProto} message ErrorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ErrorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.path = "";
                        object.error = "";
                    }
                    if (message.path != null && message.hasOwnProperty("path"))
                        object.path = message.path;
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = message.error;
                    return object;
                };

                /**
                 * Converts this ErrorProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ErrorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ErrorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ErrorProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ErrorProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ErrorProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ErrorProto";
                };

                return ErrorProto;
            })();

            proto.SystemNoteProto = (function() {

                /**
                 * Properties of a SystemNoteProto.
                 * @memberof space.kenko.proto
                 * @interface ISystemNoteProto
                 * @property {string|null} [note] SystemNoteProto note
                 * @property {number|Long|null} [timestamp] SystemNoteProto timestamp
                 * @property {space.kenko.proto.ILoginProto|null} [loggedInUser] SystemNoteProto loggedInUser
                 */

                /**
                 * Constructs a new SystemNoteProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SystemNoteProto.
                 * @implements ISystemNoteProto
                 * @constructor
                 * @param {space.kenko.proto.ISystemNoteProto=} [properties] Properties to set
                 */
                function SystemNoteProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemNoteProto note.
                 * @member {string} note
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.note = "";

                /**
                 * SystemNoteProto timestamp.
                 * @member {number|Long} timestamp
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * SystemNoteProto loggedInUser.
                 * @member {space.kenko.proto.ILoginProto|null|undefined} loggedInUser
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 */
                SystemNoteProto.prototype.loggedInUser = null;

                /**
                 * Creates a new SystemNoteProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto instance
                 */
                SystemNoteProto.create = function create(properties) {
                    return new SystemNoteProto(properties);
                };

                /**
                 * Encodes the specified SystemNoteProto message. Does not implicitly {@link space.kenko.proto.SystemNoteProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto} message SystemNoteProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemNoteProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.note);
                    if (message.timestamp != null && Object.hasOwnProperty.call(message, "timestamp"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.timestamp);
                    if (message.loggedInUser != null && Object.hasOwnProperty.call(message, "loggedInUser"))
                        $root.space.kenko.proto.LoginProto.encode(message.loggedInUser, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SystemNoteProto message, length delimited. Does not implicitly {@link space.kenko.proto.SystemNoteProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.ISystemNoteProto} message SystemNoteProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemNoteProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemNoteProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemNoteProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SystemNoteProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.note = reader.string();
                                break;
                            }
                        case 2: {
                                message.timestamp = reader.int64();
                                break;
                            }
                        case 3: {
                                message.loggedInUser = $root.space.kenko.proto.LoginProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemNoteProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemNoteProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemNoteProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemNoteProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.note != null && message.hasOwnProperty("note"))
                        if (!$util.isString(message.note))
                            return "note: string expected";
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        if (!$util.isInteger(message.timestamp) && !(message.timestamp && $util.isInteger(message.timestamp.low) && $util.isInteger(message.timestamp.high)))
                            return "timestamp: integer|Long expected";
                    if (message.loggedInUser != null && message.hasOwnProperty("loggedInUser")) {
                        let error = $root.space.kenko.proto.LoginProto.verify(message.loggedInUser);
                        if (error)
                            return "loggedInUser." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SystemNoteProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SystemNoteProto} SystemNoteProto
                 */
                SystemNoteProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SystemNoteProto)
                        return object;
                    let message = new $root.space.kenko.proto.SystemNoteProto();
                    if (object.note != null)
                        message.note = String(object.note);
                    if (object.timestamp != null)
                        if ($util.Long)
                            (message.timestamp = $util.Long.fromValue(object.timestamp)).unsigned = false;
                        else if (typeof object.timestamp === "string")
                            message.timestamp = parseInt(object.timestamp, 10);
                        else if (typeof object.timestamp === "number")
                            message.timestamp = object.timestamp;
                        else if (typeof object.timestamp === "object")
                            message.timestamp = new $util.LongBits(object.timestamp.low >>> 0, object.timestamp.high >>> 0).toNumber();
                    if (object.loggedInUser != null) {
                        if (typeof object.loggedInUser !== "object")
                            throw TypeError(".space.kenko.proto.SystemNoteProto.loggedInUser: object expected");
                        message.loggedInUser = $root.space.kenko.proto.LoginProto.fromObject(object.loggedInUser);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemNoteProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {space.kenko.proto.SystemNoteProto} message SystemNoteProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemNoteProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.note = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.timestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.timestamp = options.longs === String ? "0" : 0;
                        object.loggedInUser = null;
                    }
                    if (message.note != null && message.hasOwnProperty("note"))
                        object.note = message.note;
                    if (message.timestamp != null && message.hasOwnProperty("timestamp"))
                        if (typeof message.timestamp === "number")
                            object.timestamp = options.longs === String ? String(message.timestamp) : message.timestamp;
                        else
                            object.timestamp = options.longs === String ? $util.Long.prototype.toString.call(message.timestamp) : options.longs === Number ? new $util.LongBits(message.timestamp.low >>> 0, message.timestamp.high >>> 0).toNumber() : message.timestamp;
                    if (message.loggedInUser != null && message.hasOwnProperty("loggedInUser"))
                        object.loggedInUser = $root.space.kenko.proto.LoginProto.toObject(message.loggedInUser, options);
                    return object;
                };

                /**
                 * Converts this SystemNoteProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemNoteProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SystemNoteProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SystemNoteProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SystemNoteProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SystemNoteProto";
                };

                return SystemNoteProto;
            })();

            proto.LoginProto = (function() {

                /**
                 * Properties of a LoginProto.
                 * @memberof space.kenko.proto
                 * @interface ILoginProto
                 * @property {string|null} [loginId] LoginProto loginId
                 * @property {string|null} [loginName] LoginProto loginName
                 * @property {string|null} [loginEmail] LoginProto loginEmail
                 */

                /**
                 * Constructs a new LoginProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LoginProto.
                 * @implements ILoginProto
                 * @constructor
                 * @param {space.kenko.proto.ILoginProto=} [properties] Properties to set
                 */
                function LoginProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LoginProto loginId.
                 * @member {string} loginId
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginId = "";

                /**
                 * LoginProto loginName.
                 * @member {string} loginName
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginName = "";

                /**
                 * LoginProto loginEmail.
                 * @member {string} loginEmail
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 */
                LoginProto.prototype.loginEmail = "";

                /**
                 * Creates a new LoginProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LoginProto} LoginProto instance
                 */
                LoginProto.create = function create(properties) {
                    return new LoginProto(properties);
                };

                /**
                 * Encodes the specified LoginProto message. Does not implicitly {@link space.kenko.proto.LoginProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto} message LoginProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoginProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.loginId != null && Object.hasOwnProperty.call(message, "loginId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.loginId);
                    if (message.loginName != null && Object.hasOwnProperty.call(message, "loginName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.loginName);
                    if (message.loginEmail != null && Object.hasOwnProperty.call(message, "loginEmail"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.loginEmail);
                    return writer;
                };

                /**
                 * Encodes the specified LoginProto message, length delimited. Does not implicitly {@link space.kenko.proto.LoginProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.ILoginProto} message LoginProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LoginProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LoginProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoginProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LoginProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.loginId = reader.string();
                                break;
                            }
                        case 2: {
                                message.loginName = reader.string();
                                break;
                            }
                        case 3: {
                                message.loginEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LoginProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LoginProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LoginProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LoginProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.loginId != null && message.hasOwnProperty("loginId"))
                        if (!$util.isString(message.loginId))
                            return "loginId: string expected";
                    if (message.loginName != null && message.hasOwnProperty("loginName"))
                        if (!$util.isString(message.loginName))
                            return "loginName: string expected";
                    if (message.loginEmail != null && message.hasOwnProperty("loginEmail"))
                        if (!$util.isString(message.loginEmail))
                            return "loginEmail: string expected";
                    return null;
                };

                /**
                 * Creates a LoginProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LoginProto} LoginProto
                 */
                LoginProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LoginProto)
                        return object;
                    let message = new $root.space.kenko.proto.LoginProto();
                    if (object.loginId != null)
                        message.loginId = String(object.loginId);
                    if (object.loginName != null)
                        message.loginName = String(object.loginName);
                    if (object.loginEmail != null)
                        message.loginEmail = String(object.loginEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a LoginProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {space.kenko.proto.LoginProto} message LoginProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LoginProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.loginId = "";
                        object.loginName = "";
                        object.loginEmail = "";
                    }
                    if (message.loginId != null && message.hasOwnProperty("loginId"))
                        object.loginId = message.loginId;
                    if (message.loginName != null && message.hasOwnProperty("loginName"))
                        object.loginName = message.loginName;
                    if (message.loginEmail != null && message.hasOwnProperty("loginEmail"))
                        object.loginEmail = message.loginEmail;
                    return object;
                };

                /**
                 * Converts this LoginProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LoginProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LoginProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LoginProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LoginProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LoginProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LoginProto";
                };

                return LoginProto;
            })();

            proto.EmailProto = (function() {

                /**
                 * Properties of an EmailProto.
                 * @memberof space.kenko.proto
                 * @interface IEmailProto
                 * @property {string|null} [email] EmailProto email
                 * @property {boolean|null} [isVerified] EmailProto isVerified
                 */

                /**
                 * Constructs a new EmailProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an EmailProto.
                 * @implements IEmailProto
                 * @constructor
                 * @param {space.kenko.proto.IEmailProto=} [properties] Properties to set
                 */
                function EmailProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EmailProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 */
                EmailProto.prototype.email = "";

                /**
                 * EmailProto isVerified.
                 * @member {boolean} isVerified
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 */
                EmailProto.prototype.isVerified = false;

                /**
                 * Creates a new EmailProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.EmailProto} EmailProto instance
                 */
                EmailProto.create = function create(properties) {
                    return new EmailProto(properties);
                };

                /**
                 * Encodes the specified EmailProto message. Does not implicitly {@link space.kenko.proto.EmailProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto} message EmailProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                    if (message.isVerified != null && Object.hasOwnProperty.call(message, "isVerified"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerified);
                    return writer;
                };

                /**
                 * Encodes the specified EmailProto message, length delimited. Does not implicitly {@link space.kenko.proto.EmailProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.IEmailProto} message EmailProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EmailProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.EmailProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.email = reader.string();
                                break;
                            }
                        case 2: {
                                message.isVerified = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EmailProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EmailProto message.
                 * @function verify
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EmailProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        if (typeof message.isVerified !== "boolean")
                            return "isVerified: boolean expected";
                    return null;
                };

                /**
                 * Creates an EmailProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.EmailProto} EmailProto
                 */
                EmailProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.EmailProto)
                        return object;
                    let message = new $root.space.kenko.proto.EmailProto();
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.isVerified != null)
                        message.isVerified = Boolean(object.isVerified);
                    return message;
                };

                /**
                 * Creates a plain object from an EmailProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {space.kenko.proto.EmailProto} message EmailProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EmailProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.email = "";
                        object.isVerified = false;
                    }
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        object.isVerified = message.isVerified;
                    return object;
                };

                /**
                 * Converts this EmailProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.EmailProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EmailProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EmailProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.EmailProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EmailProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.EmailProto";
                };

                return EmailProto;
            })();

            proto.PhoneProto = (function() {

                /**
                 * Properties of a PhoneProto.
                 * @memberof space.kenko.proto
                 * @interface IPhoneProto
                 * @property {string|null} [number] PhoneProto number
                 * @property {boolean|null} [isVerified] PhoneProto isVerified
                 */

                /**
                 * Constructs a new PhoneProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PhoneProto.
                 * @implements IPhoneProto
                 * @constructor
                 * @param {space.kenko.proto.IPhoneProto=} [properties] Properties to set
                 */
                function PhoneProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PhoneProto number.
                 * @member {string} number
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 */
                PhoneProto.prototype.number = "";

                /**
                 * PhoneProto isVerified.
                 * @member {boolean} isVerified
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 */
                PhoneProto.prototype.isVerified = false;

                /**
                 * Creates a new PhoneProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto instance
                 */
                PhoneProto.create = function create(properties) {
                    return new PhoneProto(properties);
                };

                /**
                 * Encodes the specified PhoneProto message. Does not implicitly {@link space.kenko.proto.PhoneProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto} message PhoneProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhoneProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.number);
                    if (message.isVerified != null && Object.hasOwnProperty.call(message, "isVerified"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isVerified);
                    return writer;
                };

                /**
                 * Encodes the specified PhoneProto message, length delimited. Does not implicitly {@link space.kenko.proto.PhoneProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.IPhoneProto} message PhoneProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhoneProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PhoneProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhoneProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PhoneProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.number = reader.string();
                                break;
                            }
                        case 2: {
                                message.isVerified = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PhoneProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhoneProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PhoneProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PhoneProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isString(message.number))
                            return "number: string expected";
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        if (typeof message.isVerified !== "boolean")
                            return "isVerified: boolean expected";
                    return null;
                };

                /**
                 * Creates a PhoneProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PhoneProto} PhoneProto
                 */
                PhoneProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PhoneProto)
                        return object;
                    let message = new $root.space.kenko.proto.PhoneProto();
                    if (object.number != null)
                        message.number = String(object.number);
                    if (object.isVerified != null)
                        message.isVerified = Boolean(object.isVerified);
                    return message;
                };

                /**
                 * Creates a plain object from a PhoneProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {space.kenko.proto.PhoneProto} message PhoneProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PhoneProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.number = "";
                        object.isVerified = false;
                    }
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.isVerified != null && message.hasOwnProperty("isVerified"))
                        object.isVerified = message.isVerified;
                    return object;
                };

                /**
                 * Converts this PhoneProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PhoneProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PhoneProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PhoneProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PhoneProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PhoneProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PhoneProto";
                };

                return PhoneProto;
            })();

            proto.KensuExceptionProto = (function() {

                /**
                 * Properties of a KensuExceptionProto.
                 * @memberof space.kenko.proto
                 * @interface IKensuExceptionProto
                 * @property {string|null} [message] KensuExceptionProto message
                 * @property {Array.<space.kenko.proto.IErrorProto>|null} [fieldErrors] KensuExceptionProto fieldErrors
                 */

                /**
                 * Constructs a new KensuExceptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a KensuExceptionProto.
                 * @implements IKensuExceptionProto
                 * @constructor
                 * @param {space.kenko.proto.IKensuExceptionProto=} [properties] Properties to set
                 */
                function KensuExceptionProto(properties) {
                    this.fieldErrors = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * KensuExceptionProto message.
                 * @member {string} message
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 */
                KensuExceptionProto.prototype.message = "";

                /**
                 * KensuExceptionProto fieldErrors.
                 * @member {Array.<space.kenko.proto.IErrorProto>} fieldErrors
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 */
                KensuExceptionProto.prototype.fieldErrors = $util.emptyArray;

                /**
                 * Creates a new KensuExceptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto instance
                 */
                KensuExceptionProto.create = function create(properties) {
                    return new KensuExceptionProto(properties);
                };

                /**
                 * Encodes the specified KensuExceptionProto message. Does not implicitly {@link space.kenko.proto.KensuExceptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto} message KensuExceptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KensuExceptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                    if (message.fieldErrors != null && message.fieldErrors.length)
                        for (let i = 0; i < message.fieldErrors.length; ++i)
                            $root.space.kenko.proto.ErrorProto.encode(message.fieldErrors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified KensuExceptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.KensuExceptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.IKensuExceptionProto} message KensuExceptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KensuExceptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a KensuExceptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KensuExceptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.KensuExceptionProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.message = reader.string();
                                break;
                            }
                        case 2: {
                                if (!(message.fieldErrors && message.fieldErrors.length))
                                    message.fieldErrors = [];
                                message.fieldErrors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a KensuExceptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KensuExceptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a KensuExceptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                KensuExceptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    if (message.fieldErrors != null && message.hasOwnProperty("fieldErrors")) {
                        if (!Array.isArray(message.fieldErrors))
                            return "fieldErrors: array expected";
                        for (let i = 0; i < message.fieldErrors.length; ++i) {
                            let error = $root.space.kenko.proto.ErrorProto.verify(message.fieldErrors[i]);
                            if (error)
                                return "fieldErrors." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a KensuExceptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.KensuExceptionProto} KensuExceptionProto
                 */
                KensuExceptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.KensuExceptionProto)
                        return object;
                    let message = new $root.space.kenko.proto.KensuExceptionProto();
                    if (object.message != null)
                        message.message = String(object.message);
                    if (object.fieldErrors) {
                        if (!Array.isArray(object.fieldErrors))
                            throw TypeError(".space.kenko.proto.KensuExceptionProto.fieldErrors: array expected");
                        message.fieldErrors = [];
                        for (let i = 0; i < object.fieldErrors.length; ++i) {
                            if (typeof object.fieldErrors[i] !== "object")
                                throw TypeError(".space.kenko.proto.KensuExceptionProto.fieldErrors: object expected");
                            message.fieldErrors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.fieldErrors[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a KensuExceptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {space.kenko.proto.KensuExceptionProto} message KensuExceptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                KensuExceptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.fieldErrors = [];
                    if (options.defaults)
                        object.message = "";
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = message.message;
                    if (message.fieldErrors && message.fieldErrors.length) {
                        object.fieldErrors = [];
                        for (let j = 0; j < message.fieldErrors.length; ++j)
                            object.fieldErrors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.fieldErrors[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this KensuExceptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                KensuExceptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for KensuExceptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.KensuExceptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                KensuExceptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.KensuExceptionProto";
                };

                return KensuExceptionProto;
            })();

            /**
             * ContactMethodType enum.
             * @name space.kenko.proto.ContactMethodType
             * @enum {number}
             * @property {number} UNKNOWN=0 UNKNOWN value
             * @property {number} EMAIL=1 EMAIL value
             * @property {number} MOBILE_PHONE=2 MOBILE_PHONE value
             */
            proto.ContactMethodType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN"] = 0;
                values[valuesById[1] = "EMAIL"] = 1;
                values[valuesById[2] = "MOBILE_PHONE"] = 2;
                return values;
            })();

            proto.ContactMethodProto = (function() {

                /**
                 * Properties of a ContactMethodProto.
                 * @memberof space.kenko.proto
                 * @interface IContactMethodProto
                 * @property {space.kenko.proto.ContactMethodType|null} [type] ContactMethodProto type
                 * @property {string|null} [address] ContactMethodProto address
                 */

                /**
                 * Constructs a new ContactMethodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ContactMethodProto.
                 * @implements IContactMethodProto
                 * @constructor
                 * @param {space.kenko.proto.IContactMethodProto=} [properties] Properties to set
                 */
                function ContactMethodProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ContactMethodProto type.
                 * @member {space.kenko.proto.ContactMethodType} type
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 */
                ContactMethodProto.prototype.type = 0;

                /**
                 * ContactMethodProto address.
                 * @member {string} address
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 */
                ContactMethodProto.prototype.address = "";

                /**
                 * Creates a new ContactMethodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto instance
                 */
                ContactMethodProto.create = function create(properties) {
                    return new ContactMethodProto(properties);
                };

                /**
                 * Encodes the specified ContactMethodProto message. Does not implicitly {@link space.kenko.proto.ContactMethodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto} message ContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactMethodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.address);
                    return writer;
                };

                /**
                 * Encodes the specified ContactMethodProto message, length delimited. Does not implicitly {@link space.kenko.proto.ContactMethodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IContactMethodProto} message ContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ContactMethodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ContactMethodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactMethodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ContactMethodProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.type = reader.int32();
                                break;
                            }
                        case 2: {
                                message.address = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ContactMethodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ContactMethodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ContactMethodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ContactMethodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    return null;
                };

                /**
                 * Creates a ContactMethodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ContactMethodProto} ContactMethodProto
                 */
                ContactMethodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ContactMethodProto)
                        return object;
                    let message = new $root.space.kenko.proto.ContactMethodProto();
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "UNKNOWN":
                    case 0:
                        message.type = 0;
                        break;
                    case "EMAIL":
                    case 1:
                        message.type = 1;
                        break;
                    case "MOBILE_PHONE":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.address != null)
                        message.address = String(object.address);
                    return message;
                };

                /**
                 * Creates a plain object from a ContactMethodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {space.kenko.proto.ContactMethodProto} message ContactMethodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ContactMethodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.type = options.enums === String ? "UNKNOWN" : 0;
                        object.address = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.space.kenko.proto.ContactMethodType[message.type] === undefined ? message.type : $root.space.kenko.proto.ContactMethodType[message.type] : message.type;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    return object;
                };

                /**
                 * Converts this ContactMethodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ContactMethodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ContactMethodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ContactMethodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ContactMethodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ContactMethodProto";
                };

                return ContactMethodProto;
            })();

            proto.VerifiedContactMethodProto = (function() {

                /**
                 * Properties of a VerifiedContactMethodProto.
                 * @memberof space.kenko.proto
                 * @interface IVerifiedContactMethodProto
                 * @property {space.kenko.proto.IContactMethodProto|null} [contactMethod] VerifiedContactMethodProto contactMethod
                 * @property {number|Long|null} [verificationTimeMs] VerifiedContactMethodProto verificationTimeMs
                 */

                /**
                 * Constructs a new VerifiedContactMethodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VerifiedContactMethodProto.
                 * @implements IVerifiedContactMethodProto
                 * @constructor
                 * @param {space.kenko.proto.IVerifiedContactMethodProto=} [properties] Properties to set
                 */
                function VerifiedContactMethodProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VerifiedContactMethodProto contactMethod.
                 * @member {space.kenko.proto.IContactMethodProto|null|undefined} contactMethod
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 */
                VerifiedContactMethodProto.prototype.contactMethod = null;

                /**
                 * VerifiedContactMethodProto verificationTimeMs.
                 * @member {number|Long} verificationTimeMs
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 */
                VerifiedContactMethodProto.prototype.verificationTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new VerifiedContactMethodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto instance
                 */
                VerifiedContactMethodProto.create = function create(properties) {
                    return new VerifiedContactMethodProto(properties);
                };

                /**
                 * Encodes the specified VerifiedContactMethodProto message. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto} message VerifiedContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.contactMethod != null && Object.hasOwnProperty.call(message, "contactMethod"))
                        $root.space.kenko.proto.ContactMethodProto.encode(message.contactMethod, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.verificationTimeMs != null && Object.hasOwnProperty.call(message, "verificationTimeMs"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.verificationTimeMs);
                    return writer;
                };

                /**
                 * Encodes the specified VerifiedContactMethodProto message, length delimited. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodProto} message VerifiedContactMethodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VerifiedContactMethodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VerifiedContactMethodProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.contactMethod = $root.space.kenko.proto.ContactMethodProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.verificationTimeMs = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VerifiedContactMethodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VerifiedContactMethodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VerifiedContactMethodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.contactMethod != null && message.hasOwnProperty("contactMethod")) {
                        let error = $root.space.kenko.proto.ContactMethodProto.verify(message.contactMethod);
                        if (error)
                            return "contactMethod." + error;
                    }
                    if (message.verificationTimeMs != null && message.hasOwnProperty("verificationTimeMs"))
                        if (!$util.isInteger(message.verificationTimeMs) && !(message.verificationTimeMs && $util.isInteger(message.verificationTimeMs.low) && $util.isInteger(message.verificationTimeMs.high)))
                            return "verificationTimeMs: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a VerifiedContactMethodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VerifiedContactMethodProto} VerifiedContactMethodProto
                 */
                VerifiedContactMethodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VerifiedContactMethodProto)
                        return object;
                    let message = new $root.space.kenko.proto.VerifiedContactMethodProto();
                    if (object.contactMethod != null) {
                        if (typeof object.contactMethod !== "object")
                            throw TypeError(".space.kenko.proto.VerifiedContactMethodProto.contactMethod: object expected");
                        message.contactMethod = $root.space.kenko.proto.ContactMethodProto.fromObject(object.contactMethod);
                    }
                    if (object.verificationTimeMs != null)
                        if ($util.Long)
                            (message.verificationTimeMs = $util.Long.fromValue(object.verificationTimeMs)).unsigned = false;
                        else if (typeof object.verificationTimeMs === "string")
                            message.verificationTimeMs = parseInt(object.verificationTimeMs, 10);
                        else if (typeof object.verificationTimeMs === "number")
                            message.verificationTimeMs = object.verificationTimeMs;
                        else if (typeof object.verificationTimeMs === "object")
                            message.verificationTimeMs = new $util.LongBits(object.verificationTimeMs.low >>> 0, object.verificationTimeMs.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a VerifiedContactMethodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {space.kenko.proto.VerifiedContactMethodProto} message VerifiedContactMethodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VerifiedContactMethodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.contactMethod = null;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.verificationTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.verificationTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.contactMethod != null && message.hasOwnProperty("contactMethod"))
                        object.contactMethod = $root.space.kenko.proto.ContactMethodProto.toObject(message.contactMethod, options);
                    if (message.verificationTimeMs != null && message.hasOwnProperty("verificationTimeMs"))
                        if (typeof message.verificationTimeMs === "number")
                            object.verificationTimeMs = options.longs === String ? String(message.verificationTimeMs) : message.verificationTimeMs;
                        else
                            object.verificationTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.verificationTimeMs) : options.longs === Number ? new $util.LongBits(message.verificationTimeMs.low >>> 0, message.verificationTimeMs.high >>> 0).toNumber() : message.verificationTimeMs;
                    return object;
                };

                /**
                 * Converts this VerifiedContactMethodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VerifiedContactMethodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VerifiedContactMethodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VerifiedContactMethodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VerifiedContactMethodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VerifiedContactMethodProto";
                };

                return VerifiedContactMethodProto;
            })();

            proto.VerifiedContactMethodsProto = (function() {

                /**
                 * Properties of a VerifiedContactMethodsProto.
                 * @memberof space.kenko.proto
                 * @interface IVerifiedContactMethodsProto
                 * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [contactMethods] VerifiedContactMethodsProto contactMethods
                 */

                /**
                 * Constructs a new VerifiedContactMethodsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VerifiedContactMethodsProto.
                 * @implements IVerifiedContactMethodsProto
                 * @constructor
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto=} [properties] Properties to set
                 */
                function VerifiedContactMethodsProto(properties) {
                    this.contactMethods = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VerifiedContactMethodsProto contactMethods.
                 * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} contactMethods
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @instance
                 */
                VerifiedContactMethodsProto.prototype.contactMethods = $util.emptyArray;

                /**
                 * Creates a new VerifiedContactMethodsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto instance
                 */
                VerifiedContactMethodsProto.create = function create(properties) {
                    return new VerifiedContactMethodsProto(properties);
                };

                /**
                 * Encodes the specified VerifiedContactMethodsProto message. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto} message VerifiedContactMethodsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.contactMethods != null && message.contactMethods.length)
                        for (let i = 0; i < message.contactMethods.length; ++i)
                            $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.contactMethods[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified VerifiedContactMethodsProto message, length delimited. Does not implicitly {@link space.kenko.proto.VerifiedContactMethodsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.IVerifiedContactMethodsProto} message VerifiedContactMethodsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VerifiedContactMethodsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VerifiedContactMethodsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VerifiedContactMethodsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.contactMethods && message.contactMethods.length))
                                    message.contactMethods = [];
                                message.contactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VerifiedContactMethodsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VerifiedContactMethodsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VerifiedContactMethodsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VerifiedContactMethodsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.contactMethods != null && message.hasOwnProperty("contactMethods")) {
                        if (!Array.isArray(message.contactMethods))
                            return "contactMethods: array expected";
                        for (let i = 0; i < message.contactMethods.length; ++i) {
                            let error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.contactMethods[i]);
                            if (error)
                                return "contactMethods." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a VerifiedContactMethodsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VerifiedContactMethodsProto} VerifiedContactMethodsProto
                 */
                VerifiedContactMethodsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VerifiedContactMethodsProto)
                        return object;
                    let message = new $root.space.kenko.proto.VerifiedContactMethodsProto();
                    if (object.contactMethods) {
                        if (!Array.isArray(object.contactMethods))
                            throw TypeError(".space.kenko.proto.VerifiedContactMethodsProto.contactMethods: array expected");
                        message.contactMethods = [];
                        for (let i = 0; i < object.contactMethods.length; ++i) {
                            if (typeof object.contactMethods[i] !== "object")
                                throw TypeError(".space.kenko.proto.VerifiedContactMethodsProto.contactMethods: object expected");
                            message.contactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.contactMethods[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a VerifiedContactMethodsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {space.kenko.proto.VerifiedContactMethodsProto} message VerifiedContactMethodsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VerifiedContactMethodsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.contactMethods = [];
                    if (message.contactMethods && message.contactMethods.length) {
                        object.contactMethods = [];
                        for (let j = 0; j < message.contactMethods.length; ++j)
                            object.contactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.contactMethods[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this VerifiedContactMethodsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VerifiedContactMethodsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VerifiedContactMethodsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VerifiedContactMethodsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VerifiedContactMethodsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VerifiedContactMethodsProto";
                };

                return VerifiedContactMethodsProto;
            })();

            proto.BusinessProfileProto = (function() {

                /**
                 * Properties of a BusinessProfileProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessProfileProto
                 * @property {string|null} [businessName] BusinessProfileProto businessName
                 * @property {string|null} [businessDescription] BusinessProfileProto businessDescription
                 * @property {string|null} [websiteUrl] BusinessProfileProto websiteUrl
                 * @property {string|null} [phoneNumber] BusinessProfileProto phoneNumber
                 * @property {string|null} [email] BusinessProfileProto email
                 * @property {string|null} [imageUrl] BusinessProfileProto imageUrl
                 * @property {Array.<string>|null} [servicesOffered] BusinessProfileProto servicesOffered
                 */

                /**
                 * Constructs a new BusinessProfileProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessProfileProto.
                 * @implements IBusinessProfileProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessProfileProto=} [properties] Properties to set
                 */
                function BusinessProfileProto(properties) {
                    this.servicesOffered = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessProfileProto businessName.
                 * @member {string} businessName
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.businessName = "";

                /**
                 * BusinessProfileProto businessDescription.
                 * @member {string} businessDescription
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.businessDescription = "";

                /**
                 * BusinessProfileProto websiteUrl.
                 * @member {string} websiteUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.websiteUrl = "";

                /**
                 * BusinessProfileProto phoneNumber.
                 * @member {string} phoneNumber
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.phoneNumber = "";

                /**
                 * BusinessProfileProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.email = "";

                /**
                 * BusinessProfileProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.imageUrl = "";

                /**
                 * BusinessProfileProto servicesOffered.
                 * @member {Array.<string>} servicesOffered
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 */
                BusinessProfileProto.prototype.servicesOffered = $util.emptyArray;

                /**
                 * Creates a new BusinessProfileProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto instance
                 */
                BusinessProfileProto.create = function create(properties) {
                    return new BusinessProfileProto(properties);
                };

                /**
                 * Encodes the specified BusinessProfileProto message. Does not implicitly {@link space.kenko.proto.BusinessProfileProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto} message BusinessProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessProfileProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.businessDescription != null && Object.hasOwnProperty.call(message, "businessDescription"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessDescription);
                    if (message.websiteUrl != null && Object.hasOwnProperty.call(message, "websiteUrl"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.websiteUrl);
                    if (message.phoneNumber != null && Object.hasOwnProperty.call(message, "phoneNumber"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.phoneNumber);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.email);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.imageUrl);
                    if (message.servicesOffered != null && message.servicesOffered.length)
                        for (let i = 0; i < message.servicesOffered.length; ++i)
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.servicesOffered[i]);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessProfileProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessProfileProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.IBusinessProfileProto} message BusinessProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessProfileProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessProfileProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessProfileProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 2: {
                                message.businessDescription = reader.string();
                                break;
                            }
                        case 3: {
                                message.websiteUrl = reader.string();
                                break;
                            }
                        case 4: {
                                message.phoneNumber = reader.string();
                                break;
                            }
                        case 5: {
                                message.email = reader.string();
                                break;
                            }
                        case 6: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 9: {
                                if (!(message.servicesOffered && message.servicesOffered.length))
                                    message.servicesOffered = [];
                                message.servicesOffered.push(reader.string());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessProfileProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessProfileProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessProfileProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessProfileProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        if (!$util.isString(message.businessDescription))
                            return "businessDescription: string expected";
                    if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
                        if (!$util.isString(message.websiteUrl))
                            return "websiteUrl: string expected";
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        if (!$util.isString(message.phoneNumber))
                            return "phoneNumber: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.servicesOffered != null && message.hasOwnProperty("servicesOffered")) {
                        if (!Array.isArray(message.servicesOffered))
                            return "servicesOffered: array expected";
                        for (let i = 0; i < message.servicesOffered.length; ++i)
                            if (!$util.isString(message.servicesOffered[i]))
                                return "servicesOffered: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a BusinessProfileProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessProfileProto} BusinessProfileProto
                 */
                BusinessProfileProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessProfileProto)
                        return object;
                    let message = new $root.space.kenko.proto.BusinessProfileProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.businessDescription != null)
                        message.businessDescription = String(object.businessDescription);
                    if (object.websiteUrl != null)
                        message.websiteUrl = String(object.websiteUrl);
                    if (object.phoneNumber != null)
                        message.phoneNumber = String(object.phoneNumber);
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.servicesOffered) {
                        if (!Array.isArray(object.servicesOffered))
                            throw TypeError(".space.kenko.proto.BusinessProfileProto.servicesOffered: array expected");
                        message.servicesOffered = [];
                        for (let i = 0; i < object.servicesOffered.length; ++i)
                            message.servicesOffered[i] = String(object.servicesOffered[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessProfileProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {space.kenko.proto.BusinessProfileProto} message BusinessProfileProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessProfileProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.servicesOffered = [];
                    if (options.defaults) {
                        object.businessName = "";
                        object.businessDescription = "";
                        object.websiteUrl = "";
                        object.phoneNumber = "";
                        object.email = "";
                        object.imageUrl = "";
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.businessDescription != null && message.hasOwnProperty("businessDescription"))
                        object.businessDescription = message.businessDescription;
                    if (message.websiteUrl != null && message.hasOwnProperty("websiteUrl"))
                        object.websiteUrl = message.websiteUrl;
                    if (message.phoneNumber != null && message.hasOwnProperty("phoneNumber"))
                        object.phoneNumber = message.phoneNumber;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.servicesOffered && message.servicesOffered.length) {
                        object.servicesOffered = [];
                        for (let j = 0; j < message.servicesOffered.length; ++j)
                            object.servicesOffered[j] = message.servicesOffered[j];
                    }
                    return object;
                };

                /**
                 * Converts this BusinessProfileProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessProfileProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessProfileProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessProfileProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessProfileProto";
                };

                return BusinessProfileProto;
            })();

            proto.VirtualAppointmentInfo = (function() {

                /**
                 * Properties of a VirtualAppointmentInfo.
                 * @memberof space.kenko.proto
                 * @interface IVirtualAppointmentInfo
                 * @property {boolean|null} [acceptsVirtualAppointments] VirtualAppointmentInfo acceptsVirtualAppointments
                 */

                /**
                 * Constructs a new VirtualAppointmentInfo.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a VirtualAppointmentInfo.
                 * @implements IVirtualAppointmentInfo
                 * @constructor
                 * @param {space.kenko.proto.IVirtualAppointmentInfo=} [properties] Properties to set
                 */
                function VirtualAppointmentInfo(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * VirtualAppointmentInfo acceptsVirtualAppointments.
                 * @member {boolean} acceptsVirtualAppointments
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @instance
                 */
                VirtualAppointmentInfo.prototype.acceptsVirtualAppointments = false;

                /**
                 * Creates a new VirtualAppointmentInfo instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo=} [properties] Properties to set
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo instance
                 */
                VirtualAppointmentInfo.create = function create(properties) {
                    return new VirtualAppointmentInfo(properties);
                };

                /**
                 * Encodes the specified VirtualAppointmentInfo message. Does not implicitly {@link space.kenko.proto.VirtualAppointmentInfo.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo} message VirtualAppointmentInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VirtualAppointmentInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.acceptsVirtualAppointments != null && Object.hasOwnProperty.call(message, "acceptsVirtualAppointments"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.acceptsVirtualAppointments);
                    return writer;
                };

                /**
                 * Encodes the specified VirtualAppointmentInfo message, length delimited. Does not implicitly {@link space.kenko.proto.VirtualAppointmentInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.IVirtualAppointmentInfo} message VirtualAppointmentInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                VirtualAppointmentInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a VirtualAppointmentInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VirtualAppointmentInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.VirtualAppointmentInfo();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.acceptsVirtualAppointments = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a VirtualAppointmentInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                VirtualAppointmentInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a VirtualAppointmentInfo message.
                 * @function verify
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                VirtualAppointmentInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.acceptsVirtualAppointments != null && message.hasOwnProperty("acceptsVirtualAppointments"))
                        if (typeof message.acceptsVirtualAppointments !== "boolean")
                            return "acceptsVirtualAppointments: boolean expected";
                    return null;
                };

                /**
                 * Creates a VirtualAppointmentInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.VirtualAppointmentInfo} VirtualAppointmentInfo
                 */
                VirtualAppointmentInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.VirtualAppointmentInfo)
                        return object;
                    let message = new $root.space.kenko.proto.VirtualAppointmentInfo();
                    if (object.acceptsVirtualAppointments != null)
                        message.acceptsVirtualAppointments = Boolean(object.acceptsVirtualAppointments);
                    return message;
                };

                /**
                 * Creates a plain object from a VirtualAppointmentInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {space.kenko.proto.VirtualAppointmentInfo} message VirtualAppointmentInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                VirtualAppointmentInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.acceptsVirtualAppointments = false;
                    if (message.acceptsVirtualAppointments != null && message.hasOwnProperty("acceptsVirtualAppointments"))
                        object.acceptsVirtualAppointments = message.acceptsVirtualAppointments;
                    return object;
                };

                /**
                 * Converts this VirtualAppointmentInfo to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                VirtualAppointmentInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for VirtualAppointmentInfo
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.VirtualAppointmentInfo
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                VirtualAppointmentInfo.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.VirtualAppointmentInfo";
                };

                return VirtualAppointmentInfo;
            })();

            /**
             * ProviderApprovalState enum.
             * @name space.kenko.proto.ProviderApprovalState
             * @enum {number}
             * @property {number} APPROVAL_STATE_UNKNOWN=0 APPROVAL_STATE_UNKNOWN value
             * @property {number} NEW_PROVIDER_MANUAL_APPROVE=10 NEW_PROVIDER_MANUAL_APPROVE value
             * @property {number} NEW_PROVIDER_AUTO_APPROVE=11 NEW_PROVIDER_AUTO_APPROVE value
             * @property {number} AWAITING_REVIEW=20 AWAITING_REVIEW value
             * @property {number} PROVIDER_APPROVED=30 PROVIDER_APPROVED value
             * @property {number} PROVIDER_REJECTED=40 PROVIDER_REJECTED value
             */
            proto.ProviderApprovalState = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "APPROVAL_STATE_UNKNOWN"] = 0;
                values[valuesById[10] = "NEW_PROVIDER_MANUAL_APPROVE"] = 10;
                values[valuesById[11] = "NEW_PROVIDER_AUTO_APPROVE"] = 11;
                values[valuesById[20] = "AWAITING_REVIEW"] = 20;
                values[valuesById[30] = "PROVIDER_APPROVED"] = 30;
                values[valuesById[40] = "PROVIDER_REJECTED"] = 40;
                return values;
            })();

            proto.BusinessLocationProto = (function() {

                /**
                 * Properties of a BusinessLocationProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessLocationProto
                 * @property {string|null} [locationId] BusinessLocationProto locationId
                 * @property {string|null} [locationName] BusinessLocationProto locationName
                 * @property {space.kenko.proto.IPhysicalBusinessLocation|null} [physicalLocation] BusinessLocationProto physicalLocation
                 * @property {boolean|null} [archived] BusinessLocationProto archived
                 */

                /**
                 * Constructs a new BusinessLocationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessLocationProto.
                 * @implements IBusinessLocationProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessLocationProto=} [properties] Properties to set
                 */
                function BusinessLocationProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessLocationProto locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.locationId = "";

                /**
                 * BusinessLocationProto locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.locationName = "";

                /**
                 * BusinessLocationProto physicalLocation.
                 * @member {space.kenko.proto.IPhysicalBusinessLocation|null|undefined} physicalLocation
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.physicalLocation = null;

                /**
                 * BusinessLocationProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                BusinessLocationProto.prototype.archived = false;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * BusinessLocationProto LocationType.
                 * @member {"physicalLocation"|undefined} LocationType
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 */
                Object.defineProperty(BusinessLocationProto.prototype, "LocationType", {
                    get: $util.oneOfGetter($oneOfFields = ["physicalLocation"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BusinessLocationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto instance
                 */
                BusinessLocationProto.create = function create(properties) {
                    return new BusinessLocationProto(properties);
                };

                /**
                 * Encodes the specified BusinessLocationProto message. Does not implicitly {@link space.kenko.proto.BusinessLocationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto} message BusinessLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessLocationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationName);
                    if (message.physicalLocation != null && Object.hasOwnProperty.call(message, "physicalLocation"))
                        $root.space.kenko.proto.PhysicalBusinessLocation.encode(message.physicalLocation, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessLocationProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessLocationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.IBusinessLocationProto} message BusinessLocationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessLocationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessLocationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessLocationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessLocationProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 21: {
                                message.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessLocationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessLocationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessLocationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessLocationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.physicalLocation != null && message.hasOwnProperty("physicalLocation")) {
                        properties.LocationType = 1;
                        {
                            let error = $root.space.kenko.proto.PhysicalBusinessLocation.verify(message.physicalLocation);
                            if (error)
                                return "physicalLocation." + error;
                        }
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessLocationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessLocationProto} BusinessLocationProto
                 */
                BusinessLocationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessLocationProto)
                        return object;
                    let message = new $root.space.kenko.proto.BusinessLocationProto();
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.physicalLocation != null) {
                        if (typeof object.physicalLocation !== "object")
                            throw TypeError(".space.kenko.proto.BusinessLocationProto.physicalLocation: object expected");
                        message.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.fromObject(object.physicalLocation);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessLocationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {space.kenko.proto.BusinessLocationProto} message BusinessLocationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessLocationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.locationId = "";
                        object.locationName = "";
                        object.archived = false;
                    }
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.physicalLocation != null && message.hasOwnProperty("physicalLocation")) {
                        object.physicalLocation = $root.space.kenko.proto.PhysicalBusinessLocation.toObject(message.physicalLocation, options);
                        if (options.oneofs)
                            object.LocationType = "physicalLocation";
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this BusinessLocationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessLocationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessLocationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessLocationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessLocationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessLocationProto";
                };

                return BusinessLocationProto;
            })();

            proto.PhysicalBusinessLocation = (function() {

                /**
                 * Properties of a PhysicalBusinessLocation.
                 * @memberof space.kenko.proto
                 * @interface IPhysicalBusinessLocation
                 * @property {string|null} [address] PhysicalBusinessLocation address
                 * @property {number|null} [lat] PhysicalBusinessLocation lat
                 * @property {number|null} [lng] PhysicalBusinessLocation lng
                 * @property {string|null} [timeZone] PhysicalBusinessLocation timeZone
                 * @property {boolean|null} ["private"] PhysicalBusinessLocation private
                 * @property {string|null} [imageUrl] PhysicalBusinessLocation imageUrl
                 * @property {string|null} [phone] PhysicalBusinessLocation phone
                 * @property {string|null} [email] PhysicalBusinessLocation email
                 */

                /**
                 * Constructs a new PhysicalBusinessLocation.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PhysicalBusinessLocation.
                 * @implements IPhysicalBusinessLocation
                 * @constructor
                 * @param {space.kenko.proto.IPhysicalBusinessLocation=} [properties] Properties to set
                 */
                function PhysicalBusinessLocation(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PhysicalBusinessLocation address.
                 * @member {string} address
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.address = "";

                /**
                 * PhysicalBusinessLocation lat.
                 * @member {number} lat
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.lat = 0;

                /**
                 * PhysicalBusinessLocation lng.
                 * @member {number} lng
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.lng = 0;

                /**
                 * PhysicalBusinessLocation timeZone.
                 * @member {string} timeZone
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.timeZone = "";

                /**
                 * PhysicalBusinessLocation private.
                 * @member {boolean} private
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype["private"] = false;

                /**
                 * PhysicalBusinessLocation imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.imageUrl = "";

                /**
                 * PhysicalBusinessLocation phone.
                 * @member {string} phone
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.phone = "";

                /**
                 * PhysicalBusinessLocation email.
                 * @member {string} email
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 */
                PhysicalBusinessLocation.prototype.email = "";

                /**
                 * Creates a new PhysicalBusinessLocation instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation=} [properties] Properties to set
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation instance
                 */
                PhysicalBusinessLocation.create = function create(properties) {
                    return new PhysicalBusinessLocation(properties);
                };

                /**
                 * Encodes the specified PhysicalBusinessLocation message. Does not implicitly {@link space.kenko.proto.PhysicalBusinessLocation.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation} message PhysicalBusinessLocation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhysicalBusinessLocation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.address);
                    if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.lat);
                    if (message.lng != null && Object.hasOwnProperty.call(message, "lng"))
                        writer.uint32(/* id 5, wireType 1 =*/41).double(message.lng);
                    if (message.timeZone != null && Object.hasOwnProperty.call(message, "timeZone"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.timeZone);
                    if (message["private"] != null && Object.hasOwnProperty.call(message, "private"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message["private"]);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.imageUrl);
                    if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.phone);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified PhysicalBusinessLocation message, length delimited. Does not implicitly {@link space.kenko.proto.PhysicalBusinessLocation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.IPhysicalBusinessLocation} message PhysicalBusinessLocation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PhysicalBusinessLocation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PhysicalBusinessLocation message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhysicalBusinessLocation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PhysicalBusinessLocation();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.address = reader.string();
                                break;
                            }
                        case 4: {
                                message.lat = reader.double();
                                break;
                            }
                        case 5: {
                                message.lng = reader.double();
                                break;
                            }
                        case 6: {
                                message.timeZone = reader.string();
                                break;
                            }
                        case 7: {
                                message["private"] = reader.bool();
                                break;
                            }
                        case 8: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 9: {
                                message.phone = reader.string();
                                break;
                            }
                        case 10: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PhysicalBusinessLocation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PhysicalBusinessLocation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PhysicalBusinessLocation message.
                 * @function verify
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PhysicalBusinessLocation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        if (typeof message.lat !== "number")
                            return "lat: number expected";
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        if (typeof message.lng !== "number")
                            return "lng: number expected";
                    if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                        if (!$util.isString(message.timeZone))
                            return "timeZone: string expected";
                    if (message["private"] != null && message.hasOwnProperty("private"))
                        if (typeof message["private"] !== "boolean")
                            return "private: boolean expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        if (!$util.isString(message.phone))
                            return "phone: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a PhysicalBusinessLocation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PhysicalBusinessLocation} PhysicalBusinessLocation
                 */
                PhysicalBusinessLocation.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PhysicalBusinessLocation)
                        return object;
                    let message = new $root.space.kenko.proto.PhysicalBusinessLocation();
                    if (object.address != null)
                        message.address = String(object.address);
                    if (object.lat != null)
                        message.lat = Number(object.lat);
                    if (object.lng != null)
                        message.lng = Number(object.lng);
                    if (object.timeZone != null)
                        message.timeZone = String(object.timeZone);
                    if (object["private"] != null)
                        message["private"] = Boolean(object["private"]);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.phone != null)
                        message.phone = String(object.phone);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a PhysicalBusinessLocation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {space.kenko.proto.PhysicalBusinessLocation} message PhysicalBusinessLocation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PhysicalBusinessLocation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.address = "";
                        object.lat = 0;
                        object.lng = 0;
                        object.timeZone = "";
                        object["private"] = false;
                        object.imageUrl = "";
                        object.phone = "";
                        object.email = "";
                    }
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        object.lng = options.json && !isFinite(message.lng) ? String(message.lng) : message.lng;
                    if (message.timeZone != null && message.hasOwnProperty("timeZone"))
                        object.timeZone = message.timeZone;
                    if (message["private"] != null && message.hasOwnProperty("private"))
                        object["private"] = message["private"];
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        object.phone = message.phone;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this PhysicalBusinessLocation to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PhysicalBusinessLocation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PhysicalBusinessLocation
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PhysicalBusinessLocation
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PhysicalBusinessLocation.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PhysicalBusinessLocation";
                };

                return PhysicalBusinessLocation;
            })();

            proto.ProviderProfileProto = (function() {

                /**
                 * Properties of a ProviderProfileProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderProfileProto
                 * @property {string|null} [firstName] ProviderProfileProto firstName
                 * @property {string|null} [lastName] ProviderProfileProto lastName
                 * @property {string|null} [countryCode] ProviderProfileProto countryCode
                 * @property {boolean|null} [agreedToTerms] ProviderProfileProto agreedToTerms
                 * @property {string|null} [phone] ProviderProfileProto phone
                 * @property {string|null} [email] ProviderProfileProto email
                 */

                /**
                 * Constructs a new ProviderProfileProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderProfileProto.
                 * @implements IProviderProfileProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderProfileProto=} [properties] Properties to set
                 */
                function ProviderProfileProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderProfileProto firstName.
                 * @member {string} firstName
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.firstName = "";

                /**
                 * ProviderProfileProto lastName.
                 * @member {string} lastName
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.lastName = "";

                /**
                 * ProviderProfileProto countryCode.
                 * @member {string} countryCode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.countryCode = "";

                /**
                 * ProviderProfileProto agreedToTerms.
                 * @member {boolean} agreedToTerms
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.agreedToTerms = false;

                /**
                 * ProviderProfileProto phone.
                 * @member {string} phone
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.phone = "";

                /**
                 * ProviderProfileProto email.
                 * @member {string} email
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 */
                ProviderProfileProto.prototype.email = "";

                /**
                 * Creates a new ProviderProfileProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto instance
                 */
                ProviderProfileProto.create = function create(properties) {
                    return new ProviderProfileProto(properties);
                };

                /**
                 * Encodes the specified ProviderProfileProto message. Does not implicitly {@link space.kenko.proto.ProviderProfileProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto} message ProviderProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderProfileProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.firstName);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastName);
                    if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.countryCode);
                    if (message.agreedToTerms != null && Object.hasOwnProperty.call(message, "agreedToTerms"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.agreedToTerms);
                    if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.phone);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.email);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderProfileProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderProfileProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.IProviderProfileProto} message ProviderProfileProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderProfileProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderProfileProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderProfileProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.firstName = reader.string();
                                break;
                            }
                        case 2: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 5: {
                                message.countryCode = reader.string();
                                break;
                            }
                        case 6: {
                                message.agreedToTerms = reader.bool();
                                break;
                            }
                        case 7: {
                                message.phone = reader.string();
                                break;
                            }
                        case 8: {
                                message.email = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderProfileProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderProfileProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderProfileProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderProfileProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        if (!$util.isString(message.firstName))
                            return "firstName: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                        if (!$util.isString(message.countryCode))
                            return "countryCode: string expected";
                    if (message.agreedToTerms != null && message.hasOwnProperty("agreedToTerms"))
                        if (typeof message.agreedToTerms !== "boolean")
                            return "agreedToTerms: boolean expected";
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        if (!$util.isString(message.phone))
                            return "phone: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    return null;
                };

                /**
                 * Creates a ProviderProfileProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderProfileProto} ProviderProfileProto
                 */
                ProviderProfileProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderProfileProto)
                        return object;
                    let message = new $root.space.kenko.proto.ProviderProfileProto();
                    if (object.firstName != null)
                        message.firstName = String(object.firstName);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.countryCode != null)
                        message.countryCode = String(object.countryCode);
                    if (object.agreedToTerms != null)
                        message.agreedToTerms = Boolean(object.agreedToTerms);
                    if (object.phone != null)
                        message.phone = String(object.phone);
                    if (object.email != null)
                        message.email = String(object.email);
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderProfileProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {space.kenko.proto.ProviderProfileProto} message ProviderProfileProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderProfileProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.firstName = "";
                        object.lastName = "";
                        object.countryCode = "";
                        object.agreedToTerms = false;
                        object.phone = "";
                        object.email = "";
                    }
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        object.firstName = message.firstName;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                        object.countryCode = message.countryCode;
                    if (message.agreedToTerms != null && message.hasOwnProperty("agreedToTerms"))
                        object.agreedToTerms = message.agreedToTerms;
                    if (message.phone != null && message.hasOwnProperty("phone"))
                        object.phone = message.phone;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    return object;
                };

                /**
                 * Converts this ProviderProfileProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderProfileProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderProfileProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderProfileProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderProfileProto";
                };

                return ProviderProfileProto;
            })();

            proto.AddressProto = (function() {

                /**
                 * Properties of an AddressProto.
                 * @memberof space.kenko.proto
                 * @interface IAddressProto
                 * @property {string|null} [formattedAddress] AddressProto formattedAddress
                 * @property {number|null} [lat] AddressProto lat
                 * @property {number|null} [lng] AddressProto lng
                 */

                /**
                 * Constructs a new AddressProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an AddressProto.
                 * @implements IAddressProto
                 * @constructor
                 * @param {space.kenko.proto.IAddressProto=} [properties] Properties to set
                 */
                function AddressProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AddressProto formattedAddress.
                 * @member {string} formattedAddress
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.formattedAddress = "";

                /**
                 * AddressProto lat.
                 * @member {number} lat
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.lat = 0;

                /**
                 * AddressProto lng.
                 * @member {number} lng
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 */
                AddressProto.prototype.lng = 0;

                /**
                 * Creates a new AddressProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.AddressProto} AddressProto instance
                 */
                AddressProto.create = function create(properties) {
                    return new AddressProto(properties);
                };

                /**
                 * Encodes the specified AddressProto message. Does not implicitly {@link space.kenko.proto.AddressProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto} message AddressProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.formattedAddress != null && Object.hasOwnProperty.call(message, "formattedAddress"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.formattedAddress);
                    if (message.lat != null && Object.hasOwnProperty.call(message, "lat"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.lat);
                    if (message.lng != null && Object.hasOwnProperty.call(message, "lng"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.lng);
                    return writer;
                };

                /**
                 * Encodes the specified AddressProto message, length delimited. Does not implicitly {@link space.kenko.proto.AddressProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.IAddressProto} message AddressProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AddressProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AddressProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.AddressProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.formattedAddress = reader.string();
                                break;
                            }
                        case 2: {
                                message.lat = reader.double();
                                break;
                            }
                        case 3: {
                                message.lng = reader.double();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AddressProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AddressProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AddressProto message.
                 * @function verify
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AddressProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                        if (!$util.isString(message.formattedAddress))
                            return "formattedAddress: string expected";
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        if (typeof message.lat !== "number")
                            return "lat: number expected";
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        if (typeof message.lng !== "number")
                            return "lng: number expected";
                    return null;
                };

                /**
                 * Creates an AddressProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.AddressProto} AddressProto
                 */
                AddressProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.AddressProto)
                        return object;
                    let message = new $root.space.kenko.proto.AddressProto();
                    if (object.formattedAddress != null)
                        message.formattedAddress = String(object.formattedAddress);
                    if (object.lat != null)
                        message.lat = Number(object.lat);
                    if (object.lng != null)
                        message.lng = Number(object.lng);
                    return message;
                };

                /**
                 * Creates a plain object from an AddressProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {space.kenko.proto.AddressProto} message AddressProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AddressProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.formattedAddress = "";
                        object.lat = 0;
                        object.lng = 0;
                    }
                    if (message.formattedAddress != null && message.hasOwnProperty("formattedAddress"))
                        object.formattedAddress = message.formattedAddress;
                    if (message.lat != null && message.hasOwnProperty("lat"))
                        object.lat = options.json && !isFinite(message.lat) ? String(message.lat) : message.lat;
                    if (message.lng != null && message.hasOwnProperty("lng"))
                        object.lng = options.json && !isFinite(message.lng) ? String(message.lng) : message.lng;
                    return object;
                };

                /**
                 * Converts this AddressProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.AddressProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AddressProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AddressProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.AddressProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AddressProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.AddressProto";
                };

                return AddressProto;
            })();

            proto.PractitionerProto = (function() {

                /**
                 * Properties of a PractitionerProto.
                 * @memberof space.kenko.proto
                 * @interface IPractitionerProto
                 * @property {string|null} [practitionerId] PractitionerProto practitionerId
                 * @property {string|null} [firstName] PractitionerProto firstName
                 * @property {string|null} [lastName] PractitionerProto lastName
                 * @property {string|null} [bio] PractitionerProto bio
                 * @property {string|null} [imageUrl] PractitionerProto imageUrl
                 * @property {string|null} [jobTitle] PractitionerProto jobTitle
                 * @property {Array.<space.kenko.proto.IEducationProto>|null} [education] PractitionerProto education
                 * @property {Array.<space.kenko.proto.ILicenseOrCredentialsProto>|null} [credentials] PractitionerProto credentials
                 * @property {Array.<string>|null} [languages] PractitionerProto languages
                 * @property {string|null} [calendarExportKey] PractitionerProto calendarExportKey
                 * @property {string|null} [virtualMeetingLink] PractitionerProto virtualMeetingLink
                 * @property {boolean|null} [archived] PractitionerProto archived
                 */

                /**
                 * Constructs a new PractitionerProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PractitionerProto.
                 * @implements IPractitionerProto
                 * @constructor
                 * @param {space.kenko.proto.IPractitionerProto=} [properties] Properties to set
                 */
                function PractitionerProto(properties) {
                    this.education = [];
                    this.credentials = [];
                    this.languages = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PractitionerProto practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.practitionerId = "";

                /**
                 * PractitionerProto firstName.
                 * @member {string} firstName
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.firstName = "";

                /**
                 * PractitionerProto lastName.
                 * @member {string} lastName
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.lastName = "";

                /**
                 * PractitionerProto bio.
                 * @member {string} bio
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.bio = "";

                /**
                 * PractitionerProto imageUrl.
                 * @member {string} imageUrl
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.imageUrl = "";

                /**
                 * PractitionerProto jobTitle.
                 * @member {string} jobTitle
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.jobTitle = "";

                /**
                 * PractitionerProto education.
                 * @member {Array.<space.kenko.proto.IEducationProto>} education
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.education = $util.emptyArray;

                /**
                 * PractitionerProto credentials.
                 * @member {Array.<space.kenko.proto.ILicenseOrCredentialsProto>} credentials
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.credentials = $util.emptyArray;

                /**
                 * PractitionerProto languages.
                 * @member {Array.<string>} languages
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.languages = $util.emptyArray;

                /**
                 * PractitionerProto calendarExportKey.
                 * @member {string} calendarExportKey
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.calendarExportKey = "";

                /**
                 * PractitionerProto virtualMeetingLink.
                 * @member {string} virtualMeetingLink
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.virtualMeetingLink = "";

                /**
                 * PractitionerProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 */
                PractitionerProto.prototype.archived = false;

                /**
                 * Creates a new PractitionerProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto instance
                 */
                PractitionerProto.create = function create(properties) {
                    return new PractitionerProto(properties);
                };

                /**
                 * Encodes the specified PractitionerProto message. Does not implicitly {@link space.kenko.proto.PractitionerProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto} message PractitionerProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PractitionerProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.firstName);
                    if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.lastName);
                    if (message.bio != null && Object.hasOwnProperty.call(message, "bio"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.bio);
                    if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.imageUrl);
                    if (message.jobTitle != null && Object.hasOwnProperty.call(message, "jobTitle"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.jobTitle);
                    if (message.education != null && message.education.length)
                        for (let i = 0; i < message.education.length; ++i)
                            $root.space.kenko.proto.EducationProto.encode(message.education[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.credentials != null && message.credentials.length)
                        for (let i = 0; i < message.credentials.length; ++i)
                            $root.space.kenko.proto.LicenseOrCredentialsProto.encode(message.credentials[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.languages != null && message.languages.length)
                        for (let i = 0; i < message.languages.length; ++i)
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.languages[i]);
                    if (message.calendarExportKey != null && Object.hasOwnProperty.call(message, "calendarExportKey"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.calendarExportKey);
                    if (message.virtualMeetingLink != null && Object.hasOwnProperty.call(message, "virtualMeetingLink"))
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.virtualMeetingLink);
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified PractitionerProto message, length delimited. Does not implicitly {@link space.kenko.proto.PractitionerProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.IPractitionerProto} message PractitionerProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PractitionerProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PractitionerProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PractitionerProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PractitionerProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.firstName = reader.string();
                                break;
                            }
                        case 3: {
                                message.lastName = reader.string();
                                break;
                            }
                        case 4: {
                                message.bio = reader.string();
                                break;
                            }
                        case 5: {
                                message.imageUrl = reader.string();
                                break;
                            }
                        case 10: {
                                message.jobTitle = reader.string();
                                break;
                            }
                        case 11: {
                                if (!(message.education && message.education.length))
                                    message.education = [];
                                message.education.push($root.space.kenko.proto.EducationProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 12: {
                                if (!(message.credentials && message.credentials.length))
                                    message.credentials = [];
                                message.credentials.push($root.space.kenko.proto.LicenseOrCredentialsProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 13: {
                                if (!(message.languages && message.languages.length))
                                    message.languages = [];
                                message.languages.push(reader.string());
                                break;
                            }
                        case 14: {
                                message.calendarExportKey = reader.string();
                                break;
                            }
                        case 15: {
                                message.virtualMeetingLink = reader.string();
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PractitionerProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PractitionerProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PractitionerProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PractitionerProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        if (!$util.isString(message.firstName))
                            return "firstName: string expected";
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        if (!$util.isString(message.lastName))
                            return "lastName: string expected";
                    if (message.bio != null && message.hasOwnProperty("bio"))
                        if (!$util.isString(message.bio))
                            return "bio: string expected";
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        if (!$util.isString(message.imageUrl))
                            return "imageUrl: string expected";
                    if (message.jobTitle != null && message.hasOwnProperty("jobTitle"))
                        if (!$util.isString(message.jobTitle))
                            return "jobTitle: string expected";
                    if (message.education != null && message.hasOwnProperty("education")) {
                        if (!Array.isArray(message.education))
                            return "education: array expected";
                        for (let i = 0; i < message.education.length; ++i) {
                            let error = $root.space.kenko.proto.EducationProto.verify(message.education[i]);
                            if (error)
                                return "education." + error;
                        }
                    }
                    if (message.credentials != null && message.hasOwnProperty("credentials")) {
                        if (!Array.isArray(message.credentials))
                            return "credentials: array expected";
                        for (let i = 0; i < message.credentials.length; ++i) {
                            let error = $root.space.kenko.proto.LicenseOrCredentialsProto.verify(message.credentials[i]);
                            if (error)
                                return "credentials." + error;
                        }
                    }
                    if (message.languages != null && message.hasOwnProperty("languages")) {
                        if (!Array.isArray(message.languages))
                            return "languages: array expected";
                        for (let i = 0; i < message.languages.length; ++i)
                            if (!$util.isString(message.languages[i]))
                                return "languages: string[] expected";
                    }
                    if (message.calendarExportKey != null && message.hasOwnProperty("calendarExportKey"))
                        if (!$util.isString(message.calendarExportKey))
                            return "calendarExportKey: string expected";
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        if (!$util.isString(message.virtualMeetingLink))
                            return "virtualMeetingLink: string expected";
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a PractitionerProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PractitionerProto} PractitionerProto
                 */
                PractitionerProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PractitionerProto)
                        return object;
                    let message = new $root.space.kenko.proto.PractitionerProto();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.firstName != null)
                        message.firstName = String(object.firstName);
                    if (object.lastName != null)
                        message.lastName = String(object.lastName);
                    if (object.bio != null)
                        message.bio = String(object.bio);
                    if (object.imageUrl != null)
                        message.imageUrl = String(object.imageUrl);
                    if (object.jobTitle != null)
                        message.jobTitle = String(object.jobTitle);
                    if (object.education) {
                        if (!Array.isArray(object.education))
                            throw TypeError(".space.kenko.proto.PractitionerProto.education: array expected");
                        message.education = [];
                        for (let i = 0; i < object.education.length; ++i) {
                            if (typeof object.education[i] !== "object")
                                throw TypeError(".space.kenko.proto.PractitionerProto.education: object expected");
                            message.education[i] = $root.space.kenko.proto.EducationProto.fromObject(object.education[i]);
                        }
                    }
                    if (object.credentials) {
                        if (!Array.isArray(object.credentials))
                            throw TypeError(".space.kenko.proto.PractitionerProto.credentials: array expected");
                        message.credentials = [];
                        for (let i = 0; i < object.credentials.length; ++i) {
                            if (typeof object.credentials[i] !== "object")
                                throw TypeError(".space.kenko.proto.PractitionerProto.credentials: object expected");
                            message.credentials[i] = $root.space.kenko.proto.LicenseOrCredentialsProto.fromObject(object.credentials[i]);
                        }
                    }
                    if (object.languages) {
                        if (!Array.isArray(object.languages))
                            throw TypeError(".space.kenko.proto.PractitionerProto.languages: array expected");
                        message.languages = [];
                        for (let i = 0; i < object.languages.length; ++i)
                            message.languages[i] = String(object.languages[i]);
                    }
                    if (object.calendarExportKey != null)
                        message.calendarExportKey = String(object.calendarExportKey);
                    if (object.virtualMeetingLink != null)
                        message.virtualMeetingLink = String(object.virtualMeetingLink);
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a PractitionerProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {space.kenko.proto.PractitionerProto} message PractitionerProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PractitionerProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.education = [];
                        object.credentials = [];
                        object.languages = [];
                    }
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.firstName = "";
                        object.lastName = "";
                        object.bio = "";
                        object.imageUrl = "";
                        object.jobTitle = "";
                        object.calendarExportKey = "";
                        object.virtualMeetingLink = "";
                        object.archived = false;
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.firstName != null && message.hasOwnProperty("firstName"))
                        object.firstName = message.firstName;
                    if (message.lastName != null && message.hasOwnProperty("lastName"))
                        object.lastName = message.lastName;
                    if (message.bio != null && message.hasOwnProperty("bio"))
                        object.bio = message.bio;
                    if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                        object.imageUrl = message.imageUrl;
                    if (message.jobTitle != null && message.hasOwnProperty("jobTitle"))
                        object.jobTitle = message.jobTitle;
                    if (message.education && message.education.length) {
                        object.education = [];
                        for (let j = 0; j < message.education.length; ++j)
                            object.education[j] = $root.space.kenko.proto.EducationProto.toObject(message.education[j], options);
                    }
                    if (message.credentials && message.credentials.length) {
                        object.credentials = [];
                        for (let j = 0; j < message.credentials.length; ++j)
                            object.credentials[j] = $root.space.kenko.proto.LicenseOrCredentialsProto.toObject(message.credentials[j], options);
                    }
                    if (message.languages && message.languages.length) {
                        object.languages = [];
                        for (let j = 0; j < message.languages.length; ++j)
                            object.languages[j] = message.languages[j];
                    }
                    if (message.calendarExportKey != null && message.hasOwnProperty("calendarExportKey"))
                        object.calendarExportKey = message.calendarExportKey;
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        object.virtualMeetingLink = message.virtualMeetingLink;
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this PractitionerProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PractitionerProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PractitionerProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PractitionerProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PractitionerProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PractitionerProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PractitionerProto";
                };

                return PractitionerProto;
            })();

            proto.SpecialtyProto = (function() {

                /**
                 * Properties of a SpecialtyProto.
                 * @memberof space.kenko.proto
                 * @interface ISpecialtyProto
                 * @property {string|null} [specialty] SpecialtyProto specialty
                 * @property {number|null} [yearsExperience] SpecialtyProto yearsExperience
                 */

                /**
                 * Constructs a new SpecialtyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SpecialtyProto.
                 * @implements ISpecialtyProto
                 * @constructor
                 * @param {space.kenko.proto.ISpecialtyProto=} [properties] Properties to set
                 */
                function SpecialtyProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SpecialtyProto specialty.
                 * @member {string} specialty
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 */
                SpecialtyProto.prototype.specialty = "";

                /**
                 * SpecialtyProto yearsExperience.
                 * @member {number} yearsExperience
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 */
                SpecialtyProto.prototype.yearsExperience = 0;

                /**
                 * Creates a new SpecialtyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto instance
                 */
                SpecialtyProto.create = function create(properties) {
                    return new SpecialtyProto(properties);
                };

                /**
                 * Encodes the specified SpecialtyProto message. Does not implicitly {@link space.kenko.proto.SpecialtyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto} message SpecialtyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialtyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.specialty != null && Object.hasOwnProperty.call(message, "specialty"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.specialty);
                    if (message.yearsExperience != null && Object.hasOwnProperty.call(message, "yearsExperience"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.yearsExperience);
                    return writer;
                };

                /**
                 * Encodes the specified SpecialtyProto message, length delimited. Does not implicitly {@link space.kenko.proto.SpecialtyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.ISpecialtyProto} message SpecialtyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SpecialtyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SpecialtyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialtyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SpecialtyProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.specialty = reader.string();
                                break;
                            }
                        case 2: {
                                message.yearsExperience = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SpecialtyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SpecialtyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SpecialtyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SpecialtyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.specialty != null && message.hasOwnProperty("specialty"))
                        if (!$util.isString(message.specialty))
                            return "specialty: string expected";
                    if (message.yearsExperience != null && message.hasOwnProperty("yearsExperience"))
                        if (!$util.isInteger(message.yearsExperience))
                            return "yearsExperience: integer expected";
                    return null;
                };

                /**
                 * Creates a SpecialtyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SpecialtyProto} SpecialtyProto
                 */
                SpecialtyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SpecialtyProto)
                        return object;
                    let message = new $root.space.kenko.proto.SpecialtyProto();
                    if (object.specialty != null)
                        message.specialty = String(object.specialty);
                    if (object.yearsExperience != null)
                        message.yearsExperience = object.yearsExperience | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SpecialtyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {space.kenko.proto.SpecialtyProto} message SpecialtyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SpecialtyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.specialty = "";
                        object.yearsExperience = 0;
                    }
                    if (message.specialty != null && message.hasOwnProperty("specialty"))
                        object.specialty = message.specialty;
                    if (message.yearsExperience != null && message.hasOwnProperty("yearsExperience"))
                        object.yearsExperience = message.yearsExperience;
                    return object;
                };

                /**
                 * Converts this SpecialtyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SpecialtyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SpecialtyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SpecialtyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SpecialtyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SpecialtyProto";
                };

                return SpecialtyProto;
            })();

            proto.EducationProto = (function() {

                /**
                 * Properties of an EducationProto.
                 * @memberof space.kenko.proto
                 * @interface IEducationProto
                 * @property {string|null} [school] EducationProto school
                 * @property {string|null} [degree] EducationProto degree
                 * @property {number|null} [yearCompleted] EducationProto yearCompleted
                 */

                /**
                 * Constructs a new EducationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an EducationProto.
                 * @implements IEducationProto
                 * @constructor
                 * @param {space.kenko.proto.IEducationProto=} [properties] Properties to set
                 */
                function EducationProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EducationProto school.
                 * @member {string} school
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.school = "";

                /**
                 * EducationProto degree.
                 * @member {string} degree
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.degree = "";

                /**
                 * EducationProto yearCompleted.
                 * @member {number} yearCompleted
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 */
                EducationProto.prototype.yearCompleted = 0;

                /**
                 * Creates a new EducationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.EducationProto} EducationProto instance
                 */
                EducationProto.create = function create(properties) {
                    return new EducationProto(properties);
                };

                /**
                 * Encodes the specified EducationProto message. Does not implicitly {@link space.kenko.proto.EducationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto} message EducationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EducationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.school != null && Object.hasOwnProperty.call(message, "school"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.school);
                    if (message.degree != null && Object.hasOwnProperty.call(message, "degree"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.degree);
                    if (message.yearCompleted != null && Object.hasOwnProperty.call(message, "yearCompleted"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.yearCompleted);
                    return writer;
                };

                /**
                 * Encodes the specified EducationProto message, length delimited. Does not implicitly {@link space.kenko.proto.EducationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.IEducationProto} message EducationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EducationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EducationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EducationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.EducationProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.school = reader.string();
                                break;
                            }
                        case 2: {
                                message.degree = reader.string();
                                break;
                            }
                        case 3: {
                                message.yearCompleted = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EducationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EducationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EducationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EducationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.school != null && message.hasOwnProperty("school"))
                        if (!$util.isString(message.school))
                            return "school: string expected";
                    if (message.degree != null && message.hasOwnProperty("degree"))
                        if (!$util.isString(message.degree))
                            return "degree: string expected";
                    if (message.yearCompleted != null && message.hasOwnProperty("yearCompleted"))
                        if (!$util.isInteger(message.yearCompleted))
                            return "yearCompleted: integer expected";
                    return null;
                };

                /**
                 * Creates an EducationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.EducationProto} EducationProto
                 */
                EducationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.EducationProto)
                        return object;
                    let message = new $root.space.kenko.proto.EducationProto();
                    if (object.school != null)
                        message.school = String(object.school);
                    if (object.degree != null)
                        message.degree = String(object.degree);
                    if (object.yearCompleted != null)
                        message.yearCompleted = object.yearCompleted | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an EducationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {space.kenko.proto.EducationProto} message EducationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EducationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.school = "";
                        object.degree = "";
                        object.yearCompleted = 0;
                    }
                    if (message.school != null && message.hasOwnProperty("school"))
                        object.school = message.school;
                    if (message.degree != null && message.hasOwnProperty("degree"))
                        object.degree = message.degree;
                    if (message.yearCompleted != null && message.hasOwnProperty("yearCompleted"))
                        object.yearCompleted = message.yearCompleted;
                    return object;
                };

                /**
                 * Converts this EducationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.EducationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EducationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for EducationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.EducationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                EducationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.EducationProto";
                };

                return EducationProto;
            })();

            proto.LicenseOrCredentialsProto = (function() {

                /**
                 * Properties of a LicenseOrCredentialsProto.
                 * @memberof space.kenko.proto
                 * @interface ILicenseOrCredentialsProto
                 * @property {string|null} [licenseOrCredential] LicenseOrCredentialsProto licenseOrCredential
                 * @property {string|null} [supportDocumentationUrl] LicenseOrCredentialsProto supportDocumentationUrl
                 */

                /**
                 * Constructs a new LicenseOrCredentialsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a LicenseOrCredentialsProto.
                 * @implements ILicenseOrCredentialsProto
                 * @constructor
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto=} [properties] Properties to set
                 */
                function LicenseOrCredentialsProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LicenseOrCredentialsProto licenseOrCredential.
                 * @member {string} licenseOrCredential
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 */
                LicenseOrCredentialsProto.prototype.licenseOrCredential = "";

                /**
                 * LicenseOrCredentialsProto supportDocumentationUrl.
                 * @member {string} supportDocumentationUrl
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 */
                LicenseOrCredentialsProto.prototype.supportDocumentationUrl = "";

                /**
                 * Creates a new LicenseOrCredentialsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto instance
                 */
                LicenseOrCredentialsProto.create = function create(properties) {
                    return new LicenseOrCredentialsProto(properties);
                };

                /**
                 * Encodes the specified LicenseOrCredentialsProto message. Does not implicitly {@link space.kenko.proto.LicenseOrCredentialsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto} message LicenseOrCredentialsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LicenseOrCredentialsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.licenseOrCredential != null && Object.hasOwnProperty.call(message, "licenseOrCredential"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.licenseOrCredential);
                    if (message.supportDocumentationUrl != null && Object.hasOwnProperty.call(message, "supportDocumentationUrl"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.supportDocumentationUrl);
                    return writer;
                };

                /**
                 * Encodes the specified LicenseOrCredentialsProto message, length delimited. Does not implicitly {@link space.kenko.proto.LicenseOrCredentialsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.ILicenseOrCredentialsProto} message LicenseOrCredentialsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LicenseOrCredentialsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LicenseOrCredentialsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LicenseOrCredentialsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.LicenseOrCredentialsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.licenseOrCredential = reader.string();
                                break;
                            }
                        case 2: {
                                message.supportDocumentationUrl = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LicenseOrCredentialsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LicenseOrCredentialsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LicenseOrCredentialsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LicenseOrCredentialsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.licenseOrCredential != null && message.hasOwnProperty("licenseOrCredential"))
                        if (!$util.isString(message.licenseOrCredential))
                            return "licenseOrCredential: string expected";
                    if (message.supportDocumentationUrl != null && message.hasOwnProperty("supportDocumentationUrl"))
                        if (!$util.isString(message.supportDocumentationUrl))
                            return "supportDocumentationUrl: string expected";
                    return null;
                };

                /**
                 * Creates a LicenseOrCredentialsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.LicenseOrCredentialsProto} LicenseOrCredentialsProto
                 */
                LicenseOrCredentialsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.LicenseOrCredentialsProto)
                        return object;
                    let message = new $root.space.kenko.proto.LicenseOrCredentialsProto();
                    if (object.licenseOrCredential != null)
                        message.licenseOrCredential = String(object.licenseOrCredential);
                    if (object.supportDocumentationUrl != null)
                        message.supportDocumentationUrl = String(object.supportDocumentationUrl);
                    return message;
                };

                /**
                 * Creates a plain object from a LicenseOrCredentialsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {space.kenko.proto.LicenseOrCredentialsProto} message LicenseOrCredentialsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LicenseOrCredentialsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.licenseOrCredential = "";
                        object.supportDocumentationUrl = "";
                    }
                    if (message.licenseOrCredential != null && message.hasOwnProperty("licenseOrCredential"))
                        object.licenseOrCredential = message.licenseOrCredential;
                    if (message.supportDocumentationUrl != null && message.hasOwnProperty("supportDocumentationUrl"))
                        object.supportDocumentationUrl = message.supportDocumentationUrl;
                    return object;
                };

                /**
                 * Converts this LicenseOrCredentialsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LicenseOrCredentialsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for LicenseOrCredentialsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.LicenseOrCredentialsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                LicenseOrCredentialsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.LicenseOrCredentialsProto";
                };

                return LicenseOrCredentialsProto;
            })();

            proto.PracticeDetailsProto = (function() {

                /**
                 * Properties of a PracticeDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IPracticeDetailsProto
                 * @property {Array.<space.kenko.proto.IServiceProto>|null} [services] PracticeDetailsProto services
                 */

                /**
                 * Constructs a new PracticeDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PracticeDetailsProto.
                 * @implements IPracticeDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IPracticeDetailsProto=} [properties] Properties to set
                 */
                function PracticeDetailsProto(properties) {
                    this.services = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PracticeDetailsProto services.
                 * @member {Array.<space.kenko.proto.IServiceProto>} services
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @instance
                 */
                PracticeDetailsProto.prototype.services = $util.emptyArray;

                /**
                 * Creates a new PracticeDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto instance
                 */
                PracticeDetailsProto.create = function create(properties) {
                    return new PracticeDetailsProto(properties);
                };

                /**
                 * Encodes the specified PracticeDetailsProto message. Does not implicitly {@link space.kenko.proto.PracticeDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto} message PracticeDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PracticeDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.services != null && message.services.length)
                        for (let i = 0; i < message.services.length; ++i)
                            $root.space.kenko.proto.ServiceProto.encode(message.services[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PracticeDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.PracticeDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPracticeDetailsProto} message PracticeDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PracticeDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PracticeDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PracticeDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PracticeDetailsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.services && message.services.length))
                                    message.services = [];
                                message.services.push($root.space.kenko.proto.ServiceProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PracticeDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PracticeDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PracticeDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PracticeDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.services != null && message.hasOwnProperty("services")) {
                        if (!Array.isArray(message.services))
                            return "services: array expected";
                        for (let i = 0; i < message.services.length; ++i) {
                            let error = $root.space.kenko.proto.ServiceProto.verify(message.services[i]);
                            if (error)
                                return "services." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PracticeDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PracticeDetailsProto} PracticeDetailsProto
                 */
                PracticeDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PracticeDetailsProto)
                        return object;
                    let message = new $root.space.kenko.proto.PracticeDetailsProto();
                    if (object.services) {
                        if (!Array.isArray(object.services))
                            throw TypeError(".space.kenko.proto.PracticeDetailsProto.services: array expected");
                        message.services = [];
                        for (let i = 0; i < object.services.length; ++i) {
                            if (typeof object.services[i] !== "object")
                                throw TypeError(".space.kenko.proto.PracticeDetailsProto.services: object expected");
                            message.services[i] = $root.space.kenko.proto.ServiceProto.fromObject(object.services[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PracticeDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {space.kenko.proto.PracticeDetailsProto} message PracticeDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PracticeDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.services = [];
                    if (message.services && message.services.length) {
                        object.services = [];
                        for (let j = 0; j < message.services.length; ++j)
                            object.services[j] = $root.space.kenko.proto.ServiceProto.toObject(message.services[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PracticeDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PracticeDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PracticeDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PracticeDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PracticeDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PracticeDetailsProto";
                };

                return PracticeDetailsProto;
            })();

            proto.StudioDetailsProto = (function() {

                /**
                 * Properties of a StudioDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IStudioDetailsProto
                 * @property {Array.<space.kenko.proto.IClassTemplateProto>|null} [classTemplates] StudioDetailsProto classTemplates
                 */

                /**
                 * Constructs a new StudioDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a StudioDetailsProto.
                 * @implements IStudioDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IStudioDetailsProto=} [properties] Properties to set
                 */
                function StudioDetailsProto(properties) {
                    this.classTemplates = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StudioDetailsProto classTemplates.
                 * @member {Array.<space.kenko.proto.IClassTemplateProto>} classTemplates
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @instance
                 */
                StudioDetailsProto.prototype.classTemplates = $util.emptyArray;

                /**
                 * Creates a new StudioDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto instance
                 */
                StudioDetailsProto.create = function create(properties) {
                    return new StudioDetailsProto(properties);
                };

                /**
                 * Encodes the specified StudioDetailsProto message. Does not implicitly {@link space.kenko.proto.StudioDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto} message StudioDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StudioDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.classTemplates != null && message.classTemplates.length)
                        for (let i = 0; i < message.classTemplates.length; ++i)
                            $root.space.kenko.proto.ClassTemplateProto.encode(message.classTemplates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StudioDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.StudioDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.IStudioDetailsProto} message StudioDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StudioDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StudioDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StudioDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.StudioDetailsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.classTemplates && message.classTemplates.length))
                                    message.classTemplates = [];
                                message.classTemplates.push($root.space.kenko.proto.ClassTemplateProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StudioDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StudioDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StudioDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StudioDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.classTemplates != null && message.hasOwnProperty("classTemplates")) {
                        if (!Array.isArray(message.classTemplates))
                            return "classTemplates: array expected";
                        for (let i = 0; i < message.classTemplates.length; ++i) {
                            let error = $root.space.kenko.proto.ClassTemplateProto.verify(message.classTemplates[i]);
                            if (error)
                                return "classTemplates." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StudioDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.StudioDetailsProto} StudioDetailsProto
                 */
                StudioDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.StudioDetailsProto)
                        return object;
                    let message = new $root.space.kenko.proto.StudioDetailsProto();
                    if (object.classTemplates) {
                        if (!Array.isArray(object.classTemplates))
                            throw TypeError(".space.kenko.proto.StudioDetailsProto.classTemplates: array expected");
                        message.classTemplates = [];
                        for (let i = 0; i < object.classTemplates.length; ++i) {
                            if (typeof object.classTemplates[i] !== "object")
                                throw TypeError(".space.kenko.proto.StudioDetailsProto.classTemplates: object expected");
                            message.classTemplates[i] = $root.space.kenko.proto.ClassTemplateProto.fromObject(object.classTemplates[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StudioDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {space.kenko.proto.StudioDetailsProto} message StudioDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StudioDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.classTemplates = [];
                    if (message.classTemplates && message.classTemplates.length) {
                        object.classTemplates = [];
                        for (let j = 0; j < message.classTemplates.length; ++j)
                            object.classTemplates[j] = $root.space.kenko.proto.ClassTemplateProto.toObject(message.classTemplates[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this StudioDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StudioDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for StudioDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.StudioDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                StudioDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.StudioDetailsProto";
                };

                return StudioDetailsProto;
            })();

            proto.PricingDetailsProto = (function() {

                /**
                 * Properties of a PricingDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IPricingDetailsProto
                 * @property {Array.<IPriceCategoryProto>|null} [priceCategories] PricingDetailsProto priceCategories
                 * @property {Array.<IPackageProto>|null} [packages] PricingDetailsProto packages
                 * @property {Array.<space.kenko.proto.ISubscriptionProto>|null} [subscriptions] PricingDetailsProto subscriptions
                 */

                /**
                 * Constructs a new PricingDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PricingDetailsProto.
                 * @implements IPricingDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IPricingDetailsProto=} [properties] Properties to set
                 */
                function PricingDetailsProto(properties) {
                    this.priceCategories = [];
                    this.packages = [];
                    this.subscriptions = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PricingDetailsProto priceCategories.
                 * @member {Array.<IPriceCategoryProto>} priceCategories
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.priceCategories = $util.emptyArray;

                /**
                 * PricingDetailsProto packages.
                 * @member {Array.<IPackageProto>} packages
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.packages = $util.emptyArray;

                /**
                 * PricingDetailsProto subscriptions.
                 * @member {Array.<space.kenko.proto.ISubscriptionProto>} subscriptions
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 */
                PricingDetailsProto.prototype.subscriptions = $util.emptyArray;

                /**
                 * Creates a new PricingDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto instance
                 */
                PricingDetailsProto.create = function create(properties) {
                    return new PricingDetailsProto(properties);
                };

                /**
                 * Encodes the specified PricingDetailsProto message. Does not implicitly {@link space.kenko.proto.PricingDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto} message PricingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PricingDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.priceCategories != null && message.priceCategories.length)
                        for (let i = 0; i < message.priceCategories.length; ++i)
                            $root.PriceCategoryProto.encode(message.priceCategories[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.packages != null && message.packages.length)
                        for (let i = 0; i < message.packages.length; ++i)
                            $root.PackageProto.encode(message.packages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.subscriptions != null && message.subscriptions.length)
                        for (let i = 0; i < message.subscriptions.length; ++i)
                            $root.space.kenko.proto.SubscriptionProto.encode(message.subscriptions[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PricingDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.PricingDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IPricingDetailsProto} message PricingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PricingDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PricingDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PricingDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PricingDetailsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.priceCategories && message.priceCategories.length))
                                    message.priceCategories = [];
                                message.priceCategories.push($root.PriceCategoryProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 2: {
                                if (!(message.packages && message.packages.length))
                                    message.packages = [];
                                message.packages.push($root.PackageProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 3: {
                                if (!(message.subscriptions && message.subscriptions.length))
                                    message.subscriptions = [];
                                message.subscriptions.push($root.space.kenko.proto.SubscriptionProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PricingDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PricingDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PricingDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PricingDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.priceCategories != null && message.hasOwnProperty("priceCategories")) {
                        if (!Array.isArray(message.priceCategories))
                            return "priceCategories: array expected";
                        for (let i = 0; i < message.priceCategories.length; ++i) {
                            let error = $root.PriceCategoryProto.verify(message.priceCategories[i]);
                            if (error)
                                return "priceCategories." + error;
                        }
                    }
                    if (message.packages != null && message.hasOwnProperty("packages")) {
                        if (!Array.isArray(message.packages))
                            return "packages: array expected";
                        for (let i = 0; i < message.packages.length; ++i) {
                            let error = $root.PackageProto.verify(message.packages[i]);
                            if (error)
                                return "packages." + error;
                        }
                    }
                    if (message.subscriptions != null && message.hasOwnProperty("subscriptions")) {
                        if (!Array.isArray(message.subscriptions))
                            return "subscriptions: array expected";
                        for (let i = 0; i < message.subscriptions.length; ++i) {
                            let error = $root.space.kenko.proto.SubscriptionProto.verify(message.subscriptions[i]);
                            if (error)
                                return "subscriptions." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PricingDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PricingDetailsProto} PricingDetailsProto
                 */
                PricingDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PricingDetailsProto)
                        return object;
                    let message = new $root.space.kenko.proto.PricingDetailsProto();
                    if (object.priceCategories) {
                        if (!Array.isArray(object.priceCategories))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.priceCategories: array expected");
                        message.priceCategories = [];
                        for (let i = 0; i < object.priceCategories.length; ++i) {
                            if (typeof object.priceCategories[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.priceCategories: object expected");
                            message.priceCategories[i] = $root.PriceCategoryProto.fromObject(object.priceCategories[i]);
                        }
                    }
                    if (object.packages) {
                        if (!Array.isArray(object.packages))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.packages: array expected");
                        message.packages = [];
                        for (let i = 0; i < object.packages.length; ++i) {
                            if (typeof object.packages[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.packages: object expected");
                            message.packages[i] = $root.PackageProto.fromObject(object.packages[i]);
                        }
                    }
                    if (object.subscriptions) {
                        if (!Array.isArray(object.subscriptions))
                            throw TypeError(".space.kenko.proto.PricingDetailsProto.subscriptions: array expected");
                        message.subscriptions = [];
                        for (let i = 0; i < object.subscriptions.length; ++i) {
                            if (typeof object.subscriptions[i] !== "object")
                                throw TypeError(".space.kenko.proto.PricingDetailsProto.subscriptions: object expected");
                            message.subscriptions[i] = $root.space.kenko.proto.SubscriptionProto.fromObject(object.subscriptions[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PricingDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {space.kenko.proto.PricingDetailsProto} message PricingDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PricingDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.priceCategories = [];
                        object.packages = [];
                        object.subscriptions = [];
                    }
                    if (message.priceCategories && message.priceCategories.length) {
                        object.priceCategories = [];
                        for (let j = 0; j < message.priceCategories.length; ++j)
                            object.priceCategories[j] = $root.PriceCategoryProto.toObject(message.priceCategories[j], options);
                    }
                    if (message.packages && message.packages.length) {
                        object.packages = [];
                        for (let j = 0; j < message.packages.length; ++j)
                            object.packages[j] = $root.PackageProto.toObject(message.packages[j], options);
                    }
                    if (message.subscriptions && message.subscriptions.length) {
                        object.subscriptions = [];
                        for (let j = 0; j < message.subscriptions.length; ++j)
                            object.subscriptions[j] = $root.space.kenko.proto.SubscriptionProto.toObject(message.subscriptions[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PricingDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PricingDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PricingDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PricingDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PricingDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PricingDetailsProto";
                };

                return PricingDetailsProto;
            })();

            proto.ServiceProto = (function() {

                /**
                 * Properties of a ServiceProto.
                 * @memberof space.kenko.proto
                 * @interface IServiceProto
                 * @property {string|null} [sku] ServiceProto sku
                 * @property {string|null} [name] ServiceProto name
                 * @property {string|null} [description] ServiceProto description
                 * @property {number|null} [lengthMinutes] ServiceProto lengthMinutes
                 * @property {string|null} [category] ServiceProto category
                 * @property {Array.<string>|null} [availableLocationIds] ServiceProto availableLocationIds
                 * @property {boolean|null} [isVirtual] ServiceProto isVirtual
                 * @property {Array.<string>|null} [practitionerId] ServiceProto practitionerId
                 * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ServiceProto paymentPolicy
                 * @property {boolean|null} [archived] ServiceProto archived
                 */

                /**
                 * Constructs a new ServiceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ServiceProto.
                 * @implements IServiceProto
                 * @constructor
                 * @param {space.kenko.proto.IServiceProto=} [properties] Properties to set
                 */
                function ServiceProto(properties) {
                    this.availableLocationIds = [];
                    this.practitionerId = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ServiceProto sku.
                 * @member {string} sku
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.sku = "";

                /**
                 * ServiceProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.name = "";

                /**
                 * ServiceProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.description = "";

                /**
                 * ServiceProto lengthMinutes.
                 * @member {number} lengthMinutes
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.lengthMinutes = 0;

                /**
                 * ServiceProto category.
                 * @member {string} category
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.category = "";

                /**
                 * ServiceProto availableLocationIds.
                 * @member {Array.<string>} availableLocationIds
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.availableLocationIds = $util.emptyArray;

                /**
                 * ServiceProto isVirtual.
                 * @member {boolean} isVirtual
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.isVirtual = false;

                /**
                 * ServiceProto practitionerId.
                 * @member {Array.<string>} practitionerId
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.practitionerId = $util.emptyArray;

                /**
                 * ServiceProto paymentPolicy.
                 * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.paymentPolicy = null;

                /**
                 * ServiceProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 */
                ServiceProto.prototype.archived = false;

                /**
                 * Creates a new ServiceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto instance
                 */
                ServiceProto.create = function create(properties) {
                    return new ServiceProto(properties);
                };

                /**
                 * Encodes the specified ServiceProto message. Does not implicitly {@link space.kenko.proto.ServiceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto} message ServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.sku != null && Object.hasOwnProperty.call(message, "sku"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.sku);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.lengthMinutes != null && Object.hasOwnProperty.call(message, "lengthMinutes"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lengthMinutes);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.category);
                    if (message.availableLocationIds != null && message.availableLocationIds.length)
                        for (let i = 0; i < message.availableLocationIds.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.availableLocationIds[i]);
                    if (message.isVirtual != null && Object.hasOwnProperty.call(message, "isVirtual"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isVirtual);
                    if (message.practitionerId != null && message.practitionerId.length)
                        for (let i = 0; i < message.practitionerId.length; ++i)
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.practitionerId[i]);
                    if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
                        $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified ServiceProto message, length delimited. Does not implicitly {@link space.kenko.proto.ServiceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.IServiceProto} message ServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ServiceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ServiceProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.sku = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.lengthMinutes = reader.int32();
                                break;
                            }
                        case 5: {
                                message.category = reader.string();
                                break;
                            }
                        case 6: {
                                if (!(message.availableLocationIds && message.availableLocationIds.length))
                                    message.availableLocationIds = [];
                                message.availableLocationIds.push(reader.string());
                                break;
                            }
                        case 7: {
                                message.isVirtual = reader.bool();
                                break;
                            }
                        case 9: {
                                if (!(message.practitionerId && message.practitionerId.length))
                                    message.practitionerId = [];
                                message.practitionerId.push(reader.string());
                                break;
                            }
                        case 11: {
                                message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ServiceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ServiceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ServiceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.sku != null && message.hasOwnProperty("sku"))
                        if (!$util.isString(message.sku))
                            return "sku: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        if (!$util.isInteger(message.lengthMinutes))
                            return "lengthMinutes: integer expected";
                    if (message.category != null && message.hasOwnProperty("category"))
                        if (!$util.isString(message.category))
                            return "category: string expected";
                    if (message.availableLocationIds != null && message.hasOwnProperty("availableLocationIds")) {
                        if (!Array.isArray(message.availableLocationIds))
                            return "availableLocationIds: array expected";
                        for (let i = 0; i < message.availableLocationIds.length; ++i)
                            if (!$util.isString(message.availableLocationIds[i]))
                                return "availableLocationIds: string[] expected";
                    }
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        if (typeof message.isVirtual !== "boolean")
                            return "isVirtual: boolean expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId")) {
                        if (!Array.isArray(message.practitionerId))
                            return "practitionerId: array expected";
                        for (let i = 0; i < message.practitionerId.length; ++i)
                            if (!$util.isString(message.practitionerId[i]))
                                return "practitionerId: string[] expected";
                    }
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
                        let error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
                        if (error)
                            return "paymentPolicy." + error;
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a ServiceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ServiceProto} ServiceProto
                 */
                ServiceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ServiceProto)
                        return object;
                    let message = new $root.space.kenko.proto.ServiceProto();
                    if (object.sku != null)
                        message.sku = String(object.sku);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.lengthMinutes != null)
                        message.lengthMinutes = object.lengthMinutes | 0;
                    if (object.category != null)
                        message.category = String(object.category);
                    if (object.availableLocationIds) {
                        if (!Array.isArray(object.availableLocationIds))
                            throw TypeError(".space.kenko.proto.ServiceProto.availableLocationIds: array expected");
                        message.availableLocationIds = [];
                        for (let i = 0; i < object.availableLocationIds.length; ++i)
                            message.availableLocationIds[i] = String(object.availableLocationIds[i]);
                    }
                    if (object.isVirtual != null)
                        message.isVirtual = Boolean(object.isVirtual);
                    if (object.practitionerId) {
                        if (!Array.isArray(object.practitionerId))
                            throw TypeError(".space.kenko.proto.ServiceProto.practitionerId: array expected");
                        message.practitionerId = [];
                        for (let i = 0; i < object.practitionerId.length; ++i)
                            message.practitionerId[i] = String(object.practitionerId[i]);
                    }
                    if (object.paymentPolicy != null) {
                        if (typeof object.paymentPolicy !== "object")
                            throw TypeError(".space.kenko.proto.ServiceProto.paymentPolicy: object expected");
                        message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a ServiceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {space.kenko.proto.ServiceProto} message ServiceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ServiceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.availableLocationIds = [];
                        object.practitionerId = [];
                    }
                    if (options.defaults) {
                        object.sku = "";
                        object.name = "";
                        object.description = "";
                        object.lengthMinutes = 0;
                        object.category = "";
                        object.isVirtual = false;
                        object.paymentPolicy = null;
                        object.archived = false;
                    }
                    if (message.sku != null && message.hasOwnProperty("sku"))
                        object.sku = message.sku;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        object.lengthMinutes = message.lengthMinutes;
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = message.category;
                    if (message.availableLocationIds && message.availableLocationIds.length) {
                        object.availableLocationIds = [];
                        for (let j = 0; j < message.availableLocationIds.length; ++j)
                            object.availableLocationIds[j] = message.availableLocationIds[j];
                    }
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        object.isVirtual = message.isVirtual;
                    if (message.practitionerId && message.practitionerId.length) {
                        object.practitionerId = [];
                        for (let j = 0; j < message.practitionerId.length; ++j)
                            object.practitionerId[j] = message.practitionerId[j];
                    }
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
                        object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this ServiceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ServiceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ServiceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ServiceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ServiceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ServiceProto";
                };

                return ServiceProto;
            })();

            proto.ClassTemplateProto = (function() {

                /**
                 * Properties of a ClassTemplateProto.
                 * @memberof space.kenko.proto
                 * @interface IClassTemplateProto
                 * @property {string|null} [classTemplateId] ClassTemplateProto classTemplateId
                 * @property {string|null} [name] ClassTemplateProto name
                 * @property {string|null} [description] ClassTemplateProto description
                 * @property {number|null} [lengthMinutes] ClassTemplateProto lengthMinutes
                 * @property {string|null} [category] ClassTemplateProto category
                 * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ClassTemplateProto paymentPolicy
                 * @property {number|null} [maxAttendees] ClassTemplateProto maxAttendees
                 * @property {boolean|null} [archived] ClassTemplateProto archived
                 */

                /**
                 * Constructs a new ClassTemplateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClassTemplateProto.
                 * @implements IClassTemplateProto
                 * @constructor
                 * @param {space.kenko.proto.IClassTemplateProto=} [properties] Properties to set
                 */
                function ClassTemplateProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClassTemplateProto classTemplateId.
                 * @member {string} classTemplateId
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.classTemplateId = "";

                /**
                 * ClassTemplateProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.name = "";

                /**
                 * ClassTemplateProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.description = "";

                /**
                 * ClassTemplateProto lengthMinutes.
                 * @member {number} lengthMinutes
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.lengthMinutes = 0;

                /**
                 * ClassTemplateProto category.
                 * @member {string} category
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.category = "";

                /**
                 * ClassTemplateProto paymentPolicy.
                 * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.paymentPolicy = null;

                /**
                 * ClassTemplateProto maxAttendees.
                 * @member {number} maxAttendees
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.maxAttendees = 0;

                /**
                 * ClassTemplateProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 */
                ClassTemplateProto.prototype.archived = false;

                /**
                 * Creates a new ClassTemplateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto instance
                 */
                ClassTemplateProto.create = function create(properties) {
                    return new ClassTemplateProto(properties);
                };

                /**
                 * Encodes the specified ClassTemplateProto message. Does not implicitly {@link space.kenko.proto.ClassTemplateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto} message ClassTemplateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassTemplateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.classTemplateId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.lengthMinutes != null && Object.hasOwnProperty.call(message, "lengthMinutes"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.lengthMinutes);
                    if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.category);
                    if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
                        $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.maxAttendees != null && Object.hasOwnProperty.call(message, "maxAttendees"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int32(message.maxAttendees);
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified ClassTemplateProto message, length delimited. Does not implicitly {@link space.kenko.proto.ClassTemplateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.IClassTemplateProto} message ClassTemplateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassTemplateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClassTemplateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassTemplateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClassTemplateProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.classTemplateId = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.lengthMinutes = reader.int32();
                                break;
                            }
                        case 5: {
                                message.category = reader.string();
                                break;
                            }
                        case 11: {
                                message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 12: {
                                message.maxAttendees = reader.int32();
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClassTemplateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassTemplateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClassTemplateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClassTemplateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        if (!$util.isString(message.classTemplateId))
                            return "classTemplateId: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        if (!$util.isInteger(message.lengthMinutes))
                            return "lengthMinutes: integer expected";
                    if (message.category != null && message.hasOwnProperty("category"))
                        if (!$util.isString(message.category))
                            return "category: string expected";
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
                        let error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
                        if (error)
                            return "paymentPolicy." + error;
                    }
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        if (!$util.isInteger(message.maxAttendees))
                            return "maxAttendees: integer expected";
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a ClassTemplateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClassTemplateProto} ClassTemplateProto
                 */
                ClassTemplateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClassTemplateProto)
                        return object;
                    let message = new $root.space.kenko.proto.ClassTemplateProto();
                    if (object.classTemplateId != null)
                        message.classTemplateId = String(object.classTemplateId);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.lengthMinutes != null)
                        message.lengthMinutes = object.lengthMinutes | 0;
                    if (object.category != null)
                        message.category = String(object.category);
                    if (object.paymentPolicy != null) {
                        if (typeof object.paymentPolicy !== "object")
                            throw TypeError(".space.kenko.proto.ClassTemplateProto.paymentPolicy: object expected");
                        message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
                    }
                    if (object.maxAttendees != null)
                        message.maxAttendees = object.maxAttendees | 0;
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a ClassTemplateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {space.kenko.proto.ClassTemplateProto} message ClassTemplateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClassTemplateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.classTemplateId = "";
                        object.name = "";
                        object.description = "";
                        object.lengthMinutes = 0;
                        object.category = "";
                        object.paymentPolicy = null;
                        object.maxAttendees = 0;
                        object.archived = false;
                    }
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        object.classTemplateId = message.classTemplateId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.lengthMinutes != null && message.hasOwnProperty("lengthMinutes"))
                        object.lengthMinutes = message.lengthMinutes;
                    if (message.category != null && message.hasOwnProperty("category"))
                        object.category = message.category;
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
                        object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        object.maxAttendees = message.maxAttendees;
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this ClassTemplateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClassTemplateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClassTemplateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClassTemplateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClassTemplateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClassTemplateProto";
                };

                return ClassTemplateProto;
            })();

            proto.SubscriptionProto = (function() {

                /**
                 * Properties of a SubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface ISubscriptionProto
                 * @property {string|null} [stripeSubscriptionId] SubscriptionProto stripeSubscriptionId
                 * @property {string|null} [name] SubscriptionProto name
                 * @property {string|null} [description] SubscriptionProto description
                 * @property {space.kenko.proto.IBillingPeriodProto|null} [billingPeriod] SubscriptionProto billingPeriod
                 * @property {space.kenko.proto.IPriceProto|null} [price] SubscriptionProto price
                 * @property {space.kenko.proto.ISubscriptionEntitlementProto|null} [entitlement] SubscriptionProto entitlement
                 * @property {boolean|null} [archived] SubscriptionProto archived
                 */

                /**
                 * Constructs a new SubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SubscriptionProto.
                 * @implements ISubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.ISubscriptionProto=} [properties] Properties to set
                 */
                function SubscriptionProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionProto stripeSubscriptionId.
                 * @member {string} stripeSubscriptionId
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.stripeSubscriptionId = "";

                /**
                 * SubscriptionProto name.
                 * @member {string} name
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.name = "";

                /**
                 * SubscriptionProto description.
                 * @member {string} description
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.description = "";

                /**
                 * SubscriptionProto billingPeriod.
                 * @member {space.kenko.proto.IBillingPeriodProto|null|undefined} billingPeriod
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.billingPeriod = null;

                /**
                 * SubscriptionProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.price = null;

                /**
                 * SubscriptionProto entitlement.
                 * @member {space.kenko.proto.ISubscriptionEntitlementProto|null|undefined} entitlement
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.entitlement = null;

                /**
                 * SubscriptionProto archived.
                 * @member {boolean} archived
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 */
                SubscriptionProto.prototype.archived = false;

                /**
                 * Creates a new SubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto instance
                 */
                SubscriptionProto.create = function create(properties) {
                    return new SubscriptionProto(properties);
                };

                /**
                 * Encodes the specified SubscriptionProto message. Does not implicitly {@link space.kenko.proto.SubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto} message SubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.stripeSubscriptionId != null && Object.hasOwnProperty.call(message, "stripeSubscriptionId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripeSubscriptionId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                    if (message.billingPeriod != null && Object.hasOwnProperty.call(message, "billingPeriod"))
                        $root.space.kenko.proto.BillingPeriodProto.encode(message.billingPeriod, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.entitlement != null && Object.hasOwnProperty.call(message, "entitlement"))
                        $root.space.kenko.proto.SubscriptionEntitlementProto.encode(message.entitlement, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.archived);
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.SubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionProto} message SubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SubscriptionProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.stripeSubscriptionId = reader.string();
                                break;
                            }
                        case 2: {
                                message.name = reader.string();
                                break;
                            }
                        case 3: {
                                message.description = reader.string();
                                break;
                            }
                        case 4: {
                                message.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 5: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.archived = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.stripeSubscriptionId != null && message.hasOwnProperty("stripeSubscriptionId"))
                        if (!$util.isString(message.stripeSubscriptionId))
                            return "stripeSubscriptionId: string expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.billingPeriod != null && message.hasOwnProperty("billingPeriod")) {
                        let error = $root.space.kenko.proto.BillingPeriodProto.verify(message.billingPeriod);
                        if (error)
                            return "billingPeriod." + error;
                    }
                    if (message.price != null && message.hasOwnProperty("price")) {
                        let error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.entitlement != null && message.hasOwnProperty("entitlement")) {
                        let error = $root.space.kenko.proto.SubscriptionEntitlementProto.verify(message.entitlement);
                        if (error)
                            return "entitlement." + error;
                    }
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        if (typeof message.archived !== "boolean")
                            return "archived: boolean expected";
                    return null;
                };

                /**
                 * Creates a SubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SubscriptionProto} SubscriptionProto
                 */
                SubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SubscriptionProto)
                        return object;
                    let message = new $root.space.kenko.proto.SubscriptionProto();
                    if (object.stripeSubscriptionId != null)
                        message.stripeSubscriptionId = String(object.stripeSubscriptionId);
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    if (object.billingPeriod != null) {
                        if (typeof object.billingPeriod !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.billingPeriod: object expected");
                        message.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.fromObject(object.billingPeriod);
                    }
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    if (object.entitlement != null) {
                        if (typeof object.entitlement !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionProto.entitlement: object expected");
                        message.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.fromObject(object.entitlement);
                    }
                    if (object.archived != null)
                        message.archived = Boolean(object.archived);
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {space.kenko.proto.SubscriptionProto} message SubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.stripeSubscriptionId = "";
                        object.name = "";
                        object.description = "";
                        object.billingPeriod = null;
                        object.price = null;
                        object.entitlement = null;
                        object.archived = false;
                    }
                    if (message.stripeSubscriptionId != null && message.hasOwnProperty("stripeSubscriptionId"))
                        object.stripeSubscriptionId = message.stripeSubscriptionId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.billingPeriod != null && message.hasOwnProperty("billingPeriod"))
                        object.billingPeriod = $root.space.kenko.proto.BillingPeriodProto.toObject(message.billingPeriod, options);
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    if (message.entitlement != null && message.hasOwnProperty("entitlement"))
                        object.entitlement = $root.space.kenko.proto.SubscriptionEntitlementProto.toObject(message.entitlement, options);
                    if (message.archived != null && message.hasOwnProperty("archived"))
                        object.archived = message.archived;
                    return object;
                };

                /**
                 * Converts this SubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SubscriptionProto";
                };

                return SubscriptionProto;
            })();

            /**
             * BillingPeriodUnitProto enum.
             * @name space.kenko.proto.BillingPeriodUnitProto
             * @enum {number}
             * @property {number} BILLING_PERIOD_UNKNOWN=0 BILLING_PERIOD_UNKNOWN value
             * @property {number} MONTH=1 MONTH value
             * @property {number} YEAR=2 YEAR value
             */
            proto.BillingPeriodUnitProto = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "BILLING_PERIOD_UNKNOWN"] = 0;
                values[valuesById[1] = "MONTH"] = 1;
                values[valuesById[2] = "YEAR"] = 2;
                return values;
            })();

            proto.BillingPeriodProto = (function() {

                /**
                 * Properties of a BillingPeriodProto.
                 * @memberof space.kenko.proto
                 * @interface IBillingPeriodProto
                 * @property {number|null} [amount] BillingPeriodProto amount
                 * @property {space.kenko.proto.BillingPeriodUnitProto|null} [unit] BillingPeriodProto unit
                 */

                /**
                 * Constructs a new BillingPeriodProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BillingPeriodProto.
                 * @implements IBillingPeriodProto
                 * @constructor
                 * @param {space.kenko.proto.IBillingPeriodProto=} [properties] Properties to set
                 */
                function BillingPeriodProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BillingPeriodProto amount.
                 * @member {number} amount
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 */
                BillingPeriodProto.prototype.amount = 0;

                /**
                 * BillingPeriodProto unit.
                 * @member {space.kenko.proto.BillingPeriodUnitProto} unit
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 */
                BillingPeriodProto.prototype.unit = 0;

                /**
                 * Creates a new BillingPeriodProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto instance
                 */
                BillingPeriodProto.create = function create(properties) {
                    return new BillingPeriodProto(properties);
                };

                /**
                 * Encodes the specified BillingPeriodProto message. Does not implicitly {@link space.kenko.proto.BillingPeriodProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto} message BillingPeriodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BillingPeriodProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.amount);
                    if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.unit);
                    return writer;
                };

                /**
                 * Encodes the specified BillingPeriodProto message, length delimited. Does not implicitly {@link space.kenko.proto.BillingPeriodProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.IBillingPeriodProto} message BillingPeriodProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BillingPeriodProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BillingPeriodProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BillingPeriodProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BillingPeriodProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.amount = reader.int32();
                                break;
                            }
                        case 2: {
                                message.unit = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BillingPeriodProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BillingPeriodProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BillingPeriodProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BillingPeriodProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        if (!$util.isInteger(message.amount))
                            return "amount: integer expected";
                    if (message.unit != null && message.hasOwnProperty("unit"))
                        switch (message.unit) {
                        default:
                            return "unit: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a BillingPeriodProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BillingPeriodProto} BillingPeriodProto
                 */
                BillingPeriodProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BillingPeriodProto)
                        return object;
                    let message = new $root.space.kenko.proto.BillingPeriodProto();
                    if (object.amount != null)
                        message.amount = object.amount | 0;
                    switch (object.unit) {
                    default:
                        if (typeof object.unit === "number") {
                            message.unit = object.unit;
                            break;
                        }
                        break;
                    case "BILLING_PERIOD_UNKNOWN":
                    case 0:
                        message.unit = 0;
                        break;
                    case "MONTH":
                    case 1:
                        message.unit = 1;
                        break;
                    case "YEAR":
                    case 2:
                        message.unit = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BillingPeriodProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {space.kenko.proto.BillingPeriodProto} message BillingPeriodProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BillingPeriodProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.amount = 0;
                        object.unit = options.enums === String ? "BILLING_PERIOD_UNKNOWN" : 0;
                    }
                    if (message.amount != null && message.hasOwnProperty("amount"))
                        object.amount = message.amount;
                    if (message.unit != null && message.hasOwnProperty("unit"))
                        object.unit = options.enums === String ? $root.space.kenko.proto.BillingPeriodUnitProto[message.unit] === undefined ? message.unit : $root.space.kenko.proto.BillingPeriodUnitProto[message.unit] : message.unit;
                    return object;
                };

                /**
                 * Converts this BillingPeriodProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BillingPeriodProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BillingPeriodProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BillingPeriodProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BillingPeriodProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BillingPeriodProto";
                };

                return BillingPeriodProto;
            })();

            proto.SubscriptionEntitlementProto = (function() {

                /**
                 * Properties of a SubscriptionEntitlementProto.
                 * @memberof space.kenko.proto
                 * @interface ISubscriptionEntitlementProto
                 * @property {string|null} [id] SubscriptionEntitlementProto id
                 * @property {string|null} [displayName] SubscriptionEntitlementProto displayName
                 * @property {space.kenko.proto.IClassSubscriptionEntitlement|null} [classes] SubscriptionEntitlementProto classes
                 */

                /**
                 * Constructs a new SubscriptionEntitlementProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SubscriptionEntitlementProto.
                 * @implements ISubscriptionEntitlementProto
                 * @constructor
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto=} [properties] Properties to set
                 */
                function SubscriptionEntitlementProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubscriptionEntitlementProto id.
                 * @member {string} id
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.id = "";

                /**
                 * SubscriptionEntitlementProto displayName.
                 * @member {string} displayName
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.displayName = "";

                /**
                 * SubscriptionEntitlementProto classes.
                 * @member {space.kenko.proto.IClassSubscriptionEntitlement|null|undefined} classes
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                SubscriptionEntitlementProto.prototype.classes = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * SubscriptionEntitlementProto EntitlementType.
                 * @member {"classes"|undefined} EntitlementType
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 */
                Object.defineProperty(SubscriptionEntitlementProto.prototype, "EntitlementType", {
                    get: $util.oneOfGetter($oneOfFields = ["classes"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new SubscriptionEntitlementProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto instance
                 */
                SubscriptionEntitlementProto.create = function create(properties) {
                    return new SubscriptionEntitlementProto(properties);
                };

                /**
                 * Encodes the specified SubscriptionEntitlementProto message. Does not implicitly {@link space.kenko.proto.SubscriptionEntitlementProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto} message SubscriptionEntitlementProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionEntitlementProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                    if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.displayName);
                    if (message.classes != null && Object.hasOwnProperty.call(message, "classes"))
                        $root.space.kenko.proto.ClassSubscriptionEntitlement.encode(message.classes, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SubscriptionEntitlementProto message, length delimited. Does not implicitly {@link space.kenko.proto.SubscriptionEntitlementProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.ISubscriptionEntitlementProto} message SubscriptionEntitlementProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubscriptionEntitlementProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubscriptionEntitlementProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionEntitlementProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SubscriptionEntitlementProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.id = reader.string();
                                break;
                            }
                        case 2: {
                                message.displayName = reader.string();
                                break;
                            }
                        case 10: {
                                message.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubscriptionEntitlementProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubscriptionEntitlementProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubscriptionEntitlementProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubscriptionEntitlementProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isString(message.id))
                            return "id: string expected";
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        if (!$util.isString(message.displayName))
                            return "displayName: string expected";
                    if (message.classes != null && message.hasOwnProperty("classes")) {
                        properties.EntitlementType = 1;
                        {
                            let error = $root.space.kenko.proto.ClassSubscriptionEntitlement.verify(message.classes);
                            if (error)
                                return "classes." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SubscriptionEntitlementProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SubscriptionEntitlementProto} SubscriptionEntitlementProto
                 */
                SubscriptionEntitlementProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SubscriptionEntitlementProto)
                        return object;
                    let message = new $root.space.kenko.proto.SubscriptionEntitlementProto();
                    if (object.id != null)
                        message.id = String(object.id);
                    if (object.displayName != null)
                        message.displayName = String(object.displayName);
                    if (object.classes != null) {
                        if (typeof object.classes !== "object")
                            throw TypeError(".space.kenko.proto.SubscriptionEntitlementProto.classes: object expected");
                        message.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.fromObject(object.classes);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SubscriptionEntitlementProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {space.kenko.proto.SubscriptionEntitlementProto} message SubscriptionEntitlementProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubscriptionEntitlementProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.id = "";
                        object.displayName = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        object.id = message.id;
                    if (message.displayName != null && message.hasOwnProperty("displayName"))
                        object.displayName = message.displayName;
                    if (message.classes != null && message.hasOwnProperty("classes")) {
                        object.classes = $root.space.kenko.proto.ClassSubscriptionEntitlement.toObject(message.classes, options);
                        if (options.oneofs)
                            object.EntitlementType = "classes";
                    }
                    return object;
                };

                /**
                 * Converts this SubscriptionEntitlementProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubscriptionEntitlementProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SubscriptionEntitlementProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SubscriptionEntitlementProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SubscriptionEntitlementProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SubscriptionEntitlementProto";
                };

                return SubscriptionEntitlementProto;
            })();

            proto.ClassSubscriptionEntitlement = (function() {

                /**
                 * Properties of a ClassSubscriptionEntitlement.
                 * @memberof space.kenko.proto
                 * @interface IClassSubscriptionEntitlement
                 * @property {string|null} [includedPriceCategory] ClassSubscriptionEntitlement includedPriceCategory
                 * @property {number|null} [maxClassesPerDay] ClassSubscriptionEntitlement maxClassesPerDay
                 */

                /**
                 * Constructs a new ClassSubscriptionEntitlement.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClassSubscriptionEntitlement.
                 * @implements IClassSubscriptionEntitlement
                 * @constructor
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement=} [properties] Properties to set
                 */
                function ClassSubscriptionEntitlement(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClassSubscriptionEntitlement includedPriceCategory.
                 * @member {string} includedPriceCategory
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 */
                ClassSubscriptionEntitlement.prototype.includedPriceCategory = "";

                /**
                 * ClassSubscriptionEntitlement maxClassesPerDay.
                 * @member {number} maxClassesPerDay
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 */
                ClassSubscriptionEntitlement.prototype.maxClassesPerDay = 0;

                /**
                 * Creates a new ClassSubscriptionEntitlement instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement instance
                 */
                ClassSubscriptionEntitlement.create = function create(properties) {
                    return new ClassSubscriptionEntitlement(properties);
                };

                /**
                 * Encodes the specified ClassSubscriptionEntitlement message. Does not implicitly {@link space.kenko.proto.ClassSubscriptionEntitlement.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement} message ClassSubscriptionEntitlement message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassSubscriptionEntitlement.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.includedPriceCategory != null && Object.hasOwnProperty.call(message, "includedPriceCategory"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.includedPriceCategory);
                    if (message.maxClassesPerDay != null && Object.hasOwnProperty.call(message, "maxClassesPerDay"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxClassesPerDay);
                    return writer;
                };

                /**
                 * Encodes the specified ClassSubscriptionEntitlement message, length delimited. Does not implicitly {@link space.kenko.proto.ClassSubscriptionEntitlement.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.IClassSubscriptionEntitlement} message ClassSubscriptionEntitlement message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassSubscriptionEntitlement.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClassSubscriptionEntitlement message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassSubscriptionEntitlement.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClassSubscriptionEntitlement();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.includedPriceCategory = reader.string();
                                break;
                            }
                        case 2: {
                                message.maxClassesPerDay = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClassSubscriptionEntitlement message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassSubscriptionEntitlement.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClassSubscriptionEntitlement message.
                 * @function verify
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClassSubscriptionEntitlement.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.includedPriceCategory != null && message.hasOwnProperty("includedPriceCategory"))
                        if (!$util.isString(message.includedPriceCategory))
                            return "includedPriceCategory: string expected";
                    if (message.maxClassesPerDay != null && message.hasOwnProperty("maxClassesPerDay"))
                        if (!$util.isInteger(message.maxClassesPerDay))
                            return "maxClassesPerDay: integer expected";
                    return null;
                };

                /**
                 * Creates a ClassSubscriptionEntitlement message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClassSubscriptionEntitlement} ClassSubscriptionEntitlement
                 */
                ClassSubscriptionEntitlement.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClassSubscriptionEntitlement)
                        return object;
                    let message = new $root.space.kenko.proto.ClassSubscriptionEntitlement();
                    if (object.includedPriceCategory != null)
                        message.includedPriceCategory = String(object.includedPriceCategory);
                    if (object.maxClassesPerDay != null)
                        message.maxClassesPerDay = object.maxClassesPerDay | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a ClassSubscriptionEntitlement message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {space.kenko.proto.ClassSubscriptionEntitlement} message ClassSubscriptionEntitlement
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClassSubscriptionEntitlement.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.includedPriceCategory = "";
                        object.maxClassesPerDay = 0;
                    }
                    if (message.includedPriceCategory != null && message.hasOwnProperty("includedPriceCategory"))
                        object.includedPriceCategory = message.includedPriceCategory;
                    if (message.maxClassesPerDay != null && message.hasOwnProperty("maxClassesPerDay"))
                        object.maxClassesPerDay = message.maxClassesPerDay;
                    return object;
                };

                /**
                 * Converts this ClassSubscriptionEntitlement to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClassSubscriptionEntitlement.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClassSubscriptionEntitlement
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClassSubscriptionEntitlement
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClassSubscriptionEntitlement.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClassSubscriptionEntitlement";
                };

                return ClassSubscriptionEntitlement;
            })();

            proto.PurchasedSubscriptionProto = (function() {

                /**
                 * Properties of a PurchasedSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface IPurchasedSubscriptionProto
                 * @property {string|null} [purchasedSubscriptionId] PurchasedSubscriptionProto purchasedSubscriptionId
                 * @property {space.kenko.proto.ISubscriptionProto|null} [subscriptionDetails] PurchasedSubscriptionProto subscriptionDetails
                 * @property {number|Long|null} [purchaseTimestamp] PurchasedSubscriptionProto purchaseTimestamp
                 * @property {string|null} [subscriptionState] PurchasedSubscriptionProto subscriptionState
                 * @property {number|Long|null} [lastPaidInvoice] PurchasedSubscriptionProto lastPaidInvoice
                 */

                /**
                 * Constructs a new PurchasedSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PurchasedSubscriptionProto.
                 * @implements IPurchasedSubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto=} [properties] Properties to set
                 */
                function PurchasedSubscriptionProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PurchasedSubscriptionProto purchasedSubscriptionId.
                 * @member {string} purchasedSubscriptionId
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.purchasedSubscriptionId = "";

                /**
                 * PurchasedSubscriptionProto subscriptionDetails.
                 * @member {space.kenko.proto.ISubscriptionProto|null|undefined} subscriptionDetails
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.subscriptionDetails = null;

                /**
                 * PurchasedSubscriptionProto purchaseTimestamp.
                 * @member {number|Long} purchaseTimestamp
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.purchaseTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PurchasedSubscriptionProto subscriptionState.
                 * @member {string} subscriptionState
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.subscriptionState = "";

                /**
                 * PurchasedSubscriptionProto lastPaidInvoice.
                 * @member {number|Long} lastPaidInvoice
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 */
                PurchasedSubscriptionProto.prototype.lastPaidInvoice = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new PurchasedSubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto instance
                 */
                PurchasedSubscriptionProto.create = function create(properties) {
                    return new PurchasedSubscriptionProto(properties);
                };

                /**
                 * Encodes the specified PurchasedSubscriptionProto message. Does not implicitly {@link space.kenko.proto.PurchasedSubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto} message PurchasedSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PurchasedSubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.purchasedSubscriptionId != null && Object.hasOwnProperty.call(message, "purchasedSubscriptionId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.purchasedSubscriptionId);
                    if (message.subscriptionDetails != null && Object.hasOwnProperty.call(message, "subscriptionDetails"))
                        $root.space.kenko.proto.SubscriptionProto.encode(message.subscriptionDetails, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.purchaseTimestamp != null && Object.hasOwnProperty.call(message, "purchaseTimestamp"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.purchaseTimestamp);
                    if (message.subscriptionState != null && Object.hasOwnProperty.call(message, "subscriptionState"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.subscriptionState);
                    if (message.lastPaidInvoice != null && Object.hasOwnProperty.call(message, "lastPaidInvoice"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastPaidInvoice);
                    return writer;
                };

                /**
                 * Encodes the specified PurchasedSubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.PurchasedSubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IPurchasedSubscriptionProto} message PurchasedSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PurchasedSubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PurchasedSubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PurchasedSubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PurchasedSubscriptionProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.purchasedSubscriptionId = reader.string();
                                break;
                            }
                        case 2: {
                                message.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 3: {
                                message.purchaseTimestamp = reader.int64();
                                break;
                            }
                        case 4: {
                                message.subscriptionState = reader.string();
                                break;
                            }
                        case 5: {
                                message.lastPaidInvoice = reader.int64();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PurchasedSubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PurchasedSubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PurchasedSubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PurchasedSubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.purchasedSubscriptionId != null && message.hasOwnProperty("purchasedSubscriptionId"))
                        if (!$util.isString(message.purchasedSubscriptionId))
                            return "purchasedSubscriptionId: string expected";
                    if (message.subscriptionDetails != null && message.hasOwnProperty("subscriptionDetails")) {
                        let error = $root.space.kenko.proto.SubscriptionProto.verify(message.subscriptionDetails);
                        if (error)
                            return "subscriptionDetails." + error;
                    }
                    if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
                        if (!$util.isInteger(message.purchaseTimestamp) && !(message.purchaseTimestamp && $util.isInteger(message.purchaseTimestamp.low) && $util.isInteger(message.purchaseTimestamp.high)))
                            return "purchaseTimestamp: integer|Long expected";
                    if (message.subscriptionState != null && message.hasOwnProperty("subscriptionState"))
                        if (!$util.isString(message.subscriptionState))
                            return "subscriptionState: string expected";
                    if (message.lastPaidInvoice != null && message.hasOwnProperty("lastPaidInvoice"))
                        if (!$util.isInteger(message.lastPaidInvoice) && !(message.lastPaidInvoice && $util.isInteger(message.lastPaidInvoice.low) && $util.isInteger(message.lastPaidInvoice.high)))
                            return "lastPaidInvoice: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a PurchasedSubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PurchasedSubscriptionProto} PurchasedSubscriptionProto
                 */
                PurchasedSubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PurchasedSubscriptionProto)
                        return object;
                    let message = new $root.space.kenko.proto.PurchasedSubscriptionProto();
                    if (object.purchasedSubscriptionId != null)
                        message.purchasedSubscriptionId = String(object.purchasedSubscriptionId);
                    if (object.subscriptionDetails != null) {
                        if (typeof object.subscriptionDetails !== "object")
                            throw TypeError(".space.kenko.proto.PurchasedSubscriptionProto.subscriptionDetails: object expected");
                        message.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.fromObject(object.subscriptionDetails);
                    }
                    if (object.purchaseTimestamp != null)
                        if ($util.Long)
                            (message.purchaseTimestamp = $util.Long.fromValue(object.purchaseTimestamp)).unsigned = false;
                        else if (typeof object.purchaseTimestamp === "string")
                            message.purchaseTimestamp = parseInt(object.purchaseTimestamp, 10);
                        else if (typeof object.purchaseTimestamp === "number")
                            message.purchaseTimestamp = object.purchaseTimestamp;
                        else if (typeof object.purchaseTimestamp === "object")
                            message.purchaseTimestamp = new $util.LongBits(object.purchaseTimestamp.low >>> 0, object.purchaseTimestamp.high >>> 0).toNumber();
                    if (object.subscriptionState != null)
                        message.subscriptionState = String(object.subscriptionState);
                    if (object.lastPaidInvoice != null)
                        if ($util.Long)
                            (message.lastPaidInvoice = $util.Long.fromValue(object.lastPaidInvoice)).unsigned = false;
                        else if (typeof object.lastPaidInvoice === "string")
                            message.lastPaidInvoice = parseInt(object.lastPaidInvoice, 10);
                        else if (typeof object.lastPaidInvoice === "number")
                            message.lastPaidInvoice = object.lastPaidInvoice;
                        else if (typeof object.lastPaidInvoice === "object")
                            message.lastPaidInvoice = new $util.LongBits(object.lastPaidInvoice.low >>> 0, object.lastPaidInvoice.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a PurchasedSubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.PurchasedSubscriptionProto} message PurchasedSubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PurchasedSubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.purchasedSubscriptionId = "";
                        object.subscriptionDetails = null;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.purchaseTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.purchaseTimestamp = options.longs === String ? "0" : 0;
                        object.subscriptionState = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.lastPaidInvoice = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastPaidInvoice = options.longs === String ? "0" : 0;
                    }
                    if (message.purchasedSubscriptionId != null && message.hasOwnProperty("purchasedSubscriptionId"))
                        object.purchasedSubscriptionId = message.purchasedSubscriptionId;
                    if (message.subscriptionDetails != null && message.hasOwnProperty("subscriptionDetails"))
                        object.subscriptionDetails = $root.space.kenko.proto.SubscriptionProto.toObject(message.subscriptionDetails, options);
                    if (message.purchaseTimestamp != null && message.hasOwnProperty("purchaseTimestamp"))
                        if (typeof message.purchaseTimestamp === "number")
                            object.purchaseTimestamp = options.longs === String ? String(message.purchaseTimestamp) : message.purchaseTimestamp;
                        else
                            object.purchaseTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.purchaseTimestamp) : options.longs === Number ? new $util.LongBits(message.purchaseTimestamp.low >>> 0, message.purchaseTimestamp.high >>> 0).toNumber() : message.purchaseTimestamp;
                    if (message.subscriptionState != null && message.hasOwnProperty("subscriptionState"))
                        object.subscriptionState = message.subscriptionState;
                    if (message.lastPaidInvoice != null && message.hasOwnProperty("lastPaidInvoice"))
                        if (typeof message.lastPaidInvoice === "number")
                            object.lastPaidInvoice = options.longs === String ? String(message.lastPaidInvoice) : message.lastPaidInvoice;
                        else
                            object.lastPaidInvoice = options.longs === String ? $util.Long.prototype.toString.call(message.lastPaidInvoice) : options.longs === Number ? new $util.LongBits(message.lastPaidInvoice.low >>> 0, message.lastPaidInvoice.high >>> 0).toNumber() : message.lastPaidInvoice;
                    return object;
                };

                /**
                 * Converts this PurchasedSubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PurchasedSubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PurchasedSubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PurchasedSubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PurchasedSubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PurchasedSubscriptionProto";
                };

                return PurchasedSubscriptionProto;
            })();

            /**
             * BusinessSubscriptionType enum.
             * @name space.kenko.proto.BusinessSubscriptionType
             * @enum {number}
             * @property {number} SUBSCRIPTION_TYPE_UNKNOWN=0 SUBSCRIPTION_TYPE_UNKNOWN value
             * @property {number} LISTING=1 LISTING value
             * @property {number} LISTING_PLUS_BOOKING=2 LISTING_PLUS_BOOKING value
             */
            proto.BusinessSubscriptionType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SUBSCRIPTION_TYPE_UNKNOWN"] = 0;
                values[valuesById[1] = "LISTING"] = 1;
                values[valuesById[2] = "LISTING_PLUS_BOOKING"] = 2;
                return values;
            })();

            proto.BusinessSubscriptionProto = (function() {

                /**
                 * Properties of a BusinessSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessSubscriptionProto
                 * @property {space.kenko.proto.BusinessSubscriptionType|null} [type] BusinessSubscriptionProto type
                 * @property {number|null} [quantity] BusinessSubscriptionProto quantity
                 * @property {string|null} [paymentProvider] BusinessSubscriptionProto paymentProvider
                 * @property {boolean|null} [isActive] BusinessSubscriptionProto isActive
                 * @property {string|null} [subscriptionId] BusinessSubscriptionProto subscriptionId
                 */

                /**
                 * Constructs a new BusinessSubscriptionProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessSubscriptionProto.
                 * @implements IBusinessSubscriptionProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessSubscriptionProto=} [properties] Properties to set
                 */
                function BusinessSubscriptionProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessSubscriptionProto type.
                 * @member {space.kenko.proto.BusinessSubscriptionType} type
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.type = 0;

                /**
                 * BusinessSubscriptionProto quantity.
                 * @member {number} quantity
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.quantity = 0;

                /**
                 * BusinessSubscriptionProto paymentProvider.
                 * @member {string} paymentProvider
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.paymentProvider = "";

                /**
                 * BusinessSubscriptionProto isActive.
                 * @member {boolean} isActive
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.isActive = false;

                /**
                 * BusinessSubscriptionProto subscriptionId.
                 * @member {string} subscriptionId
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 */
                BusinessSubscriptionProto.prototype.subscriptionId = "";

                /**
                 * Creates a new BusinessSubscriptionProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto instance
                 */
                BusinessSubscriptionProto.create = function create(properties) {
                    return new BusinessSubscriptionProto(properties);
                };

                /**
                 * Encodes the specified BusinessSubscriptionProto message. Does not implicitly {@link space.kenko.proto.BusinessSubscriptionProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto} message BusinessSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSubscriptionProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                    if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.quantity);
                    if (message.paymentProvider != null && Object.hasOwnProperty.call(message, "paymentProvider"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.paymentProvider);
                    if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isActive);
                    if (message.subscriptionId != null && Object.hasOwnProperty.call(message, "subscriptionId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.subscriptionId);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessSubscriptionProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessSubscriptionProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSubscriptionProto} message BusinessSubscriptionProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSubscriptionProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessSubscriptionProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSubscriptionProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessSubscriptionProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.type = reader.int32();
                                break;
                            }
                        case 2: {
                                message.quantity = reader.int32();
                                break;
                            }
                        case 3: {
                                message.paymentProvider = reader.string();
                                break;
                            }
                        case 4: {
                                message.isActive = reader.bool();
                                break;
                            }
                        case 5: {
                                message.subscriptionId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessSubscriptionProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSubscriptionProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessSubscriptionProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessSubscriptionProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        if (!$util.isInteger(message.quantity))
                            return "quantity: integer expected";
                    if (message.paymentProvider != null && message.hasOwnProperty("paymentProvider"))
                        if (!$util.isString(message.paymentProvider))
                            return "paymentProvider: string expected";
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        if (typeof message.isActive !== "boolean")
                            return "isActive: boolean expected";
                    if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                        if (!$util.isString(message.subscriptionId))
                            return "subscriptionId: string expected";
                    return null;
                };

                /**
                 * Creates a BusinessSubscriptionProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessSubscriptionProto} BusinessSubscriptionProto
                 */
                BusinessSubscriptionProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessSubscriptionProto)
                        return object;
                    let message = new $root.space.kenko.proto.BusinessSubscriptionProto();
                    switch (object.type) {
                    default:
                        if (typeof object.type === "number") {
                            message.type = object.type;
                            break;
                        }
                        break;
                    case "SUBSCRIPTION_TYPE_UNKNOWN":
                    case 0:
                        message.type = 0;
                        break;
                    case "LISTING":
                    case 1:
                        message.type = 1;
                        break;
                    case "LISTING_PLUS_BOOKING":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.quantity != null)
                        message.quantity = object.quantity | 0;
                    if (object.paymentProvider != null)
                        message.paymentProvider = String(object.paymentProvider);
                    if (object.isActive != null)
                        message.isActive = Boolean(object.isActive);
                    if (object.subscriptionId != null)
                        message.subscriptionId = String(object.subscriptionId);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessSubscriptionProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {space.kenko.proto.BusinessSubscriptionProto} message BusinessSubscriptionProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessSubscriptionProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.type = options.enums === String ? "SUBSCRIPTION_TYPE_UNKNOWN" : 0;
                        object.quantity = 0;
                        object.paymentProvider = "";
                        object.isActive = false;
                        object.subscriptionId = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.space.kenko.proto.BusinessSubscriptionType[message.type] === undefined ? message.type : $root.space.kenko.proto.BusinessSubscriptionType[message.type] : message.type;
                    if (message.quantity != null && message.hasOwnProperty("quantity"))
                        object.quantity = message.quantity;
                    if (message.paymentProvider != null && message.hasOwnProperty("paymentProvider"))
                        object.paymentProvider = message.paymentProvider;
                    if (message.isActive != null && message.hasOwnProperty("isActive"))
                        object.isActive = message.isActive;
                    if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                        object.subscriptionId = message.subscriptionId;
                    return object;
                };

                /**
                 * Converts this BusinessSubscriptionProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessSubscriptionProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessSubscriptionProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessSubscriptionProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessSubscriptionProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessSubscriptionProto";
                };

                return BusinessSubscriptionProto;
            })();

            proto.ConnectedAccountStatusProto = (function() {

                /**
                 * Properties of a ConnectedAccountStatusProto.
                 * @memberof space.kenko.proto
                 * @interface IConnectedAccountStatusProto
                 * @property {boolean|null} [accountIsReady] ConnectedAccountStatusProto accountIsReady
                 * @property {boolean|null} [stripeChargesEnabled] ConnectedAccountStatusProto stripeChargesEnabled
                 * @property {boolean|null} [stripeDetailsSubmitted] ConnectedAccountStatusProto stripeDetailsSubmitted
                 */

                /**
                 * Constructs a new ConnectedAccountStatusProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ConnectedAccountStatusProto.
                 * @implements IConnectedAccountStatusProto
                 * @constructor
                 * @param {space.kenko.proto.IConnectedAccountStatusProto=} [properties] Properties to set
                 */
                function ConnectedAccountStatusProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ConnectedAccountStatusProto accountIsReady.
                 * @member {boolean} accountIsReady
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.accountIsReady = false;

                /**
                 * ConnectedAccountStatusProto stripeChargesEnabled.
                 * @member {boolean} stripeChargesEnabled
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.stripeChargesEnabled = false;

                /**
                 * ConnectedAccountStatusProto stripeDetailsSubmitted.
                 * @member {boolean} stripeDetailsSubmitted
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 */
                ConnectedAccountStatusProto.prototype.stripeDetailsSubmitted = false;

                /**
                 * Creates a new ConnectedAccountStatusProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto instance
                 */
                ConnectedAccountStatusProto.create = function create(properties) {
                    return new ConnectedAccountStatusProto(properties);
                };

                /**
                 * Encodes the specified ConnectedAccountStatusProto message. Does not implicitly {@link space.kenko.proto.ConnectedAccountStatusProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto} message ConnectedAccountStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectedAccountStatusProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.accountIsReady != null && Object.hasOwnProperty.call(message, "accountIsReady"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.accountIsReady);
                    if (message.stripeChargesEnabled != null && Object.hasOwnProperty.call(message, "stripeChargesEnabled"))
                        writer.uint32(/* id 100, wireType 0 =*/800).bool(message.stripeChargesEnabled);
                    if (message.stripeDetailsSubmitted != null && Object.hasOwnProperty.call(message, "stripeDetailsSubmitted"))
                        writer.uint32(/* id 101, wireType 0 =*/808).bool(message.stripeDetailsSubmitted);
                    return writer;
                };

                /**
                 * Encodes the specified ConnectedAccountStatusProto message, length delimited. Does not implicitly {@link space.kenko.proto.ConnectedAccountStatusProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.IConnectedAccountStatusProto} message ConnectedAccountStatusProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ConnectedAccountStatusProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ConnectedAccountStatusProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectedAccountStatusProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ConnectedAccountStatusProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.accountIsReady = reader.bool();
                                break;
                            }
                        case 100: {
                                message.stripeChargesEnabled = reader.bool();
                                break;
                            }
                        case 101: {
                                message.stripeDetailsSubmitted = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ConnectedAccountStatusProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ConnectedAccountStatusProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ConnectedAccountStatusProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ConnectedAccountStatusProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.accountIsReady != null && message.hasOwnProperty("accountIsReady"))
                        if (typeof message.accountIsReady !== "boolean")
                            return "accountIsReady: boolean expected";
                    if (message.stripeChargesEnabled != null && message.hasOwnProperty("stripeChargesEnabled"))
                        if (typeof message.stripeChargesEnabled !== "boolean")
                            return "stripeChargesEnabled: boolean expected";
                    if (message.stripeDetailsSubmitted != null && message.hasOwnProperty("stripeDetailsSubmitted"))
                        if (typeof message.stripeDetailsSubmitted !== "boolean")
                            return "stripeDetailsSubmitted: boolean expected";
                    return null;
                };

                /**
                 * Creates a ConnectedAccountStatusProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ConnectedAccountStatusProto} ConnectedAccountStatusProto
                 */
                ConnectedAccountStatusProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ConnectedAccountStatusProto)
                        return object;
                    let message = new $root.space.kenko.proto.ConnectedAccountStatusProto();
                    if (object.accountIsReady != null)
                        message.accountIsReady = Boolean(object.accountIsReady);
                    if (object.stripeChargesEnabled != null)
                        message.stripeChargesEnabled = Boolean(object.stripeChargesEnabled);
                    if (object.stripeDetailsSubmitted != null)
                        message.stripeDetailsSubmitted = Boolean(object.stripeDetailsSubmitted);
                    return message;
                };

                /**
                 * Creates a plain object from a ConnectedAccountStatusProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {space.kenko.proto.ConnectedAccountStatusProto} message ConnectedAccountStatusProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ConnectedAccountStatusProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.accountIsReady = false;
                        object.stripeChargesEnabled = false;
                        object.stripeDetailsSubmitted = false;
                    }
                    if (message.accountIsReady != null && message.hasOwnProperty("accountIsReady"))
                        object.accountIsReady = message.accountIsReady;
                    if (message.stripeChargesEnabled != null && message.hasOwnProperty("stripeChargesEnabled"))
                        object.stripeChargesEnabled = message.stripeChargesEnabled;
                    if (message.stripeDetailsSubmitted != null && message.hasOwnProperty("stripeDetailsSubmitted"))
                        object.stripeDetailsSubmitted = message.stripeDetailsSubmitted;
                    return object;
                };

                /**
                 * Converts this ConnectedAccountStatusProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ConnectedAccountStatusProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ConnectedAccountStatusProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ConnectedAccountStatusProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ConnectedAccountStatusProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ConnectedAccountStatusProto";
                };

                return ConnectedAccountStatusProto;
            })();

            proto.BusinessSettingsProto = (function() {

                /**
                 * Properties of a BusinessSettingsProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessSettingsProto
                 * @property {boolean|null} [offersClasses] BusinessSettingsProto offersClasses
                 * @property {boolean|null} [offersAppointments] BusinessSettingsProto offersAppointments
                 * @property {boolean|null} [offersVirtualServices] BusinessSettingsProto offersVirtualServices
                 * @property {boolean|null} [offersInPersonServices] BusinessSettingsProto offersInPersonServices
                 * @property {boolean|null} [newClientsMustInquire] BusinessSettingsProto newClientsMustInquire
                 */

                /**
                 * Constructs a new BusinessSettingsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessSettingsProto.
                 * @implements IBusinessSettingsProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessSettingsProto=} [properties] Properties to set
                 */
                function BusinessSettingsProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessSettingsProto offersClasses.
                 * @member {boolean} offersClasses
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersClasses = false;

                /**
                 * BusinessSettingsProto offersAppointments.
                 * @member {boolean} offersAppointments
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersAppointments = false;

                /**
                 * BusinessSettingsProto offersVirtualServices.
                 * @member {boolean} offersVirtualServices
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersVirtualServices = false;

                /**
                 * BusinessSettingsProto offersInPersonServices.
                 * @member {boolean} offersInPersonServices
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.offersInPersonServices = false;

                /**
                 * BusinessSettingsProto newClientsMustInquire.
                 * @member {boolean} newClientsMustInquire
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 */
                BusinessSettingsProto.prototype.newClientsMustInquire = false;

                /**
                 * Creates a new BusinessSettingsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto instance
                 */
                BusinessSettingsProto.create = function create(properties) {
                    return new BusinessSettingsProto(properties);
                };

                /**
                 * Encodes the specified BusinessSettingsProto message. Does not implicitly {@link space.kenko.proto.BusinessSettingsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto} message BusinessSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSettingsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.offersClasses != null && Object.hasOwnProperty.call(message, "offersClasses"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.offersClasses);
                    if (message.offersAppointments != null && Object.hasOwnProperty.call(message, "offersAppointments"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.offersAppointments);
                    if (message.offersVirtualServices != null && Object.hasOwnProperty.call(message, "offersVirtualServices"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.offersVirtualServices);
                    if (message.offersInPersonServices != null && Object.hasOwnProperty.call(message, "offersInPersonServices"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.offersInPersonServices);
                    if (message.newClientsMustInquire != null && Object.hasOwnProperty.call(message, "newClientsMustInquire"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.newClientsMustInquire);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessSettingsProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessSettingsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.IBusinessSettingsProto} message BusinessSettingsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessSettingsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessSettingsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSettingsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessSettingsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.offersClasses = reader.bool();
                                break;
                            }
                        case 2: {
                                message.offersAppointments = reader.bool();
                                break;
                            }
                        case 3: {
                                message.offersVirtualServices = reader.bool();
                                break;
                            }
                        case 4: {
                                message.offersInPersonServices = reader.bool();
                                break;
                            }
                        case 10: {
                                message.newClientsMustInquire = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessSettingsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessSettingsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessSettingsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessSettingsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
                        if (typeof message.offersClasses !== "boolean")
                            return "offersClasses: boolean expected";
                    if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
                        if (typeof message.offersAppointments !== "boolean")
                            return "offersAppointments: boolean expected";
                    if (message.offersVirtualServices != null && message.hasOwnProperty("offersVirtualServices"))
                        if (typeof message.offersVirtualServices !== "boolean")
                            return "offersVirtualServices: boolean expected";
                    if (message.offersInPersonServices != null && message.hasOwnProperty("offersInPersonServices"))
                        if (typeof message.offersInPersonServices !== "boolean")
                            return "offersInPersonServices: boolean expected";
                    if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
                        if (typeof message.newClientsMustInquire !== "boolean")
                            return "newClientsMustInquire: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessSettingsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessSettingsProto} BusinessSettingsProto
                 */
                BusinessSettingsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessSettingsProto)
                        return object;
                    let message = new $root.space.kenko.proto.BusinessSettingsProto();
                    if (object.offersClasses != null)
                        message.offersClasses = Boolean(object.offersClasses);
                    if (object.offersAppointments != null)
                        message.offersAppointments = Boolean(object.offersAppointments);
                    if (object.offersVirtualServices != null)
                        message.offersVirtualServices = Boolean(object.offersVirtualServices);
                    if (object.offersInPersonServices != null)
                        message.offersInPersonServices = Boolean(object.offersInPersonServices);
                    if (object.newClientsMustInquire != null)
                        message.newClientsMustInquire = Boolean(object.newClientsMustInquire);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessSettingsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {space.kenko.proto.BusinessSettingsProto} message BusinessSettingsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessSettingsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.offersClasses = false;
                        object.offersAppointments = false;
                        object.offersVirtualServices = false;
                        object.offersInPersonServices = false;
                        object.newClientsMustInquire = false;
                    }
                    if (message.offersClasses != null && message.hasOwnProperty("offersClasses"))
                        object.offersClasses = message.offersClasses;
                    if (message.offersAppointments != null && message.hasOwnProperty("offersAppointments"))
                        object.offersAppointments = message.offersAppointments;
                    if (message.offersVirtualServices != null && message.hasOwnProperty("offersVirtualServices"))
                        object.offersVirtualServices = message.offersVirtualServices;
                    if (message.offersInPersonServices != null && message.hasOwnProperty("offersInPersonServices"))
                        object.offersInPersonServices = message.offersInPersonServices;
                    if (message.newClientsMustInquire != null && message.hasOwnProperty("newClientsMustInquire"))
                        object.newClientsMustInquire = message.newClientsMustInquire;
                    return object;
                };

                /**
                 * Converts this BusinessSettingsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessSettingsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessSettingsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessSettingsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessSettingsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessSettingsProto";
                };

                return BusinessSettingsProto;
            })();

            proto.BusinessOnboardingStateProto = (function() {

                /**
                 * Properties of a BusinessOnboardingStateProto.
                 * @memberof space.kenko.proto
                 * @interface IBusinessOnboardingStateProto
                 * @property {boolean|null} [createdFirstCalendarAppt] BusinessOnboardingStateProto createdFirstCalendarAppt
                 */

                /**
                 * Constructs a new BusinessOnboardingStateProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BusinessOnboardingStateProto.
                 * @implements IBusinessOnboardingStateProto
                 * @constructor
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto=} [properties] Properties to set
                 */
                function BusinessOnboardingStateProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BusinessOnboardingStateProto createdFirstCalendarAppt.
                 * @member {boolean} createdFirstCalendarAppt
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @instance
                 */
                BusinessOnboardingStateProto.prototype.createdFirstCalendarAppt = false;

                /**
                 * Creates a new BusinessOnboardingStateProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto instance
                 */
                BusinessOnboardingStateProto.create = function create(properties) {
                    return new BusinessOnboardingStateProto(properties);
                };

                /**
                 * Encodes the specified BusinessOnboardingStateProto message. Does not implicitly {@link space.kenko.proto.BusinessOnboardingStateProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto} message BusinessOnboardingStateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessOnboardingStateProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.createdFirstCalendarAppt != null && Object.hasOwnProperty.call(message, "createdFirstCalendarAppt"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.createdFirstCalendarAppt);
                    return writer;
                };

                /**
                 * Encodes the specified BusinessOnboardingStateProto message, length delimited. Does not implicitly {@link space.kenko.proto.BusinessOnboardingStateProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.IBusinessOnboardingStateProto} message BusinessOnboardingStateProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BusinessOnboardingStateProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BusinessOnboardingStateProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessOnboardingStateProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BusinessOnboardingStateProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.createdFirstCalendarAppt = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BusinessOnboardingStateProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BusinessOnboardingStateProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BusinessOnboardingStateProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BusinessOnboardingStateProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.createdFirstCalendarAppt != null && message.hasOwnProperty("createdFirstCalendarAppt"))
                        if (typeof message.createdFirstCalendarAppt !== "boolean")
                            return "createdFirstCalendarAppt: boolean expected";
                    return null;
                };

                /**
                 * Creates a BusinessOnboardingStateProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BusinessOnboardingStateProto} BusinessOnboardingStateProto
                 */
                BusinessOnboardingStateProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BusinessOnboardingStateProto)
                        return object;
                    let message = new $root.space.kenko.proto.BusinessOnboardingStateProto();
                    if (object.createdFirstCalendarAppt != null)
                        message.createdFirstCalendarAppt = Boolean(object.createdFirstCalendarAppt);
                    return message;
                };

                /**
                 * Creates a plain object from a BusinessOnboardingStateProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {space.kenko.proto.BusinessOnboardingStateProto} message BusinessOnboardingStateProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BusinessOnboardingStateProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.createdFirstCalendarAppt = false;
                    if (message.createdFirstCalendarAppt != null && message.hasOwnProperty("createdFirstCalendarAppt"))
                        object.createdFirstCalendarAppt = message.createdFirstCalendarAppt;
                    return object;
                };

                /**
                 * Converts this BusinessOnboardingStateProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BusinessOnboardingStateProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BusinessOnboardingStateProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BusinessOnboardingStateProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BusinessOnboardingStateProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BusinessOnboardingStateProto";
                };

                return BusinessOnboardingStateProto;
            })();

            proto.PaymentPolicyProto = (function() {

                /**
                 * Properties of a PaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPaymentPolicyProto
                 * @property {space.kenko.proto.IPrepaidPaymentPolicyProto|null} [prepaid] PaymentPolicyProto prepaid
                 * @property {space.kenko.proto.IPostpaidPaymentPolicyProto|null} [postpaid] PaymentPolicyProto postpaid
                 */

                /**
                 * Constructs a new PaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PaymentPolicyProto.
                 * @implements IPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPaymentPolicyProto=} [properties] Properties to set
                 */
                function PaymentPolicyProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PaymentPolicyProto prepaid.
                 * @member {space.kenko.proto.IPrepaidPaymentPolicyProto|null|undefined} prepaid
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                PaymentPolicyProto.prototype.prepaid = null;

                /**
                 * PaymentPolicyProto postpaid.
                 * @member {space.kenko.proto.IPostpaidPaymentPolicyProto|null|undefined} postpaid
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                PaymentPolicyProto.prototype.postpaid = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * PaymentPolicyProto PaymentPolicy.
                 * @member {"prepaid"|"postpaid"|undefined} PaymentPolicy
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 */
                Object.defineProperty(PaymentPolicyProto.prototype, "PaymentPolicy", {
                    get: $util.oneOfGetter($oneOfFields = ["prepaid", "postpaid"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new PaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto instance
                 */
                PaymentPolicyProto.create = function create(properties) {
                    return new PaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto} message PaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prepaid != null && Object.hasOwnProperty.call(message, "prepaid"))
                        $root.space.kenko.proto.PrepaidPaymentPolicyProto.encode(message.prepaid, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.postpaid != null && Object.hasOwnProperty.call(message, "postpaid"))
                        $root.space.kenko.proto.PostpaidPaymentPolicyProto.encode(message.postpaid, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPaymentPolicyProto} message PaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PaymentPolicyProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.prepaid != null && message.hasOwnProperty("prepaid")) {
                        properties.PaymentPolicy = 1;
                        {
                            let error = $root.space.kenko.proto.PrepaidPaymentPolicyProto.verify(message.prepaid);
                            if (error)
                                return "prepaid." + error;
                        }
                    }
                    if (message.postpaid != null && message.hasOwnProperty("postpaid")) {
                        if (properties.PaymentPolicy === 1)
                            return "PaymentPolicy: multiple values";
                        properties.PaymentPolicy = 1;
                        {
                            let error = $root.space.kenko.proto.PostpaidPaymentPolicyProto.verify(message.postpaid);
                            if (error)
                                return "postpaid." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PaymentPolicyProto} PaymentPolicyProto
                 */
                PaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PaymentPolicyProto)
                        return object;
                    let message = new $root.space.kenko.proto.PaymentPolicyProto();
                    if (object.prepaid != null) {
                        if (typeof object.prepaid !== "object")
                            throw TypeError(".space.kenko.proto.PaymentPolicyProto.prepaid: object expected");
                        message.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.fromObject(object.prepaid);
                    }
                    if (object.postpaid != null) {
                        if (typeof object.postpaid !== "object")
                            throw TypeError(".space.kenko.proto.PaymentPolicyProto.postpaid: object expected");
                        message.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.fromObject(object.postpaid);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PaymentPolicyProto} message PaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.prepaid != null && message.hasOwnProperty("prepaid")) {
                        object.prepaid = $root.space.kenko.proto.PrepaidPaymentPolicyProto.toObject(message.prepaid, options);
                        if (options.oneofs)
                            object.PaymentPolicy = "prepaid";
                    }
                    if (message.postpaid != null && message.hasOwnProperty("postpaid")) {
                        object.postpaid = $root.space.kenko.proto.PostpaidPaymentPolicyProto.toObject(message.postpaid, options);
                        if (options.oneofs)
                            object.PaymentPolicy = "postpaid";
                    }
                    return object;
                };

                /**
                 * Converts this PaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PaymentPolicyProto";
                };

                return PaymentPolicyProto;
            })();

            proto.PrepaidPaymentPolicyProto = (function() {

                /**
                 * Properties of a PrepaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPrepaidPaymentPolicyProto
                 * @property {string|null} [priceCategoryId] PrepaidPaymentPolicyProto priceCategoryId
                 * @property {space.kenko.proto.IPriceProto|null} [price] PrepaidPaymentPolicyProto price
                 */

                /**
                 * Constructs a new PrepaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PrepaidPaymentPolicyProto.
                 * @implements IPrepaidPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto=} [properties] Properties to set
                 */
                function PrepaidPaymentPolicyProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PrepaidPaymentPolicyProto priceCategoryId.
                 * @member {string} priceCategoryId
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 */
                PrepaidPaymentPolicyProto.prototype.priceCategoryId = "";

                /**
                 * PrepaidPaymentPolicyProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 */
                PrepaidPaymentPolicyProto.prototype.price = null;

                /**
                 * Creates a new PrepaidPaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto instance
                 */
                PrepaidPaymentPolicyProto.create = function create(properties) {
                    return new PrepaidPaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PrepaidPaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PrepaidPaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PrepaidPaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.priceCategoryId != null && Object.hasOwnProperty.call(message, "priceCategoryId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.priceCategoryId);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PrepaidPaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PrepaidPaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PrepaidPaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PrepaidPaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PrepaidPaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PrepaidPaymentPolicyProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.priceCategoryId = reader.string();
                                break;
                            }
                        case 2: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PrepaidPaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PrepaidPaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PrepaidPaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PrepaidPaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.priceCategoryId != null && message.hasOwnProperty("priceCategoryId"))
                        if (!$util.isString(message.priceCategoryId))
                            return "priceCategoryId: string expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        let error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PrepaidPaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PrepaidPaymentPolicyProto} PrepaidPaymentPolicyProto
                 */
                PrepaidPaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PrepaidPaymentPolicyProto)
                        return object;
                    let message = new $root.space.kenko.proto.PrepaidPaymentPolicyProto();
                    if (object.priceCategoryId != null)
                        message.priceCategoryId = String(object.priceCategoryId);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PrepaidPaymentPolicyProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PrepaidPaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PrepaidPaymentPolicyProto} message PrepaidPaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PrepaidPaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.priceCategoryId = "";
                        object.price = null;
                    }
                    if (message.priceCategoryId != null && message.hasOwnProperty("priceCategoryId"))
                        object.priceCategoryId = message.priceCategoryId;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PrepaidPaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PrepaidPaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PrepaidPaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PrepaidPaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PrepaidPaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PrepaidPaymentPolicyProto";
                };

                return PrepaidPaymentPolicyProto;
            })();

            proto.PostpaidPaymentPolicyProto = (function() {

                /**
                 * Properties of a PostpaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @interface IPostpaidPaymentPolicyProto
                 * @property {space.kenko.proto.IPriceProto|null} [price] PostpaidPaymentPolicyProto price
                 */

                /**
                 * Constructs a new PostpaidPaymentPolicyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PostpaidPaymentPolicyProto.
                 * @implements IPostpaidPaymentPolicyProto
                 * @constructor
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto=} [properties] Properties to set
                 */
                function PostpaidPaymentPolicyProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PostpaidPaymentPolicyProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @instance
                 */
                PostpaidPaymentPolicyProto.prototype.price = null;

                /**
                 * Creates a new PostpaidPaymentPolicyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto instance
                 */
                PostpaidPaymentPolicyProto.create = function create(properties) {
                    return new PostpaidPaymentPolicyProto(properties);
                };

                /**
                 * Encodes the specified PostpaidPaymentPolicyProto message. Does not implicitly {@link space.kenko.proto.PostpaidPaymentPolicyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidPaymentPolicyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PostpaidPaymentPolicyProto message, length delimited. Does not implicitly {@link space.kenko.proto.PostpaidPaymentPolicyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidPaymentPolicyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PostpaidPaymentPolicyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidPaymentPolicyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PostpaidPaymentPolicyProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PostpaidPaymentPolicyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidPaymentPolicyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PostpaidPaymentPolicyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PostpaidPaymentPolicyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        let error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PostpaidPaymentPolicyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PostpaidPaymentPolicyProto} PostpaidPaymentPolicyProto
                 */
                PostpaidPaymentPolicyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PostpaidPaymentPolicyProto)
                        return object;
                    let message = new $root.space.kenko.proto.PostpaidPaymentPolicyProto();
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PostpaidPaymentPolicyProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PostpaidPaymentPolicyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {space.kenko.proto.PostpaidPaymentPolicyProto} message PostpaidPaymentPolicyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PostpaidPaymentPolicyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.price = null;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PostpaidPaymentPolicyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PostpaidPaymentPolicyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PostpaidPaymentPolicyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PostpaidPaymentPolicyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PostpaidPaymentPolicyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PostpaidPaymentPolicyProto";
                };

                return PostpaidPaymentPolicyProto;
            })();

            proto.ApiPaymentProto = (function() {

                /**
                 * Properties of an ApiPaymentProto.
                 * @memberof space.kenko.proto
                 * @interface IApiPaymentProto
                 * @property {string|null} [paymentId] ApiPaymentProto paymentId
                 * @property {string|null} [userId] ApiPaymentProto userId
                 * @property {string|null} [userName] ApiPaymentProto userName
                 * @property {string|null} [businessId] ApiPaymentProto businessId
                 * @property {space.kenko.proto.IPriceProto|null} [price] ApiPaymentProto price
                 * @property {number|Long|null} [createdTimestampMs] ApiPaymentProto createdTimestampMs
                 * @property {string|null} [status] ApiPaymentProto status
                 * @property {string|null} [purchasedThingName] ApiPaymentProto purchasedThingName
                 */

                /**
                 * Constructs a new ApiPaymentProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ApiPaymentProto.
                 * @implements IApiPaymentProto
                 * @constructor
                 * @param {space.kenko.proto.IApiPaymentProto=} [properties] Properties to set
                 */
                function ApiPaymentProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ApiPaymentProto paymentId.
                 * @member {string} paymentId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.paymentId = "";

                /**
                 * ApiPaymentProto userId.
                 * @member {string} userId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.userId = "";

                /**
                 * ApiPaymentProto userName.
                 * @member {string} userName
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.userName = "";

                /**
                 * ApiPaymentProto businessId.
                 * @member {string} businessId
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.businessId = "";

                /**
                 * ApiPaymentProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.price = null;

                /**
                 * ApiPaymentProto createdTimestampMs.
                 * @member {number|Long} createdTimestampMs
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.createdTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ApiPaymentProto status.
                 * @member {string} status
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.status = "";

                /**
                 * ApiPaymentProto purchasedThingName.
                 * @member {string} purchasedThingName
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 */
                ApiPaymentProto.prototype.purchasedThingName = "";

                /**
                 * Creates a new ApiPaymentProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto instance
                 */
                ApiPaymentProto.create = function create(properties) {
                    return new ApiPaymentProto(properties);
                };

                /**
                 * Encodes the specified ApiPaymentProto message. Does not implicitly {@link space.kenko.proto.ApiPaymentProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto} message ApiPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiPaymentProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.paymentId != null && Object.hasOwnProperty.call(message, "paymentId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.paymentId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                    if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.userName);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.businessId);
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.createdTimestampMs != null && Object.hasOwnProperty.call(message, "createdTimestampMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdTimestampMs);
                    if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.status);
                    if (message.purchasedThingName != null && Object.hasOwnProperty.call(message, "purchasedThingName"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.purchasedThingName);
                    return writer;
                };

                /**
                 * Encodes the specified ApiPaymentProto message, length delimited. Does not implicitly {@link space.kenko.proto.ApiPaymentProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.IApiPaymentProto} message ApiPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiPaymentProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ApiPaymentProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiPaymentProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ApiPaymentProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.paymentId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userId = reader.string();
                                break;
                            }
                        case 3: {
                                message.userName = reader.string();
                                break;
                            }
                        case 4: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 5: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 6: {
                                message.createdTimestampMs = reader.int64();
                                break;
                            }
                        case 7: {
                                message.status = reader.string();
                                break;
                            }
                        case 8: {
                                message.purchasedThingName = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ApiPaymentProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiPaymentProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ApiPaymentProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ApiPaymentProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        if (!$util.isString(message.paymentId))
                            return "paymentId: string expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.userName != null && message.hasOwnProperty("userName"))
                        if (!$util.isString(message.userName))
                            return "userName: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        let error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
                        if (!$util.isInteger(message.createdTimestampMs) && !(message.createdTimestampMs && $util.isInteger(message.createdTimestampMs.low) && $util.isInteger(message.createdTimestampMs.high)))
                            return "createdTimestampMs: integer|Long expected";
                    if (message.status != null && message.hasOwnProperty("status"))
                        if (!$util.isString(message.status))
                            return "status: string expected";
                    if (message.purchasedThingName != null && message.hasOwnProperty("purchasedThingName"))
                        if (!$util.isString(message.purchasedThingName))
                            return "purchasedThingName: string expected";
                    return null;
                };

                /**
                 * Creates an ApiPaymentProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ApiPaymentProto} ApiPaymentProto
                 */
                ApiPaymentProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ApiPaymentProto)
                        return object;
                    let message = new $root.space.kenko.proto.ApiPaymentProto();
                    if (object.paymentId != null)
                        message.paymentId = String(object.paymentId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.userName != null)
                        message.userName = String(object.userName);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.ApiPaymentProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    if (object.createdTimestampMs != null)
                        if ($util.Long)
                            (message.createdTimestampMs = $util.Long.fromValue(object.createdTimestampMs)).unsigned = false;
                        else if (typeof object.createdTimestampMs === "string")
                            message.createdTimestampMs = parseInt(object.createdTimestampMs, 10);
                        else if (typeof object.createdTimestampMs === "number")
                            message.createdTimestampMs = object.createdTimestampMs;
                        else if (typeof object.createdTimestampMs === "object")
                            message.createdTimestampMs = new $util.LongBits(object.createdTimestampMs.low >>> 0, object.createdTimestampMs.high >>> 0).toNumber();
                    if (object.status != null)
                        message.status = String(object.status);
                    if (object.purchasedThingName != null)
                        message.purchasedThingName = String(object.purchasedThingName);
                    return message;
                };

                /**
                 * Creates a plain object from an ApiPaymentProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {space.kenko.proto.ApiPaymentProto} message ApiPaymentProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ApiPaymentProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.paymentId = "";
                        object.userId = "";
                        object.userName = "";
                        object.businessId = "";
                        object.price = null;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.createdTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createdTimestampMs = options.longs === String ? "0" : 0;
                        object.status = "";
                        object.purchasedThingName = "";
                    }
                    if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                        object.paymentId = message.paymentId;
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.userName != null && message.hasOwnProperty("userName"))
                        object.userName = message.userName;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    if (message.createdTimestampMs != null && message.hasOwnProperty("createdTimestampMs"))
                        if (typeof message.createdTimestampMs === "number")
                            object.createdTimestampMs = options.longs === String ? String(message.createdTimestampMs) : message.createdTimestampMs;
                        else
                            object.createdTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimestampMs) : options.longs === Number ? new $util.LongBits(message.createdTimestampMs.low >>> 0, message.createdTimestampMs.high >>> 0).toNumber() : message.createdTimestampMs;
                    if (message.status != null && message.hasOwnProperty("status"))
                        object.status = message.status;
                    if (message.purchasedThingName != null && message.hasOwnProperty("purchasedThingName"))
                        object.purchasedThingName = message.purchasedThingName;
                    return object;
                };

                /**
                 * Converts this ApiPaymentProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ApiPaymentProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ApiPaymentProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ApiPaymentProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ApiPaymentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ApiPaymentProto";
                };

                return ApiPaymentProto;
            })();

            proto.ProviderSurveyProto = (function() {

                /**
                 * Properties of a ProviderSurveyProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderSurveyProto
                 * @property {string|null} [businessName] ProviderSurveyProto businessName
                 * @property {Array.<space.kenko.proto.SurveySessionType>|null} [sessionTypes] ProviderSurveyProto sessionTypes
                 * @property {string|null} [surveyCompletedByProviderId] ProviderSurveyProto surveyCompletedByProviderId
                 * @property {space.kenko.proto.SurveyCurrentBookingPlatform|null} [currentBookingPlatform] ProviderSurveyProto currentBookingPlatform
                 * @property {space.kenko.proto.BusinessSubscriptionType|null} [chosenSubscription] ProviderSurveyProto chosenSubscription
                 * @property {number|null} [numLocations] ProviderSurveyProto numLocations
                 * @property {number|null} [numPractitioners] ProviderSurveyProto numPractitioners
                 * @property {space.kenko.proto.SurveyVirtualServices|null} [virtualServices] ProviderSurveyProto virtualServices
                 */

                /**
                 * Constructs a new ProviderSurveyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderSurveyProto.
                 * @implements IProviderSurveyProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderSurveyProto=} [properties] Properties to set
                 */
                function ProviderSurveyProto(properties) {
                    this.sessionTypes = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderSurveyProto businessName.
                 * @member {string} businessName
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.businessName = "";

                /**
                 * ProviderSurveyProto sessionTypes.
                 * @member {Array.<space.kenko.proto.SurveySessionType>} sessionTypes
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.sessionTypes = $util.emptyArray;

                /**
                 * ProviderSurveyProto surveyCompletedByProviderId.
                 * @member {string} surveyCompletedByProviderId
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.surveyCompletedByProviderId = "";

                /**
                 * ProviderSurveyProto currentBookingPlatform.
                 * @member {space.kenko.proto.SurveyCurrentBookingPlatform} currentBookingPlatform
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.currentBookingPlatform = 0;

                /**
                 * ProviderSurveyProto chosenSubscription.
                 * @member {space.kenko.proto.BusinessSubscriptionType} chosenSubscription
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.chosenSubscription = 0;

                /**
                 * ProviderSurveyProto numLocations.
                 * @member {number} numLocations
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.numLocations = 0;

                /**
                 * ProviderSurveyProto numPractitioners.
                 * @member {number} numPractitioners
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.numPractitioners = 0;

                /**
                 * ProviderSurveyProto virtualServices.
                 * @member {space.kenko.proto.SurveyVirtualServices} virtualServices
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 */
                ProviderSurveyProto.prototype.virtualServices = 0;

                /**
                 * Creates a new ProviderSurveyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.IProviderSurveyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto instance
                 */
                ProviderSurveyProto.create = function create(properties) {
                    return new ProviderSurveyProto(properties);
                };

                /**
                 * Encodes the specified ProviderSurveyProto message. Does not implicitly {@link space.kenko.proto.ProviderSurveyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.IProviderSurveyProto} message ProviderSurveyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderSurveyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessName);
                    if (message.sessionTypes != null && message.sessionTypes.length) {
                        writer.uint32(/* id 11, wireType 2 =*/90).fork();
                        for (let i = 0; i < message.sessionTypes.length; ++i)
                            writer.int32(message.sessionTypes[i]);
                        writer.ldelim();
                    }
                    if (message.surveyCompletedByProviderId != null && Object.hasOwnProperty.call(message, "surveyCompletedByProviderId"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.surveyCompletedByProviderId);
                    if (message.currentBookingPlatform != null && Object.hasOwnProperty.call(message, "currentBookingPlatform"))
                        writer.uint32(/* id 21, wireType 0 =*/168).int32(message.currentBookingPlatform);
                    if (message.chosenSubscription != null && Object.hasOwnProperty.call(message, "chosenSubscription"))
                        writer.uint32(/* id 24, wireType 0 =*/192).int32(message.chosenSubscription);
                    if (message.numLocations != null && Object.hasOwnProperty.call(message, "numLocations"))
                        writer.uint32(/* id 25, wireType 0 =*/200).int32(message.numLocations);
                    if (message.numPractitioners != null && Object.hasOwnProperty.call(message, "numPractitioners"))
                        writer.uint32(/* id 26, wireType 0 =*/208).int32(message.numPractitioners);
                    if (message.virtualServices != null && Object.hasOwnProperty.call(message, "virtualServices"))
                        writer.uint32(/* id 27, wireType 0 =*/216).int32(message.virtualServices);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderSurveyProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderSurveyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.IProviderSurveyProto} message ProviderSurveyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderSurveyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderSurveyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderSurveyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderSurveyProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.businessName = reader.string();
                                break;
                            }
                        case 11: {
                                if (!(message.sessionTypes && message.sessionTypes.length))
                                    message.sessionTypes = [];
                                if ((tag & 7) === 2) {
                                    let end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.sessionTypes.push(reader.int32());
                                } else
                                    message.sessionTypes.push(reader.int32());
                                break;
                            }
                        case 14: {
                                message.surveyCompletedByProviderId = reader.string();
                                break;
                            }
                        case 21: {
                                message.currentBookingPlatform = reader.int32();
                                break;
                            }
                        case 24: {
                                message.chosenSubscription = reader.int32();
                                break;
                            }
                        case 25: {
                                message.numLocations = reader.int32();
                                break;
                            }
                        case 26: {
                                message.numPractitioners = reader.int32();
                                break;
                            }
                        case 27: {
                                message.virtualServices = reader.int32();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderSurveyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderSurveyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderSurveyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderSurveyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        if (!$util.isString(message.businessName))
                            return "businessName: string expected";
                    if (message.sessionTypes != null && message.hasOwnProperty("sessionTypes")) {
                        if (!Array.isArray(message.sessionTypes))
                            return "sessionTypes: array expected";
                        for (let i = 0; i < message.sessionTypes.length; ++i)
                            switch (message.sessionTypes[i]) {
                            default:
                                return "sessionTypes: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                    }
                    if (message.surveyCompletedByProviderId != null && message.hasOwnProperty("surveyCompletedByProviderId"))
                        if (!$util.isString(message.surveyCompletedByProviderId))
                            return "surveyCompletedByProviderId: string expected";
                    if (message.currentBookingPlatform != null && message.hasOwnProperty("currentBookingPlatform"))
                        switch (message.currentBookingPlatform) {
                        default:
                            return "currentBookingPlatform: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.chosenSubscription != null && message.hasOwnProperty("chosenSubscription"))
                        switch (message.chosenSubscription) {
                        default:
                            return "chosenSubscription: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.numLocations != null && message.hasOwnProperty("numLocations"))
                        if (!$util.isInteger(message.numLocations))
                            return "numLocations: integer expected";
                    if (message.numPractitioners != null && message.hasOwnProperty("numPractitioners"))
                        if (!$util.isInteger(message.numPractitioners))
                            return "numPractitioners: integer expected";
                    if (message.virtualServices != null && message.hasOwnProperty("virtualServices"))
                        switch (message.virtualServices) {
                        default:
                            return "virtualServices: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a ProviderSurveyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderSurveyProto} ProviderSurveyProto
                 */
                ProviderSurveyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderSurveyProto)
                        return object;
                    let message = new $root.space.kenko.proto.ProviderSurveyProto();
                    if (object.businessName != null)
                        message.businessName = String(object.businessName);
                    if (object.sessionTypes) {
                        if (!Array.isArray(object.sessionTypes))
                            throw TypeError(".space.kenko.proto.ProviderSurveyProto.sessionTypes: array expected");
                        message.sessionTypes = [];
                        for (let i = 0; i < object.sessionTypes.length; ++i)
                            switch (object.sessionTypes[i]) {
                            default:
                                if (typeof object.sessionTypes[i] === "number") {
                                    message.sessionTypes[i] = object.sessionTypes[i];
                                    break;
                                }
                            case "SESSION_TYPE_UNKNOWN":
                            case 0:
                                message.sessionTypes[i] = 0;
                                break;
                            case "PRIVATE_SESSIONS":
                            case 1:
                                message.sessionTypes[i] = 1;
                                break;
                            case "SEMI_PRIVATE_SESSIONS":
                            case 2:
                                message.sessionTypes[i] = 2;
                                break;
                            case "GROUP_CLASSES":
                            case 3:
                                message.sessionTypes[i] = 3;
                                break;
                            case "EVENTS":
                            case 4:
                                message.sessionTypes[i] = 4;
                                break;
                            }
                    }
                    if (object.surveyCompletedByProviderId != null)
                        message.surveyCompletedByProviderId = String(object.surveyCompletedByProviderId);
                    switch (object.currentBookingPlatform) {
                    default:
                        if (typeof object.currentBookingPlatform === "number") {
                            message.currentBookingPlatform = object.currentBookingPlatform;
                            break;
                        }
                        break;
                    case "PLATFORM_UNKNOWN":
                    case 0:
                        message.currentBookingPlatform = 0;
                        break;
                    case "YES_AND_HAPPY":
                    case 1:
                        message.currentBookingPlatform = 1;
                        break;
                    case "YES_AND_OPEN":
                    case 2:
                        message.currentBookingPlatform = 2;
                        break;
                    case "NO_BUT_LOOKING":
                    case 3:
                        message.currentBookingPlatform = 3;
                        break;
                    case "NO_DONT_NEED":
                    case 4:
                        message.currentBookingPlatform = 4;
                        break;
                    }
                    switch (object.chosenSubscription) {
                    default:
                        if (typeof object.chosenSubscription === "number") {
                            message.chosenSubscription = object.chosenSubscription;
                            break;
                        }
                        break;
                    case "SUBSCRIPTION_TYPE_UNKNOWN":
                    case 0:
                        message.chosenSubscription = 0;
                        break;
                    case "LISTING":
                    case 1:
                        message.chosenSubscription = 1;
                        break;
                    case "LISTING_PLUS_BOOKING":
                    case 2:
                        message.chosenSubscription = 2;
                        break;
                    }
                    if (object.numLocations != null)
                        message.numLocations = object.numLocations | 0;
                    if (object.numPractitioners != null)
                        message.numPractitioners = object.numPractitioners | 0;
                    switch (object.virtualServices) {
                    default:
                        if (typeof object.virtualServices === "number") {
                            message.virtualServices = object.virtualServices;
                            break;
                        }
                        break;
                    case "VIRTUAL_UNKNOWN":
                    case 0:
                        message.virtualServices = 0;
                        break;
                    case "IN_PERSON_ONLY":
                    case 1:
                        message.virtualServices = 1;
                        break;
                    case "IN_PERSON_AND_VIRTUAL":
                    case 2:
                        message.virtualServices = 2;
                        break;
                    case "VIRTUAL_ONLY":
                    case 3:
                        message.virtualServices = 3;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderSurveyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {space.kenko.proto.ProviderSurveyProto} message ProviderSurveyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderSurveyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.sessionTypes = [];
                    if (options.defaults) {
                        object.businessName = "";
                        object.surveyCompletedByProviderId = "";
                        object.currentBookingPlatform = options.enums === String ? "PLATFORM_UNKNOWN" : 0;
                        object.chosenSubscription = options.enums === String ? "SUBSCRIPTION_TYPE_UNKNOWN" : 0;
                        object.numLocations = 0;
                        object.numPractitioners = 0;
                        object.virtualServices = options.enums === String ? "VIRTUAL_UNKNOWN" : 0;
                    }
                    if (message.businessName != null && message.hasOwnProperty("businessName"))
                        object.businessName = message.businessName;
                    if (message.sessionTypes && message.sessionTypes.length) {
                        object.sessionTypes = [];
                        for (let j = 0; j < message.sessionTypes.length; ++j)
                            object.sessionTypes[j] = options.enums === String ? $root.space.kenko.proto.SurveySessionType[message.sessionTypes[j]] === undefined ? message.sessionTypes[j] : $root.space.kenko.proto.SurveySessionType[message.sessionTypes[j]] : message.sessionTypes[j];
                    }
                    if (message.surveyCompletedByProviderId != null && message.hasOwnProperty("surveyCompletedByProviderId"))
                        object.surveyCompletedByProviderId = message.surveyCompletedByProviderId;
                    if (message.currentBookingPlatform != null && message.hasOwnProperty("currentBookingPlatform"))
                        object.currentBookingPlatform = options.enums === String ? $root.space.kenko.proto.SurveyCurrentBookingPlatform[message.currentBookingPlatform] === undefined ? message.currentBookingPlatform : $root.space.kenko.proto.SurveyCurrentBookingPlatform[message.currentBookingPlatform] : message.currentBookingPlatform;
                    if (message.chosenSubscription != null && message.hasOwnProperty("chosenSubscription"))
                        object.chosenSubscription = options.enums === String ? $root.space.kenko.proto.BusinessSubscriptionType[message.chosenSubscription] === undefined ? message.chosenSubscription : $root.space.kenko.proto.BusinessSubscriptionType[message.chosenSubscription] : message.chosenSubscription;
                    if (message.numLocations != null && message.hasOwnProperty("numLocations"))
                        object.numLocations = message.numLocations;
                    if (message.numPractitioners != null && message.hasOwnProperty("numPractitioners"))
                        object.numPractitioners = message.numPractitioners;
                    if (message.virtualServices != null && message.hasOwnProperty("virtualServices"))
                        object.virtualServices = options.enums === String ? $root.space.kenko.proto.SurveyVirtualServices[message.virtualServices] === undefined ? message.virtualServices : $root.space.kenko.proto.SurveyVirtualServices[message.virtualServices] : message.virtualServices;
                    return object;
                };

                /**
                 * Converts this ProviderSurveyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderSurveyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderSurveyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderSurveyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderSurveyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderSurveyProto";
                };

                return ProviderSurveyProto;
            })();

            /**
             * SurveyRole enum.
             * @name space.kenko.proto.SurveyRole
             * @enum {number}
             * @property {number} ROLE_UNKNOWN=0 ROLE_UNKNOWN value
             * @property {number} OFFICE_MANAGER_OR_STAFF=1 OFFICE_MANAGER_OR_STAFF value
             * @property {number} PRACTITIONER=2 PRACTITIONER value
             * @property {number} BUSINESS_OWNER_AND_PRACTITIONER=3 BUSINESS_OWNER_AND_PRACTITIONER value
             * @property {number} BUSINESS_OWNER_NON_PRACTITIONER=4 BUSINESS_OWNER_NON_PRACTITIONER value
             * @property {number} OTHER=5 OTHER value
             */
            proto.SurveyRole = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "ROLE_UNKNOWN"] = 0;
                values[valuesById[1] = "OFFICE_MANAGER_OR_STAFF"] = 1;
                values[valuesById[2] = "PRACTITIONER"] = 2;
                values[valuesById[3] = "BUSINESS_OWNER_AND_PRACTITIONER"] = 3;
                values[valuesById[4] = "BUSINESS_OWNER_NON_PRACTITIONER"] = 4;
                values[valuesById[5] = "OTHER"] = 5;
                return values;
            })();

            /**
             * SurveySessionType enum.
             * @name space.kenko.proto.SurveySessionType
             * @enum {number}
             * @property {number} SESSION_TYPE_UNKNOWN=0 SESSION_TYPE_UNKNOWN value
             * @property {number} PRIVATE_SESSIONS=1 PRIVATE_SESSIONS value
             * @property {number} SEMI_PRIVATE_SESSIONS=2 SEMI_PRIVATE_SESSIONS value
             * @property {number} GROUP_CLASSES=3 GROUP_CLASSES value
             * @property {number} EVENTS=4 EVENTS value
             */
            proto.SurveySessionType = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SESSION_TYPE_UNKNOWN"] = 0;
                values[valuesById[1] = "PRIVATE_SESSIONS"] = 1;
                values[valuesById[2] = "SEMI_PRIVATE_SESSIONS"] = 2;
                values[valuesById[3] = "GROUP_CLASSES"] = 3;
                values[valuesById[4] = "EVENTS"] = 4;
                return values;
            })();

            /**
             * SurveyApptLocations enum.
             * @name space.kenko.proto.SurveyApptLocations
             * @enum {number}
             * @property {number} APPT_LOCATION_UNKNOWN=0 APPT_LOCATION_UNKNOWN value
             * @property {number} IN_PERSON_AT_BUSINESS=1 IN_PERSON_AT_BUSINESS value
             * @property {number} VIRTUAL_APPOINTMENTS=2 VIRTUAL_APPOINTMENTS value
             * @property {number} IN_HOME_APPOINTMENTS=3 IN_HOME_APPOINTMENTS value
             */
            proto.SurveyApptLocations = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "APPT_LOCATION_UNKNOWN"] = 0;
                values[valuesById[1] = "IN_PERSON_AT_BUSINESS"] = 1;
                values[valuesById[2] = "VIRTUAL_APPOINTMENTS"] = 2;
                values[valuesById[3] = "IN_HOME_APPOINTMENTS"] = 3;
                return values;
            })();

            /**
             * SurveyPracticeYearsInOperation enum.
             * @name space.kenko.proto.SurveyPracticeYearsInOperation
             * @enum {number}
             * @property {number} YEARS_UNKNOWN=0 YEARS_UNKNOWN value
             * @property {number} LESS_THAN_1=1 LESS_THAN_1 value
             * @property {number} ONE_TO_THREE=2 ONE_TO_THREE value
             * @property {number} FOUR_TO_SEVEN=3 FOUR_TO_SEVEN value
             * @property {number} EIGHT_TO_TEN=4 EIGHT_TO_TEN value
             * @property {number} MORE_THAN_TEN=5 MORE_THAN_TEN value
             */
            proto.SurveyPracticeYearsInOperation = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "YEARS_UNKNOWN"] = 0;
                values[valuesById[1] = "LESS_THAN_1"] = 1;
                values[valuesById[2] = "ONE_TO_THREE"] = 2;
                values[valuesById[3] = "FOUR_TO_SEVEN"] = 3;
                values[valuesById[4] = "EIGHT_TO_TEN"] = 4;
                values[valuesById[5] = "MORE_THAN_TEN"] = 5;
                return values;
            })();

            /**
             * SurveyCurrentBookingPlatform enum.
             * @name space.kenko.proto.SurveyCurrentBookingPlatform
             * @enum {number}
             * @property {number} PLATFORM_UNKNOWN=0 PLATFORM_UNKNOWN value
             * @property {number} YES_AND_HAPPY=1 YES_AND_HAPPY value
             * @property {number} YES_AND_OPEN=2 YES_AND_OPEN value
             * @property {number} NO_BUT_LOOKING=3 NO_BUT_LOOKING value
             * @property {number} NO_DONT_NEED=4 NO_DONT_NEED value
             */
            proto.SurveyCurrentBookingPlatform = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "PLATFORM_UNKNOWN"] = 0;
                values[valuesById[1] = "YES_AND_HAPPY"] = 1;
                values[valuesById[2] = "YES_AND_OPEN"] = 2;
                values[valuesById[3] = "NO_BUT_LOOKING"] = 3;
                values[valuesById[4] = "NO_DONT_NEED"] = 4;
                return values;
            })();

            /**
             * SurveyTeamMembers enum.
             * @name space.kenko.proto.SurveyTeamMembers
             * @enum {number}
             * @property {number} TEAM_MEMBERS_UNKNOWN=0 TEAM_MEMBERS_UNKNOWN value
             * @property {number} SOLO_PRACTITIONER=1 SOLO_PRACTITIONER value
             * @property {number} TWO_TO_FIVE=2 TWO_TO_FIVE value
             * @property {number} SIX_TO_TEN=3 SIX_TO_TEN value
             * @property {number} ELEVEN_PLUS=4 ELEVEN_PLUS value
             */
            proto.SurveyTeamMembers = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TEAM_MEMBERS_UNKNOWN"] = 0;
                values[valuesById[1] = "SOLO_PRACTITIONER"] = 1;
                values[valuesById[2] = "TWO_TO_FIVE"] = 2;
                values[valuesById[3] = "SIX_TO_TEN"] = 3;
                values[valuesById[4] = "ELEVEN_PLUS"] = 4;
                return values;
            })();

            /**
             * SurveyVirtualServices enum.
             * @name space.kenko.proto.SurveyVirtualServices
             * @enum {number}
             * @property {number} VIRTUAL_UNKNOWN=0 VIRTUAL_UNKNOWN value
             * @property {number} IN_PERSON_ONLY=1 IN_PERSON_ONLY value
             * @property {number} IN_PERSON_AND_VIRTUAL=2 IN_PERSON_AND_VIRTUAL value
             * @property {number} VIRTUAL_ONLY=3 VIRTUAL_ONLY value
             */
            proto.SurveyVirtualServices = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "VIRTUAL_UNKNOWN"] = 0;
                values[valuesById[1] = "IN_PERSON_ONLY"] = 1;
                values[valuesById[2] = "IN_PERSON_AND_VIRTUAL"] = 2;
                values[valuesById[3] = "VIRTUAL_ONLY"] = 3;
                return values;
            })();

            proto.InvitationProtos = (function() {

                /**
                 * Properties of an InvitationProtos.
                 * @memberof space.kenko.proto
                 * @interface IInvitationProtos
                 * @property {Array.<space.kenko.proto.IInvitationProto>|null} [invitations] InvitationProtos invitations
                 */

                /**
                 * Constructs a new InvitationProtos.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an InvitationProtos.
                 * @implements IInvitationProtos
                 * @constructor
                 * @param {space.kenko.proto.IInvitationProtos=} [properties] Properties to set
                 */
                function InvitationProtos(properties) {
                    this.invitations = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * InvitationProtos invitations.
                 * @member {Array.<space.kenko.proto.IInvitationProto>} invitations
                 * @memberof space.kenko.proto.InvitationProtos
                 * @instance
                 */
                InvitationProtos.prototype.invitations = $util.emptyArray;

                /**
                 * Creates a new InvitationProtos instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.IInvitationProtos=} [properties] Properties to set
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos instance
                 */
                InvitationProtos.create = function create(properties) {
                    return new InvitationProtos(properties);
                };

                /**
                 * Encodes the specified InvitationProtos message. Does not implicitly {@link space.kenko.proto.InvitationProtos.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.IInvitationProtos} message InvitationProtos message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProtos.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.invitations != null && message.invitations.length)
                        for (let i = 0; i < message.invitations.length; ++i)
                            $root.space.kenko.proto.InvitationProto.encode(message.invitations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified InvitationProtos message, length delimited. Does not implicitly {@link space.kenko.proto.InvitationProtos.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.IInvitationProtos} message InvitationProtos message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProtos.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an InvitationProtos message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProtos.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.InvitationProtos();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                if (!(message.invitations && message.invitations.length))
                                    message.invitations = [];
                                message.invitations.push($root.space.kenko.proto.InvitationProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an InvitationProtos message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProtos.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an InvitationProtos message.
                 * @function verify
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                InvitationProtos.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.invitations != null && message.hasOwnProperty("invitations")) {
                        if (!Array.isArray(message.invitations))
                            return "invitations: array expected";
                        for (let i = 0; i < message.invitations.length; ++i) {
                            let error = $root.space.kenko.proto.InvitationProto.verify(message.invitations[i]);
                            if (error)
                                return "invitations." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an InvitationProtos message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.InvitationProtos} InvitationProtos
                 */
                InvitationProtos.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.InvitationProtos)
                        return object;
                    let message = new $root.space.kenko.proto.InvitationProtos();
                    if (object.invitations) {
                        if (!Array.isArray(object.invitations))
                            throw TypeError(".space.kenko.proto.InvitationProtos.invitations: array expected");
                        message.invitations = [];
                        for (let i = 0; i < object.invitations.length; ++i) {
                            if (typeof object.invitations[i] !== "object")
                                throw TypeError(".space.kenko.proto.InvitationProtos.invitations: object expected");
                            message.invitations[i] = $root.space.kenko.proto.InvitationProto.fromObject(object.invitations[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an InvitationProtos message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {space.kenko.proto.InvitationProtos} message InvitationProtos
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                InvitationProtos.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.invitations = [];
                    if (message.invitations && message.invitations.length) {
                        object.invitations = [];
                        for (let j = 0; j < message.invitations.length; ++j)
                            object.invitations[j] = $root.space.kenko.proto.InvitationProto.toObject(message.invitations[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this InvitationProtos to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.InvitationProtos
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                InvitationProtos.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for InvitationProtos
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.InvitationProtos
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                InvitationProtos.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.InvitationProtos";
                };

                return InvitationProtos;
            })();

            proto.InvitationProto = (function() {

                /**
                 * Properties of an InvitationProto.
                 * @memberof space.kenko.proto
                 * @interface IInvitationProto
                 * @property {string|null} [inviteCode] InvitationProto inviteCode
                 * @property {number|Long|null} [generatedTimestamp] InvitationProto generatedTimestamp
                 * @property {boolean|null} [alphaProviderAutoApprove] InvitationProto alphaProviderAutoApprove
                 */

                /**
                 * Constructs a new InvitationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an InvitationProto.
                 * @implements IInvitationProto
                 * @constructor
                 * @param {space.kenko.proto.IInvitationProto=} [properties] Properties to set
                 */
                function InvitationProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * InvitationProto inviteCode.
                 * @member {string} inviteCode
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 */
                InvitationProto.prototype.inviteCode = "";

                /**
                 * InvitationProto generatedTimestamp.
                 * @member {number|Long} generatedTimestamp
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 */
                InvitationProto.prototype.generatedTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * InvitationProto alphaProviderAutoApprove.
                 * @member {boolean} alphaProviderAutoApprove
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 */
                InvitationProto.prototype.alphaProviderAutoApprove = false;

                /**
                 * Creates a new InvitationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.IInvitationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto instance
                 */
                InvitationProto.create = function create(properties) {
                    return new InvitationProto(properties);
                };

                /**
                 * Encodes the specified InvitationProto message. Does not implicitly {@link space.kenko.proto.InvitationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.IInvitationProto} message InvitationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
                    if (message.generatedTimestamp != null && Object.hasOwnProperty.call(message, "generatedTimestamp"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.generatedTimestamp);
                    if (message.alphaProviderAutoApprove != null && Object.hasOwnProperty.call(message, "alphaProviderAutoApprove"))
                        writer.uint32(/* id 1000, wireType 0 =*/8000).bool(message.alphaProviderAutoApprove);
                    return writer;
                };

                /**
                 * Encodes the specified InvitationProto message, length delimited. Does not implicitly {@link space.kenko.proto.InvitationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.IInvitationProto} message InvitationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                InvitationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an InvitationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.InvitationProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.inviteCode = reader.string();
                                break;
                            }
                        case 2: {
                                message.generatedTimestamp = reader.int64();
                                break;
                            }
                        case 1000: {
                                message.alphaProviderAutoApprove = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an InvitationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                InvitationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an InvitationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                InvitationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
                        if (!$util.isString(message.inviteCode))
                            return "inviteCode: string expected";
                    if (message.generatedTimestamp != null && message.hasOwnProperty("generatedTimestamp"))
                        if (!$util.isInteger(message.generatedTimestamp) && !(message.generatedTimestamp && $util.isInteger(message.generatedTimestamp.low) && $util.isInteger(message.generatedTimestamp.high)))
                            return "generatedTimestamp: integer|Long expected";
                    if (message.alphaProviderAutoApprove != null && message.hasOwnProperty("alphaProviderAutoApprove"))
                        if (typeof message.alphaProviderAutoApprove !== "boolean")
                            return "alphaProviderAutoApprove: boolean expected";
                    return null;
                };

                /**
                 * Creates an InvitationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.InvitationProto} InvitationProto
                 */
                InvitationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.InvitationProto)
                        return object;
                    let message = new $root.space.kenko.proto.InvitationProto();
                    if (object.inviteCode != null)
                        message.inviteCode = String(object.inviteCode);
                    if (object.generatedTimestamp != null)
                        if ($util.Long)
                            (message.generatedTimestamp = $util.Long.fromValue(object.generatedTimestamp)).unsigned = false;
                        else if (typeof object.generatedTimestamp === "string")
                            message.generatedTimestamp = parseInt(object.generatedTimestamp, 10);
                        else if (typeof object.generatedTimestamp === "number")
                            message.generatedTimestamp = object.generatedTimestamp;
                        else if (typeof object.generatedTimestamp === "object")
                            message.generatedTimestamp = new $util.LongBits(object.generatedTimestamp.low >>> 0, object.generatedTimestamp.high >>> 0).toNumber();
                    if (object.alphaProviderAutoApprove != null)
                        message.alphaProviderAutoApprove = Boolean(object.alphaProviderAutoApprove);
                    return message;
                };

                /**
                 * Creates a plain object from an InvitationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {space.kenko.proto.InvitationProto} message InvitationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                InvitationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.inviteCode = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.generatedTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.generatedTimestamp = options.longs === String ? "0" : 0;
                        object.alphaProviderAutoApprove = false;
                    }
                    if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
                        object.inviteCode = message.inviteCode;
                    if (message.generatedTimestamp != null && message.hasOwnProperty("generatedTimestamp"))
                        if (typeof message.generatedTimestamp === "number")
                            object.generatedTimestamp = options.longs === String ? String(message.generatedTimestamp) : message.generatedTimestamp;
                        else
                            object.generatedTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.generatedTimestamp) : options.longs === Number ? new $util.LongBits(message.generatedTimestamp.low >>> 0, message.generatedTimestamp.high >>> 0).toNumber() : message.generatedTimestamp;
                    if (message.alphaProviderAutoApprove != null && message.hasOwnProperty("alphaProviderAutoApprove"))
                        object.alphaProviderAutoApprove = message.alphaProviderAutoApprove;
                    return object;
                };

                /**
                 * Converts this InvitationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.InvitationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                InvitationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for InvitationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.InvitationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                InvitationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.InvitationProto";
                };

                return InvitationProto;
            })();

            proto.SchemaChallengeVerificationProto = (function() {

                /**
                 * Properties of a SchemaChallengeVerificationProto.
                 * @memberof space.kenko.proto
                 * @interface ISchemaChallengeVerificationProto
                 * @property {Array.<number|Long>|null} [challengeTimestamps] SchemaChallengeVerificationProto challengeTimestamps
                 * @property {Array.<number|Long>|null} [verificationAttemptTimestamps] SchemaChallengeVerificationProto verificationAttemptTimestamps
                 * @property {string|null} [latestOtp] SchemaChallengeVerificationProto latestOtp
                 * @property {number|Long|null} [latestChallengeTimestamp] SchemaChallengeVerificationProto latestChallengeTimestamp
                 * @property {space.kenko.proto.IContactMethodProto|null} [latestChallengeRecipient] SchemaChallengeVerificationProto latestChallengeRecipient
                 */

                /**
                 * Constructs a new SchemaChallengeVerificationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a SchemaChallengeVerificationProto.
                 * @implements ISchemaChallengeVerificationProto
                 * @constructor
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto=} [properties] Properties to set
                 */
                function SchemaChallengeVerificationProto(properties) {
                    this.challengeTimestamps = [];
                    this.verificationAttemptTimestamps = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SchemaChallengeVerificationProto challengeTimestamps.
                 * @member {Array.<number|Long>} challengeTimestamps
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.challengeTimestamps = $util.emptyArray;

                /**
                 * SchemaChallengeVerificationProto verificationAttemptTimestamps.
                 * @member {Array.<number|Long>} verificationAttemptTimestamps
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.verificationAttemptTimestamps = $util.emptyArray;

                /**
                 * SchemaChallengeVerificationProto latestOtp.
                 * @member {string} latestOtp
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.latestOtp = "";

                /**
                 * SchemaChallengeVerificationProto latestChallengeTimestamp.
                 * @member {number|Long} latestChallengeTimestamp
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.latestChallengeTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * SchemaChallengeVerificationProto latestChallengeRecipient.
                 * @member {space.kenko.proto.IContactMethodProto|null|undefined} latestChallengeRecipient
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 */
                SchemaChallengeVerificationProto.prototype.latestChallengeRecipient = null;

                /**
                 * Creates a new SchemaChallengeVerificationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto instance
                 */
                SchemaChallengeVerificationProto.create = function create(properties) {
                    return new SchemaChallengeVerificationProto(properties);
                };

                /**
                 * Encodes the specified SchemaChallengeVerificationProto message. Does not implicitly {@link space.kenko.proto.SchemaChallengeVerificationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto} message SchemaChallengeVerificationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SchemaChallengeVerificationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.challengeTimestamps != null && message.challengeTimestamps.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (let i = 0; i < message.challengeTimestamps.length; ++i)
                            writer.int64(message.challengeTimestamps[i]);
                        writer.ldelim();
                    }
                    if (message.verificationAttemptTimestamps != null && message.verificationAttemptTimestamps.length) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork();
                        for (let i = 0; i < message.verificationAttemptTimestamps.length; ++i)
                            writer.int64(message.verificationAttemptTimestamps[i]);
                        writer.ldelim();
                    }
                    if (message.latestOtp != null && Object.hasOwnProperty.call(message, "latestOtp"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.latestOtp);
                    if (message.latestChallengeTimestamp != null && Object.hasOwnProperty.call(message, "latestChallengeTimestamp"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.latestChallengeTimestamp);
                    if (message.latestChallengeRecipient != null && Object.hasOwnProperty.call(message, "latestChallengeRecipient"))
                        $root.space.kenko.proto.ContactMethodProto.encode(message.latestChallengeRecipient, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SchemaChallengeVerificationProto message, length delimited. Does not implicitly {@link space.kenko.proto.SchemaChallengeVerificationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.ISchemaChallengeVerificationProto} message SchemaChallengeVerificationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SchemaChallengeVerificationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SchemaChallengeVerificationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SchemaChallengeVerificationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.SchemaChallengeVerificationProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2: {
                                if (!(message.challengeTimestamps && message.challengeTimestamps.length))
                                    message.challengeTimestamps = [];
                                if ((tag & 7) === 2) {
                                    let end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.challengeTimestamps.push(reader.int64());
                                } else
                                    message.challengeTimestamps.push(reader.int64());
                                break;
                            }
                        case 3: {
                                if (!(message.verificationAttemptTimestamps && message.verificationAttemptTimestamps.length))
                                    message.verificationAttemptTimestamps = [];
                                if ((tag & 7) === 2) {
                                    let end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.verificationAttemptTimestamps.push(reader.int64());
                                } else
                                    message.verificationAttemptTimestamps.push(reader.int64());
                                break;
                            }
                        case 4: {
                                message.latestOtp = reader.string();
                                break;
                            }
                        case 5: {
                                message.latestChallengeTimestamp = reader.int64();
                                break;
                            }
                        case 7: {
                                message.latestChallengeRecipient = $root.space.kenko.proto.ContactMethodProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SchemaChallengeVerificationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SchemaChallengeVerificationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SchemaChallengeVerificationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SchemaChallengeVerificationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.challengeTimestamps != null && message.hasOwnProperty("challengeTimestamps")) {
                        if (!Array.isArray(message.challengeTimestamps))
                            return "challengeTimestamps: array expected";
                        for (let i = 0; i < message.challengeTimestamps.length; ++i)
                            if (!$util.isInteger(message.challengeTimestamps[i]) && !(message.challengeTimestamps[i] && $util.isInteger(message.challengeTimestamps[i].low) && $util.isInteger(message.challengeTimestamps[i].high)))
                                return "challengeTimestamps: integer|Long[] expected";
                    }
                    if (message.verificationAttemptTimestamps != null && message.hasOwnProperty("verificationAttemptTimestamps")) {
                        if (!Array.isArray(message.verificationAttemptTimestamps))
                            return "verificationAttemptTimestamps: array expected";
                        for (let i = 0; i < message.verificationAttemptTimestamps.length; ++i)
                            if (!$util.isInteger(message.verificationAttemptTimestamps[i]) && !(message.verificationAttemptTimestamps[i] && $util.isInteger(message.verificationAttemptTimestamps[i].low) && $util.isInteger(message.verificationAttemptTimestamps[i].high)))
                                return "verificationAttemptTimestamps: integer|Long[] expected";
                    }
                    if (message.latestOtp != null && message.hasOwnProperty("latestOtp"))
                        if (!$util.isString(message.latestOtp))
                            return "latestOtp: string expected";
                    if (message.latestChallengeTimestamp != null && message.hasOwnProperty("latestChallengeTimestamp"))
                        if (!$util.isInteger(message.latestChallengeTimestamp) && !(message.latestChallengeTimestamp && $util.isInteger(message.latestChallengeTimestamp.low) && $util.isInteger(message.latestChallengeTimestamp.high)))
                            return "latestChallengeTimestamp: integer|Long expected";
                    if (message.latestChallengeRecipient != null && message.hasOwnProperty("latestChallengeRecipient")) {
                        let error = $root.space.kenko.proto.ContactMethodProto.verify(message.latestChallengeRecipient);
                        if (error)
                            return "latestChallengeRecipient." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SchemaChallengeVerificationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.SchemaChallengeVerificationProto} SchemaChallengeVerificationProto
                 */
                SchemaChallengeVerificationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.SchemaChallengeVerificationProto)
                        return object;
                    let message = new $root.space.kenko.proto.SchemaChallengeVerificationProto();
                    if (object.challengeTimestamps) {
                        if (!Array.isArray(object.challengeTimestamps))
                            throw TypeError(".space.kenko.proto.SchemaChallengeVerificationProto.challengeTimestamps: array expected");
                        message.challengeTimestamps = [];
                        for (let i = 0; i < object.challengeTimestamps.length; ++i)
                            if ($util.Long)
                                (message.challengeTimestamps[i] = $util.Long.fromValue(object.challengeTimestamps[i])).unsigned = false;
                            else if (typeof object.challengeTimestamps[i] === "string")
                                message.challengeTimestamps[i] = parseInt(object.challengeTimestamps[i], 10);
                            else if (typeof object.challengeTimestamps[i] === "number")
                                message.challengeTimestamps[i] = object.challengeTimestamps[i];
                            else if (typeof object.challengeTimestamps[i] === "object")
                                message.challengeTimestamps[i] = new $util.LongBits(object.challengeTimestamps[i].low >>> 0, object.challengeTimestamps[i].high >>> 0).toNumber();
                    }
                    if (object.verificationAttemptTimestamps) {
                        if (!Array.isArray(object.verificationAttemptTimestamps))
                            throw TypeError(".space.kenko.proto.SchemaChallengeVerificationProto.verificationAttemptTimestamps: array expected");
                        message.verificationAttemptTimestamps = [];
                        for (let i = 0; i < object.verificationAttemptTimestamps.length; ++i)
                            if ($util.Long)
                                (message.verificationAttemptTimestamps[i] = $util.Long.fromValue(object.verificationAttemptTimestamps[i])).unsigned = false;
                            else if (typeof object.verificationAttemptTimestamps[i] === "string")
                                message.verificationAttemptTimestamps[i] = parseInt(object.verificationAttemptTimestamps[i], 10);
                            else if (typeof object.verificationAttemptTimestamps[i] === "number")
                                message.verificationAttemptTimestamps[i] = object.verificationAttemptTimestamps[i];
                            else if (typeof object.verificationAttemptTimestamps[i] === "object")
                                message.verificationAttemptTimestamps[i] = new $util.LongBits(object.verificationAttemptTimestamps[i].low >>> 0, object.verificationAttemptTimestamps[i].high >>> 0).toNumber();
                    }
                    if (object.latestOtp != null)
                        message.latestOtp = String(object.latestOtp);
                    if (object.latestChallengeTimestamp != null)
                        if ($util.Long)
                            (message.latestChallengeTimestamp = $util.Long.fromValue(object.latestChallengeTimestamp)).unsigned = false;
                        else if (typeof object.latestChallengeTimestamp === "string")
                            message.latestChallengeTimestamp = parseInt(object.latestChallengeTimestamp, 10);
                        else if (typeof object.latestChallengeTimestamp === "number")
                            message.latestChallengeTimestamp = object.latestChallengeTimestamp;
                        else if (typeof object.latestChallengeTimestamp === "object")
                            message.latestChallengeTimestamp = new $util.LongBits(object.latestChallengeTimestamp.low >>> 0, object.latestChallengeTimestamp.high >>> 0).toNumber();
                    if (object.latestChallengeRecipient != null) {
                        if (typeof object.latestChallengeRecipient !== "object")
                            throw TypeError(".space.kenko.proto.SchemaChallengeVerificationProto.latestChallengeRecipient: object expected");
                        message.latestChallengeRecipient = $root.space.kenko.proto.ContactMethodProto.fromObject(object.latestChallengeRecipient);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SchemaChallengeVerificationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {space.kenko.proto.SchemaChallengeVerificationProto} message SchemaChallengeVerificationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SchemaChallengeVerificationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults) {
                        object.challengeTimestamps = [];
                        object.verificationAttemptTimestamps = [];
                    }
                    if (options.defaults) {
                        object.latestOtp = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.latestChallengeTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.latestChallengeTimestamp = options.longs === String ? "0" : 0;
                        object.latestChallengeRecipient = null;
                    }
                    if (message.challengeTimestamps && message.challengeTimestamps.length) {
                        object.challengeTimestamps = [];
                        for (let j = 0; j < message.challengeTimestamps.length; ++j)
                            if (typeof message.challengeTimestamps[j] === "number")
                                object.challengeTimestamps[j] = options.longs === String ? String(message.challengeTimestamps[j]) : message.challengeTimestamps[j];
                            else
                                object.challengeTimestamps[j] = options.longs === String ? $util.Long.prototype.toString.call(message.challengeTimestamps[j]) : options.longs === Number ? new $util.LongBits(message.challengeTimestamps[j].low >>> 0, message.challengeTimestamps[j].high >>> 0).toNumber() : message.challengeTimestamps[j];
                    }
                    if (message.verificationAttemptTimestamps && message.verificationAttemptTimestamps.length) {
                        object.verificationAttemptTimestamps = [];
                        for (let j = 0; j < message.verificationAttemptTimestamps.length; ++j)
                            if (typeof message.verificationAttemptTimestamps[j] === "number")
                                object.verificationAttemptTimestamps[j] = options.longs === String ? String(message.verificationAttemptTimestamps[j]) : message.verificationAttemptTimestamps[j];
                            else
                                object.verificationAttemptTimestamps[j] = options.longs === String ? $util.Long.prototype.toString.call(message.verificationAttemptTimestamps[j]) : options.longs === Number ? new $util.LongBits(message.verificationAttemptTimestamps[j].low >>> 0, message.verificationAttemptTimestamps[j].high >>> 0).toNumber() : message.verificationAttemptTimestamps[j];
                    }
                    if (message.latestOtp != null && message.hasOwnProperty("latestOtp"))
                        object.latestOtp = message.latestOtp;
                    if (message.latestChallengeTimestamp != null && message.hasOwnProperty("latestChallengeTimestamp"))
                        if (typeof message.latestChallengeTimestamp === "number")
                            object.latestChallengeTimestamp = options.longs === String ? String(message.latestChallengeTimestamp) : message.latestChallengeTimestamp;
                        else
                            object.latestChallengeTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.latestChallengeTimestamp) : options.longs === Number ? new $util.LongBits(message.latestChallengeTimestamp.low >>> 0, message.latestChallengeTimestamp.high >>> 0).toNumber() : message.latestChallengeTimestamp;
                    if (message.latestChallengeRecipient != null && message.hasOwnProperty("latestChallengeRecipient"))
                        object.latestChallengeRecipient = $root.space.kenko.proto.ContactMethodProto.toObject(message.latestChallengeRecipient, options);
                    return object;
                };

                /**
                 * Converts this SchemaChallengeVerificationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SchemaChallengeVerificationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for SchemaChallengeVerificationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.SchemaChallengeVerificationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                SchemaChallengeVerificationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.SchemaChallengeVerificationProto";
                };

                return SchemaChallengeVerificationProto;
            })();

            proto.ApiBookingProto = (function() {

                /**
                 * Properties of an ApiBookingProto.
                 * @memberof space.kenko.proto
                 * @interface IApiBookingProto
                 * @property {string|null} [bookingId] ApiBookingProto bookingId
                 * @property {string|null} [userId] ApiBookingProto userId
                 * @property {string|null} [businessId] ApiBookingProto businessId
                 * @property {number|Long|null} [startTimeMs] ApiBookingProto startTimeMs
                 * @property {number|Long|null} [endTimeMs] ApiBookingProto endTimeMs
                 * @property {string|null} [timeZoneId] ApiBookingProto timeZoneId
                 * @property {string|null} [eventInstanceId] ApiBookingProto eventInstanceId
                 * @property {space.kenko.proto.IBookingDetailsProto|null} [details] ApiBookingProto details
                 */

                /**
                 * Constructs a new ApiBookingProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an ApiBookingProto.
                 * @implements IApiBookingProto
                 * @constructor
                 * @param {space.kenko.proto.IApiBookingProto=} [properties] Properties to set
                 */
                function ApiBookingProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ApiBookingProto bookingId.
                 * @member {string} bookingId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.bookingId = "";

                /**
                 * ApiBookingProto userId.
                 * @member {string} userId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.userId = "";

                /**
                 * ApiBookingProto businessId.
                 * @member {string} businessId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.businessId = "";

                /**
                 * ApiBookingProto startTimeMs.
                 * @member {number|Long} startTimeMs
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.startTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ApiBookingProto endTimeMs.
                 * @member {number|Long} endTimeMs
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.endTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ApiBookingProto timeZoneId.
                 * @member {string} timeZoneId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.timeZoneId = "";

                /**
                 * ApiBookingProto eventInstanceId.
                 * @member {string} eventInstanceId
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.eventInstanceId = "";

                /**
                 * ApiBookingProto details.
                 * @member {space.kenko.proto.IBookingDetailsProto|null|undefined} details
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 */
                ApiBookingProto.prototype.details = null;

                /**
                 * Creates a new ApiBookingProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.IApiBookingProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto instance
                 */
                ApiBookingProto.create = function create(properties) {
                    return new ApiBookingProto(properties);
                };

                /**
                 * Encodes the specified ApiBookingProto message. Does not implicitly {@link space.kenko.proto.ApiBookingProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.IApiBookingProto} message ApiBookingProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiBookingProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.bookingId != null && Object.hasOwnProperty.call(message, "bookingId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.bookingId);
                    if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.userId);
                    if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.businessId);
                    if (message.startTimeMs != null && Object.hasOwnProperty.call(message, "startTimeMs"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.startTimeMs);
                    if (message.endTimeMs != null && Object.hasOwnProperty.call(message, "endTimeMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.endTimeMs);
                    if (message.timeZoneId != null && Object.hasOwnProperty.call(message, "timeZoneId"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.timeZoneId);
                    if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.eventInstanceId);
                    if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                        $root.space.kenko.proto.BookingDetailsProto.encode(message.details, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ApiBookingProto message, length delimited. Does not implicitly {@link space.kenko.proto.ApiBookingProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.IApiBookingProto} message ApiBookingProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ApiBookingProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ApiBookingProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiBookingProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ApiBookingProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.bookingId = reader.string();
                                break;
                            }
                        case 2: {
                                message.userId = reader.string();
                                break;
                            }
                        case 3: {
                                message.businessId = reader.string();
                                break;
                            }
                        case 5: {
                                message.startTimeMs = reader.int64();
                                break;
                            }
                        case 6: {
                                message.endTimeMs = reader.int64();
                                break;
                            }
                        case 7: {
                                message.timeZoneId = reader.string();
                                break;
                            }
                        case 8: {
                                message.eventInstanceId = reader.string();
                                break;
                            }
                        case 9: {
                                message.details = $root.space.kenko.proto.BookingDetailsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ApiBookingProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ApiBookingProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ApiBookingProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ApiBookingProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.bookingId != null && message.hasOwnProperty("bookingId"))
                        if (!$util.isString(message.bookingId))
                            return "bookingId: string expected";
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        if (!$util.isString(message.userId))
                            return "userId: string expected";
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        if (!$util.isString(message.businessId))
                            return "businessId: string expected";
                    if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                        if (!$util.isInteger(message.startTimeMs) && !(message.startTimeMs && $util.isInteger(message.startTimeMs.low) && $util.isInteger(message.startTimeMs.high)))
                            return "startTimeMs: integer|Long expected";
                    if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                        if (!$util.isInteger(message.endTimeMs) && !(message.endTimeMs && $util.isInteger(message.endTimeMs.low) && $util.isInteger(message.endTimeMs.high)))
                            return "endTimeMs: integer|Long expected";
                    if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
                        if (!$util.isString(message.timeZoneId))
                            return "timeZoneId: string expected";
                    if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
                        if (!$util.isString(message.eventInstanceId))
                            return "eventInstanceId: string expected";
                    if (message.details != null && message.hasOwnProperty("details")) {
                        let error = $root.space.kenko.proto.BookingDetailsProto.verify(message.details);
                        if (error)
                            return "details." + error;
                    }
                    return null;
                };

                /**
                 * Creates an ApiBookingProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ApiBookingProto} ApiBookingProto
                 */
                ApiBookingProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ApiBookingProto)
                        return object;
                    let message = new $root.space.kenko.proto.ApiBookingProto();
                    if (object.bookingId != null)
                        message.bookingId = String(object.bookingId);
                    if (object.userId != null)
                        message.userId = String(object.userId);
                    if (object.businessId != null)
                        message.businessId = String(object.businessId);
                    if (object.startTimeMs != null)
                        if ($util.Long)
                            (message.startTimeMs = $util.Long.fromValue(object.startTimeMs)).unsigned = false;
                        else if (typeof object.startTimeMs === "string")
                            message.startTimeMs = parseInt(object.startTimeMs, 10);
                        else if (typeof object.startTimeMs === "number")
                            message.startTimeMs = object.startTimeMs;
                        else if (typeof object.startTimeMs === "object")
                            message.startTimeMs = new $util.LongBits(object.startTimeMs.low >>> 0, object.startTimeMs.high >>> 0).toNumber();
                    if (object.endTimeMs != null)
                        if ($util.Long)
                            (message.endTimeMs = $util.Long.fromValue(object.endTimeMs)).unsigned = false;
                        else if (typeof object.endTimeMs === "string")
                            message.endTimeMs = parseInt(object.endTimeMs, 10);
                        else if (typeof object.endTimeMs === "number")
                            message.endTimeMs = object.endTimeMs;
                        else if (typeof object.endTimeMs === "object")
                            message.endTimeMs = new $util.LongBits(object.endTimeMs.low >>> 0, object.endTimeMs.high >>> 0).toNumber();
                    if (object.timeZoneId != null)
                        message.timeZoneId = String(object.timeZoneId);
                    if (object.eventInstanceId != null)
                        message.eventInstanceId = String(object.eventInstanceId);
                    if (object.details != null) {
                        if (typeof object.details !== "object")
                            throw TypeError(".space.kenko.proto.ApiBookingProto.details: object expected");
                        message.details = $root.space.kenko.proto.BookingDetailsProto.fromObject(object.details);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ApiBookingProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {space.kenko.proto.ApiBookingProto} message ApiBookingProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ApiBookingProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.bookingId = "";
                        object.userId = "";
                        object.businessId = "";
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.startTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.startTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.endTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.endTimeMs = options.longs === String ? "0" : 0;
                        object.timeZoneId = "";
                        object.eventInstanceId = "";
                        object.details = null;
                    }
                    if (message.bookingId != null && message.hasOwnProperty("bookingId"))
                        object.bookingId = message.bookingId;
                    if (message.userId != null && message.hasOwnProperty("userId"))
                        object.userId = message.userId;
                    if (message.businessId != null && message.hasOwnProperty("businessId"))
                        object.businessId = message.businessId;
                    if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                        if (typeof message.startTimeMs === "number")
                            object.startTimeMs = options.longs === String ? String(message.startTimeMs) : message.startTimeMs;
                        else
                            object.startTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeMs) : options.longs === Number ? new $util.LongBits(message.startTimeMs.low >>> 0, message.startTimeMs.high >>> 0).toNumber() : message.startTimeMs;
                    if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                        if (typeof message.endTimeMs === "number")
                            object.endTimeMs = options.longs === String ? String(message.endTimeMs) : message.endTimeMs;
                        else
                            object.endTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.endTimeMs) : options.longs === Number ? new $util.LongBits(message.endTimeMs.low >>> 0, message.endTimeMs.high >>> 0).toNumber() : message.endTimeMs;
                    if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
                        object.timeZoneId = message.timeZoneId;
                    if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
                        object.eventInstanceId = message.eventInstanceId;
                    if (message.details != null && message.hasOwnProperty("details"))
                        object.details = $root.space.kenko.proto.BookingDetailsProto.toObject(message.details, options);
                    return object;
                };

                /**
                 * Converts this ApiBookingProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ApiBookingProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ApiBookingProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ApiBookingProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ApiBookingProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ApiBookingProto";
                };

                return ApiBookingProto;
            })();

            proto.BookingDetailsProto = (function() {

                /**
                 * Properties of a BookingDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface IBookingDetailsProto
                 * @property {space.kenko.proto.IBookedServiceProto|null} [service] BookingDetailsProto service
                 * @property {space.kenko.proto.IBookedClassProto|null} ["class"] BookingDetailsProto class
                 * @property {space.kenko.proto.IBookingPaymentProto|null} [paymentInfo] BookingDetailsProto paymentInfo
                 * @property {number|Long|null} [bookingTimestamp] BookingDetailsProto bookingTimestamp
                 * @property {string|null} [clientName] BookingDetailsProto clientName
                 * @property {string|null} [clientEmail] BookingDetailsProto clientEmail
                 * @property {boolean|null} [clientEmailVerified] BookingDetailsProto clientEmailVerified
                 * @property {string|null} [clientPhone] BookingDetailsProto clientPhone
                 * @property {boolean|null} [clientPhoneVerified] BookingDetailsProto clientPhoneVerified
                 * @property {Array.<space.kenko.proto.ISystemNoteProto>|null} [notes] BookingDetailsProto notes
                 */

                /**
                 * Constructs a new BookingDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookingDetailsProto.
                 * @implements IBookingDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.IBookingDetailsProto=} [properties] Properties to set
                 */
                function BookingDetailsProto(properties) {
                    this.notes = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookingDetailsProto service.
                 * @member {space.kenko.proto.IBookedServiceProto|null|undefined} service
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.service = null;

                /**
                 * BookingDetailsProto class.
                 * @member {space.kenko.proto.IBookedClassProto|null|undefined} class
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype["class"] = null;

                /**
                 * BookingDetailsProto paymentInfo.
                 * @member {space.kenko.proto.IBookingPaymentProto|null|undefined} paymentInfo
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.paymentInfo = null;

                /**
                 * BookingDetailsProto bookingTimestamp.
                 * @member {number|Long} bookingTimestamp
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.bookingTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * BookingDetailsProto clientName.
                 * @member {string} clientName
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientName = "";

                /**
                 * BookingDetailsProto clientEmail.
                 * @member {string} clientEmail
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientEmail = "";

                /**
                 * BookingDetailsProto clientEmailVerified.
                 * @member {boolean} clientEmailVerified
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientEmailVerified = false;

                /**
                 * BookingDetailsProto clientPhone.
                 * @member {string} clientPhone
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientPhone = "";

                /**
                 * BookingDetailsProto clientPhoneVerified.
                 * @member {boolean} clientPhoneVerified
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.clientPhoneVerified = false;

                /**
                 * BookingDetailsProto notes.
                 * @member {Array.<space.kenko.proto.ISystemNoteProto>} notes
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                BookingDetailsProto.prototype.notes = $util.emptyArray;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * BookingDetailsProto BookingType.
                 * @member {"service"|"class"|undefined} BookingType
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 */
                Object.defineProperty(BookingDetailsProto.prototype, "BookingType", {
                    get: $util.oneOfGetter($oneOfFields = ["service", "class"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BookingDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IBookingDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto instance
                 */
                BookingDetailsProto.create = function create(properties) {
                    return new BookingDetailsProto(properties);
                };

                /**
                 * Encodes the specified BookingDetailsProto message. Does not implicitly {@link space.kenko.proto.BookingDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IBookingDetailsProto} message BookingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.service != null && Object.hasOwnProperty.call(message, "service"))
                        $root.space.kenko.proto.BookedServiceProto.encode(message.service, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message["class"] != null && Object.hasOwnProperty.call(message, "class"))
                        $root.space.kenko.proto.BookedClassProto.encode(message["class"], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.paymentInfo != null && Object.hasOwnProperty.call(message, "paymentInfo"))
                        $root.space.kenko.proto.BookingPaymentProto.encode(message.paymentInfo, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
                    if (message.bookingTimestamp != null && Object.hasOwnProperty.call(message, "bookingTimestamp"))
                        writer.uint32(/* id 100, wireType 0 =*/800).int64(message.bookingTimestamp);
                    if (message.clientName != null && Object.hasOwnProperty.call(message, "clientName"))
                        writer.uint32(/* id 101, wireType 2 =*/810).string(message.clientName);
                    if (message.clientEmail != null && Object.hasOwnProperty.call(message, "clientEmail"))
                        writer.uint32(/* id 102, wireType 2 =*/818).string(message.clientEmail);
                    if (message.clientEmailVerified != null && Object.hasOwnProperty.call(message, "clientEmailVerified"))
                        writer.uint32(/* id 103, wireType 0 =*/824).bool(message.clientEmailVerified);
                    if (message.clientPhone != null && Object.hasOwnProperty.call(message, "clientPhone"))
                        writer.uint32(/* id 104, wireType 2 =*/834).string(message.clientPhone);
                    if (message.clientPhoneVerified != null && Object.hasOwnProperty.call(message, "clientPhoneVerified"))
                        writer.uint32(/* id 105, wireType 0 =*/840).bool(message.clientPhoneVerified);
                    if (message.notes != null && message.notes.length)
                        for (let i = 0; i < message.notes.length; ++i)
                            $root.space.kenko.proto.SystemNoteProto.encode(message.notes[i], writer.uint32(/* id 200, wireType 2 =*/1602).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BookingDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookingDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.IBookingDetailsProto} message BookingDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookingDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookingDetailsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.service = $root.space.kenko.proto.BookedServiceProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message["class"] = $root.space.kenko.proto.BookedClassProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 50: {
                                message.paymentInfo = $root.space.kenko.proto.BookingPaymentProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 100: {
                                message.bookingTimestamp = reader.int64();
                                break;
                            }
                        case 101: {
                                message.clientName = reader.string();
                                break;
                            }
                        case 102: {
                                message.clientEmail = reader.string();
                                break;
                            }
                        case 103: {
                                message.clientEmailVerified = reader.bool();
                                break;
                            }
                        case 104: {
                                message.clientPhone = reader.string();
                                break;
                            }
                        case 105: {
                                message.clientPhoneVerified = reader.bool();
                                break;
                            }
                        case 200: {
                                if (!(message.notes && message.notes.length))
                                    message.notes = [];
                                message.notes.push($root.space.kenko.proto.SystemNoteProto.decode(reader, reader.uint32()));
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookingDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookingDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookingDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.service != null && message.hasOwnProperty("service")) {
                        properties.BookingType = 1;
                        {
                            let error = $root.space.kenko.proto.BookedServiceProto.verify(message.service);
                            if (error)
                                return "service." + error;
                        }
                    }
                    if (message["class"] != null && message.hasOwnProperty("class")) {
                        if (properties.BookingType === 1)
                            return "BookingType: multiple values";
                        properties.BookingType = 1;
                        {
                            let error = $root.space.kenko.proto.BookedClassProto.verify(message["class"]);
                            if (error)
                                return "class." + error;
                        }
                    }
                    if (message.paymentInfo != null && message.hasOwnProperty("paymentInfo")) {
                        let error = $root.space.kenko.proto.BookingPaymentProto.verify(message.paymentInfo);
                        if (error)
                            return "paymentInfo." + error;
                    }
                    if (message.bookingTimestamp != null && message.hasOwnProperty("bookingTimestamp"))
                        if (!$util.isInteger(message.bookingTimestamp) && !(message.bookingTimestamp && $util.isInteger(message.bookingTimestamp.low) && $util.isInteger(message.bookingTimestamp.high)))
                            return "bookingTimestamp: integer|Long expected";
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        if (!$util.isString(message.clientName))
                            return "clientName: string expected";
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        if (!$util.isString(message.clientEmail))
                            return "clientEmail: string expected";
                    if (message.clientEmailVerified != null && message.hasOwnProperty("clientEmailVerified"))
                        if (typeof message.clientEmailVerified !== "boolean")
                            return "clientEmailVerified: boolean expected";
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        if (!$util.isString(message.clientPhone))
                            return "clientPhone: string expected";
                    if (message.clientPhoneVerified != null && message.hasOwnProperty("clientPhoneVerified"))
                        if (typeof message.clientPhoneVerified !== "boolean")
                            return "clientPhoneVerified: boolean expected";
                    if (message.notes != null && message.hasOwnProperty("notes")) {
                        if (!Array.isArray(message.notes))
                            return "notes: array expected";
                        for (let i = 0; i < message.notes.length; ++i) {
                            let error = $root.space.kenko.proto.SystemNoteProto.verify(message.notes[i]);
                            if (error)
                                return "notes." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BookingDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookingDetailsProto} BookingDetailsProto
                 */
                BookingDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookingDetailsProto)
                        return object;
                    let message = new $root.space.kenko.proto.BookingDetailsProto();
                    if (object.service != null) {
                        if (typeof object.service !== "object")
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.service: object expected");
                        message.service = $root.space.kenko.proto.BookedServiceProto.fromObject(object.service);
                    }
                    if (object["class"] != null) {
                        if (typeof object["class"] !== "object")
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.class: object expected");
                        message["class"] = $root.space.kenko.proto.BookedClassProto.fromObject(object["class"]);
                    }
                    if (object.paymentInfo != null) {
                        if (typeof object.paymentInfo !== "object")
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.paymentInfo: object expected");
                        message.paymentInfo = $root.space.kenko.proto.BookingPaymentProto.fromObject(object.paymentInfo);
                    }
                    if (object.bookingTimestamp != null)
                        if ($util.Long)
                            (message.bookingTimestamp = $util.Long.fromValue(object.bookingTimestamp)).unsigned = false;
                        else if (typeof object.bookingTimestamp === "string")
                            message.bookingTimestamp = parseInt(object.bookingTimestamp, 10);
                        else if (typeof object.bookingTimestamp === "number")
                            message.bookingTimestamp = object.bookingTimestamp;
                        else if (typeof object.bookingTimestamp === "object")
                            message.bookingTimestamp = new $util.LongBits(object.bookingTimestamp.low >>> 0, object.bookingTimestamp.high >>> 0).toNumber();
                    if (object.clientName != null)
                        message.clientName = String(object.clientName);
                    if (object.clientEmail != null)
                        message.clientEmail = String(object.clientEmail);
                    if (object.clientEmailVerified != null)
                        message.clientEmailVerified = Boolean(object.clientEmailVerified);
                    if (object.clientPhone != null)
                        message.clientPhone = String(object.clientPhone);
                    if (object.clientPhoneVerified != null)
                        message.clientPhoneVerified = Boolean(object.clientPhoneVerified);
                    if (object.notes) {
                        if (!Array.isArray(object.notes))
                            throw TypeError(".space.kenko.proto.BookingDetailsProto.notes: array expected");
                        message.notes = [];
                        for (let i = 0; i < object.notes.length; ++i) {
                            if (typeof object.notes[i] !== "object")
                                throw TypeError(".space.kenko.proto.BookingDetailsProto.notes: object expected");
                            message.notes[i] = $root.space.kenko.proto.SystemNoteProto.fromObject(object.notes[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BookingDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {space.kenko.proto.BookingDetailsProto} message BookingDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookingDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.notes = [];
                    if (options.defaults) {
                        object.paymentInfo = null;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.bookingTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.bookingTimestamp = options.longs === String ? "0" : 0;
                        object.clientName = "";
                        object.clientEmail = "";
                        object.clientEmailVerified = false;
                        object.clientPhone = "";
                        object.clientPhoneVerified = false;
                    }
                    if (message.service != null && message.hasOwnProperty("service")) {
                        object.service = $root.space.kenko.proto.BookedServiceProto.toObject(message.service, options);
                        if (options.oneofs)
                            object.BookingType = "service";
                    }
                    if (message["class"] != null && message.hasOwnProperty("class")) {
                        object["class"] = $root.space.kenko.proto.BookedClassProto.toObject(message["class"], options);
                        if (options.oneofs)
                            object.BookingType = "class";
                    }
                    if (message.paymentInfo != null && message.hasOwnProperty("paymentInfo"))
                        object.paymentInfo = $root.space.kenko.proto.BookingPaymentProto.toObject(message.paymentInfo, options);
                    if (message.bookingTimestamp != null && message.hasOwnProperty("bookingTimestamp"))
                        if (typeof message.bookingTimestamp === "number")
                            object.bookingTimestamp = options.longs === String ? String(message.bookingTimestamp) : message.bookingTimestamp;
                        else
                            object.bookingTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.bookingTimestamp) : options.longs === Number ? new $util.LongBits(message.bookingTimestamp.low >>> 0, message.bookingTimestamp.high >>> 0).toNumber() : message.bookingTimestamp;
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        object.clientName = message.clientName;
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        object.clientEmail = message.clientEmail;
                    if (message.clientEmailVerified != null && message.hasOwnProperty("clientEmailVerified"))
                        object.clientEmailVerified = message.clientEmailVerified;
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        object.clientPhone = message.clientPhone;
                    if (message.clientPhoneVerified != null && message.hasOwnProperty("clientPhoneVerified"))
                        object.clientPhoneVerified = message.clientPhoneVerified;
                    if (message.notes && message.notes.length) {
                        object.notes = [];
                        for (let j = 0; j < message.notes.length; ++j)
                            object.notes[j] = $root.space.kenko.proto.SystemNoteProto.toObject(message.notes[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this BookingDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookingDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookingDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookingDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookingDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookingDetailsProto";
                };

                return BookingDetailsProto;
            })();

            proto.BookedServiceProto = (function() {

                /**
                 * Properties of a BookedServiceProto.
                 * @memberof space.kenko.proto
                 * @interface IBookedServiceProto
                 * @property {string|null} [practitionerId] BookedServiceProto practitionerId
                 * @property {string|null} [practitionerName] BookedServiceProto practitionerName
                 * @property {string|null} [serviceId] BookedServiceProto serviceId
                 * @property {string|null} [serviceName] BookedServiceProto serviceName
                 * @property {string|null} [locationId] BookedServiceProto locationId
                 * @property {string|null} [locationName] BookedServiceProto locationName
                 * @property {string|null} [address] BookedServiceProto address
                 * @property {string|null} [virtualMeetingLink] BookedServiceProto virtualMeetingLink
                 * @property {boolean|null} [isVirtual] BookedServiceProto isVirtual
                 */

                /**
                 * Constructs a new BookedServiceProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookedServiceProto.
                 * @implements IBookedServiceProto
                 * @constructor
                 * @param {space.kenko.proto.IBookedServiceProto=} [properties] Properties to set
                 */
                function BookedServiceProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookedServiceProto practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.practitionerId = "";

                /**
                 * BookedServiceProto practitionerName.
                 * @member {string} practitionerName
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.practitionerName = "";

                /**
                 * BookedServiceProto serviceId.
                 * @member {string} serviceId
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.serviceId = "";

                /**
                 * BookedServiceProto serviceName.
                 * @member {string} serviceName
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.serviceName = "";

                /**
                 * BookedServiceProto locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.locationId = "";

                /**
                 * BookedServiceProto locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.locationName = "";

                /**
                 * BookedServiceProto address.
                 * @member {string} address
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.address = "";

                /**
                 * BookedServiceProto virtualMeetingLink.
                 * @member {string} virtualMeetingLink
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.virtualMeetingLink = "";

                /**
                 * BookedServiceProto isVirtual.
                 * @member {boolean} isVirtual
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 */
                BookedServiceProto.prototype.isVirtual = false;

                /**
                 * Creates a new BookedServiceProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.IBookedServiceProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto instance
                 */
                BookedServiceProto.create = function create(properties) {
                    return new BookedServiceProto(properties);
                };

                /**
                 * Encodes the specified BookedServiceProto message. Does not implicitly {@link space.kenko.proto.BookedServiceProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.IBookedServiceProto} message BookedServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedServiceProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.practitionerName != null && Object.hasOwnProperty.call(message, "practitionerName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.practitionerName);
                    if (message.serviceId != null && Object.hasOwnProperty.call(message, "serviceId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.serviceId);
                    if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.serviceName);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.locationName);
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.address);
                    if (message.virtualMeetingLink != null && Object.hasOwnProperty.call(message, "virtualMeetingLink"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.virtualMeetingLink);
                    if (message.isVirtual != null && Object.hasOwnProperty.call(message, "isVirtual"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isVirtual);
                    return writer;
                };

                /**
                 * Encodes the specified BookedServiceProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookedServiceProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.IBookedServiceProto} message BookedServiceProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedServiceProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookedServiceProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedServiceProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookedServiceProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.practitionerName = reader.string();
                                break;
                            }
                        case 4: {
                                message.serviceId = reader.string();
                                break;
                            }
                        case 5: {
                                message.serviceName = reader.string();
                                break;
                            }
                        case 6: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 7: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 8: {
                                message.address = reader.string();
                                break;
                            }
                        case 9: {
                                message.virtualMeetingLink = reader.string();
                                break;
                            }
                        case 10: {
                                message.isVirtual = reader.bool();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookedServiceProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedServiceProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookedServiceProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookedServiceProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        if (!$util.isString(message.practitionerName))
                            return "practitionerName: string expected";
                    if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                        if (!$util.isString(message.serviceId))
                            return "serviceId: string expected";
                    if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                        if (!$util.isString(message.serviceName))
                            return "serviceName: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        if (!$util.isString(message.virtualMeetingLink))
                            return "virtualMeetingLink: string expected";
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        if (typeof message.isVirtual !== "boolean")
                            return "isVirtual: boolean expected";
                    return null;
                };

                /**
                 * Creates a BookedServiceProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookedServiceProto} BookedServiceProto
                 */
                BookedServiceProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookedServiceProto)
                        return object;
                    let message = new $root.space.kenko.proto.BookedServiceProto();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.practitionerName != null)
                        message.practitionerName = String(object.practitionerName);
                    if (object.serviceId != null)
                        message.serviceId = String(object.serviceId);
                    if (object.serviceName != null)
                        message.serviceName = String(object.serviceName);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.address != null)
                        message.address = String(object.address);
                    if (object.virtualMeetingLink != null)
                        message.virtualMeetingLink = String(object.virtualMeetingLink);
                    if (object.isVirtual != null)
                        message.isVirtual = Boolean(object.isVirtual);
                    return message;
                };

                /**
                 * Creates a plain object from a BookedServiceProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {space.kenko.proto.BookedServiceProto} message BookedServiceProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookedServiceProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.practitionerName = "";
                        object.serviceId = "";
                        object.serviceName = "";
                        object.locationId = "";
                        object.locationName = "";
                        object.address = "";
                        object.virtualMeetingLink = "";
                        object.isVirtual = false;
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        object.practitionerName = message.practitionerName;
                    if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                        object.serviceId = message.serviceId;
                    if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                        object.serviceName = message.serviceName;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    if (message.virtualMeetingLink != null && message.hasOwnProperty("virtualMeetingLink"))
                        object.virtualMeetingLink = message.virtualMeetingLink;
                    if (message.isVirtual != null && message.hasOwnProperty("isVirtual"))
                        object.isVirtual = message.isVirtual;
                    return object;
                };

                /**
                 * Converts this BookedServiceProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookedServiceProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookedServiceProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookedServiceProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookedServiceProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookedServiceProto";
                };

                return BookedServiceProto;
            })();

            proto.BookingPurchaseOption = (function() {

                /**
                 * Properties of a BookingPurchaseOption.
                 * @memberof space.kenko.proto
                 * @interface IBookingPurchaseOption
                 * @property {string|null} [prepaidSingleCreditId] BookingPurchaseOption prepaidSingleCreditId
                 * @property {string|null} [prepaidPackageId] BookingPurchaseOption prepaidPackageId
                 * @property {space.kenko.proto.IPriceProto|null} [postpaidReservationOnly] BookingPurchaseOption postpaidReservationOnly
                 */

                /**
                 * Constructs a new BookingPurchaseOption.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookingPurchaseOption.
                 * @implements IBookingPurchaseOption
                 * @constructor
                 * @param {space.kenko.proto.IBookingPurchaseOption=} [properties] Properties to set
                 */
                function BookingPurchaseOption(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookingPurchaseOption prepaidSingleCreditId.
                 * @member {string|null|undefined} prepaidSingleCreditId
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                BookingPurchaseOption.prototype.prepaidSingleCreditId = null;

                /**
                 * BookingPurchaseOption prepaidPackageId.
                 * @member {string|null|undefined} prepaidPackageId
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                BookingPurchaseOption.prototype.prepaidPackageId = null;

                /**
                 * BookingPurchaseOption postpaidReservationOnly.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} postpaidReservationOnly
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                BookingPurchaseOption.prototype.postpaidReservationOnly = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * BookingPurchaseOption Type.
                 * @member {"prepaidSingleCreditId"|"prepaidPackageId"|"postpaidReservationOnly"|undefined} Type
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 */
                Object.defineProperty(BookingPurchaseOption.prototype, "Type", {
                    get: $util.oneOfGetter($oneOfFields = ["prepaidSingleCreditId", "prepaidPackageId", "postpaidReservationOnly"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BookingPurchaseOption instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.IBookingPurchaseOption=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption instance
                 */
                BookingPurchaseOption.create = function create(properties) {
                    return new BookingPurchaseOption(properties);
                };

                /**
                 * Encodes the specified BookingPurchaseOption message. Does not implicitly {@link space.kenko.proto.BookingPurchaseOption.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.IBookingPurchaseOption} message BookingPurchaseOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPurchaseOption.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prepaidSingleCreditId != null && Object.hasOwnProperty.call(message, "prepaidSingleCreditId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.prepaidSingleCreditId);
                    if (message.prepaidPackageId != null && Object.hasOwnProperty.call(message, "prepaidPackageId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.prepaidPackageId);
                    if (message.postpaidReservationOnly != null && Object.hasOwnProperty.call(message, "postpaidReservationOnly"))
                        $root.space.kenko.proto.PriceProto.encode(message.postpaidReservationOnly, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BookingPurchaseOption message, length delimited. Does not implicitly {@link space.kenko.proto.BookingPurchaseOption.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.IBookingPurchaseOption} message BookingPurchaseOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPurchaseOption.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookingPurchaseOption message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPurchaseOption.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookingPurchaseOption();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.prepaidSingleCreditId = reader.string();
                                break;
                            }
                        case 2: {
                                message.prepaidPackageId = reader.string();
                                break;
                            }
                        case 3: {
                                message.postpaidReservationOnly = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookingPurchaseOption message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPurchaseOption.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookingPurchaseOption message.
                 * @function verify
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookingPurchaseOption.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.prepaidSingleCreditId != null && message.hasOwnProperty("prepaidSingleCreditId")) {
                        properties.Type = 1;
                        if (!$util.isString(message.prepaidSingleCreditId))
                            return "prepaidSingleCreditId: string expected";
                    }
                    if (message.prepaidPackageId != null && message.hasOwnProperty("prepaidPackageId")) {
                        if (properties.Type === 1)
                            return "Type: multiple values";
                        properties.Type = 1;
                        if (!$util.isString(message.prepaidPackageId))
                            return "prepaidPackageId: string expected";
                    }
                    if (message.postpaidReservationOnly != null && message.hasOwnProperty("postpaidReservationOnly")) {
                        if (properties.Type === 1)
                            return "Type: multiple values";
                        properties.Type = 1;
                        {
                            let error = $root.space.kenko.proto.PriceProto.verify(message.postpaidReservationOnly);
                            if (error)
                                return "postpaidReservationOnly." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BookingPurchaseOption message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookingPurchaseOption} BookingPurchaseOption
                 */
                BookingPurchaseOption.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookingPurchaseOption)
                        return object;
                    let message = new $root.space.kenko.proto.BookingPurchaseOption();
                    if (object.prepaidSingleCreditId != null)
                        message.prepaidSingleCreditId = String(object.prepaidSingleCreditId);
                    if (object.prepaidPackageId != null)
                        message.prepaidPackageId = String(object.prepaidPackageId);
                    if (object.postpaidReservationOnly != null) {
                        if (typeof object.postpaidReservationOnly !== "object")
                            throw TypeError(".space.kenko.proto.BookingPurchaseOption.postpaidReservationOnly: object expected");
                        message.postpaidReservationOnly = $root.space.kenko.proto.PriceProto.fromObject(object.postpaidReservationOnly);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BookingPurchaseOption message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {space.kenko.proto.BookingPurchaseOption} message BookingPurchaseOption
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookingPurchaseOption.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.prepaidSingleCreditId != null && message.hasOwnProperty("prepaidSingleCreditId")) {
                        object.prepaidSingleCreditId = message.prepaidSingleCreditId;
                        if (options.oneofs)
                            object.Type = "prepaidSingleCreditId";
                    }
                    if (message.prepaidPackageId != null && message.hasOwnProperty("prepaidPackageId")) {
                        object.prepaidPackageId = message.prepaidPackageId;
                        if (options.oneofs)
                            object.Type = "prepaidPackageId";
                    }
                    if (message.postpaidReservationOnly != null && message.hasOwnProperty("postpaidReservationOnly")) {
                        object.postpaidReservationOnly = $root.space.kenko.proto.PriceProto.toObject(message.postpaidReservationOnly, options);
                        if (options.oneofs)
                            object.Type = "postpaidReservationOnly";
                    }
                    return object;
                };

                /**
                 * Converts this BookingPurchaseOption to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookingPurchaseOption.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookingPurchaseOption
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookingPurchaseOption
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookingPurchaseOption.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookingPurchaseOption";
                };

                return BookingPurchaseOption;
            })();

            proto.BookingPaymentProto = (function() {

                /**
                 * Properties of a BookingPaymentProto.
                 * @memberof space.kenko.proto
                 * @interface IBookingPaymentProto
                 * @property {IPurchasedSingleClassCreditProto|null} [prepaidSingleClassCredit] BookingPaymentProto prepaidSingleClassCredit
                 * @property {IPurchasedPackageProto|null} [prepaidPackage] BookingPaymentProto prepaidPackage
                 * @property {space.kenko.proto.IPostpaidReservationProto|null} [postpaidReservation] BookingPaymentProto postpaidReservation
                 * @property {space.kenko.proto.IPostpaidExternalPayment|null} [postpaidExternalPayment] BookingPaymentProto postpaidExternalPayment
                 */

                /**
                 * Constructs a new BookingPaymentProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookingPaymentProto.
                 * @implements IBookingPaymentProto
                 * @constructor
                 * @param {space.kenko.proto.IBookingPaymentProto=} [properties] Properties to set
                 */
                function BookingPaymentProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookingPaymentProto prepaidSingleClassCredit.
                 * @member {IPurchasedSingleClassCreditProto|null|undefined} prepaidSingleClassCredit
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.prepaidSingleClassCredit = null;

                /**
                 * BookingPaymentProto prepaidPackage.
                 * @member {IPurchasedPackageProto|null|undefined} prepaidPackage
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.prepaidPackage = null;

                /**
                 * BookingPaymentProto postpaidReservation.
                 * @member {space.kenko.proto.IPostpaidReservationProto|null|undefined} postpaidReservation
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.postpaidReservation = null;

                /**
                 * BookingPaymentProto postpaidExternalPayment.
                 * @member {space.kenko.proto.IPostpaidExternalPayment|null|undefined} postpaidExternalPayment
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                BookingPaymentProto.prototype.postpaidExternalPayment = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * BookingPaymentProto PaymentType.
                 * @member {"prepaidSingleClassCredit"|"prepaidPackage"|"postpaidReservation"|"postpaidExternalPayment"|undefined} PaymentType
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 */
                Object.defineProperty(BookingPaymentProto.prototype, "PaymentType", {
                    get: $util.oneOfGetter($oneOfFields = ["prepaidSingleClassCredit", "prepaidPackage", "postpaidReservation", "postpaidExternalPayment"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BookingPaymentProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.IBookingPaymentProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto instance
                 */
                BookingPaymentProto.create = function create(properties) {
                    return new BookingPaymentProto(properties);
                };

                /**
                 * Encodes the specified BookingPaymentProto message. Does not implicitly {@link space.kenko.proto.BookingPaymentProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.IBookingPaymentProto} message BookingPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPaymentProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.prepaidSingleClassCredit != null && Object.hasOwnProperty.call(message, "prepaidSingleClassCredit"))
                        $root.PurchasedSingleClassCreditProto.encode(message.prepaidSingleClassCredit, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
                    if (message.prepaidPackage != null && Object.hasOwnProperty.call(message, "prepaidPackage"))
                        $root.PurchasedPackageProto.encode(message.prepaidPackage, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
                    if (message.postpaidReservation != null && Object.hasOwnProperty.call(message, "postpaidReservation"))
                        $root.space.kenko.proto.PostpaidReservationProto.encode(message.postpaidReservation, writer.uint32(/* id 201, wireType 2 =*/1610).fork()).ldelim();
                    if (message.postpaidExternalPayment != null && Object.hasOwnProperty.call(message, "postpaidExternalPayment"))
                        $root.space.kenko.proto.PostpaidExternalPayment.encode(message.postpaidExternalPayment, writer.uint32(/* id 202, wireType 2 =*/1618).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BookingPaymentProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookingPaymentProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.IBookingPaymentProto} message BookingPaymentProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookingPaymentProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookingPaymentProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPaymentProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookingPaymentProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 100: {
                                message.prepaidSingleClassCredit = $root.PurchasedSingleClassCreditProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 101: {
                                message.prepaidPackage = $root.PurchasedPackageProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 201: {
                                message.postpaidReservation = $root.space.kenko.proto.PostpaidReservationProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 202: {
                                message.postpaidExternalPayment = $root.space.kenko.proto.PostpaidExternalPayment.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookingPaymentProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookingPaymentProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookingPaymentProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookingPaymentProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.prepaidSingleClassCredit != null && message.hasOwnProperty("prepaidSingleClassCredit")) {
                        properties.PaymentType = 1;
                        {
                            let error = $root.PurchasedSingleClassCreditProto.verify(message.prepaidSingleClassCredit);
                            if (error)
                                return "prepaidSingleClassCredit." + error;
                        }
                    }
                    if (message.prepaidPackage != null && message.hasOwnProperty("prepaidPackage")) {
                        if (properties.PaymentType === 1)
                            return "PaymentType: multiple values";
                        properties.PaymentType = 1;
                        {
                            let error = $root.PurchasedPackageProto.verify(message.prepaidPackage);
                            if (error)
                                return "prepaidPackage." + error;
                        }
                    }
                    if (message.postpaidReservation != null && message.hasOwnProperty("postpaidReservation")) {
                        if (properties.PaymentType === 1)
                            return "PaymentType: multiple values";
                        properties.PaymentType = 1;
                        {
                            let error = $root.space.kenko.proto.PostpaidReservationProto.verify(message.postpaidReservation);
                            if (error)
                                return "postpaidReservation." + error;
                        }
                    }
                    if (message.postpaidExternalPayment != null && message.hasOwnProperty("postpaidExternalPayment")) {
                        if (properties.PaymentType === 1)
                            return "PaymentType: multiple values";
                        properties.PaymentType = 1;
                        {
                            let error = $root.space.kenko.proto.PostpaidExternalPayment.verify(message.postpaidExternalPayment);
                            if (error)
                                return "postpaidExternalPayment." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BookingPaymentProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookingPaymentProto} BookingPaymentProto
                 */
                BookingPaymentProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookingPaymentProto)
                        return object;
                    let message = new $root.space.kenko.proto.BookingPaymentProto();
                    if (object.prepaidSingleClassCredit != null) {
                        if (typeof object.prepaidSingleClassCredit !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.prepaidSingleClassCredit: object expected");
                        message.prepaidSingleClassCredit = $root.PurchasedSingleClassCreditProto.fromObject(object.prepaidSingleClassCredit);
                    }
                    if (object.prepaidPackage != null) {
                        if (typeof object.prepaidPackage !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.prepaidPackage: object expected");
                        message.prepaidPackage = $root.PurchasedPackageProto.fromObject(object.prepaidPackage);
                    }
                    if (object.postpaidReservation != null) {
                        if (typeof object.postpaidReservation !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.postpaidReservation: object expected");
                        message.postpaidReservation = $root.space.kenko.proto.PostpaidReservationProto.fromObject(object.postpaidReservation);
                    }
                    if (object.postpaidExternalPayment != null) {
                        if (typeof object.postpaidExternalPayment !== "object")
                            throw TypeError(".space.kenko.proto.BookingPaymentProto.postpaidExternalPayment: object expected");
                        message.postpaidExternalPayment = $root.space.kenko.proto.PostpaidExternalPayment.fromObject(object.postpaidExternalPayment);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BookingPaymentProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {space.kenko.proto.BookingPaymentProto} message BookingPaymentProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookingPaymentProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.prepaidSingleClassCredit != null && message.hasOwnProperty("prepaidSingleClassCredit")) {
                        object.prepaidSingleClassCredit = $root.PurchasedSingleClassCreditProto.toObject(message.prepaidSingleClassCredit, options);
                        if (options.oneofs)
                            object.PaymentType = "prepaidSingleClassCredit";
                    }
                    if (message.prepaidPackage != null && message.hasOwnProperty("prepaidPackage")) {
                        object.prepaidPackage = $root.PurchasedPackageProto.toObject(message.prepaidPackage, options);
                        if (options.oneofs)
                            object.PaymentType = "prepaidPackage";
                    }
                    if (message.postpaidReservation != null && message.hasOwnProperty("postpaidReservation")) {
                        object.postpaidReservation = $root.space.kenko.proto.PostpaidReservationProto.toObject(message.postpaidReservation, options);
                        if (options.oneofs)
                            object.PaymentType = "postpaidReservation";
                    }
                    if (message.postpaidExternalPayment != null && message.hasOwnProperty("postpaidExternalPayment")) {
                        object.postpaidExternalPayment = $root.space.kenko.proto.PostpaidExternalPayment.toObject(message.postpaidExternalPayment, options);
                        if (options.oneofs)
                            object.PaymentType = "postpaidExternalPayment";
                    }
                    return object;
                };

                /**
                 * Converts this BookingPaymentProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookingPaymentProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookingPaymentProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookingPaymentProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookingPaymentProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookingPaymentProto";
                };

                return BookingPaymentProto;
            })();

            proto.PostpaidReservationProto = (function() {

                /**
                 * Properties of a PostpaidReservationProto.
                 * @memberof space.kenko.proto
                 * @interface IPostpaidReservationProto
                 * @property {space.kenko.proto.IPriceProto|null} [price] PostpaidReservationProto price
                 */

                /**
                 * Constructs a new PostpaidReservationProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PostpaidReservationProto.
                 * @implements IPostpaidReservationProto
                 * @constructor
                 * @param {space.kenko.proto.IPostpaidReservationProto=} [properties] Properties to set
                 */
                function PostpaidReservationProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PostpaidReservationProto price.
                 * @member {space.kenko.proto.IPriceProto|null|undefined} price
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @instance
                 */
                PostpaidReservationProto.prototype.price = null;

                /**
                 * Creates a new PostpaidReservationProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidReservationProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto instance
                 */
                PostpaidReservationProto.create = function create(properties) {
                    return new PostpaidReservationProto(properties);
                };

                /**
                 * Encodes the specified PostpaidReservationProto message. Does not implicitly {@link space.kenko.proto.PostpaidReservationProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidReservationProto} message PostpaidReservationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidReservationProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                        $root.space.kenko.proto.PriceProto.encode(message.price, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PostpaidReservationProto message, length delimited. Does not implicitly {@link space.kenko.proto.PostpaidReservationProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.IPostpaidReservationProto} message PostpaidReservationProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidReservationProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PostpaidReservationProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidReservationProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PostpaidReservationProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.price = $root.space.kenko.proto.PriceProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PostpaidReservationProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidReservationProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PostpaidReservationProto message.
                 * @function verify
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PostpaidReservationProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.price != null && message.hasOwnProperty("price")) {
                        let error = $root.space.kenko.proto.PriceProto.verify(message.price);
                        if (error)
                            return "price." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PostpaidReservationProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PostpaidReservationProto} PostpaidReservationProto
                 */
                PostpaidReservationProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PostpaidReservationProto)
                        return object;
                    let message = new $root.space.kenko.proto.PostpaidReservationProto();
                    if (object.price != null) {
                        if (typeof object.price !== "object")
                            throw TypeError(".space.kenko.proto.PostpaidReservationProto.price: object expected");
                        message.price = $root.space.kenko.proto.PriceProto.fromObject(object.price);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PostpaidReservationProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {space.kenko.proto.PostpaidReservationProto} message PostpaidReservationProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PostpaidReservationProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults)
                        object.price = null;
                    if (message.price != null && message.hasOwnProperty("price"))
                        object.price = $root.space.kenko.proto.PriceProto.toObject(message.price, options);
                    return object;
                };

                /**
                 * Converts this PostpaidReservationProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PostpaidReservationProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PostpaidReservationProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PostpaidReservationProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PostpaidReservationProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PostpaidReservationProto";
                };

                return PostpaidReservationProto;
            })();

            proto.PostpaidExternalPayment = (function() {

                /**
                 * Properties of a PostpaidExternalPayment.
                 * @memberof space.kenko.proto
                 * @interface IPostpaidExternalPayment
                 */

                /**
                 * Constructs a new PostpaidExternalPayment.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a PostpaidExternalPayment.
                 * @implements IPostpaidExternalPayment
                 * @constructor
                 * @param {space.kenko.proto.IPostpaidExternalPayment=} [properties] Properties to set
                 */
                function PostpaidExternalPayment(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new PostpaidExternalPayment instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.IPostpaidExternalPayment=} [properties] Properties to set
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment instance
                 */
                PostpaidExternalPayment.create = function create(properties) {
                    return new PostpaidExternalPayment(properties);
                };

                /**
                 * Encodes the specified PostpaidExternalPayment message. Does not implicitly {@link space.kenko.proto.PostpaidExternalPayment.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.IPostpaidExternalPayment} message PostpaidExternalPayment message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidExternalPayment.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified PostpaidExternalPayment message, length delimited. Does not implicitly {@link space.kenko.proto.PostpaidExternalPayment.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.IPostpaidExternalPayment} message PostpaidExternalPayment message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PostpaidExternalPayment.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PostpaidExternalPayment message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidExternalPayment.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.PostpaidExternalPayment();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PostpaidExternalPayment message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PostpaidExternalPayment.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PostpaidExternalPayment message.
                 * @function verify
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PostpaidExternalPayment.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a PostpaidExternalPayment message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.PostpaidExternalPayment} PostpaidExternalPayment
                 */
                PostpaidExternalPayment.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.PostpaidExternalPayment)
                        return object;
                    return new $root.space.kenko.proto.PostpaidExternalPayment();
                };

                /**
                 * Creates a plain object from a PostpaidExternalPayment message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {space.kenko.proto.PostpaidExternalPayment} message PostpaidExternalPayment
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PostpaidExternalPayment.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this PostpaidExternalPayment to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PostpaidExternalPayment.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for PostpaidExternalPayment
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.PostpaidExternalPayment
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                PostpaidExternalPayment.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.PostpaidExternalPayment";
                };

                return PostpaidExternalPayment;
            })();

            proto.BookedClassProto = (function() {

                /**
                 * Properties of a BookedClassProto.
                 * @memberof space.kenko.proto
                 * @interface IBookedClassProto
                 * @property {string|null} [practitionerId] BookedClassProto practitionerId
                 * @property {string|null} [practitionerName] BookedClassProto practitionerName
                 * @property {string|null} [className] BookedClassProto className
                 * @property {string|null} [locationName] BookedClassProto locationName
                 * @property {string|null} [locationId] BookedClassProto locationId
                 * @property {string|null} [address] BookedClassProto address
                 */

                /**
                 * Constructs a new BookedClassProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a BookedClassProto.
                 * @implements IBookedClassProto
                 * @constructor
                 * @param {space.kenko.proto.IBookedClassProto=} [properties] Properties to set
                 */
                function BookedClassProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BookedClassProto practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.practitionerId = "";

                /**
                 * BookedClassProto practitionerName.
                 * @member {string} practitionerName
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.practitionerName = "";

                /**
                 * BookedClassProto className.
                 * @member {string} className
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.className = "";

                /**
                 * BookedClassProto locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.locationName = "";

                /**
                 * BookedClassProto locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.locationId = "";

                /**
                 * BookedClassProto address.
                 * @member {string} address
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 */
                BookedClassProto.prototype.address = "";

                /**
                 * Creates a new BookedClassProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.IBookedClassProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto instance
                 */
                BookedClassProto.create = function create(properties) {
                    return new BookedClassProto(properties);
                };

                /**
                 * Encodes the specified BookedClassProto message. Does not implicitly {@link space.kenko.proto.BookedClassProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.IBookedClassProto} message BookedClassProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedClassProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.practitionerName != null && Object.hasOwnProperty.call(message, "practitionerName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.practitionerName);
                    if (message.className != null && Object.hasOwnProperty.call(message, "className"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.className);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.locationName);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.locationId);
                    if (message.address != null && Object.hasOwnProperty.call(message, "address"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.address);
                    return writer;
                };

                /**
                 * Encodes the specified BookedClassProto message, length delimited. Does not implicitly {@link space.kenko.proto.BookedClassProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.IBookedClassProto} message BookedClassProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BookedClassProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BookedClassProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedClassProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.BookedClassProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.practitionerName = reader.string();
                                break;
                            }
                        case 3: {
                                message.className = reader.string();
                                break;
                            }
                        case 4: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 5: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 6: {
                                message.address = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BookedClassProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BookedClassProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BookedClassProto message.
                 * @function verify
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BookedClassProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        if (!$util.isString(message.practitionerName))
                            return "practitionerName: string expected";
                    if (message.className != null && message.hasOwnProperty("className"))
                        if (!$util.isString(message.className))
                            return "className: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.address != null && message.hasOwnProperty("address"))
                        if (!$util.isString(message.address))
                            return "address: string expected";
                    return null;
                };

                /**
                 * Creates a BookedClassProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.BookedClassProto} BookedClassProto
                 */
                BookedClassProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.BookedClassProto)
                        return object;
                    let message = new $root.space.kenko.proto.BookedClassProto();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.practitionerName != null)
                        message.practitionerName = String(object.practitionerName);
                    if (object.className != null)
                        message.className = String(object.className);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.address != null)
                        message.address = String(object.address);
                    return message;
                };

                /**
                 * Creates a plain object from a BookedClassProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {space.kenko.proto.BookedClassProto} message BookedClassProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BookedClassProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.practitionerName = "";
                        object.className = "";
                        object.locationName = "";
                        object.locationId = "";
                        object.address = "";
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        object.practitionerName = message.practitionerName;
                    if (message.className != null && message.hasOwnProperty("className"))
                        object.className = message.className;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.address != null && message.hasOwnProperty("address"))
                        object.address = message.address;
                    return object;
                };

                /**
                 * Converts this BookedClassProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.BookedClassProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BookedClassProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for BookedClassProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.BookedClassProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                BookedClassProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.BookedClassProto";
                };

                return BookedClassProto;
            })();

            proto.CalendarEventProto = (function() {

                /**
                 * Properties of a CalendarEventProto.
                 * @memberof space.kenko.proto
                 * @interface ICalendarEventProto
                 * @property {string|null} [timeZoneId] CalendarEventProto timeZoneId
                 * @property {space.kenko.proto.ICalendarEventDetailsProto|null} [defaultDetails] CalendarEventProto defaultDetails
                 * @property {Array.<space.kenko.proto.ICalendarEventOverrideProto>|null} [overrides] CalendarEventProto overrides
                 * @property {space.kenko.proto.IRepeatStrategyProto|null} [repeatStrategy] CalendarEventProto repeatStrategy
                 */

                /**
                 * Constructs a new CalendarEventProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a CalendarEventProto.
                 * @implements ICalendarEventProto
                 * @constructor
                 * @param {space.kenko.proto.ICalendarEventProto=} [properties] Properties to set
                 */
                function CalendarEventProto(properties) {
                    this.overrides = [];
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CalendarEventProto timeZoneId.
                 * @member {string} timeZoneId
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @instance
                 */
                CalendarEventProto.prototype.timeZoneId = "";

                /**
                 * CalendarEventProto defaultDetails.
                 * @member {space.kenko.proto.ICalendarEventDetailsProto|null|undefined} defaultDetails
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @instance
                 */
                CalendarEventProto.prototype.defaultDetails = null;

                /**
                 * CalendarEventProto overrides.
                 * @member {Array.<space.kenko.proto.ICalendarEventOverrideProto>} overrides
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @instance
                 */
                CalendarEventProto.prototype.overrides = $util.emptyArray;

                /**
                 * CalendarEventProto repeatStrategy.
                 * @member {space.kenko.proto.IRepeatStrategyProto|null|undefined} repeatStrategy
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @instance
                 */
                CalendarEventProto.prototype.repeatStrategy = null;

                /**
                 * Creates a new CalendarEventProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.CalendarEventProto} CalendarEventProto instance
                 */
                CalendarEventProto.create = function create(properties) {
                    return new CalendarEventProto(properties);
                };

                /**
                 * Encodes the specified CalendarEventProto message. Does not implicitly {@link space.kenko.proto.CalendarEventProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventProto} message CalendarEventProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalendarEventProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.timeZoneId != null && Object.hasOwnProperty.call(message, "timeZoneId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.timeZoneId);
                    if (message.defaultDetails != null && Object.hasOwnProperty.call(message, "defaultDetails"))
                        $root.space.kenko.proto.CalendarEventDetailsProto.encode(message.defaultDetails, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.overrides != null && message.overrides.length)
                        for (let i = 0; i < message.overrides.length; ++i)
                            $root.space.kenko.proto.CalendarEventOverrideProto.encode(message.overrides[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.repeatStrategy != null && Object.hasOwnProperty.call(message, "repeatStrategy"))
                        $root.space.kenko.proto.RepeatStrategyProto.encode(message.repeatStrategy, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CalendarEventProto message, length delimited. Does not implicitly {@link space.kenko.proto.CalendarEventProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventProto} message CalendarEventProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalendarEventProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CalendarEventProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.CalendarEventProto} CalendarEventProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalendarEventProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.CalendarEventProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2: {
                                message.timeZoneId = reader.string();
                                break;
                            }
                        case 7: {
                                message.defaultDetails = $root.space.kenko.proto.CalendarEventDetailsProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 8: {
                                if (!(message.overrides && message.overrides.length))
                                    message.overrides = [];
                                message.overrides.push($root.space.kenko.proto.CalendarEventOverrideProto.decode(reader, reader.uint32()));
                                break;
                            }
                        case 20: {
                                message.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CalendarEventProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.CalendarEventProto} CalendarEventProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalendarEventProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CalendarEventProto message.
                 * @function verify
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CalendarEventProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
                        if (!$util.isString(message.timeZoneId))
                            return "timeZoneId: string expected";
                    if (message.defaultDetails != null && message.hasOwnProperty("defaultDetails")) {
                        let error = $root.space.kenko.proto.CalendarEventDetailsProto.verify(message.defaultDetails);
                        if (error)
                            return "defaultDetails." + error;
                    }
                    if (message.overrides != null && message.hasOwnProperty("overrides")) {
                        if (!Array.isArray(message.overrides))
                            return "overrides: array expected";
                        for (let i = 0; i < message.overrides.length; ++i) {
                            let error = $root.space.kenko.proto.CalendarEventOverrideProto.verify(message.overrides[i]);
                            if (error)
                                return "overrides." + error;
                        }
                    }
                    if (message.repeatStrategy != null && message.hasOwnProperty("repeatStrategy")) {
                        let error = $root.space.kenko.proto.RepeatStrategyProto.verify(message.repeatStrategy);
                        if (error)
                            return "repeatStrategy." + error;
                    }
                    return null;
                };

                /**
                 * Creates a CalendarEventProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.CalendarEventProto} CalendarEventProto
                 */
                CalendarEventProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.CalendarEventProto)
                        return object;
                    let message = new $root.space.kenko.proto.CalendarEventProto();
                    if (object.timeZoneId != null)
                        message.timeZoneId = String(object.timeZoneId);
                    if (object.defaultDetails != null) {
                        if (typeof object.defaultDetails !== "object")
                            throw TypeError(".space.kenko.proto.CalendarEventProto.defaultDetails: object expected");
                        message.defaultDetails = $root.space.kenko.proto.CalendarEventDetailsProto.fromObject(object.defaultDetails);
                    }
                    if (object.overrides) {
                        if (!Array.isArray(object.overrides))
                            throw TypeError(".space.kenko.proto.CalendarEventProto.overrides: array expected");
                        message.overrides = [];
                        for (let i = 0; i < object.overrides.length; ++i) {
                            if (typeof object.overrides[i] !== "object")
                                throw TypeError(".space.kenko.proto.CalendarEventProto.overrides: object expected");
                            message.overrides[i] = $root.space.kenko.proto.CalendarEventOverrideProto.fromObject(object.overrides[i]);
                        }
                    }
                    if (object.repeatStrategy != null) {
                        if (typeof object.repeatStrategy !== "object")
                            throw TypeError(".space.kenko.proto.CalendarEventProto.repeatStrategy: object expected");
                        message.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.fromObject(object.repeatStrategy);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CalendarEventProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {space.kenko.proto.CalendarEventProto} message CalendarEventProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CalendarEventProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.arrays || options.defaults)
                        object.overrides = [];
                    if (options.defaults) {
                        object.timeZoneId = "";
                        object.defaultDetails = null;
                        object.repeatStrategy = null;
                    }
                    if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
                        object.timeZoneId = message.timeZoneId;
                    if (message.defaultDetails != null && message.hasOwnProperty("defaultDetails"))
                        object.defaultDetails = $root.space.kenko.proto.CalendarEventDetailsProto.toObject(message.defaultDetails, options);
                    if (message.overrides && message.overrides.length) {
                        object.overrides = [];
                        for (let j = 0; j < message.overrides.length; ++j)
                            object.overrides[j] = $root.space.kenko.proto.CalendarEventOverrideProto.toObject(message.overrides[j], options);
                    }
                    if (message.repeatStrategy != null && message.hasOwnProperty("repeatStrategy"))
                        object.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.toObject(message.repeatStrategy, options);
                    return object;
                };

                /**
                 * Converts this CalendarEventProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CalendarEventProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CalendarEventProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.CalendarEventProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CalendarEventProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.CalendarEventProto";
                };

                return CalendarEventProto;
            })();

            proto.RepeatStrategyProto = (function() {

                /**
                 * Properties of a RepeatStrategyProto.
                 * @memberof space.kenko.proto
                 * @interface IRepeatStrategyProto
                 * @property {space.kenko.proto.INoRepeatSchedule|null} [none] RepeatStrategyProto none
                 * @property {space.kenko.proto.IWeeklyRepeatSchedule|null} [weekly] RepeatStrategyProto weekly
                 */

                /**
                 * Constructs a new RepeatStrategyProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a RepeatStrategyProto.
                 * @implements IRepeatStrategyProto
                 * @constructor
                 * @param {space.kenko.proto.IRepeatStrategyProto=} [properties] Properties to set
                 */
                function RepeatStrategyProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RepeatStrategyProto none.
                 * @member {space.kenko.proto.INoRepeatSchedule|null|undefined} none
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @instance
                 */
                RepeatStrategyProto.prototype.none = null;

                /**
                 * RepeatStrategyProto weekly.
                 * @member {space.kenko.proto.IWeeklyRepeatSchedule|null|undefined} weekly
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @instance
                 */
                RepeatStrategyProto.prototype.weekly = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * RepeatStrategyProto RepeatStrategy.
                 * @member {"none"|"weekly"|undefined} RepeatStrategy
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @instance
                 */
                Object.defineProperty(RepeatStrategyProto.prototype, "RepeatStrategy", {
                    get: $util.oneOfGetter($oneOfFields = ["none", "weekly"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new RepeatStrategyProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {space.kenko.proto.IRepeatStrategyProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.RepeatStrategyProto} RepeatStrategyProto instance
                 */
                RepeatStrategyProto.create = function create(properties) {
                    return new RepeatStrategyProto(properties);
                };

                /**
                 * Encodes the specified RepeatStrategyProto message. Does not implicitly {@link space.kenko.proto.RepeatStrategyProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {space.kenko.proto.IRepeatStrategyProto} message RepeatStrategyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RepeatStrategyProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.none != null && Object.hasOwnProperty.call(message, "none"))
                        $root.space.kenko.proto.NoRepeatSchedule.encode(message.none, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.weekly != null && Object.hasOwnProperty.call(message, "weekly"))
                        $root.space.kenko.proto.WeeklyRepeatSchedule.encode(message.weekly, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RepeatStrategyProto message, length delimited. Does not implicitly {@link space.kenko.proto.RepeatStrategyProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {space.kenko.proto.IRepeatStrategyProto} message RepeatStrategyProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RepeatStrategyProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RepeatStrategyProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.RepeatStrategyProto} RepeatStrategyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RepeatStrategyProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.RepeatStrategyProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.none = $root.space.kenko.proto.NoRepeatSchedule.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.weekly = $root.space.kenko.proto.WeeklyRepeatSchedule.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RepeatStrategyProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.RepeatStrategyProto} RepeatStrategyProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RepeatStrategyProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RepeatStrategyProto message.
                 * @function verify
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RepeatStrategyProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.none != null && message.hasOwnProperty("none")) {
                        properties.RepeatStrategy = 1;
                        {
                            let error = $root.space.kenko.proto.NoRepeatSchedule.verify(message.none);
                            if (error)
                                return "none." + error;
                        }
                    }
                    if (message.weekly != null && message.hasOwnProperty("weekly")) {
                        if (properties.RepeatStrategy === 1)
                            return "RepeatStrategy: multiple values";
                        properties.RepeatStrategy = 1;
                        {
                            let error = $root.space.kenko.proto.WeeklyRepeatSchedule.verify(message.weekly);
                            if (error)
                                return "weekly." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RepeatStrategyProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.RepeatStrategyProto} RepeatStrategyProto
                 */
                RepeatStrategyProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.RepeatStrategyProto)
                        return object;
                    let message = new $root.space.kenko.proto.RepeatStrategyProto();
                    if (object.none != null) {
                        if (typeof object.none !== "object")
                            throw TypeError(".space.kenko.proto.RepeatStrategyProto.none: object expected");
                        message.none = $root.space.kenko.proto.NoRepeatSchedule.fromObject(object.none);
                    }
                    if (object.weekly != null) {
                        if (typeof object.weekly !== "object")
                            throw TypeError(".space.kenko.proto.RepeatStrategyProto.weekly: object expected");
                        message.weekly = $root.space.kenko.proto.WeeklyRepeatSchedule.fromObject(object.weekly);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RepeatStrategyProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {space.kenko.proto.RepeatStrategyProto} message RepeatStrategyProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RepeatStrategyProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.none != null && message.hasOwnProperty("none")) {
                        object.none = $root.space.kenko.proto.NoRepeatSchedule.toObject(message.none, options);
                        if (options.oneofs)
                            object.RepeatStrategy = "none";
                    }
                    if (message.weekly != null && message.hasOwnProperty("weekly")) {
                        object.weekly = $root.space.kenko.proto.WeeklyRepeatSchedule.toObject(message.weekly, options);
                        if (options.oneofs)
                            object.RepeatStrategy = "weekly";
                    }
                    return object;
                };

                /**
                 * Converts this RepeatStrategyProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RepeatStrategyProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RepeatStrategyProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.RepeatStrategyProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RepeatStrategyProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.RepeatStrategyProto";
                };

                return RepeatStrategyProto;
            })();

            proto.CalendarEventOverrideProto = (function() {

                /**
                 * Properties of a CalendarEventOverrideProto.
                 * @memberof space.kenko.proto
                 * @interface ICalendarEventOverrideProto
                 * @property {space.kenko.proto.ILocalDateProto|null} [originalDate] CalendarEventOverrideProto originalDate
                 * @property {space.kenko.proto.ICalendarEventDetailsProto|null} [details] CalendarEventOverrideProto details
                 */

                /**
                 * Constructs a new CalendarEventOverrideProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a CalendarEventOverrideProto.
                 * @implements ICalendarEventOverrideProto
                 * @constructor
                 * @param {space.kenko.proto.ICalendarEventOverrideProto=} [properties] Properties to set
                 */
                function CalendarEventOverrideProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CalendarEventOverrideProto originalDate.
                 * @member {space.kenko.proto.ILocalDateProto|null|undefined} originalDate
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @instance
                 */
                CalendarEventOverrideProto.prototype.originalDate = null;

                /**
                 * CalendarEventOverrideProto details.
                 * @member {space.kenko.proto.ICalendarEventDetailsProto|null|undefined} details
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @instance
                 */
                CalendarEventOverrideProto.prototype.details = null;

                /**
                 * Creates a new CalendarEventOverrideProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventOverrideProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.CalendarEventOverrideProto} CalendarEventOverrideProto instance
                 */
                CalendarEventOverrideProto.create = function create(properties) {
                    return new CalendarEventOverrideProto(properties);
                };

                /**
                 * Encodes the specified CalendarEventOverrideProto message. Does not implicitly {@link space.kenko.proto.CalendarEventOverrideProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventOverrideProto} message CalendarEventOverrideProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalendarEventOverrideProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.originalDate != null && Object.hasOwnProperty.call(message, "originalDate"))
                        $root.space.kenko.proto.LocalDateProto.encode(message.originalDate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                        $root.space.kenko.proto.CalendarEventDetailsProto.encode(message.details, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CalendarEventOverrideProto message, length delimited. Does not implicitly {@link space.kenko.proto.CalendarEventOverrideProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventOverrideProto} message CalendarEventOverrideProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalendarEventOverrideProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CalendarEventOverrideProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.CalendarEventOverrideProto} CalendarEventOverrideProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalendarEventOverrideProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.CalendarEventOverrideProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.originalDate = $root.space.kenko.proto.LocalDateProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 2: {
                                message.details = $root.space.kenko.proto.CalendarEventDetailsProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CalendarEventOverrideProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.CalendarEventOverrideProto} CalendarEventOverrideProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalendarEventOverrideProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CalendarEventOverrideProto message.
                 * @function verify
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CalendarEventOverrideProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.originalDate != null && message.hasOwnProperty("originalDate")) {
                        let error = $root.space.kenko.proto.LocalDateProto.verify(message.originalDate);
                        if (error)
                            return "originalDate." + error;
                    }
                    if (message.details != null && message.hasOwnProperty("details")) {
                        let error = $root.space.kenko.proto.CalendarEventDetailsProto.verify(message.details);
                        if (error)
                            return "details." + error;
                    }
                    return null;
                };

                /**
                 * Creates a CalendarEventOverrideProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.CalendarEventOverrideProto} CalendarEventOverrideProto
                 */
                CalendarEventOverrideProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.CalendarEventOverrideProto)
                        return object;
                    let message = new $root.space.kenko.proto.CalendarEventOverrideProto();
                    if (object.originalDate != null) {
                        if (typeof object.originalDate !== "object")
                            throw TypeError(".space.kenko.proto.CalendarEventOverrideProto.originalDate: object expected");
                        message.originalDate = $root.space.kenko.proto.LocalDateProto.fromObject(object.originalDate);
                    }
                    if (object.details != null) {
                        if (typeof object.details !== "object")
                            throw TypeError(".space.kenko.proto.CalendarEventOverrideProto.details: object expected");
                        message.details = $root.space.kenko.proto.CalendarEventDetailsProto.fromObject(object.details);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CalendarEventOverrideProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {space.kenko.proto.CalendarEventOverrideProto} message CalendarEventOverrideProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CalendarEventOverrideProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.originalDate = null;
                        object.details = null;
                    }
                    if (message.originalDate != null && message.hasOwnProperty("originalDate"))
                        object.originalDate = $root.space.kenko.proto.LocalDateProto.toObject(message.originalDate, options);
                    if (message.details != null && message.hasOwnProperty("details"))
                        object.details = $root.space.kenko.proto.CalendarEventDetailsProto.toObject(message.details, options);
                    return object;
                };

                /**
                 * Converts this CalendarEventOverrideProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CalendarEventOverrideProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CalendarEventOverrideProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.CalendarEventOverrideProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CalendarEventOverrideProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.CalendarEventOverrideProto";
                };

                return CalendarEventOverrideProto;
            })();

            proto.CalendarEventDetailsProto = (function() {

                /**
                 * Properties of a CalendarEventDetailsProto.
                 * @memberof space.kenko.proto
                 * @interface ICalendarEventDetailsProto
                 * @property {number|Long|null} [startTime] CalendarEventDetailsProto startTime
                 * @property {number|Long|null} [endTime] CalendarEventDetailsProto endTime
                 * @property {space.kenko.proto.IKenkoEventDetails|null} [kenkoDetails] CalendarEventDetailsProto kenkoDetails
                 */

                /**
                 * Constructs a new CalendarEventDetailsProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a CalendarEventDetailsProto.
                 * @implements ICalendarEventDetailsProto
                 * @constructor
                 * @param {space.kenko.proto.ICalendarEventDetailsProto=} [properties] Properties to set
                 */
                function CalendarEventDetailsProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CalendarEventDetailsProto startTime.
                 * @member {number|Long} startTime
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @instance
                 */
                CalendarEventDetailsProto.prototype.startTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * CalendarEventDetailsProto endTime.
                 * @member {number|Long} endTime
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @instance
                 */
                CalendarEventDetailsProto.prototype.endTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * CalendarEventDetailsProto kenkoDetails.
                 * @member {space.kenko.proto.IKenkoEventDetails|null|undefined} kenkoDetails
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @instance
                 */
                CalendarEventDetailsProto.prototype.kenkoDetails = null;

                /**
                 * Creates a new CalendarEventDetailsProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventDetailsProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.CalendarEventDetailsProto} CalendarEventDetailsProto instance
                 */
                CalendarEventDetailsProto.create = function create(properties) {
                    return new CalendarEventDetailsProto(properties);
                };

                /**
                 * Encodes the specified CalendarEventDetailsProto message. Does not implicitly {@link space.kenko.proto.CalendarEventDetailsProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventDetailsProto} message CalendarEventDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalendarEventDetailsProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.startTime);
                    if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.endTime);
                    if (message.kenkoDetails != null && Object.hasOwnProperty.call(message, "kenkoDetails"))
                        $root.space.kenko.proto.KenkoEventDetails.encode(message.kenkoDetails, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CalendarEventDetailsProto message, length delimited. Does not implicitly {@link space.kenko.proto.CalendarEventDetailsProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {space.kenko.proto.ICalendarEventDetailsProto} message CalendarEventDetailsProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CalendarEventDetailsProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CalendarEventDetailsProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.CalendarEventDetailsProto} CalendarEventDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalendarEventDetailsProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.CalendarEventDetailsProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.startTime = reader.int64();
                                break;
                            }
                        case 2: {
                                message.endTime = reader.int64();
                                break;
                            }
                        case 4: {
                                message.kenkoDetails = $root.space.kenko.proto.KenkoEventDetails.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CalendarEventDetailsProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.CalendarEventDetailsProto} CalendarEventDetailsProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CalendarEventDetailsProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CalendarEventDetailsProto message.
                 * @function verify
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CalendarEventDetailsProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        if (!$util.isInteger(message.startTime) && !(message.startTime && $util.isInteger(message.startTime.low) && $util.isInteger(message.startTime.high)))
                            return "startTime: integer|Long expected";
                    if (message.endTime != null && message.hasOwnProperty("endTime"))
                        if (!$util.isInteger(message.endTime) && !(message.endTime && $util.isInteger(message.endTime.low) && $util.isInteger(message.endTime.high)))
                            return "endTime: integer|Long expected";
                    if (message.kenkoDetails != null && message.hasOwnProperty("kenkoDetails")) {
                        let error = $root.space.kenko.proto.KenkoEventDetails.verify(message.kenkoDetails);
                        if (error)
                            return "kenkoDetails." + error;
                    }
                    return null;
                };

                /**
                 * Creates a CalendarEventDetailsProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.CalendarEventDetailsProto} CalendarEventDetailsProto
                 */
                CalendarEventDetailsProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.CalendarEventDetailsProto)
                        return object;
                    let message = new $root.space.kenko.proto.CalendarEventDetailsProto();
                    if (object.startTime != null)
                        if ($util.Long)
                            (message.startTime = $util.Long.fromValue(object.startTime)).unsigned = false;
                        else if (typeof object.startTime === "string")
                            message.startTime = parseInt(object.startTime, 10);
                        else if (typeof object.startTime === "number")
                            message.startTime = object.startTime;
                        else if (typeof object.startTime === "object")
                            message.startTime = new $util.LongBits(object.startTime.low >>> 0, object.startTime.high >>> 0).toNumber();
                    if (object.endTime != null)
                        if ($util.Long)
                            (message.endTime = $util.Long.fromValue(object.endTime)).unsigned = false;
                        else if (typeof object.endTime === "string")
                            message.endTime = parseInt(object.endTime, 10);
                        else if (typeof object.endTime === "number")
                            message.endTime = object.endTime;
                        else if (typeof object.endTime === "object")
                            message.endTime = new $util.LongBits(object.endTime.low >>> 0, object.endTime.high >>> 0).toNumber();
                    if (object.kenkoDetails != null) {
                        if (typeof object.kenkoDetails !== "object")
                            throw TypeError(".space.kenko.proto.CalendarEventDetailsProto.kenkoDetails: object expected");
                        message.kenkoDetails = $root.space.kenko.proto.KenkoEventDetails.fromObject(object.kenkoDetails);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CalendarEventDetailsProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {space.kenko.proto.CalendarEventDetailsProto} message CalendarEventDetailsProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CalendarEventDetailsProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.startTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.startTime = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            let long = new $util.Long(0, 0, false);
                            object.endTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.endTime = options.longs === String ? "0" : 0;
                        object.kenkoDetails = null;
                    }
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        if (typeof message.startTime === "number")
                            object.startTime = options.longs === String ? String(message.startTime) : message.startTime;
                        else
                            object.startTime = options.longs === String ? $util.Long.prototype.toString.call(message.startTime) : options.longs === Number ? new $util.LongBits(message.startTime.low >>> 0, message.startTime.high >>> 0).toNumber() : message.startTime;
                    if (message.endTime != null && message.hasOwnProperty("endTime"))
                        if (typeof message.endTime === "number")
                            object.endTime = options.longs === String ? String(message.endTime) : message.endTime;
                        else
                            object.endTime = options.longs === String ? $util.Long.prototype.toString.call(message.endTime) : options.longs === Number ? new $util.LongBits(message.endTime.low >>> 0, message.endTime.high >>> 0).toNumber() : message.endTime;
                    if (message.kenkoDetails != null && message.hasOwnProperty("kenkoDetails"))
                        object.kenkoDetails = $root.space.kenko.proto.KenkoEventDetails.toObject(message.kenkoDetails, options);
                    return object;
                };

                /**
                 * Converts this CalendarEventDetailsProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CalendarEventDetailsProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for CalendarEventDetailsProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.CalendarEventDetailsProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                CalendarEventDetailsProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.CalendarEventDetailsProto";
                };

                return CalendarEventDetailsProto;
            })();

            proto.KenkoEventDetails = (function() {

                /**
                 * Properties of a KenkoEventDetails.
                 * @memberof space.kenko.proto
                 * @interface IKenkoEventDetails
                 * @property {space.kenko.proto.IAvailabilityEventType|null} [availability] KenkoEventDetails availability
                 * @property {space.kenko.proto.IClassEventType|null} ["class"] KenkoEventDetails class
                 */

                /**
                 * Constructs a new KenkoEventDetails.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a KenkoEventDetails.
                 * @implements IKenkoEventDetails
                 * @constructor
                 * @param {space.kenko.proto.IKenkoEventDetails=} [properties] Properties to set
                 */
                function KenkoEventDetails(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * KenkoEventDetails availability.
                 * @member {space.kenko.proto.IAvailabilityEventType|null|undefined} availability
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @instance
                 */
                KenkoEventDetails.prototype.availability = null;

                /**
                 * KenkoEventDetails class.
                 * @member {space.kenko.proto.IClassEventType|null|undefined} class
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @instance
                 */
                KenkoEventDetails.prototype["class"] = null;

                // OneOf field names bound to virtual getters and setters
                let $oneOfFields;

                /**
                 * KenkoEventDetails EventType.
                 * @member {"availability"|"class"|undefined} EventType
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @instance
                 */
                Object.defineProperty(KenkoEventDetails.prototype, "EventType", {
                    get: $util.oneOfGetter($oneOfFields = ["availability", "class"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new KenkoEventDetails instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {space.kenko.proto.IKenkoEventDetails=} [properties] Properties to set
                 * @returns {space.kenko.proto.KenkoEventDetails} KenkoEventDetails instance
                 */
                KenkoEventDetails.create = function create(properties) {
                    return new KenkoEventDetails(properties);
                };

                /**
                 * Encodes the specified KenkoEventDetails message. Does not implicitly {@link space.kenko.proto.KenkoEventDetails.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {space.kenko.proto.IKenkoEventDetails} message KenkoEventDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KenkoEventDetails.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.availability != null && Object.hasOwnProperty.call(message, "availability"))
                        $root.space.kenko.proto.AvailabilityEventType.encode(message.availability, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message["class"] != null && Object.hasOwnProperty.call(message, "class"))
                        $root.space.kenko.proto.ClassEventType.encode(message["class"], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified KenkoEventDetails message, length delimited. Does not implicitly {@link space.kenko.proto.KenkoEventDetails.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {space.kenko.proto.IKenkoEventDetails} message KenkoEventDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                KenkoEventDetails.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a KenkoEventDetails message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.KenkoEventDetails} KenkoEventDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KenkoEventDetails.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.KenkoEventDetails();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 11: {
                                message.availability = $root.space.kenko.proto.AvailabilityEventType.decode(reader, reader.uint32());
                                break;
                            }
                        case 13: {
                                message["class"] = $root.space.kenko.proto.ClassEventType.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a KenkoEventDetails message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.KenkoEventDetails} KenkoEventDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                KenkoEventDetails.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a KenkoEventDetails message.
                 * @function verify
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                KenkoEventDetails.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    let properties = {};
                    if (message.availability != null && message.hasOwnProperty("availability")) {
                        properties.EventType = 1;
                        {
                            let error = $root.space.kenko.proto.AvailabilityEventType.verify(message.availability);
                            if (error)
                                return "availability." + error;
                        }
                    }
                    if (message["class"] != null && message.hasOwnProperty("class")) {
                        if (properties.EventType === 1)
                            return "EventType: multiple values";
                        properties.EventType = 1;
                        {
                            let error = $root.space.kenko.proto.ClassEventType.verify(message["class"]);
                            if (error)
                                return "class." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a KenkoEventDetails message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.KenkoEventDetails} KenkoEventDetails
                 */
                KenkoEventDetails.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.KenkoEventDetails)
                        return object;
                    let message = new $root.space.kenko.proto.KenkoEventDetails();
                    if (object.availability != null) {
                        if (typeof object.availability !== "object")
                            throw TypeError(".space.kenko.proto.KenkoEventDetails.availability: object expected");
                        message.availability = $root.space.kenko.proto.AvailabilityEventType.fromObject(object.availability);
                    }
                    if (object["class"] != null) {
                        if (typeof object["class"] !== "object")
                            throw TypeError(".space.kenko.proto.KenkoEventDetails.class: object expected");
                        message["class"] = $root.space.kenko.proto.ClassEventType.fromObject(object["class"]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a KenkoEventDetails message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {space.kenko.proto.KenkoEventDetails} message KenkoEventDetails
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                KenkoEventDetails.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (message.availability != null && message.hasOwnProperty("availability")) {
                        object.availability = $root.space.kenko.proto.AvailabilityEventType.toObject(message.availability, options);
                        if (options.oneofs)
                            object.EventType = "availability";
                    }
                    if (message["class"] != null && message.hasOwnProperty("class")) {
                        object["class"] = $root.space.kenko.proto.ClassEventType.toObject(message["class"], options);
                        if (options.oneofs)
                            object.EventType = "class";
                    }
                    return object;
                };

                /**
                 * Converts this KenkoEventDetails to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                KenkoEventDetails.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for KenkoEventDetails
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.KenkoEventDetails
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                KenkoEventDetails.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.KenkoEventDetails";
                };

                return KenkoEventDetails;
            })();

            /**
             * DayOfWeekProto enum.
             * @name space.kenko.proto.DayOfWeekProto
             * @enum {number}
             * @property {number} DAY_OF_WEEK_UNKNOWN=0 DAY_OF_WEEK_UNKNOWN value
             * @property {number} MONDAY=1 MONDAY value
             * @property {number} TUESDAY=2 TUESDAY value
             * @property {number} WEDNESDAY=3 WEDNESDAY value
             * @property {number} THURSDAY=4 THURSDAY value
             * @property {number} FRIDAY=5 FRIDAY value
             * @property {number} SATURDAY=6 SATURDAY value
             * @property {number} SUNDAY=7 SUNDAY value
             */
            proto.DayOfWeekProto = (function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "DAY_OF_WEEK_UNKNOWN"] = 0;
                values[valuesById[1] = "MONDAY"] = 1;
                values[valuesById[2] = "TUESDAY"] = 2;
                values[valuesById[3] = "WEDNESDAY"] = 3;
                values[valuesById[4] = "THURSDAY"] = 4;
                values[valuesById[5] = "FRIDAY"] = 5;
                values[valuesById[6] = "SATURDAY"] = 6;
                values[valuesById[7] = "SUNDAY"] = 7;
                return values;
            })();

            proto.NoRepeatSchedule = (function() {

                /**
                 * Properties of a NoRepeatSchedule.
                 * @memberof space.kenko.proto
                 * @interface INoRepeatSchedule
                 */

                /**
                 * Constructs a new NoRepeatSchedule.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a NoRepeatSchedule.
                 * @implements INoRepeatSchedule
                 * @constructor
                 * @param {space.kenko.proto.INoRepeatSchedule=} [properties] Properties to set
                 */
                function NoRepeatSchedule(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new NoRepeatSchedule instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.INoRepeatSchedule=} [properties] Properties to set
                 * @returns {space.kenko.proto.NoRepeatSchedule} NoRepeatSchedule instance
                 */
                NoRepeatSchedule.create = function create(properties) {
                    return new NoRepeatSchedule(properties);
                };

                /**
                 * Encodes the specified NoRepeatSchedule message. Does not implicitly {@link space.kenko.proto.NoRepeatSchedule.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.INoRepeatSchedule} message NoRepeatSchedule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NoRepeatSchedule.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified NoRepeatSchedule message, length delimited. Does not implicitly {@link space.kenko.proto.NoRepeatSchedule.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.INoRepeatSchedule} message NoRepeatSchedule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NoRepeatSchedule.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NoRepeatSchedule message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.NoRepeatSchedule} NoRepeatSchedule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NoRepeatSchedule.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.NoRepeatSchedule();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NoRepeatSchedule message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.NoRepeatSchedule} NoRepeatSchedule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NoRepeatSchedule.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NoRepeatSchedule message.
                 * @function verify
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NoRepeatSchedule.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a NoRepeatSchedule message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.NoRepeatSchedule} NoRepeatSchedule
                 */
                NoRepeatSchedule.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.NoRepeatSchedule)
                        return object;
                    return new $root.space.kenko.proto.NoRepeatSchedule();
                };

                /**
                 * Creates a plain object from a NoRepeatSchedule message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.NoRepeatSchedule} message NoRepeatSchedule
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NoRepeatSchedule.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this NoRepeatSchedule to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NoRepeatSchedule.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for NoRepeatSchedule
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.NoRepeatSchedule
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                NoRepeatSchedule.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.NoRepeatSchedule";
                };

                return NoRepeatSchedule;
            })();

            proto.WeeklyRepeatSchedule = (function() {

                /**
                 * Properties of a WeeklyRepeatSchedule.
                 * @memberof space.kenko.proto
                 * @interface IWeeklyRepeatSchedule
                 * @property {number|null} [repeatPeriodWeeks] WeeklyRepeatSchedule repeatPeriodWeeks
                 * @property {number|null} [daysOfWeekBitmask] WeeklyRepeatSchedule daysOfWeekBitmask
                 * @property {space.kenko.proto.ILocalDateProto|null} [endDate] WeeklyRepeatSchedule endDate
                 */

                /**
                 * Constructs a new WeeklyRepeatSchedule.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a WeeklyRepeatSchedule.
                 * @implements IWeeklyRepeatSchedule
                 * @constructor
                 * @param {space.kenko.proto.IWeeklyRepeatSchedule=} [properties] Properties to set
                 */
                function WeeklyRepeatSchedule(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * WeeklyRepeatSchedule repeatPeriodWeeks.
                 * @member {number} repeatPeriodWeeks
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @instance
                 */
                WeeklyRepeatSchedule.prototype.repeatPeriodWeeks = 0;

                /**
                 * WeeklyRepeatSchedule daysOfWeekBitmask.
                 * @member {number} daysOfWeekBitmask
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @instance
                 */
                WeeklyRepeatSchedule.prototype.daysOfWeekBitmask = 0;

                /**
                 * WeeklyRepeatSchedule endDate.
                 * @member {space.kenko.proto.ILocalDateProto|null|undefined} endDate
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @instance
                 */
                WeeklyRepeatSchedule.prototype.endDate = null;

                /**
                 * Creates a new WeeklyRepeatSchedule instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.IWeeklyRepeatSchedule=} [properties] Properties to set
                 * @returns {space.kenko.proto.WeeklyRepeatSchedule} WeeklyRepeatSchedule instance
                 */
                WeeklyRepeatSchedule.create = function create(properties) {
                    return new WeeklyRepeatSchedule(properties);
                };

                /**
                 * Encodes the specified WeeklyRepeatSchedule message. Does not implicitly {@link space.kenko.proto.WeeklyRepeatSchedule.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.IWeeklyRepeatSchedule} message WeeklyRepeatSchedule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WeeklyRepeatSchedule.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.repeatPeriodWeeks != null && Object.hasOwnProperty.call(message, "repeatPeriodWeeks"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.repeatPeriodWeeks);
                    if (message.daysOfWeekBitmask != null && Object.hasOwnProperty.call(message, "daysOfWeekBitmask"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.daysOfWeekBitmask);
                    if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                        $root.space.kenko.proto.LocalDateProto.encode(message.endDate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified WeeklyRepeatSchedule message, length delimited. Does not implicitly {@link space.kenko.proto.WeeklyRepeatSchedule.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.IWeeklyRepeatSchedule} message WeeklyRepeatSchedule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WeeklyRepeatSchedule.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a WeeklyRepeatSchedule message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.WeeklyRepeatSchedule} WeeklyRepeatSchedule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WeeklyRepeatSchedule.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.WeeklyRepeatSchedule();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.repeatPeriodWeeks = reader.uint32();
                                break;
                            }
                        case 2: {
                                message.daysOfWeekBitmask = reader.int32();
                                break;
                            }
                        case 3: {
                                message.endDate = $root.space.kenko.proto.LocalDateProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a WeeklyRepeatSchedule message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.WeeklyRepeatSchedule} WeeklyRepeatSchedule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WeeklyRepeatSchedule.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a WeeklyRepeatSchedule message.
                 * @function verify
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WeeklyRepeatSchedule.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.repeatPeriodWeeks != null && message.hasOwnProperty("repeatPeriodWeeks"))
                        if (!$util.isInteger(message.repeatPeriodWeeks))
                            return "repeatPeriodWeeks: integer expected";
                    if (message.daysOfWeekBitmask != null && message.hasOwnProperty("daysOfWeekBitmask"))
                        if (!$util.isInteger(message.daysOfWeekBitmask))
                            return "daysOfWeekBitmask: integer expected";
                    if (message.endDate != null && message.hasOwnProperty("endDate")) {
                        let error = $root.space.kenko.proto.LocalDateProto.verify(message.endDate);
                        if (error)
                            return "endDate." + error;
                    }
                    return null;
                };

                /**
                 * Creates a WeeklyRepeatSchedule message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.WeeklyRepeatSchedule} WeeklyRepeatSchedule
                 */
                WeeklyRepeatSchedule.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.WeeklyRepeatSchedule)
                        return object;
                    let message = new $root.space.kenko.proto.WeeklyRepeatSchedule();
                    if (object.repeatPeriodWeeks != null)
                        message.repeatPeriodWeeks = object.repeatPeriodWeeks >>> 0;
                    if (object.daysOfWeekBitmask != null)
                        message.daysOfWeekBitmask = object.daysOfWeekBitmask | 0;
                    if (object.endDate != null) {
                        if (typeof object.endDate !== "object")
                            throw TypeError(".space.kenko.proto.WeeklyRepeatSchedule.endDate: object expected");
                        message.endDate = $root.space.kenko.proto.LocalDateProto.fromObject(object.endDate);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a WeeklyRepeatSchedule message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {space.kenko.proto.WeeklyRepeatSchedule} message WeeklyRepeatSchedule
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WeeklyRepeatSchedule.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.repeatPeriodWeeks = 0;
                        object.daysOfWeekBitmask = 0;
                        object.endDate = null;
                    }
                    if (message.repeatPeriodWeeks != null && message.hasOwnProperty("repeatPeriodWeeks"))
                        object.repeatPeriodWeeks = message.repeatPeriodWeeks;
                    if (message.daysOfWeekBitmask != null && message.hasOwnProperty("daysOfWeekBitmask"))
                        object.daysOfWeekBitmask = message.daysOfWeekBitmask;
                    if (message.endDate != null && message.hasOwnProperty("endDate"))
                        object.endDate = $root.space.kenko.proto.LocalDateProto.toObject(message.endDate, options);
                    return object;
                };

                /**
                 * Converts this WeeklyRepeatSchedule to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WeeklyRepeatSchedule.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for WeeklyRepeatSchedule
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.WeeklyRepeatSchedule
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                WeeklyRepeatSchedule.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.WeeklyRepeatSchedule";
                };

                return WeeklyRepeatSchedule;
            })();

            proto.AvailabilityEventType = (function() {

                /**
                 * Properties of an AvailabilityEventType.
                 * @memberof space.kenko.proto
                 * @interface IAvailabilityEventType
                 * @property {string|null} [practitionerId] AvailabilityEventType practitionerId
                 * @property {string|null} [locationId] AvailabilityEventType locationId
                 */

                /**
                 * Constructs a new AvailabilityEventType.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an AvailabilityEventType.
                 * @implements IAvailabilityEventType
                 * @constructor
                 * @param {space.kenko.proto.IAvailabilityEventType=} [properties] Properties to set
                 */
                function AvailabilityEventType(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AvailabilityEventType practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @instance
                 */
                AvailabilityEventType.prototype.practitionerId = "";

                /**
                 * AvailabilityEventType locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @instance
                 */
                AvailabilityEventType.prototype.locationId = "";

                /**
                 * Creates a new AvailabilityEventType instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {space.kenko.proto.IAvailabilityEventType=} [properties] Properties to set
                 * @returns {space.kenko.proto.AvailabilityEventType} AvailabilityEventType instance
                 */
                AvailabilityEventType.create = function create(properties) {
                    return new AvailabilityEventType(properties);
                };

                /**
                 * Encodes the specified AvailabilityEventType message. Does not implicitly {@link space.kenko.proto.AvailabilityEventType.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {space.kenko.proto.IAvailabilityEventType} message AvailabilityEventType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AvailabilityEventType.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.locationId);
                    return writer;
                };

                /**
                 * Encodes the specified AvailabilityEventType message, length delimited. Does not implicitly {@link space.kenko.proto.AvailabilityEventType.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {space.kenko.proto.IAvailabilityEventType} message AvailabilityEventType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AvailabilityEventType.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AvailabilityEventType message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.AvailabilityEventType} AvailabilityEventType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AvailabilityEventType.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.AvailabilityEventType();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.locationId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AvailabilityEventType message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.AvailabilityEventType} AvailabilityEventType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AvailabilityEventType.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AvailabilityEventType message.
                 * @function verify
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AvailabilityEventType.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    return null;
                };

                /**
                 * Creates an AvailabilityEventType message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.AvailabilityEventType} AvailabilityEventType
                 */
                AvailabilityEventType.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.AvailabilityEventType)
                        return object;
                    let message = new $root.space.kenko.proto.AvailabilityEventType();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    return message;
                };

                /**
                 * Creates a plain object from an AvailabilityEventType message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {space.kenko.proto.AvailabilityEventType} message AvailabilityEventType
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AvailabilityEventType.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.locationId = "";
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    return object;
                };

                /**
                 * Converts this AvailabilityEventType to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AvailabilityEventType.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AvailabilityEventType
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.AvailabilityEventType
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AvailabilityEventType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.AvailabilityEventType";
                };

                return AvailabilityEventType;
            })();

            proto.AppointmentEventType = (function() {

                /**
                 * Properties of an AppointmentEventType.
                 * @memberof space.kenko.proto
                 * @interface IAppointmentEventType
                 * @property {string|null} [practitionerId] AppointmentEventType practitionerId
                 * @property {string|null} [practitionerName] AppointmentEventType practitionerName
                 * @property {string|null} [serviceId] AppointmentEventType serviceId
                 * @property {string|null} [serviceName] AppointmentEventType serviceName
                 * @property {string|null} [locationId] AppointmentEventType locationId
                 * @property {string|null} [locationName] AppointmentEventType locationName
                 * @property {string|null} [locationAddress] AppointmentEventType locationAddress
                 * @property {string|null} [clientUserId] AppointmentEventType clientUserId
                 * @property {string|null} [clientName] AppointmentEventType clientName
                 * @property {string|null} [clientPhone] AppointmentEventType clientPhone
                 * @property {string|null} [clientEmail] AppointmentEventType clientEmail
                 */

                /**
                 * Constructs a new AppointmentEventType.
                 * @memberof space.kenko.proto
                 * @classdesc Represents an AppointmentEventType.
                 * @implements IAppointmentEventType
                 * @constructor
                 * @param {space.kenko.proto.IAppointmentEventType=} [properties] Properties to set
                 */
                function AppointmentEventType(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AppointmentEventType practitionerId.
                 * @member {string} practitionerId
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.practitionerId = "";

                /**
                 * AppointmentEventType practitionerName.
                 * @member {string} practitionerName
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.practitionerName = "";

                /**
                 * AppointmentEventType serviceId.
                 * @member {string} serviceId
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.serviceId = "";

                /**
                 * AppointmentEventType serviceName.
                 * @member {string} serviceName
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.serviceName = "";

                /**
                 * AppointmentEventType locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.locationId = "";

                /**
                 * AppointmentEventType locationName.
                 * @member {string} locationName
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.locationName = "";

                /**
                 * AppointmentEventType locationAddress.
                 * @member {string} locationAddress
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.locationAddress = "";

                /**
                 * AppointmentEventType clientUserId.
                 * @member {string} clientUserId
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.clientUserId = "";

                /**
                 * AppointmentEventType clientName.
                 * @member {string} clientName
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.clientName = "";

                /**
                 * AppointmentEventType clientPhone.
                 * @member {string} clientPhone
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.clientPhone = "";

                /**
                 * AppointmentEventType clientEmail.
                 * @member {string} clientEmail
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 */
                AppointmentEventType.prototype.clientEmail = "";

                /**
                 * Creates a new AppointmentEventType instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {space.kenko.proto.IAppointmentEventType=} [properties] Properties to set
                 * @returns {space.kenko.proto.AppointmentEventType} AppointmentEventType instance
                 */
                AppointmentEventType.create = function create(properties) {
                    return new AppointmentEventType(properties);
                };

                /**
                 * Encodes the specified AppointmentEventType message. Does not implicitly {@link space.kenko.proto.AppointmentEventType.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {space.kenko.proto.IAppointmentEventType} message AppointmentEventType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AppointmentEventType.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.practitionerId != null && Object.hasOwnProperty.call(message, "practitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.practitionerId);
                    if (message.practitionerName != null && Object.hasOwnProperty.call(message, "practitionerName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.practitionerName);
                    if (message.serviceId != null && Object.hasOwnProperty.call(message, "serviceId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.serviceId);
                    if (message.serviceName != null && Object.hasOwnProperty.call(message, "serviceName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.serviceName);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.locationId);
                    if (message.locationName != null && Object.hasOwnProperty.call(message, "locationName"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.locationName);
                    if (message.locationAddress != null && Object.hasOwnProperty.call(message, "locationAddress"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.locationAddress);
                    if (message.clientUserId != null && Object.hasOwnProperty.call(message, "clientUserId"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.clientUserId);
                    if (message.clientName != null && Object.hasOwnProperty.call(message, "clientName"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.clientName);
                    if (message.clientPhone != null && Object.hasOwnProperty.call(message, "clientPhone"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.clientPhone);
                    if (message.clientEmail != null && Object.hasOwnProperty.call(message, "clientEmail"))
                        writer.uint32(/* id 13, wireType 2 =*/106).string(message.clientEmail);
                    return writer;
                };

                /**
                 * Encodes the specified AppointmentEventType message, length delimited. Does not implicitly {@link space.kenko.proto.AppointmentEventType.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {space.kenko.proto.IAppointmentEventType} message AppointmentEventType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AppointmentEventType.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AppointmentEventType message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.AppointmentEventType} AppointmentEventType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AppointmentEventType.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.AppointmentEventType();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.practitionerId = reader.string();
                                break;
                            }
                        case 2: {
                                message.practitionerName = reader.string();
                                break;
                            }
                        case 3: {
                                message.serviceId = reader.string();
                                break;
                            }
                        case 4: {
                                message.serviceName = reader.string();
                                break;
                            }
                        case 5: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 6: {
                                message.locationName = reader.string();
                                break;
                            }
                        case 7: {
                                message.locationAddress = reader.string();
                                break;
                            }
                        case 10: {
                                message.clientUserId = reader.string();
                                break;
                            }
                        case 11: {
                                message.clientName = reader.string();
                                break;
                            }
                        case 12: {
                                message.clientPhone = reader.string();
                                break;
                            }
                        case 13: {
                                message.clientEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AppointmentEventType message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.AppointmentEventType} AppointmentEventType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AppointmentEventType.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AppointmentEventType message.
                 * @function verify
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AppointmentEventType.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        if (!$util.isString(message.practitionerId))
                            return "practitionerId: string expected";
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        if (!$util.isString(message.practitionerName))
                            return "practitionerName: string expected";
                    if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                        if (!$util.isString(message.serviceId))
                            return "serviceId: string expected";
                    if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                        if (!$util.isString(message.serviceName))
                            return "serviceName: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        if (!$util.isString(message.locationName))
                            return "locationName: string expected";
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                        if (!$util.isString(message.locationAddress))
                            return "locationAddress: string expected";
                    if (message.clientUserId != null && message.hasOwnProperty("clientUserId"))
                        if (!$util.isString(message.clientUserId))
                            return "clientUserId: string expected";
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        if (!$util.isString(message.clientName))
                            return "clientName: string expected";
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        if (!$util.isString(message.clientPhone))
                            return "clientPhone: string expected";
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        if (!$util.isString(message.clientEmail))
                            return "clientEmail: string expected";
                    return null;
                };

                /**
                 * Creates an AppointmentEventType message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.AppointmentEventType} AppointmentEventType
                 */
                AppointmentEventType.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.AppointmentEventType)
                        return object;
                    let message = new $root.space.kenko.proto.AppointmentEventType();
                    if (object.practitionerId != null)
                        message.practitionerId = String(object.practitionerId);
                    if (object.practitionerName != null)
                        message.practitionerName = String(object.practitionerName);
                    if (object.serviceId != null)
                        message.serviceId = String(object.serviceId);
                    if (object.serviceName != null)
                        message.serviceName = String(object.serviceName);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.locationName != null)
                        message.locationName = String(object.locationName);
                    if (object.locationAddress != null)
                        message.locationAddress = String(object.locationAddress);
                    if (object.clientUserId != null)
                        message.clientUserId = String(object.clientUserId);
                    if (object.clientName != null)
                        message.clientName = String(object.clientName);
                    if (object.clientPhone != null)
                        message.clientPhone = String(object.clientPhone);
                    if (object.clientEmail != null)
                        message.clientEmail = String(object.clientEmail);
                    return message;
                };

                /**
                 * Creates a plain object from an AppointmentEventType message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {space.kenko.proto.AppointmentEventType} message AppointmentEventType
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AppointmentEventType.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.practitionerId = "";
                        object.practitionerName = "";
                        object.serviceId = "";
                        object.serviceName = "";
                        object.locationId = "";
                        object.locationName = "";
                        object.locationAddress = "";
                        object.clientUserId = "";
                        object.clientName = "";
                        object.clientPhone = "";
                        object.clientEmail = "";
                    }
                    if (message.practitionerId != null && message.hasOwnProperty("practitionerId"))
                        object.practitionerId = message.practitionerId;
                    if (message.practitionerName != null && message.hasOwnProperty("practitionerName"))
                        object.practitionerName = message.practitionerName;
                    if (message.serviceId != null && message.hasOwnProperty("serviceId"))
                        object.serviceId = message.serviceId;
                    if (message.serviceName != null && message.hasOwnProperty("serviceName"))
                        object.serviceName = message.serviceName;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.locationName != null && message.hasOwnProperty("locationName"))
                        object.locationName = message.locationName;
                    if (message.locationAddress != null && message.hasOwnProperty("locationAddress"))
                        object.locationAddress = message.locationAddress;
                    if (message.clientUserId != null && message.hasOwnProperty("clientUserId"))
                        object.clientUserId = message.clientUserId;
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        object.clientName = message.clientName;
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        object.clientPhone = message.clientPhone;
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        object.clientEmail = message.clientEmail;
                    return object;
                };

                /**
                 * Converts this AppointmentEventType to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AppointmentEventType.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for AppointmentEventType
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.AppointmentEventType
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                AppointmentEventType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.AppointmentEventType";
                };

                return AppointmentEventType;
            })();

            proto.ClassEventType = (function() {

                /**
                 * Properties of a ClassEventType.
                 * @memberof space.kenko.proto
                 * @interface IClassEventType
                 * @property {string|null} [teacherPractitionerId] ClassEventType teacherPractitionerId
                 * @property {string|null} [className] ClassEventType className
                 * @property {string|null} [locationId] ClassEventType locationId
                 * @property {number|null} [maxAttendees] ClassEventType maxAttendees
                 * @property {space.kenko.proto.IPaymentPolicyProto|null} [paymentPolicy] ClassEventType paymentPolicy
                 * @property {string|null} [classTemplateId] ClassEventType classTemplateId
                 */

                /**
                 * Constructs a new ClassEventType.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClassEventType.
                 * @implements IClassEventType
                 * @constructor
                 * @param {space.kenko.proto.IClassEventType=} [properties] Properties to set
                 */
                function ClassEventType(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClassEventType teacherPractitionerId.
                 * @member {string} teacherPractitionerId
                 * @memberof space.kenko.proto.ClassEventType
                 * @instance
                 */
                ClassEventType.prototype.teacherPractitionerId = "";

                /**
                 * ClassEventType className.
                 * @member {string} className
                 * @memberof space.kenko.proto.ClassEventType
                 * @instance
                 */
                ClassEventType.prototype.className = "";

                /**
                 * ClassEventType locationId.
                 * @member {string} locationId
                 * @memberof space.kenko.proto.ClassEventType
                 * @instance
                 */
                ClassEventType.prototype.locationId = "";

                /**
                 * ClassEventType maxAttendees.
                 * @member {number} maxAttendees
                 * @memberof space.kenko.proto.ClassEventType
                 * @instance
                 */
                ClassEventType.prototype.maxAttendees = 0;

                /**
                 * ClassEventType paymentPolicy.
                 * @member {space.kenko.proto.IPaymentPolicyProto|null|undefined} paymentPolicy
                 * @memberof space.kenko.proto.ClassEventType
                 * @instance
                 */
                ClassEventType.prototype.paymentPolicy = null;

                /**
                 * ClassEventType classTemplateId.
                 * @member {string} classTemplateId
                 * @memberof space.kenko.proto.ClassEventType
                 * @instance
                 */
                ClassEventType.prototype.classTemplateId = "";

                /**
                 * Creates a new ClassEventType instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {space.kenko.proto.IClassEventType=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClassEventType} ClassEventType instance
                 */
                ClassEventType.create = function create(properties) {
                    return new ClassEventType(properties);
                };

                /**
                 * Encodes the specified ClassEventType message. Does not implicitly {@link space.kenko.proto.ClassEventType.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {space.kenko.proto.IClassEventType} message ClassEventType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassEventType.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.teacherPractitionerId != null && Object.hasOwnProperty.call(message, "teacherPractitionerId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.teacherPractitionerId);
                    if (message.className != null && Object.hasOwnProperty.call(message, "className"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.className);
                    if (message.locationId != null && Object.hasOwnProperty.call(message, "locationId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.locationId);
                    if (message.maxAttendees != null && Object.hasOwnProperty.call(message, "maxAttendees"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.maxAttendees);
                    if (message.paymentPolicy != null && Object.hasOwnProperty.call(message, "paymentPolicy"))
                        $root.space.kenko.proto.PaymentPolicyProto.encode(message.paymentPolicy, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.classTemplateId != null && Object.hasOwnProperty.call(message, "classTemplateId"))
                        writer.uint32(/* id 13, wireType 2 =*/106).string(message.classTemplateId);
                    return writer;
                };

                /**
                 * Encodes the specified ClassEventType message, length delimited. Does not implicitly {@link space.kenko.proto.ClassEventType.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {space.kenko.proto.IClassEventType} message ClassEventType message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClassEventType.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClassEventType message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClassEventType} ClassEventType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassEventType.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClassEventType();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.teacherPractitionerId = reader.string();
                                break;
                            }
                        case 4: {
                                message.className = reader.string();
                                break;
                            }
                        case 5: {
                                message.locationId = reader.string();
                                break;
                            }
                        case 7: {
                                message.maxAttendees = reader.int32();
                                break;
                            }
                        case 12: {
                                message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.decode(reader, reader.uint32());
                                break;
                            }
                        case 13: {
                                message.classTemplateId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClassEventType message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClassEventType} ClassEventType
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClassEventType.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClassEventType message.
                 * @function verify
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClassEventType.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.teacherPractitionerId != null && message.hasOwnProperty("teacherPractitionerId"))
                        if (!$util.isString(message.teacherPractitionerId))
                            return "teacherPractitionerId: string expected";
                    if (message.className != null && message.hasOwnProperty("className"))
                        if (!$util.isString(message.className))
                            return "className: string expected";
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        if (!$util.isString(message.locationId))
                            return "locationId: string expected";
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        if (!$util.isInteger(message.maxAttendees))
                            return "maxAttendees: integer expected";
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy")) {
                        let error = $root.space.kenko.proto.PaymentPolicyProto.verify(message.paymentPolicy);
                        if (error)
                            return "paymentPolicy." + error;
                    }
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        if (!$util.isString(message.classTemplateId))
                            return "classTemplateId: string expected";
                    return null;
                };

                /**
                 * Creates a ClassEventType message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClassEventType} ClassEventType
                 */
                ClassEventType.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClassEventType)
                        return object;
                    let message = new $root.space.kenko.proto.ClassEventType();
                    if (object.teacherPractitionerId != null)
                        message.teacherPractitionerId = String(object.teacherPractitionerId);
                    if (object.className != null)
                        message.className = String(object.className);
                    if (object.locationId != null)
                        message.locationId = String(object.locationId);
                    if (object.maxAttendees != null)
                        message.maxAttendees = object.maxAttendees | 0;
                    if (object.paymentPolicy != null) {
                        if (typeof object.paymentPolicy !== "object")
                            throw TypeError(".space.kenko.proto.ClassEventType.paymentPolicy: object expected");
                        message.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.fromObject(object.paymentPolicy);
                    }
                    if (object.classTemplateId != null)
                        message.classTemplateId = String(object.classTemplateId);
                    return message;
                };

                /**
                 * Creates a plain object from a ClassEventType message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {space.kenko.proto.ClassEventType} message ClassEventType
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClassEventType.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.teacherPractitionerId = "";
                        object.className = "";
                        object.locationId = "";
                        object.maxAttendees = 0;
                        object.paymentPolicy = null;
                        object.classTemplateId = "";
                    }
                    if (message.teacherPractitionerId != null && message.hasOwnProperty("teacherPractitionerId"))
                        object.teacherPractitionerId = message.teacherPractitionerId;
                    if (message.className != null && message.hasOwnProperty("className"))
                        object.className = message.className;
                    if (message.locationId != null && message.hasOwnProperty("locationId"))
                        object.locationId = message.locationId;
                    if (message.maxAttendees != null && message.hasOwnProperty("maxAttendees"))
                        object.maxAttendees = message.maxAttendees;
                    if (message.paymentPolicy != null && message.hasOwnProperty("paymentPolicy"))
                        object.paymentPolicy = $root.space.kenko.proto.PaymentPolicyProto.toObject(message.paymentPolicy, options);
                    if (message.classTemplateId != null && message.hasOwnProperty("classTemplateId"))
                        object.classTemplateId = message.classTemplateId;
                    return object;
                };

                /**
                 * Converts this ClassEventType to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClassEventType
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClassEventType.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClassEventType
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClassEventType
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClassEventType.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClassEventType";
                };

                return ClassEventType;
            })();

            proto.ClientInfoProto = (function() {

                /**
                 * Properties of a ClientInfoProto.
                 * @memberof space.kenko.proto
                 * @interface IClientInfoProto
                 * @property {string|null} [clientUserId] ClientInfoProto clientUserId
                 * @property {string|null} [clientName] ClientInfoProto clientName
                 * @property {string|null} [clientPhone] ClientInfoProto clientPhone
                 * @property {string|null} [clientEmail] ClientInfoProto clientEmail
                 */

                /**
                 * Constructs a new ClientInfoProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ClientInfoProto.
                 * @implements IClientInfoProto
                 * @constructor
                 * @param {space.kenko.proto.IClientInfoProto=} [properties] Properties to set
                 */
                function ClientInfoProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ClientInfoProto clientUserId.
                 * @member {string} clientUserId
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @instance
                 */
                ClientInfoProto.prototype.clientUserId = "";

                /**
                 * ClientInfoProto clientName.
                 * @member {string} clientName
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @instance
                 */
                ClientInfoProto.prototype.clientName = "";

                /**
                 * ClientInfoProto clientPhone.
                 * @member {string} clientPhone
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @instance
                 */
                ClientInfoProto.prototype.clientPhone = "";

                /**
                 * ClientInfoProto clientEmail.
                 * @member {string} clientEmail
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @instance
                 */
                ClientInfoProto.prototype.clientEmail = "";

                /**
                 * Creates a new ClientInfoProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {space.kenko.proto.IClientInfoProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ClientInfoProto} ClientInfoProto instance
                 */
                ClientInfoProto.create = function create(properties) {
                    return new ClientInfoProto(properties);
                };

                /**
                 * Encodes the specified ClientInfoProto message. Does not implicitly {@link space.kenko.proto.ClientInfoProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {space.kenko.proto.IClientInfoProto} message ClientInfoProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClientInfoProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.clientUserId != null && Object.hasOwnProperty.call(message, "clientUserId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientUserId);
                    if (message.clientName != null && Object.hasOwnProperty.call(message, "clientName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.clientName);
                    if (message.clientPhone != null && Object.hasOwnProperty.call(message, "clientPhone"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.clientPhone);
                    if (message.clientEmail != null && Object.hasOwnProperty.call(message, "clientEmail"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.clientEmail);
                    return writer;
                };

                /**
                 * Encodes the specified ClientInfoProto message, length delimited. Does not implicitly {@link space.kenko.proto.ClientInfoProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {space.kenko.proto.IClientInfoProto} message ClientInfoProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ClientInfoProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ClientInfoProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ClientInfoProto} ClientInfoProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClientInfoProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ClientInfoProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.clientUserId = reader.string();
                                break;
                            }
                        case 2: {
                                message.clientName = reader.string();
                                break;
                            }
                        case 3: {
                                message.clientPhone = reader.string();
                                break;
                            }
                        case 4: {
                                message.clientEmail = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ClientInfoProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ClientInfoProto} ClientInfoProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ClientInfoProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ClientInfoProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ClientInfoProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.clientUserId != null && message.hasOwnProperty("clientUserId"))
                        if (!$util.isString(message.clientUserId))
                            return "clientUserId: string expected";
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        if (!$util.isString(message.clientName))
                            return "clientName: string expected";
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        if (!$util.isString(message.clientPhone))
                            return "clientPhone: string expected";
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        if (!$util.isString(message.clientEmail))
                            return "clientEmail: string expected";
                    return null;
                };

                /**
                 * Creates a ClientInfoProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ClientInfoProto} ClientInfoProto
                 */
                ClientInfoProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ClientInfoProto)
                        return object;
                    let message = new $root.space.kenko.proto.ClientInfoProto();
                    if (object.clientUserId != null)
                        message.clientUserId = String(object.clientUserId);
                    if (object.clientName != null)
                        message.clientName = String(object.clientName);
                    if (object.clientPhone != null)
                        message.clientPhone = String(object.clientPhone);
                    if (object.clientEmail != null)
                        message.clientEmail = String(object.clientEmail);
                    return message;
                };

                /**
                 * Creates a plain object from a ClientInfoProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {space.kenko.proto.ClientInfoProto} message ClientInfoProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ClientInfoProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.clientUserId = "";
                        object.clientName = "";
                        object.clientPhone = "";
                        object.clientEmail = "";
                    }
                    if (message.clientUserId != null && message.hasOwnProperty("clientUserId"))
                        object.clientUserId = message.clientUserId;
                    if (message.clientName != null && message.hasOwnProperty("clientName"))
                        object.clientName = message.clientName;
                    if (message.clientPhone != null && message.hasOwnProperty("clientPhone"))
                        object.clientPhone = message.clientPhone;
                    if (message.clientEmail != null && message.hasOwnProperty("clientEmail"))
                        object.clientEmail = message.clientEmail;
                    return object;
                };

                /**
                 * Converts this ClientInfoProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ClientInfoProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ClientInfoProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ClientInfoProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ClientInfoProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ClientInfoProto";
                };

                return ClientInfoProto;
            })();

            proto.RequestEnvelopeProto = (function() {

                /**
                 * Properties of a RequestEnvelopeProto.
                 * @memberof space.kenko.proto
                 * @interface IRequestEnvelopeProto
                 * @property {string|null} [authToken] RequestEnvelopeProto authToken
                 * @property {Uint8Array|null} [requestMessage] RequestEnvelopeProto requestMessage
                 * @property {space.kenko.proto.IProviderContextProto|null} [impersonation] RequestEnvelopeProto impersonation
                 */

                /**
                 * Constructs a new RequestEnvelopeProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a RequestEnvelopeProto.
                 * @implements IRequestEnvelopeProto
                 * @constructor
                 * @param {space.kenko.proto.IRequestEnvelopeProto=} [properties] Properties to set
                 */
                function RequestEnvelopeProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RequestEnvelopeProto authToken.
                 * @member {string} authToken
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.authToken = "";

                /**
                 * RequestEnvelopeProto requestMessage.
                 * @member {Uint8Array} requestMessage
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.requestMessage = $util.newBuffer([]);

                /**
                 * RequestEnvelopeProto impersonation.
                 * @member {space.kenko.proto.IProviderContextProto|null|undefined} impersonation
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 */
                RequestEnvelopeProto.prototype.impersonation = null;

                /**
                 * Creates a new RequestEnvelopeProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto instance
                 */
                RequestEnvelopeProto.create = function create(properties) {
                    return new RequestEnvelopeProto(properties);
                };

                /**
                 * Encodes the specified RequestEnvelopeProto message. Does not implicitly {@link space.kenko.proto.RequestEnvelopeProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto} message RequestEnvelopeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RequestEnvelopeProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.authToken != null && Object.hasOwnProperty.call(message, "authToken"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.authToken);
                    if (message.requestMessage != null && Object.hasOwnProperty.call(message, "requestMessage"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.requestMessage);
                    if (message.impersonation != null && Object.hasOwnProperty.call(message, "impersonation"))
                        $root.space.kenko.proto.ProviderContextProto.encode(message.impersonation, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RequestEnvelopeProto message, length delimited. Does not implicitly {@link space.kenko.proto.RequestEnvelopeProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.IRequestEnvelopeProto} message RequestEnvelopeProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RequestEnvelopeProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RequestEnvelopeProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RequestEnvelopeProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.RequestEnvelopeProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.authToken = reader.string();
                                break;
                            }
                        case 2: {
                                message.requestMessage = reader.bytes();
                                break;
                            }
                        case 100: {
                                message.impersonation = $root.space.kenko.proto.ProviderContextProto.decode(reader, reader.uint32());
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RequestEnvelopeProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RequestEnvelopeProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RequestEnvelopeProto message.
                 * @function verify
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RequestEnvelopeProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        if (!$util.isString(message.authToken))
                            return "authToken: string expected";
                    if (message.requestMessage != null && message.hasOwnProperty("requestMessage"))
                        if (!(message.requestMessage && typeof message.requestMessage.length === "number" || $util.isString(message.requestMessage)))
                            return "requestMessage: buffer expected";
                    if (message.impersonation != null && message.hasOwnProperty("impersonation")) {
                        let error = $root.space.kenko.proto.ProviderContextProto.verify(message.impersonation);
                        if (error)
                            return "impersonation." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RequestEnvelopeProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.RequestEnvelopeProto} RequestEnvelopeProto
                 */
                RequestEnvelopeProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.RequestEnvelopeProto)
                        return object;
                    let message = new $root.space.kenko.proto.RequestEnvelopeProto();
                    if (object.authToken != null)
                        message.authToken = String(object.authToken);
                    if (object.requestMessage != null)
                        if (typeof object.requestMessage === "string")
                            $util.base64.decode(object.requestMessage, message.requestMessage = $util.newBuffer($util.base64.length(object.requestMessage)), 0);
                        else if (object.requestMessage.length >= 0)
                            message.requestMessage = object.requestMessage;
                    if (object.impersonation != null) {
                        if (typeof object.impersonation !== "object")
                            throw TypeError(".space.kenko.proto.RequestEnvelopeProto.impersonation: object expected");
                        message.impersonation = $root.space.kenko.proto.ProviderContextProto.fromObject(object.impersonation);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RequestEnvelopeProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {space.kenko.proto.RequestEnvelopeProto} message RequestEnvelopeProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RequestEnvelopeProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.authToken = "";
                        if (options.bytes === String)
                            object.requestMessage = "";
                        else {
                            object.requestMessage = [];
                            if (options.bytes !== Array)
                                object.requestMessage = $util.newBuffer(object.requestMessage);
                        }
                        object.impersonation = null;
                    }
                    if (message.authToken != null && message.hasOwnProperty("authToken"))
                        object.authToken = message.authToken;
                    if (message.requestMessage != null && message.hasOwnProperty("requestMessage"))
                        object.requestMessage = options.bytes === String ? $util.base64.encode(message.requestMessage, 0, message.requestMessage.length) : options.bytes === Array ? Array.prototype.slice.call(message.requestMessage) : message.requestMessage;
                    if (message.impersonation != null && message.hasOwnProperty("impersonation"))
                        object.impersonation = $root.space.kenko.proto.ProviderContextProto.toObject(message.impersonation, options);
                    return object;
                };

                /**
                 * Converts this RequestEnvelopeProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RequestEnvelopeProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for RequestEnvelopeProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.RequestEnvelopeProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                RequestEnvelopeProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.RequestEnvelopeProto";
                };

                return RequestEnvelopeProto;
            })();

            proto.ProviderContextProto = (function() {

                /**
                 * Properties of a ProviderContextProto.
                 * @memberof space.kenko.proto
                 * @interface IProviderContextProto
                 * @property {string|null} [impersonatedBusinessId] ProviderContextProto impersonatedBusinessId
                 * @property {string|null} [impersonatedProviderId] ProviderContextProto impersonatedProviderId
                 */

                /**
                 * Constructs a new ProviderContextProto.
                 * @memberof space.kenko.proto
                 * @classdesc Represents a ProviderContextProto.
                 * @implements IProviderContextProto
                 * @constructor
                 * @param {space.kenko.proto.IProviderContextProto=} [properties] Properties to set
                 */
                function ProviderContextProto(properties) {
                    if (properties)
                        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ProviderContextProto impersonatedBusinessId.
                 * @member {string} impersonatedBusinessId
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 */
                ProviderContextProto.prototype.impersonatedBusinessId = "";

                /**
                 * ProviderContextProto impersonatedProviderId.
                 * @member {string} impersonatedProviderId
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 */
                ProviderContextProto.prototype.impersonatedProviderId = "";

                /**
                 * Creates a new ProviderContextProto instance using the specified properties.
                 * @function create
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto=} [properties] Properties to set
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto instance
                 */
                ProviderContextProto.create = function create(properties) {
                    return new ProviderContextProto(properties);
                };

                /**
                 * Encodes the specified ProviderContextProto message. Does not implicitly {@link space.kenko.proto.ProviderContextProto.verify|verify} messages.
                 * @function encode
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto} message ProviderContextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderContextProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.impersonatedBusinessId != null && Object.hasOwnProperty.call(message, "impersonatedBusinessId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.impersonatedBusinessId);
                    if (message.impersonatedProviderId != null && Object.hasOwnProperty.call(message, "impersonatedProviderId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.impersonatedProviderId);
                    return writer;
                };

                /**
                 * Encodes the specified ProviderContextProto message, length delimited. Does not implicitly {@link space.kenko.proto.ProviderContextProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.IProviderContextProto} message ProviderContextProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProviderContextProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ProviderContextProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderContextProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    let end = length === undefined ? reader.len : reader.pos + length, message = new $root.space.kenko.proto.ProviderContextProto();
                    while (reader.pos < end) {
                        let tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1: {
                                message.impersonatedBusinessId = reader.string();
                                break;
                            }
                        case 2: {
                                message.impersonatedProviderId = reader.string();
                                break;
                            }
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ProviderContextProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProviderContextProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ProviderContextProto message.
                 * @function verify
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProviderContextProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.impersonatedBusinessId != null && message.hasOwnProperty("impersonatedBusinessId"))
                        if (!$util.isString(message.impersonatedBusinessId))
                            return "impersonatedBusinessId: string expected";
                    if (message.impersonatedProviderId != null && message.hasOwnProperty("impersonatedProviderId"))
                        if (!$util.isString(message.impersonatedProviderId))
                            return "impersonatedProviderId: string expected";
                    return null;
                };

                /**
                 * Creates a ProviderContextProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {space.kenko.proto.ProviderContextProto} ProviderContextProto
                 */
                ProviderContextProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.space.kenko.proto.ProviderContextProto)
                        return object;
                    let message = new $root.space.kenko.proto.ProviderContextProto();
                    if (object.impersonatedBusinessId != null)
                        message.impersonatedBusinessId = String(object.impersonatedBusinessId);
                    if (object.impersonatedProviderId != null)
                        message.impersonatedProviderId = String(object.impersonatedProviderId);
                    return message;
                };

                /**
                 * Creates a plain object from a ProviderContextProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {space.kenko.proto.ProviderContextProto} message ProviderContextProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProviderContextProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    let object = {};
                    if (options.defaults) {
                        object.impersonatedBusinessId = "";
                        object.impersonatedProviderId = "";
                    }
                    if (message.impersonatedBusinessId != null && message.hasOwnProperty("impersonatedBusinessId"))
                        object.impersonatedBusinessId = message.impersonatedBusinessId;
                    if (message.impersonatedProviderId != null && message.hasOwnProperty("impersonatedProviderId"))
                        object.impersonatedProviderId = message.impersonatedProviderId;
                    return object;
                };

                /**
                 * Converts this ProviderContextProto to JSON.
                 * @function toJSON
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProviderContextProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Gets the default type url for ProviderContextProto
                 * @function getTypeUrl
                 * @memberof space.kenko.proto.ProviderContextProto
                 * @static
                 * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                 * @returns {string} The default type url
                 */
                ProviderContextProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                    if (typeUrlPrefix === undefined) {
                        typeUrlPrefix = "type.googleapis.com";
                    }
                    return typeUrlPrefix + "/space.kenko.proto.ProviderContextProto";
                };

                return ProviderContextProto;
            })();

            return proto;
        })();

        return kenko;
    })();

    return space;
})();

export const GetProviderProfileRequest = $root.GetProviderProfileRequest = (() => {

    /**
     * Properties of a GetProviderProfileRequest.
     * @exports IGetProviderProfileRequest
     * @interface IGetProviderProfileRequest
     */

    /**
     * Constructs a new GetProviderProfileRequest.
     * @exports GetProviderProfileRequest
     * @classdesc Represents a GetProviderProfileRequest.
     * @implements IGetProviderProfileRequest
     * @constructor
     * @param {IGetProviderProfileRequest=} [properties] Properties to set
     */
    function GetProviderProfileRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new GetProviderProfileRequest instance using the specified properties.
     * @function create
     * @memberof GetProviderProfileRequest
     * @static
     * @param {IGetProviderProfileRequest=} [properties] Properties to set
     * @returns {GetProviderProfileRequest} GetProviderProfileRequest instance
     */
    GetProviderProfileRequest.create = function create(properties) {
        return new GetProviderProfileRequest(properties);
    };

    /**
     * Encodes the specified GetProviderProfileRequest message. Does not implicitly {@link GetProviderProfileRequest.verify|verify} messages.
     * @function encode
     * @memberof GetProviderProfileRequest
     * @static
     * @param {IGetProviderProfileRequest} message GetProviderProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetProviderProfileRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified GetProviderProfileRequest message, length delimited. Does not implicitly {@link GetProviderProfileRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetProviderProfileRequest
     * @static
     * @param {IGetProviderProfileRequest} message GetProviderProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetProviderProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetProviderProfileRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetProviderProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetProviderProfileRequest} GetProviderProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetProviderProfileRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetProviderProfileRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetProviderProfileRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetProviderProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetProviderProfileRequest} GetProviderProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetProviderProfileRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetProviderProfileRequest message.
     * @function verify
     * @memberof GetProviderProfileRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetProviderProfileRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a GetProviderProfileRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetProviderProfileRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetProviderProfileRequest} GetProviderProfileRequest
     */
    GetProviderProfileRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetProviderProfileRequest)
            return object;
        return new $root.GetProviderProfileRequest();
    };

    /**
     * Creates a plain object from a GetProviderProfileRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetProviderProfileRequest
     * @static
     * @param {GetProviderProfileRequest} message GetProviderProfileRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetProviderProfileRequest.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this GetProviderProfileRequest to JSON.
     * @function toJSON
     * @memberof GetProviderProfileRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetProviderProfileRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetProviderProfileRequest
     * @function getTypeUrl
     * @memberof GetProviderProfileRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetProviderProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetProviderProfileRequest";
    };

    return GetProviderProfileRequest;
})();

export const GetProviderProfileResponse = $root.GetProviderProfileResponse = (() => {

    /**
     * Properties of a GetProviderProfileResponse.
     * @exports IGetProviderProfileResponse
     * @interface IGetProviderProfileResponse
     * @property {boolean|null} [okay] GetProviderProfileResponse okay
     * @property {Array.<string>|null} [authenticatedUserRoles] GetProviderProfileResponse authenticatedUserRoles
     * @property {IApiProviderProto|null} [provider] GetProviderProfileResponse provider
     * @property {IApiBusinessProto|null} [business] GetProviderProfileResponse business
     * @property {IApiBusinessProfileProto|null} [businessProfile] GetProviderProfileResponse businessProfile
     * @property {IProviderClientSettings|null} [clientSettings] GetProviderProfileResponse clientSettings
     */

    /**
     * Constructs a new GetProviderProfileResponse.
     * @exports GetProviderProfileResponse
     * @classdesc Represents a GetProviderProfileResponse.
     * @implements IGetProviderProfileResponse
     * @constructor
     * @param {IGetProviderProfileResponse=} [properties] Properties to set
     */
    function GetProviderProfileResponse(properties) {
        this.authenticatedUserRoles = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetProviderProfileResponse okay.
     * @member {boolean} okay
     * @memberof GetProviderProfileResponse
     * @instance
     */
    GetProviderProfileResponse.prototype.okay = false;

    /**
     * GetProviderProfileResponse authenticatedUserRoles.
     * @member {Array.<string>} authenticatedUserRoles
     * @memberof GetProviderProfileResponse
     * @instance
     */
    GetProviderProfileResponse.prototype.authenticatedUserRoles = $util.emptyArray;

    /**
     * GetProviderProfileResponse provider.
     * @member {IApiProviderProto|null|undefined} provider
     * @memberof GetProviderProfileResponse
     * @instance
     */
    GetProviderProfileResponse.prototype.provider = null;

    /**
     * GetProviderProfileResponse business.
     * @member {IApiBusinessProto|null|undefined} business
     * @memberof GetProviderProfileResponse
     * @instance
     */
    GetProviderProfileResponse.prototype.business = null;

    /**
     * GetProviderProfileResponse businessProfile.
     * @member {IApiBusinessProfileProto|null|undefined} businessProfile
     * @memberof GetProviderProfileResponse
     * @instance
     */
    GetProviderProfileResponse.prototype.businessProfile = null;

    /**
     * GetProviderProfileResponse clientSettings.
     * @member {IProviderClientSettings|null|undefined} clientSettings
     * @memberof GetProviderProfileResponse
     * @instance
     */
    GetProviderProfileResponse.prototype.clientSettings = null;

    /**
     * Creates a new GetProviderProfileResponse instance using the specified properties.
     * @function create
     * @memberof GetProviderProfileResponse
     * @static
     * @param {IGetProviderProfileResponse=} [properties] Properties to set
     * @returns {GetProviderProfileResponse} GetProviderProfileResponse instance
     */
    GetProviderProfileResponse.create = function create(properties) {
        return new GetProviderProfileResponse(properties);
    };

    /**
     * Encodes the specified GetProviderProfileResponse message. Does not implicitly {@link GetProviderProfileResponse.verify|verify} messages.
     * @function encode
     * @memberof GetProviderProfileResponse
     * @static
     * @param {IGetProviderProfileResponse} message GetProviderProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetProviderProfileResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.authenticatedUserRoles != null && message.authenticatedUserRoles.length)
            for (let i = 0; i < message.authenticatedUserRoles.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.authenticatedUserRoles[i]);
        if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
            $root.ApiProviderProto.encode(message.provider, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.business != null && Object.hasOwnProperty.call(message, "business"))
            $root.ApiBusinessProto.encode(message.business, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.businessProfile != null && Object.hasOwnProperty.call(message, "businessProfile"))
            $root.ApiBusinessProfileProto.encode(message.businessProfile, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.clientSettings != null && Object.hasOwnProperty.call(message, "clientSettings"))
            $root.ProviderClientSettings.encode(message.clientSettings, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetProviderProfileResponse message, length delimited. Does not implicitly {@link GetProviderProfileResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetProviderProfileResponse
     * @static
     * @param {IGetProviderProfileResponse} message GetProviderProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetProviderProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetProviderProfileResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetProviderProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetProviderProfileResponse} GetProviderProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetProviderProfileResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetProviderProfileResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.authenticatedUserRoles && message.authenticatedUserRoles.length))
                        message.authenticatedUserRoles = [];
                    message.authenticatedUserRoles.push(reader.string());
                    break;
                }
            case 3: {
                    message.provider = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.business = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.businessProfile = $root.ApiBusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.clientSettings = $root.ProviderClientSettings.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetProviderProfileResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetProviderProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetProviderProfileResponse} GetProviderProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetProviderProfileResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetProviderProfileResponse message.
     * @function verify
     * @memberof GetProviderProfileResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetProviderProfileResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.authenticatedUserRoles != null && message.hasOwnProperty("authenticatedUserRoles")) {
            if (!Array.isArray(message.authenticatedUserRoles))
                return "authenticatedUserRoles: array expected";
            for (let i = 0; i < message.authenticatedUserRoles.length; ++i)
                if (!$util.isString(message.authenticatedUserRoles[i]))
                    return "authenticatedUserRoles: string[] expected";
        }
        if (message.provider != null && message.hasOwnProperty("provider")) {
            let error = $root.ApiProviderProto.verify(message.provider);
            if (error)
                return "provider." + error;
        }
        if (message.business != null && message.hasOwnProperty("business")) {
            let error = $root.ApiBusinessProto.verify(message.business);
            if (error)
                return "business." + error;
        }
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile")) {
            let error = $root.ApiBusinessProfileProto.verify(message.businessProfile);
            if (error)
                return "businessProfile." + error;
        }
        if (message.clientSettings != null && message.hasOwnProperty("clientSettings")) {
            let error = $root.ProviderClientSettings.verify(message.clientSettings);
            if (error)
                return "clientSettings." + error;
        }
        return null;
    };

    /**
     * Creates a GetProviderProfileResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetProviderProfileResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetProviderProfileResponse} GetProviderProfileResponse
     */
    GetProviderProfileResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetProviderProfileResponse)
            return object;
        let message = new $root.GetProviderProfileResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.authenticatedUserRoles) {
            if (!Array.isArray(object.authenticatedUserRoles))
                throw TypeError(".GetProviderProfileResponse.authenticatedUserRoles: array expected");
            message.authenticatedUserRoles = [];
            for (let i = 0; i < object.authenticatedUserRoles.length; ++i)
                message.authenticatedUserRoles[i] = String(object.authenticatedUserRoles[i]);
        }
        if (object.provider != null) {
            if (typeof object.provider !== "object")
                throw TypeError(".GetProviderProfileResponse.provider: object expected");
            message.provider = $root.ApiProviderProto.fromObject(object.provider);
        }
        if (object.business != null) {
            if (typeof object.business !== "object")
                throw TypeError(".GetProviderProfileResponse.business: object expected");
            message.business = $root.ApiBusinessProto.fromObject(object.business);
        }
        if (object.businessProfile != null) {
            if (typeof object.businessProfile !== "object")
                throw TypeError(".GetProviderProfileResponse.businessProfile: object expected");
            message.businessProfile = $root.ApiBusinessProfileProto.fromObject(object.businessProfile);
        }
        if (object.clientSettings != null) {
            if (typeof object.clientSettings !== "object")
                throw TypeError(".GetProviderProfileResponse.clientSettings: object expected");
            message.clientSettings = $root.ProviderClientSettings.fromObject(object.clientSettings);
        }
        return message;
    };

    /**
     * Creates a plain object from a GetProviderProfileResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetProviderProfileResponse
     * @static
     * @param {GetProviderProfileResponse} message GetProviderProfileResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetProviderProfileResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.authenticatedUserRoles = [];
        if (options.defaults) {
            object.okay = false;
            object.provider = null;
            object.business = null;
            object.businessProfile = null;
            object.clientSettings = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.authenticatedUserRoles && message.authenticatedUserRoles.length) {
            object.authenticatedUserRoles = [];
            for (let j = 0; j < message.authenticatedUserRoles.length; ++j)
                object.authenticatedUserRoles[j] = message.authenticatedUserRoles[j];
        }
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = $root.ApiProviderProto.toObject(message.provider, options);
        if (message.business != null && message.hasOwnProperty("business"))
            object.business = $root.ApiBusinessProto.toObject(message.business, options);
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile"))
            object.businessProfile = $root.ApiBusinessProfileProto.toObject(message.businessProfile, options);
        if (message.clientSettings != null && message.hasOwnProperty("clientSettings"))
            object.clientSettings = $root.ProviderClientSettings.toObject(message.clientSettings, options);
        return object;
    };

    /**
     * Converts this GetProviderProfileResponse to JSON.
     * @function toJSON
     * @memberof GetProviderProfileResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetProviderProfileResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetProviderProfileResponse
     * @function getTypeUrl
     * @memberof GetProviderProfileResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetProviderProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetProviderProfileResponse";
    };

    return GetProviderProfileResponse;
})();

export const ProviderClientSettings = $root.ProviderClientSettings = (() => {

    /**
     * Properties of a ProviderClientSettings.
     * @exports IProviderClientSettings
     * @interface IProviderClientSettings
     */

    /**
     * Constructs a new ProviderClientSettings.
     * @exports ProviderClientSettings
     * @classdesc Represents a ProviderClientSettings.
     * @implements IProviderClientSettings
     * @constructor
     * @param {IProviderClientSettings=} [properties] Properties to set
     */
    function ProviderClientSettings(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Creates a new ProviderClientSettings instance using the specified properties.
     * @function create
     * @memberof ProviderClientSettings
     * @static
     * @param {IProviderClientSettings=} [properties] Properties to set
     * @returns {ProviderClientSettings} ProviderClientSettings instance
     */
    ProviderClientSettings.create = function create(properties) {
        return new ProviderClientSettings(properties);
    };

    /**
     * Encodes the specified ProviderClientSettings message. Does not implicitly {@link ProviderClientSettings.verify|verify} messages.
     * @function encode
     * @memberof ProviderClientSettings
     * @static
     * @param {IProviderClientSettings} message ProviderClientSettings message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProviderClientSettings.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        return writer;
    };

    /**
     * Encodes the specified ProviderClientSettings message, length delimited. Does not implicitly {@link ProviderClientSettings.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ProviderClientSettings
     * @static
     * @param {IProviderClientSettings} message ProviderClientSettings message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ProviderClientSettings.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ProviderClientSettings message from the specified reader or buffer.
     * @function decode
     * @memberof ProviderClientSettings
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ProviderClientSettings} ProviderClientSettings
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProviderClientSettings.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ProviderClientSettings();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ProviderClientSettings message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ProviderClientSettings
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ProviderClientSettings} ProviderClientSettings
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ProviderClientSettings.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ProviderClientSettings message.
     * @function verify
     * @memberof ProviderClientSettings
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ProviderClientSettings.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        return null;
    };

    /**
     * Creates a ProviderClientSettings message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ProviderClientSettings
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ProviderClientSettings} ProviderClientSettings
     */
    ProviderClientSettings.fromObject = function fromObject(object) {
        if (object instanceof $root.ProviderClientSettings)
            return object;
        return new $root.ProviderClientSettings();
    };

    /**
     * Creates a plain object from a ProviderClientSettings message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ProviderClientSettings
     * @static
     * @param {ProviderClientSettings} message ProviderClientSettings
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ProviderClientSettings.toObject = function toObject() {
        return {};
    };

    /**
     * Converts this ProviderClientSettings to JSON.
     * @function toJSON
     * @memberof ProviderClientSettings
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ProviderClientSettings.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ProviderClientSettings
     * @function getTypeUrl
     * @memberof ProviderClientSettings
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ProviderClientSettings.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ProviderClientSettings";
    };

    return ProviderClientSettings;
})();

export const ApiProviderProto = $root.ApiProviderProto = (() => {

    /**
     * Properties of an ApiProviderProto.
     * @exports IApiProviderProto
     * @interface IApiProviderProto
     * @property {string|null} [providerId] ApiProviderProto providerId
     * @property {string|null} [businessId] ApiProviderProto businessId
     * @property {string|null} [loginId] ApiProviderProto loginId
     * @property {Array.<string>|null} [adminRoles] ApiProviderProto adminRoles
     * @property {string|null} [lastLoginEmail] ApiProviderProto lastLoginEmail
     * @property {number|Long|null} [lastLoginTimestamp] ApiProviderProto lastLoginTimestamp
     * @property {space.kenko.proto.IProviderProfileProto|null} [profile] ApiProviderProto profile
     * @property {Array.<string>|null} [businessRoles] ApiProviderProto businessRoles
     * @property {string|null} [linkedPractitionerId] ApiProviderProto linkedPractitionerId
     * @property {string|null} [contactEmail] ApiProviderProto contactEmail
     * @property {string|null} [mobileNumber] ApiProviderProto mobileNumber
     * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [verifiedContactMethods] ApiProviderProto verifiedContactMethods
     */

    /**
     * Constructs a new ApiProviderProto.
     * @exports ApiProviderProto
     * @classdesc Represents an ApiProviderProto.
     * @implements IApiProviderProto
     * @constructor
     * @param {IApiProviderProto=} [properties] Properties to set
     */
    function ApiProviderProto(properties) {
        this.adminRoles = [];
        this.businessRoles = [];
        this.verifiedContactMethods = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiProviderProto providerId.
     * @member {string} providerId
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.providerId = "";

    /**
     * ApiProviderProto businessId.
     * @member {string} businessId
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.businessId = "";

    /**
     * ApiProviderProto loginId.
     * @member {string} loginId
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.loginId = "";

    /**
     * ApiProviderProto adminRoles.
     * @member {Array.<string>} adminRoles
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.adminRoles = $util.emptyArray;

    /**
     * ApiProviderProto lastLoginEmail.
     * @member {string} lastLoginEmail
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.lastLoginEmail = "";

    /**
     * ApiProviderProto lastLoginTimestamp.
     * @member {number|Long} lastLoginTimestamp
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.lastLoginTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ApiProviderProto profile.
     * @member {space.kenko.proto.IProviderProfileProto|null|undefined} profile
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.profile = null;

    /**
     * ApiProviderProto businessRoles.
     * @member {Array.<string>} businessRoles
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.businessRoles = $util.emptyArray;

    /**
     * ApiProviderProto linkedPractitionerId.
     * @member {string} linkedPractitionerId
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.linkedPractitionerId = "";

    /**
     * ApiProviderProto contactEmail.
     * @member {string} contactEmail
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.contactEmail = "";

    /**
     * ApiProviderProto mobileNumber.
     * @member {string} mobileNumber
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.mobileNumber = "";

    /**
     * ApiProviderProto verifiedContactMethods.
     * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} verifiedContactMethods
     * @memberof ApiProviderProto
     * @instance
     */
    ApiProviderProto.prototype.verifiedContactMethods = $util.emptyArray;

    /**
     * Creates a new ApiProviderProto instance using the specified properties.
     * @function create
     * @memberof ApiProviderProto
     * @static
     * @param {IApiProviderProto=} [properties] Properties to set
     * @returns {ApiProviderProto} ApiProviderProto instance
     */
    ApiProviderProto.create = function create(properties) {
        return new ApiProviderProto(properties);
    };

    /**
     * Encodes the specified ApiProviderProto message. Does not implicitly {@link ApiProviderProto.verify|verify} messages.
     * @function encode
     * @memberof ApiProviderProto
     * @static
     * @param {IApiProviderProto} message ApiProviderProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiProviderProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.providerId != null && Object.hasOwnProperty.call(message, "providerId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.providerId);
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessId);
        if (message.loginId != null && Object.hasOwnProperty.call(message, "loginId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.loginId);
        if (message.adminRoles != null && message.adminRoles.length)
            for (let i = 0; i < message.adminRoles.length; ++i)
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.adminRoles[i]);
        if (message.lastLoginEmail != null && Object.hasOwnProperty.call(message, "lastLoginEmail"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastLoginEmail);
        if (message.lastLoginTimestamp != null && Object.hasOwnProperty.call(message, "lastLoginTimestamp"))
            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastLoginTimestamp);
        if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
            $root.space.kenko.proto.ProviderProfileProto.encode(message.profile, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.businessRoles != null && message.businessRoles.length)
            for (let i = 0; i < message.businessRoles.length; ++i)
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.businessRoles[i]);
        if (message.linkedPractitionerId != null && Object.hasOwnProperty.call(message, "linkedPractitionerId"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.linkedPractitionerId);
        if (message.contactEmail != null && Object.hasOwnProperty.call(message, "contactEmail"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.contactEmail);
        if (message.mobileNumber != null && Object.hasOwnProperty.call(message, "mobileNumber"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.mobileNumber);
        if (message.verifiedContactMethods != null && message.verifiedContactMethods.length)
            for (let i = 0; i < message.verifiedContactMethods.length; ++i)
                $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.verifiedContactMethods[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiProviderProto message, length delimited. Does not implicitly {@link ApiProviderProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiProviderProto
     * @static
     * @param {IApiProviderProto} message ApiProviderProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiProviderProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiProviderProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiProviderProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiProviderProto} ApiProviderProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiProviderProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiProviderProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.providerId = reader.string();
                    break;
                }
            case 2: {
                    message.businessId = reader.string();
                    break;
                }
            case 3: {
                    message.loginId = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.adminRoles && message.adminRoles.length))
                        message.adminRoles = [];
                    message.adminRoles.push(reader.string());
                    break;
                }
            case 5: {
                    message.lastLoginEmail = reader.string();
                    break;
                }
            case 6: {
                    message.lastLoginTimestamp = reader.int64();
                    break;
                }
            case 7: {
                    message.profile = $root.space.kenko.proto.ProviderProfileProto.decode(reader, reader.uint32());
                    break;
                }
            case 9: {
                    if (!(message.businessRoles && message.businessRoles.length))
                        message.businessRoles = [];
                    message.businessRoles.push(reader.string());
                    break;
                }
            case 10: {
                    message.linkedPractitionerId = reader.string();
                    break;
                }
            case 11: {
                    message.contactEmail = reader.string();
                    break;
                }
            case 12: {
                    message.mobileNumber = reader.string();
                    break;
                }
            case 13: {
                    if (!(message.verifiedContactMethods && message.verifiedContactMethods.length))
                        message.verifiedContactMethods = [];
                    message.verifiedContactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiProviderProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiProviderProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiProviderProto} ApiProviderProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiProviderProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiProviderProto message.
     * @function verify
     * @memberof ApiProviderProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiProviderProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.providerId != null && message.hasOwnProperty("providerId"))
            if (!$util.isString(message.providerId))
                return "providerId: string expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.loginId != null && message.hasOwnProperty("loginId"))
            if (!$util.isString(message.loginId))
                return "loginId: string expected";
        if (message.adminRoles != null && message.hasOwnProperty("adminRoles")) {
            if (!Array.isArray(message.adminRoles))
                return "adminRoles: array expected";
            for (let i = 0; i < message.adminRoles.length; ++i)
                if (!$util.isString(message.adminRoles[i]))
                    return "adminRoles: string[] expected";
        }
        if (message.lastLoginEmail != null && message.hasOwnProperty("lastLoginEmail"))
            if (!$util.isString(message.lastLoginEmail))
                return "lastLoginEmail: string expected";
        if (message.lastLoginTimestamp != null && message.hasOwnProperty("lastLoginTimestamp"))
            if (!$util.isInteger(message.lastLoginTimestamp) && !(message.lastLoginTimestamp && $util.isInteger(message.lastLoginTimestamp.low) && $util.isInteger(message.lastLoginTimestamp.high)))
                return "lastLoginTimestamp: integer|Long expected";
        if (message.profile != null && message.hasOwnProperty("profile")) {
            let error = $root.space.kenko.proto.ProviderProfileProto.verify(message.profile);
            if (error)
                return "profile." + error;
        }
        if (message.businessRoles != null && message.hasOwnProperty("businessRoles")) {
            if (!Array.isArray(message.businessRoles))
                return "businessRoles: array expected";
            for (let i = 0; i < message.businessRoles.length; ++i)
                if (!$util.isString(message.businessRoles[i]))
                    return "businessRoles: string[] expected";
        }
        if (message.linkedPractitionerId != null && message.hasOwnProperty("linkedPractitionerId"))
            if (!$util.isString(message.linkedPractitionerId))
                return "linkedPractitionerId: string expected";
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            if (!$util.isString(message.contactEmail))
                return "contactEmail: string expected";
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            if (!$util.isString(message.mobileNumber))
                return "mobileNumber: string expected";
        if (message.verifiedContactMethods != null && message.hasOwnProperty("verifiedContactMethods")) {
            if (!Array.isArray(message.verifiedContactMethods))
                return "verifiedContactMethods: array expected";
            for (let i = 0; i < message.verifiedContactMethods.length; ++i) {
                let error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.verifiedContactMethods[i]);
                if (error)
                    return "verifiedContactMethods." + error;
            }
        }
        return null;
    };

    /**
     * Creates an ApiProviderProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiProviderProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiProviderProto} ApiProviderProto
     */
    ApiProviderProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiProviderProto)
            return object;
        let message = new $root.ApiProviderProto();
        if (object.providerId != null)
            message.providerId = String(object.providerId);
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.loginId != null)
            message.loginId = String(object.loginId);
        if (object.adminRoles) {
            if (!Array.isArray(object.adminRoles))
                throw TypeError(".ApiProviderProto.adminRoles: array expected");
            message.adminRoles = [];
            for (let i = 0; i < object.adminRoles.length; ++i)
                message.adminRoles[i] = String(object.adminRoles[i]);
        }
        if (object.lastLoginEmail != null)
            message.lastLoginEmail = String(object.lastLoginEmail);
        if (object.lastLoginTimestamp != null)
            if ($util.Long)
                (message.lastLoginTimestamp = $util.Long.fromValue(object.lastLoginTimestamp)).unsigned = false;
            else if (typeof object.lastLoginTimestamp === "string")
                message.lastLoginTimestamp = parseInt(object.lastLoginTimestamp, 10);
            else if (typeof object.lastLoginTimestamp === "number")
                message.lastLoginTimestamp = object.lastLoginTimestamp;
            else if (typeof object.lastLoginTimestamp === "object")
                message.lastLoginTimestamp = new $util.LongBits(object.lastLoginTimestamp.low >>> 0, object.lastLoginTimestamp.high >>> 0).toNumber();
        if (object.profile != null) {
            if (typeof object.profile !== "object")
                throw TypeError(".ApiProviderProto.profile: object expected");
            message.profile = $root.space.kenko.proto.ProviderProfileProto.fromObject(object.profile);
        }
        if (object.businessRoles) {
            if (!Array.isArray(object.businessRoles))
                throw TypeError(".ApiProviderProto.businessRoles: array expected");
            message.businessRoles = [];
            for (let i = 0; i < object.businessRoles.length; ++i)
                message.businessRoles[i] = String(object.businessRoles[i]);
        }
        if (object.linkedPractitionerId != null)
            message.linkedPractitionerId = String(object.linkedPractitionerId);
        if (object.contactEmail != null)
            message.contactEmail = String(object.contactEmail);
        if (object.mobileNumber != null)
            message.mobileNumber = String(object.mobileNumber);
        if (object.verifiedContactMethods) {
            if (!Array.isArray(object.verifiedContactMethods))
                throw TypeError(".ApiProviderProto.verifiedContactMethods: array expected");
            message.verifiedContactMethods = [];
            for (let i = 0; i < object.verifiedContactMethods.length; ++i) {
                if (typeof object.verifiedContactMethods[i] !== "object")
                    throw TypeError(".ApiProviderProto.verifiedContactMethods: object expected");
                message.verifiedContactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.verifiedContactMethods[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiProviderProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiProviderProto
     * @static
     * @param {ApiProviderProto} message ApiProviderProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiProviderProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.adminRoles = [];
            object.businessRoles = [];
            object.verifiedContactMethods = [];
        }
        if (options.defaults) {
            object.providerId = "";
            object.businessId = "";
            object.loginId = "";
            object.lastLoginEmail = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.lastLoginTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lastLoginTimestamp = options.longs === String ? "0" : 0;
            object.profile = null;
            object.linkedPractitionerId = "";
            object.contactEmail = "";
            object.mobileNumber = "";
        }
        if (message.providerId != null && message.hasOwnProperty("providerId"))
            object.providerId = message.providerId;
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.loginId != null && message.hasOwnProperty("loginId"))
            object.loginId = message.loginId;
        if (message.adminRoles && message.adminRoles.length) {
            object.adminRoles = [];
            for (let j = 0; j < message.adminRoles.length; ++j)
                object.adminRoles[j] = message.adminRoles[j];
        }
        if (message.lastLoginEmail != null && message.hasOwnProperty("lastLoginEmail"))
            object.lastLoginEmail = message.lastLoginEmail;
        if (message.lastLoginTimestamp != null && message.hasOwnProperty("lastLoginTimestamp"))
            if (typeof message.lastLoginTimestamp === "number")
                object.lastLoginTimestamp = options.longs === String ? String(message.lastLoginTimestamp) : message.lastLoginTimestamp;
            else
                object.lastLoginTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.lastLoginTimestamp) : options.longs === Number ? new $util.LongBits(message.lastLoginTimestamp.low >>> 0, message.lastLoginTimestamp.high >>> 0).toNumber() : message.lastLoginTimestamp;
        if (message.profile != null && message.hasOwnProperty("profile"))
            object.profile = $root.space.kenko.proto.ProviderProfileProto.toObject(message.profile, options);
        if (message.businessRoles && message.businessRoles.length) {
            object.businessRoles = [];
            for (let j = 0; j < message.businessRoles.length; ++j)
                object.businessRoles[j] = message.businessRoles[j];
        }
        if (message.linkedPractitionerId != null && message.hasOwnProperty("linkedPractitionerId"))
            object.linkedPractitionerId = message.linkedPractitionerId;
        if (message.contactEmail != null && message.hasOwnProperty("contactEmail"))
            object.contactEmail = message.contactEmail;
        if (message.mobileNumber != null && message.hasOwnProperty("mobileNumber"))
            object.mobileNumber = message.mobileNumber;
        if (message.verifiedContactMethods && message.verifiedContactMethods.length) {
            object.verifiedContactMethods = [];
            for (let j = 0; j < message.verifiedContactMethods.length; ++j)
                object.verifiedContactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.verifiedContactMethods[j], options);
        }
        return object;
    };

    /**
     * Converts this ApiProviderProto to JSON.
     * @function toJSON
     * @memberof ApiProviderProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiProviderProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiProviderProto
     * @function getTypeUrl
     * @memberof ApiProviderProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiProviderProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiProviderProto";
    };

    return ApiProviderProto;
})();

export const ApiBusinessProto = $root.ApiBusinessProto = (() => {

    /**
     * Properties of an ApiBusinessProto.
     * @exports IApiBusinessProto
     * @interface IApiBusinessProto
     * @property {string|null} [businessId] ApiBusinessProto businessId
     * @property {space.kenko.proto.ProviderApprovalState|null} [approvalState] ApiBusinessProto approvalState
     * @property {space.kenko.proto.IProviderSurveyProto|null} [surveyProto] ApiBusinessProto surveyProto
     * @property {string|null} [stripeAccountId] ApiBusinessProto stripeAccountId
     * @property {space.kenko.proto.IConnectedAccountStatusProto|null} [connectedAccountStatus] ApiBusinessProto connectedAccountStatus
     * @property {space.kenko.proto.IBusinessSubscriptionProto|null} [subscription] ApiBusinessProto subscription
     * @property {space.kenko.proto.IBusinessSettingsProto|null} [businessSettings] ApiBusinessProto businessSettings
     * @property {Array.<space.kenko.proto.IVerifiedContactMethodProto>|null} [verifiedContactMethods] ApiBusinessProto verifiedContactMethods
     * @property {boolean|null} [published] ApiBusinessProto published
     * @property {space.kenko.proto.IBusinessOnboardingStateProto|null} [onboardingState] ApiBusinessProto onboardingState
     */

    /**
     * Constructs a new ApiBusinessProto.
     * @exports ApiBusinessProto
     * @classdesc Represents an ApiBusinessProto.
     * @implements IApiBusinessProto
     * @constructor
     * @param {IApiBusinessProto=} [properties] Properties to set
     */
    function ApiBusinessProto(properties) {
        this.verifiedContactMethods = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiBusinessProto businessId.
     * @member {string} businessId
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.businessId = "";

    /**
     * ApiBusinessProto approvalState.
     * @member {space.kenko.proto.ProviderApprovalState} approvalState
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.approvalState = 0;

    /**
     * ApiBusinessProto surveyProto.
     * @member {space.kenko.proto.IProviderSurveyProto|null|undefined} surveyProto
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.surveyProto = null;

    /**
     * ApiBusinessProto stripeAccountId.
     * @member {string} stripeAccountId
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.stripeAccountId = "";

    /**
     * ApiBusinessProto connectedAccountStatus.
     * @member {space.kenko.proto.IConnectedAccountStatusProto|null|undefined} connectedAccountStatus
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.connectedAccountStatus = null;

    /**
     * ApiBusinessProto subscription.
     * @member {space.kenko.proto.IBusinessSubscriptionProto|null|undefined} subscription
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.subscription = null;

    /**
     * ApiBusinessProto businessSettings.
     * @member {space.kenko.proto.IBusinessSettingsProto|null|undefined} businessSettings
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.businessSettings = null;

    /**
     * ApiBusinessProto verifiedContactMethods.
     * @member {Array.<space.kenko.proto.IVerifiedContactMethodProto>} verifiedContactMethods
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.verifiedContactMethods = $util.emptyArray;

    /**
     * ApiBusinessProto published.
     * @member {boolean} published
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.published = false;

    /**
     * ApiBusinessProto onboardingState.
     * @member {space.kenko.proto.IBusinessOnboardingStateProto|null|undefined} onboardingState
     * @memberof ApiBusinessProto
     * @instance
     */
    ApiBusinessProto.prototype.onboardingState = null;

    /**
     * Creates a new ApiBusinessProto instance using the specified properties.
     * @function create
     * @memberof ApiBusinessProto
     * @static
     * @param {IApiBusinessProto=} [properties] Properties to set
     * @returns {ApiBusinessProto} ApiBusinessProto instance
     */
    ApiBusinessProto.create = function create(properties) {
        return new ApiBusinessProto(properties);
    };

    /**
     * Encodes the specified ApiBusinessProto message. Does not implicitly {@link ApiBusinessProto.verify|verify} messages.
     * @function encode
     * @memberof ApiBusinessProto
     * @static
     * @param {IApiBusinessProto} message ApiBusinessProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiBusinessProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.approvalState != null && Object.hasOwnProperty.call(message, "approvalState"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.approvalState);
        if (message.surveyProto != null && Object.hasOwnProperty.call(message, "surveyProto"))
            $root.space.kenko.proto.ProviderSurveyProto.encode(message.surveyProto, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.stripeAccountId != null && Object.hasOwnProperty.call(message, "stripeAccountId"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.stripeAccountId);
        if (message.connectedAccountStatus != null && Object.hasOwnProperty.call(message, "connectedAccountStatus"))
            $root.space.kenko.proto.ConnectedAccountStatusProto.encode(message.connectedAccountStatus, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.subscription != null && Object.hasOwnProperty.call(message, "subscription"))
            $root.space.kenko.proto.BusinessSubscriptionProto.encode(message.subscription, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.businessSettings != null && Object.hasOwnProperty.call(message, "businessSettings"))
            $root.space.kenko.proto.BusinessSettingsProto.encode(message.businessSettings, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.verifiedContactMethods != null && message.verifiedContactMethods.length)
            for (let i = 0; i < message.verifiedContactMethods.length; ++i)
                $root.space.kenko.proto.VerifiedContactMethodProto.encode(message.verifiedContactMethods[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.published != null && Object.hasOwnProperty.call(message, "published"))
            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.published);
        if (message.onboardingState != null && Object.hasOwnProperty.call(message, "onboardingState"))
            $root.space.kenko.proto.BusinessOnboardingStateProto.encode(message.onboardingState, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiBusinessProto message, length delimited. Does not implicitly {@link ApiBusinessProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiBusinessProto
     * @static
     * @param {IApiBusinessProto} message ApiBusinessProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiBusinessProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiBusinessProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiBusinessProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiBusinessProto} ApiBusinessProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiBusinessProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiBusinessProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 2: {
                    message.approvalState = reader.int32();
                    break;
                }
            case 3: {
                    message.surveyProto = $root.space.kenko.proto.ProviderSurveyProto.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.stripeAccountId = reader.string();
                    break;
                }
            case 7: {
                    message.connectedAccountStatus = $root.space.kenko.proto.ConnectedAccountStatusProto.decode(reader, reader.uint32());
                    break;
                }
            case 9: {
                    message.subscription = $root.space.kenko.proto.BusinessSubscriptionProto.decode(reader, reader.uint32());
                    break;
                }
            case 10: {
                    message.businessSettings = $root.space.kenko.proto.BusinessSettingsProto.decode(reader, reader.uint32());
                    break;
                }
            case 11: {
                    if (!(message.verifiedContactMethods && message.verifiedContactMethods.length))
                        message.verifiedContactMethods = [];
                    message.verifiedContactMethods.push($root.space.kenko.proto.VerifiedContactMethodProto.decode(reader, reader.uint32()));
                    break;
                }
            case 12: {
                    message.published = reader.bool();
                    break;
                }
            case 13: {
                    message.onboardingState = $root.space.kenko.proto.BusinessOnboardingStateProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiBusinessProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiBusinessProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiBusinessProto} ApiBusinessProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiBusinessProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiBusinessProto message.
     * @function verify
     * @memberof ApiBusinessProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiBusinessProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.approvalState != null && message.hasOwnProperty("approvalState"))
            switch (message.approvalState) {
            default:
                return "approvalState: enum value expected";
            case 0:
            case 10:
            case 11:
            case 20:
            case 30:
            case 40:
                break;
            }
        if (message.surveyProto != null && message.hasOwnProperty("surveyProto")) {
            let error = $root.space.kenko.proto.ProviderSurveyProto.verify(message.surveyProto);
            if (error)
                return "surveyProto." + error;
        }
        if (message.stripeAccountId != null && message.hasOwnProperty("stripeAccountId"))
            if (!$util.isString(message.stripeAccountId))
                return "stripeAccountId: string expected";
        if (message.connectedAccountStatus != null && message.hasOwnProperty("connectedAccountStatus")) {
            let error = $root.space.kenko.proto.ConnectedAccountStatusProto.verify(message.connectedAccountStatus);
            if (error)
                return "connectedAccountStatus." + error;
        }
        if (message.subscription != null && message.hasOwnProperty("subscription")) {
            let error = $root.space.kenko.proto.BusinessSubscriptionProto.verify(message.subscription);
            if (error)
                return "subscription." + error;
        }
        if (message.businessSettings != null && message.hasOwnProperty("businessSettings")) {
            let error = $root.space.kenko.proto.BusinessSettingsProto.verify(message.businessSettings);
            if (error)
                return "businessSettings." + error;
        }
        if (message.verifiedContactMethods != null && message.hasOwnProperty("verifiedContactMethods")) {
            if (!Array.isArray(message.verifiedContactMethods))
                return "verifiedContactMethods: array expected";
            for (let i = 0; i < message.verifiedContactMethods.length; ++i) {
                let error = $root.space.kenko.proto.VerifiedContactMethodProto.verify(message.verifiedContactMethods[i]);
                if (error)
                    return "verifiedContactMethods." + error;
            }
        }
        if (message.published != null && message.hasOwnProperty("published"))
            if (typeof message.published !== "boolean")
                return "published: boolean expected";
        if (message.onboardingState != null && message.hasOwnProperty("onboardingState")) {
            let error = $root.space.kenko.proto.BusinessOnboardingStateProto.verify(message.onboardingState);
            if (error)
                return "onboardingState." + error;
        }
        return null;
    };

    /**
     * Creates an ApiBusinessProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiBusinessProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiBusinessProto} ApiBusinessProto
     */
    ApiBusinessProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiBusinessProto)
            return object;
        let message = new $root.ApiBusinessProto();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        switch (object.approvalState) {
        default:
            if (typeof object.approvalState === "number") {
                message.approvalState = object.approvalState;
                break;
            }
            break;
        case "APPROVAL_STATE_UNKNOWN":
        case 0:
            message.approvalState = 0;
            break;
        case "NEW_PROVIDER_MANUAL_APPROVE":
        case 10:
            message.approvalState = 10;
            break;
        case "NEW_PROVIDER_AUTO_APPROVE":
        case 11:
            message.approvalState = 11;
            break;
        case "AWAITING_REVIEW":
        case 20:
            message.approvalState = 20;
            break;
        case "PROVIDER_APPROVED":
        case 30:
            message.approvalState = 30;
            break;
        case "PROVIDER_REJECTED":
        case 40:
            message.approvalState = 40;
            break;
        }
        if (object.surveyProto != null) {
            if (typeof object.surveyProto !== "object")
                throw TypeError(".ApiBusinessProto.surveyProto: object expected");
            message.surveyProto = $root.space.kenko.proto.ProviderSurveyProto.fromObject(object.surveyProto);
        }
        if (object.stripeAccountId != null)
            message.stripeAccountId = String(object.stripeAccountId);
        if (object.connectedAccountStatus != null) {
            if (typeof object.connectedAccountStatus !== "object")
                throw TypeError(".ApiBusinessProto.connectedAccountStatus: object expected");
            message.connectedAccountStatus = $root.space.kenko.proto.ConnectedAccountStatusProto.fromObject(object.connectedAccountStatus);
        }
        if (object.subscription != null) {
            if (typeof object.subscription !== "object")
                throw TypeError(".ApiBusinessProto.subscription: object expected");
            message.subscription = $root.space.kenko.proto.BusinessSubscriptionProto.fromObject(object.subscription);
        }
        if (object.businessSettings != null) {
            if (typeof object.businessSettings !== "object")
                throw TypeError(".ApiBusinessProto.businessSettings: object expected");
            message.businessSettings = $root.space.kenko.proto.BusinessSettingsProto.fromObject(object.businessSettings);
        }
        if (object.verifiedContactMethods) {
            if (!Array.isArray(object.verifiedContactMethods))
                throw TypeError(".ApiBusinessProto.verifiedContactMethods: array expected");
            message.verifiedContactMethods = [];
            for (let i = 0; i < object.verifiedContactMethods.length; ++i) {
                if (typeof object.verifiedContactMethods[i] !== "object")
                    throw TypeError(".ApiBusinessProto.verifiedContactMethods: object expected");
                message.verifiedContactMethods[i] = $root.space.kenko.proto.VerifiedContactMethodProto.fromObject(object.verifiedContactMethods[i]);
            }
        }
        if (object.published != null)
            message.published = Boolean(object.published);
        if (object.onboardingState != null) {
            if (typeof object.onboardingState !== "object")
                throw TypeError(".ApiBusinessProto.onboardingState: object expected");
            message.onboardingState = $root.space.kenko.proto.BusinessOnboardingStateProto.fromObject(object.onboardingState);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiBusinessProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiBusinessProto
     * @static
     * @param {ApiBusinessProto} message ApiBusinessProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiBusinessProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.verifiedContactMethods = [];
        if (options.defaults) {
            object.businessId = "";
            object.approvalState = options.enums === String ? "APPROVAL_STATE_UNKNOWN" : 0;
            object.surveyProto = null;
            object.stripeAccountId = "";
            object.connectedAccountStatus = null;
            object.subscription = null;
            object.businessSettings = null;
            object.published = false;
            object.onboardingState = null;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.approvalState != null && message.hasOwnProperty("approvalState"))
            object.approvalState = options.enums === String ? $root.space.kenko.proto.ProviderApprovalState[message.approvalState] === undefined ? message.approvalState : $root.space.kenko.proto.ProviderApprovalState[message.approvalState] : message.approvalState;
        if (message.surveyProto != null && message.hasOwnProperty("surveyProto"))
            object.surveyProto = $root.space.kenko.proto.ProviderSurveyProto.toObject(message.surveyProto, options);
        if (message.stripeAccountId != null && message.hasOwnProperty("stripeAccountId"))
            object.stripeAccountId = message.stripeAccountId;
        if (message.connectedAccountStatus != null && message.hasOwnProperty("connectedAccountStatus"))
            object.connectedAccountStatus = $root.space.kenko.proto.ConnectedAccountStatusProto.toObject(message.connectedAccountStatus, options);
        if (message.subscription != null && message.hasOwnProperty("subscription"))
            object.subscription = $root.space.kenko.proto.BusinessSubscriptionProto.toObject(message.subscription, options);
        if (message.businessSettings != null && message.hasOwnProperty("businessSettings"))
            object.businessSettings = $root.space.kenko.proto.BusinessSettingsProto.toObject(message.businessSettings, options);
        if (message.verifiedContactMethods && message.verifiedContactMethods.length) {
            object.verifiedContactMethods = [];
            for (let j = 0; j < message.verifiedContactMethods.length; ++j)
                object.verifiedContactMethods[j] = $root.space.kenko.proto.VerifiedContactMethodProto.toObject(message.verifiedContactMethods[j], options);
        }
        if (message.published != null && message.hasOwnProperty("published"))
            object.published = message.published;
        if (message.onboardingState != null && message.hasOwnProperty("onboardingState"))
            object.onboardingState = $root.space.kenko.proto.BusinessOnboardingStateProto.toObject(message.onboardingState, options);
        return object;
    };

    /**
     * Converts this ApiBusinessProto to JSON.
     * @function toJSON
     * @memberof ApiBusinessProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiBusinessProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiBusinessProto
     * @function getTypeUrl
     * @memberof ApiBusinessProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiBusinessProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiBusinessProto";
    };

    return ApiBusinessProto;
})();

export const ApiBusinessProfileProto = $root.ApiBusinessProfileProto = (() => {

    /**
     * Properties of an ApiBusinessProfileProto.
     * @exports IApiBusinessProfileProto
     * @interface IApiBusinessProfileProto
     * @property {string|null} [versionId] ApiBusinessProfileProto versionId
     * @property {number|Long|null} [lastModifiedTimestamp] ApiBusinessProfileProto lastModifiedTimestamp
     * @property {number|Long|null} [reviewTimestamp] ApiBusinessProfileProto reviewTimestamp
     * @property {space.kenko.proto.IBusinessProfileProto|null} [proto] ApiBusinessProfileProto proto
     * @property {Array.<space.kenko.proto.IBusinessLocationProto>|null} [locations] ApiBusinessProfileProto locations
     * @property {Array.<space.kenko.proto.IPractitionerProto>|null} [practitioners] ApiBusinessProfileProto practitioners
     * @property {space.kenko.proto.IPricingDetailsProto|null} [pricing] ApiBusinessProfileProto pricing
     * @property {space.kenko.proto.IPracticeDetailsProto|null} [practice] ApiBusinessProfileProto practice
     * @property {space.kenko.proto.IStudioDetailsProto|null} [studio] ApiBusinessProfileProto studio
     */

    /**
     * Constructs a new ApiBusinessProfileProto.
     * @exports ApiBusinessProfileProto
     * @classdesc Represents an ApiBusinessProfileProto.
     * @implements IApiBusinessProfileProto
     * @constructor
     * @param {IApiBusinessProfileProto=} [properties] Properties to set
     */
    function ApiBusinessProfileProto(properties) {
        this.locations = [];
        this.practitioners = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApiBusinessProfileProto versionId.
     * @member {string} versionId
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.versionId = "";

    /**
     * ApiBusinessProfileProto lastModifiedTimestamp.
     * @member {number|Long} lastModifiedTimestamp
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.lastModifiedTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ApiBusinessProfileProto reviewTimestamp.
     * @member {number|Long} reviewTimestamp
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.reviewTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ApiBusinessProfileProto proto.
     * @member {space.kenko.proto.IBusinessProfileProto|null|undefined} proto
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.proto = null;

    /**
     * ApiBusinessProfileProto locations.
     * @member {Array.<space.kenko.proto.IBusinessLocationProto>} locations
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.locations = $util.emptyArray;

    /**
     * ApiBusinessProfileProto practitioners.
     * @member {Array.<space.kenko.proto.IPractitionerProto>} practitioners
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.practitioners = $util.emptyArray;

    /**
     * ApiBusinessProfileProto pricing.
     * @member {space.kenko.proto.IPricingDetailsProto|null|undefined} pricing
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.pricing = null;

    /**
     * ApiBusinessProfileProto practice.
     * @member {space.kenko.proto.IPracticeDetailsProto|null|undefined} practice
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.practice = null;

    /**
     * ApiBusinessProfileProto studio.
     * @member {space.kenko.proto.IStudioDetailsProto|null|undefined} studio
     * @memberof ApiBusinessProfileProto
     * @instance
     */
    ApiBusinessProfileProto.prototype.studio = null;

    /**
     * Creates a new ApiBusinessProfileProto instance using the specified properties.
     * @function create
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {IApiBusinessProfileProto=} [properties] Properties to set
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto instance
     */
    ApiBusinessProfileProto.create = function create(properties) {
        return new ApiBusinessProfileProto(properties);
    };

    /**
     * Encodes the specified ApiBusinessProfileProto message. Does not implicitly {@link ApiBusinessProfileProto.verify|verify} messages.
     * @function encode
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {IApiBusinessProfileProto} message ApiBusinessProfileProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiBusinessProfileProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.versionId);
        if (message.lastModifiedTimestamp != null && Object.hasOwnProperty.call(message, "lastModifiedTimestamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.lastModifiedTimestamp);
        if (message.reviewTimestamp != null && Object.hasOwnProperty.call(message, "reviewTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.reviewTimestamp);
        if (message.proto != null && Object.hasOwnProperty.call(message, "proto"))
            $root.space.kenko.proto.BusinessProfileProto.encode(message.proto, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.locations != null && message.locations.length)
            for (let i = 0; i < message.locations.length; ++i)
                $root.space.kenko.proto.BusinessLocationProto.encode(message.locations[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.practitioners != null && message.practitioners.length)
            for (let i = 0; i < message.practitioners.length; ++i)
                $root.space.kenko.proto.PractitionerProto.encode(message.practitioners[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.pricing != null && Object.hasOwnProperty.call(message, "pricing"))
            $root.space.kenko.proto.PricingDetailsProto.encode(message.pricing, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        if (message.practice != null && Object.hasOwnProperty.call(message, "practice"))
            $root.space.kenko.proto.PracticeDetailsProto.encode(message.practice, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
        if (message.studio != null && Object.hasOwnProperty.call(message, "studio"))
            $root.space.kenko.proto.StudioDetailsProto.encode(message.studio, writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ApiBusinessProfileProto message, length delimited. Does not implicitly {@link ApiBusinessProfileProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {IApiBusinessProfileProto} message ApiBusinessProfileProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApiBusinessProfileProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an ApiBusinessProfileProto message from the specified reader or buffer.
     * @function decode
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiBusinessProfileProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApiBusinessProfileProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.versionId = reader.string();
                    break;
                }
            case 2: {
                    message.lastModifiedTimestamp = reader.int64();
                    break;
                }
            case 3: {
                    message.reviewTimestamp = reader.int64();
                    break;
                }
            case 10: {
                    message.proto = $root.space.kenko.proto.BusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            case 11: {
                    if (!(message.locations && message.locations.length))
                        message.locations = [];
                    message.locations.push($root.space.kenko.proto.BusinessLocationProto.decode(reader, reader.uint32()));
                    break;
                }
            case 12: {
                    if (!(message.practitioners && message.practitioners.length))
                        message.practitioners = [];
                    message.practitioners.push($root.space.kenko.proto.PractitionerProto.decode(reader, reader.uint32()));
                    break;
                }
            case 13: {
                    message.pricing = $root.space.kenko.proto.PricingDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            case 100: {
                    message.practice = $root.space.kenko.proto.PracticeDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            case 101: {
                    message.studio = $root.space.kenko.proto.StudioDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an ApiBusinessProfileProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApiBusinessProfileProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an ApiBusinessProfileProto message.
     * @function verify
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ApiBusinessProfileProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.versionId != null && message.hasOwnProperty("versionId"))
            if (!$util.isString(message.versionId))
                return "versionId: string expected";
        if (message.lastModifiedTimestamp != null && message.hasOwnProperty("lastModifiedTimestamp"))
            if (!$util.isInteger(message.lastModifiedTimestamp) && !(message.lastModifiedTimestamp && $util.isInteger(message.lastModifiedTimestamp.low) && $util.isInteger(message.lastModifiedTimestamp.high)))
                return "lastModifiedTimestamp: integer|Long expected";
        if (message.reviewTimestamp != null && message.hasOwnProperty("reviewTimestamp"))
            if (!$util.isInteger(message.reviewTimestamp) && !(message.reviewTimestamp && $util.isInteger(message.reviewTimestamp.low) && $util.isInteger(message.reviewTimestamp.high)))
                return "reviewTimestamp: integer|Long expected";
        if (message.proto != null && message.hasOwnProperty("proto")) {
            let error = $root.space.kenko.proto.BusinessProfileProto.verify(message.proto);
            if (error)
                return "proto." + error;
        }
        if (message.locations != null && message.hasOwnProperty("locations")) {
            if (!Array.isArray(message.locations))
                return "locations: array expected";
            for (let i = 0; i < message.locations.length; ++i) {
                let error = $root.space.kenko.proto.BusinessLocationProto.verify(message.locations[i]);
                if (error)
                    return "locations." + error;
            }
        }
        if (message.practitioners != null && message.hasOwnProperty("practitioners")) {
            if (!Array.isArray(message.practitioners))
                return "practitioners: array expected";
            for (let i = 0; i < message.practitioners.length; ++i) {
                let error = $root.space.kenko.proto.PractitionerProto.verify(message.practitioners[i]);
                if (error)
                    return "practitioners." + error;
            }
        }
        if (message.pricing != null && message.hasOwnProperty("pricing")) {
            let error = $root.space.kenko.proto.PricingDetailsProto.verify(message.pricing);
            if (error)
                return "pricing." + error;
        }
        if (message.practice != null && message.hasOwnProperty("practice")) {
            let error = $root.space.kenko.proto.PracticeDetailsProto.verify(message.practice);
            if (error)
                return "practice." + error;
        }
        if (message.studio != null && message.hasOwnProperty("studio")) {
            let error = $root.space.kenko.proto.StudioDetailsProto.verify(message.studio);
            if (error)
                return "studio." + error;
        }
        return null;
    };

    /**
     * Creates an ApiBusinessProfileProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApiBusinessProfileProto} ApiBusinessProfileProto
     */
    ApiBusinessProfileProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ApiBusinessProfileProto)
            return object;
        let message = new $root.ApiBusinessProfileProto();
        if (object.versionId != null)
            message.versionId = String(object.versionId);
        if (object.lastModifiedTimestamp != null)
            if ($util.Long)
                (message.lastModifiedTimestamp = $util.Long.fromValue(object.lastModifiedTimestamp)).unsigned = false;
            else if (typeof object.lastModifiedTimestamp === "string")
                message.lastModifiedTimestamp = parseInt(object.lastModifiedTimestamp, 10);
            else if (typeof object.lastModifiedTimestamp === "number")
                message.lastModifiedTimestamp = object.lastModifiedTimestamp;
            else if (typeof object.lastModifiedTimestamp === "object")
                message.lastModifiedTimestamp = new $util.LongBits(object.lastModifiedTimestamp.low >>> 0, object.lastModifiedTimestamp.high >>> 0).toNumber();
        if (object.reviewTimestamp != null)
            if ($util.Long)
                (message.reviewTimestamp = $util.Long.fromValue(object.reviewTimestamp)).unsigned = false;
            else if (typeof object.reviewTimestamp === "string")
                message.reviewTimestamp = parseInt(object.reviewTimestamp, 10);
            else if (typeof object.reviewTimestamp === "number")
                message.reviewTimestamp = object.reviewTimestamp;
            else if (typeof object.reviewTimestamp === "object")
                message.reviewTimestamp = new $util.LongBits(object.reviewTimestamp.low >>> 0, object.reviewTimestamp.high >>> 0).toNumber();
        if (object.proto != null) {
            if (typeof object.proto !== "object")
                throw TypeError(".ApiBusinessProfileProto.proto: object expected");
            message.proto = $root.space.kenko.proto.BusinessProfileProto.fromObject(object.proto);
        }
        if (object.locations) {
            if (!Array.isArray(object.locations))
                throw TypeError(".ApiBusinessProfileProto.locations: array expected");
            message.locations = [];
            for (let i = 0; i < object.locations.length; ++i) {
                if (typeof object.locations[i] !== "object")
                    throw TypeError(".ApiBusinessProfileProto.locations: object expected");
                message.locations[i] = $root.space.kenko.proto.BusinessLocationProto.fromObject(object.locations[i]);
            }
        }
        if (object.practitioners) {
            if (!Array.isArray(object.practitioners))
                throw TypeError(".ApiBusinessProfileProto.practitioners: array expected");
            message.practitioners = [];
            for (let i = 0; i < object.practitioners.length; ++i) {
                if (typeof object.practitioners[i] !== "object")
                    throw TypeError(".ApiBusinessProfileProto.practitioners: object expected");
                message.practitioners[i] = $root.space.kenko.proto.PractitionerProto.fromObject(object.practitioners[i]);
            }
        }
        if (object.pricing != null) {
            if (typeof object.pricing !== "object")
                throw TypeError(".ApiBusinessProfileProto.pricing: object expected");
            message.pricing = $root.space.kenko.proto.PricingDetailsProto.fromObject(object.pricing);
        }
        if (object.practice != null) {
            if (typeof object.practice !== "object")
                throw TypeError(".ApiBusinessProfileProto.practice: object expected");
            message.practice = $root.space.kenko.proto.PracticeDetailsProto.fromObject(object.practice);
        }
        if (object.studio != null) {
            if (typeof object.studio !== "object")
                throw TypeError(".ApiBusinessProfileProto.studio: object expected");
            message.studio = $root.space.kenko.proto.StudioDetailsProto.fromObject(object.studio);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApiBusinessProfileProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {ApiBusinessProfileProto} message ApiBusinessProfileProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApiBusinessProfileProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults) {
            object.locations = [];
            object.practitioners = [];
        }
        if (options.defaults) {
            object.versionId = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.lastModifiedTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lastModifiedTimestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.reviewTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.reviewTimestamp = options.longs === String ? "0" : 0;
            object.proto = null;
            object.pricing = null;
            object.practice = null;
            object.studio = null;
        }
        if (message.versionId != null && message.hasOwnProperty("versionId"))
            object.versionId = message.versionId;
        if (message.lastModifiedTimestamp != null && message.hasOwnProperty("lastModifiedTimestamp"))
            if (typeof message.lastModifiedTimestamp === "number")
                object.lastModifiedTimestamp = options.longs === String ? String(message.lastModifiedTimestamp) : message.lastModifiedTimestamp;
            else
                object.lastModifiedTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.lastModifiedTimestamp) : options.longs === Number ? new $util.LongBits(message.lastModifiedTimestamp.low >>> 0, message.lastModifiedTimestamp.high >>> 0).toNumber() : message.lastModifiedTimestamp;
        if (message.reviewTimestamp != null && message.hasOwnProperty("reviewTimestamp"))
            if (typeof message.reviewTimestamp === "number")
                object.reviewTimestamp = options.longs === String ? String(message.reviewTimestamp) : message.reviewTimestamp;
            else
                object.reviewTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.reviewTimestamp) : options.longs === Number ? new $util.LongBits(message.reviewTimestamp.low >>> 0, message.reviewTimestamp.high >>> 0).toNumber() : message.reviewTimestamp;
        if (message.proto != null && message.hasOwnProperty("proto"))
            object.proto = $root.space.kenko.proto.BusinessProfileProto.toObject(message.proto, options);
        if (message.locations && message.locations.length) {
            object.locations = [];
            for (let j = 0; j < message.locations.length; ++j)
                object.locations[j] = $root.space.kenko.proto.BusinessLocationProto.toObject(message.locations[j], options);
        }
        if (message.practitioners && message.practitioners.length) {
            object.practitioners = [];
            for (let j = 0; j < message.practitioners.length; ++j)
                object.practitioners[j] = $root.space.kenko.proto.PractitionerProto.toObject(message.practitioners[j], options);
        }
        if (message.pricing != null && message.hasOwnProperty("pricing"))
            object.pricing = $root.space.kenko.proto.PricingDetailsProto.toObject(message.pricing, options);
        if (message.practice != null && message.hasOwnProperty("practice"))
            object.practice = $root.space.kenko.proto.PracticeDetailsProto.toObject(message.practice, options);
        if (message.studio != null && message.hasOwnProperty("studio"))
            object.studio = $root.space.kenko.proto.StudioDetailsProto.toObject(message.studio, options);
        return object;
    };

    /**
     * Converts this ApiBusinessProfileProto to JSON.
     * @function toJSON
     * @memberof ApiBusinessProfileProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApiBusinessProfileProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApiBusinessProfileProto
     * @function getTypeUrl
     * @memberof ApiBusinessProfileProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApiBusinessProfileProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApiBusinessProfileProto";
    };

    return ApiBusinessProfileProto;
})();

export const UpdateBusinessProfileRequest = $root.UpdateBusinessProfileRequest = (() => {

    /**
     * Properties of an UpdateBusinessProfileRequest.
     * @exports IUpdateBusinessProfileRequest
     * @interface IUpdateBusinessProfileRequest
     * @property {space.kenko.proto.IBusinessProfileProto|null} [businessProfile] UpdateBusinessProfileRequest businessProfile
     */

    /**
     * Constructs a new UpdateBusinessProfileRequest.
     * @exports UpdateBusinessProfileRequest
     * @classdesc Represents an UpdateBusinessProfileRequest.
     * @implements IUpdateBusinessProfileRequest
     * @constructor
     * @param {IUpdateBusinessProfileRequest=} [properties] Properties to set
     */
    function UpdateBusinessProfileRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateBusinessProfileRequest businessProfile.
     * @member {space.kenko.proto.IBusinessProfileProto|null|undefined} businessProfile
     * @memberof UpdateBusinessProfileRequest
     * @instance
     */
    UpdateBusinessProfileRequest.prototype.businessProfile = null;

    /**
     * Creates a new UpdateBusinessProfileRequest instance using the specified properties.
     * @function create
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {IUpdateBusinessProfileRequest=} [properties] Properties to set
     * @returns {UpdateBusinessProfileRequest} UpdateBusinessProfileRequest instance
     */
    UpdateBusinessProfileRequest.create = function create(properties) {
        return new UpdateBusinessProfileRequest(properties);
    };

    /**
     * Encodes the specified UpdateBusinessProfileRequest message. Does not implicitly {@link UpdateBusinessProfileRequest.verify|verify} messages.
     * @function encode
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {IUpdateBusinessProfileRequest} message UpdateBusinessProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateBusinessProfileRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessProfile != null && Object.hasOwnProperty.call(message, "businessProfile"))
            $root.space.kenko.proto.BusinessProfileProto.encode(message.businessProfile, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateBusinessProfileRequest message, length delimited. Does not implicitly {@link UpdateBusinessProfileRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {IUpdateBusinessProfileRequest} message UpdateBusinessProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateBusinessProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateBusinessProfileRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateBusinessProfileRequest} UpdateBusinessProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateBusinessProfileRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateBusinessProfileRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessProfile = $root.space.kenko.proto.BusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateBusinessProfileRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateBusinessProfileRequest} UpdateBusinessProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateBusinessProfileRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateBusinessProfileRequest message.
     * @function verify
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateBusinessProfileRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile")) {
            let error = $root.space.kenko.proto.BusinessProfileProto.verify(message.businessProfile);
            if (error)
                return "businessProfile." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateBusinessProfileRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateBusinessProfileRequest} UpdateBusinessProfileRequest
     */
    UpdateBusinessProfileRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateBusinessProfileRequest)
            return object;
        let message = new $root.UpdateBusinessProfileRequest();
        if (object.businessProfile != null) {
            if (typeof object.businessProfile !== "object")
                throw TypeError(".UpdateBusinessProfileRequest.businessProfile: object expected");
            message.businessProfile = $root.space.kenko.proto.BusinessProfileProto.fromObject(object.businessProfile);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateBusinessProfileRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {UpdateBusinessProfileRequest} message UpdateBusinessProfileRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateBusinessProfileRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.businessProfile = null;
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile"))
            object.businessProfile = $root.space.kenko.proto.BusinessProfileProto.toObject(message.businessProfile, options);
        return object;
    };

    /**
     * Converts this UpdateBusinessProfileRequest to JSON.
     * @function toJSON
     * @memberof UpdateBusinessProfileRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateBusinessProfileRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateBusinessProfileRequest
     * @function getTypeUrl
     * @memberof UpdateBusinessProfileRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateBusinessProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateBusinessProfileRequest";
    };

    return UpdateBusinessProfileRequest;
})();

export const UpdateProviderProfileRequest = $root.UpdateProviderProfileRequest = (() => {

    /**
     * Properties of an UpdateProviderProfileRequest.
     * @exports IUpdateProviderProfileRequest
     * @interface IUpdateProviderProfileRequest
     * @property {space.kenko.proto.IProviderProfileProto|null} [profile] UpdateProviderProfileRequest profile
     */

    /**
     * Constructs a new UpdateProviderProfileRequest.
     * @exports UpdateProviderProfileRequest
     * @classdesc Represents an UpdateProviderProfileRequest.
     * @implements IUpdateProviderProfileRequest
     * @constructor
     * @param {IUpdateProviderProfileRequest=} [properties] Properties to set
     */
    function UpdateProviderProfileRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateProviderProfileRequest profile.
     * @member {space.kenko.proto.IProviderProfileProto|null|undefined} profile
     * @memberof UpdateProviderProfileRequest
     * @instance
     */
    UpdateProviderProfileRequest.prototype.profile = null;

    /**
     * Creates a new UpdateProviderProfileRequest instance using the specified properties.
     * @function create
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {IUpdateProviderProfileRequest=} [properties] Properties to set
     * @returns {UpdateProviderProfileRequest} UpdateProviderProfileRequest instance
     */
    UpdateProviderProfileRequest.create = function create(properties) {
        return new UpdateProviderProfileRequest(properties);
    };

    /**
     * Encodes the specified UpdateProviderProfileRequest message. Does not implicitly {@link UpdateProviderProfileRequest.verify|verify} messages.
     * @function encode
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {IUpdateProviderProfileRequest} message UpdateProviderProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderProfileRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
            $root.space.kenko.proto.ProviderProfileProto.encode(message.profile, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateProviderProfileRequest message, length delimited. Does not implicitly {@link UpdateProviderProfileRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {IUpdateProviderProfileRequest} message UpdateProviderProfileRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderProfileRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateProviderProfileRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateProviderProfileRequest} UpdateProviderProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderProfileRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateProviderProfileRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.profile = $root.space.kenko.proto.ProviderProfileProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateProviderProfileRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateProviderProfileRequest} UpdateProviderProfileRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderProfileRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateProviderProfileRequest message.
     * @function verify
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateProviderProfileRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.profile != null && message.hasOwnProperty("profile")) {
            let error = $root.space.kenko.proto.ProviderProfileProto.verify(message.profile);
            if (error)
                return "profile." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateProviderProfileRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateProviderProfileRequest} UpdateProviderProfileRequest
     */
    UpdateProviderProfileRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateProviderProfileRequest)
            return object;
        let message = new $root.UpdateProviderProfileRequest();
        if (object.profile != null) {
            if (typeof object.profile !== "object")
                throw TypeError(".UpdateProviderProfileRequest.profile: object expected");
            message.profile = $root.space.kenko.proto.ProviderProfileProto.fromObject(object.profile);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateProviderProfileRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {UpdateProviderProfileRequest} message UpdateProviderProfileRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateProviderProfileRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.profile = null;
        if (message.profile != null && message.hasOwnProperty("profile"))
            object.profile = $root.space.kenko.proto.ProviderProfileProto.toObject(message.profile, options);
        return object;
    };

    /**
     * Converts this UpdateProviderProfileRequest to JSON.
     * @function toJSON
     * @memberof UpdateProviderProfileRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateProviderProfileRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateProviderProfileRequest
     * @function getTypeUrl
     * @memberof UpdateProviderProfileRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateProviderProfileRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateProviderProfileRequest";
    };

    return UpdateProviderProfileRequest;
})();

export const UpdateProviderProfileResponse = $root.UpdateProviderProfileResponse = (() => {

    /**
     * Properties of an UpdateProviderProfileResponse.
     * @exports IUpdateProviderProfileResponse
     * @interface IUpdateProviderProfileResponse
     * @property {boolean|null} [okay] UpdateProviderProfileResponse okay
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [fatalErrors] UpdateProviderProfileResponse fatalErrors
     * @property {IApiProviderProto|null} [provider] UpdateProviderProfileResponse provider
     */

    /**
     * Constructs a new UpdateProviderProfileResponse.
     * @exports UpdateProviderProfileResponse
     * @classdesc Represents an UpdateProviderProfileResponse.
     * @implements IUpdateProviderProfileResponse
     * @constructor
     * @param {IUpdateProviderProfileResponse=} [properties] Properties to set
     */
    function UpdateProviderProfileResponse(properties) {
        this.fatalErrors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateProviderProfileResponse okay.
     * @member {boolean} okay
     * @memberof UpdateProviderProfileResponse
     * @instance
     */
    UpdateProviderProfileResponse.prototype.okay = false;

    /**
     * UpdateProviderProfileResponse fatalErrors.
     * @member {Array.<space.kenko.proto.IErrorProto>} fatalErrors
     * @memberof UpdateProviderProfileResponse
     * @instance
     */
    UpdateProviderProfileResponse.prototype.fatalErrors = $util.emptyArray;

    /**
     * UpdateProviderProfileResponse provider.
     * @member {IApiProviderProto|null|undefined} provider
     * @memberof UpdateProviderProfileResponse
     * @instance
     */
    UpdateProviderProfileResponse.prototype.provider = null;

    /**
     * Creates a new UpdateProviderProfileResponse instance using the specified properties.
     * @function create
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {IUpdateProviderProfileResponse=} [properties] Properties to set
     * @returns {UpdateProviderProfileResponse} UpdateProviderProfileResponse instance
     */
    UpdateProviderProfileResponse.create = function create(properties) {
        return new UpdateProviderProfileResponse(properties);
    };

    /**
     * Encodes the specified UpdateProviderProfileResponse message. Does not implicitly {@link UpdateProviderProfileResponse.verify|verify} messages.
     * @function encode
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {IUpdateProviderProfileResponse} message UpdateProviderProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderProfileResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.fatalErrors != null && message.fatalErrors.length)
            for (let i = 0; i < message.fatalErrors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.fatalErrors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
            $root.ApiProviderProto.encode(message.provider, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateProviderProfileResponse message, length delimited. Does not implicitly {@link UpdateProviderProfileResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {IUpdateProviderProfileResponse} message UpdateProviderProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateProviderProfileResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateProviderProfileResponse} UpdateProviderProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderProfileResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateProviderProfileResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.fatalErrors && message.fatalErrors.length))
                        message.fatalErrors = [];
                    message.fatalErrors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.provider = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateProviderProfileResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateProviderProfileResponse} UpdateProviderProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderProfileResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateProviderProfileResponse message.
     * @function verify
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateProviderProfileResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.fatalErrors != null && message.hasOwnProperty("fatalErrors")) {
            if (!Array.isArray(message.fatalErrors))
                return "fatalErrors: array expected";
            for (let i = 0; i < message.fatalErrors.length; ++i) {
                let error = $root.space.kenko.proto.ErrorProto.verify(message.fatalErrors[i]);
                if (error)
                    return "fatalErrors." + error;
            }
        }
        if (message.provider != null && message.hasOwnProperty("provider")) {
            let error = $root.ApiProviderProto.verify(message.provider);
            if (error)
                return "provider." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateProviderProfileResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateProviderProfileResponse} UpdateProviderProfileResponse
     */
    UpdateProviderProfileResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateProviderProfileResponse)
            return object;
        let message = new $root.UpdateProviderProfileResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.fatalErrors) {
            if (!Array.isArray(object.fatalErrors))
                throw TypeError(".UpdateProviderProfileResponse.fatalErrors: array expected");
            message.fatalErrors = [];
            for (let i = 0; i < object.fatalErrors.length; ++i) {
                if (typeof object.fatalErrors[i] !== "object")
                    throw TypeError(".UpdateProviderProfileResponse.fatalErrors: object expected");
                message.fatalErrors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.fatalErrors[i]);
            }
        }
        if (object.provider != null) {
            if (typeof object.provider !== "object")
                throw TypeError(".UpdateProviderProfileResponse.provider: object expected");
            message.provider = $root.ApiProviderProto.fromObject(object.provider);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateProviderProfileResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {UpdateProviderProfileResponse} message UpdateProviderProfileResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateProviderProfileResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.fatalErrors = [];
        if (options.defaults) {
            object.okay = false;
            object.provider = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.fatalErrors && message.fatalErrors.length) {
            object.fatalErrors = [];
            for (let j = 0; j < message.fatalErrors.length; ++j)
                object.fatalErrors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.fatalErrors[j], options);
        }
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = $root.ApiProviderProto.toObject(message.provider, options);
        return object;
    };

    /**
     * Converts this UpdateProviderProfileResponse to JSON.
     * @function toJSON
     * @memberof UpdateProviderProfileResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateProviderProfileResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateProviderProfileResponse
     * @function getTypeUrl
     * @memberof UpdateProviderProfileResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateProviderProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateProviderProfileResponse";
    };

    return UpdateProviderProfileResponse;
})();

export const UpdateBusinessSettingsRequest = $root.UpdateBusinessSettingsRequest = (() => {

    /**
     * Properties of an UpdateBusinessSettingsRequest.
     * @exports IUpdateBusinessSettingsRequest
     * @interface IUpdateBusinessSettingsRequest
     * @property {space.kenko.proto.IBusinessSettingsProto|null} [settings] UpdateBusinessSettingsRequest settings
     */

    /**
     * Constructs a new UpdateBusinessSettingsRequest.
     * @exports UpdateBusinessSettingsRequest
     * @classdesc Represents an UpdateBusinessSettingsRequest.
     * @implements IUpdateBusinessSettingsRequest
     * @constructor
     * @param {IUpdateBusinessSettingsRequest=} [properties] Properties to set
     */
    function UpdateBusinessSettingsRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateBusinessSettingsRequest settings.
     * @member {space.kenko.proto.IBusinessSettingsProto|null|undefined} settings
     * @memberof UpdateBusinessSettingsRequest
     * @instance
     */
    UpdateBusinessSettingsRequest.prototype.settings = null;

    /**
     * Creates a new UpdateBusinessSettingsRequest instance using the specified properties.
     * @function create
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {IUpdateBusinessSettingsRequest=} [properties] Properties to set
     * @returns {UpdateBusinessSettingsRequest} UpdateBusinessSettingsRequest instance
     */
    UpdateBusinessSettingsRequest.create = function create(properties) {
        return new UpdateBusinessSettingsRequest(properties);
    };

    /**
     * Encodes the specified UpdateBusinessSettingsRequest message. Does not implicitly {@link UpdateBusinessSettingsRequest.verify|verify} messages.
     * @function encode
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {IUpdateBusinessSettingsRequest} message UpdateBusinessSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateBusinessSettingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.settings != null && Object.hasOwnProperty.call(message, "settings"))
            $root.space.kenko.proto.BusinessSettingsProto.encode(message.settings, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateBusinessSettingsRequest message, length delimited. Does not implicitly {@link UpdateBusinessSettingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {IUpdateBusinessSettingsRequest} message UpdateBusinessSettingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateBusinessSettingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateBusinessSettingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateBusinessSettingsRequest} UpdateBusinessSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateBusinessSettingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateBusinessSettingsRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.settings = $root.space.kenko.proto.BusinessSettingsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateBusinessSettingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateBusinessSettingsRequest} UpdateBusinessSettingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateBusinessSettingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateBusinessSettingsRequest message.
     * @function verify
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateBusinessSettingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.settings != null && message.hasOwnProperty("settings")) {
            let error = $root.space.kenko.proto.BusinessSettingsProto.verify(message.settings);
            if (error)
                return "settings." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateBusinessSettingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateBusinessSettingsRequest} UpdateBusinessSettingsRequest
     */
    UpdateBusinessSettingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateBusinessSettingsRequest)
            return object;
        let message = new $root.UpdateBusinessSettingsRequest();
        if (object.settings != null) {
            if (typeof object.settings !== "object")
                throw TypeError(".UpdateBusinessSettingsRequest.settings: object expected");
            message.settings = $root.space.kenko.proto.BusinessSettingsProto.fromObject(object.settings);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateBusinessSettingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {UpdateBusinessSettingsRequest} message UpdateBusinessSettingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateBusinessSettingsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.settings = null;
        if (message.settings != null && message.hasOwnProperty("settings"))
            object.settings = $root.space.kenko.proto.BusinessSettingsProto.toObject(message.settings, options);
        return object;
    };

    /**
     * Converts this UpdateBusinessSettingsRequest to JSON.
     * @function toJSON
     * @memberof UpdateBusinessSettingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateBusinessSettingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateBusinessSettingsRequest
     * @function getTypeUrl
     * @memberof UpdateBusinessSettingsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateBusinessSettingsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateBusinessSettingsRequest";
    };

    return UpdateBusinessSettingsRequest;
})();

export const UpdateIntendedMembershipRequest = $root.UpdateIntendedMembershipRequest = (() => {

    /**
     * Properties of an UpdateIntendedMembershipRequest.
     * @exports IUpdateIntendedMembershipRequest
     * @interface IUpdateIntendedMembershipRequest
     * @property {space.kenko.proto.BusinessSubscriptionType|null} [type] UpdateIntendedMembershipRequest type
     * @property {number|null} [quantity] UpdateIntendedMembershipRequest quantity
     */

    /**
     * Constructs a new UpdateIntendedMembershipRequest.
     * @exports UpdateIntendedMembershipRequest
     * @classdesc Represents an UpdateIntendedMembershipRequest.
     * @implements IUpdateIntendedMembershipRequest
     * @constructor
     * @param {IUpdateIntendedMembershipRequest=} [properties] Properties to set
     */
    function UpdateIntendedMembershipRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateIntendedMembershipRequest type.
     * @member {space.kenko.proto.BusinessSubscriptionType} type
     * @memberof UpdateIntendedMembershipRequest
     * @instance
     */
    UpdateIntendedMembershipRequest.prototype.type = 0;

    /**
     * UpdateIntendedMembershipRequest quantity.
     * @member {number} quantity
     * @memberof UpdateIntendedMembershipRequest
     * @instance
     */
    UpdateIntendedMembershipRequest.prototype.quantity = 0;

    /**
     * Creates a new UpdateIntendedMembershipRequest instance using the specified properties.
     * @function create
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {IUpdateIntendedMembershipRequest=} [properties] Properties to set
     * @returns {UpdateIntendedMembershipRequest} UpdateIntendedMembershipRequest instance
     */
    UpdateIntendedMembershipRequest.create = function create(properties) {
        return new UpdateIntendedMembershipRequest(properties);
    };

    /**
     * Encodes the specified UpdateIntendedMembershipRequest message. Does not implicitly {@link UpdateIntendedMembershipRequest.verify|verify} messages.
     * @function encode
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {IUpdateIntendedMembershipRequest} message UpdateIntendedMembershipRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateIntendedMembershipRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.quantity);
        return writer;
    };

    /**
     * Encodes the specified UpdateIntendedMembershipRequest message, length delimited. Does not implicitly {@link UpdateIntendedMembershipRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {IUpdateIntendedMembershipRequest} message UpdateIntendedMembershipRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateIntendedMembershipRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateIntendedMembershipRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateIntendedMembershipRequest} UpdateIntendedMembershipRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateIntendedMembershipRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateIntendedMembershipRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.quantity = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateIntendedMembershipRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateIntendedMembershipRequest} UpdateIntendedMembershipRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateIntendedMembershipRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateIntendedMembershipRequest message.
     * @function verify
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateIntendedMembershipRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            if (!$util.isInteger(message.quantity))
                return "quantity: integer expected";
        return null;
    };

    /**
     * Creates an UpdateIntendedMembershipRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateIntendedMembershipRequest} UpdateIntendedMembershipRequest
     */
    UpdateIntendedMembershipRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateIntendedMembershipRequest)
            return object;
        let message = new $root.UpdateIntendedMembershipRequest();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "SUBSCRIPTION_TYPE_UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "LISTING":
        case 1:
            message.type = 1;
            break;
        case "LISTING_PLUS_BOOKING":
        case 2:
            message.type = 2;
            break;
        }
        if (object.quantity != null)
            message.quantity = object.quantity | 0;
        return message;
    };

    /**
     * Creates a plain object from an UpdateIntendedMembershipRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {UpdateIntendedMembershipRequest} message UpdateIntendedMembershipRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateIntendedMembershipRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "SUBSCRIPTION_TYPE_UNKNOWN" : 0;
            object.quantity = 0;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.space.kenko.proto.BusinessSubscriptionType[message.type] === undefined ? message.type : $root.space.kenko.proto.BusinessSubscriptionType[message.type] : message.type;
        if (message.quantity != null && message.hasOwnProperty("quantity"))
            object.quantity = message.quantity;
        return object;
    };

    /**
     * Converts this UpdateIntendedMembershipRequest to JSON.
     * @function toJSON
     * @memberof UpdateIntendedMembershipRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateIntendedMembershipRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateIntendedMembershipRequest
     * @function getTypeUrl
     * @memberof UpdateIntendedMembershipRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateIntendedMembershipRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateIntendedMembershipRequest";
    };

    return UpdateIntendedMembershipRequest;
})();

export const DebugDeleteProviderRequest = $root.DebugDeleteProviderRequest = (() => {

    /**
     * Properties of a DebugDeleteProviderRequest.
     * @exports IDebugDeleteProviderRequest
     * @interface IDebugDeleteProviderRequest
     * @property {boolean|null} [resetProvider] DebugDeleteProviderRequest resetProvider
     * @property {boolean|null} [deleteProvider] DebugDeleteProviderRequest deleteProvider
     * @property {boolean|null} [resetBusiness] DebugDeleteProviderRequest resetBusiness
     * @property {boolean|null} [deleteBusinessAndAllProviders] DebugDeleteProviderRequest deleteBusinessAndAllProviders
     * @property {boolean|null} [autoApproveBusiness] DebugDeleteProviderRequest autoApproveBusiness
     */

    /**
     * Constructs a new DebugDeleteProviderRequest.
     * @exports DebugDeleteProviderRequest
     * @classdesc Represents a DebugDeleteProviderRequest.
     * @implements IDebugDeleteProviderRequest
     * @constructor
     * @param {IDebugDeleteProviderRequest=} [properties] Properties to set
     */
    function DebugDeleteProviderRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugDeleteProviderRequest resetProvider.
     * @member {boolean} resetProvider
     * @memberof DebugDeleteProviderRequest
     * @instance
     */
    DebugDeleteProviderRequest.prototype.resetProvider = false;

    /**
     * DebugDeleteProviderRequest deleteProvider.
     * @member {boolean} deleteProvider
     * @memberof DebugDeleteProviderRequest
     * @instance
     */
    DebugDeleteProviderRequest.prototype.deleteProvider = false;

    /**
     * DebugDeleteProviderRequest resetBusiness.
     * @member {boolean} resetBusiness
     * @memberof DebugDeleteProviderRequest
     * @instance
     */
    DebugDeleteProviderRequest.prototype.resetBusiness = false;

    /**
     * DebugDeleteProviderRequest deleteBusinessAndAllProviders.
     * @member {boolean} deleteBusinessAndAllProviders
     * @memberof DebugDeleteProviderRequest
     * @instance
     */
    DebugDeleteProviderRequest.prototype.deleteBusinessAndAllProviders = false;

    /**
     * DebugDeleteProviderRequest autoApproveBusiness.
     * @member {boolean} autoApproveBusiness
     * @memberof DebugDeleteProviderRequest
     * @instance
     */
    DebugDeleteProviderRequest.prototype.autoApproveBusiness = false;

    /**
     * Creates a new DebugDeleteProviderRequest instance using the specified properties.
     * @function create
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {IDebugDeleteProviderRequest=} [properties] Properties to set
     * @returns {DebugDeleteProviderRequest} DebugDeleteProviderRequest instance
     */
    DebugDeleteProviderRequest.create = function create(properties) {
        return new DebugDeleteProviderRequest(properties);
    };

    /**
     * Encodes the specified DebugDeleteProviderRequest message. Does not implicitly {@link DebugDeleteProviderRequest.verify|verify} messages.
     * @function encode
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {IDebugDeleteProviderRequest} message DebugDeleteProviderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteProviderRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.resetProvider != null && Object.hasOwnProperty.call(message, "resetProvider"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.resetProvider);
        if (message.deleteProvider != null && Object.hasOwnProperty.call(message, "deleteProvider"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.deleteProvider);
        if (message.resetBusiness != null && Object.hasOwnProperty.call(message, "resetBusiness"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.resetBusiness);
        if (message.deleteBusinessAndAllProviders != null && Object.hasOwnProperty.call(message, "deleteBusinessAndAllProviders"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.deleteBusinessAndAllProviders);
        if (message.autoApproveBusiness != null && Object.hasOwnProperty.call(message, "autoApproveBusiness"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.autoApproveBusiness);
        return writer;
    };

    /**
     * Encodes the specified DebugDeleteProviderRequest message, length delimited. Does not implicitly {@link DebugDeleteProviderRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {IDebugDeleteProviderRequest} message DebugDeleteProviderRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteProviderRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DebugDeleteProviderRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugDeleteProviderRequest} DebugDeleteProviderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteProviderRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugDeleteProviderRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.resetProvider = reader.bool();
                    break;
                }
            case 2: {
                    message.deleteProvider = reader.bool();
                    break;
                }
            case 3: {
                    message.resetBusiness = reader.bool();
                    break;
                }
            case 4: {
                    message.deleteBusinessAndAllProviders = reader.bool();
                    break;
                }
            case 5: {
                    message.autoApproveBusiness = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DebugDeleteProviderRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugDeleteProviderRequest} DebugDeleteProviderRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteProviderRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugDeleteProviderRequest message.
     * @function verify
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugDeleteProviderRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.resetProvider != null && message.hasOwnProperty("resetProvider"))
            if (typeof message.resetProvider !== "boolean")
                return "resetProvider: boolean expected";
        if (message.deleteProvider != null && message.hasOwnProperty("deleteProvider"))
            if (typeof message.deleteProvider !== "boolean")
                return "deleteProvider: boolean expected";
        if (message.resetBusiness != null && message.hasOwnProperty("resetBusiness"))
            if (typeof message.resetBusiness !== "boolean")
                return "resetBusiness: boolean expected";
        if (message.deleteBusinessAndAllProviders != null && message.hasOwnProperty("deleteBusinessAndAllProviders"))
            if (typeof message.deleteBusinessAndAllProviders !== "boolean")
                return "deleteBusinessAndAllProviders: boolean expected";
        if (message.autoApproveBusiness != null && message.hasOwnProperty("autoApproveBusiness"))
            if (typeof message.autoApproveBusiness !== "boolean")
                return "autoApproveBusiness: boolean expected";
        return null;
    };

    /**
     * Creates a DebugDeleteProviderRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugDeleteProviderRequest} DebugDeleteProviderRequest
     */
    DebugDeleteProviderRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugDeleteProviderRequest)
            return object;
        let message = new $root.DebugDeleteProviderRequest();
        if (object.resetProvider != null)
            message.resetProvider = Boolean(object.resetProvider);
        if (object.deleteProvider != null)
            message.deleteProvider = Boolean(object.deleteProvider);
        if (object.resetBusiness != null)
            message.resetBusiness = Boolean(object.resetBusiness);
        if (object.deleteBusinessAndAllProviders != null)
            message.deleteBusinessAndAllProviders = Boolean(object.deleteBusinessAndAllProviders);
        if (object.autoApproveBusiness != null)
            message.autoApproveBusiness = Boolean(object.autoApproveBusiness);
        return message;
    };

    /**
     * Creates a plain object from a DebugDeleteProviderRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {DebugDeleteProviderRequest} message DebugDeleteProviderRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugDeleteProviderRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.resetProvider = false;
            object.deleteProvider = false;
            object.resetBusiness = false;
            object.deleteBusinessAndAllProviders = false;
            object.autoApproveBusiness = false;
        }
        if (message.resetProvider != null && message.hasOwnProperty("resetProvider"))
            object.resetProvider = message.resetProvider;
        if (message.deleteProvider != null && message.hasOwnProperty("deleteProvider"))
            object.deleteProvider = message.deleteProvider;
        if (message.resetBusiness != null && message.hasOwnProperty("resetBusiness"))
            object.resetBusiness = message.resetBusiness;
        if (message.deleteBusinessAndAllProviders != null && message.hasOwnProperty("deleteBusinessAndAllProviders"))
            object.deleteBusinessAndAllProviders = message.deleteBusinessAndAllProviders;
        if (message.autoApproveBusiness != null && message.hasOwnProperty("autoApproveBusiness"))
            object.autoApproveBusiness = message.autoApproveBusiness;
        return object;
    };

    /**
     * Converts this DebugDeleteProviderRequest to JSON.
     * @function toJSON
     * @memberof DebugDeleteProviderRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugDeleteProviderRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugDeleteProviderRequest
     * @function getTypeUrl
     * @memberof DebugDeleteProviderRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugDeleteProviderRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugDeleteProviderRequest";
    };

    return DebugDeleteProviderRequest;
})();

export const DebugDeleteProviderResponse = $root.DebugDeleteProviderResponse = (() => {

    /**
     * Properties of a DebugDeleteProviderResponse.
     * @exports IDebugDeleteProviderResponse
     * @interface IDebugDeleteProviderResponse
     * @property {boolean|null} [okay] DebugDeleteProviderResponse okay
     * @property {IApiProviderProto|null} [provider] DebugDeleteProviderResponse provider
     * @property {IApiBusinessProto|null} [business] DebugDeleteProviderResponse business
     * @property {IApiBusinessProfileProto|null} [businessProfile] DebugDeleteProviderResponse businessProfile
     */

    /**
     * Constructs a new DebugDeleteProviderResponse.
     * @exports DebugDeleteProviderResponse
     * @classdesc Represents a DebugDeleteProviderResponse.
     * @implements IDebugDeleteProviderResponse
     * @constructor
     * @param {IDebugDeleteProviderResponse=} [properties] Properties to set
     */
    function DebugDeleteProviderResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugDeleteProviderResponse okay.
     * @member {boolean} okay
     * @memberof DebugDeleteProviderResponse
     * @instance
     */
    DebugDeleteProviderResponse.prototype.okay = false;

    /**
     * DebugDeleteProviderResponse provider.
     * @member {IApiProviderProto|null|undefined} provider
     * @memberof DebugDeleteProviderResponse
     * @instance
     */
    DebugDeleteProviderResponse.prototype.provider = null;

    /**
     * DebugDeleteProviderResponse business.
     * @member {IApiBusinessProto|null|undefined} business
     * @memberof DebugDeleteProviderResponse
     * @instance
     */
    DebugDeleteProviderResponse.prototype.business = null;

    /**
     * DebugDeleteProviderResponse businessProfile.
     * @member {IApiBusinessProfileProto|null|undefined} businessProfile
     * @memberof DebugDeleteProviderResponse
     * @instance
     */
    DebugDeleteProviderResponse.prototype.businessProfile = null;

    /**
     * Creates a new DebugDeleteProviderResponse instance using the specified properties.
     * @function create
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {IDebugDeleteProviderResponse=} [properties] Properties to set
     * @returns {DebugDeleteProviderResponse} DebugDeleteProviderResponse instance
     */
    DebugDeleteProviderResponse.create = function create(properties) {
        return new DebugDeleteProviderResponse(properties);
    };

    /**
     * Encodes the specified DebugDeleteProviderResponse message. Does not implicitly {@link DebugDeleteProviderResponse.verify|verify} messages.
     * @function encode
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {IDebugDeleteProviderResponse} message DebugDeleteProviderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteProviderResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
            $root.ApiProviderProto.encode(message.provider, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.business != null && Object.hasOwnProperty.call(message, "business"))
            $root.ApiBusinessProto.encode(message.business, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.businessProfile != null && Object.hasOwnProperty.call(message, "businessProfile"))
            $root.ApiBusinessProfileProto.encode(message.businessProfile, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified DebugDeleteProviderResponse message, length delimited. Does not implicitly {@link DebugDeleteProviderResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {IDebugDeleteProviderResponse} message DebugDeleteProviderResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteProviderResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DebugDeleteProviderResponse message from the specified reader or buffer.
     * @function decode
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugDeleteProviderResponse} DebugDeleteProviderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteProviderResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugDeleteProviderResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.provider = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.business = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.businessProfile = $root.ApiBusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DebugDeleteProviderResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugDeleteProviderResponse} DebugDeleteProviderResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteProviderResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugDeleteProviderResponse message.
     * @function verify
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugDeleteProviderResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.provider != null && message.hasOwnProperty("provider")) {
            let error = $root.ApiProviderProto.verify(message.provider);
            if (error)
                return "provider." + error;
        }
        if (message.business != null && message.hasOwnProperty("business")) {
            let error = $root.ApiBusinessProto.verify(message.business);
            if (error)
                return "business." + error;
        }
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile")) {
            let error = $root.ApiBusinessProfileProto.verify(message.businessProfile);
            if (error)
                return "businessProfile." + error;
        }
        return null;
    };

    /**
     * Creates a DebugDeleteProviderResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugDeleteProviderResponse} DebugDeleteProviderResponse
     */
    DebugDeleteProviderResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugDeleteProviderResponse)
            return object;
        let message = new $root.DebugDeleteProviderResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.provider != null) {
            if (typeof object.provider !== "object")
                throw TypeError(".DebugDeleteProviderResponse.provider: object expected");
            message.provider = $root.ApiProviderProto.fromObject(object.provider);
        }
        if (object.business != null) {
            if (typeof object.business !== "object")
                throw TypeError(".DebugDeleteProviderResponse.business: object expected");
            message.business = $root.ApiBusinessProto.fromObject(object.business);
        }
        if (object.businessProfile != null) {
            if (typeof object.businessProfile !== "object")
                throw TypeError(".DebugDeleteProviderResponse.businessProfile: object expected");
            message.businessProfile = $root.ApiBusinessProfileProto.fromObject(object.businessProfile);
        }
        return message;
    };

    /**
     * Creates a plain object from a DebugDeleteProviderResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {DebugDeleteProviderResponse} message DebugDeleteProviderResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugDeleteProviderResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.okay = false;
            object.provider = null;
            object.business = null;
            object.businessProfile = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = $root.ApiProviderProto.toObject(message.provider, options);
        if (message.business != null && message.hasOwnProperty("business"))
            object.business = $root.ApiBusinessProto.toObject(message.business, options);
        if (message.businessProfile != null && message.hasOwnProperty("businessProfile"))
            object.businessProfile = $root.ApiBusinessProfileProto.toObject(message.businessProfile, options);
        return object;
    };

    /**
     * Converts this DebugDeleteProviderResponse to JSON.
     * @function toJSON
     * @memberof DebugDeleteProviderResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugDeleteProviderResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugDeleteProviderResponse
     * @function getTypeUrl
     * @memberof DebugDeleteProviderResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugDeleteProviderResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugDeleteProviderResponse";
    };

    return DebugDeleteProviderResponse;
})();

export const MutateServiceRequest = $root.MutateServiceRequest = (() => {

    /**
     * Properties of a MutateServiceRequest.
     * @exports IMutateServiceRequest
     * @interface IMutateServiceRequest
     * @property {space.kenko.proto.IServiceProto|null} [service] MutateServiceRequest service
     */

    /**
     * Constructs a new MutateServiceRequest.
     * @exports MutateServiceRequest
     * @classdesc Represents a MutateServiceRequest.
     * @implements IMutateServiceRequest
     * @constructor
     * @param {IMutateServiceRequest=} [properties] Properties to set
     */
    function MutateServiceRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateServiceRequest service.
     * @member {space.kenko.proto.IServiceProto|null|undefined} service
     * @memberof MutateServiceRequest
     * @instance
     */
    MutateServiceRequest.prototype.service = null;

    /**
     * Creates a new MutateServiceRequest instance using the specified properties.
     * @function create
     * @memberof MutateServiceRequest
     * @static
     * @param {IMutateServiceRequest=} [properties] Properties to set
     * @returns {MutateServiceRequest} MutateServiceRequest instance
     */
    MutateServiceRequest.create = function create(properties) {
        return new MutateServiceRequest(properties);
    };

    /**
     * Encodes the specified MutateServiceRequest message. Does not implicitly {@link MutateServiceRequest.verify|verify} messages.
     * @function encode
     * @memberof MutateServiceRequest
     * @static
     * @param {IMutateServiceRequest} message MutateServiceRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateServiceRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.service != null && Object.hasOwnProperty.call(message, "service"))
            $root.space.kenko.proto.ServiceProto.encode(message.service, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutateServiceRequest message, length delimited. Does not implicitly {@link MutateServiceRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateServiceRequest
     * @static
     * @param {IMutateServiceRequest} message MutateServiceRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateServiceRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateServiceRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MutateServiceRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateServiceRequest} MutateServiceRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateServiceRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateServiceRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.service = $root.space.kenko.proto.ServiceProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateServiceRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateServiceRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateServiceRequest} MutateServiceRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateServiceRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateServiceRequest message.
     * @function verify
     * @memberof MutateServiceRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateServiceRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.service != null && message.hasOwnProperty("service")) {
            let error = $root.space.kenko.proto.ServiceProto.verify(message.service);
            if (error)
                return "service." + error;
        }
        return null;
    };

    /**
     * Creates a MutateServiceRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateServiceRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateServiceRequest} MutateServiceRequest
     */
    MutateServiceRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateServiceRequest)
            return object;
        let message = new $root.MutateServiceRequest();
        if (object.service != null) {
            if (typeof object.service !== "object")
                throw TypeError(".MutateServiceRequest.service: object expected");
            message.service = $root.space.kenko.proto.ServiceProto.fromObject(object.service);
        }
        return message;
    };

    /**
     * Creates a plain object from a MutateServiceRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateServiceRequest
     * @static
     * @param {MutateServiceRequest} message MutateServiceRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateServiceRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.service = null;
        if (message.service != null && message.hasOwnProperty("service"))
            object.service = $root.space.kenko.proto.ServiceProto.toObject(message.service, options);
        return object;
    };

    /**
     * Converts this MutateServiceRequest to JSON.
     * @function toJSON
     * @memberof MutateServiceRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateServiceRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateServiceRequest
     * @function getTypeUrl
     * @memberof MutateServiceRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateServiceRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateServiceRequest";
    };

    return MutateServiceRequest;
})();

export const MutateClassTemplateRequest = $root.MutateClassTemplateRequest = (() => {

    /**
     * Properties of a MutateClassTemplateRequest.
     * @exports IMutateClassTemplateRequest
     * @interface IMutateClassTemplateRequest
     * @property {space.kenko.proto.IClassTemplateProto|null} [classTemplate] MutateClassTemplateRequest classTemplate
     */

    /**
     * Constructs a new MutateClassTemplateRequest.
     * @exports MutateClassTemplateRequest
     * @classdesc Represents a MutateClassTemplateRequest.
     * @implements IMutateClassTemplateRequest
     * @constructor
     * @param {IMutateClassTemplateRequest=} [properties] Properties to set
     */
    function MutateClassTemplateRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateClassTemplateRequest classTemplate.
     * @member {space.kenko.proto.IClassTemplateProto|null|undefined} classTemplate
     * @memberof MutateClassTemplateRequest
     * @instance
     */
    MutateClassTemplateRequest.prototype.classTemplate = null;

    /**
     * Creates a new MutateClassTemplateRequest instance using the specified properties.
     * @function create
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {IMutateClassTemplateRequest=} [properties] Properties to set
     * @returns {MutateClassTemplateRequest} MutateClassTemplateRequest instance
     */
    MutateClassTemplateRequest.create = function create(properties) {
        return new MutateClassTemplateRequest(properties);
    };

    /**
     * Encodes the specified MutateClassTemplateRequest message. Does not implicitly {@link MutateClassTemplateRequest.verify|verify} messages.
     * @function encode
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {IMutateClassTemplateRequest} message MutateClassTemplateRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateClassTemplateRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classTemplate != null && Object.hasOwnProperty.call(message, "classTemplate"))
            $root.space.kenko.proto.ClassTemplateProto.encode(message.classTemplate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutateClassTemplateRequest message, length delimited. Does not implicitly {@link MutateClassTemplateRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {IMutateClassTemplateRequest} message MutateClassTemplateRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateClassTemplateRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateClassTemplateRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateClassTemplateRequest} MutateClassTemplateRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateClassTemplateRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateClassTemplateRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classTemplate = $root.space.kenko.proto.ClassTemplateProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateClassTemplateRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateClassTemplateRequest} MutateClassTemplateRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateClassTemplateRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateClassTemplateRequest message.
     * @function verify
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateClassTemplateRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.classTemplate != null && message.hasOwnProperty("classTemplate")) {
            let error = $root.space.kenko.proto.ClassTemplateProto.verify(message.classTemplate);
            if (error)
                return "classTemplate." + error;
        }
        return null;
    };

    /**
     * Creates a MutateClassTemplateRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateClassTemplateRequest} MutateClassTemplateRequest
     */
    MutateClassTemplateRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateClassTemplateRequest)
            return object;
        let message = new $root.MutateClassTemplateRequest();
        if (object.classTemplate != null) {
            if (typeof object.classTemplate !== "object")
                throw TypeError(".MutateClassTemplateRequest.classTemplate: object expected");
            message.classTemplate = $root.space.kenko.proto.ClassTemplateProto.fromObject(object.classTemplate);
        }
        return message;
    };

    /**
     * Creates a plain object from a MutateClassTemplateRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {MutateClassTemplateRequest} message MutateClassTemplateRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateClassTemplateRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.classTemplate = null;
        if (message.classTemplate != null && message.hasOwnProperty("classTemplate"))
            object.classTemplate = $root.space.kenko.proto.ClassTemplateProto.toObject(message.classTemplate, options);
        return object;
    };

    /**
     * Converts this MutateClassTemplateRequest to JSON.
     * @function toJSON
     * @memberof MutateClassTemplateRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateClassTemplateRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateClassTemplateRequest
     * @function getTypeUrl
     * @memberof MutateClassTemplateRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateClassTemplateRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateClassTemplateRequest";
    };

    return MutateClassTemplateRequest;
})();

export const MutatePractitionerRequest = $root.MutatePractitionerRequest = (() => {

    /**
     * Properties of a MutatePractitionerRequest.
     * @exports IMutatePractitionerRequest
     * @interface IMutatePractitionerRequest
     * @property {space.kenko.proto.IPractitionerProto|null} [practitioner] MutatePractitionerRequest practitioner
     */

    /**
     * Constructs a new MutatePractitionerRequest.
     * @exports MutatePractitionerRequest
     * @classdesc Represents a MutatePractitionerRequest.
     * @implements IMutatePractitionerRequest
     * @constructor
     * @param {IMutatePractitionerRequest=} [properties] Properties to set
     */
    function MutatePractitionerRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutatePractitionerRequest practitioner.
     * @member {space.kenko.proto.IPractitionerProto|null|undefined} practitioner
     * @memberof MutatePractitionerRequest
     * @instance
     */
    MutatePractitionerRequest.prototype.practitioner = null;

    /**
     * Creates a new MutatePractitionerRequest instance using the specified properties.
     * @function create
     * @memberof MutatePractitionerRequest
     * @static
     * @param {IMutatePractitionerRequest=} [properties] Properties to set
     * @returns {MutatePractitionerRequest} MutatePractitionerRequest instance
     */
    MutatePractitionerRequest.create = function create(properties) {
        return new MutatePractitionerRequest(properties);
    };

    /**
     * Encodes the specified MutatePractitionerRequest message. Does not implicitly {@link MutatePractitionerRequest.verify|verify} messages.
     * @function encode
     * @memberof MutatePractitionerRequest
     * @static
     * @param {IMutatePractitionerRequest} message MutatePractitionerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutatePractitionerRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.practitioner != null && Object.hasOwnProperty.call(message, "practitioner"))
            $root.space.kenko.proto.PractitionerProto.encode(message.practitioner, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutatePractitionerRequest message, length delimited. Does not implicitly {@link MutatePractitionerRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutatePractitionerRequest
     * @static
     * @param {IMutatePractitionerRequest} message MutatePractitionerRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutatePractitionerRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutatePractitionerRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MutatePractitionerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutatePractitionerRequest} MutatePractitionerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutatePractitionerRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutatePractitionerRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.practitioner = $root.space.kenko.proto.PractitionerProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutatePractitionerRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutatePractitionerRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutatePractitionerRequest} MutatePractitionerRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutatePractitionerRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutatePractitionerRequest message.
     * @function verify
     * @memberof MutatePractitionerRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutatePractitionerRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.practitioner != null && message.hasOwnProperty("practitioner")) {
            let error = $root.space.kenko.proto.PractitionerProto.verify(message.practitioner);
            if (error)
                return "practitioner." + error;
        }
        return null;
    };

    /**
     * Creates a MutatePractitionerRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutatePractitionerRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutatePractitionerRequest} MutatePractitionerRequest
     */
    MutatePractitionerRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MutatePractitionerRequest)
            return object;
        let message = new $root.MutatePractitionerRequest();
        if (object.practitioner != null) {
            if (typeof object.practitioner !== "object")
                throw TypeError(".MutatePractitionerRequest.practitioner: object expected");
            message.practitioner = $root.space.kenko.proto.PractitionerProto.fromObject(object.practitioner);
        }
        return message;
    };

    /**
     * Creates a plain object from a MutatePractitionerRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutatePractitionerRequest
     * @static
     * @param {MutatePractitionerRequest} message MutatePractitionerRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutatePractitionerRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.practitioner = null;
        if (message.practitioner != null && message.hasOwnProperty("practitioner"))
            object.practitioner = $root.space.kenko.proto.PractitionerProto.toObject(message.practitioner, options);
        return object;
    };

    /**
     * Converts this MutatePractitionerRequest to JSON.
     * @function toJSON
     * @memberof MutatePractitionerRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutatePractitionerRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutatePractitionerRequest
     * @function getTypeUrl
     * @memberof MutatePractitionerRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutatePractitionerRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutatePractitionerRequest";
    };

    return MutatePractitionerRequest;
})();

export const MutateTeamMemberRequest = $root.MutateTeamMemberRequest = (() => {

    /**
     * Properties of a MutateTeamMemberRequest.
     * @exports IMutateTeamMemberRequest
     * @interface IMutateTeamMemberRequest
     * @property {IApiProviderProto|null} [teamMember] MutateTeamMemberRequest teamMember
     */

    /**
     * Constructs a new MutateTeamMemberRequest.
     * @exports MutateTeamMemberRequest
     * @classdesc Represents a MutateTeamMemberRequest.
     * @implements IMutateTeamMemberRequest
     * @constructor
     * @param {IMutateTeamMemberRequest=} [properties] Properties to set
     */
    function MutateTeamMemberRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateTeamMemberRequest teamMember.
     * @member {IApiProviderProto|null|undefined} teamMember
     * @memberof MutateTeamMemberRequest
     * @instance
     */
    MutateTeamMemberRequest.prototype.teamMember = null;

    /**
     * Creates a new MutateTeamMemberRequest instance using the specified properties.
     * @function create
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {IMutateTeamMemberRequest=} [properties] Properties to set
     * @returns {MutateTeamMemberRequest} MutateTeamMemberRequest instance
     */
    MutateTeamMemberRequest.create = function create(properties) {
        return new MutateTeamMemberRequest(properties);
    };

    /**
     * Encodes the specified MutateTeamMemberRequest message. Does not implicitly {@link MutateTeamMemberRequest.verify|verify} messages.
     * @function encode
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {IMutateTeamMemberRequest} message MutateTeamMemberRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateTeamMemberRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.teamMember != null && Object.hasOwnProperty.call(message, "teamMember"))
            $root.ApiProviderProto.encode(message.teamMember, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutateTeamMemberRequest message, length delimited. Does not implicitly {@link MutateTeamMemberRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {IMutateTeamMemberRequest} message MutateTeamMemberRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateTeamMemberRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateTeamMemberRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateTeamMemberRequest} MutateTeamMemberRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateTeamMemberRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateTeamMemberRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.teamMember = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateTeamMemberRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateTeamMemberRequest} MutateTeamMemberRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateTeamMemberRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateTeamMemberRequest message.
     * @function verify
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateTeamMemberRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.teamMember != null && message.hasOwnProperty("teamMember")) {
            let error = $root.ApiProviderProto.verify(message.teamMember);
            if (error)
                return "teamMember." + error;
        }
        return null;
    };

    /**
     * Creates a MutateTeamMemberRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateTeamMemberRequest} MutateTeamMemberRequest
     */
    MutateTeamMemberRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateTeamMemberRequest)
            return object;
        let message = new $root.MutateTeamMemberRequest();
        if (object.teamMember != null) {
            if (typeof object.teamMember !== "object")
                throw TypeError(".MutateTeamMemberRequest.teamMember: object expected");
            message.teamMember = $root.ApiProviderProto.fromObject(object.teamMember);
        }
        return message;
    };

    /**
     * Creates a plain object from a MutateTeamMemberRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {MutateTeamMemberRequest} message MutateTeamMemberRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateTeamMemberRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.teamMember = null;
        if (message.teamMember != null && message.hasOwnProperty("teamMember"))
            object.teamMember = $root.ApiProviderProto.toObject(message.teamMember, options);
        return object;
    };

    /**
     * Converts this MutateTeamMemberRequest to JSON.
     * @function toJSON
     * @memberof MutateTeamMemberRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateTeamMemberRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateTeamMemberRequest
     * @function getTypeUrl
     * @memberof MutateTeamMemberRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateTeamMemberRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateTeamMemberRequest";
    };

    return MutateTeamMemberRequest;
})();

export const MutateTeamMemberResponse = $root.MutateTeamMemberResponse = (() => {

    /**
     * Properties of a MutateTeamMemberResponse.
     * @exports IMutateTeamMemberResponse
     * @interface IMutateTeamMemberResponse
     * @property {boolean|null} [okay] MutateTeamMemberResponse okay
     * @property {IApiProviderProto|null} [updated] MutateTeamMemberResponse updated
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] MutateTeamMemberResponse errors
     */

    /**
     * Constructs a new MutateTeamMemberResponse.
     * @exports MutateTeamMemberResponse
     * @classdesc Represents a MutateTeamMemberResponse.
     * @implements IMutateTeamMemberResponse
     * @constructor
     * @param {IMutateTeamMemberResponse=} [properties] Properties to set
     */
    function MutateTeamMemberResponse(properties) {
        this.errors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateTeamMemberResponse okay.
     * @member {boolean} okay
     * @memberof MutateTeamMemberResponse
     * @instance
     */
    MutateTeamMemberResponse.prototype.okay = false;

    /**
     * MutateTeamMemberResponse updated.
     * @member {IApiProviderProto|null|undefined} updated
     * @memberof MutateTeamMemberResponse
     * @instance
     */
    MutateTeamMemberResponse.prototype.updated = null;

    /**
     * MutateTeamMemberResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof MutateTeamMemberResponse
     * @instance
     */
    MutateTeamMemberResponse.prototype.errors = $util.emptyArray;

    /**
     * Creates a new MutateTeamMemberResponse instance using the specified properties.
     * @function create
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {IMutateTeamMemberResponse=} [properties] Properties to set
     * @returns {MutateTeamMemberResponse} MutateTeamMemberResponse instance
     */
    MutateTeamMemberResponse.create = function create(properties) {
        return new MutateTeamMemberResponse(properties);
    };

    /**
     * Encodes the specified MutateTeamMemberResponse message. Does not implicitly {@link MutateTeamMemberResponse.verify|verify} messages.
     * @function encode
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {IMutateTeamMemberResponse} message MutateTeamMemberResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateTeamMemberResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.updated != null && Object.hasOwnProperty.call(message, "updated"))
            $root.ApiProviderProto.encode(message.updated, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.errors != null && message.errors.length)
            for (let i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutateTeamMemberResponse message, length delimited. Does not implicitly {@link MutateTeamMemberResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {IMutateTeamMemberResponse} message MutateTeamMemberResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateTeamMemberResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateTeamMemberResponse message from the specified reader or buffer.
     * @function decode
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateTeamMemberResponse} MutateTeamMemberResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateTeamMemberResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateTeamMemberResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.updated = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateTeamMemberResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateTeamMemberResponse} MutateTeamMemberResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateTeamMemberResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateTeamMemberResponse message.
     * @function verify
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateTeamMemberResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.updated != null && message.hasOwnProperty("updated")) {
            let error = $root.ApiProviderProto.verify(message.updated);
            if (error)
                return "updated." + error;
        }
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (let i = 0; i < message.errors.length; ++i) {
                let error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        return null;
    };

    /**
     * Creates a MutateTeamMemberResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateTeamMemberResponse} MutateTeamMemberResponse
     */
    MutateTeamMemberResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateTeamMemberResponse)
            return object;
        let message = new $root.MutateTeamMemberResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.updated != null) {
            if (typeof object.updated !== "object")
                throw TypeError(".MutateTeamMemberResponse.updated: object expected");
            message.updated = $root.ApiProviderProto.fromObject(object.updated);
        }
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".MutateTeamMemberResponse.errors: array expected");
            message.errors = [];
            for (let i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".MutateTeamMemberResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a MutateTeamMemberResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {MutateTeamMemberResponse} message MutateTeamMemberResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateTeamMemberResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults) {
            object.okay = false;
            object.updated = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.updated != null && message.hasOwnProperty("updated"))
            object.updated = $root.ApiProviderProto.toObject(message.updated, options);
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (let j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        return object;
    };

    /**
     * Converts this MutateTeamMemberResponse to JSON.
     * @function toJSON
     * @memberof MutateTeamMemberResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateTeamMemberResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateTeamMemberResponse
     * @function getTypeUrl
     * @memberof MutateTeamMemberResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateTeamMemberResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateTeamMemberResponse";
    };

    return MutateTeamMemberResponse;
})();

export const AcceptBusinessInviteRequest = $root.AcceptBusinessInviteRequest = (() => {

    /**
     * Properties of an AcceptBusinessInviteRequest.
     * @exports IAcceptBusinessInviteRequest
     * @interface IAcceptBusinessInviteRequest
     * @property {string|null} [inviteCode] AcceptBusinessInviteRequest inviteCode
     * @property {boolean|null} [accepted] AcceptBusinessInviteRequest accepted
     */

    /**
     * Constructs a new AcceptBusinessInviteRequest.
     * @exports AcceptBusinessInviteRequest
     * @classdesc Represents an AcceptBusinessInviteRequest.
     * @implements IAcceptBusinessInviteRequest
     * @constructor
     * @param {IAcceptBusinessInviteRequest=} [properties] Properties to set
     */
    function AcceptBusinessInviteRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AcceptBusinessInviteRequest inviteCode.
     * @member {string} inviteCode
     * @memberof AcceptBusinessInviteRequest
     * @instance
     */
    AcceptBusinessInviteRequest.prototype.inviteCode = "";

    /**
     * AcceptBusinessInviteRequest accepted.
     * @member {boolean} accepted
     * @memberof AcceptBusinessInviteRequest
     * @instance
     */
    AcceptBusinessInviteRequest.prototype.accepted = false;

    /**
     * Creates a new AcceptBusinessInviteRequest instance using the specified properties.
     * @function create
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {IAcceptBusinessInviteRequest=} [properties] Properties to set
     * @returns {AcceptBusinessInviteRequest} AcceptBusinessInviteRequest instance
     */
    AcceptBusinessInviteRequest.create = function create(properties) {
        return new AcceptBusinessInviteRequest(properties);
    };

    /**
     * Encodes the specified AcceptBusinessInviteRequest message. Does not implicitly {@link AcceptBusinessInviteRequest.verify|verify} messages.
     * @function encode
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {IAcceptBusinessInviteRequest} message AcceptBusinessInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptBusinessInviteRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
        if (message.accepted != null && Object.hasOwnProperty.call(message, "accepted"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.accepted);
        return writer;
    };

    /**
     * Encodes the specified AcceptBusinessInviteRequest message, length delimited. Does not implicitly {@link AcceptBusinessInviteRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {IAcceptBusinessInviteRequest} message AcceptBusinessInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptBusinessInviteRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AcceptBusinessInviteRequest message from the specified reader or buffer.
     * @function decode
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AcceptBusinessInviteRequest} AcceptBusinessInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptBusinessInviteRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AcceptBusinessInviteRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.inviteCode = reader.string();
                    break;
                }
            case 2: {
                    message.accepted = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AcceptBusinessInviteRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AcceptBusinessInviteRequest} AcceptBusinessInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptBusinessInviteRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AcceptBusinessInviteRequest message.
     * @function verify
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AcceptBusinessInviteRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            if (!$util.isString(message.inviteCode))
                return "inviteCode: string expected";
        if (message.accepted != null && message.hasOwnProperty("accepted"))
            if (typeof message.accepted !== "boolean")
                return "accepted: boolean expected";
        return null;
    };

    /**
     * Creates an AcceptBusinessInviteRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AcceptBusinessInviteRequest} AcceptBusinessInviteRequest
     */
    AcceptBusinessInviteRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AcceptBusinessInviteRequest)
            return object;
        let message = new $root.AcceptBusinessInviteRequest();
        if (object.inviteCode != null)
            message.inviteCode = String(object.inviteCode);
        if (object.accepted != null)
            message.accepted = Boolean(object.accepted);
        return message;
    };

    /**
     * Creates a plain object from an AcceptBusinessInviteRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {AcceptBusinessInviteRequest} message AcceptBusinessInviteRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AcceptBusinessInviteRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.inviteCode = "";
            object.accepted = false;
        }
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            object.inviteCode = message.inviteCode;
        if (message.accepted != null && message.hasOwnProperty("accepted"))
            object.accepted = message.accepted;
        return object;
    };

    /**
     * Converts this AcceptBusinessInviteRequest to JSON.
     * @function toJSON
     * @memberof AcceptBusinessInviteRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AcceptBusinessInviteRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AcceptBusinessInviteRequest
     * @function getTypeUrl
     * @memberof AcceptBusinessInviteRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AcceptBusinessInviteRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AcceptBusinessInviteRequest";
    };

    return AcceptBusinessInviteRequest;
})();

export const AcceptBusinessInviteResponse = $root.AcceptBusinessInviteResponse = (() => {

    /**
     * Properties of an AcceptBusinessInviteResponse.
     * @exports IAcceptBusinessInviteResponse
     * @interface IAcceptBusinessInviteResponse
     * @property {boolean|null} [okay] AcceptBusinessInviteResponse okay
     * @property {IApiProviderProto|null} [provider] AcceptBusinessInviteResponse provider
     * @property {IApiBusinessProto|null} [business] AcceptBusinessInviteResponse business
     */

    /**
     * Constructs a new AcceptBusinessInviteResponse.
     * @exports AcceptBusinessInviteResponse
     * @classdesc Represents an AcceptBusinessInviteResponse.
     * @implements IAcceptBusinessInviteResponse
     * @constructor
     * @param {IAcceptBusinessInviteResponse=} [properties] Properties to set
     */
    function AcceptBusinessInviteResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AcceptBusinessInviteResponse okay.
     * @member {boolean} okay
     * @memberof AcceptBusinessInviteResponse
     * @instance
     */
    AcceptBusinessInviteResponse.prototype.okay = false;

    /**
     * AcceptBusinessInviteResponse provider.
     * @member {IApiProviderProto|null|undefined} provider
     * @memberof AcceptBusinessInviteResponse
     * @instance
     */
    AcceptBusinessInviteResponse.prototype.provider = null;

    /**
     * AcceptBusinessInviteResponse business.
     * @member {IApiBusinessProto|null|undefined} business
     * @memberof AcceptBusinessInviteResponse
     * @instance
     */
    AcceptBusinessInviteResponse.prototype.business = null;

    /**
     * Creates a new AcceptBusinessInviteResponse instance using the specified properties.
     * @function create
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {IAcceptBusinessInviteResponse=} [properties] Properties to set
     * @returns {AcceptBusinessInviteResponse} AcceptBusinessInviteResponse instance
     */
    AcceptBusinessInviteResponse.create = function create(properties) {
        return new AcceptBusinessInviteResponse(properties);
    };

    /**
     * Encodes the specified AcceptBusinessInviteResponse message. Does not implicitly {@link AcceptBusinessInviteResponse.verify|verify} messages.
     * @function encode
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {IAcceptBusinessInviteResponse} message AcceptBusinessInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptBusinessInviteResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
            $root.ApiProviderProto.encode(message.provider, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.business != null && Object.hasOwnProperty.call(message, "business"))
            $root.ApiBusinessProto.encode(message.business, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AcceptBusinessInviteResponse message, length delimited. Does not implicitly {@link AcceptBusinessInviteResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {IAcceptBusinessInviteResponse} message AcceptBusinessInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptBusinessInviteResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AcceptBusinessInviteResponse message from the specified reader or buffer.
     * @function decode
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AcceptBusinessInviteResponse} AcceptBusinessInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptBusinessInviteResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AcceptBusinessInviteResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.provider = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.business = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AcceptBusinessInviteResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AcceptBusinessInviteResponse} AcceptBusinessInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptBusinessInviteResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AcceptBusinessInviteResponse message.
     * @function verify
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AcceptBusinessInviteResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.provider != null && message.hasOwnProperty("provider")) {
            let error = $root.ApiProviderProto.verify(message.provider);
            if (error)
                return "provider." + error;
        }
        if (message.business != null && message.hasOwnProperty("business")) {
            let error = $root.ApiBusinessProto.verify(message.business);
            if (error)
                return "business." + error;
        }
        return null;
    };

    /**
     * Creates an AcceptBusinessInviteResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AcceptBusinessInviteResponse} AcceptBusinessInviteResponse
     */
    AcceptBusinessInviteResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.AcceptBusinessInviteResponse)
            return object;
        let message = new $root.AcceptBusinessInviteResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.provider != null) {
            if (typeof object.provider !== "object")
                throw TypeError(".AcceptBusinessInviteResponse.provider: object expected");
            message.provider = $root.ApiProviderProto.fromObject(object.provider);
        }
        if (object.business != null) {
            if (typeof object.business !== "object")
                throw TypeError(".AcceptBusinessInviteResponse.business: object expected");
            message.business = $root.ApiBusinessProto.fromObject(object.business);
        }
        return message;
    };

    /**
     * Creates a plain object from an AcceptBusinessInviteResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {AcceptBusinessInviteResponse} message AcceptBusinessInviteResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AcceptBusinessInviteResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.okay = false;
            object.provider = null;
            object.business = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = $root.ApiProviderProto.toObject(message.provider, options);
        if (message.business != null && message.hasOwnProperty("business"))
            object.business = $root.ApiBusinessProto.toObject(message.business, options);
        return object;
    };

    /**
     * Converts this AcceptBusinessInviteResponse to JSON.
     * @function toJSON
     * @memberof AcceptBusinessInviteResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AcceptBusinessInviteResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AcceptBusinessInviteResponse
     * @function getTypeUrl
     * @memberof AcceptBusinessInviteResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AcceptBusinessInviteResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AcceptBusinessInviteResponse";
    };

    return AcceptBusinessInviteResponse;
})();

export const CheckBusinessInviteRequest = $root.CheckBusinessInviteRequest = (() => {

    /**
     * Properties of a CheckBusinessInviteRequest.
     * @exports ICheckBusinessInviteRequest
     * @interface ICheckBusinessInviteRequest
     * @property {string|null} [inviteCode] CheckBusinessInviteRequest inviteCode
     */

    /**
     * Constructs a new CheckBusinessInviteRequest.
     * @exports CheckBusinessInviteRequest
     * @classdesc Represents a CheckBusinessInviteRequest.
     * @implements ICheckBusinessInviteRequest
     * @constructor
     * @param {ICheckBusinessInviteRequest=} [properties] Properties to set
     */
    function CheckBusinessInviteRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckBusinessInviteRequest inviteCode.
     * @member {string} inviteCode
     * @memberof CheckBusinessInviteRequest
     * @instance
     */
    CheckBusinessInviteRequest.prototype.inviteCode = "";

    /**
     * Creates a new CheckBusinessInviteRequest instance using the specified properties.
     * @function create
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {ICheckBusinessInviteRequest=} [properties] Properties to set
     * @returns {CheckBusinessInviteRequest} CheckBusinessInviteRequest instance
     */
    CheckBusinessInviteRequest.create = function create(properties) {
        return new CheckBusinessInviteRequest(properties);
    };

    /**
     * Encodes the specified CheckBusinessInviteRequest message. Does not implicitly {@link CheckBusinessInviteRequest.verify|verify} messages.
     * @function encode
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {ICheckBusinessInviteRequest} message CheckBusinessInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckBusinessInviteRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
        return writer;
    };

    /**
     * Encodes the specified CheckBusinessInviteRequest message, length delimited. Does not implicitly {@link CheckBusinessInviteRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {ICheckBusinessInviteRequest} message CheckBusinessInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckBusinessInviteRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckBusinessInviteRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckBusinessInviteRequest} CheckBusinessInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckBusinessInviteRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckBusinessInviteRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.inviteCode = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckBusinessInviteRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckBusinessInviteRequest} CheckBusinessInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckBusinessInviteRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckBusinessInviteRequest message.
     * @function verify
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckBusinessInviteRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            if (!$util.isString(message.inviteCode))
                return "inviteCode: string expected";
        return null;
    };

    /**
     * Creates a CheckBusinessInviteRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckBusinessInviteRequest} CheckBusinessInviteRequest
     */
    CheckBusinessInviteRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckBusinessInviteRequest)
            return object;
        let message = new $root.CheckBusinessInviteRequest();
        if (object.inviteCode != null)
            message.inviteCode = String(object.inviteCode);
        return message;
    };

    /**
     * Creates a plain object from a CheckBusinessInviteRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {CheckBusinessInviteRequest} message CheckBusinessInviteRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckBusinessInviteRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.inviteCode = "";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            object.inviteCode = message.inviteCode;
        return object;
    };

    /**
     * Converts this CheckBusinessInviteRequest to JSON.
     * @function toJSON
     * @memberof CheckBusinessInviteRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckBusinessInviteRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckBusinessInviteRequest
     * @function getTypeUrl
     * @memberof CheckBusinessInviteRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckBusinessInviteRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckBusinessInviteRequest";
    };

    return CheckBusinessInviteRequest;
})();

export const CheckBusinessInviteResponse = $root.CheckBusinessInviteResponse = (() => {

    /**
     * Properties of a CheckBusinessInviteResponse.
     * @exports ICheckBusinessInviteResponse
     * @interface ICheckBusinessInviteResponse
     * @property {boolean|null} [okay] CheckBusinessInviteResponse okay
     */

    /**
     * Constructs a new CheckBusinessInviteResponse.
     * @exports CheckBusinessInviteResponse
     * @classdesc Represents a CheckBusinessInviteResponse.
     * @implements ICheckBusinessInviteResponse
     * @constructor
     * @param {ICheckBusinessInviteResponse=} [properties] Properties to set
     */
    function CheckBusinessInviteResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckBusinessInviteResponse okay.
     * @member {boolean} okay
     * @memberof CheckBusinessInviteResponse
     * @instance
     */
    CheckBusinessInviteResponse.prototype.okay = false;

    /**
     * Creates a new CheckBusinessInviteResponse instance using the specified properties.
     * @function create
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {ICheckBusinessInviteResponse=} [properties] Properties to set
     * @returns {CheckBusinessInviteResponse} CheckBusinessInviteResponse instance
     */
    CheckBusinessInviteResponse.create = function create(properties) {
        return new CheckBusinessInviteResponse(properties);
    };

    /**
     * Encodes the specified CheckBusinessInviteResponse message. Does not implicitly {@link CheckBusinessInviteResponse.verify|verify} messages.
     * @function encode
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {ICheckBusinessInviteResponse} message CheckBusinessInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckBusinessInviteResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        return writer;
    };

    /**
     * Encodes the specified CheckBusinessInviteResponse message, length delimited. Does not implicitly {@link CheckBusinessInviteResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {ICheckBusinessInviteResponse} message CheckBusinessInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckBusinessInviteResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckBusinessInviteResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckBusinessInviteResponse} CheckBusinessInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckBusinessInviteResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckBusinessInviteResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckBusinessInviteResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckBusinessInviteResponse} CheckBusinessInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckBusinessInviteResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckBusinessInviteResponse message.
     * @function verify
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckBusinessInviteResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        return null;
    };

    /**
     * Creates a CheckBusinessInviteResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckBusinessInviteResponse} CheckBusinessInviteResponse
     */
    CheckBusinessInviteResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckBusinessInviteResponse)
            return object;
        let message = new $root.CheckBusinessInviteResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        return message;
    };

    /**
     * Creates a plain object from a CheckBusinessInviteResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {CheckBusinessInviteResponse} message CheckBusinessInviteResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckBusinessInviteResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        return object;
    };

    /**
     * Converts this CheckBusinessInviteResponse to JSON.
     * @function toJSON
     * @memberof CheckBusinessInviteResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckBusinessInviteResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckBusinessInviteResponse
     * @function getTypeUrl
     * @memberof CheckBusinessInviteResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckBusinessInviteResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckBusinessInviteResponse";
    };

    return CheckBusinessInviteResponse;
})();

export const PublishOnKensuRequest = $root.PublishOnKensuRequest = (() => {

    /**
     * Properties of a PublishOnKensuRequest.
     * @exports IPublishOnKensuRequest
     * @interface IPublishOnKensuRequest
     * @property {boolean|null} [publish] PublishOnKensuRequest publish
     */

    /**
     * Constructs a new PublishOnKensuRequest.
     * @exports PublishOnKensuRequest
     * @classdesc Represents a PublishOnKensuRequest.
     * @implements IPublishOnKensuRequest
     * @constructor
     * @param {IPublishOnKensuRequest=} [properties] Properties to set
     */
    function PublishOnKensuRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PublishOnKensuRequest publish.
     * @member {boolean} publish
     * @memberof PublishOnKensuRequest
     * @instance
     */
    PublishOnKensuRequest.prototype.publish = false;

    /**
     * Creates a new PublishOnKensuRequest instance using the specified properties.
     * @function create
     * @memberof PublishOnKensuRequest
     * @static
     * @param {IPublishOnKensuRequest=} [properties] Properties to set
     * @returns {PublishOnKensuRequest} PublishOnKensuRequest instance
     */
    PublishOnKensuRequest.create = function create(properties) {
        return new PublishOnKensuRequest(properties);
    };

    /**
     * Encodes the specified PublishOnKensuRequest message. Does not implicitly {@link PublishOnKensuRequest.verify|verify} messages.
     * @function encode
     * @memberof PublishOnKensuRequest
     * @static
     * @param {IPublishOnKensuRequest} message PublishOnKensuRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublishOnKensuRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.publish != null && Object.hasOwnProperty.call(message, "publish"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.publish);
        return writer;
    };

    /**
     * Encodes the specified PublishOnKensuRequest message, length delimited. Does not implicitly {@link PublishOnKensuRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublishOnKensuRequest
     * @static
     * @param {IPublishOnKensuRequest} message PublishOnKensuRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublishOnKensuRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PublishOnKensuRequest message from the specified reader or buffer.
     * @function decode
     * @memberof PublishOnKensuRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublishOnKensuRequest} PublishOnKensuRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublishOnKensuRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublishOnKensuRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.publish = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PublishOnKensuRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublishOnKensuRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublishOnKensuRequest} PublishOnKensuRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublishOnKensuRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PublishOnKensuRequest message.
     * @function verify
     * @memberof PublishOnKensuRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublishOnKensuRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.publish != null && message.hasOwnProperty("publish"))
            if (typeof message.publish !== "boolean")
                return "publish: boolean expected";
        return null;
    };

    /**
     * Creates a PublishOnKensuRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublishOnKensuRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublishOnKensuRequest} PublishOnKensuRequest
     */
    PublishOnKensuRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.PublishOnKensuRequest)
            return object;
        let message = new $root.PublishOnKensuRequest();
        if (object.publish != null)
            message.publish = Boolean(object.publish);
        return message;
    };

    /**
     * Creates a plain object from a PublishOnKensuRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublishOnKensuRequest
     * @static
     * @param {PublishOnKensuRequest} message PublishOnKensuRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublishOnKensuRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.publish = false;
        if (message.publish != null && message.hasOwnProperty("publish"))
            object.publish = message.publish;
        return object;
    };

    /**
     * Converts this PublishOnKensuRequest to JSON.
     * @function toJSON
     * @memberof PublishOnKensuRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublishOnKensuRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PublishOnKensuRequest
     * @function getTypeUrl
     * @memberof PublishOnKensuRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublishOnKensuRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublishOnKensuRequest";
    };

    return PublishOnKensuRequest;
})();

export const PublishOnKensuResponse = $root.PublishOnKensuResponse = (() => {

    /**
     * Properties of a PublishOnKensuResponse.
     * @exports IPublishOnKensuResponse
     * @interface IPublishOnKensuResponse
     * @property {boolean|null} [okay] PublishOnKensuResponse okay
     * @property {IApiBusinessProto|null} [updatedBusiness] PublishOnKensuResponse updatedBusiness
     * @property {string|null} [error] PublishOnKensuResponse error
     */

    /**
     * Constructs a new PublishOnKensuResponse.
     * @exports PublishOnKensuResponse
     * @classdesc Represents a PublishOnKensuResponse.
     * @implements IPublishOnKensuResponse
     * @constructor
     * @param {IPublishOnKensuResponse=} [properties] Properties to set
     */
    function PublishOnKensuResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PublishOnKensuResponse okay.
     * @member {boolean} okay
     * @memberof PublishOnKensuResponse
     * @instance
     */
    PublishOnKensuResponse.prototype.okay = false;

    /**
     * PublishOnKensuResponse updatedBusiness.
     * @member {IApiBusinessProto|null|undefined} updatedBusiness
     * @memberof PublishOnKensuResponse
     * @instance
     */
    PublishOnKensuResponse.prototype.updatedBusiness = null;

    /**
     * PublishOnKensuResponse error.
     * @member {string} error
     * @memberof PublishOnKensuResponse
     * @instance
     */
    PublishOnKensuResponse.prototype.error = "";

    /**
     * Creates a new PublishOnKensuResponse instance using the specified properties.
     * @function create
     * @memberof PublishOnKensuResponse
     * @static
     * @param {IPublishOnKensuResponse=} [properties] Properties to set
     * @returns {PublishOnKensuResponse} PublishOnKensuResponse instance
     */
    PublishOnKensuResponse.create = function create(properties) {
        return new PublishOnKensuResponse(properties);
    };

    /**
     * Encodes the specified PublishOnKensuResponse message. Does not implicitly {@link PublishOnKensuResponse.verify|verify} messages.
     * @function encode
     * @memberof PublishOnKensuResponse
     * @static
     * @param {IPublishOnKensuResponse} message PublishOnKensuResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublishOnKensuResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.updatedBusiness != null && Object.hasOwnProperty.call(message, "updatedBusiness"))
            $root.ApiBusinessProto.encode(message.updatedBusiness, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.error);
        return writer;
    };

    /**
     * Encodes the specified PublishOnKensuResponse message, length delimited. Does not implicitly {@link PublishOnKensuResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PublishOnKensuResponse
     * @static
     * @param {IPublishOnKensuResponse} message PublishOnKensuResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PublishOnKensuResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PublishOnKensuResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PublishOnKensuResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PublishOnKensuResponse} PublishOnKensuResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublishOnKensuResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.PublishOnKensuResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.updatedBusiness = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.error = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PublishOnKensuResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PublishOnKensuResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PublishOnKensuResponse} PublishOnKensuResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PublishOnKensuResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PublishOnKensuResponse message.
     * @function verify
     * @memberof PublishOnKensuResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PublishOnKensuResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.updatedBusiness != null && message.hasOwnProperty("updatedBusiness")) {
            let error = $root.ApiBusinessProto.verify(message.updatedBusiness);
            if (error)
                return "updatedBusiness." + error;
        }
        if (message.error != null && message.hasOwnProperty("error"))
            if (!$util.isString(message.error))
                return "error: string expected";
        return null;
    };

    /**
     * Creates a PublishOnKensuResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PublishOnKensuResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PublishOnKensuResponse} PublishOnKensuResponse
     */
    PublishOnKensuResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.PublishOnKensuResponse)
            return object;
        let message = new $root.PublishOnKensuResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.updatedBusiness != null) {
            if (typeof object.updatedBusiness !== "object")
                throw TypeError(".PublishOnKensuResponse.updatedBusiness: object expected");
            message.updatedBusiness = $root.ApiBusinessProto.fromObject(object.updatedBusiness);
        }
        if (object.error != null)
            message.error = String(object.error);
        return message;
    };

    /**
     * Creates a plain object from a PublishOnKensuResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PublishOnKensuResponse
     * @static
     * @param {PublishOnKensuResponse} message PublishOnKensuResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PublishOnKensuResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.okay = false;
            object.updatedBusiness = null;
            object.error = "";
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.updatedBusiness != null && message.hasOwnProperty("updatedBusiness"))
            object.updatedBusiness = $root.ApiBusinessProto.toObject(message.updatedBusiness, options);
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
        return object;
    };

    /**
     * Converts this PublishOnKensuResponse to JSON.
     * @function toJSON
     * @memberof PublishOnKensuResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PublishOnKensuResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for PublishOnKensuResponse
     * @function getTypeUrl
     * @memberof PublishOnKensuResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    PublishOnKensuResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PublishOnKensuResponse";
    };

    return PublishOnKensuResponse;
})();

export const GetLoginsForBusinessRequest = $root.GetLoginsForBusinessRequest = (() => {

    /**
     * Properties of a GetLoginsForBusinessRequest.
     * @exports IGetLoginsForBusinessRequest
     * @interface IGetLoginsForBusinessRequest
     * @property {Array.<string>|null} [providerIds] GetLoginsForBusinessRequest providerIds
     * @property {boolean|null} [forAdminHeader] GetLoginsForBusinessRequest forAdminHeader
     */

    /**
     * Constructs a new GetLoginsForBusinessRequest.
     * @exports GetLoginsForBusinessRequest
     * @classdesc Represents a GetLoginsForBusinessRequest.
     * @implements IGetLoginsForBusinessRequest
     * @constructor
     * @param {IGetLoginsForBusinessRequest=} [properties] Properties to set
     */
    function GetLoginsForBusinessRequest(properties) {
        this.providerIds = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetLoginsForBusinessRequest providerIds.
     * @member {Array.<string>} providerIds
     * @memberof GetLoginsForBusinessRequest
     * @instance
     */
    GetLoginsForBusinessRequest.prototype.providerIds = $util.emptyArray;

    /**
     * GetLoginsForBusinessRequest forAdminHeader.
     * @member {boolean} forAdminHeader
     * @memberof GetLoginsForBusinessRequest
     * @instance
     */
    GetLoginsForBusinessRequest.prototype.forAdminHeader = false;

    /**
     * Creates a new GetLoginsForBusinessRequest instance using the specified properties.
     * @function create
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {IGetLoginsForBusinessRequest=} [properties] Properties to set
     * @returns {GetLoginsForBusinessRequest} GetLoginsForBusinessRequest instance
     */
    GetLoginsForBusinessRequest.create = function create(properties) {
        return new GetLoginsForBusinessRequest(properties);
    };

    /**
     * Encodes the specified GetLoginsForBusinessRequest message. Does not implicitly {@link GetLoginsForBusinessRequest.verify|verify} messages.
     * @function encode
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {IGetLoginsForBusinessRequest} message GetLoginsForBusinessRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLoginsForBusinessRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.providerIds != null && message.providerIds.length)
            for (let i = 0; i < message.providerIds.length; ++i)
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.providerIds[i]);
        if (message.forAdminHeader != null && Object.hasOwnProperty.call(message, "forAdminHeader"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.forAdminHeader);
        return writer;
    };

    /**
     * Encodes the specified GetLoginsForBusinessRequest message, length delimited. Does not implicitly {@link GetLoginsForBusinessRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {IGetLoginsForBusinessRequest} message GetLoginsForBusinessRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLoginsForBusinessRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetLoginsForBusinessRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetLoginsForBusinessRequest} GetLoginsForBusinessRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLoginsForBusinessRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetLoginsForBusinessRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.providerIds && message.providerIds.length))
                        message.providerIds = [];
                    message.providerIds.push(reader.string());
                    break;
                }
            case 2: {
                    message.forAdminHeader = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetLoginsForBusinessRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetLoginsForBusinessRequest} GetLoginsForBusinessRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLoginsForBusinessRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetLoginsForBusinessRequest message.
     * @function verify
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetLoginsForBusinessRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.providerIds != null && message.hasOwnProperty("providerIds")) {
            if (!Array.isArray(message.providerIds))
                return "providerIds: array expected";
            for (let i = 0; i < message.providerIds.length; ++i)
                if (!$util.isString(message.providerIds[i]))
                    return "providerIds: string[] expected";
        }
        if (message.forAdminHeader != null && message.hasOwnProperty("forAdminHeader"))
            if (typeof message.forAdminHeader !== "boolean")
                return "forAdminHeader: boolean expected";
        return null;
    };

    /**
     * Creates a GetLoginsForBusinessRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetLoginsForBusinessRequest} GetLoginsForBusinessRequest
     */
    GetLoginsForBusinessRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetLoginsForBusinessRequest)
            return object;
        let message = new $root.GetLoginsForBusinessRequest();
        if (object.providerIds) {
            if (!Array.isArray(object.providerIds))
                throw TypeError(".GetLoginsForBusinessRequest.providerIds: array expected");
            message.providerIds = [];
            for (let i = 0; i < object.providerIds.length; ++i)
                message.providerIds[i] = String(object.providerIds[i]);
        }
        if (object.forAdminHeader != null)
            message.forAdminHeader = Boolean(object.forAdminHeader);
        return message;
    };

    /**
     * Creates a plain object from a GetLoginsForBusinessRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {GetLoginsForBusinessRequest} message GetLoginsForBusinessRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetLoginsForBusinessRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.providerIds = [];
        if (options.defaults)
            object.forAdminHeader = false;
        if (message.providerIds && message.providerIds.length) {
            object.providerIds = [];
            for (let j = 0; j < message.providerIds.length; ++j)
                object.providerIds[j] = message.providerIds[j];
        }
        if (message.forAdminHeader != null && message.hasOwnProperty("forAdminHeader"))
            object.forAdminHeader = message.forAdminHeader;
        return object;
    };

    /**
     * Converts this GetLoginsForBusinessRequest to JSON.
     * @function toJSON
     * @memberof GetLoginsForBusinessRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetLoginsForBusinessRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetLoginsForBusinessRequest
     * @function getTypeUrl
     * @memberof GetLoginsForBusinessRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetLoginsForBusinessRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetLoginsForBusinessRequest";
    };

    return GetLoginsForBusinessRequest;
})();

export const GetLoginsForBusinessResponse = $root.GetLoginsForBusinessResponse = (() => {

    /**
     * Properties of a GetLoginsForBusinessResponse.
     * @exports IGetLoginsForBusinessResponse
     * @interface IGetLoginsForBusinessResponse
     * @property {boolean|null} [okay] GetLoginsForBusinessResponse okay
     * @property {Array.<IApiProviderProto>|null} [provider] GetLoginsForBusinessResponse provider
     */

    /**
     * Constructs a new GetLoginsForBusinessResponse.
     * @exports GetLoginsForBusinessResponse
     * @classdesc Represents a GetLoginsForBusinessResponse.
     * @implements IGetLoginsForBusinessResponse
     * @constructor
     * @param {IGetLoginsForBusinessResponse=} [properties] Properties to set
     */
    function GetLoginsForBusinessResponse(properties) {
        this.provider = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetLoginsForBusinessResponse okay.
     * @member {boolean} okay
     * @memberof GetLoginsForBusinessResponse
     * @instance
     */
    GetLoginsForBusinessResponse.prototype.okay = false;

    /**
     * GetLoginsForBusinessResponse provider.
     * @member {Array.<IApiProviderProto>} provider
     * @memberof GetLoginsForBusinessResponse
     * @instance
     */
    GetLoginsForBusinessResponse.prototype.provider = $util.emptyArray;

    /**
     * Creates a new GetLoginsForBusinessResponse instance using the specified properties.
     * @function create
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {IGetLoginsForBusinessResponse=} [properties] Properties to set
     * @returns {GetLoginsForBusinessResponse} GetLoginsForBusinessResponse instance
     */
    GetLoginsForBusinessResponse.create = function create(properties) {
        return new GetLoginsForBusinessResponse(properties);
    };

    /**
     * Encodes the specified GetLoginsForBusinessResponse message. Does not implicitly {@link GetLoginsForBusinessResponse.verify|verify} messages.
     * @function encode
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {IGetLoginsForBusinessResponse} message GetLoginsForBusinessResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLoginsForBusinessResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.provider != null && message.provider.length)
            for (let i = 0; i < message.provider.length; ++i)
                $root.ApiProviderProto.encode(message.provider[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetLoginsForBusinessResponse message, length delimited. Does not implicitly {@link GetLoginsForBusinessResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {IGetLoginsForBusinessResponse} message GetLoginsForBusinessResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetLoginsForBusinessResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetLoginsForBusinessResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetLoginsForBusinessResponse} GetLoginsForBusinessResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLoginsForBusinessResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetLoginsForBusinessResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.provider && message.provider.length))
                        message.provider = [];
                    message.provider.push($root.ApiProviderProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetLoginsForBusinessResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetLoginsForBusinessResponse} GetLoginsForBusinessResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetLoginsForBusinessResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetLoginsForBusinessResponse message.
     * @function verify
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetLoginsForBusinessResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.provider != null && message.hasOwnProperty("provider")) {
            if (!Array.isArray(message.provider))
                return "provider: array expected";
            for (let i = 0; i < message.provider.length; ++i) {
                let error = $root.ApiProviderProto.verify(message.provider[i]);
                if (error)
                    return "provider." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetLoginsForBusinessResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetLoginsForBusinessResponse} GetLoginsForBusinessResponse
     */
    GetLoginsForBusinessResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetLoginsForBusinessResponse)
            return object;
        let message = new $root.GetLoginsForBusinessResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.provider) {
            if (!Array.isArray(object.provider))
                throw TypeError(".GetLoginsForBusinessResponse.provider: array expected");
            message.provider = [];
            for (let i = 0; i < object.provider.length; ++i) {
                if (typeof object.provider[i] !== "object")
                    throw TypeError(".GetLoginsForBusinessResponse.provider: object expected");
                message.provider[i] = $root.ApiProviderProto.fromObject(object.provider[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetLoginsForBusinessResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {GetLoginsForBusinessResponse} message GetLoginsForBusinessResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetLoginsForBusinessResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.provider = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.provider && message.provider.length) {
            object.provider = [];
            for (let j = 0; j < message.provider.length; ++j)
                object.provider[j] = $root.ApiProviderProto.toObject(message.provider[j], options);
        }
        return object;
    };

    /**
     * Converts this GetLoginsForBusinessResponse to JSON.
     * @function toJSON
     * @memberof GetLoginsForBusinessResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetLoginsForBusinessResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetLoginsForBusinessResponse
     * @function getTypeUrl
     * @memberof GetLoginsForBusinessResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetLoginsForBusinessResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetLoginsForBusinessResponse";
    };

    return GetLoginsForBusinessResponse;
})();

export const ClientProto = $root.ClientProto = (() => {

    /**
     * Properties of a ClientProto.
     * @exports IClientProto
     * @interface IClientProto
     * @property {IApiUserProto|null} [user] ClientProto user
     * @property {IClientRelationshipDetailsProto|null} [relationship] ClientProto relationship
     */

    /**
     * Constructs a new ClientProto.
     * @exports ClientProto
     * @classdesc Represents a ClientProto.
     * @implements IClientProto
     * @constructor
     * @param {IClientProto=} [properties] Properties to set
     */
    function ClientProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClientProto user.
     * @member {IApiUserProto|null|undefined} user
     * @memberof ClientProto
     * @instance
     */
    ClientProto.prototype.user = null;

    /**
     * ClientProto relationship.
     * @member {IClientRelationshipDetailsProto|null|undefined} relationship
     * @memberof ClientProto
     * @instance
     */
    ClientProto.prototype.relationship = null;

    /**
     * Creates a new ClientProto instance using the specified properties.
     * @function create
     * @memberof ClientProto
     * @static
     * @param {IClientProto=} [properties] Properties to set
     * @returns {ClientProto} ClientProto instance
     */
    ClientProto.create = function create(properties) {
        return new ClientProto(properties);
    };

    /**
     * Encodes the specified ClientProto message. Does not implicitly {@link ClientProto.verify|verify} messages.
     * @function encode
     * @memberof ClientProto
     * @static
     * @param {IClientProto} message ClientProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
            $root.ApiUserProto.encode(message.user, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.relationship != null && Object.hasOwnProperty.call(message, "relationship"))
            $root.ClientRelationshipDetailsProto.encode(message.relationship, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClientProto message, length delimited. Does not implicitly {@link ClientProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClientProto
     * @static
     * @param {IClientProto} message ClientProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClientProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClientProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClientProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClientProto} ClientProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClientProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.user = $root.ApiUserProto.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.relationship = $root.ClientRelationshipDetailsProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClientProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClientProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClientProto} ClientProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClientProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClientProto message.
     * @function verify
     * @memberof ClientProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClientProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.user != null && message.hasOwnProperty("user")) {
            let error = $root.ApiUserProto.verify(message.user);
            if (error)
                return "user." + error;
        }
        if (message.relationship != null && message.hasOwnProperty("relationship")) {
            let error = $root.ClientRelationshipDetailsProto.verify(message.relationship);
            if (error)
                return "relationship." + error;
        }
        return null;
    };

    /**
     * Creates a ClientProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClientProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClientProto} ClientProto
     */
    ClientProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClientProto)
            return object;
        let message = new $root.ClientProto();
        if (object.user != null) {
            if (typeof object.user !== "object")
                throw TypeError(".ClientProto.user: object expected");
            message.user = $root.ApiUserProto.fromObject(object.user);
        }
        if (object.relationship != null) {
            if (typeof object.relationship !== "object")
                throw TypeError(".ClientProto.relationship: object expected");
            message.relationship = $root.ClientRelationshipDetailsProto.fromObject(object.relationship);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClientProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClientProto
     * @static
     * @param {ClientProto} message ClientProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClientProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.user = null;
            object.relationship = null;
        }
        if (message.user != null && message.hasOwnProperty("user"))
            object.user = $root.ApiUserProto.toObject(message.user, options);
        if (message.relationship != null && message.hasOwnProperty("relationship"))
            object.relationship = $root.ClientRelationshipDetailsProto.toObject(message.relationship, options);
        return object;
    };

    /**
     * Converts this ClientProto to JSON.
     * @function toJSON
     * @memberof ClientProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClientProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClientProto
     * @function getTypeUrl
     * @memberof ClientProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClientProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClientProto";
    };

    return ClientProto;
})();

export const GetClientListRequest = $root.GetClientListRequest = (() => {

    /**
     * Properties of a GetClientListRequest.
     * @exports IGetClientListRequest
     * @interface IGetClientListRequest
     * @property {string|null} [clientId] GetClientListRequest clientId
     */

    /**
     * Constructs a new GetClientListRequest.
     * @exports GetClientListRequest
     * @classdesc Represents a GetClientListRequest.
     * @implements IGetClientListRequest
     * @constructor
     * @param {IGetClientListRequest=} [properties] Properties to set
     */
    function GetClientListRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClientListRequest clientId.
     * @member {string} clientId
     * @memberof GetClientListRequest
     * @instance
     */
    GetClientListRequest.prototype.clientId = "";

    /**
     * Creates a new GetClientListRequest instance using the specified properties.
     * @function create
     * @memberof GetClientListRequest
     * @static
     * @param {IGetClientListRequest=} [properties] Properties to set
     * @returns {GetClientListRequest} GetClientListRequest instance
     */
    GetClientListRequest.create = function create(properties) {
        return new GetClientListRequest(properties);
    };

    /**
     * Encodes the specified GetClientListRequest message. Does not implicitly {@link GetClientListRequest.verify|verify} messages.
     * @function encode
     * @memberof GetClientListRequest
     * @static
     * @param {IGetClientListRequest} message GetClientListRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientListRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.clientId != null && Object.hasOwnProperty.call(message, "clientId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.clientId);
        return writer;
    };

    /**
     * Encodes the specified GetClientListRequest message, length delimited. Does not implicitly {@link GetClientListRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClientListRequest
     * @static
     * @param {IGetClientListRequest} message GetClientListRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientListRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClientListRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetClientListRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClientListRequest} GetClientListRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientListRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClientListRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.clientId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClientListRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClientListRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClientListRequest} GetClientListRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientListRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClientListRequest message.
     * @function verify
     * @memberof GetClientListRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClientListRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.clientId != null && message.hasOwnProperty("clientId"))
            if (!$util.isString(message.clientId))
                return "clientId: string expected";
        return null;
    };

    /**
     * Creates a GetClientListRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClientListRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClientListRequest} GetClientListRequest
     */
    GetClientListRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClientListRequest)
            return object;
        let message = new $root.GetClientListRequest();
        if (object.clientId != null)
            message.clientId = String(object.clientId);
        return message;
    };

    /**
     * Creates a plain object from a GetClientListRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClientListRequest
     * @static
     * @param {GetClientListRequest} message GetClientListRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClientListRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.clientId = "";
        if (message.clientId != null && message.hasOwnProperty("clientId"))
            object.clientId = message.clientId;
        return object;
    };

    /**
     * Converts this GetClientListRequest to JSON.
     * @function toJSON
     * @memberof GetClientListRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClientListRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClientListRequest
     * @function getTypeUrl
     * @memberof GetClientListRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClientListRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClientListRequest";
    };

    return GetClientListRequest;
})();

export const GetClientListResponse = $root.GetClientListResponse = (() => {

    /**
     * Properties of a GetClientListResponse.
     * @exports IGetClientListResponse
     * @interface IGetClientListResponse
     * @property {boolean|null} [okay] GetClientListResponse okay
     * @property {Array.<IClientProto>|null} [client] GetClientListResponse client
     */

    /**
     * Constructs a new GetClientListResponse.
     * @exports GetClientListResponse
     * @classdesc Represents a GetClientListResponse.
     * @implements IGetClientListResponse
     * @constructor
     * @param {IGetClientListResponse=} [properties] Properties to set
     */
    function GetClientListResponse(properties) {
        this.client = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClientListResponse okay.
     * @member {boolean} okay
     * @memberof GetClientListResponse
     * @instance
     */
    GetClientListResponse.prototype.okay = false;

    /**
     * GetClientListResponse client.
     * @member {Array.<IClientProto>} client
     * @memberof GetClientListResponse
     * @instance
     */
    GetClientListResponse.prototype.client = $util.emptyArray;

    /**
     * Creates a new GetClientListResponse instance using the specified properties.
     * @function create
     * @memberof GetClientListResponse
     * @static
     * @param {IGetClientListResponse=} [properties] Properties to set
     * @returns {GetClientListResponse} GetClientListResponse instance
     */
    GetClientListResponse.create = function create(properties) {
        return new GetClientListResponse(properties);
    };

    /**
     * Encodes the specified GetClientListResponse message. Does not implicitly {@link GetClientListResponse.verify|verify} messages.
     * @function encode
     * @memberof GetClientListResponse
     * @static
     * @param {IGetClientListResponse} message GetClientListResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientListResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.client != null && message.client.length)
            for (let i = 0; i < message.client.length; ++i)
                $root.ClientProto.encode(message.client[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetClientListResponse message, length delimited. Does not implicitly {@link GetClientListResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClientListResponse
     * @static
     * @param {IGetClientListResponse} message GetClientListResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientListResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClientListResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetClientListResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClientListResponse} GetClientListResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientListResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClientListResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.client && message.client.length))
                        message.client = [];
                    message.client.push($root.ClientProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClientListResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClientListResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClientListResponse} GetClientListResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientListResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClientListResponse message.
     * @function verify
     * @memberof GetClientListResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClientListResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.client != null && message.hasOwnProperty("client")) {
            if (!Array.isArray(message.client))
                return "client: array expected";
            for (let i = 0; i < message.client.length; ++i) {
                let error = $root.ClientProto.verify(message.client[i]);
                if (error)
                    return "client." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetClientListResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClientListResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClientListResponse} GetClientListResponse
     */
    GetClientListResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClientListResponse)
            return object;
        let message = new $root.GetClientListResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.client) {
            if (!Array.isArray(object.client))
                throw TypeError(".GetClientListResponse.client: array expected");
            message.client = [];
            for (let i = 0; i < object.client.length; ++i) {
                if (typeof object.client[i] !== "object")
                    throw TypeError(".GetClientListResponse.client: object expected");
                message.client[i] = $root.ClientProto.fromObject(object.client[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetClientListResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClientListResponse
     * @static
     * @param {GetClientListResponse} message GetClientListResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClientListResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.client = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.client && message.client.length) {
            object.client = [];
            for (let j = 0; j < message.client.length; ++j)
                object.client[j] = $root.ClientProto.toObject(message.client[j], options);
        }
        return object;
    };

    /**
     * Converts this GetClientListResponse to JSON.
     * @function toJSON
     * @memberof GetClientListResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClientListResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClientListResponse
     * @function getTypeUrl
     * @memberof GetClientListResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClientListResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClientListResponse";
    };

    return GetClientListResponse;
})();

export const AcceptTeamMemberInviteRequest = $root.AcceptTeamMemberInviteRequest = (() => {

    /**
     * Properties of an AcceptTeamMemberInviteRequest.
     * @exports IAcceptTeamMemberInviteRequest
     * @interface IAcceptTeamMemberInviteRequest
     * @property {string|null} [inviteCode] AcceptTeamMemberInviteRequest inviteCode
     */

    /**
     * Constructs a new AcceptTeamMemberInviteRequest.
     * @exports AcceptTeamMemberInviteRequest
     * @classdesc Represents an AcceptTeamMemberInviteRequest.
     * @implements IAcceptTeamMemberInviteRequest
     * @constructor
     * @param {IAcceptTeamMemberInviteRequest=} [properties] Properties to set
     */
    function AcceptTeamMemberInviteRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AcceptTeamMemberInviteRequest inviteCode.
     * @member {string} inviteCode
     * @memberof AcceptTeamMemberInviteRequest
     * @instance
     */
    AcceptTeamMemberInviteRequest.prototype.inviteCode = "";

    /**
     * Creates a new AcceptTeamMemberInviteRequest instance using the specified properties.
     * @function create
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {IAcceptTeamMemberInviteRequest=} [properties] Properties to set
     * @returns {AcceptTeamMemberInviteRequest} AcceptTeamMemberInviteRequest instance
     */
    AcceptTeamMemberInviteRequest.create = function create(properties) {
        return new AcceptTeamMemberInviteRequest(properties);
    };

    /**
     * Encodes the specified AcceptTeamMemberInviteRequest message. Does not implicitly {@link AcceptTeamMemberInviteRequest.verify|verify} messages.
     * @function encode
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {IAcceptTeamMemberInviteRequest} message AcceptTeamMemberInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptTeamMemberInviteRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
        return writer;
    };

    /**
     * Encodes the specified AcceptTeamMemberInviteRequest message, length delimited. Does not implicitly {@link AcceptTeamMemberInviteRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {IAcceptTeamMemberInviteRequest} message AcceptTeamMemberInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptTeamMemberInviteRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AcceptTeamMemberInviteRequest message from the specified reader or buffer.
     * @function decode
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AcceptTeamMemberInviteRequest} AcceptTeamMemberInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptTeamMemberInviteRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AcceptTeamMemberInviteRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.inviteCode = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AcceptTeamMemberInviteRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AcceptTeamMemberInviteRequest} AcceptTeamMemberInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptTeamMemberInviteRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AcceptTeamMemberInviteRequest message.
     * @function verify
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AcceptTeamMemberInviteRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            if (!$util.isString(message.inviteCode))
                return "inviteCode: string expected";
        return null;
    };

    /**
     * Creates an AcceptTeamMemberInviteRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AcceptTeamMemberInviteRequest} AcceptTeamMemberInviteRequest
     */
    AcceptTeamMemberInviteRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AcceptTeamMemberInviteRequest)
            return object;
        let message = new $root.AcceptTeamMemberInviteRequest();
        if (object.inviteCode != null)
            message.inviteCode = String(object.inviteCode);
        return message;
    };

    /**
     * Creates a plain object from an AcceptTeamMemberInviteRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {AcceptTeamMemberInviteRequest} message AcceptTeamMemberInviteRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AcceptTeamMemberInviteRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.inviteCode = "";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            object.inviteCode = message.inviteCode;
        return object;
    };

    /**
     * Converts this AcceptTeamMemberInviteRequest to JSON.
     * @function toJSON
     * @memberof AcceptTeamMemberInviteRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AcceptTeamMemberInviteRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AcceptTeamMemberInviteRequest
     * @function getTypeUrl
     * @memberof AcceptTeamMemberInviteRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AcceptTeamMemberInviteRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AcceptTeamMemberInviteRequest";
    };

    return AcceptTeamMemberInviteRequest;
})();

export const AcceptTeamMemberInviteResponse = $root.AcceptTeamMemberInviteResponse = (() => {

    /**
     * Properties of an AcceptTeamMemberInviteResponse.
     * @exports IAcceptTeamMemberInviteResponse
     * @interface IAcceptTeamMemberInviteResponse
     * @property {boolean|null} [okay] AcceptTeamMemberInviteResponse okay
     */

    /**
     * Constructs a new AcceptTeamMemberInviteResponse.
     * @exports AcceptTeamMemberInviteResponse
     * @classdesc Represents an AcceptTeamMemberInviteResponse.
     * @implements IAcceptTeamMemberInviteResponse
     * @constructor
     * @param {IAcceptTeamMemberInviteResponse=} [properties] Properties to set
     */
    function AcceptTeamMemberInviteResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AcceptTeamMemberInviteResponse okay.
     * @member {boolean} okay
     * @memberof AcceptTeamMemberInviteResponse
     * @instance
     */
    AcceptTeamMemberInviteResponse.prototype.okay = false;

    /**
     * Creates a new AcceptTeamMemberInviteResponse instance using the specified properties.
     * @function create
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {IAcceptTeamMemberInviteResponse=} [properties] Properties to set
     * @returns {AcceptTeamMemberInviteResponse} AcceptTeamMemberInviteResponse instance
     */
    AcceptTeamMemberInviteResponse.create = function create(properties) {
        return new AcceptTeamMemberInviteResponse(properties);
    };

    /**
     * Encodes the specified AcceptTeamMemberInviteResponse message. Does not implicitly {@link AcceptTeamMemberInviteResponse.verify|verify} messages.
     * @function encode
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {IAcceptTeamMemberInviteResponse} message AcceptTeamMemberInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptTeamMemberInviteResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        return writer;
    };

    /**
     * Encodes the specified AcceptTeamMemberInviteResponse message, length delimited. Does not implicitly {@link AcceptTeamMemberInviteResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {IAcceptTeamMemberInviteResponse} message AcceptTeamMemberInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptTeamMemberInviteResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AcceptTeamMemberInviteResponse message from the specified reader or buffer.
     * @function decode
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AcceptTeamMemberInviteResponse} AcceptTeamMemberInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptTeamMemberInviteResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AcceptTeamMemberInviteResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AcceptTeamMemberInviteResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AcceptTeamMemberInviteResponse} AcceptTeamMemberInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptTeamMemberInviteResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AcceptTeamMemberInviteResponse message.
     * @function verify
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AcceptTeamMemberInviteResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        return null;
    };

    /**
     * Creates an AcceptTeamMemberInviteResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AcceptTeamMemberInviteResponse} AcceptTeamMemberInviteResponse
     */
    AcceptTeamMemberInviteResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.AcceptTeamMemberInviteResponse)
            return object;
        let message = new $root.AcceptTeamMemberInviteResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        return message;
    };

    /**
     * Creates a plain object from an AcceptTeamMemberInviteResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {AcceptTeamMemberInviteResponse} message AcceptTeamMemberInviteResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AcceptTeamMemberInviteResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        return object;
    };

    /**
     * Converts this AcceptTeamMemberInviteResponse to JSON.
     * @function toJSON
     * @memberof AcceptTeamMemberInviteResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AcceptTeamMemberInviteResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AcceptTeamMemberInviteResponse
     * @function getTypeUrl
     * @memberof AcceptTeamMemberInviteResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AcceptTeamMemberInviteResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AcceptTeamMemberInviteResponse";
    };

    return AcceptTeamMemberInviteResponse;
})();

export const CheckTeamMemberInviteRequest = $root.CheckTeamMemberInviteRequest = (() => {

    /**
     * Properties of a CheckTeamMemberInviteRequest.
     * @exports ICheckTeamMemberInviteRequest
     * @interface ICheckTeamMemberInviteRequest
     * @property {string|null} [inviteCode] CheckTeamMemberInviteRequest inviteCode
     */

    /**
     * Constructs a new CheckTeamMemberInviteRequest.
     * @exports CheckTeamMemberInviteRequest
     * @classdesc Represents a CheckTeamMemberInviteRequest.
     * @implements ICheckTeamMemberInviteRequest
     * @constructor
     * @param {ICheckTeamMemberInviteRequest=} [properties] Properties to set
     */
    function CheckTeamMemberInviteRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckTeamMemberInviteRequest inviteCode.
     * @member {string} inviteCode
     * @memberof CheckTeamMemberInviteRequest
     * @instance
     */
    CheckTeamMemberInviteRequest.prototype.inviteCode = "";

    /**
     * Creates a new CheckTeamMemberInviteRequest instance using the specified properties.
     * @function create
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {ICheckTeamMemberInviteRequest=} [properties] Properties to set
     * @returns {CheckTeamMemberInviteRequest} CheckTeamMemberInviteRequest instance
     */
    CheckTeamMemberInviteRequest.create = function create(properties) {
        return new CheckTeamMemberInviteRequest(properties);
    };

    /**
     * Encodes the specified CheckTeamMemberInviteRequest message. Does not implicitly {@link CheckTeamMemberInviteRequest.verify|verify} messages.
     * @function encode
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {ICheckTeamMemberInviteRequest} message CheckTeamMemberInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckTeamMemberInviteRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
        return writer;
    };

    /**
     * Encodes the specified CheckTeamMemberInviteRequest message, length delimited. Does not implicitly {@link CheckTeamMemberInviteRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {ICheckTeamMemberInviteRequest} message CheckTeamMemberInviteRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckTeamMemberInviteRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckTeamMemberInviteRequest message from the specified reader or buffer.
     * @function decode
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckTeamMemberInviteRequest} CheckTeamMemberInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckTeamMemberInviteRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckTeamMemberInviteRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.inviteCode = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckTeamMemberInviteRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckTeamMemberInviteRequest} CheckTeamMemberInviteRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckTeamMemberInviteRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckTeamMemberInviteRequest message.
     * @function verify
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckTeamMemberInviteRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            if (!$util.isString(message.inviteCode))
                return "inviteCode: string expected";
        return null;
    };

    /**
     * Creates a CheckTeamMemberInviteRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckTeamMemberInviteRequest} CheckTeamMemberInviteRequest
     */
    CheckTeamMemberInviteRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckTeamMemberInviteRequest)
            return object;
        let message = new $root.CheckTeamMemberInviteRequest();
        if (object.inviteCode != null)
            message.inviteCode = String(object.inviteCode);
        return message;
    };

    /**
     * Creates a plain object from a CheckTeamMemberInviteRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {CheckTeamMemberInviteRequest} message CheckTeamMemberInviteRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckTeamMemberInviteRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.inviteCode = "";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            object.inviteCode = message.inviteCode;
        return object;
    };

    /**
     * Converts this CheckTeamMemberInviteRequest to JSON.
     * @function toJSON
     * @memberof CheckTeamMemberInviteRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckTeamMemberInviteRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckTeamMemberInviteRequest
     * @function getTypeUrl
     * @memberof CheckTeamMemberInviteRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckTeamMemberInviteRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckTeamMemberInviteRequest";
    };

    return CheckTeamMemberInviteRequest;
})();

export const CheckTeamMemberInviteResponse = $root.CheckTeamMemberInviteResponse = (() => {

    /**
     * Properties of a CheckTeamMemberInviteResponse.
     * @exports ICheckTeamMemberInviteResponse
     * @interface ICheckTeamMemberInviteResponse
     * @property {boolean|null} [okay] CheckTeamMemberInviteResponse okay
     * @property {string|null} [businessName] CheckTeamMemberInviteResponse businessName
     */

    /**
     * Constructs a new CheckTeamMemberInviteResponse.
     * @exports CheckTeamMemberInviteResponse
     * @classdesc Represents a CheckTeamMemberInviteResponse.
     * @implements ICheckTeamMemberInviteResponse
     * @constructor
     * @param {ICheckTeamMemberInviteResponse=} [properties] Properties to set
     */
    function CheckTeamMemberInviteResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckTeamMemberInviteResponse okay.
     * @member {boolean} okay
     * @memberof CheckTeamMemberInviteResponse
     * @instance
     */
    CheckTeamMemberInviteResponse.prototype.okay = false;

    /**
     * CheckTeamMemberInviteResponse businessName.
     * @member {string} businessName
     * @memberof CheckTeamMemberInviteResponse
     * @instance
     */
    CheckTeamMemberInviteResponse.prototype.businessName = "";

    /**
     * Creates a new CheckTeamMemberInviteResponse instance using the specified properties.
     * @function create
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {ICheckTeamMemberInviteResponse=} [properties] Properties to set
     * @returns {CheckTeamMemberInviteResponse} CheckTeamMemberInviteResponse instance
     */
    CheckTeamMemberInviteResponse.create = function create(properties) {
        return new CheckTeamMemberInviteResponse(properties);
    };

    /**
     * Encodes the specified CheckTeamMemberInviteResponse message. Does not implicitly {@link CheckTeamMemberInviteResponse.verify|verify} messages.
     * @function encode
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {ICheckTeamMemberInviteResponse} message CheckTeamMemberInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckTeamMemberInviteResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.businessName != null && Object.hasOwnProperty.call(message, "businessName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.businessName);
        return writer;
    };

    /**
     * Encodes the specified CheckTeamMemberInviteResponse message, length delimited. Does not implicitly {@link CheckTeamMemberInviteResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {ICheckTeamMemberInviteResponse} message CheckTeamMemberInviteResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckTeamMemberInviteResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CheckTeamMemberInviteResponse message from the specified reader or buffer.
     * @function decode
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckTeamMemberInviteResponse} CheckTeamMemberInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckTeamMemberInviteResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckTeamMemberInviteResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.businessName = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CheckTeamMemberInviteResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CheckTeamMemberInviteResponse} CheckTeamMemberInviteResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckTeamMemberInviteResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CheckTeamMemberInviteResponse message.
     * @function verify
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CheckTeamMemberInviteResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.businessName != null && message.hasOwnProperty("businessName"))
            if (!$util.isString(message.businessName))
                return "businessName: string expected";
        return null;
    };

    /**
     * Creates a CheckTeamMemberInviteResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckTeamMemberInviteResponse} CheckTeamMemberInviteResponse
     */
    CheckTeamMemberInviteResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckTeamMemberInviteResponse)
            return object;
        let message = new $root.CheckTeamMemberInviteResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.businessName != null)
            message.businessName = String(object.businessName);
        return message;
    };

    /**
     * Creates a plain object from a CheckTeamMemberInviteResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {CheckTeamMemberInviteResponse} message CheckTeamMemberInviteResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckTeamMemberInviteResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.okay = false;
            object.businessName = "";
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.businessName != null && message.hasOwnProperty("businessName"))
            object.businessName = message.businessName;
        return object;
    };

    /**
     * Converts this CheckTeamMemberInviteResponse to JSON.
     * @function toJSON
     * @memberof CheckTeamMemberInviteResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckTeamMemberInviteResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckTeamMemberInviteResponse
     * @function getTypeUrl
     * @memberof CheckTeamMemberInviteResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckTeamMemberInviteResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckTeamMemberInviteResponse";
    };

    return CheckTeamMemberInviteResponse;
})();

export const InviteTeamMemberRequest = $root.InviteTeamMemberRequest = (() => {

    /**
     * Properties of an InviteTeamMemberRequest.
     * @exports IInviteTeamMemberRequest
     * @interface IInviteTeamMemberRequest
     * @property {string|null} [email] InviteTeamMemberRequest email
     */

    /**
     * Constructs a new InviteTeamMemberRequest.
     * @exports InviteTeamMemberRequest
     * @classdesc Represents an InviteTeamMemberRequest.
     * @implements IInviteTeamMemberRequest
     * @constructor
     * @param {IInviteTeamMemberRequest=} [properties] Properties to set
     */
    function InviteTeamMemberRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InviteTeamMemberRequest email.
     * @member {string} email
     * @memberof InviteTeamMemberRequest
     * @instance
     */
    InviteTeamMemberRequest.prototype.email = "";

    /**
     * Creates a new InviteTeamMemberRequest instance using the specified properties.
     * @function create
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {IInviteTeamMemberRequest=} [properties] Properties to set
     * @returns {InviteTeamMemberRequest} InviteTeamMemberRequest instance
     */
    InviteTeamMemberRequest.create = function create(properties) {
        return new InviteTeamMemberRequest(properties);
    };

    /**
     * Encodes the specified InviteTeamMemberRequest message. Does not implicitly {@link InviteTeamMemberRequest.verify|verify} messages.
     * @function encode
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {IInviteTeamMemberRequest} message InviteTeamMemberRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InviteTeamMemberRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
        return writer;
    };

    /**
     * Encodes the specified InviteTeamMemberRequest message, length delimited. Does not implicitly {@link InviteTeamMemberRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {IInviteTeamMemberRequest} message InviteTeamMemberRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InviteTeamMemberRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InviteTeamMemberRequest message from the specified reader or buffer.
     * @function decode
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InviteTeamMemberRequest} InviteTeamMemberRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InviteTeamMemberRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InviteTeamMemberRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.email = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InviteTeamMemberRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InviteTeamMemberRequest} InviteTeamMemberRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InviteTeamMemberRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InviteTeamMemberRequest message.
     * @function verify
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InviteTeamMemberRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.email != null && message.hasOwnProperty("email"))
            if (!$util.isString(message.email))
                return "email: string expected";
        return null;
    };

    /**
     * Creates an InviteTeamMemberRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InviteTeamMemberRequest} InviteTeamMemberRequest
     */
    InviteTeamMemberRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.InviteTeamMemberRequest)
            return object;
        let message = new $root.InviteTeamMemberRequest();
        if (object.email != null)
            message.email = String(object.email);
        return message;
    };

    /**
     * Creates a plain object from an InviteTeamMemberRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {InviteTeamMemberRequest} message InviteTeamMemberRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InviteTeamMemberRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.email = "";
        if (message.email != null && message.hasOwnProperty("email"))
            object.email = message.email;
        return object;
    };

    /**
     * Converts this InviteTeamMemberRequest to JSON.
     * @function toJSON
     * @memberof InviteTeamMemberRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InviteTeamMemberRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for InviteTeamMemberRequest
     * @function getTypeUrl
     * @memberof InviteTeamMemberRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    InviteTeamMemberRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/InviteTeamMemberRequest";
    };

    return InviteTeamMemberRequest;
})();

export const InviteTeamMemberResponse = $root.InviteTeamMemberResponse = (() => {

    /**
     * Properties of an InviteTeamMemberResponse.
     * @exports IInviteTeamMemberResponse
     * @interface IInviteTeamMemberResponse
     * @property {boolean|null} [okay] InviteTeamMemberResponse okay
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] InviteTeamMemberResponse errors
     * @property {ITeamMemberInviteProto|null} [updated] InviteTeamMemberResponse updated
     */

    /**
     * Constructs a new InviteTeamMemberResponse.
     * @exports InviteTeamMemberResponse
     * @classdesc Represents an InviteTeamMemberResponse.
     * @implements IInviteTeamMemberResponse
     * @constructor
     * @param {IInviteTeamMemberResponse=} [properties] Properties to set
     */
    function InviteTeamMemberResponse(properties) {
        this.errors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InviteTeamMemberResponse okay.
     * @member {boolean} okay
     * @memberof InviteTeamMemberResponse
     * @instance
     */
    InviteTeamMemberResponse.prototype.okay = false;

    /**
     * InviteTeamMemberResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof InviteTeamMemberResponse
     * @instance
     */
    InviteTeamMemberResponse.prototype.errors = $util.emptyArray;

    /**
     * InviteTeamMemberResponse updated.
     * @member {ITeamMemberInviteProto|null|undefined} updated
     * @memberof InviteTeamMemberResponse
     * @instance
     */
    InviteTeamMemberResponse.prototype.updated = null;

    /**
     * Creates a new InviteTeamMemberResponse instance using the specified properties.
     * @function create
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {IInviteTeamMemberResponse=} [properties] Properties to set
     * @returns {InviteTeamMemberResponse} InviteTeamMemberResponse instance
     */
    InviteTeamMemberResponse.create = function create(properties) {
        return new InviteTeamMemberResponse(properties);
    };

    /**
     * Encodes the specified InviteTeamMemberResponse message. Does not implicitly {@link InviteTeamMemberResponse.verify|verify} messages.
     * @function encode
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {IInviteTeamMemberResponse} message InviteTeamMemberResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InviteTeamMemberResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.errors != null && message.errors.length)
            for (let i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.updated != null && Object.hasOwnProperty.call(message, "updated"))
            $root.TeamMemberInviteProto.encode(message.updated, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified InviteTeamMemberResponse message, length delimited. Does not implicitly {@link InviteTeamMemberResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {IInviteTeamMemberResponse} message InviteTeamMemberResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InviteTeamMemberResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an InviteTeamMemberResponse message from the specified reader or buffer.
     * @function decode
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InviteTeamMemberResponse} InviteTeamMemberResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InviteTeamMemberResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InviteTeamMemberResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.updated = $root.TeamMemberInviteProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an InviteTeamMemberResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {InviteTeamMemberResponse} InviteTeamMemberResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InviteTeamMemberResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an InviteTeamMemberResponse message.
     * @function verify
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    InviteTeamMemberResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (let i = 0; i < message.errors.length; ++i) {
                let error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        if (message.updated != null && message.hasOwnProperty("updated")) {
            let error = $root.TeamMemberInviteProto.verify(message.updated);
            if (error)
                return "updated." + error;
        }
        return null;
    };

    /**
     * Creates an InviteTeamMemberResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InviteTeamMemberResponse} InviteTeamMemberResponse
     */
    InviteTeamMemberResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.InviteTeamMemberResponse)
            return object;
        let message = new $root.InviteTeamMemberResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".InviteTeamMemberResponse.errors: array expected");
            message.errors = [];
            for (let i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".InviteTeamMemberResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        if (object.updated != null) {
            if (typeof object.updated !== "object")
                throw TypeError(".InviteTeamMemberResponse.updated: object expected");
            message.updated = $root.TeamMemberInviteProto.fromObject(object.updated);
        }
        return message;
    };

    /**
     * Creates a plain object from an InviteTeamMemberResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {InviteTeamMemberResponse} message InviteTeamMemberResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InviteTeamMemberResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults) {
            object.okay = false;
            object.updated = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (let j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        if (message.updated != null && message.hasOwnProperty("updated"))
            object.updated = $root.TeamMemberInviteProto.toObject(message.updated, options);
        return object;
    };

    /**
     * Converts this InviteTeamMemberResponse to JSON.
     * @function toJSON
     * @memberof InviteTeamMemberResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InviteTeamMemberResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for InviteTeamMemberResponse
     * @function getTypeUrl
     * @memberof InviteTeamMemberResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    InviteTeamMemberResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/InviteTeamMemberResponse";
    };

    return InviteTeamMemberResponse;
})();

export const GetTeamMemberInvitesResponse = $root.GetTeamMemberInvitesResponse = (() => {

    /**
     * Properties of a GetTeamMemberInvitesResponse.
     * @exports IGetTeamMemberInvitesResponse
     * @interface IGetTeamMemberInvitesResponse
     * @property {boolean|null} [okay] GetTeamMemberInvitesResponse okay
     * @property {Array.<ITeamMemberInviteProto>|null} [invite] GetTeamMemberInvitesResponse invite
     */

    /**
     * Constructs a new GetTeamMemberInvitesResponse.
     * @exports GetTeamMemberInvitesResponse
     * @classdesc Represents a GetTeamMemberInvitesResponse.
     * @implements IGetTeamMemberInvitesResponse
     * @constructor
     * @param {IGetTeamMemberInvitesResponse=} [properties] Properties to set
     */
    function GetTeamMemberInvitesResponse(properties) {
        this.invite = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetTeamMemberInvitesResponse okay.
     * @member {boolean} okay
     * @memberof GetTeamMemberInvitesResponse
     * @instance
     */
    GetTeamMemberInvitesResponse.prototype.okay = false;

    /**
     * GetTeamMemberInvitesResponse invite.
     * @member {Array.<ITeamMemberInviteProto>} invite
     * @memberof GetTeamMemberInvitesResponse
     * @instance
     */
    GetTeamMemberInvitesResponse.prototype.invite = $util.emptyArray;

    /**
     * Creates a new GetTeamMemberInvitesResponse instance using the specified properties.
     * @function create
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {IGetTeamMemberInvitesResponse=} [properties] Properties to set
     * @returns {GetTeamMemberInvitesResponse} GetTeamMemberInvitesResponse instance
     */
    GetTeamMemberInvitesResponse.create = function create(properties) {
        return new GetTeamMemberInvitesResponse(properties);
    };

    /**
     * Encodes the specified GetTeamMemberInvitesResponse message. Does not implicitly {@link GetTeamMemberInvitesResponse.verify|verify} messages.
     * @function encode
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {IGetTeamMemberInvitesResponse} message GetTeamMemberInvitesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTeamMemberInvitesResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.invite != null && message.invite.length)
            for (let i = 0; i < message.invite.length; ++i)
                $root.TeamMemberInviteProto.encode(message.invite[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetTeamMemberInvitesResponse message, length delimited. Does not implicitly {@link GetTeamMemberInvitesResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {IGetTeamMemberInvitesResponse} message GetTeamMemberInvitesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTeamMemberInvitesResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetTeamMemberInvitesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetTeamMemberInvitesResponse} GetTeamMemberInvitesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTeamMemberInvitesResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetTeamMemberInvitesResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.invite && message.invite.length))
                        message.invite = [];
                    message.invite.push($root.TeamMemberInviteProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetTeamMemberInvitesResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetTeamMemberInvitesResponse} GetTeamMemberInvitesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTeamMemberInvitesResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetTeamMemberInvitesResponse message.
     * @function verify
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetTeamMemberInvitesResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.invite != null && message.hasOwnProperty("invite")) {
            if (!Array.isArray(message.invite))
                return "invite: array expected";
            for (let i = 0; i < message.invite.length; ++i) {
                let error = $root.TeamMemberInviteProto.verify(message.invite[i]);
                if (error)
                    return "invite." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetTeamMemberInvitesResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetTeamMemberInvitesResponse} GetTeamMemberInvitesResponse
     */
    GetTeamMemberInvitesResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetTeamMemberInvitesResponse)
            return object;
        let message = new $root.GetTeamMemberInvitesResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.invite) {
            if (!Array.isArray(object.invite))
                throw TypeError(".GetTeamMemberInvitesResponse.invite: array expected");
            message.invite = [];
            for (let i = 0; i < object.invite.length; ++i) {
                if (typeof object.invite[i] !== "object")
                    throw TypeError(".GetTeamMemberInvitesResponse.invite: object expected");
                message.invite[i] = $root.TeamMemberInviteProto.fromObject(object.invite[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetTeamMemberInvitesResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {GetTeamMemberInvitesResponse} message GetTeamMemberInvitesResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetTeamMemberInvitesResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.invite = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.invite && message.invite.length) {
            object.invite = [];
            for (let j = 0; j < message.invite.length; ++j)
                object.invite[j] = $root.TeamMemberInviteProto.toObject(message.invite[j], options);
        }
        return object;
    };

    /**
     * Converts this GetTeamMemberInvitesResponse to JSON.
     * @function toJSON
     * @memberof GetTeamMemberInvitesResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetTeamMemberInvitesResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetTeamMemberInvitesResponse
     * @function getTypeUrl
     * @memberof GetTeamMemberInvitesResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetTeamMemberInvitesResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetTeamMemberInvitesResponse";
    };

    return GetTeamMemberInvitesResponse;
})();

export const UpdateProviderSurveyRequest = $root.UpdateProviderSurveyRequest = (() => {

    /**
     * Properties of an UpdateProviderSurveyRequest.
     * @exports IUpdateProviderSurveyRequest
     * @interface IUpdateProviderSurveyRequest
     * @property {space.kenko.proto.IProviderSurveyProto|null} [survey] UpdateProviderSurveyRequest survey
     * @property {boolean|null} [surveyComplete] UpdateProviderSurveyRequest surveyComplete
     */

    /**
     * Constructs a new UpdateProviderSurveyRequest.
     * @exports UpdateProviderSurveyRequest
     * @classdesc Represents an UpdateProviderSurveyRequest.
     * @implements IUpdateProviderSurveyRequest
     * @constructor
     * @param {IUpdateProviderSurveyRequest=} [properties] Properties to set
     */
    function UpdateProviderSurveyRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateProviderSurveyRequest survey.
     * @member {space.kenko.proto.IProviderSurveyProto|null|undefined} survey
     * @memberof UpdateProviderSurveyRequest
     * @instance
     */
    UpdateProviderSurveyRequest.prototype.survey = null;

    /**
     * UpdateProviderSurveyRequest surveyComplete.
     * @member {boolean} surveyComplete
     * @memberof UpdateProviderSurveyRequest
     * @instance
     */
    UpdateProviderSurveyRequest.prototype.surveyComplete = false;

    /**
     * Creates a new UpdateProviderSurveyRequest instance using the specified properties.
     * @function create
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {IUpdateProviderSurveyRequest=} [properties] Properties to set
     * @returns {UpdateProviderSurveyRequest} UpdateProviderSurveyRequest instance
     */
    UpdateProviderSurveyRequest.create = function create(properties) {
        return new UpdateProviderSurveyRequest(properties);
    };

    /**
     * Encodes the specified UpdateProviderSurveyRequest message. Does not implicitly {@link UpdateProviderSurveyRequest.verify|verify} messages.
     * @function encode
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {IUpdateProviderSurveyRequest} message UpdateProviderSurveyRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderSurveyRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.survey != null && Object.hasOwnProperty.call(message, "survey"))
            $root.space.kenko.proto.ProviderSurveyProto.encode(message.survey, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.surveyComplete != null && Object.hasOwnProperty.call(message, "surveyComplete"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.surveyComplete);
        return writer;
    };

    /**
     * Encodes the specified UpdateProviderSurveyRequest message, length delimited. Does not implicitly {@link UpdateProviderSurveyRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {IUpdateProviderSurveyRequest} message UpdateProviderSurveyRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderSurveyRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateProviderSurveyRequest message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateProviderSurveyRequest} UpdateProviderSurveyRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderSurveyRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateProviderSurveyRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.survey = $root.space.kenko.proto.ProviderSurveyProto.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.surveyComplete = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateProviderSurveyRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateProviderSurveyRequest} UpdateProviderSurveyRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderSurveyRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateProviderSurveyRequest message.
     * @function verify
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateProviderSurveyRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.survey != null && message.hasOwnProperty("survey")) {
            let error = $root.space.kenko.proto.ProviderSurveyProto.verify(message.survey);
            if (error)
                return "survey." + error;
        }
        if (message.surveyComplete != null && message.hasOwnProperty("surveyComplete"))
            if (typeof message.surveyComplete !== "boolean")
                return "surveyComplete: boolean expected";
        return null;
    };

    /**
     * Creates an UpdateProviderSurveyRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateProviderSurveyRequest} UpdateProviderSurveyRequest
     */
    UpdateProviderSurveyRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateProviderSurveyRequest)
            return object;
        let message = new $root.UpdateProviderSurveyRequest();
        if (object.survey != null) {
            if (typeof object.survey !== "object")
                throw TypeError(".UpdateProviderSurveyRequest.survey: object expected");
            message.survey = $root.space.kenko.proto.ProviderSurveyProto.fromObject(object.survey);
        }
        if (object.surveyComplete != null)
            message.surveyComplete = Boolean(object.surveyComplete);
        return message;
    };

    /**
     * Creates a plain object from an UpdateProviderSurveyRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {UpdateProviderSurveyRequest} message UpdateProviderSurveyRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateProviderSurveyRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.survey = null;
            object.surveyComplete = false;
        }
        if (message.survey != null && message.hasOwnProperty("survey"))
            object.survey = $root.space.kenko.proto.ProviderSurveyProto.toObject(message.survey, options);
        if (message.surveyComplete != null && message.hasOwnProperty("surveyComplete"))
            object.surveyComplete = message.surveyComplete;
        return object;
    };

    /**
     * Converts this UpdateProviderSurveyRequest to JSON.
     * @function toJSON
     * @memberof UpdateProviderSurveyRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateProviderSurveyRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateProviderSurveyRequest
     * @function getTypeUrl
     * @memberof UpdateProviderSurveyRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateProviderSurveyRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateProviderSurveyRequest";
    };

    return UpdateProviderSurveyRequest;
})();

export const UpdateProviderSurveyResponse = $root.UpdateProviderSurveyResponse = (() => {

    /**
     * Properties of an UpdateProviderSurveyResponse.
     * @exports IUpdateProviderSurveyResponse
     * @interface IUpdateProviderSurveyResponse
     * @property {boolean|null} [okay] UpdateProviderSurveyResponse okay
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] UpdateProviderSurveyResponse errors
     * @property {IApiBusinessProto|null} [business] UpdateProviderSurveyResponse business
     * @property {IApiBusinessProfileProto|null} [profile] UpdateProviderSurveyResponse profile
     * @property {IApiProviderProto|null} [provider] UpdateProviderSurveyResponse provider
     */

    /**
     * Constructs a new UpdateProviderSurveyResponse.
     * @exports UpdateProviderSurveyResponse
     * @classdesc Represents an UpdateProviderSurveyResponse.
     * @implements IUpdateProviderSurveyResponse
     * @constructor
     * @param {IUpdateProviderSurveyResponse=} [properties] Properties to set
     */
    function UpdateProviderSurveyResponse(properties) {
        this.errors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdateProviderSurveyResponse okay.
     * @member {boolean} okay
     * @memberof UpdateProviderSurveyResponse
     * @instance
     */
    UpdateProviderSurveyResponse.prototype.okay = false;

    /**
     * UpdateProviderSurveyResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof UpdateProviderSurveyResponse
     * @instance
     */
    UpdateProviderSurveyResponse.prototype.errors = $util.emptyArray;

    /**
     * UpdateProviderSurveyResponse business.
     * @member {IApiBusinessProto|null|undefined} business
     * @memberof UpdateProviderSurveyResponse
     * @instance
     */
    UpdateProviderSurveyResponse.prototype.business = null;

    /**
     * UpdateProviderSurveyResponse profile.
     * @member {IApiBusinessProfileProto|null|undefined} profile
     * @memberof UpdateProviderSurveyResponse
     * @instance
     */
    UpdateProviderSurveyResponse.prototype.profile = null;

    /**
     * UpdateProviderSurveyResponse provider.
     * @member {IApiProviderProto|null|undefined} provider
     * @memberof UpdateProviderSurveyResponse
     * @instance
     */
    UpdateProviderSurveyResponse.prototype.provider = null;

    /**
     * Creates a new UpdateProviderSurveyResponse instance using the specified properties.
     * @function create
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {IUpdateProviderSurveyResponse=} [properties] Properties to set
     * @returns {UpdateProviderSurveyResponse} UpdateProviderSurveyResponse instance
     */
    UpdateProviderSurveyResponse.create = function create(properties) {
        return new UpdateProviderSurveyResponse(properties);
    };

    /**
     * Encodes the specified UpdateProviderSurveyResponse message. Does not implicitly {@link UpdateProviderSurveyResponse.verify|verify} messages.
     * @function encode
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {IUpdateProviderSurveyResponse} message UpdateProviderSurveyResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderSurveyResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.errors != null && message.errors.length)
            for (let i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.business != null && Object.hasOwnProperty.call(message, "business"))
            $root.ApiBusinessProto.encode(message.business, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
            $root.ApiBusinessProfileProto.encode(message.profile, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
            $root.ApiProviderProto.encode(message.provider, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdateProviderSurveyResponse message, length delimited. Does not implicitly {@link UpdateProviderSurveyResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {IUpdateProviderSurveyResponse} message UpdateProviderSurveyResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdateProviderSurveyResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdateProviderSurveyResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdateProviderSurveyResponse} UpdateProviderSurveyResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderSurveyResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdateProviderSurveyResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.business = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.profile = $root.ApiBusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.provider = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdateProviderSurveyResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdateProviderSurveyResponse} UpdateProviderSurveyResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdateProviderSurveyResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdateProviderSurveyResponse message.
     * @function verify
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdateProviderSurveyResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (let i = 0; i < message.errors.length; ++i) {
                let error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        if (message.business != null && message.hasOwnProperty("business")) {
            let error = $root.ApiBusinessProto.verify(message.business);
            if (error)
                return "business." + error;
        }
        if (message.profile != null && message.hasOwnProperty("profile")) {
            let error = $root.ApiBusinessProfileProto.verify(message.profile);
            if (error)
                return "profile." + error;
        }
        if (message.provider != null && message.hasOwnProperty("provider")) {
            let error = $root.ApiProviderProto.verify(message.provider);
            if (error)
                return "provider." + error;
        }
        return null;
    };

    /**
     * Creates an UpdateProviderSurveyResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdateProviderSurveyResponse} UpdateProviderSurveyResponse
     */
    UpdateProviderSurveyResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdateProviderSurveyResponse)
            return object;
        let message = new $root.UpdateProviderSurveyResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".UpdateProviderSurveyResponse.errors: array expected");
            message.errors = [];
            for (let i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".UpdateProviderSurveyResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        if (object.business != null) {
            if (typeof object.business !== "object")
                throw TypeError(".UpdateProviderSurveyResponse.business: object expected");
            message.business = $root.ApiBusinessProto.fromObject(object.business);
        }
        if (object.profile != null) {
            if (typeof object.profile !== "object")
                throw TypeError(".UpdateProviderSurveyResponse.profile: object expected");
            message.profile = $root.ApiBusinessProfileProto.fromObject(object.profile);
        }
        if (object.provider != null) {
            if (typeof object.provider !== "object")
                throw TypeError(".UpdateProviderSurveyResponse.provider: object expected");
            message.provider = $root.ApiProviderProto.fromObject(object.provider);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdateProviderSurveyResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {UpdateProviderSurveyResponse} message UpdateProviderSurveyResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdateProviderSurveyResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults) {
            object.okay = false;
            object.business = null;
            object.profile = null;
            object.provider = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (let j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        if (message.business != null && message.hasOwnProperty("business"))
            object.business = $root.ApiBusinessProto.toObject(message.business, options);
        if (message.profile != null && message.hasOwnProperty("profile"))
            object.profile = $root.ApiBusinessProfileProto.toObject(message.profile, options);
        if (message.provider != null && message.hasOwnProperty("provider"))
            object.provider = $root.ApiProviderProto.toObject(message.provider, options);
        return object;
    };

    /**
     * Converts this UpdateProviderSurveyResponse to JSON.
     * @function toJSON
     * @memberof UpdateProviderSurveyResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdateProviderSurveyResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdateProviderSurveyResponse
     * @function getTypeUrl
     * @memberof UpdateProviderSurveyResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdateProviderSurveyResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdateProviderSurveyResponse";
    };

    return UpdateProviderSurveyResponse;
})();

export const AdminBusinessSearchRequest = $root.AdminBusinessSearchRequest = (() => {

    /**
     * Properties of an AdminBusinessSearchRequest.
     * @exports IAdminBusinessSearchRequest
     * @interface IAdminBusinessSearchRequest
     * @property {string|null} [query] AdminBusinessSearchRequest query
     */

    /**
     * Constructs a new AdminBusinessSearchRequest.
     * @exports AdminBusinessSearchRequest
     * @classdesc Represents an AdminBusinessSearchRequest.
     * @implements IAdminBusinessSearchRequest
     * @constructor
     * @param {IAdminBusinessSearchRequest=} [properties] Properties to set
     */
    function AdminBusinessSearchRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AdminBusinessSearchRequest query.
     * @member {string} query
     * @memberof AdminBusinessSearchRequest
     * @instance
     */
    AdminBusinessSearchRequest.prototype.query = "";

    /**
     * Creates a new AdminBusinessSearchRequest instance using the specified properties.
     * @function create
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {IAdminBusinessSearchRequest=} [properties] Properties to set
     * @returns {AdminBusinessSearchRequest} AdminBusinessSearchRequest instance
     */
    AdminBusinessSearchRequest.create = function create(properties) {
        return new AdminBusinessSearchRequest(properties);
    };

    /**
     * Encodes the specified AdminBusinessSearchRequest message. Does not implicitly {@link AdminBusinessSearchRequest.verify|verify} messages.
     * @function encode
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {IAdminBusinessSearchRequest} message AdminBusinessSearchRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminBusinessSearchRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.query != null && Object.hasOwnProperty.call(message, "query"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.query);
        return writer;
    };

    /**
     * Encodes the specified AdminBusinessSearchRequest message, length delimited. Does not implicitly {@link AdminBusinessSearchRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {IAdminBusinessSearchRequest} message AdminBusinessSearchRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminBusinessSearchRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AdminBusinessSearchRequest message from the specified reader or buffer.
     * @function decode
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AdminBusinessSearchRequest} AdminBusinessSearchRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminBusinessSearchRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AdminBusinessSearchRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.query = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AdminBusinessSearchRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AdminBusinessSearchRequest} AdminBusinessSearchRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminBusinessSearchRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AdminBusinessSearchRequest message.
     * @function verify
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AdminBusinessSearchRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.query != null && message.hasOwnProperty("query"))
            if (!$util.isString(message.query))
                return "query: string expected";
        return null;
    };

    /**
     * Creates an AdminBusinessSearchRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AdminBusinessSearchRequest} AdminBusinessSearchRequest
     */
    AdminBusinessSearchRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AdminBusinessSearchRequest)
            return object;
        let message = new $root.AdminBusinessSearchRequest();
        if (object.query != null)
            message.query = String(object.query);
        return message;
    };

    /**
     * Creates a plain object from an AdminBusinessSearchRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {AdminBusinessSearchRequest} message AdminBusinessSearchRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AdminBusinessSearchRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.query = "";
        if (message.query != null && message.hasOwnProperty("query"))
            object.query = message.query;
        return object;
    };

    /**
     * Converts this AdminBusinessSearchRequest to JSON.
     * @function toJSON
     * @memberof AdminBusinessSearchRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AdminBusinessSearchRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AdminBusinessSearchRequest
     * @function getTypeUrl
     * @memberof AdminBusinessSearchRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AdminBusinessSearchRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AdminBusinessSearchRequest";
    };

    return AdminBusinessSearchRequest;
})();

export const AdminBusinessSearchResponse = $root.AdminBusinessSearchResponse = (() => {

    /**
     * Properties of an AdminBusinessSearchResponse.
     * @exports IAdminBusinessSearchResponse
     * @interface IAdminBusinessSearchResponse
     * @property {boolean|null} [okay] AdminBusinessSearchResponse okay
     * @property {Array.<AdminBusinessSearchResponse.IBusinessSearchResult>|null} [searchResult] AdminBusinessSearchResponse searchResult
     */

    /**
     * Constructs a new AdminBusinessSearchResponse.
     * @exports AdminBusinessSearchResponse
     * @classdesc Represents an AdminBusinessSearchResponse.
     * @implements IAdminBusinessSearchResponse
     * @constructor
     * @param {IAdminBusinessSearchResponse=} [properties] Properties to set
     */
    function AdminBusinessSearchResponse(properties) {
        this.searchResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AdminBusinessSearchResponse okay.
     * @member {boolean} okay
     * @memberof AdminBusinessSearchResponse
     * @instance
     */
    AdminBusinessSearchResponse.prototype.okay = false;

    /**
     * AdminBusinessSearchResponse searchResult.
     * @member {Array.<AdminBusinessSearchResponse.IBusinessSearchResult>} searchResult
     * @memberof AdminBusinessSearchResponse
     * @instance
     */
    AdminBusinessSearchResponse.prototype.searchResult = $util.emptyArray;

    /**
     * Creates a new AdminBusinessSearchResponse instance using the specified properties.
     * @function create
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {IAdminBusinessSearchResponse=} [properties] Properties to set
     * @returns {AdminBusinessSearchResponse} AdminBusinessSearchResponse instance
     */
    AdminBusinessSearchResponse.create = function create(properties) {
        return new AdminBusinessSearchResponse(properties);
    };

    /**
     * Encodes the specified AdminBusinessSearchResponse message. Does not implicitly {@link AdminBusinessSearchResponse.verify|verify} messages.
     * @function encode
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {IAdminBusinessSearchResponse} message AdminBusinessSearchResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminBusinessSearchResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.searchResult != null && message.searchResult.length)
            for (let i = 0; i < message.searchResult.length; ++i)
                $root.AdminBusinessSearchResponse.BusinessSearchResult.encode(message.searchResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AdminBusinessSearchResponse message, length delimited. Does not implicitly {@link AdminBusinessSearchResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {IAdminBusinessSearchResponse} message AdminBusinessSearchResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AdminBusinessSearchResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AdminBusinessSearchResponse message from the specified reader or buffer.
     * @function decode
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AdminBusinessSearchResponse} AdminBusinessSearchResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminBusinessSearchResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AdminBusinessSearchResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.searchResult && message.searchResult.length))
                        message.searchResult = [];
                    message.searchResult.push($root.AdminBusinessSearchResponse.BusinessSearchResult.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AdminBusinessSearchResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AdminBusinessSearchResponse} AdminBusinessSearchResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AdminBusinessSearchResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AdminBusinessSearchResponse message.
     * @function verify
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AdminBusinessSearchResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.searchResult != null && message.hasOwnProperty("searchResult")) {
            if (!Array.isArray(message.searchResult))
                return "searchResult: array expected";
            for (let i = 0; i < message.searchResult.length; ++i) {
                let error = $root.AdminBusinessSearchResponse.BusinessSearchResult.verify(message.searchResult[i]);
                if (error)
                    return "searchResult." + error;
            }
        }
        return null;
    };

    /**
     * Creates an AdminBusinessSearchResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AdminBusinessSearchResponse} AdminBusinessSearchResponse
     */
    AdminBusinessSearchResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.AdminBusinessSearchResponse)
            return object;
        let message = new $root.AdminBusinessSearchResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.searchResult) {
            if (!Array.isArray(object.searchResult))
                throw TypeError(".AdminBusinessSearchResponse.searchResult: array expected");
            message.searchResult = [];
            for (let i = 0; i < object.searchResult.length; ++i) {
                if (typeof object.searchResult[i] !== "object")
                    throw TypeError(".AdminBusinessSearchResponse.searchResult: object expected");
                message.searchResult[i] = $root.AdminBusinessSearchResponse.BusinessSearchResult.fromObject(object.searchResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from an AdminBusinessSearchResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {AdminBusinessSearchResponse} message AdminBusinessSearchResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AdminBusinessSearchResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.searchResult = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.searchResult && message.searchResult.length) {
            object.searchResult = [];
            for (let j = 0; j < message.searchResult.length; ++j)
                object.searchResult[j] = $root.AdminBusinessSearchResponse.BusinessSearchResult.toObject(message.searchResult[j], options);
        }
        return object;
    };

    /**
     * Converts this AdminBusinessSearchResponse to JSON.
     * @function toJSON
     * @memberof AdminBusinessSearchResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AdminBusinessSearchResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AdminBusinessSearchResponse
     * @function getTypeUrl
     * @memberof AdminBusinessSearchResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AdminBusinessSearchResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AdminBusinessSearchResponse";
    };

    AdminBusinessSearchResponse.BusinessSearchResult = (function() {

        /**
         * Properties of a BusinessSearchResult.
         * @memberof AdminBusinessSearchResponse
         * @interface IBusinessSearchResult
         * @property {IApiBusinessProto|null} [business] BusinessSearchResult business
         * @property {IApiBusinessProfileProto|null} [profile] BusinessSearchResult profile
         */

        /**
         * Constructs a new BusinessSearchResult.
         * @memberof AdminBusinessSearchResponse
         * @classdesc Represents a BusinessSearchResult.
         * @implements IBusinessSearchResult
         * @constructor
         * @param {AdminBusinessSearchResponse.IBusinessSearchResult=} [properties] Properties to set
         */
        function BusinessSearchResult(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BusinessSearchResult business.
         * @member {IApiBusinessProto|null|undefined} business
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @instance
         */
        BusinessSearchResult.prototype.business = null;

        /**
         * BusinessSearchResult profile.
         * @member {IApiBusinessProfileProto|null|undefined} profile
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @instance
         */
        BusinessSearchResult.prototype.profile = null;

        /**
         * Creates a new BusinessSearchResult instance using the specified properties.
         * @function create
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {AdminBusinessSearchResponse.IBusinessSearchResult=} [properties] Properties to set
         * @returns {AdminBusinessSearchResponse.BusinessSearchResult} BusinessSearchResult instance
         */
        BusinessSearchResult.create = function create(properties) {
            return new BusinessSearchResult(properties);
        };

        /**
         * Encodes the specified BusinessSearchResult message. Does not implicitly {@link AdminBusinessSearchResponse.BusinessSearchResult.verify|verify} messages.
         * @function encode
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {AdminBusinessSearchResponse.IBusinessSearchResult} message BusinessSearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BusinessSearchResult.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.business != null && Object.hasOwnProperty.call(message, "business"))
                $root.ApiBusinessProto.encode(message.business, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.profile != null && Object.hasOwnProperty.call(message, "profile"))
                $root.ApiBusinessProfileProto.encode(message.profile, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BusinessSearchResult message, length delimited. Does not implicitly {@link AdminBusinessSearchResponse.BusinessSearchResult.verify|verify} messages.
         * @function encodeDelimited
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {AdminBusinessSearchResponse.IBusinessSearchResult} message BusinessSearchResult message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BusinessSearchResult.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BusinessSearchResult message from the specified reader or buffer.
         * @function decode
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {AdminBusinessSearchResponse.BusinessSearchResult} BusinessSearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BusinessSearchResult.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AdminBusinessSearchResponse.BusinessSearchResult();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1: {
                        message.business = $root.ApiBusinessProto.decode(reader, reader.uint32());
                        break;
                    }
                case 2: {
                        message.profile = $root.ApiBusinessProfileProto.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BusinessSearchResult message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {AdminBusinessSearchResponse.BusinessSearchResult} BusinessSearchResult
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BusinessSearchResult.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BusinessSearchResult message.
         * @function verify
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BusinessSearchResult.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.business != null && message.hasOwnProperty("business")) {
                let error = $root.ApiBusinessProto.verify(message.business);
                if (error)
                    return "business." + error;
            }
            if (message.profile != null && message.hasOwnProperty("profile")) {
                let error = $root.ApiBusinessProfileProto.verify(message.profile);
                if (error)
                    return "profile." + error;
            }
            return null;
        };

        /**
         * Creates a BusinessSearchResult message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {AdminBusinessSearchResponse.BusinessSearchResult} BusinessSearchResult
         */
        BusinessSearchResult.fromObject = function fromObject(object) {
            if (object instanceof $root.AdminBusinessSearchResponse.BusinessSearchResult)
                return object;
            let message = new $root.AdminBusinessSearchResponse.BusinessSearchResult();
            if (object.business != null) {
                if (typeof object.business !== "object")
                    throw TypeError(".AdminBusinessSearchResponse.BusinessSearchResult.business: object expected");
                message.business = $root.ApiBusinessProto.fromObject(object.business);
            }
            if (object.profile != null) {
                if (typeof object.profile !== "object")
                    throw TypeError(".AdminBusinessSearchResponse.BusinessSearchResult.profile: object expected");
                message.profile = $root.ApiBusinessProfileProto.fromObject(object.profile);
            }
            return message;
        };

        /**
         * Creates a plain object from a BusinessSearchResult message. Also converts values to other types if specified.
         * @function toObject
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {AdminBusinessSearchResponse.BusinessSearchResult} message BusinessSearchResult
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BusinessSearchResult.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.business = null;
                object.profile = null;
            }
            if (message.business != null && message.hasOwnProperty("business"))
                object.business = $root.ApiBusinessProto.toObject(message.business, options);
            if (message.profile != null && message.hasOwnProperty("profile"))
                object.profile = $root.ApiBusinessProfileProto.toObject(message.profile, options);
            return object;
        };

        /**
         * Converts this BusinessSearchResult to JSON.
         * @function toJSON
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BusinessSearchResult.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for BusinessSearchResult
         * @function getTypeUrl
         * @memberof AdminBusinessSearchResponse.BusinessSearchResult
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        BusinessSearchResult.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/AdminBusinessSearchResponse.BusinessSearchResult";
        };

        return BusinessSearchResult;
    })();

    return AdminBusinessSearchResponse;
})();

export const GetClassBookingsRequest = $root.GetClassBookingsRequest = (() => {

    /**
     * Properties of a GetClassBookingsRequest.
     * @exports IGetClassBookingsRequest
     * @interface IGetClassBookingsRequest
     * @property {string|null} [eventInstanceId] GetClassBookingsRequest eventInstanceId
     */

    /**
     * Constructs a new GetClassBookingsRequest.
     * @exports GetClassBookingsRequest
     * @classdesc Represents a GetClassBookingsRequest.
     * @implements IGetClassBookingsRequest
     * @constructor
     * @param {IGetClassBookingsRequest=} [properties] Properties to set
     */
    function GetClassBookingsRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClassBookingsRequest eventInstanceId.
     * @member {string} eventInstanceId
     * @memberof GetClassBookingsRequest
     * @instance
     */
    GetClassBookingsRequest.prototype.eventInstanceId = "";

    /**
     * Creates a new GetClassBookingsRequest instance using the specified properties.
     * @function create
     * @memberof GetClassBookingsRequest
     * @static
     * @param {IGetClassBookingsRequest=} [properties] Properties to set
     * @returns {GetClassBookingsRequest} GetClassBookingsRequest instance
     */
    GetClassBookingsRequest.create = function create(properties) {
        return new GetClassBookingsRequest(properties);
    };

    /**
     * Encodes the specified GetClassBookingsRequest message. Does not implicitly {@link GetClassBookingsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetClassBookingsRequest
     * @static
     * @param {IGetClassBookingsRequest} message GetClassBookingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClassBookingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.eventInstanceId != null && Object.hasOwnProperty.call(message, "eventInstanceId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.eventInstanceId);
        return writer;
    };

    /**
     * Encodes the specified GetClassBookingsRequest message, length delimited. Does not implicitly {@link GetClassBookingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClassBookingsRequest
     * @static
     * @param {IGetClassBookingsRequest} message GetClassBookingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClassBookingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClassBookingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetClassBookingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClassBookingsRequest} GetClassBookingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClassBookingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClassBookingsRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.eventInstanceId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClassBookingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClassBookingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClassBookingsRequest} GetClassBookingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClassBookingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClassBookingsRequest message.
     * @function verify
     * @memberof GetClassBookingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClassBookingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            if (!$util.isString(message.eventInstanceId))
                return "eventInstanceId: string expected";
        return null;
    };

    /**
     * Creates a GetClassBookingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClassBookingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClassBookingsRequest} GetClassBookingsRequest
     */
    GetClassBookingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClassBookingsRequest)
            return object;
        let message = new $root.GetClassBookingsRequest();
        if (object.eventInstanceId != null)
            message.eventInstanceId = String(object.eventInstanceId);
        return message;
    };

    /**
     * Creates a plain object from a GetClassBookingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClassBookingsRequest
     * @static
     * @param {GetClassBookingsRequest} message GetClassBookingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClassBookingsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.eventInstanceId = "";
        if (message.eventInstanceId != null && message.hasOwnProperty("eventInstanceId"))
            object.eventInstanceId = message.eventInstanceId;
        return object;
    };

    /**
     * Converts this GetClassBookingsRequest to JSON.
     * @function toJSON
     * @memberof GetClassBookingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClassBookingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClassBookingsRequest
     * @function getTypeUrl
     * @memberof GetClassBookingsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClassBookingsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClassBookingsRequest";
    };

    return GetClassBookingsRequest;
})();

export const GetClientBookingsRequest = $root.GetClientBookingsRequest = (() => {

    /**
     * Properties of a GetClientBookingsRequest.
     * @exports IGetClientBookingsRequest
     * @interface IGetClientBookingsRequest
     * @property {string|null} [userId] GetClientBookingsRequest userId
     * @property {string|null} [optionalBookingId] GetClientBookingsRequest optionalBookingId
     */

    /**
     * Constructs a new GetClientBookingsRequest.
     * @exports GetClientBookingsRequest
     * @classdesc Represents a GetClientBookingsRequest.
     * @implements IGetClientBookingsRequest
     * @constructor
     * @param {IGetClientBookingsRequest=} [properties] Properties to set
     */
    function GetClientBookingsRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClientBookingsRequest userId.
     * @member {string} userId
     * @memberof GetClientBookingsRequest
     * @instance
     */
    GetClientBookingsRequest.prototype.userId = "";

    /**
     * GetClientBookingsRequest optionalBookingId.
     * @member {string} optionalBookingId
     * @memberof GetClientBookingsRequest
     * @instance
     */
    GetClientBookingsRequest.prototype.optionalBookingId = "";

    /**
     * Creates a new GetClientBookingsRequest instance using the specified properties.
     * @function create
     * @memberof GetClientBookingsRequest
     * @static
     * @param {IGetClientBookingsRequest=} [properties] Properties to set
     * @returns {GetClientBookingsRequest} GetClientBookingsRequest instance
     */
    GetClientBookingsRequest.create = function create(properties) {
        return new GetClientBookingsRequest(properties);
    };

    /**
     * Encodes the specified GetClientBookingsRequest message. Does not implicitly {@link GetClientBookingsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetClientBookingsRequest
     * @static
     * @param {IGetClientBookingsRequest} message GetClientBookingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientBookingsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.optionalBookingId != null && Object.hasOwnProperty.call(message, "optionalBookingId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.optionalBookingId);
        return writer;
    };

    /**
     * Encodes the specified GetClientBookingsRequest message, length delimited. Does not implicitly {@link GetClientBookingsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClientBookingsRequest
     * @static
     * @param {IGetClientBookingsRequest} message GetClientBookingsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientBookingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClientBookingsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetClientBookingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClientBookingsRequest} GetClientBookingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientBookingsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClientBookingsRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.optionalBookingId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClientBookingsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClientBookingsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClientBookingsRequest} GetClientBookingsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientBookingsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClientBookingsRequest message.
     * @function verify
     * @memberof GetClientBookingsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClientBookingsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.optionalBookingId != null && message.hasOwnProperty("optionalBookingId"))
            if (!$util.isString(message.optionalBookingId))
                return "optionalBookingId: string expected";
        return null;
    };

    /**
     * Creates a GetClientBookingsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClientBookingsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClientBookingsRequest} GetClientBookingsRequest
     */
    GetClientBookingsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClientBookingsRequest)
            return object;
        let message = new $root.GetClientBookingsRequest();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.optionalBookingId != null)
            message.optionalBookingId = String(object.optionalBookingId);
        return message;
    };

    /**
     * Creates a plain object from a GetClientBookingsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClientBookingsRequest
     * @static
     * @param {GetClientBookingsRequest} message GetClientBookingsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClientBookingsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.userId = "";
            object.optionalBookingId = "";
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.optionalBookingId != null && message.hasOwnProperty("optionalBookingId"))
            object.optionalBookingId = message.optionalBookingId;
        return object;
    };

    /**
     * Converts this GetClientBookingsRequest to JSON.
     * @function toJSON
     * @memberof GetClientBookingsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClientBookingsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClientBookingsRequest
     * @function getTypeUrl
     * @memberof GetClientBookingsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClientBookingsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClientBookingsRequest";
    };

    return GetClientBookingsRequest;
})();

export const GetBookingsResponse = $root.GetBookingsResponse = (() => {

    /**
     * Properties of a GetBookingsResponse.
     * @exports IGetBookingsResponse
     * @interface IGetBookingsResponse
     * @property {boolean|null} [okay] GetBookingsResponse okay
     * @property {Array.<space.kenko.proto.IApiBookingProto>|null} [booking] GetBookingsResponse booking
     */

    /**
     * Constructs a new GetBookingsResponse.
     * @exports GetBookingsResponse
     * @classdesc Represents a GetBookingsResponse.
     * @implements IGetBookingsResponse
     * @constructor
     * @param {IGetBookingsResponse=} [properties] Properties to set
     */
    function GetBookingsResponse(properties) {
        this.booking = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetBookingsResponse okay.
     * @member {boolean} okay
     * @memberof GetBookingsResponse
     * @instance
     */
    GetBookingsResponse.prototype.okay = false;

    /**
     * GetBookingsResponse booking.
     * @member {Array.<space.kenko.proto.IApiBookingProto>} booking
     * @memberof GetBookingsResponse
     * @instance
     */
    GetBookingsResponse.prototype.booking = $util.emptyArray;

    /**
     * Creates a new GetBookingsResponse instance using the specified properties.
     * @function create
     * @memberof GetBookingsResponse
     * @static
     * @param {IGetBookingsResponse=} [properties] Properties to set
     * @returns {GetBookingsResponse} GetBookingsResponse instance
     */
    GetBookingsResponse.create = function create(properties) {
        return new GetBookingsResponse(properties);
    };

    /**
     * Encodes the specified GetBookingsResponse message. Does not implicitly {@link GetBookingsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetBookingsResponse
     * @static
     * @param {IGetBookingsResponse} message GetBookingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.booking != null && message.booking.length)
            for (let i = 0; i < message.booking.length; ++i)
                $root.space.kenko.proto.ApiBookingProto.encode(message.booking[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetBookingsResponse message, length delimited. Does not implicitly {@link GetBookingsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetBookingsResponse
     * @static
     * @param {IGetBookingsResponse} message GetBookingsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetBookingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetBookingsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetBookingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetBookingsResponse} GetBookingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetBookingsResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.booking && message.booking.length))
                        message.booking = [];
                    message.booking.push($root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetBookingsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetBookingsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetBookingsResponse} GetBookingsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetBookingsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetBookingsResponse message.
     * @function verify
     * @memberof GetBookingsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetBookingsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.booking != null && message.hasOwnProperty("booking")) {
            if (!Array.isArray(message.booking))
                return "booking: array expected";
            for (let i = 0; i < message.booking.length; ++i) {
                let error = $root.space.kenko.proto.ApiBookingProto.verify(message.booking[i]);
                if (error)
                    return "booking." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetBookingsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetBookingsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetBookingsResponse} GetBookingsResponse
     */
    GetBookingsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetBookingsResponse)
            return object;
        let message = new $root.GetBookingsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.booking) {
            if (!Array.isArray(object.booking))
                throw TypeError(".GetBookingsResponse.booking: array expected");
            message.booking = [];
            for (let i = 0; i < object.booking.length; ++i) {
                if (typeof object.booking[i] !== "object")
                    throw TypeError(".GetBookingsResponse.booking: object expected");
                message.booking[i] = $root.space.kenko.proto.ApiBookingProto.fromObject(object.booking[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetBookingsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetBookingsResponse
     * @static
     * @param {GetBookingsResponse} message GetBookingsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetBookingsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.booking = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.booking && message.booking.length) {
            object.booking = [];
            for (let j = 0; j < message.booking.length; ++j)
                object.booking[j] = $root.space.kenko.proto.ApiBookingProto.toObject(message.booking[j], options);
        }
        return object;
    };

    /**
     * Converts this GetBookingsResponse to JSON.
     * @function toJSON
     * @memberof GetBookingsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetBookingsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetBookingsResponse
     * @function getTypeUrl
     * @memberof GetBookingsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetBookingsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetBookingsResponse";
    };

    return GetBookingsResponse;
})();

export const MutateClassPackRequest = $root.MutateClassPackRequest = (() => {

    /**
     * Properties of a MutateClassPackRequest.
     * @exports IMutateClassPackRequest
     * @interface IMutateClassPackRequest
     * @property {IPackageProto|null} [classPack] MutateClassPackRequest classPack
     */

    /**
     * Constructs a new MutateClassPackRequest.
     * @exports MutateClassPackRequest
     * @classdesc Represents a MutateClassPackRequest.
     * @implements IMutateClassPackRequest
     * @constructor
     * @param {IMutateClassPackRequest=} [properties] Properties to set
     */
    function MutateClassPackRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateClassPackRequest classPack.
     * @member {IPackageProto|null|undefined} classPack
     * @memberof MutateClassPackRequest
     * @instance
     */
    MutateClassPackRequest.prototype.classPack = null;

    /**
     * Creates a new MutateClassPackRequest instance using the specified properties.
     * @function create
     * @memberof MutateClassPackRequest
     * @static
     * @param {IMutateClassPackRequest=} [properties] Properties to set
     * @returns {MutateClassPackRequest} MutateClassPackRequest instance
     */
    MutateClassPackRequest.create = function create(properties) {
        return new MutateClassPackRequest(properties);
    };

    /**
     * Encodes the specified MutateClassPackRequest message. Does not implicitly {@link MutateClassPackRequest.verify|verify} messages.
     * @function encode
     * @memberof MutateClassPackRequest
     * @static
     * @param {IMutateClassPackRequest} message MutateClassPackRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateClassPackRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.classPack != null && Object.hasOwnProperty.call(message, "classPack"))
            $root.PackageProto.encode(message.classPack, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutateClassPackRequest message, length delimited. Does not implicitly {@link MutateClassPackRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateClassPackRequest
     * @static
     * @param {IMutateClassPackRequest} message MutateClassPackRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateClassPackRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateClassPackRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MutateClassPackRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateClassPackRequest} MutateClassPackRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateClassPackRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateClassPackRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.classPack = $root.PackageProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateClassPackRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateClassPackRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateClassPackRequest} MutateClassPackRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateClassPackRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateClassPackRequest message.
     * @function verify
     * @memberof MutateClassPackRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateClassPackRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.classPack != null && message.hasOwnProperty("classPack")) {
            let error = $root.PackageProto.verify(message.classPack);
            if (error)
                return "classPack." + error;
        }
        return null;
    };

    /**
     * Creates a MutateClassPackRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateClassPackRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateClassPackRequest} MutateClassPackRequest
     */
    MutateClassPackRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateClassPackRequest)
            return object;
        let message = new $root.MutateClassPackRequest();
        if (object.classPack != null) {
            if (typeof object.classPack !== "object")
                throw TypeError(".MutateClassPackRequest.classPack: object expected");
            message.classPack = $root.PackageProto.fromObject(object.classPack);
        }
        return message;
    };

    /**
     * Creates a plain object from a MutateClassPackRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateClassPackRequest
     * @static
     * @param {MutateClassPackRequest} message MutateClassPackRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateClassPackRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.classPack = null;
        if (message.classPack != null && message.hasOwnProperty("classPack"))
            object.classPack = $root.PackageProto.toObject(message.classPack, options);
        return object;
    };

    /**
     * Converts this MutateClassPackRequest to JSON.
     * @function toJSON
     * @memberof MutateClassPackRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateClassPackRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateClassPackRequest
     * @function getTypeUrl
     * @memberof MutateClassPackRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateClassPackRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateClassPackRequest";
    };

    return MutateClassPackRequest;
})();

export const UpdatedProfileResponse = $root.UpdatedProfileResponse = (() => {

    /**
     * Properties of an UpdatedProfileResponse.
     * @exports IUpdatedProfileResponse
     * @interface IUpdatedProfileResponse
     * @property {boolean|null} [okay] UpdatedProfileResponse okay
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] UpdatedProfileResponse errors
     * @property {IApiBusinessProfileProto|null} [updated] UpdatedProfileResponse updated
     */

    /**
     * Constructs a new UpdatedProfileResponse.
     * @exports UpdatedProfileResponse
     * @classdesc Represents an UpdatedProfileResponse.
     * @implements IUpdatedProfileResponse
     * @constructor
     * @param {IUpdatedProfileResponse=} [properties] Properties to set
     */
    function UpdatedProfileResponse(properties) {
        this.errors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdatedProfileResponse okay.
     * @member {boolean} okay
     * @memberof UpdatedProfileResponse
     * @instance
     */
    UpdatedProfileResponse.prototype.okay = false;

    /**
     * UpdatedProfileResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof UpdatedProfileResponse
     * @instance
     */
    UpdatedProfileResponse.prototype.errors = $util.emptyArray;

    /**
     * UpdatedProfileResponse updated.
     * @member {IApiBusinessProfileProto|null|undefined} updated
     * @memberof UpdatedProfileResponse
     * @instance
     */
    UpdatedProfileResponse.prototype.updated = null;

    /**
     * Creates a new UpdatedProfileResponse instance using the specified properties.
     * @function create
     * @memberof UpdatedProfileResponse
     * @static
     * @param {IUpdatedProfileResponse=} [properties] Properties to set
     * @returns {UpdatedProfileResponse} UpdatedProfileResponse instance
     */
    UpdatedProfileResponse.create = function create(properties) {
        return new UpdatedProfileResponse(properties);
    };

    /**
     * Encodes the specified UpdatedProfileResponse message. Does not implicitly {@link UpdatedProfileResponse.verify|verify} messages.
     * @function encode
     * @memberof UpdatedProfileResponse
     * @static
     * @param {IUpdatedProfileResponse} message UpdatedProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatedProfileResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.errors != null && message.errors.length)
            for (let i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.updated != null && Object.hasOwnProperty.call(message, "updated"))
            $root.ApiBusinessProfileProto.encode(message.updated, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdatedProfileResponse message, length delimited. Does not implicitly {@link UpdatedProfileResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdatedProfileResponse
     * @static
     * @param {IUpdatedProfileResponse} message UpdatedProfileResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatedProfileResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdatedProfileResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UpdatedProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdatedProfileResponse} UpdatedProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatedProfileResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdatedProfileResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.updated = $root.ApiBusinessProfileProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdatedProfileResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdatedProfileResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdatedProfileResponse} UpdatedProfileResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatedProfileResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdatedProfileResponse message.
     * @function verify
     * @memberof UpdatedProfileResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdatedProfileResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (let i = 0; i < message.errors.length; ++i) {
                let error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        if (message.updated != null && message.hasOwnProperty("updated")) {
            let error = $root.ApiBusinessProfileProto.verify(message.updated);
            if (error)
                return "updated." + error;
        }
        return null;
    };

    /**
     * Creates an UpdatedProfileResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdatedProfileResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdatedProfileResponse} UpdatedProfileResponse
     */
    UpdatedProfileResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdatedProfileResponse)
            return object;
        let message = new $root.UpdatedProfileResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".UpdatedProfileResponse.errors: array expected");
            message.errors = [];
            for (let i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".UpdatedProfileResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        if (object.updated != null) {
            if (typeof object.updated !== "object")
                throw TypeError(".UpdatedProfileResponse.updated: object expected");
            message.updated = $root.ApiBusinessProfileProto.fromObject(object.updated);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdatedProfileResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdatedProfileResponse
     * @static
     * @param {UpdatedProfileResponse} message UpdatedProfileResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdatedProfileResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults) {
            object.okay = false;
            object.updated = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (let j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        if (message.updated != null && message.hasOwnProperty("updated"))
            object.updated = $root.ApiBusinessProfileProto.toObject(message.updated, options);
        return object;
    };

    /**
     * Converts this UpdatedProfileResponse to JSON.
     * @function toJSON
     * @memberof UpdatedProfileResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdatedProfileResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdatedProfileResponse
     * @function getTypeUrl
     * @memberof UpdatedProfileResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdatedProfileResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdatedProfileResponse";
    };

    return UpdatedProfileResponse;
})();

export const UpdatedBusinessResponse = $root.UpdatedBusinessResponse = (() => {

    /**
     * Properties of an UpdatedBusinessResponse.
     * @exports IUpdatedBusinessResponse
     * @interface IUpdatedBusinessResponse
     * @property {boolean|null} [okay] UpdatedBusinessResponse okay
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] UpdatedBusinessResponse errors
     * @property {IApiBusinessProto|null} [updated] UpdatedBusinessResponse updated
     */

    /**
     * Constructs a new UpdatedBusinessResponse.
     * @exports UpdatedBusinessResponse
     * @classdesc Represents an UpdatedBusinessResponse.
     * @implements IUpdatedBusinessResponse
     * @constructor
     * @param {IUpdatedBusinessResponse=} [properties] Properties to set
     */
    function UpdatedBusinessResponse(properties) {
        this.errors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UpdatedBusinessResponse okay.
     * @member {boolean} okay
     * @memberof UpdatedBusinessResponse
     * @instance
     */
    UpdatedBusinessResponse.prototype.okay = false;

    /**
     * UpdatedBusinessResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof UpdatedBusinessResponse
     * @instance
     */
    UpdatedBusinessResponse.prototype.errors = $util.emptyArray;

    /**
     * UpdatedBusinessResponse updated.
     * @member {IApiBusinessProto|null|undefined} updated
     * @memberof UpdatedBusinessResponse
     * @instance
     */
    UpdatedBusinessResponse.prototype.updated = null;

    /**
     * Creates a new UpdatedBusinessResponse instance using the specified properties.
     * @function create
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {IUpdatedBusinessResponse=} [properties] Properties to set
     * @returns {UpdatedBusinessResponse} UpdatedBusinessResponse instance
     */
    UpdatedBusinessResponse.create = function create(properties) {
        return new UpdatedBusinessResponse(properties);
    };

    /**
     * Encodes the specified UpdatedBusinessResponse message. Does not implicitly {@link UpdatedBusinessResponse.verify|verify} messages.
     * @function encode
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {IUpdatedBusinessResponse} message UpdatedBusinessResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatedBusinessResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.errors != null && message.errors.length)
            for (let i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.updated != null && Object.hasOwnProperty.call(message, "updated"))
            $root.ApiBusinessProto.encode(message.updated, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified UpdatedBusinessResponse message, length delimited. Does not implicitly {@link UpdatedBusinessResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {IUpdatedBusinessResponse} message UpdatedBusinessResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UpdatedBusinessResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an UpdatedBusinessResponse message from the specified reader or buffer.
     * @function decode
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UpdatedBusinessResponse} UpdatedBusinessResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatedBusinessResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UpdatedBusinessResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.updated = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an UpdatedBusinessResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {UpdatedBusinessResponse} UpdatedBusinessResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UpdatedBusinessResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an UpdatedBusinessResponse message.
     * @function verify
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    UpdatedBusinessResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (let i = 0; i < message.errors.length; ++i) {
                let error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        if (message.updated != null && message.hasOwnProperty("updated")) {
            let error = $root.ApiBusinessProto.verify(message.updated);
            if (error)
                return "updated." + error;
        }
        return null;
    };

    /**
     * Creates an UpdatedBusinessResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UpdatedBusinessResponse} UpdatedBusinessResponse
     */
    UpdatedBusinessResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.UpdatedBusinessResponse)
            return object;
        let message = new $root.UpdatedBusinessResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".UpdatedBusinessResponse.errors: array expected");
            message.errors = [];
            for (let i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".UpdatedBusinessResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        if (object.updated != null) {
            if (typeof object.updated !== "object")
                throw TypeError(".UpdatedBusinessResponse.updated: object expected");
            message.updated = $root.ApiBusinessProto.fromObject(object.updated);
        }
        return message;
    };

    /**
     * Creates a plain object from an UpdatedBusinessResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {UpdatedBusinessResponse} message UpdatedBusinessResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UpdatedBusinessResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults) {
            object.okay = false;
            object.updated = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (let j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        if (message.updated != null && message.hasOwnProperty("updated"))
            object.updated = $root.ApiBusinessProto.toObject(message.updated, options);
        return object;
    };

    /**
     * Converts this UpdatedBusinessResponse to JSON.
     * @function toJSON
     * @memberof UpdatedBusinessResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UpdatedBusinessResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UpdatedBusinessResponse
     * @function getTypeUrl
     * @memberof UpdatedBusinessResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UpdatedBusinessResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UpdatedBusinessResponse";
    };

    return UpdatedBusinessResponse;
})();

export const MutateLocationRequest = $root.MutateLocationRequest = (() => {

    /**
     * Properties of a MutateLocationRequest.
     * @exports IMutateLocationRequest
     * @interface IMutateLocationRequest
     * @property {space.kenko.proto.IBusinessLocationProto|null} [location] MutateLocationRequest location
     */

    /**
     * Constructs a new MutateLocationRequest.
     * @exports MutateLocationRequest
     * @classdesc Represents a MutateLocationRequest.
     * @implements IMutateLocationRequest
     * @constructor
     * @param {IMutateLocationRequest=} [properties] Properties to set
     */
    function MutateLocationRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateLocationRequest location.
     * @member {space.kenko.proto.IBusinessLocationProto|null|undefined} location
     * @memberof MutateLocationRequest
     * @instance
     */
    MutateLocationRequest.prototype.location = null;

    /**
     * Creates a new MutateLocationRequest instance using the specified properties.
     * @function create
     * @memberof MutateLocationRequest
     * @static
     * @param {IMutateLocationRequest=} [properties] Properties to set
     * @returns {MutateLocationRequest} MutateLocationRequest instance
     */
    MutateLocationRequest.create = function create(properties) {
        return new MutateLocationRequest(properties);
    };

    /**
     * Encodes the specified MutateLocationRequest message. Does not implicitly {@link MutateLocationRequest.verify|verify} messages.
     * @function encode
     * @memberof MutateLocationRequest
     * @static
     * @param {IMutateLocationRequest} message MutateLocationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateLocationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.location != null && Object.hasOwnProperty.call(message, "location"))
            $root.space.kenko.proto.BusinessLocationProto.encode(message.location, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutateLocationRequest message, length delimited. Does not implicitly {@link MutateLocationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateLocationRequest
     * @static
     * @param {IMutateLocationRequest} message MutateLocationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateLocationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateLocationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MutateLocationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateLocationRequest} MutateLocationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateLocationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateLocationRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.location = $root.space.kenko.proto.BusinessLocationProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateLocationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateLocationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateLocationRequest} MutateLocationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateLocationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateLocationRequest message.
     * @function verify
     * @memberof MutateLocationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateLocationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.location != null && message.hasOwnProperty("location")) {
            let error = $root.space.kenko.proto.BusinessLocationProto.verify(message.location);
            if (error)
                return "location." + error;
        }
        return null;
    };

    /**
     * Creates a MutateLocationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateLocationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateLocationRequest} MutateLocationRequest
     */
    MutateLocationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateLocationRequest)
            return object;
        let message = new $root.MutateLocationRequest();
        if (object.location != null) {
            if (typeof object.location !== "object")
                throw TypeError(".MutateLocationRequest.location: object expected");
            message.location = $root.space.kenko.proto.BusinessLocationProto.fromObject(object.location);
        }
        return message;
    };

    /**
     * Creates a plain object from a MutateLocationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateLocationRequest
     * @static
     * @param {MutateLocationRequest} message MutateLocationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateLocationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.location = null;
        if (message.location != null && message.hasOwnProperty("location"))
            object.location = $root.space.kenko.proto.BusinessLocationProto.toObject(message.location, options);
        return object;
    };

    /**
     * Converts this MutateLocationRequest to JSON.
     * @function toJSON
     * @memberof MutateLocationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateLocationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateLocationRequest
     * @function getTypeUrl
     * @memberof MutateLocationRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateLocationRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateLocationRequest";
    };

    return MutateLocationRequest;
})();

export const MarkBookingAsPaidRequest = $root.MarkBookingAsPaidRequest = (() => {

    /**
     * Properties of a MarkBookingAsPaidRequest.
     * @exports IMarkBookingAsPaidRequest
     * @interface IMarkBookingAsPaidRequest
     * @property {string|null} [bookingId] MarkBookingAsPaidRequest bookingId
     * @property {boolean|null} [paid] MarkBookingAsPaidRequest paid
     * @property {string|null} [note] MarkBookingAsPaidRequest note
     */

    /**
     * Constructs a new MarkBookingAsPaidRequest.
     * @exports MarkBookingAsPaidRequest
     * @classdesc Represents a MarkBookingAsPaidRequest.
     * @implements IMarkBookingAsPaidRequest
     * @constructor
     * @param {IMarkBookingAsPaidRequest=} [properties] Properties to set
     */
    function MarkBookingAsPaidRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarkBookingAsPaidRequest bookingId.
     * @member {string} bookingId
     * @memberof MarkBookingAsPaidRequest
     * @instance
     */
    MarkBookingAsPaidRequest.prototype.bookingId = "";

    /**
     * MarkBookingAsPaidRequest paid.
     * @member {boolean} paid
     * @memberof MarkBookingAsPaidRequest
     * @instance
     */
    MarkBookingAsPaidRequest.prototype.paid = false;

    /**
     * MarkBookingAsPaidRequest note.
     * @member {string} note
     * @memberof MarkBookingAsPaidRequest
     * @instance
     */
    MarkBookingAsPaidRequest.prototype.note = "";

    /**
     * Creates a new MarkBookingAsPaidRequest instance using the specified properties.
     * @function create
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {IMarkBookingAsPaidRequest=} [properties] Properties to set
     * @returns {MarkBookingAsPaidRequest} MarkBookingAsPaidRequest instance
     */
    MarkBookingAsPaidRequest.create = function create(properties) {
        return new MarkBookingAsPaidRequest(properties);
    };

    /**
     * Encodes the specified MarkBookingAsPaidRequest message. Does not implicitly {@link MarkBookingAsPaidRequest.verify|verify} messages.
     * @function encode
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {IMarkBookingAsPaidRequest} message MarkBookingAsPaidRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarkBookingAsPaidRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bookingId != null && Object.hasOwnProperty.call(message, "bookingId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bookingId);
        if (message.paid != null && Object.hasOwnProperty.call(message, "paid"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.paid);
        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.note);
        return writer;
    };

    /**
     * Encodes the specified MarkBookingAsPaidRequest message, length delimited. Does not implicitly {@link MarkBookingAsPaidRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {IMarkBookingAsPaidRequest} message MarkBookingAsPaidRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarkBookingAsPaidRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarkBookingAsPaidRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarkBookingAsPaidRequest} MarkBookingAsPaidRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarkBookingAsPaidRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarkBookingAsPaidRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.bookingId = reader.string();
                    break;
                }
            case 2: {
                    message.paid = reader.bool();
                    break;
                }
            case 3: {
                    message.note = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarkBookingAsPaidRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarkBookingAsPaidRequest} MarkBookingAsPaidRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarkBookingAsPaidRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarkBookingAsPaidRequest message.
     * @function verify
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarkBookingAsPaidRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            if (!$util.isString(message.bookingId))
                return "bookingId: string expected";
        if (message.paid != null && message.hasOwnProperty("paid"))
            if (typeof message.paid !== "boolean")
                return "paid: boolean expected";
        if (message.note != null && message.hasOwnProperty("note"))
            if (!$util.isString(message.note))
                return "note: string expected";
        return null;
    };

    /**
     * Creates a MarkBookingAsPaidRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarkBookingAsPaidRequest} MarkBookingAsPaidRequest
     */
    MarkBookingAsPaidRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MarkBookingAsPaidRequest)
            return object;
        let message = new $root.MarkBookingAsPaidRequest();
        if (object.bookingId != null)
            message.bookingId = String(object.bookingId);
        if (object.paid != null)
            message.paid = Boolean(object.paid);
        if (object.note != null)
            message.note = String(object.note);
        return message;
    };

    /**
     * Creates a plain object from a MarkBookingAsPaidRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {MarkBookingAsPaidRequest} message MarkBookingAsPaidRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarkBookingAsPaidRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.bookingId = "";
            object.paid = false;
            object.note = "";
        }
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            object.bookingId = message.bookingId;
        if (message.paid != null && message.hasOwnProperty("paid"))
            object.paid = message.paid;
        if (message.note != null && message.hasOwnProperty("note"))
            object.note = message.note;
        return object;
    };

    /**
     * Converts this MarkBookingAsPaidRequest to JSON.
     * @function toJSON
     * @memberof MarkBookingAsPaidRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarkBookingAsPaidRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MarkBookingAsPaidRequest
     * @function getTypeUrl
     * @memberof MarkBookingAsPaidRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MarkBookingAsPaidRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MarkBookingAsPaidRequest";
    };

    return MarkBookingAsPaidRequest;
})();

export const MarkBookingAsPaidResponse = $root.MarkBookingAsPaidResponse = (() => {

    /**
     * Properties of a MarkBookingAsPaidResponse.
     * @exports IMarkBookingAsPaidResponse
     * @interface IMarkBookingAsPaidResponse
     * @property {boolean|null} [okay] MarkBookingAsPaidResponse okay
     * @property {space.kenko.proto.IApiBookingProto|null} [updatedBooking] MarkBookingAsPaidResponse updatedBooking
     */

    /**
     * Constructs a new MarkBookingAsPaidResponse.
     * @exports MarkBookingAsPaidResponse
     * @classdesc Represents a MarkBookingAsPaidResponse.
     * @implements IMarkBookingAsPaidResponse
     * @constructor
     * @param {IMarkBookingAsPaidResponse=} [properties] Properties to set
     */
    function MarkBookingAsPaidResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MarkBookingAsPaidResponse okay.
     * @member {boolean} okay
     * @memberof MarkBookingAsPaidResponse
     * @instance
     */
    MarkBookingAsPaidResponse.prototype.okay = false;

    /**
     * MarkBookingAsPaidResponse updatedBooking.
     * @member {space.kenko.proto.IApiBookingProto|null|undefined} updatedBooking
     * @memberof MarkBookingAsPaidResponse
     * @instance
     */
    MarkBookingAsPaidResponse.prototype.updatedBooking = null;

    /**
     * Creates a new MarkBookingAsPaidResponse instance using the specified properties.
     * @function create
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {IMarkBookingAsPaidResponse=} [properties] Properties to set
     * @returns {MarkBookingAsPaidResponse} MarkBookingAsPaidResponse instance
     */
    MarkBookingAsPaidResponse.create = function create(properties) {
        return new MarkBookingAsPaidResponse(properties);
    };

    /**
     * Encodes the specified MarkBookingAsPaidResponse message. Does not implicitly {@link MarkBookingAsPaidResponse.verify|verify} messages.
     * @function encode
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {IMarkBookingAsPaidResponse} message MarkBookingAsPaidResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarkBookingAsPaidResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.updatedBooking != null && Object.hasOwnProperty.call(message, "updatedBooking"))
            $root.space.kenko.proto.ApiBookingProto.encode(message.updatedBooking, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MarkBookingAsPaidResponse message, length delimited. Does not implicitly {@link MarkBookingAsPaidResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {IMarkBookingAsPaidResponse} message MarkBookingAsPaidResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MarkBookingAsPaidResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MarkBookingAsPaidResponse message from the specified reader or buffer.
     * @function decode
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MarkBookingAsPaidResponse} MarkBookingAsPaidResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarkBookingAsPaidResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MarkBookingAsPaidResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.updatedBooking = $root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MarkBookingAsPaidResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MarkBookingAsPaidResponse} MarkBookingAsPaidResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MarkBookingAsPaidResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MarkBookingAsPaidResponse message.
     * @function verify
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MarkBookingAsPaidResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.updatedBooking != null && message.hasOwnProperty("updatedBooking")) {
            let error = $root.space.kenko.proto.ApiBookingProto.verify(message.updatedBooking);
            if (error)
                return "updatedBooking." + error;
        }
        return null;
    };

    /**
     * Creates a MarkBookingAsPaidResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MarkBookingAsPaidResponse} MarkBookingAsPaidResponse
     */
    MarkBookingAsPaidResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.MarkBookingAsPaidResponse)
            return object;
        let message = new $root.MarkBookingAsPaidResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.updatedBooking != null) {
            if (typeof object.updatedBooking !== "object")
                throw TypeError(".MarkBookingAsPaidResponse.updatedBooking: object expected");
            message.updatedBooking = $root.space.kenko.proto.ApiBookingProto.fromObject(object.updatedBooking);
        }
        return message;
    };

    /**
     * Creates a plain object from a MarkBookingAsPaidResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {MarkBookingAsPaidResponse} message MarkBookingAsPaidResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MarkBookingAsPaidResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.okay = false;
            object.updatedBooking = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.updatedBooking != null && message.hasOwnProperty("updatedBooking"))
            object.updatedBooking = $root.space.kenko.proto.ApiBookingProto.toObject(message.updatedBooking, options);
        return object;
    };

    /**
     * Converts this MarkBookingAsPaidResponse to JSON.
     * @function toJSON
     * @memberof MarkBookingAsPaidResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MarkBookingAsPaidResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MarkBookingAsPaidResponse
     * @function getTypeUrl
     * @memberof MarkBookingAsPaidResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MarkBookingAsPaidResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MarkBookingAsPaidResponse";
    };

    return MarkBookingAsPaidResponse;
})();

export const GetClientInquiriesResponse = $root.GetClientInquiriesResponse = (() => {

    /**
     * Properties of a GetClientInquiriesResponse.
     * @exports IGetClientInquiriesResponse
     * @interface IGetClientInquiriesResponse
     * @property {boolean|null} [okay] GetClientInquiriesResponse okay
     * @property {Array.<IApiClientInquiryProto>|null} [inquiries] GetClientInquiriesResponse inquiries
     */

    /**
     * Constructs a new GetClientInquiriesResponse.
     * @exports GetClientInquiriesResponse
     * @classdesc Represents a GetClientInquiriesResponse.
     * @implements IGetClientInquiriesResponse
     * @constructor
     * @param {IGetClientInquiriesResponse=} [properties] Properties to set
     */
    function GetClientInquiriesResponse(properties) {
        this.inquiries = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetClientInquiriesResponse okay.
     * @member {boolean} okay
     * @memberof GetClientInquiriesResponse
     * @instance
     */
    GetClientInquiriesResponse.prototype.okay = false;

    /**
     * GetClientInquiriesResponse inquiries.
     * @member {Array.<IApiClientInquiryProto>} inquiries
     * @memberof GetClientInquiriesResponse
     * @instance
     */
    GetClientInquiriesResponse.prototype.inquiries = $util.emptyArray;

    /**
     * Creates a new GetClientInquiriesResponse instance using the specified properties.
     * @function create
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {IGetClientInquiriesResponse=} [properties] Properties to set
     * @returns {GetClientInquiriesResponse} GetClientInquiriesResponse instance
     */
    GetClientInquiriesResponse.create = function create(properties) {
        return new GetClientInquiriesResponse(properties);
    };

    /**
     * Encodes the specified GetClientInquiriesResponse message. Does not implicitly {@link GetClientInquiriesResponse.verify|verify} messages.
     * @function encode
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {IGetClientInquiriesResponse} message GetClientInquiriesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientInquiriesResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.inquiries != null && message.inquiries.length)
            for (let i = 0; i < message.inquiries.length; ++i)
                $root.ApiClientInquiryProto.encode(message.inquiries[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetClientInquiriesResponse message, length delimited. Does not implicitly {@link GetClientInquiriesResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {IGetClientInquiriesResponse} message GetClientInquiriesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetClientInquiriesResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetClientInquiriesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetClientInquiriesResponse} GetClientInquiriesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientInquiriesResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetClientInquiriesResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.inquiries && message.inquiries.length))
                        message.inquiries = [];
                    message.inquiries.push($root.ApiClientInquiryProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetClientInquiriesResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetClientInquiriesResponse} GetClientInquiriesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetClientInquiriesResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetClientInquiriesResponse message.
     * @function verify
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetClientInquiriesResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.inquiries != null && message.hasOwnProperty("inquiries")) {
            if (!Array.isArray(message.inquiries))
                return "inquiries: array expected";
            for (let i = 0; i < message.inquiries.length; ++i) {
                let error = $root.ApiClientInquiryProto.verify(message.inquiries[i]);
                if (error)
                    return "inquiries." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetClientInquiriesResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetClientInquiriesResponse} GetClientInquiriesResponse
     */
    GetClientInquiriesResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetClientInquiriesResponse)
            return object;
        let message = new $root.GetClientInquiriesResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.inquiries) {
            if (!Array.isArray(object.inquiries))
                throw TypeError(".GetClientInquiriesResponse.inquiries: array expected");
            message.inquiries = [];
            for (let i = 0; i < object.inquiries.length; ++i) {
                if (typeof object.inquiries[i] !== "object")
                    throw TypeError(".GetClientInquiriesResponse.inquiries: object expected");
                message.inquiries[i] = $root.ApiClientInquiryProto.fromObject(object.inquiries[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetClientInquiriesResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {GetClientInquiriesResponse} message GetClientInquiriesResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetClientInquiriesResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.inquiries = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.inquiries && message.inquiries.length) {
            object.inquiries = [];
            for (let j = 0; j < message.inquiries.length; ++j)
                object.inquiries[j] = $root.ApiClientInquiryProto.toObject(message.inquiries[j], options);
        }
        return object;
    };

    /**
     * Converts this GetClientInquiriesResponse to JSON.
     * @function toJSON
     * @memberof GetClientInquiriesResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetClientInquiriesResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetClientInquiriesResponse
     * @function getTypeUrl
     * @memberof GetClientInquiriesResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetClientInquiriesResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetClientInquiriesResponse";
    };

    return GetClientInquiriesResponse;
})();

export const AcceptClientInquiryRequest = $root.AcceptClientInquiryRequest = (() => {

    /**
     * Properties of an AcceptClientInquiryRequest.
     * @exports IAcceptClientInquiryRequest
     * @interface IAcceptClientInquiryRequest
     * @property {string|null} [userId] AcceptClientInquiryRequest userId
     * @property {boolean|null} [accept] AcceptClientInquiryRequest accept
     */

    /**
     * Constructs a new AcceptClientInquiryRequest.
     * @exports AcceptClientInquiryRequest
     * @classdesc Represents an AcceptClientInquiryRequest.
     * @implements IAcceptClientInquiryRequest
     * @constructor
     * @param {IAcceptClientInquiryRequest=} [properties] Properties to set
     */
    function AcceptClientInquiryRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AcceptClientInquiryRequest userId.
     * @member {string} userId
     * @memberof AcceptClientInquiryRequest
     * @instance
     */
    AcceptClientInquiryRequest.prototype.userId = "";

    /**
     * AcceptClientInquiryRequest accept.
     * @member {boolean} accept
     * @memberof AcceptClientInquiryRequest
     * @instance
     */
    AcceptClientInquiryRequest.prototype.accept = false;

    /**
     * Creates a new AcceptClientInquiryRequest instance using the specified properties.
     * @function create
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {IAcceptClientInquiryRequest=} [properties] Properties to set
     * @returns {AcceptClientInquiryRequest} AcceptClientInquiryRequest instance
     */
    AcceptClientInquiryRequest.create = function create(properties) {
        return new AcceptClientInquiryRequest(properties);
    };

    /**
     * Encodes the specified AcceptClientInquiryRequest message. Does not implicitly {@link AcceptClientInquiryRequest.verify|verify} messages.
     * @function encode
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {IAcceptClientInquiryRequest} message AcceptClientInquiryRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptClientInquiryRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
        if (message.accept != null && Object.hasOwnProperty.call(message, "accept"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.accept);
        return writer;
    };

    /**
     * Encodes the specified AcceptClientInquiryRequest message, length delimited. Does not implicitly {@link AcceptClientInquiryRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {IAcceptClientInquiryRequest} message AcceptClientInquiryRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptClientInquiryRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AcceptClientInquiryRequest message from the specified reader or buffer.
     * @function decode
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AcceptClientInquiryRequest} AcceptClientInquiryRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptClientInquiryRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AcceptClientInquiryRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.accept = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AcceptClientInquiryRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AcceptClientInquiryRequest} AcceptClientInquiryRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptClientInquiryRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AcceptClientInquiryRequest message.
     * @function verify
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AcceptClientInquiryRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.accept != null && message.hasOwnProperty("accept"))
            if (typeof message.accept !== "boolean")
                return "accept: boolean expected";
        return null;
    };

    /**
     * Creates an AcceptClientInquiryRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AcceptClientInquiryRequest} AcceptClientInquiryRequest
     */
    AcceptClientInquiryRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.AcceptClientInquiryRequest)
            return object;
        let message = new $root.AcceptClientInquiryRequest();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.accept != null)
            message.accept = Boolean(object.accept);
        return message;
    };

    /**
     * Creates a plain object from an AcceptClientInquiryRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {AcceptClientInquiryRequest} message AcceptClientInquiryRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AcceptClientInquiryRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.userId = "";
            object.accept = false;
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.accept != null && message.hasOwnProperty("accept"))
            object.accept = message.accept;
        return object;
    };

    /**
     * Converts this AcceptClientInquiryRequest to JSON.
     * @function toJSON
     * @memberof AcceptClientInquiryRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AcceptClientInquiryRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AcceptClientInquiryRequest
     * @function getTypeUrl
     * @memberof AcceptClientInquiryRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AcceptClientInquiryRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AcceptClientInquiryRequest";
    };

    return AcceptClientInquiryRequest;
})();

export const AcceptClientInquiryResponse = $root.AcceptClientInquiryResponse = (() => {

    /**
     * Properties of an AcceptClientInquiryResponse.
     * @exports IAcceptClientInquiryResponse
     * @interface IAcceptClientInquiryResponse
     * @property {boolean|null} [okay] AcceptClientInquiryResponse okay
     */

    /**
     * Constructs a new AcceptClientInquiryResponse.
     * @exports AcceptClientInquiryResponse
     * @classdesc Represents an AcceptClientInquiryResponse.
     * @implements IAcceptClientInquiryResponse
     * @constructor
     * @param {IAcceptClientInquiryResponse=} [properties] Properties to set
     */
    function AcceptClientInquiryResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AcceptClientInquiryResponse okay.
     * @member {boolean} okay
     * @memberof AcceptClientInquiryResponse
     * @instance
     */
    AcceptClientInquiryResponse.prototype.okay = false;

    /**
     * Creates a new AcceptClientInquiryResponse instance using the specified properties.
     * @function create
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {IAcceptClientInquiryResponse=} [properties] Properties to set
     * @returns {AcceptClientInquiryResponse} AcceptClientInquiryResponse instance
     */
    AcceptClientInquiryResponse.create = function create(properties) {
        return new AcceptClientInquiryResponse(properties);
    };

    /**
     * Encodes the specified AcceptClientInquiryResponse message. Does not implicitly {@link AcceptClientInquiryResponse.verify|verify} messages.
     * @function encode
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {IAcceptClientInquiryResponse} message AcceptClientInquiryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptClientInquiryResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        return writer;
    };

    /**
     * Encodes the specified AcceptClientInquiryResponse message, length delimited. Does not implicitly {@link AcceptClientInquiryResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {IAcceptClientInquiryResponse} message AcceptClientInquiryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AcceptClientInquiryResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AcceptClientInquiryResponse message from the specified reader or buffer.
     * @function decode
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AcceptClientInquiryResponse} AcceptClientInquiryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptClientInquiryResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AcceptClientInquiryResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AcceptClientInquiryResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AcceptClientInquiryResponse} AcceptClientInquiryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AcceptClientInquiryResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AcceptClientInquiryResponse message.
     * @function verify
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AcceptClientInquiryResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        return null;
    };

    /**
     * Creates an AcceptClientInquiryResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AcceptClientInquiryResponse} AcceptClientInquiryResponse
     */
    AcceptClientInquiryResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.AcceptClientInquiryResponse)
            return object;
        let message = new $root.AcceptClientInquiryResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        return message;
    };

    /**
     * Creates a plain object from an AcceptClientInquiryResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {AcceptClientInquiryResponse} message AcceptClientInquiryResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AcceptClientInquiryResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        return object;
    };

    /**
     * Converts this AcceptClientInquiryResponse to JSON.
     * @function toJSON
     * @memberof AcceptClientInquiryResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AcceptClientInquiryResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AcceptClientInquiryResponse
     * @function getTypeUrl
     * @memberof AcceptClientInquiryResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AcceptClientInquiryResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AcceptClientInquiryResponse";
    };

    return AcceptClientInquiryResponse;
})();

export const VerificationRequest = $root.VerificationRequest = (() => {

    /**
     * Properties of a VerificationRequest.
     * @exports IVerificationRequest
     * @interface IVerificationRequest
     * @property {EmailOrPhoneLocation|null} [location] VerificationRequest location
     * @property {space.kenko.proto.ContactMethodType|null} [type] VerificationRequest type
     * @property {string|null} [value] VerificationRequest value
     */

    /**
     * Constructs a new VerificationRequest.
     * @exports VerificationRequest
     * @classdesc Represents a VerificationRequest.
     * @implements IVerificationRequest
     * @constructor
     * @param {IVerificationRequest=} [properties] Properties to set
     */
    function VerificationRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * VerificationRequest location.
     * @member {EmailOrPhoneLocation} location
     * @memberof VerificationRequest
     * @instance
     */
    VerificationRequest.prototype.location = 0;

    /**
     * VerificationRequest type.
     * @member {space.kenko.proto.ContactMethodType} type
     * @memberof VerificationRequest
     * @instance
     */
    VerificationRequest.prototype.type = 0;

    /**
     * VerificationRequest value.
     * @member {string} value
     * @memberof VerificationRequest
     * @instance
     */
    VerificationRequest.prototype.value = "";

    /**
     * Creates a new VerificationRequest instance using the specified properties.
     * @function create
     * @memberof VerificationRequest
     * @static
     * @param {IVerificationRequest=} [properties] Properties to set
     * @returns {VerificationRequest} VerificationRequest instance
     */
    VerificationRequest.create = function create(properties) {
        return new VerificationRequest(properties);
    };

    /**
     * Encodes the specified VerificationRequest message. Does not implicitly {@link VerificationRequest.verify|verify} messages.
     * @function encode
     * @memberof VerificationRequest
     * @static
     * @param {IVerificationRequest} message VerificationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.location != null && Object.hasOwnProperty.call(message, "location"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.location);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.value);
        return writer;
    };

    /**
     * Encodes the specified VerificationRequest message, length delimited. Does not implicitly {@link VerificationRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof VerificationRequest
     * @static
     * @param {IVerificationRequest} message VerificationRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a VerificationRequest message from the specified reader or buffer.
     * @function decode
     * @memberof VerificationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {VerificationRequest} VerificationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.VerificationRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.location = reader.int32();
                    break;
                }
            case 2: {
                    message.type = reader.int32();
                    break;
                }
            case 3: {
                    message.value = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a VerificationRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof VerificationRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {VerificationRequest} VerificationRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a VerificationRequest message.
     * @function verify
     * @memberof VerificationRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    VerificationRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.location != null && message.hasOwnProperty("location"))
            switch (message.location) {
            default:
                return "location: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.type != null && message.hasOwnProperty("type"))
            switch (message.type) {
            default:
                return "type: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isString(message.value))
                return "value: string expected";
        return null;
    };

    /**
     * Creates a VerificationRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof VerificationRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {VerificationRequest} VerificationRequest
     */
    VerificationRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.VerificationRequest)
            return object;
        let message = new $root.VerificationRequest();
        switch (object.location) {
        default:
            if (typeof object.location === "number") {
                message.location = object.location;
                break;
            }
            break;
        case "UNKNOWN":
        case 0:
            message.location = 0;
            break;
        case "PROVIDER":
        case 1:
            message.location = 1;
            break;
        case "BUSINESS":
        case 2:
            message.location = 2;
            break;
        }
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "UNKNOWN":
        case 0:
            message.type = 0;
            break;
        case "EMAIL":
        case 1:
            message.type = 1;
            break;
        case "MOBILE_PHONE":
        case 2:
            message.type = 2;
            break;
        }
        if (object.value != null)
            message.value = String(object.value);
        return message;
    };

    /**
     * Creates a plain object from a VerificationRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof VerificationRequest
     * @static
     * @param {VerificationRequest} message VerificationRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VerificationRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.location = options.enums === String ? "UNKNOWN" : 0;
            object.type = options.enums === String ? "UNKNOWN" : 0;
            object.value = "";
        }
        if (message.location != null && message.hasOwnProperty("location"))
            object.location = options.enums === String ? $root.EmailOrPhoneLocation[message.location] === undefined ? message.location : $root.EmailOrPhoneLocation[message.location] : message.location;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.space.kenko.proto.ContactMethodType[message.type] === undefined ? message.type : $root.space.kenko.proto.ContactMethodType[message.type] : message.type;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    /**
     * Converts this VerificationRequest to JSON.
     * @function toJSON
     * @memberof VerificationRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VerificationRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for VerificationRequest
     * @function getTypeUrl
     * @memberof VerificationRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    VerificationRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/VerificationRequest";
    };

    return VerificationRequest;
})();

export const VerificationResponse = $root.VerificationResponse = (() => {

    /**
     * Properties of a VerificationResponse.
     * @exports IVerificationResponse
     * @interface IVerificationResponse
     * @property {boolean|null} [okay] VerificationResponse okay
     * @property {string|null} [error] VerificationResponse error
     * @property {IApiProviderProto|null} [updatedProvider] VerificationResponse updatedProvider
     * @property {IApiBusinessProto|null} [updatedBusiness] VerificationResponse updatedBusiness
     */

    /**
     * Constructs a new VerificationResponse.
     * @exports VerificationResponse
     * @classdesc Represents a VerificationResponse.
     * @implements IVerificationResponse
     * @constructor
     * @param {IVerificationResponse=} [properties] Properties to set
     */
    function VerificationResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * VerificationResponse okay.
     * @member {boolean} okay
     * @memberof VerificationResponse
     * @instance
     */
    VerificationResponse.prototype.okay = false;

    /**
     * VerificationResponse error.
     * @member {string} error
     * @memberof VerificationResponse
     * @instance
     */
    VerificationResponse.prototype.error = "";

    /**
     * VerificationResponse updatedProvider.
     * @member {IApiProviderProto|null|undefined} updatedProvider
     * @memberof VerificationResponse
     * @instance
     */
    VerificationResponse.prototype.updatedProvider = null;

    /**
     * VerificationResponse updatedBusiness.
     * @member {IApiBusinessProto|null|undefined} updatedBusiness
     * @memberof VerificationResponse
     * @instance
     */
    VerificationResponse.prototype.updatedBusiness = null;

    /**
     * Creates a new VerificationResponse instance using the specified properties.
     * @function create
     * @memberof VerificationResponse
     * @static
     * @param {IVerificationResponse=} [properties] Properties to set
     * @returns {VerificationResponse} VerificationResponse instance
     */
    VerificationResponse.create = function create(properties) {
        return new VerificationResponse(properties);
    };

    /**
     * Encodes the specified VerificationResponse message. Does not implicitly {@link VerificationResponse.verify|verify} messages.
     * @function encode
     * @memberof VerificationResponse
     * @static
     * @param {IVerificationResponse} message VerificationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.error != null && Object.hasOwnProperty.call(message, "error"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.error);
        if (message.updatedProvider != null && Object.hasOwnProperty.call(message, "updatedProvider"))
            $root.ApiProviderProto.encode(message.updatedProvider, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.updatedBusiness != null && Object.hasOwnProperty.call(message, "updatedBusiness"))
            $root.ApiBusinessProto.encode(message.updatedBusiness, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified VerificationResponse message, length delimited. Does not implicitly {@link VerificationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof VerificationResponse
     * @static
     * @param {IVerificationResponse} message VerificationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VerificationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a VerificationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof VerificationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {VerificationResponse} VerificationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.VerificationResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.error = reader.string();
                    break;
                }
            case 3: {
                    message.updatedProvider = $root.ApiProviderProto.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.updatedBusiness = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a VerificationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof VerificationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {VerificationResponse} VerificationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VerificationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a VerificationResponse message.
     * @function verify
     * @memberof VerificationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    VerificationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.error != null && message.hasOwnProperty("error"))
            if (!$util.isString(message.error))
                return "error: string expected";
        if (message.updatedProvider != null && message.hasOwnProperty("updatedProvider")) {
            let error = $root.ApiProviderProto.verify(message.updatedProvider);
            if (error)
                return "updatedProvider." + error;
        }
        if (message.updatedBusiness != null && message.hasOwnProperty("updatedBusiness")) {
            let error = $root.ApiBusinessProto.verify(message.updatedBusiness);
            if (error)
                return "updatedBusiness." + error;
        }
        return null;
    };

    /**
     * Creates a VerificationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof VerificationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {VerificationResponse} VerificationResponse
     */
    VerificationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.VerificationResponse)
            return object;
        let message = new $root.VerificationResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.error != null)
            message.error = String(object.error);
        if (object.updatedProvider != null) {
            if (typeof object.updatedProvider !== "object")
                throw TypeError(".VerificationResponse.updatedProvider: object expected");
            message.updatedProvider = $root.ApiProviderProto.fromObject(object.updatedProvider);
        }
        if (object.updatedBusiness != null) {
            if (typeof object.updatedBusiness !== "object")
                throw TypeError(".VerificationResponse.updatedBusiness: object expected");
            message.updatedBusiness = $root.ApiBusinessProto.fromObject(object.updatedBusiness);
        }
        return message;
    };

    /**
     * Creates a plain object from a VerificationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof VerificationResponse
     * @static
     * @param {VerificationResponse} message VerificationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VerificationResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.okay = false;
            object.error = "";
            object.updatedProvider = null;
            object.updatedBusiness = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.error != null && message.hasOwnProperty("error"))
            object.error = message.error;
        if (message.updatedProvider != null && message.hasOwnProperty("updatedProvider"))
            object.updatedProvider = $root.ApiProviderProto.toObject(message.updatedProvider, options);
        if (message.updatedBusiness != null && message.hasOwnProperty("updatedBusiness"))
            object.updatedBusiness = $root.ApiBusinessProto.toObject(message.updatedBusiness, options);
        return object;
    };

    /**
     * Converts this VerificationResponse to JSON.
     * @function toJSON
     * @memberof VerificationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VerificationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for VerificationResponse
     * @function getTypeUrl
     * @memberof VerificationResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    VerificationResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/VerificationResponse";
    };

    return VerificationResponse;
})();

export const GetEventsRequest = $root.GetEventsRequest = (() => {

    /**
     * Properties of a GetEventsRequest.
     * @exports IGetEventsRequest
     * @interface IGetEventsRequest
     * @property {string|null} [businessId] GetEventsRequest businessId
     * @property {number|Long|null} [startTimestampMs] GetEventsRequest startTimestampMs
     * @property {number|Long|null} [endTimestampMs] GetEventsRequest endTimestampMs
     */

    /**
     * Constructs a new GetEventsRequest.
     * @exports GetEventsRequest
     * @classdesc Represents a GetEventsRequest.
     * @implements IGetEventsRequest
     * @constructor
     * @param {IGetEventsRequest=} [properties] Properties to set
     */
    function GetEventsRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetEventsRequest businessId.
     * @member {string} businessId
     * @memberof GetEventsRequest
     * @instance
     */
    GetEventsRequest.prototype.businessId = "";

    /**
     * GetEventsRequest startTimestampMs.
     * @member {number|Long} startTimestampMs
     * @memberof GetEventsRequest
     * @instance
     */
    GetEventsRequest.prototype.startTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * GetEventsRequest endTimestampMs.
     * @member {number|Long} endTimestampMs
     * @memberof GetEventsRequest
     * @instance
     */
    GetEventsRequest.prototype.endTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new GetEventsRequest instance using the specified properties.
     * @function create
     * @memberof GetEventsRequest
     * @static
     * @param {IGetEventsRequest=} [properties] Properties to set
     * @returns {GetEventsRequest} GetEventsRequest instance
     */
    GetEventsRequest.create = function create(properties) {
        return new GetEventsRequest(properties);
    };

    /**
     * Encodes the specified GetEventsRequest message. Does not implicitly {@link GetEventsRequest.verify|verify} messages.
     * @function encode
     * @memberof GetEventsRequest
     * @static
     * @param {IGetEventsRequest} message GetEventsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetEventsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        if (message.startTimestampMs != null && Object.hasOwnProperty.call(message, "startTimestampMs"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.startTimestampMs);
        if (message.endTimestampMs != null && Object.hasOwnProperty.call(message, "endTimestampMs"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.endTimestampMs);
        return writer;
    };

    /**
     * Encodes the specified GetEventsRequest message, length delimited. Does not implicitly {@link GetEventsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetEventsRequest
     * @static
     * @param {IGetEventsRequest} message GetEventsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetEventsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetEventsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof GetEventsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetEventsRequest} GetEventsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetEventsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetEventsRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            case 3: {
                    message.startTimestampMs = reader.int64();
                    break;
                }
            case 4: {
                    message.endTimestampMs = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetEventsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetEventsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetEventsRequest} GetEventsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetEventsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetEventsRequest message.
     * @function verify
     * @memberof GetEventsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetEventsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        if (message.startTimestampMs != null && message.hasOwnProperty("startTimestampMs"))
            if (!$util.isInteger(message.startTimestampMs) && !(message.startTimestampMs && $util.isInteger(message.startTimestampMs.low) && $util.isInteger(message.startTimestampMs.high)))
                return "startTimestampMs: integer|Long expected";
        if (message.endTimestampMs != null && message.hasOwnProperty("endTimestampMs"))
            if (!$util.isInteger(message.endTimestampMs) && !(message.endTimestampMs && $util.isInteger(message.endTimestampMs.low) && $util.isInteger(message.endTimestampMs.high)))
                return "endTimestampMs: integer|Long expected";
        return null;
    };

    /**
     * Creates a GetEventsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetEventsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetEventsRequest} GetEventsRequest
     */
    GetEventsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.GetEventsRequest)
            return object;
        let message = new $root.GetEventsRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        if (object.startTimestampMs != null)
            if ($util.Long)
                (message.startTimestampMs = $util.Long.fromValue(object.startTimestampMs)).unsigned = false;
            else if (typeof object.startTimestampMs === "string")
                message.startTimestampMs = parseInt(object.startTimestampMs, 10);
            else if (typeof object.startTimestampMs === "number")
                message.startTimestampMs = object.startTimestampMs;
            else if (typeof object.startTimestampMs === "object")
                message.startTimestampMs = new $util.LongBits(object.startTimestampMs.low >>> 0, object.startTimestampMs.high >>> 0).toNumber();
        if (object.endTimestampMs != null)
            if ($util.Long)
                (message.endTimestampMs = $util.Long.fromValue(object.endTimestampMs)).unsigned = false;
            else if (typeof object.endTimestampMs === "string")
                message.endTimestampMs = parseInt(object.endTimestampMs, 10);
            else if (typeof object.endTimestampMs === "number")
                message.endTimestampMs = object.endTimestampMs;
            else if (typeof object.endTimestampMs === "object")
                message.endTimestampMs = new $util.LongBits(object.endTimestampMs.low >>> 0, object.endTimestampMs.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a GetEventsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetEventsRequest
     * @static
     * @param {GetEventsRequest} message GetEventsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetEventsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.businessId = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.startTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.startTimestampMs = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.endTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.endTimestampMs = options.longs === String ? "0" : 0;
        }
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        if (message.startTimestampMs != null && message.hasOwnProperty("startTimestampMs"))
            if (typeof message.startTimestampMs === "number")
                object.startTimestampMs = options.longs === String ? String(message.startTimestampMs) : message.startTimestampMs;
            else
                object.startTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.startTimestampMs) : options.longs === Number ? new $util.LongBits(message.startTimestampMs.low >>> 0, message.startTimestampMs.high >>> 0).toNumber() : message.startTimestampMs;
        if (message.endTimestampMs != null && message.hasOwnProperty("endTimestampMs"))
            if (typeof message.endTimestampMs === "number")
                object.endTimestampMs = options.longs === String ? String(message.endTimestampMs) : message.endTimestampMs;
            else
                object.endTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.endTimestampMs) : options.longs === Number ? new $util.LongBits(message.endTimestampMs.low >>> 0, message.endTimestampMs.high >>> 0).toNumber() : message.endTimestampMs;
        return object;
    };

    /**
     * Converts this GetEventsRequest to JSON.
     * @function toJSON
     * @memberof GetEventsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetEventsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetEventsRequest
     * @function getTypeUrl
     * @memberof GetEventsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetEventsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetEventsRequest";
    };

    return GetEventsRequest;
})();

export const GetEventsResponse = $root.GetEventsResponse = (() => {

    /**
     * Properties of a GetEventsResponse.
     * @exports IGetEventsResponse
     * @interface IGetEventsResponse
     * @property {boolean|null} [okay] GetEventsResponse okay
     * @property {Array.<IKensuCalendarEventProto>|null} [events] GetEventsResponse events
     */

    /**
     * Constructs a new GetEventsResponse.
     * @exports GetEventsResponse
     * @classdesc Represents a GetEventsResponse.
     * @implements IGetEventsResponse
     * @constructor
     * @param {IGetEventsResponse=} [properties] Properties to set
     */
    function GetEventsResponse(properties) {
        this.events = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetEventsResponse okay.
     * @member {boolean} okay
     * @memberof GetEventsResponse
     * @instance
     */
    GetEventsResponse.prototype.okay = false;

    /**
     * GetEventsResponse events.
     * @member {Array.<IKensuCalendarEventProto>} events
     * @memberof GetEventsResponse
     * @instance
     */
    GetEventsResponse.prototype.events = $util.emptyArray;

    /**
     * Creates a new GetEventsResponse instance using the specified properties.
     * @function create
     * @memberof GetEventsResponse
     * @static
     * @param {IGetEventsResponse=} [properties] Properties to set
     * @returns {GetEventsResponse} GetEventsResponse instance
     */
    GetEventsResponse.create = function create(properties) {
        return new GetEventsResponse(properties);
    };

    /**
     * Encodes the specified GetEventsResponse message. Does not implicitly {@link GetEventsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetEventsResponse
     * @static
     * @param {IGetEventsResponse} message GetEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetEventsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.events != null && message.events.length)
            for (let i = 0; i < message.events.length; ++i)
                $root.KensuCalendarEventProto.encode(message.events[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetEventsResponse message, length delimited. Does not implicitly {@link GetEventsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetEventsResponse
     * @static
     * @param {IGetEventsResponse} message GetEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetEventsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetEventsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetEventsResponse} GetEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetEventsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetEventsResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.events && message.events.length))
                        message.events = [];
                    message.events.push($root.KensuCalendarEventProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetEventsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetEventsResponse} GetEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetEventsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetEventsResponse message.
     * @function verify
     * @memberof GetEventsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetEventsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.events != null && message.hasOwnProperty("events")) {
            if (!Array.isArray(message.events))
                return "events: array expected";
            for (let i = 0; i < message.events.length; ++i) {
                let error = $root.KensuCalendarEventProto.verify(message.events[i]);
                if (error)
                    return "events." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetEventsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetEventsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetEventsResponse} GetEventsResponse
     */
    GetEventsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetEventsResponse)
            return object;
        let message = new $root.GetEventsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.events) {
            if (!Array.isArray(object.events))
                throw TypeError(".GetEventsResponse.events: array expected");
            message.events = [];
            for (let i = 0; i < object.events.length; ++i) {
                if (typeof object.events[i] !== "object")
                    throw TypeError(".GetEventsResponse.events: object expected");
                message.events[i] = $root.KensuCalendarEventProto.fromObject(object.events[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetEventsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetEventsResponse
     * @static
     * @param {GetEventsResponse} message GetEventsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetEventsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.events = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.events && message.events.length) {
            object.events = [];
            for (let j = 0; j < message.events.length; ++j)
                object.events[j] = $root.KensuCalendarEventProto.toObject(message.events[j], options);
        }
        return object;
    };

    /**
     * Converts this GetEventsResponse to JSON.
     * @function toJSON
     * @memberof GetEventsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetEventsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for GetEventsResponse
     * @function getTypeUrl
     * @memberof GetEventsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    GetEventsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetEventsResponse";
    };

    return GetEventsResponse;
})();

export const KensuCalendarEventProto = $root.KensuCalendarEventProto = (() => {

    /**
     * Properties of a KensuCalendarEventProto.
     * @exports IKensuCalendarEventProto
     * @interface IKensuCalendarEventProto
     * @property {string|null} [id] KensuCalendarEventProto id
     * @property {string|null} [timeZoneId] KensuCalendarEventProto timeZoneId
     * @property {number|Long|null} [startTimestamp] KensuCalendarEventProto startTimestamp
     * @property {number|Long|null} [endTimestamp] KensuCalendarEventProto endTimestamp
     * @property {IAvailabilityEventProto|null} [availability] KensuCalendarEventProto availability
     * @property {IAppointmentEventProto|null} [appointment] KensuCalendarEventProto appointment
     * @property {IClassEventProto|null} ["class"] KensuCalendarEventProto class
     * @property {IClassBookingProto|null} [classBooking] KensuCalendarEventProto classBooking
     */

    /**
     * Constructs a new KensuCalendarEventProto.
     * @exports KensuCalendarEventProto
     * @classdesc The new monolith; containing everything that is represented on a calendar.
     * One instance of this correspond to one box on the calendar.
     * 
     * EventInstanceProto2 is no longer the API for the client calendar because
     * bookings are stored outside the Calendar system. (The reason for this is
     * we need a top-level booking entity for easy querying on a per-client basis).
     * 
     * This means we need a new client wrapper that is agnostic of
     * EventInstanceProto2, that can work with CalendarService-type entities and
     * other top level entities.
     * @implements IKensuCalendarEventProto
     * @constructor
     * @param {IKensuCalendarEventProto=} [properties] Properties to set
     */
    function KensuCalendarEventProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * KensuCalendarEventProto id.
     * @member {string} id
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype.id = "";

    /**
     * KensuCalendarEventProto timeZoneId.
     * @member {string} timeZoneId
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype.timeZoneId = "";

    /**
     * KensuCalendarEventProto startTimestamp.
     * @member {number|Long} startTimestamp
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype.startTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * KensuCalendarEventProto endTimestamp.
     * @member {number|Long} endTimestamp
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype.endTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * KensuCalendarEventProto availability.
     * @member {IAvailabilityEventProto|null|undefined} availability
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype.availability = null;

    /**
     * KensuCalendarEventProto appointment.
     * @member {IAppointmentEventProto|null|undefined} appointment
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype.appointment = null;

    /**
     * KensuCalendarEventProto class.
     * @member {IClassEventProto|null|undefined} class
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype["class"] = null;

    /**
     * KensuCalendarEventProto classBooking.
     * @member {IClassBookingProto|null|undefined} classBooking
     * @memberof KensuCalendarEventProto
     * @instance
     */
    KensuCalendarEventProto.prototype.classBooking = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * KensuCalendarEventProto Type.
     * @member {"availability"|"appointment"|"class"|"classBooking"|undefined} Type
     * @memberof KensuCalendarEventProto
     * @instance
     */
    Object.defineProperty(KensuCalendarEventProto.prototype, "Type", {
        get: $util.oneOfGetter($oneOfFields = ["availability", "appointment", "class", "classBooking"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new KensuCalendarEventProto instance using the specified properties.
     * @function create
     * @memberof KensuCalendarEventProto
     * @static
     * @param {IKensuCalendarEventProto=} [properties] Properties to set
     * @returns {KensuCalendarEventProto} KensuCalendarEventProto instance
     */
    KensuCalendarEventProto.create = function create(properties) {
        return new KensuCalendarEventProto(properties);
    };

    /**
     * Encodes the specified KensuCalendarEventProto message. Does not implicitly {@link KensuCalendarEventProto.verify|verify} messages.
     * @function encode
     * @memberof KensuCalendarEventProto
     * @static
     * @param {IKensuCalendarEventProto} message KensuCalendarEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KensuCalendarEventProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
        if (message.timeZoneId != null && Object.hasOwnProperty.call(message, "timeZoneId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.timeZoneId);
        if (message.startTimestamp != null && Object.hasOwnProperty.call(message, "startTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.startTimestamp);
        if (message.endTimestamp != null && Object.hasOwnProperty.call(message, "endTimestamp"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.endTimestamp);
        if (message.availability != null && Object.hasOwnProperty.call(message, "availability"))
            $root.AvailabilityEventProto.encode(message.availability, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.appointment != null && Object.hasOwnProperty.call(message, "appointment"))
            $root.AppointmentEventProto.encode(message.appointment, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message["class"] != null && Object.hasOwnProperty.call(message, "class"))
            $root.ClassEventProto.encode(message["class"], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.classBooking != null && Object.hasOwnProperty.call(message, "classBooking"))
            $root.ClassBookingProto.encode(message.classBooking, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified KensuCalendarEventProto message, length delimited. Does not implicitly {@link KensuCalendarEventProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof KensuCalendarEventProto
     * @static
     * @param {IKensuCalendarEventProto} message KensuCalendarEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KensuCalendarEventProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a KensuCalendarEventProto message from the specified reader or buffer.
     * @function decode
     * @memberof KensuCalendarEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {KensuCalendarEventProto} KensuCalendarEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KensuCalendarEventProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.KensuCalendarEventProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.timeZoneId = reader.string();
                    break;
                }
            case 3: {
                    message.startTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.endTimestamp = reader.int64();
                    break;
                }
            case 10: {
                    message.availability = $root.AvailabilityEventProto.decode(reader, reader.uint32());
                    break;
                }
            case 11: {
                    message.appointment = $root.AppointmentEventProto.decode(reader, reader.uint32());
                    break;
                }
            case 12: {
                    message["class"] = $root.ClassEventProto.decode(reader, reader.uint32());
                    break;
                }
            case 13: {
                    message.classBooking = $root.ClassBookingProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a KensuCalendarEventProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof KensuCalendarEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {KensuCalendarEventProto} KensuCalendarEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KensuCalendarEventProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a KensuCalendarEventProto message.
     * @function verify
     * @memberof KensuCalendarEventProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    KensuCalendarEventProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        let properties = {};
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
            if (!$util.isString(message.timeZoneId))
                return "timeZoneId: string expected";
        if (message.startTimestamp != null && message.hasOwnProperty("startTimestamp"))
            if (!$util.isInteger(message.startTimestamp) && !(message.startTimestamp && $util.isInteger(message.startTimestamp.low) && $util.isInteger(message.startTimestamp.high)))
                return "startTimestamp: integer|Long expected";
        if (message.endTimestamp != null && message.hasOwnProperty("endTimestamp"))
            if (!$util.isInteger(message.endTimestamp) && !(message.endTimestamp && $util.isInteger(message.endTimestamp.low) && $util.isInteger(message.endTimestamp.high)))
                return "endTimestamp: integer|Long expected";
        if (message.availability != null && message.hasOwnProperty("availability")) {
            properties.Type = 1;
            {
                let error = $root.AvailabilityEventProto.verify(message.availability);
                if (error)
                    return "availability." + error;
            }
        }
        if (message.appointment != null && message.hasOwnProperty("appointment")) {
            if (properties.Type === 1)
                return "Type: multiple values";
            properties.Type = 1;
            {
                let error = $root.AppointmentEventProto.verify(message.appointment);
                if (error)
                    return "appointment." + error;
            }
        }
        if (message["class"] != null && message.hasOwnProperty("class")) {
            if (properties.Type === 1)
                return "Type: multiple values";
            properties.Type = 1;
            {
                let error = $root.ClassEventProto.verify(message["class"]);
                if (error)
                    return "class." + error;
            }
        }
        if (message.classBooking != null && message.hasOwnProperty("classBooking")) {
            if (properties.Type === 1)
                return "Type: multiple values";
            properties.Type = 1;
            {
                let error = $root.ClassBookingProto.verify(message.classBooking);
                if (error)
                    return "classBooking." + error;
            }
        }
        return null;
    };

    /**
     * Creates a KensuCalendarEventProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof KensuCalendarEventProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {KensuCalendarEventProto} KensuCalendarEventProto
     */
    KensuCalendarEventProto.fromObject = function fromObject(object) {
        if (object instanceof $root.KensuCalendarEventProto)
            return object;
        let message = new $root.KensuCalendarEventProto();
        if (object.id != null)
            message.id = String(object.id);
        if (object.timeZoneId != null)
            message.timeZoneId = String(object.timeZoneId);
        if (object.startTimestamp != null)
            if ($util.Long)
                (message.startTimestamp = $util.Long.fromValue(object.startTimestamp)).unsigned = false;
            else if (typeof object.startTimestamp === "string")
                message.startTimestamp = parseInt(object.startTimestamp, 10);
            else if (typeof object.startTimestamp === "number")
                message.startTimestamp = object.startTimestamp;
            else if (typeof object.startTimestamp === "object")
                message.startTimestamp = new $util.LongBits(object.startTimestamp.low >>> 0, object.startTimestamp.high >>> 0).toNumber();
        if (object.endTimestamp != null)
            if ($util.Long)
                (message.endTimestamp = $util.Long.fromValue(object.endTimestamp)).unsigned = false;
            else if (typeof object.endTimestamp === "string")
                message.endTimestamp = parseInt(object.endTimestamp, 10);
            else if (typeof object.endTimestamp === "number")
                message.endTimestamp = object.endTimestamp;
            else if (typeof object.endTimestamp === "object")
                message.endTimestamp = new $util.LongBits(object.endTimestamp.low >>> 0, object.endTimestamp.high >>> 0).toNumber();
        if (object.availability != null) {
            if (typeof object.availability !== "object")
                throw TypeError(".KensuCalendarEventProto.availability: object expected");
            message.availability = $root.AvailabilityEventProto.fromObject(object.availability);
        }
        if (object.appointment != null) {
            if (typeof object.appointment !== "object")
                throw TypeError(".KensuCalendarEventProto.appointment: object expected");
            message.appointment = $root.AppointmentEventProto.fromObject(object.appointment);
        }
        if (object["class"] != null) {
            if (typeof object["class"] !== "object")
                throw TypeError(".KensuCalendarEventProto.class: object expected");
            message["class"] = $root.ClassEventProto.fromObject(object["class"]);
        }
        if (object.classBooking != null) {
            if (typeof object.classBooking !== "object")
                throw TypeError(".KensuCalendarEventProto.classBooking: object expected");
            message.classBooking = $root.ClassBookingProto.fromObject(object.classBooking);
        }
        return message;
    };

    /**
     * Creates a plain object from a KensuCalendarEventProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof KensuCalendarEventProto
     * @static
     * @param {KensuCalendarEventProto} message KensuCalendarEventProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    KensuCalendarEventProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = "";
            object.timeZoneId = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.startTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.startTimestamp = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.endTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.endTimestamp = options.longs === String ? "0" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.timeZoneId != null && message.hasOwnProperty("timeZoneId"))
            object.timeZoneId = message.timeZoneId;
        if (message.startTimestamp != null && message.hasOwnProperty("startTimestamp"))
            if (typeof message.startTimestamp === "number")
                object.startTimestamp = options.longs === String ? String(message.startTimestamp) : message.startTimestamp;
            else
                object.startTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.startTimestamp) : options.longs === Number ? new $util.LongBits(message.startTimestamp.low >>> 0, message.startTimestamp.high >>> 0).toNumber() : message.startTimestamp;
        if (message.endTimestamp != null && message.hasOwnProperty("endTimestamp"))
            if (typeof message.endTimestamp === "number")
                object.endTimestamp = options.longs === String ? String(message.endTimestamp) : message.endTimestamp;
            else
                object.endTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.endTimestamp) : options.longs === Number ? new $util.LongBits(message.endTimestamp.low >>> 0, message.endTimestamp.high >>> 0).toNumber() : message.endTimestamp;
        if (message.availability != null && message.hasOwnProperty("availability")) {
            object.availability = $root.AvailabilityEventProto.toObject(message.availability, options);
            if (options.oneofs)
                object.Type = "availability";
        }
        if (message.appointment != null && message.hasOwnProperty("appointment")) {
            object.appointment = $root.AppointmentEventProto.toObject(message.appointment, options);
            if (options.oneofs)
                object.Type = "appointment";
        }
        if (message["class"] != null && message.hasOwnProperty("class")) {
            object["class"] = $root.ClassEventProto.toObject(message["class"], options);
            if (options.oneofs)
                object.Type = "class";
        }
        if (message.classBooking != null && message.hasOwnProperty("classBooking")) {
            object.classBooking = $root.ClassBookingProto.toObject(message.classBooking, options);
            if (options.oneofs)
                object.Type = "classBooking";
        }
        return object;
    };

    /**
     * Converts this KensuCalendarEventProto to JSON.
     * @function toJSON
     * @memberof KensuCalendarEventProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    KensuCalendarEventProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for KensuCalendarEventProto
     * @function getTypeUrl
     * @memberof KensuCalendarEventProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    KensuCalendarEventProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/KensuCalendarEventProto";
    };

    return KensuCalendarEventProto;
})();

export const AvailabilityEventProto = $root.AvailabilityEventProto = (() => {

    /**
     * Properties of an AvailabilityEventProto.
     * @exports IAvailabilityEventProto
     * @interface IAvailabilityEventProto
     * @property {space.kenko.proto.IAvailabilityEventType|null} [details] AvailabilityEventProto details
     * @property {space.kenko.proto.IRepeatStrategyProto|null} [repeatStrategy] AvailabilityEventProto repeatStrategy
     */

    /**
     * Constructs a new AvailabilityEventProto.
     * @exports AvailabilityEventProto
     * @classdesc Represents an AvailabilityEventProto.
     * @implements IAvailabilityEventProto
     * @constructor
     * @param {IAvailabilityEventProto=} [properties] Properties to set
     */
    function AvailabilityEventProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AvailabilityEventProto details.
     * @member {space.kenko.proto.IAvailabilityEventType|null|undefined} details
     * @memberof AvailabilityEventProto
     * @instance
     */
    AvailabilityEventProto.prototype.details = null;

    /**
     * AvailabilityEventProto repeatStrategy.
     * @member {space.kenko.proto.IRepeatStrategyProto|null|undefined} repeatStrategy
     * @memberof AvailabilityEventProto
     * @instance
     */
    AvailabilityEventProto.prototype.repeatStrategy = null;

    /**
     * Creates a new AvailabilityEventProto instance using the specified properties.
     * @function create
     * @memberof AvailabilityEventProto
     * @static
     * @param {IAvailabilityEventProto=} [properties] Properties to set
     * @returns {AvailabilityEventProto} AvailabilityEventProto instance
     */
    AvailabilityEventProto.create = function create(properties) {
        return new AvailabilityEventProto(properties);
    };

    /**
     * Encodes the specified AvailabilityEventProto message. Does not implicitly {@link AvailabilityEventProto.verify|verify} messages.
     * @function encode
     * @memberof AvailabilityEventProto
     * @static
     * @param {IAvailabilityEventProto} message AvailabilityEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AvailabilityEventProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.space.kenko.proto.AvailabilityEventType.encode(message.details, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.repeatStrategy != null && Object.hasOwnProperty.call(message, "repeatStrategy"))
            $root.space.kenko.proto.RepeatStrategyProto.encode(message.repeatStrategy, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AvailabilityEventProto message, length delimited. Does not implicitly {@link AvailabilityEventProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AvailabilityEventProto
     * @static
     * @param {IAvailabilityEventProto} message AvailabilityEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AvailabilityEventProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AvailabilityEventProto message from the specified reader or buffer.
     * @function decode
     * @memberof AvailabilityEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AvailabilityEventProto} AvailabilityEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AvailabilityEventProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AvailabilityEventProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.details = $root.space.kenko.proto.AvailabilityEventType.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AvailabilityEventProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AvailabilityEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AvailabilityEventProto} AvailabilityEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AvailabilityEventProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AvailabilityEventProto message.
     * @function verify
     * @memberof AvailabilityEventProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AvailabilityEventProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            let error = $root.space.kenko.proto.AvailabilityEventType.verify(message.details);
            if (error)
                return "details." + error;
        }
        if (message.repeatStrategy != null && message.hasOwnProperty("repeatStrategy")) {
            let error = $root.space.kenko.proto.RepeatStrategyProto.verify(message.repeatStrategy);
            if (error)
                return "repeatStrategy." + error;
        }
        return null;
    };

    /**
     * Creates an AvailabilityEventProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AvailabilityEventProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AvailabilityEventProto} AvailabilityEventProto
     */
    AvailabilityEventProto.fromObject = function fromObject(object) {
        if (object instanceof $root.AvailabilityEventProto)
            return object;
        let message = new $root.AvailabilityEventProto();
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".AvailabilityEventProto.details: object expected");
            message.details = $root.space.kenko.proto.AvailabilityEventType.fromObject(object.details);
        }
        if (object.repeatStrategy != null) {
            if (typeof object.repeatStrategy !== "object")
                throw TypeError(".AvailabilityEventProto.repeatStrategy: object expected");
            message.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.fromObject(object.repeatStrategy);
        }
        return message;
    };

    /**
     * Creates a plain object from an AvailabilityEventProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AvailabilityEventProto
     * @static
     * @param {AvailabilityEventProto} message AvailabilityEventProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AvailabilityEventProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.details = null;
            object.repeatStrategy = null;
        }
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.space.kenko.proto.AvailabilityEventType.toObject(message.details, options);
        if (message.repeatStrategy != null && message.hasOwnProperty("repeatStrategy"))
            object.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.toObject(message.repeatStrategy, options);
        return object;
    };

    /**
     * Converts this AvailabilityEventProto to JSON.
     * @function toJSON
     * @memberof AvailabilityEventProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AvailabilityEventProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AvailabilityEventProto
     * @function getTypeUrl
     * @memberof AvailabilityEventProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AvailabilityEventProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AvailabilityEventProto";
    };

    return AvailabilityEventProto;
})();

export const AppointmentEventProto = $root.AppointmentEventProto = (() => {

    /**
     * Properties of an AppointmentEventProto.
     * @exports IAppointmentEventProto
     * @interface IAppointmentEventProto
     * @property {space.kenko.proto.IApiBookingProto|null} [booking] AppointmentEventProto booking
     */

    /**
     * Constructs a new AppointmentEventProto.
     * @exports AppointmentEventProto
     * @classdesc Represents an AppointmentEventProto.
     * @implements IAppointmentEventProto
     * @constructor
     * @param {IAppointmentEventProto=} [properties] Properties to set
     */
    function AppointmentEventProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AppointmentEventProto booking.
     * @member {space.kenko.proto.IApiBookingProto|null|undefined} booking
     * @memberof AppointmentEventProto
     * @instance
     */
    AppointmentEventProto.prototype.booking = null;

    /**
     * Creates a new AppointmentEventProto instance using the specified properties.
     * @function create
     * @memberof AppointmentEventProto
     * @static
     * @param {IAppointmentEventProto=} [properties] Properties to set
     * @returns {AppointmentEventProto} AppointmentEventProto instance
     */
    AppointmentEventProto.create = function create(properties) {
        return new AppointmentEventProto(properties);
    };

    /**
     * Encodes the specified AppointmentEventProto message. Does not implicitly {@link AppointmentEventProto.verify|verify} messages.
     * @function encode
     * @memberof AppointmentEventProto
     * @static
     * @param {IAppointmentEventProto} message AppointmentEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentEventProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.booking != null && Object.hasOwnProperty.call(message, "booking"))
            $root.space.kenko.proto.ApiBookingProto.encode(message.booking, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AppointmentEventProto message, length delimited. Does not implicitly {@link AppointmentEventProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AppointmentEventProto
     * @static
     * @param {IAppointmentEventProto} message AppointmentEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AppointmentEventProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AppointmentEventProto message from the specified reader or buffer.
     * @function decode
     * @memberof AppointmentEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AppointmentEventProto} AppointmentEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentEventProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.AppointmentEventProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.booking = $root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AppointmentEventProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AppointmentEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AppointmentEventProto} AppointmentEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AppointmentEventProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AppointmentEventProto message.
     * @function verify
     * @memberof AppointmentEventProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AppointmentEventProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.booking != null && message.hasOwnProperty("booking")) {
            let error = $root.space.kenko.proto.ApiBookingProto.verify(message.booking);
            if (error)
                return "booking." + error;
        }
        return null;
    };

    /**
     * Creates an AppointmentEventProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AppointmentEventProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AppointmentEventProto} AppointmentEventProto
     */
    AppointmentEventProto.fromObject = function fromObject(object) {
        if (object instanceof $root.AppointmentEventProto)
            return object;
        let message = new $root.AppointmentEventProto();
        if (object.booking != null) {
            if (typeof object.booking !== "object")
                throw TypeError(".AppointmentEventProto.booking: object expected");
            message.booking = $root.space.kenko.proto.ApiBookingProto.fromObject(object.booking);
        }
        return message;
    };

    /**
     * Creates a plain object from an AppointmentEventProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AppointmentEventProto
     * @static
     * @param {AppointmentEventProto} message AppointmentEventProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AppointmentEventProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.booking = null;
        if (message.booking != null && message.hasOwnProperty("booking"))
            object.booking = $root.space.kenko.proto.ApiBookingProto.toObject(message.booking, options);
        return object;
    };

    /**
     * Converts this AppointmentEventProto to JSON.
     * @function toJSON
     * @memberof AppointmentEventProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AppointmentEventProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for AppointmentEventProto
     * @function getTypeUrl
     * @memberof AppointmentEventProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    AppointmentEventProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/AppointmentEventProto";
    };

    return AppointmentEventProto;
})();

export const ClassEventProto = $root.ClassEventProto = (() => {

    /**
     * Properties of a ClassEventProto.
     * @exports IClassEventProto
     * @interface IClassEventProto
     * @property {space.kenko.proto.IClassEventType|null} [details] ClassEventProto details
     * @property {space.kenko.proto.IRepeatStrategyProto|null} [repeatStrategy] ClassEventProto repeatStrategy
     */

    /**
     * Constructs a new ClassEventProto.
     * @exports ClassEventProto
     * @classdesc Represents a ClassEventProto.
     * @implements IClassEventProto
     * @constructor
     * @param {IClassEventProto=} [properties] Properties to set
     */
    function ClassEventProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClassEventProto details.
     * @member {space.kenko.proto.IClassEventType|null|undefined} details
     * @memberof ClassEventProto
     * @instance
     */
    ClassEventProto.prototype.details = null;

    /**
     * ClassEventProto repeatStrategy.
     * @member {space.kenko.proto.IRepeatStrategyProto|null|undefined} repeatStrategy
     * @memberof ClassEventProto
     * @instance
     */
    ClassEventProto.prototype.repeatStrategy = null;

    /**
     * Creates a new ClassEventProto instance using the specified properties.
     * @function create
     * @memberof ClassEventProto
     * @static
     * @param {IClassEventProto=} [properties] Properties to set
     * @returns {ClassEventProto} ClassEventProto instance
     */
    ClassEventProto.create = function create(properties) {
        return new ClassEventProto(properties);
    };

    /**
     * Encodes the specified ClassEventProto message. Does not implicitly {@link ClassEventProto.verify|verify} messages.
     * @function encode
     * @memberof ClassEventProto
     * @static
     * @param {IClassEventProto} message ClassEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassEventProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            $root.space.kenko.proto.ClassEventType.encode(message.details, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.repeatStrategy != null && Object.hasOwnProperty.call(message, "repeatStrategy"))
            $root.space.kenko.proto.RepeatStrategyProto.encode(message.repeatStrategy, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClassEventProto message, length delimited. Does not implicitly {@link ClassEventProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClassEventProto
     * @static
     * @param {IClassEventProto} message ClassEventProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassEventProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClassEventProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClassEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClassEventProto} ClassEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassEventProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClassEventProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.details = $root.space.kenko.proto.ClassEventType.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClassEventProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClassEventProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClassEventProto} ClassEventProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassEventProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClassEventProto message.
     * @function verify
     * @memberof ClassEventProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClassEventProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.details != null && message.hasOwnProperty("details")) {
            let error = $root.space.kenko.proto.ClassEventType.verify(message.details);
            if (error)
                return "details." + error;
        }
        if (message.repeatStrategy != null && message.hasOwnProperty("repeatStrategy")) {
            let error = $root.space.kenko.proto.RepeatStrategyProto.verify(message.repeatStrategy);
            if (error)
                return "repeatStrategy." + error;
        }
        return null;
    };

    /**
     * Creates a ClassEventProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClassEventProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClassEventProto} ClassEventProto
     */
    ClassEventProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClassEventProto)
            return object;
        let message = new $root.ClassEventProto();
        if (object.details != null) {
            if (typeof object.details !== "object")
                throw TypeError(".ClassEventProto.details: object expected");
            message.details = $root.space.kenko.proto.ClassEventType.fromObject(object.details);
        }
        if (object.repeatStrategy != null) {
            if (typeof object.repeatStrategy !== "object")
                throw TypeError(".ClassEventProto.repeatStrategy: object expected");
            message.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.fromObject(object.repeatStrategy);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClassEventProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClassEventProto
     * @static
     * @param {ClassEventProto} message ClassEventProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClassEventProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.details = null;
            object.repeatStrategy = null;
        }
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = $root.space.kenko.proto.ClassEventType.toObject(message.details, options);
        if (message.repeatStrategy != null && message.hasOwnProperty("repeatStrategy"))
            object.repeatStrategy = $root.space.kenko.proto.RepeatStrategyProto.toObject(message.repeatStrategy, options);
        return object;
    };

    /**
     * Converts this ClassEventProto to JSON.
     * @function toJSON
     * @memberof ClassEventProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClassEventProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClassEventProto
     * @function getTypeUrl
     * @memberof ClassEventProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClassEventProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClassEventProto";
    };

    return ClassEventProto;
})();

export const ClassBookingProto = $root.ClassBookingProto = (() => {

    /**
     * Properties of a ClassBookingProto.
     * @exports IClassBookingProto
     * @interface IClassBookingProto
     * @property {space.kenko.proto.IApiBookingProto|null} [booking] ClassBookingProto booking
     */

    /**
     * Constructs a new ClassBookingProto.
     * @exports ClassBookingProto
     * @classdesc Represents a ClassBookingProto.
     * @implements IClassBookingProto
     * @constructor
     * @param {IClassBookingProto=} [properties] Properties to set
     */
    function ClassBookingProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ClassBookingProto booking.
     * @member {space.kenko.proto.IApiBookingProto|null|undefined} booking
     * @memberof ClassBookingProto
     * @instance
     */
    ClassBookingProto.prototype.booking = null;

    /**
     * Creates a new ClassBookingProto instance using the specified properties.
     * @function create
     * @memberof ClassBookingProto
     * @static
     * @param {IClassBookingProto=} [properties] Properties to set
     * @returns {ClassBookingProto} ClassBookingProto instance
     */
    ClassBookingProto.create = function create(properties) {
        return new ClassBookingProto(properties);
    };

    /**
     * Encodes the specified ClassBookingProto message. Does not implicitly {@link ClassBookingProto.verify|verify} messages.
     * @function encode
     * @memberof ClassBookingProto
     * @static
     * @param {IClassBookingProto} message ClassBookingProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassBookingProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.booking != null && Object.hasOwnProperty.call(message, "booking"))
            $root.space.kenko.proto.ApiBookingProto.encode(message.booking, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ClassBookingProto message, length delimited. Does not implicitly {@link ClassBookingProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ClassBookingProto
     * @static
     * @param {IClassBookingProto} message ClassBookingProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ClassBookingProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ClassBookingProto message from the specified reader or buffer.
     * @function decode
     * @memberof ClassBookingProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ClassBookingProto} ClassBookingProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassBookingProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ClassBookingProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.booking = $root.space.kenko.proto.ApiBookingProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ClassBookingProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ClassBookingProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ClassBookingProto} ClassBookingProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ClassBookingProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ClassBookingProto message.
     * @function verify
     * @memberof ClassBookingProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ClassBookingProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.booking != null && message.hasOwnProperty("booking")) {
            let error = $root.space.kenko.proto.ApiBookingProto.verify(message.booking);
            if (error)
                return "booking." + error;
        }
        return null;
    };

    /**
     * Creates a ClassBookingProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ClassBookingProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ClassBookingProto} ClassBookingProto
     */
    ClassBookingProto.fromObject = function fromObject(object) {
        if (object instanceof $root.ClassBookingProto)
            return object;
        let message = new $root.ClassBookingProto();
        if (object.booking != null) {
            if (typeof object.booking !== "object")
                throw TypeError(".ClassBookingProto.booking: object expected");
            message.booking = $root.space.kenko.proto.ApiBookingProto.fromObject(object.booking);
        }
        return message;
    };

    /**
     * Creates a plain object from a ClassBookingProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ClassBookingProto
     * @static
     * @param {ClassBookingProto} message ClassBookingProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ClassBookingProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.booking = null;
        if (message.booking != null && message.hasOwnProperty("booking"))
            object.booking = $root.space.kenko.proto.ApiBookingProto.toObject(message.booking, options);
        return object;
    };

    /**
     * Converts this ClassBookingProto to JSON.
     * @function toJSON
     * @memberof ClassBookingProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ClassBookingProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ClassBookingProto
     * @function getTypeUrl
     * @memberof ClassBookingProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ClassBookingProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ClassBookingProto";
    };

    return ClassBookingProto;
})();

export const MutateCalendarEventRequest = $root.MutateCalendarEventRequest = (() => {

    /**
     * Properties of a MutateCalendarEventRequest.
     * @exports IMutateCalendarEventRequest
     * @interface IMutateCalendarEventRequest
     * @property {IKensuCalendarEventProto|null} [event] MutateCalendarEventRequest event
     * @property {boolean|null} [includeFutureInstances] MutateCalendarEventRequest includeFutureInstances
     * @property {number|Long|null} [clientStartTimestampMs] MutateCalendarEventRequest clientStartTimestampMs
     * @property {number|Long|null} [clientEndTimestampMs] MutateCalendarEventRequest clientEndTimestampMs
     */

    /**
     * Constructs a new MutateCalendarEventRequest.
     * @exports MutateCalendarEventRequest
     * @classdesc Represents a MutateCalendarEventRequest.
     * @implements IMutateCalendarEventRequest
     * @constructor
     * @param {IMutateCalendarEventRequest=} [properties] Properties to set
     */
    function MutateCalendarEventRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateCalendarEventRequest event.
     * @member {IKensuCalendarEventProto|null|undefined} event
     * @memberof MutateCalendarEventRequest
     * @instance
     */
    MutateCalendarEventRequest.prototype.event = null;

    /**
     * MutateCalendarEventRequest includeFutureInstances.
     * @member {boolean} includeFutureInstances
     * @memberof MutateCalendarEventRequest
     * @instance
     */
    MutateCalendarEventRequest.prototype.includeFutureInstances = false;

    /**
     * MutateCalendarEventRequest clientStartTimestampMs.
     * @member {number|Long} clientStartTimestampMs
     * @memberof MutateCalendarEventRequest
     * @instance
     */
    MutateCalendarEventRequest.prototype.clientStartTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * MutateCalendarEventRequest clientEndTimestampMs.
     * @member {number|Long} clientEndTimestampMs
     * @memberof MutateCalendarEventRequest
     * @instance
     */
    MutateCalendarEventRequest.prototype.clientEndTimestampMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new MutateCalendarEventRequest instance using the specified properties.
     * @function create
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {IMutateCalendarEventRequest=} [properties] Properties to set
     * @returns {MutateCalendarEventRequest} MutateCalendarEventRequest instance
     */
    MutateCalendarEventRequest.create = function create(properties) {
        return new MutateCalendarEventRequest(properties);
    };

    /**
     * Encodes the specified MutateCalendarEventRequest message. Does not implicitly {@link MutateCalendarEventRequest.verify|verify} messages.
     * @function encode
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {IMutateCalendarEventRequest} message MutateCalendarEventRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateCalendarEventRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.event != null && Object.hasOwnProperty.call(message, "event"))
            $root.KensuCalendarEventProto.encode(message.event, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.includeFutureInstances != null && Object.hasOwnProperty.call(message, "includeFutureInstances"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeFutureInstances);
        if (message.clientStartTimestampMs != null && Object.hasOwnProperty.call(message, "clientStartTimestampMs"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.clientStartTimestampMs);
        if (message.clientEndTimestampMs != null && Object.hasOwnProperty.call(message, "clientEndTimestampMs"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.clientEndTimestampMs);
        return writer;
    };

    /**
     * Encodes the specified MutateCalendarEventRequest message, length delimited. Does not implicitly {@link MutateCalendarEventRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {IMutateCalendarEventRequest} message MutateCalendarEventRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateCalendarEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateCalendarEventRequest message from the specified reader or buffer.
     * @function decode
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateCalendarEventRequest} MutateCalendarEventRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateCalendarEventRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateCalendarEventRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.event = $root.KensuCalendarEventProto.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.includeFutureInstances = reader.bool();
                    break;
                }
            case 3: {
                    message.clientStartTimestampMs = reader.int64();
                    break;
                }
            case 4: {
                    message.clientEndTimestampMs = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateCalendarEventRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateCalendarEventRequest} MutateCalendarEventRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateCalendarEventRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateCalendarEventRequest message.
     * @function verify
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateCalendarEventRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.event != null && message.hasOwnProperty("event")) {
            let error = $root.KensuCalendarEventProto.verify(message.event);
            if (error)
                return "event." + error;
        }
        if (message.includeFutureInstances != null && message.hasOwnProperty("includeFutureInstances"))
            if (typeof message.includeFutureInstances !== "boolean")
                return "includeFutureInstances: boolean expected";
        if (message.clientStartTimestampMs != null && message.hasOwnProperty("clientStartTimestampMs"))
            if (!$util.isInteger(message.clientStartTimestampMs) && !(message.clientStartTimestampMs && $util.isInteger(message.clientStartTimestampMs.low) && $util.isInteger(message.clientStartTimestampMs.high)))
                return "clientStartTimestampMs: integer|Long expected";
        if (message.clientEndTimestampMs != null && message.hasOwnProperty("clientEndTimestampMs"))
            if (!$util.isInteger(message.clientEndTimestampMs) && !(message.clientEndTimestampMs && $util.isInteger(message.clientEndTimestampMs.low) && $util.isInteger(message.clientEndTimestampMs.high)))
                return "clientEndTimestampMs: integer|Long expected";
        return null;
    };

    /**
     * Creates a MutateCalendarEventRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateCalendarEventRequest} MutateCalendarEventRequest
     */
    MutateCalendarEventRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateCalendarEventRequest)
            return object;
        let message = new $root.MutateCalendarEventRequest();
        if (object.event != null) {
            if (typeof object.event !== "object")
                throw TypeError(".MutateCalendarEventRequest.event: object expected");
            message.event = $root.KensuCalendarEventProto.fromObject(object.event);
        }
        if (object.includeFutureInstances != null)
            message.includeFutureInstances = Boolean(object.includeFutureInstances);
        if (object.clientStartTimestampMs != null)
            if ($util.Long)
                (message.clientStartTimestampMs = $util.Long.fromValue(object.clientStartTimestampMs)).unsigned = false;
            else if (typeof object.clientStartTimestampMs === "string")
                message.clientStartTimestampMs = parseInt(object.clientStartTimestampMs, 10);
            else if (typeof object.clientStartTimestampMs === "number")
                message.clientStartTimestampMs = object.clientStartTimestampMs;
            else if (typeof object.clientStartTimestampMs === "object")
                message.clientStartTimestampMs = new $util.LongBits(object.clientStartTimestampMs.low >>> 0, object.clientStartTimestampMs.high >>> 0).toNumber();
        if (object.clientEndTimestampMs != null)
            if ($util.Long)
                (message.clientEndTimestampMs = $util.Long.fromValue(object.clientEndTimestampMs)).unsigned = false;
            else if (typeof object.clientEndTimestampMs === "string")
                message.clientEndTimestampMs = parseInt(object.clientEndTimestampMs, 10);
            else if (typeof object.clientEndTimestampMs === "number")
                message.clientEndTimestampMs = object.clientEndTimestampMs;
            else if (typeof object.clientEndTimestampMs === "object")
                message.clientEndTimestampMs = new $util.LongBits(object.clientEndTimestampMs.low >>> 0, object.clientEndTimestampMs.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a MutateCalendarEventRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {MutateCalendarEventRequest} message MutateCalendarEventRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateCalendarEventRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.event = null;
            object.includeFutureInstances = false;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.clientStartTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.clientStartTimestampMs = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.clientEndTimestampMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.clientEndTimestampMs = options.longs === String ? "0" : 0;
        }
        if (message.event != null && message.hasOwnProperty("event"))
            object.event = $root.KensuCalendarEventProto.toObject(message.event, options);
        if (message.includeFutureInstances != null && message.hasOwnProperty("includeFutureInstances"))
            object.includeFutureInstances = message.includeFutureInstances;
        if (message.clientStartTimestampMs != null && message.hasOwnProperty("clientStartTimestampMs"))
            if (typeof message.clientStartTimestampMs === "number")
                object.clientStartTimestampMs = options.longs === String ? String(message.clientStartTimestampMs) : message.clientStartTimestampMs;
            else
                object.clientStartTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.clientStartTimestampMs) : options.longs === Number ? new $util.LongBits(message.clientStartTimestampMs.low >>> 0, message.clientStartTimestampMs.high >>> 0).toNumber() : message.clientStartTimestampMs;
        if (message.clientEndTimestampMs != null && message.hasOwnProperty("clientEndTimestampMs"))
            if (typeof message.clientEndTimestampMs === "number")
                object.clientEndTimestampMs = options.longs === String ? String(message.clientEndTimestampMs) : message.clientEndTimestampMs;
            else
                object.clientEndTimestampMs = options.longs === String ? $util.Long.prototype.toString.call(message.clientEndTimestampMs) : options.longs === Number ? new $util.LongBits(message.clientEndTimestampMs.low >>> 0, message.clientEndTimestampMs.high >>> 0).toNumber() : message.clientEndTimestampMs;
        return object;
    };

    /**
     * Converts this MutateCalendarEventRequest to JSON.
     * @function toJSON
     * @memberof MutateCalendarEventRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateCalendarEventRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateCalendarEventRequest
     * @function getTypeUrl
     * @memberof MutateCalendarEventRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateCalendarEventRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateCalendarEventRequest";
    };

    return MutateCalendarEventRequest;
})();

export const MutateCalendarEventResponse = $root.MutateCalendarEventResponse = (() => {

    /**
     * Properties of a MutateCalendarEventResponse.
     * @exports IMutateCalendarEventResponse
     * @interface IMutateCalendarEventResponse
     * @property {boolean|null} [okay] MutateCalendarEventResponse okay
     * @property {space.kenko.proto.IKensuExceptionProto|null} [exception] MutateCalendarEventResponse exception
     * @property {Array.<IKensuCalendarEventProto>|null} [instances] MutateCalendarEventResponse instances
     * @property {IApiBusinessProto|null} [optionalUpdatedBusiness] MutateCalendarEventResponse optionalUpdatedBusiness
     */

    /**
     * Constructs a new MutateCalendarEventResponse.
     * @exports MutateCalendarEventResponse
     * @classdesc Represents a MutateCalendarEventResponse.
     * @implements IMutateCalendarEventResponse
     * @constructor
     * @param {IMutateCalendarEventResponse=} [properties] Properties to set
     */
    function MutateCalendarEventResponse(properties) {
        this.instances = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MutateCalendarEventResponse okay.
     * @member {boolean} okay
     * @memberof MutateCalendarEventResponse
     * @instance
     */
    MutateCalendarEventResponse.prototype.okay = false;

    /**
     * MutateCalendarEventResponse exception.
     * @member {space.kenko.proto.IKensuExceptionProto|null|undefined} exception
     * @memberof MutateCalendarEventResponse
     * @instance
     */
    MutateCalendarEventResponse.prototype.exception = null;

    /**
     * MutateCalendarEventResponse instances.
     * @member {Array.<IKensuCalendarEventProto>} instances
     * @memberof MutateCalendarEventResponse
     * @instance
     */
    MutateCalendarEventResponse.prototype.instances = $util.emptyArray;

    /**
     * MutateCalendarEventResponse optionalUpdatedBusiness.
     * @member {IApiBusinessProto|null|undefined} optionalUpdatedBusiness
     * @memberof MutateCalendarEventResponse
     * @instance
     */
    MutateCalendarEventResponse.prototype.optionalUpdatedBusiness = null;

    /**
     * Creates a new MutateCalendarEventResponse instance using the specified properties.
     * @function create
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {IMutateCalendarEventResponse=} [properties] Properties to set
     * @returns {MutateCalendarEventResponse} MutateCalendarEventResponse instance
     */
    MutateCalendarEventResponse.create = function create(properties) {
        return new MutateCalendarEventResponse(properties);
    };

    /**
     * Encodes the specified MutateCalendarEventResponse message. Does not implicitly {@link MutateCalendarEventResponse.verify|verify} messages.
     * @function encode
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {IMutateCalendarEventResponse} message MutateCalendarEventResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateCalendarEventResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.exception != null && Object.hasOwnProperty.call(message, "exception"))
            $root.space.kenko.proto.KensuExceptionProto.encode(message.exception, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.instances != null && message.instances.length)
            for (let i = 0; i < message.instances.length; ++i)
                $root.KensuCalendarEventProto.encode(message.instances[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.optionalUpdatedBusiness != null && Object.hasOwnProperty.call(message, "optionalUpdatedBusiness"))
            $root.ApiBusinessProto.encode(message.optionalUpdatedBusiness, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MutateCalendarEventResponse message, length delimited. Does not implicitly {@link MutateCalendarEventResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {IMutateCalendarEventResponse} message MutateCalendarEventResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MutateCalendarEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MutateCalendarEventResponse message from the specified reader or buffer.
     * @function decode
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MutateCalendarEventResponse} MutateCalendarEventResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateCalendarEventResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MutateCalendarEventResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.exception = $root.space.kenko.proto.KensuExceptionProto.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    if (!(message.instances && message.instances.length))
                        message.instances = [];
                    message.instances.push($root.KensuCalendarEventProto.decode(reader, reader.uint32()));
                    break;
                }
            case 4: {
                    message.optionalUpdatedBusiness = $root.ApiBusinessProto.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MutateCalendarEventResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MutateCalendarEventResponse} MutateCalendarEventResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MutateCalendarEventResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MutateCalendarEventResponse message.
     * @function verify
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MutateCalendarEventResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.exception != null && message.hasOwnProperty("exception")) {
            let error = $root.space.kenko.proto.KensuExceptionProto.verify(message.exception);
            if (error)
                return "exception." + error;
        }
        if (message.instances != null && message.hasOwnProperty("instances")) {
            if (!Array.isArray(message.instances))
                return "instances: array expected";
            for (let i = 0; i < message.instances.length; ++i) {
                let error = $root.KensuCalendarEventProto.verify(message.instances[i]);
                if (error)
                    return "instances." + error;
            }
        }
        if (message.optionalUpdatedBusiness != null && message.hasOwnProperty("optionalUpdatedBusiness")) {
            let error = $root.ApiBusinessProto.verify(message.optionalUpdatedBusiness);
            if (error)
                return "optionalUpdatedBusiness." + error;
        }
        return null;
    };

    /**
     * Creates a MutateCalendarEventResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MutateCalendarEventResponse} MutateCalendarEventResponse
     */
    MutateCalendarEventResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.MutateCalendarEventResponse)
            return object;
        let message = new $root.MutateCalendarEventResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.exception != null) {
            if (typeof object.exception !== "object")
                throw TypeError(".MutateCalendarEventResponse.exception: object expected");
            message.exception = $root.space.kenko.proto.KensuExceptionProto.fromObject(object.exception);
        }
        if (object.instances) {
            if (!Array.isArray(object.instances))
                throw TypeError(".MutateCalendarEventResponse.instances: array expected");
            message.instances = [];
            for (let i = 0; i < object.instances.length; ++i) {
                if (typeof object.instances[i] !== "object")
                    throw TypeError(".MutateCalendarEventResponse.instances: object expected");
                message.instances[i] = $root.KensuCalendarEventProto.fromObject(object.instances[i]);
            }
        }
        if (object.optionalUpdatedBusiness != null) {
            if (typeof object.optionalUpdatedBusiness !== "object")
                throw TypeError(".MutateCalendarEventResponse.optionalUpdatedBusiness: object expected");
            message.optionalUpdatedBusiness = $root.ApiBusinessProto.fromObject(object.optionalUpdatedBusiness);
        }
        return message;
    };

    /**
     * Creates a plain object from a MutateCalendarEventResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {MutateCalendarEventResponse} message MutateCalendarEventResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MutateCalendarEventResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.instances = [];
        if (options.defaults) {
            object.okay = false;
            object.exception = null;
            object.optionalUpdatedBusiness = null;
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.exception != null && message.hasOwnProperty("exception"))
            object.exception = $root.space.kenko.proto.KensuExceptionProto.toObject(message.exception, options);
        if (message.instances && message.instances.length) {
            object.instances = [];
            for (let j = 0; j < message.instances.length; ++j)
                object.instances[j] = $root.KensuCalendarEventProto.toObject(message.instances[j], options);
        }
        if (message.optionalUpdatedBusiness != null && message.hasOwnProperty("optionalUpdatedBusiness"))
            object.optionalUpdatedBusiness = $root.ApiBusinessProto.toObject(message.optionalUpdatedBusiness, options);
        return object;
    };

    /**
     * Converts this MutateCalendarEventResponse to JSON.
     * @function toJSON
     * @memberof MutateCalendarEventResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MutateCalendarEventResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MutateCalendarEventResponse
     * @function getTypeUrl
     * @memberof MutateCalendarEventResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MutateCalendarEventResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MutateCalendarEventResponse";
    };

    return MutateCalendarEventResponse;
})();

export const TeamMemberInviteProto = $root.TeamMemberInviteProto = (() => {

    /**
     * Properties of a TeamMemberInviteProto.
     * @exports ITeamMemberInviteProto
     * @interface ITeamMemberInviteProto
     * @property {string|null} [inviteCode] TeamMemberInviteProto inviteCode
     * @property {string|null} [sentToEmail] TeamMemberInviteProto sentToEmail
     * @property {number|Long|null} [sentTimestamp] TeamMemberInviteProto sentTimestamp
     * @property {TeamMemberInviteProto.TeamMemberInviteStatus|null} [status] TeamMemberInviteProto status
     */

    /**
     * Constructs a new TeamMemberInviteProto.
     * @exports TeamMemberInviteProto
     * @classdesc Represents a TeamMemberInviteProto.
     * @implements ITeamMemberInviteProto
     * @constructor
     * @param {ITeamMemberInviteProto=} [properties] Properties to set
     */
    function TeamMemberInviteProto(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TeamMemberInviteProto inviteCode.
     * @member {string} inviteCode
     * @memberof TeamMemberInviteProto
     * @instance
     */
    TeamMemberInviteProto.prototype.inviteCode = "";

    /**
     * TeamMemberInviteProto sentToEmail.
     * @member {string} sentToEmail
     * @memberof TeamMemberInviteProto
     * @instance
     */
    TeamMemberInviteProto.prototype.sentToEmail = "";

    /**
     * TeamMemberInviteProto sentTimestamp.
     * @member {number|Long} sentTimestamp
     * @memberof TeamMemberInviteProto
     * @instance
     */
    TeamMemberInviteProto.prototype.sentTimestamp = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * TeamMemberInviteProto status.
     * @member {TeamMemberInviteProto.TeamMemberInviteStatus} status
     * @memberof TeamMemberInviteProto
     * @instance
     */
    TeamMemberInviteProto.prototype.status = 0;

    /**
     * Creates a new TeamMemberInviteProto instance using the specified properties.
     * @function create
     * @memberof TeamMemberInviteProto
     * @static
     * @param {ITeamMemberInviteProto=} [properties] Properties to set
     * @returns {TeamMemberInviteProto} TeamMemberInviteProto instance
     */
    TeamMemberInviteProto.create = function create(properties) {
        return new TeamMemberInviteProto(properties);
    };

    /**
     * Encodes the specified TeamMemberInviteProto message. Does not implicitly {@link TeamMemberInviteProto.verify|verify} messages.
     * @function encode
     * @memberof TeamMemberInviteProto
     * @static
     * @param {ITeamMemberInviteProto} message TeamMemberInviteProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeamMemberInviteProto.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.inviteCode != null && Object.hasOwnProperty.call(message, "inviteCode"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.inviteCode);
        if (message.sentToEmail != null && Object.hasOwnProperty.call(message, "sentToEmail"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.sentToEmail);
        if (message.sentTimestamp != null && Object.hasOwnProperty.call(message, "sentTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.sentTimestamp);
        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
        return writer;
    };

    /**
     * Encodes the specified TeamMemberInviteProto message, length delimited. Does not implicitly {@link TeamMemberInviteProto.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TeamMemberInviteProto
     * @static
     * @param {ITeamMemberInviteProto} message TeamMemberInviteProto message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TeamMemberInviteProto.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TeamMemberInviteProto message from the specified reader or buffer.
     * @function decode
     * @memberof TeamMemberInviteProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TeamMemberInviteProto} TeamMemberInviteProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeamMemberInviteProto.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TeamMemberInviteProto();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.inviteCode = reader.string();
                    break;
                }
            case 2: {
                    message.sentToEmail = reader.string();
                    break;
                }
            case 3: {
                    message.sentTimestamp = reader.int64();
                    break;
                }
            case 4: {
                    message.status = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TeamMemberInviteProto message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TeamMemberInviteProto
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TeamMemberInviteProto} TeamMemberInviteProto
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TeamMemberInviteProto.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TeamMemberInviteProto message.
     * @function verify
     * @memberof TeamMemberInviteProto
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TeamMemberInviteProto.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            if (!$util.isString(message.inviteCode))
                return "inviteCode: string expected";
        if (message.sentToEmail != null && message.hasOwnProperty("sentToEmail"))
            if (!$util.isString(message.sentToEmail))
                return "sentToEmail: string expected";
        if (message.sentTimestamp != null && message.hasOwnProperty("sentTimestamp"))
            if (!$util.isInteger(message.sentTimestamp) && !(message.sentTimestamp && $util.isInteger(message.sentTimestamp.low) && $util.isInteger(message.sentTimestamp.high)))
                return "sentTimestamp: integer|Long expected";
        if (message.status != null && message.hasOwnProperty("status"))
            switch (message.status) {
            default:
                return "status: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates a TeamMemberInviteProto message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TeamMemberInviteProto
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TeamMemberInviteProto} TeamMemberInviteProto
     */
    TeamMemberInviteProto.fromObject = function fromObject(object) {
        if (object instanceof $root.TeamMemberInviteProto)
            return object;
        let message = new $root.TeamMemberInviteProto();
        if (object.inviteCode != null)
            message.inviteCode = String(object.inviteCode);
        if (object.sentToEmail != null)
            message.sentToEmail = String(object.sentToEmail);
        if (object.sentTimestamp != null)
            if ($util.Long)
                (message.sentTimestamp = $util.Long.fromValue(object.sentTimestamp)).unsigned = false;
            else if (typeof object.sentTimestamp === "string")
                message.sentTimestamp = parseInt(object.sentTimestamp, 10);
            else if (typeof object.sentTimestamp === "number")
                message.sentTimestamp = object.sentTimestamp;
            else if (typeof object.sentTimestamp === "object")
                message.sentTimestamp = new $util.LongBits(object.sentTimestamp.low >>> 0, object.sentTimestamp.high >>> 0).toNumber();
        switch (object.status) {
        default:
            if (typeof object.status === "number") {
                message.status = object.status;
                break;
            }
            break;
        case "STATUS_UNKNOWN":
        case 0:
            message.status = 0;
            break;
        case "AVAILABLE":
        case 1:
            message.status = 1;
            break;
        case "ACCEPTED":
        case 2:
            message.status = 2;
            break;
        case "EXPIRED":
        case 3:
            message.status = 3;
            break;
        case "OPENED":
        case 4:
            message.status = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a TeamMemberInviteProto message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TeamMemberInviteProto
     * @static
     * @param {TeamMemberInviteProto} message TeamMemberInviteProto
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TeamMemberInviteProto.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.inviteCode = "";
            object.sentToEmail = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.sentTimestamp = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.sentTimestamp = options.longs === String ? "0" : 0;
            object.status = options.enums === String ? "STATUS_UNKNOWN" : 0;
        }
        if (message.inviteCode != null && message.hasOwnProperty("inviteCode"))
            object.inviteCode = message.inviteCode;
        if (message.sentToEmail != null && message.hasOwnProperty("sentToEmail"))
            object.sentToEmail = message.sentToEmail;
        if (message.sentTimestamp != null && message.hasOwnProperty("sentTimestamp"))
            if (typeof message.sentTimestamp === "number")
                object.sentTimestamp = options.longs === String ? String(message.sentTimestamp) : message.sentTimestamp;
            else
                object.sentTimestamp = options.longs === String ? $util.Long.prototype.toString.call(message.sentTimestamp) : options.longs === Number ? new $util.LongBits(message.sentTimestamp.low >>> 0, message.sentTimestamp.high >>> 0).toNumber() : message.sentTimestamp;
        if (message.status != null && message.hasOwnProperty("status"))
            object.status = options.enums === String ? $root.TeamMemberInviteProto.TeamMemberInviteStatus[message.status] === undefined ? message.status : $root.TeamMemberInviteProto.TeamMemberInviteStatus[message.status] : message.status;
        return object;
    };

    /**
     * Converts this TeamMemberInviteProto to JSON.
     * @function toJSON
     * @memberof TeamMemberInviteProto
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TeamMemberInviteProto.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TeamMemberInviteProto
     * @function getTypeUrl
     * @memberof TeamMemberInviteProto
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TeamMemberInviteProto.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TeamMemberInviteProto";
    };

    /**
     * TeamMemberInviteStatus enum.
     * @name TeamMemberInviteProto.TeamMemberInviteStatus
     * @enum {number}
     * @property {number} STATUS_UNKNOWN=0 STATUS_UNKNOWN value
     * @property {number} AVAILABLE=1 AVAILABLE value
     * @property {number} ACCEPTED=2 ACCEPTED value
     * @property {number} EXPIRED=3 EXPIRED value
     * @property {number} OPENED=4 OPENED value
     */
    TeamMemberInviteProto.TeamMemberInviteStatus = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "STATUS_UNKNOWN"] = 0;
        values[valuesById[1] = "AVAILABLE"] = 1;
        values[valuesById[2] = "ACCEPTED"] = 2;
        values[valuesById[3] = "EXPIRED"] = 3;
        values[valuesById[4] = "OPENED"] = 4;
        return values;
    })();

    return TeamMemberInviteProto;
})();

export const DebugDeleteCalendarEventsRequest = $root.DebugDeleteCalendarEventsRequest = (() => {

    /**
     * Properties of a DebugDeleteCalendarEventsRequest.
     * @exports IDebugDeleteCalendarEventsRequest
     * @interface IDebugDeleteCalendarEventsRequest
     * @property {string|null} [businessId] DebugDeleteCalendarEventsRequest businessId
     */

    /**
     * Constructs a new DebugDeleteCalendarEventsRequest.
     * @exports DebugDeleteCalendarEventsRequest
     * @classdesc Represents a DebugDeleteCalendarEventsRequest.
     * @implements IDebugDeleteCalendarEventsRequest
     * @constructor
     * @param {IDebugDeleteCalendarEventsRequest=} [properties] Properties to set
     */
    function DebugDeleteCalendarEventsRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugDeleteCalendarEventsRequest businessId.
     * @member {string} businessId
     * @memberof DebugDeleteCalendarEventsRequest
     * @instance
     */
    DebugDeleteCalendarEventsRequest.prototype.businessId = "";

    /**
     * Creates a new DebugDeleteCalendarEventsRequest instance using the specified properties.
     * @function create
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {IDebugDeleteCalendarEventsRequest=} [properties] Properties to set
     * @returns {DebugDeleteCalendarEventsRequest} DebugDeleteCalendarEventsRequest instance
     */
    DebugDeleteCalendarEventsRequest.create = function create(properties) {
        return new DebugDeleteCalendarEventsRequest(properties);
    };

    /**
     * Encodes the specified DebugDeleteCalendarEventsRequest message. Does not implicitly {@link DebugDeleteCalendarEventsRequest.verify|verify} messages.
     * @function encode
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {IDebugDeleteCalendarEventsRequest} message DebugDeleteCalendarEventsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteCalendarEventsRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.businessId != null && Object.hasOwnProperty.call(message, "businessId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.businessId);
        return writer;
    };

    /**
     * Encodes the specified DebugDeleteCalendarEventsRequest message, length delimited. Does not implicitly {@link DebugDeleteCalendarEventsRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {IDebugDeleteCalendarEventsRequest} message DebugDeleteCalendarEventsRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteCalendarEventsRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DebugDeleteCalendarEventsRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugDeleteCalendarEventsRequest} DebugDeleteCalendarEventsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteCalendarEventsRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugDeleteCalendarEventsRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.businessId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DebugDeleteCalendarEventsRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugDeleteCalendarEventsRequest} DebugDeleteCalendarEventsRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteCalendarEventsRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugDeleteCalendarEventsRequest message.
     * @function verify
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugDeleteCalendarEventsRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            if (!$util.isString(message.businessId))
                return "businessId: string expected";
        return null;
    };

    /**
     * Creates a DebugDeleteCalendarEventsRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugDeleteCalendarEventsRequest} DebugDeleteCalendarEventsRequest
     */
    DebugDeleteCalendarEventsRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugDeleteCalendarEventsRequest)
            return object;
        let message = new $root.DebugDeleteCalendarEventsRequest();
        if (object.businessId != null)
            message.businessId = String(object.businessId);
        return message;
    };

    /**
     * Creates a plain object from a DebugDeleteCalendarEventsRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {DebugDeleteCalendarEventsRequest} message DebugDeleteCalendarEventsRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugDeleteCalendarEventsRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.businessId = "";
        if (message.businessId != null && message.hasOwnProperty("businessId"))
            object.businessId = message.businessId;
        return object;
    };

    /**
     * Converts this DebugDeleteCalendarEventsRequest to JSON.
     * @function toJSON
     * @memberof DebugDeleteCalendarEventsRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugDeleteCalendarEventsRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugDeleteCalendarEventsRequest
     * @function getTypeUrl
     * @memberof DebugDeleteCalendarEventsRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugDeleteCalendarEventsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugDeleteCalendarEventsRequest";
    };

    return DebugDeleteCalendarEventsRequest;
})();

export const DebugDeleteCalendarEventsResponse = $root.DebugDeleteCalendarEventsResponse = (() => {

    /**
     * Properties of a DebugDeleteCalendarEventsResponse.
     * @exports IDebugDeleteCalendarEventsResponse
     * @interface IDebugDeleteCalendarEventsResponse
     * @property {boolean|null} [okay] DebugDeleteCalendarEventsResponse okay
     */

    /**
     * Constructs a new DebugDeleteCalendarEventsResponse.
     * @exports DebugDeleteCalendarEventsResponse
     * @classdesc Represents a DebugDeleteCalendarEventsResponse.
     * @implements IDebugDeleteCalendarEventsResponse
     * @constructor
     * @param {IDebugDeleteCalendarEventsResponse=} [properties] Properties to set
     */
    function DebugDeleteCalendarEventsResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DebugDeleteCalendarEventsResponse okay.
     * @member {boolean} okay
     * @memberof DebugDeleteCalendarEventsResponse
     * @instance
     */
    DebugDeleteCalendarEventsResponse.prototype.okay = false;

    /**
     * Creates a new DebugDeleteCalendarEventsResponse instance using the specified properties.
     * @function create
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {IDebugDeleteCalendarEventsResponse=} [properties] Properties to set
     * @returns {DebugDeleteCalendarEventsResponse} DebugDeleteCalendarEventsResponse instance
     */
    DebugDeleteCalendarEventsResponse.create = function create(properties) {
        return new DebugDeleteCalendarEventsResponse(properties);
    };

    /**
     * Encodes the specified DebugDeleteCalendarEventsResponse message. Does not implicitly {@link DebugDeleteCalendarEventsResponse.verify|verify} messages.
     * @function encode
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {IDebugDeleteCalendarEventsResponse} message DebugDeleteCalendarEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteCalendarEventsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        return writer;
    };

    /**
     * Encodes the specified DebugDeleteCalendarEventsResponse message, length delimited. Does not implicitly {@link DebugDeleteCalendarEventsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {IDebugDeleteCalendarEventsResponse} message DebugDeleteCalendarEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DebugDeleteCalendarEventsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DebugDeleteCalendarEventsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DebugDeleteCalendarEventsResponse} DebugDeleteCalendarEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteCalendarEventsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DebugDeleteCalendarEventsResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DebugDeleteCalendarEventsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DebugDeleteCalendarEventsResponse} DebugDeleteCalendarEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DebugDeleteCalendarEventsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DebugDeleteCalendarEventsResponse message.
     * @function verify
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DebugDeleteCalendarEventsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        return null;
    };

    /**
     * Creates a DebugDeleteCalendarEventsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DebugDeleteCalendarEventsResponse} DebugDeleteCalendarEventsResponse
     */
    DebugDeleteCalendarEventsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.DebugDeleteCalendarEventsResponse)
            return object;
        let message = new $root.DebugDeleteCalendarEventsResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        return message;
    };

    /**
     * Creates a plain object from a DebugDeleteCalendarEventsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {DebugDeleteCalendarEventsResponse} message DebugDeleteCalendarEventsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DebugDeleteCalendarEventsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        return object;
    };

    /**
     * Converts this DebugDeleteCalendarEventsResponse to JSON.
     * @function toJSON
     * @memberof DebugDeleteCalendarEventsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DebugDeleteCalendarEventsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DebugDeleteCalendarEventsResponse
     * @function getTypeUrl
     * @memberof DebugDeleteCalendarEventsResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DebugDeleteCalendarEventsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DebugDeleteCalendarEventsResponse";
    };

    return DebugDeleteCalendarEventsResponse;
})();

export const DeleteBookingRequest = $root.DeleteBookingRequest = (() => {

    /**
     * Properties of a DeleteBookingRequest.
     * @exports IDeleteBookingRequest
     * @interface IDeleteBookingRequest
     * @property {string|null} [bookingId] DeleteBookingRequest bookingId
     */

    /**
     * Constructs a new DeleteBookingRequest.
     * @exports DeleteBookingRequest
     * @classdesc Represents a DeleteBookingRequest.
     * @implements IDeleteBookingRequest
     * @constructor
     * @param {IDeleteBookingRequest=} [properties] Properties to set
     */
    function DeleteBookingRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeleteBookingRequest bookingId.
     * @member {string} bookingId
     * @memberof DeleteBookingRequest
     * @instance
     */
    DeleteBookingRequest.prototype.bookingId = "";

    /**
     * Creates a new DeleteBookingRequest instance using the specified properties.
     * @function create
     * @memberof DeleteBookingRequest
     * @static
     * @param {IDeleteBookingRequest=} [properties] Properties to set
     * @returns {DeleteBookingRequest} DeleteBookingRequest instance
     */
    DeleteBookingRequest.create = function create(properties) {
        return new DeleteBookingRequest(properties);
    };

    /**
     * Encodes the specified DeleteBookingRequest message. Does not implicitly {@link DeleteBookingRequest.verify|verify} messages.
     * @function encode
     * @memberof DeleteBookingRequest
     * @static
     * @param {IDeleteBookingRequest} message DeleteBookingRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteBookingRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bookingId != null && Object.hasOwnProperty.call(message, "bookingId"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bookingId);
        return writer;
    };

    /**
     * Encodes the specified DeleteBookingRequest message, length delimited. Does not implicitly {@link DeleteBookingRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeleteBookingRequest
     * @static
     * @param {IDeleteBookingRequest} message DeleteBookingRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteBookingRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeleteBookingRequest message from the specified reader or buffer.
     * @function decode
     * @memberof DeleteBookingRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeleteBookingRequest} DeleteBookingRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteBookingRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeleteBookingRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.bookingId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeleteBookingRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeleteBookingRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeleteBookingRequest} DeleteBookingRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteBookingRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeleteBookingRequest message.
     * @function verify
     * @memberof DeleteBookingRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeleteBookingRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            if (!$util.isString(message.bookingId))
                return "bookingId: string expected";
        return null;
    };

    /**
     * Creates a DeleteBookingRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeleteBookingRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeleteBookingRequest} DeleteBookingRequest
     */
    DeleteBookingRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.DeleteBookingRequest)
            return object;
        let message = new $root.DeleteBookingRequest();
        if (object.bookingId != null)
            message.bookingId = String(object.bookingId);
        return message;
    };

    /**
     * Creates a plain object from a DeleteBookingRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeleteBookingRequest
     * @static
     * @param {DeleteBookingRequest} message DeleteBookingRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeleteBookingRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.bookingId = "";
        if (message.bookingId != null && message.hasOwnProperty("bookingId"))
            object.bookingId = message.bookingId;
        return object;
    };

    /**
     * Converts this DeleteBookingRequest to JSON.
     * @function toJSON
     * @memberof DeleteBookingRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeleteBookingRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeleteBookingRequest
     * @function getTypeUrl
     * @memberof DeleteBookingRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeleteBookingRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeleteBookingRequest";
    };

    return DeleteBookingRequest;
})();

export const DeleteBookingResponse = $root.DeleteBookingResponse = (() => {

    /**
     * Properties of a DeleteBookingResponse.
     * @exports IDeleteBookingResponse
     * @interface IDeleteBookingResponse
     * @property {boolean|null} [okay] DeleteBookingResponse okay
     * @property {string|null} [deletedBookingId] DeleteBookingResponse deletedBookingId
     */

    /**
     * Constructs a new DeleteBookingResponse.
     * @exports DeleteBookingResponse
     * @classdesc Represents a DeleteBookingResponse.
     * @implements IDeleteBookingResponse
     * @constructor
     * @param {IDeleteBookingResponse=} [properties] Properties to set
     */
    function DeleteBookingResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * DeleteBookingResponse okay.
     * @member {boolean} okay
     * @memberof DeleteBookingResponse
     * @instance
     */
    DeleteBookingResponse.prototype.okay = false;

    /**
     * DeleteBookingResponse deletedBookingId.
     * @member {string} deletedBookingId
     * @memberof DeleteBookingResponse
     * @instance
     */
    DeleteBookingResponse.prototype.deletedBookingId = "";

    /**
     * Creates a new DeleteBookingResponse instance using the specified properties.
     * @function create
     * @memberof DeleteBookingResponse
     * @static
     * @param {IDeleteBookingResponse=} [properties] Properties to set
     * @returns {DeleteBookingResponse} DeleteBookingResponse instance
     */
    DeleteBookingResponse.create = function create(properties) {
        return new DeleteBookingResponse(properties);
    };

    /**
     * Encodes the specified DeleteBookingResponse message. Does not implicitly {@link DeleteBookingResponse.verify|verify} messages.
     * @function encode
     * @memberof DeleteBookingResponse
     * @static
     * @param {IDeleteBookingResponse} message DeleteBookingResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteBookingResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.deletedBookingId != null && Object.hasOwnProperty.call(message, "deletedBookingId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.deletedBookingId);
        return writer;
    };

    /**
     * Encodes the specified DeleteBookingResponse message, length delimited. Does not implicitly {@link DeleteBookingResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof DeleteBookingResponse
     * @static
     * @param {IDeleteBookingResponse} message DeleteBookingResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    DeleteBookingResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a DeleteBookingResponse message from the specified reader or buffer.
     * @function decode
     * @memberof DeleteBookingResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {DeleteBookingResponse} DeleteBookingResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteBookingResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.DeleteBookingResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    message.deletedBookingId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a DeleteBookingResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof DeleteBookingResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {DeleteBookingResponse} DeleteBookingResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    DeleteBookingResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a DeleteBookingResponse message.
     * @function verify
     * @memberof DeleteBookingResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    DeleteBookingResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.deletedBookingId != null && message.hasOwnProperty("deletedBookingId"))
            if (!$util.isString(message.deletedBookingId))
                return "deletedBookingId: string expected";
        return null;
    };

    /**
     * Creates a DeleteBookingResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof DeleteBookingResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {DeleteBookingResponse} DeleteBookingResponse
     */
    DeleteBookingResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.DeleteBookingResponse)
            return object;
        let message = new $root.DeleteBookingResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.deletedBookingId != null)
            message.deletedBookingId = String(object.deletedBookingId);
        return message;
    };

    /**
     * Creates a plain object from a DeleteBookingResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof DeleteBookingResponse
     * @static
     * @param {DeleteBookingResponse} message DeleteBookingResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    DeleteBookingResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.okay = false;
            object.deletedBookingId = "";
        }
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.deletedBookingId != null && message.hasOwnProperty("deletedBookingId"))
            object.deletedBookingId = message.deletedBookingId;
        return object;
    };

    /**
     * Converts this DeleteBookingResponse to JSON.
     * @function toJSON
     * @memberof DeleteBookingResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    DeleteBookingResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for DeleteBookingResponse
     * @function getTypeUrl
     * @memberof DeleteBookingResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    DeleteBookingResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/DeleteBookingResponse";
    };

    return DeleteBookingResponse;
})();

export const SendProviderInquiryRequest = $root.SendProviderInquiryRequest = (() => {

    /**
     * Properties of a SendProviderInquiryRequest.
     * @exports ISendProviderInquiryRequest
     * @interface ISendProviderInquiryRequest
     * @property {string|null} [firstName] SendProviderInquiryRequest firstName
     * @property {string|null} [lastName] SendProviderInquiryRequest lastName
     * @property {string|null} [email] SendProviderInquiryRequest email
     * @property {string|null} [phone] SendProviderInquiryRequest phone
     * @property {string|null} [website] SendProviderInquiryRequest website
     * @property {string|null} [primaryModalities] SendProviderInquiryRequest primaryModalities
     * @property {string|null} [licensesCertifications] SendProviderInquiryRequest licensesCertifications
     * @property {string|null} [yearsInPractice] SendProviderInquiryRequest yearsInPractice
     * @property {string|null} [healingPhilosophy] SendProviderInquiryRequest healingPhilosophy
     * @property {string|null} [whoReferredYou] SendProviderInquiryRequest whoReferredYou
     * @property {string|null} [anythingElse] SendProviderInquiryRequest anythingElse
     */

    /**
     * Constructs a new SendProviderInquiryRequest.
     * @exports SendProviderInquiryRequest
     * @classdesc Represents a SendProviderInquiryRequest.
     * @implements ISendProviderInquiryRequest
     * @constructor
     * @param {ISendProviderInquiryRequest=} [properties] Properties to set
     */
    function SendProviderInquiryRequest(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SendProviderInquiryRequest firstName.
     * @member {string} firstName
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.firstName = "";

    /**
     * SendProviderInquiryRequest lastName.
     * @member {string} lastName
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.lastName = "";

    /**
     * SendProviderInquiryRequest email.
     * @member {string} email
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.email = "";

    /**
     * SendProviderInquiryRequest phone.
     * @member {string} phone
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.phone = "";

    /**
     * SendProviderInquiryRequest website.
     * @member {string} website
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.website = "";

    /**
     * SendProviderInquiryRequest primaryModalities.
     * @member {string} primaryModalities
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.primaryModalities = "";

    /**
     * SendProviderInquiryRequest licensesCertifications.
     * @member {string} licensesCertifications
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.licensesCertifications = "";

    /**
     * SendProviderInquiryRequest yearsInPractice.
     * @member {string} yearsInPractice
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.yearsInPractice = "";

    /**
     * SendProviderInquiryRequest healingPhilosophy.
     * @member {string} healingPhilosophy
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.healingPhilosophy = "";

    /**
     * SendProviderInquiryRequest whoReferredYou.
     * @member {string} whoReferredYou
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.whoReferredYou = "";

    /**
     * SendProviderInquiryRequest anythingElse.
     * @member {string} anythingElse
     * @memberof SendProviderInquiryRequest
     * @instance
     */
    SendProviderInquiryRequest.prototype.anythingElse = "";

    /**
     * Creates a new SendProviderInquiryRequest instance using the specified properties.
     * @function create
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {ISendProviderInquiryRequest=} [properties] Properties to set
     * @returns {SendProviderInquiryRequest} SendProviderInquiryRequest instance
     */
    SendProviderInquiryRequest.create = function create(properties) {
        return new SendProviderInquiryRequest(properties);
    };

    /**
     * Encodes the specified SendProviderInquiryRequest message. Does not implicitly {@link SendProviderInquiryRequest.verify|verify} messages.
     * @function encode
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {ISendProviderInquiryRequest} message SendProviderInquiryRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SendProviderInquiryRequest.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.firstName != null && Object.hasOwnProperty.call(message, "firstName"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.firstName);
        if (message.lastName != null && Object.hasOwnProperty.call(message, "lastName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.lastName);
        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
        if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.phone);
        if (message.website != null && Object.hasOwnProperty.call(message, "website"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.website);
        if (message.primaryModalities != null && Object.hasOwnProperty.call(message, "primaryModalities"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.primaryModalities);
        if (message.licensesCertifications != null && Object.hasOwnProperty.call(message, "licensesCertifications"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.licensesCertifications);
        if (message.yearsInPractice != null && Object.hasOwnProperty.call(message, "yearsInPractice"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.yearsInPractice);
        if (message.healingPhilosophy != null && Object.hasOwnProperty.call(message, "healingPhilosophy"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.healingPhilosophy);
        if (message.whoReferredYou != null && Object.hasOwnProperty.call(message, "whoReferredYou"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.whoReferredYou);
        if (message.anythingElse != null && Object.hasOwnProperty.call(message, "anythingElse"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.anythingElse);
        return writer;
    };

    /**
     * Encodes the specified SendProviderInquiryRequest message, length delimited. Does not implicitly {@link SendProviderInquiryRequest.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {ISendProviderInquiryRequest} message SendProviderInquiryRequest message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SendProviderInquiryRequest.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SendProviderInquiryRequest message from the specified reader or buffer.
     * @function decode
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SendProviderInquiryRequest} SendProviderInquiryRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SendProviderInquiryRequest.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SendProviderInquiryRequest();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.firstName = reader.string();
                    break;
                }
            case 2: {
                    message.lastName = reader.string();
                    break;
                }
            case 3: {
                    message.email = reader.string();
                    break;
                }
            case 4: {
                    message.phone = reader.string();
                    break;
                }
            case 5: {
                    message.website = reader.string();
                    break;
                }
            case 6: {
                    message.primaryModalities = reader.string();
                    break;
                }
            case 7: {
                    message.licensesCertifications = reader.string();
                    break;
                }
            case 8: {
                    message.yearsInPractice = reader.string();
                    break;
                }
            case 9: {
                    message.healingPhilosophy = reader.string();
                    break;
                }
            case 10: {
                    message.whoReferredYou = reader.string();
                    break;
                }
            case 11: {
                    message.anythingElse = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SendProviderInquiryRequest message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SendProviderInquiryRequest} SendProviderInquiryRequest
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SendProviderInquiryRequest.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SendProviderInquiryRequest message.
     * @function verify
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SendProviderInquiryRequest.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.firstName != null && message.hasOwnProperty("firstName"))
            if (!$util.isString(message.firstName))
                return "firstName: string expected";
        if (message.lastName != null && message.hasOwnProperty("lastName"))
            if (!$util.isString(message.lastName))
                return "lastName: string expected";
        if (message.email != null && message.hasOwnProperty("email"))
            if (!$util.isString(message.email))
                return "email: string expected";
        if (message.phone != null && message.hasOwnProperty("phone"))
            if (!$util.isString(message.phone))
                return "phone: string expected";
        if (message.website != null && message.hasOwnProperty("website"))
            if (!$util.isString(message.website))
                return "website: string expected";
        if (message.primaryModalities != null && message.hasOwnProperty("primaryModalities"))
            if (!$util.isString(message.primaryModalities))
                return "primaryModalities: string expected";
        if (message.licensesCertifications != null && message.hasOwnProperty("licensesCertifications"))
            if (!$util.isString(message.licensesCertifications))
                return "licensesCertifications: string expected";
        if (message.yearsInPractice != null && message.hasOwnProperty("yearsInPractice"))
            if (!$util.isString(message.yearsInPractice))
                return "yearsInPractice: string expected";
        if (message.healingPhilosophy != null && message.hasOwnProperty("healingPhilosophy"))
            if (!$util.isString(message.healingPhilosophy))
                return "healingPhilosophy: string expected";
        if (message.whoReferredYou != null && message.hasOwnProperty("whoReferredYou"))
            if (!$util.isString(message.whoReferredYou))
                return "whoReferredYou: string expected";
        if (message.anythingElse != null && message.hasOwnProperty("anythingElse"))
            if (!$util.isString(message.anythingElse))
                return "anythingElse: string expected";
        return null;
    };

    /**
     * Creates a SendProviderInquiryRequest message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SendProviderInquiryRequest} SendProviderInquiryRequest
     */
    SendProviderInquiryRequest.fromObject = function fromObject(object) {
        if (object instanceof $root.SendProviderInquiryRequest)
            return object;
        let message = new $root.SendProviderInquiryRequest();
        if (object.firstName != null)
            message.firstName = String(object.firstName);
        if (object.lastName != null)
            message.lastName = String(object.lastName);
        if (object.email != null)
            message.email = String(object.email);
        if (object.phone != null)
            message.phone = String(object.phone);
        if (object.website != null)
            message.website = String(object.website);
        if (object.primaryModalities != null)
            message.primaryModalities = String(object.primaryModalities);
        if (object.licensesCertifications != null)
            message.licensesCertifications = String(object.licensesCertifications);
        if (object.yearsInPractice != null)
            message.yearsInPractice = String(object.yearsInPractice);
        if (object.healingPhilosophy != null)
            message.healingPhilosophy = String(object.healingPhilosophy);
        if (object.whoReferredYou != null)
            message.whoReferredYou = String(object.whoReferredYou);
        if (object.anythingElse != null)
            message.anythingElse = String(object.anythingElse);
        return message;
    };

    /**
     * Creates a plain object from a SendProviderInquiryRequest message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {SendProviderInquiryRequest} message SendProviderInquiryRequest
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SendProviderInquiryRequest.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.firstName = "";
            object.lastName = "";
            object.email = "";
            object.phone = "";
            object.website = "";
            object.primaryModalities = "";
            object.licensesCertifications = "";
            object.yearsInPractice = "";
            object.healingPhilosophy = "";
            object.whoReferredYou = "";
            object.anythingElse = "";
        }
        if (message.firstName != null && message.hasOwnProperty("firstName"))
            object.firstName = message.firstName;
        if (message.lastName != null && message.hasOwnProperty("lastName"))
            object.lastName = message.lastName;
        if (message.email != null && message.hasOwnProperty("email"))
            object.email = message.email;
        if (message.phone != null && message.hasOwnProperty("phone"))
            object.phone = message.phone;
        if (message.website != null && message.hasOwnProperty("website"))
            object.website = message.website;
        if (message.primaryModalities != null && message.hasOwnProperty("primaryModalities"))
            object.primaryModalities = message.primaryModalities;
        if (message.licensesCertifications != null && message.hasOwnProperty("licensesCertifications"))
            object.licensesCertifications = message.licensesCertifications;
        if (message.yearsInPractice != null && message.hasOwnProperty("yearsInPractice"))
            object.yearsInPractice = message.yearsInPractice;
        if (message.healingPhilosophy != null && message.hasOwnProperty("healingPhilosophy"))
            object.healingPhilosophy = message.healingPhilosophy;
        if (message.whoReferredYou != null && message.hasOwnProperty("whoReferredYou"))
            object.whoReferredYou = message.whoReferredYou;
        if (message.anythingElse != null && message.hasOwnProperty("anythingElse"))
            object.anythingElse = message.anythingElse;
        return object;
    };

    /**
     * Converts this SendProviderInquiryRequest to JSON.
     * @function toJSON
     * @memberof SendProviderInquiryRequest
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SendProviderInquiryRequest.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SendProviderInquiryRequest
     * @function getTypeUrl
     * @memberof SendProviderInquiryRequest
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SendProviderInquiryRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SendProviderInquiryRequest";
    };

    return SendProviderInquiryRequest;
})();

export const SendProviderInquiryResponse = $root.SendProviderInquiryResponse = (() => {

    /**
     * Properties of a SendProviderInquiryResponse.
     * @exports ISendProviderInquiryResponse
     * @interface ISendProviderInquiryResponse
     * @property {boolean|null} [okay] SendProviderInquiryResponse okay
     * @property {Array.<space.kenko.proto.IErrorProto>|null} [errors] SendProviderInquiryResponse errors
     */

    /**
     * Constructs a new SendProviderInquiryResponse.
     * @exports SendProviderInquiryResponse
     * @classdesc Represents a SendProviderInquiryResponse.
     * @implements ISendProviderInquiryResponse
     * @constructor
     * @param {ISendProviderInquiryResponse=} [properties] Properties to set
     */
    function SendProviderInquiryResponse(properties) {
        this.errors = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SendProviderInquiryResponse okay.
     * @member {boolean} okay
     * @memberof SendProviderInquiryResponse
     * @instance
     */
    SendProviderInquiryResponse.prototype.okay = false;

    /**
     * SendProviderInquiryResponse errors.
     * @member {Array.<space.kenko.proto.IErrorProto>} errors
     * @memberof SendProviderInquiryResponse
     * @instance
     */
    SendProviderInquiryResponse.prototype.errors = $util.emptyArray;

    /**
     * Creates a new SendProviderInquiryResponse instance using the specified properties.
     * @function create
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {ISendProviderInquiryResponse=} [properties] Properties to set
     * @returns {SendProviderInquiryResponse} SendProviderInquiryResponse instance
     */
    SendProviderInquiryResponse.create = function create(properties) {
        return new SendProviderInquiryResponse(properties);
    };

    /**
     * Encodes the specified SendProviderInquiryResponse message. Does not implicitly {@link SendProviderInquiryResponse.verify|verify} messages.
     * @function encode
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {ISendProviderInquiryResponse} message SendProviderInquiryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SendProviderInquiryResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
        if (message.errors != null && message.errors.length)
            for (let i = 0; i < message.errors.length; ++i)
                $root.space.kenko.proto.ErrorProto.encode(message.errors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified SendProviderInquiryResponse message, length delimited. Does not implicitly {@link SendProviderInquiryResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {ISendProviderInquiryResponse} message SendProviderInquiryResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SendProviderInquiryResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SendProviderInquiryResponse message from the specified reader or buffer.
     * @function decode
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SendProviderInquiryResponse} SendProviderInquiryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SendProviderInquiryResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SendProviderInquiryResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.okay = reader.bool();
                    break;
                }
            case 2: {
                    if (!(message.errors && message.errors.length))
                        message.errors = [];
                    message.errors.push($root.space.kenko.proto.ErrorProto.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SendProviderInquiryResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SendProviderInquiryResponse} SendProviderInquiryResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SendProviderInquiryResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SendProviderInquiryResponse message.
     * @function verify
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SendProviderInquiryResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.okay != null && message.hasOwnProperty("okay"))
            if (typeof message.okay !== "boolean")
                return "okay: boolean expected";
        if (message.errors != null && message.hasOwnProperty("errors")) {
            if (!Array.isArray(message.errors))
                return "errors: array expected";
            for (let i = 0; i < message.errors.length; ++i) {
                let error = $root.space.kenko.proto.ErrorProto.verify(message.errors[i]);
                if (error)
                    return "errors." + error;
            }
        }
        return null;
    };

    /**
     * Creates a SendProviderInquiryResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SendProviderInquiryResponse} SendProviderInquiryResponse
     */
    SendProviderInquiryResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.SendProviderInquiryResponse)
            return object;
        let message = new $root.SendProviderInquiryResponse();
        if (object.okay != null)
            message.okay = Boolean(object.okay);
        if (object.errors) {
            if (!Array.isArray(object.errors))
                throw TypeError(".SendProviderInquiryResponse.errors: array expected");
            message.errors = [];
            for (let i = 0; i < object.errors.length; ++i) {
                if (typeof object.errors[i] !== "object")
                    throw TypeError(".SendProviderInquiryResponse.errors: object expected");
                message.errors[i] = $root.space.kenko.proto.ErrorProto.fromObject(object.errors[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SendProviderInquiryResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {SendProviderInquiryResponse} message SendProviderInquiryResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SendProviderInquiryResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.errors = [];
        if (options.defaults)
            object.okay = false;
        if (message.okay != null && message.hasOwnProperty("okay"))
            object.okay = message.okay;
        if (message.errors && message.errors.length) {
            object.errors = [];
            for (let j = 0; j < message.errors.length; ++j)
                object.errors[j] = $root.space.kenko.proto.ErrorProto.toObject(message.errors[j], options);
        }
        return object;
    };

    /**
     * Converts this SendProviderInquiryResponse to JSON.
     * @function toJSON
     * @memberof SendProviderInquiryResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SendProviderInquiryResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SendProviderInquiryResponse
     * @function getTypeUrl
     * @memberof SendProviderInquiryResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SendProviderInquiryResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SendProviderInquiryResponse";
    };

    return SendProviderInquiryResponse;
})();

/**
 * EmailOrPhoneLocation enum.
 * @exports EmailOrPhoneLocation
 * @enum {number}
 * @property {number} UNKNOWN=0 UNKNOWN value
 * @property {number} PROVIDER=1 PROVIDER value
 * @property {number} BUSINESS=2 BUSINESS value
 */
export const EmailOrPhoneLocation = $root.EmailOrPhoneLocation = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "UNKNOWN"] = 0;
    values[valuesById[1] = "PROVIDER"] = 1;
    values[valuesById[2] = "BUSINESS"] = 2;
    return values;
})();

export const com = $root.com = (() => {

    /**
     * Namespace com.
     * @exports com
     * @namespace
     */
    const com = {};

    com.onkensu = (function() {

        /**
         * Namespace onkensu.
         * @memberof com
         * @namespace
         */
        const onkensu = {};

        onkensu.platform = (function() {

            /**
             * Namespace platform.
             * @memberof com.onkensu
             * @namespace
             */
            const platform = {};

            platform.billing = (function() {

                /**
                 * Namespace billing.
                 * @memberof com.onkensu.platform
                 * @namespace
                 */
                const billing = {};

                billing.GetStripeUrlResponse = (function() {

                    /**
                     * Properties of a GetStripeUrlResponse.
                     * @memberof com.onkensu.platform.billing
                     * @interface IGetStripeUrlResponse
                     * @property {string|null} [stripeUrl] GetStripeUrlResponse stripeUrl
                     */

                    /**
                     * Constructs a new GetStripeUrlResponse.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a GetStripeUrlResponse.
                     * @implements IGetStripeUrlResponse
                     * @constructor
                     * @param {com.onkensu.platform.billing.IGetStripeUrlResponse=} [properties] Properties to set
                     */
                    function GetStripeUrlResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GetStripeUrlResponse stripeUrl.
                     * @member {string} stripeUrl
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @instance
                     */
                    GetStripeUrlResponse.prototype.stripeUrl = "";

                    /**
                     * Creates a new GetStripeUrlResponse instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripeUrlResponse=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.GetStripeUrlResponse} GetStripeUrlResponse instance
                     */
                    GetStripeUrlResponse.create = function create(properties) {
                        return new GetStripeUrlResponse(properties);
                    };

                    /**
                     * Encodes the specified GetStripeUrlResponse message. Does not implicitly {@link com.onkensu.platform.billing.GetStripeUrlResponse.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripeUrlResponse} message GetStripeUrlResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripeUrlResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.stripeUrl != null && Object.hasOwnProperty.call(message, "stripeUrl"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.stripeUrl);
                        return writer;
                    };

                    /**
                     * Encodes the specified GetStripeUrlResponse message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.GetStripeUrlResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripeUrlResponse} message GetStripeUrlResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripeUrlResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GetStripeUrlResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.GetStripeUrlResponse} GetStripeUrlResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripeUrlResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.GetStripeUrlResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.stripeUrl = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GetStripeUrlResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.GetStripeUrlResponse} GetStripeUrlResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripeUrlResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GetStripeUrlResponse message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStripeUrlResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.stripeUrl != null && message.hasOwnProperty("stripeUrl"))
                            if (!$util.isString(message.stripeUrl))
                                return "stripeUrl: string expected";
                        return null;
                    };

                    /**
                     * Creates a GetStripeUrlResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.GetStripeUrlResponse} GetStripeUrlResponse
                     */
                    GetStripeUrlResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.GetStripeUrlResponse)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.GetStripeUrlResponse();
                        if (object.stripeUrl != null)
                            message.stripeUrl = String(object.stripeUrl);
                        return message;
                    };

                    /**
                     * Creates a plain object from a GetStripeUrlResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {com.onkensu.platform.billing.GetStripeUrlResponse} message GetStripeUrlResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStripeUrlResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults)
                            object.stripeUrl = "";
                        if (message.stripeUrl != null && message.hasOwnProperty("stripeUrl"))
                            object.stripeUrl = message.stripeUrl;
                        return object;
                    };

                    /**
                     * Converts this GetStripeUrlResponse to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStripeUrlResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GetStripeUrlResponse
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.GetStripeUrlResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GetStripeUrlResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.GetStripeUrlResponse";
                    };

                    return GetStripeUrlResponse;
                })();

                billing.RefundPaymentRequest = (function() {

                    /**
                     * Properties of a RefundPaymentRequest.
                     * @memberof com.onkensu.platform.billing
                     * @interface IRefundPaymentRequest
                     * @property {string|null} [paymentId] RefundPaymentRequest paymentId
                     * @property {string|null} [note] RefundPaymentRequest note
                     */

                    /**
                     * Constructs a new RefundPaymentRequest.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a RefundPaymentRequest.
                     * @implements IRefundPaymentRequest
                     * @constructor
                     * @param {com.onkensu.platform.billing.IRefundPaymentRequest=} [properties] Properties to set
                     */
                    function RefundPaymentRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RefundPaymentRequest paymentId.
                     * @member {string} paymentId
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @instance
                     */
                    RefundPaymentRequest.prototype.paymentId = "";

                    /**
                     * RefundPaymentRequest note.
                     * @member {string} note
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @instance
                     */
                    RefundPaymentRequest.prototype.note = "";

                    /**
                     * Creates a new RefundPaymentRequest instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IRefundPaymentRequest=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.RefundPaymentRequest} RefundPaymentRequest instance
                     */
                    RefundPaymentRequest.create = function create(properties) {
                        return new RefundPaymentRequest(properties);
                    };

                    /**
                     * Encodes the specified RefundPaymentRequest message. Does not implicitly {@link com.onkensu.platform.billing.RefundPaymentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IRefundPaymentRequest} message RefundPaymentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RefundPaymentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.paymentId != null && Object.hasOwnProperty.call(message, "paymentId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.paymentId);
                        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.note);
                        return writer;
                    };

                    /**
                     * Encodes the specified RefundPaymentRequest message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.RefundPaymentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IRefundPaymentRequest} message RefundPaymentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RefundPaymentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RefundPaymentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.RefundPaymentRequest} RefundPaymentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RefundPaymentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.RefundPaymentRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.paymentId = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.note = reader.string();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RefundPaymentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.RefundPaymentRequest} RefundPaymentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RefundPaymentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RefundPaymentRequest message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RefundPaymentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                            if (!$util.isString(message.paymentId))
                                return "paymentId: string expected";
                        if (message.note != null && message.hasOwnProperty("note"))
                            if (!$util.isString(message.note))
                                return "note: string expected";
                        return null;
                    };

                    /**
                     * Creates a RefundPaymentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.RefundPaymentRequest} RefundPaymentRequest
                     */
                    RefundPaymentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.RefundPaymentRequest)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.RefundPaymentRequest();
                        if (object.paymentId != null)
                            message.paymentId = String(object.paymentId);
                        if (object.note != null)
                            message.note = String(object.note);
                        return message;
                    };

                    /**
                     * Creates a plain object from a RefundPaymentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {com.onkensu.platform.billing.RefundPaymentRequest} message RefundPaymentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RefundPaymentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.paymentId = "";
                            object.note = "";
                        }
                        if (message.paymentId != null && message.hasOwnProperty("paymentId"))
                            object.paymentId = message.paymentId;
                        if (message.note != null && message.hasOwnProperty("note"))
                            object.note = message.note;
                        return object;
                    };

                    /**
                     * Converts this RefundPaymentRequest to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RefundPaymentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RefundPaymentRequest
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.RefundPaymentRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RefundPaymentRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.RefundPaymentRequest";
                    };

                    return RefundPaymentRequest;
                })();

                billing.RefundPaymentResponse = (function() {

                    /**
                     * Properties of a RefundPaymentResponse.
                     * @memberof com.onkensu.platform.billing
                     * @interface IRefundPaymentResponse
                     * @property {boolean|null} [okay] RefundPaymentResponse okay
                     * @property {space.kenko.proto.IApiPaymentProto|null} [updatedPayment] RefundPaymentResponse updatedPayment
                     */

                    /**
                     * Constructs a new RefundPaymentResponse.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a RefundPaymentResponse.
                     * @implements IRefundPaymentResponse
                     * @constructor
                     * @param {com.onkensu.platform.billing.IRefundPaymentResponse=} [properties] Properties to set
                     */
                    function RefundPaymentResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * RefundPaymentResponse okay.
                     * @member {boolean} okay
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @instance
                     */
                    RefundPaymentResponse.prototype.okay = false;

                    /**
                     * RefundPaymentResponse updatedPayment.
                     * @member {space.kenko.proto.IApiPaymentProto|null|undefined} updatedPayment
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @instance
                     */
                    RefundPaymentResponse.prototype.updatedPayment = null;

                    /**
                     * Creates a new RefundPaymentResponse instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IRefundPaymentResponse=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.RefundPaymentResponse} RefundPaymentResponse instance
                     */
                    RefundPaymentResponse.create = function create(properties) {
                        return new RefundPaymentResponse(properties);
                    };

                    /**
                     * Encodes the specified RefundPaymentResponse message. Does not implicitly {@link com.onkensu.platform.billing.RefundPaymentResponse.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IRefundPaymentResponse} message RefundPaymentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RefundPaymentResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
                        if (message.updatedPayment != null && Object.hasOwnProperty.call(message, "updatedPayment"))
                            $root.space.kenko.proto.ApiPaymentProto.encode(message.updatedPayment, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified RefundPaymentResponse message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.RefundPaymentResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IRefundPaymentResponse} message RefundPaymentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RefundPaymentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a RefundPaymentResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.RefundPaymentResponse} RefundPaymentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RefundPaymentResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.RefundPaymentResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.okay = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.updatedPayment = $root.space.kenko.proto.ApiPaymentProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a RefundPaymentResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.RefundPaymentResponse} RefundPaymentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RefundPaymentResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a RefundPaymentResponse message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RefundPaymentResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            if (typeof message.okay !== "boolean")
                                return "okay: boolean expected";
                        if (message.updatedPayment != null && message.hasOwnProperty("updatedPayment")) {
                            let error = $root.space.kenko.proto.ApiPaymentProto.verify(message.updatedPayment);
                            if (error)
                                return "updatedPayment." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a RefundPaymentResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.RefundPaymentResponse} RefundPaymentResponse
                     */
                    RefundPaymentResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.RefundPaymentResponse)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.RefundPaymentResponse();
                        if (object.okay != null)
                            message.okay = Boolean(object.okay);
                        if (object.updatedPayment != null) {
                            if (typeof object.updatedPayment !== "object")
                                throw TypeError(".com.onkensu.platform.billing.RefundPaymentResponse.updatedPayment: object expected");
                            message.updatedPayment = $root.space.kenko.proto.ApiPaymentProto.fromObject(object.updatedPayment);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a RefundPaymentResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {com.onkensu.platform.billing.RefundPaymentResponse} message RefundPaymentResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RefundPaymentResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.okay = false;
                            object.updatedPayment = null;
                        }
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            object.okay = message.okay;
                        if (message.updatedPayment != null && message.hasOwnProperty("updatedPayment"))
                            object.updatedPayment = $root.space.kenko.proto.ApiPaymentProto.toObject(message.updatedPayment, options);
                        return object;
                    };

                    /**
                     * Converts this RefundPaymentResponse to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RefundPaymentResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for RefundPaymentResponse
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.RefundPaymentResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    RefundPaymentResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.RefundPaymentResponse";
                    };

                    return RefundPaymentResponse;
                })();

                billing.ProviderSubscriptionRequest = (function() {

                    /**
                     * Properties of a ProviderSubscriptionRequest.
                     * @memberof com.onkensu.platform.billing
                     * @interface IProviderSubscriptionRequest
                     * @property {space.kenko.proto.BusinessSubscriptionType|null} [subscription] ProviderSubscriptionRequest subscription
                     * @property {number|null} [quantity] ProviderSubscriptionRequest quantity
                     */

                    /**
                     * Constructs a new ProviderSubscriptionRequest.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a ProviderSubscriptionRequest.
                     * @implements IProviderSubscriptionRequest
                     * @constructor
                     * @param {com.onkensu.platform.billing.IProviderSubscriptionRequest=} [properties] Properties to set
                     */
                    function ProviderSubscriptionRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * ProviderSubscriptionRequest subscription.
                     * @member {space.kenko.proto.BusinessSubscriptionType} subscription
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @instance
                     */
                    ProviderSubscriptionRequest.prototype.subscription = 0;

                    /**
                     * ProviderSubscriptionRequest quantity.
                     * @member {number} quantity
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @instance
                     */
                    ProviderSubscriptionRequest.prototype.quantity = 0;

                    /**
                     * Creates a new ProviderSubscriptionRequest instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IProviderSubscriptionRequest=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.ProviderSubscriptionRequest} ProviderSubscriptionRequest instance
                     */
                    ProviderSubscriptionRequest.create = function create(properties) {
                        return new ProviderSubscriptionRequest(properties);
                    };

                    /**
                     * Encodes the specified ProviderSubscriptionRequest message. Does not implicitly {@link com.onkensu.platform.billing.ProviderSubscriptionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IProviderSubscriptionRequest} message ProviderSubscriptionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProviderSubscriptionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.subscription != null && Object.hasOwnProperty.call(message, "subscription"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.subscription);
                        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.quantity);
                        return writer;
                    };

                    /**
                     * Encodes the specified ProviderSubscriptionRequest message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.ProviderSubscriptionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IProviderSubscriptionRequest} message ProviderSubscriptionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProviderSubscriptionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a ProviderSubscriptionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.ProviderSubscriptionRequest} ProviderSubscriptionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProviderSubscriptionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.ProviderSubscriptionRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.subscription = reader.int32();
                                    break;
                                }
                            case 2: {
                                    message.quantity = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a ProviderSubscriptionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.ProviderSubscriptionRequest} ProviderSubscriptionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProviderSubscriptionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a ProviderSubscriptionRequest message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProviderSubscriptionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.subscription != null && message.hasOwnProperty("subscription"))
                            switch (message.subscription) {
                            default:
                                return "subscription: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.quantity != null && message.hasOwnProperty("quantity"))
                            if (!$util.isInteger(message.quantity))
                                return "quantity: integer expected";
                        return null;
                    };

                    /**
                     * Creates a ProviderSubscriptionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.ProviderSubscriptionRequest} ProviderSubscriptionRequest
                     */
                    ProviderSubscriptionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.ProviderSubscriptionRequest)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.ProviderSubscriptionRequest();
                        switch (object.subscription) {
                        default:
                            if (typeof object.subscription === "number") {
                                message.subscription = object.subscription;
                                break;
                            }
                            break;
                        case "SUBSCRIPTION_TYPE_UNKNOWN":
                        case 0:
                            message.subscription = 0;
                            break;
                        case "LISTING":
                        case 1:
                            message.subscription = 1;
                            break;
                        case "LISTING_PLUS_BOOKING":
                        case 2:
                            message.subscription = 2;
                            break;
                        }
                        if (object.quantity != null)
                            message.quantity = object.quantity | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a ProviderSubscriptionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {com.onkensu.platform.billing.ProviderSubscriptionRequest} message ProviderSubscriptionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProviderSubscriptionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.subscription = options.enums === String ? "SUBSCRIPTION_TYPE_UNKNOWN" : 0;
                            object.quantity = 0;
                        }
                        if (message.subscription != null && message.hasOwnProperty("subscription"))
                            object.subscription = options.enums === String ? $root.space.kenko.proto.BusinessSubscriptionType[message.subscription] === undefined ? message.subscription : $root.space.kenko.proto.BusinessSubscriptionType[message.subscription] : message.subscription;
                        if (message.quantity != null && message.hasOwnProperty("quantity"))
                            object.quantity = message.quantity;
                        return object;
                    };

                    /**
                     * Converts this ProviderSubscriptionRequest to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProviderSubscriptionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for ProviderSubscriptionRequest
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.ProviderSubscriptionRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    ProviderSubscriptionRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.ProviderSubscriptionRequest";
                    };

                    return ProviderSubscriptionRequest;
                })();

                billing.GetStripePaymentsRequest = (function() {

                    /**
                     * Properties of a GetStripePaymentsRequest.
                     * @memberof com.onkensu.platform.billing
                     * @interface IGetStripePaymentsRequest
                     * @property {string|null} [userId] GetStripePaymentsRequest userId
                     * @property {string|null} [transactionId] GetStripePaymentsRequest transactionId
                     * @property {number|null} [limit] GetStripePaymentsRequest limit
                     */

                    /**
                     * Constructs a new GetStripePaymentsRequest.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a GetStripePaymentsRequest.
                     * @implements IGetStripePaymentsRequest
                     * @constructor
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsRequest=} [properties] Properties to set
                     */
                    function GetStripePaymentsRequest(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GetStripePaymentsRequest userId.
                     * @member {string} userId
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @instance
                     */
                    GetStripePaymentsRequest.prototype.userId = "";

                    /**
                     * GetStripePaymentsRequest transactionId.
                     * @member {string} transactionId
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @instance
                     */
                    GetStripePaymentsRequest.prototype.transactionId = "";

                    /**
                     * GetStripePaymentsRequest limit.
                     * @member {number} limit
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @instance
                     */
                    GetStripePaymentsRequest.prototype.limit = 0;

                    /**
                     * Creates a new GetStripePaymentsRequest instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsRequest=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsRequest} GetStripePaymentsRequest instance
                     */
                    GetStripePaymentsRequest.create = function create(properties) {
                        return new GetStripePaymentsRequest(properties);
                    };

                    /**
                     * Encodes the specified GetStripePaymentsRequest message. Does not implicitly {@link com.onkensu.platform.billing.GetStripePaymentsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsRequest} message GetStripePaymentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripePaymentsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.userId);
                        if (message.transactionId != null && Object.hasOwnProperty.call(message, "transactionId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.transactionId);
                        if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.limit);
                        return writer;
                    };

                    /**
                     * Encodes the specified GetStripePaymentsRequest message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.GetStripePaymentsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsRequest} message GetStripePaymentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripePaymentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GetStripePaymentsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsRequest} GetStripePaymentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripePaymentsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.GetStripePaymentsRequest();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.userId = reader.string();
                                    break;
                                }
                            case 2: {
                                    message.transactionId = reader.string();
                                    break;
                                }
                            case 3: {
                                    message.limit = reader.int32();
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GetStripePaymentsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsRequest} GetStripePaymentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripePaymentsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GetStripePaymentsRequest message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStripePaymentsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isString(message.userId))
                                return "userId: string expected";
                        if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                            if (!$util.isString(message.transactionId))
                                return "transactionId: string expected";
                        if (message.limit != null && message.hasOwnProperty("limit"))
                            if (!$util.isInteger(message.limit))
                                return "limit: integer expected";
                        return null;
                    };

                    /**
                     * Creates a GetStripePaymentsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsRequest} GetStripePaymentsRequest
                     */
                    GetStripePaymentsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.GetStripePaymentsRequest)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.GetStripePaymentsRequest();
                        if (object.userId != null)
                            message.userId = String(object.userId);
                        if (object.transactionId != null)
                            message.transactionId = String(object.transactionId);
                        if (object.limit != null)
                            message.limit = object.limit | 0;
                        return message;
                    };

                    /**
                     * Creates a plain object from a GetStripePaymentsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {com.onkensu.platform.billing.GetStripePaymentsRequest} message GetStripePaymentsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStripePaymentsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.userId = "";
                            object.transactionId = "";
                            object.limit = 0;
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            object.userId = message.userId;
                        if (message.transactionId != null && message.hasOwnProperty("transactionId"))
                            object.transactionId = message.transactionId;
                        if (message.limit != null && message.hasOwnProperty("limit"))
                            object.limit = message.limit;
                        return object;
                    };

                    /**
                     * Converts this GetStripePaymentsRequest to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStripePaymentsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GetStripePaymentsRequest
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsRequest
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GetStripePaymentsRequest.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.GetStripePaymentsRequest";
                    };

                    return GetStripePaymentsRequest;
                })();

                billing.GetStripePaymentsResponse = (function() {

                    /**
                     * Properties of a GetStripePaymentsResponse.
                     * @memberof com.onkensu.platform.billing
                     * @interface IGetStripePaymentsResponse
                     * @property {boolean|null} [okay] GetStripePaymentsResponse okay
                     * @property {Array.<space.kenko.proto.IApiPaymentProto>|null} [payment] GetStripePaymentsResponse payment
                     */

                    /**
                     * Constructs a new GetStripePaymentsResponse.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a GetStripePaymentsResponse.
                     * @implements IGetStripePaymentsResponse
                     * @constructor
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsResponse=} [properties] Properties to set
                     */
                    function GetStripePaymentsResponse(properties) {
                        this.payment = [];
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GetStripePaymentsResponse okay.
                     * @member {boolean} okay
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @instance
                     */
                    GetStripePaymentsResponse.prototype.okay = false;

                    /**
                     * GetStripePaymentsResponse payment.
                     * @member {Array.<space.kenko.proto.IApiPaymentProto>} payment
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @instance
                     */
                    GetStripePaymentsResponse.prototype.payment = $util.emptyArray;

                    /**
                     * Creates a new GetStripePaymentsResponse instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsResponse=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsResponse} GetStripePaymentsResponse instance
                     */
                    GetStripePaymentsResponse.create = function create(properties) {
                        return new GetStripePaymentsResponse(properties);
                    };

                    /**
                     * Encodes the specified GetStripePaymentsResponse message. Does not implicitly {@link com.onkensu.platform.billing.GetStripePaymentsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsResponse} message GetStripePaymentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripePaymentsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
                        if (message.payment != null && message.payment.length)
                            for (let i = 0; i < message.payment.length; ++i)
                                $root.space.kenko.proto.ApiPaymentProto.encode(message.payment[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified GetStripePaymentsResponse message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.GetStripePaymentsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripePaymentsResponse} message GetStripePaymentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripePaymentsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GetStripePaymentsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsResponse} GetStripePaymentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripePaymentsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.GetStripePaymentsResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.okay = reader.bool();
                                    break;
                                }
                            case 2: {
                                    if (!(message.payment && message.payment.length))
                                        message.payment = [];
                                    message.payment.push($root.space.kenko.proto.ApiPaymentProto.decode(reader, reader.uint32()));
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GetStripePaymentsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsResponse} GetStripePaymentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripePaymentsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GetStripePaymentsResponse message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStripePaymentsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            if (typeof message.okay !== "boolean")
                                return "okay: boolean expected";
                        if (message.payment != null && message.hasOwnProperty("payment")) {
                            if (!Array.isArray(message.payment))
                                return "payment: array expected";
                            for (let i = 0; i < message.payment.length; ++i) {
                                let error = $root.space.kenko.proto.ApiPaymentProto.verify(message.payment[i]);
                                if (error)
                                    return "payment." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates a GetStripePaymentsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.GetStripePaymentsResponse} GetStripePaymentsResponse
                     */
                    GetStripePaymentsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.GetStripePaymentsResponse)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.GetStripePaymentsResponse();
                        if (object.okay != null)
                            message.okay = Boolean(object.okay);
                        if (object.payment) {
                            if (!Array.isArray(object.payment))
                                throw TypeError(".com.onkensu.platform.billing.GetStripePaymentsResponse.payment: array expected");
                            message.payment = [];
                            for (let i = 0; i < object.payment.length; ++i) {
                                if (typeof object.payment[i] !== "object")
                                    throw TypeError(".com.onkensu.platform.billing.GetStripePaymentsResponse.payment: object expected");
                                message.payment[i] = $root.space.kenko.proto.ApiPaymentProto.fromObject(object.payment[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a GetStripePaymentsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {com.onkensu.platform.billing.GetStripePaymentsResponse} message GetStripePaymentsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStripePaymentsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.arrays || options.defaults)
                            object.payment = [];
                        if (options.defaults)
                            object.okay = false;
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            object.okay = message.okay;
                        if (message.payment && message.payment.length) {
                            object.payment = [];
                            for (let j = 0; j < message.payment.length; ++j)
                                object.payment[j] = $root.space.kenko.proto.ApiPaymentProto.toObject(message.payment[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this GetStripePaymentsResponse to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStripePaymentsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GetStripePaymentsResponse
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.GetStripePaymentsResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GetStripePaymentsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.GetStripePaymentsResponse";
                    };

                    return GetStripePaymentsResponse;
                })();

                billing.GetSubscriptionStatusResponse = (function() {

                    /**
                     * Properties of a GetSubscriptionStatusResponse.
                     * @memberof com.onkensu.platform.billing
                     * @interface IGetSubscriptionStatusResponse
                     * @property {boolean|null} [okay] GetSubscriptionStatusResponse okay
                     * @property {space.kenko.proto.IBusinessSubscriptionProto|null} [updatedSubscription] GetSubscriptionStatusResponse updatedSubscription
                     */

                    /**
                     * Constructs a new GetSubscriptionStatusResponse.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a GetSubscriptionStatusResponse.
                     * @implements IGetSubscriptionStatusResponse
                     * @constructor
                     * @param {com.onkensu.platform.billing.IGetSubscriptionStatusResponse=} [properties] Properties to set
                     */
                    function GetSubscriptionStatusResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GetSubscriptionStatusResponse okay.
                     * @member {boolean} okay
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @instance
                     */
                    GetSubscriptionStatusResponse.prototype.okay = false;

                    /**
                     * GetSubscriptionStatusResponse updatedSubscription.
                     * @member {space.kenko.proto.IBusinessSubscriptionProto|null|undefined} updatedSubscription
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @instance
                     */
                    GetSubscriptionStatusResponse.prototype.updatedSubscription = null;

                    /**
                     * Creates a new GetSubscriptionStatusResponse instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetSubscriptionStatusResponse=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.GetSubscriptionStatusResponse} GetSubscriptionStatusResponse instance
                     */
                    GetSubscriptionStatusResponse.create = function create(properties) {
                        return new GetSubscriptionStatusResponse(properties);
                    };

                    /**
                     * Encodes the specified GetSubscriptionStatusResponse message. Does not implicitly {@link com.onkensu.platform.billing.GetSubscriptionStatusResponse.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetSubscriptionStatusResponse} message GetSubscriptionStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSubscriptionStatusResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
                        if (message.updatedSubscription != null && Object.hasOwnProperty.call(message, "updatedSubscription"))
                            $root.space.kenko.proto.BusinessSubscriptionProto.encode(message.updatedSubscription, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified GetSubscriptionStatusResponse message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.GetSubscriptionStatusResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetSubscriptionStatusResponse} message GetSubscriptionStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSubscriptionStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GetSubscriptionStatusResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.GetSubscriptionStatusResponse} GetSubscriptionStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSubscriptionStatusResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.GetSubscriptionStatusResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.okay = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.updatedSubscription = $root.space.kenko.proto.BusinessSubscriptionProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GetSubscriptionStatusResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.GetSubscriptionStatusResponse} GetSubscriptionStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSubscriptionStatusResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GetSubscriptionStatusResponse message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetSubscriptionStatusResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            if (typeof message.okay !== "boolean")
                                return "okay: boolean expected";
                        if (message.updatedSubscription != null && message.hasOwnProperty("updatedSubscription")) {
                            let error = $root.space.kenko.proto.BusinessSubscriptionProto.verify(message.updatedSubscription);
                            if (error)
                                return "updatedSubscription." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a GetSubscriptionStatusResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.GetSubscriptionStatusResponse} GetSubscriptionStatusResponse
                     */
                    GetSubscriptionStatusResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.GetSubscriptionStatusResponse)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.GetSubscriptionStatusResponse();
                        if (object.okay != null)
                            message.okay = Boolean(object.okay);
                        if (object.updatedSubscription != null) {
                            if (typeof object.updatedSubscription !== "object")
                                throw TypeError(".com.onkensu.platform.billing.GetSubscriptionStatusResponse.updatedSubscription: object expected");
                            message.updatedSubscription = $root.space.kenko.proto.BusinessSubscriptionProto.fromObject(object.updatedSubscription);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a GetSubscriptionStatusResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.GetSubscriptionStatusResponse} message GetSubscriptionStatusResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetSubscriptionStatusResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.okay = false;
                            object.updatedSubscription = null;
                        }
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            object.okay = message.okay;
                        if (message.updatedSubscription != null && message.hasOwnProperty("updatedSubscription"))
                            object.updatedSubscription = $root.space.kenko.proto.BusinessSubscriptionProto.toObject(message.updatedSubscription, options);
                        return object;
                    };

                    /**
                     * Converts this GetSubscriptionStatusResponse to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetSubscriptionStatusResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GetSubscriptionStatusResponse
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.GetSubscriptionStatusResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GetSubscriptionStatusResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.GetSubscriptionStatusResponse";
                    };

                    return GetSubscriptionStatusResponse;
                })();

                billing.GetStripeAccountStatusResponse = (function() {

                    /**
                     * Properties of a GetStripeAccountStatusResponse.
                     * @memberof com.onkensu.platform.billing
                     * @interface IGetStripeAccountStatusResponse
                     * @property {boolean|null} [okay] GetStripeAccountStatusResponse okay
                     * @property {space.kenko.proto.IConnectedAccountStatusProto|null} [updatedAccountStatus] GetStripeAccountStatusResponse updatedAccountStatus
                     */

                    /**
                     * Constructs a new GetStripeAccountStatusResponse.
                     * @memberof com.onkensu.platform.billing
                     * @classdesc Represents a GetStripeAccountStatusResponse.
                     * @implements IGetStripeAccountStatusResponse
                     * @constructor
                     * @param {com.onkensu.platform.billing.IGetStripeAccountStatusResponse=} [properties] Properties to set
                     */
                    function GetStripeAccountStatusResponse(properties) {
                        if (properties)
                            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * GetStripeAccountStatusResponse okay.
                     * @member {boolean} okay
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @instance
                     */
                    GetStripeAccountStatusResponse.prototype.okay = false;

                    /**
                     * GetStripeAccountStatusResponse updatedAccountStatus.
                     * @member {space.kenko.proto.IConnectedAccountStatusProto|null|undefined} updatedAccountStatus
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @instance
                     */
                    GetStripeAccountStatusResponse.prototype.updatedAccountStatus = null;

                    /**
                     * Creates a new GetStripeAccountStatusResponse instance using the specified properties.
                     * @function create
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripeAccountStatusResponse=} [properties] Properties to set
                     * @returns {com.onkensu.platform.billing.GetStripeAccountStatusResponse} GetStripeAccountStatusResponse instance
                     */
                    GetStripeAccountStatusResponse.create = function create(properties) {
                        return new GetStripeAccountStatusResponse(properties);
                    };

                    /**
                     * Encodes the specified GetStripeAccountStatusResponse message. Does not implicitly {@link com.onkensu.platform.billing.GetStripeAccountStatusResponse.verify|verify} messages.
                     * @function encode
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripeAccountStatusResponse} message GetStripeAccountStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripeAccountStatusResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.okay != null && Object.hasOwnProperty.call(message, "okay"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.okay);
                        if (message.updatedAccountStatus != null && Object.hasOwnProperty.call(message, "updatedAccountStatus"))
                            $root.space.kenko.proto.ConnectedAccountStatusProto.encode(message.updatedAccountStatus, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified GetStripeAccountStatusResponse message, length delimited. Does not implicitly {@link com.onkensu.platform.billing.GetStripeAccountStatusResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.IGetStripeAccountStatusResponse} message GetStripeAccountStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStripeAccountStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a GetStripeAccountStatusResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {com.onkensu.platform.billing.GetStripeAccountStatusResponse} GetStripeAccountStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripeAccountStatusResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.com.onkensu.platform.billing.GetStripeAccountStatusResponse();
                        while (reader.pos < end) {
                            let tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1: {
                                    message.okay = reader.bool();
                                    break;
                                }
                            case 2: {
                                    message.updatedAccountStatus = $root.space.kenko.proto.ConnectedAccountStatusProto.decode(reader, reader.uint32());
                                    break;
                                }
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a GetStripeAccountStatusResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {com.onkensu.platform.billing.GetStripeAccountStatusResponse} GetStripeAccountStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStripeAccountStatusResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a GetStripeAccountStatusResponse message.
                     * @function verify
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStripeAccountStatusResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            if (typeof message.okay !== "boolean")
                                return "okay: boolean expected";
                        if (message.updatedAccountStatus != null && message.hasOwnProperty("updatedAccountStatus")) {
                            let error = $root.space.kenko.proto.ConnectedAccountStatusProto.verify(message.updatedAccountStatus);
                            if (error)
                                return "updatedAccountStatus." + error;
                        }
                        return null;
                    };

                    /**
                     * Creates a GetStripeAccountStatusResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {com.onkensu.platform.billing.GetStripeAccountStatusResponse} GetStripeAccountStatusResponse
                     */
                    GetStripeAccountStatusResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.com.onkensu.platform.billing.GetStripeAccountStatusResponse)
                            return object;
                        let message = new $root.com.onkensu.platform.billing.GetStripeAccountStatusResponse();
                        if (object.okay != null)
                            message.okay = Boolean(object.okay);
                        if (object.updatedAccountStatus != null) {
                            if (typeof object.updatedAccountStatus !== "object")
                                throw TypeError(".com.onkensu.platform.billing.GetStripeAccountStatusResponse.updatedAccountStatus: object expected");
                            message.updatedAccountStatus = $root.space.kenko.proto.ConnectedAccountStatusProto.fromObject(object.updatedAccountStatus);
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from a GetStripeAccountStatusResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {com.onkensu.platform.billing.GetStripeAccountStatusResponse} message GetStripeAccountStatusResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStripeAccountStatusResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        let object = {};
                        if (options.defaults) {
                            object.okay = false;
                            object.updatedAccountStatus = null;
                        }
                        if (message.okay != null && message.hasOwnProperty("okay"))
                            object.okay = message.okay;
                        if (message.updatedAccountStatus != null && message.hasOwnProperty("updatedAccountStatus"))
                            object.updatedAccountStatus = $root.space.kenko.proto.ConnectedAccountStatusProto.toObject(message.updatedAccountStatus, options);
                        return object;
                    };

                    /**
                     * Converts this GetStripeAccountStatusResponse to JSON.
                     * @function toJSON
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStripeAccountStatusResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    /**
                     * Gets the default type url for GetStripeAccountStatusResponse
                     * @function getTypeUrl
                     * @memberof com.onkensu.platform.billing.GetStripeAccountStatusResponse
                     * @static
                     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
                     * @returns {string} The default type url
                     */
                    GetStripeAccountStatusResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                        if (typeUrlPrefix === undefined) {
                            typeUrlPrefix = "type.googleapis.com";
                        }
                        return typeUrlPrefix + "/com.onkensu.platform.billing.GetStripeAccountStatusResponse";
                    };

                    return GetStripeAccountStatusResponse;
                })();

                return billing;
            })();

            return platform;
        })();

        return onkensu;
    })();

    return com;
})();

export { $root as default };
